
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("j8RTJ", function(module, exports) {
class $e2487d888c058b8a$export$51be62b46ee668fd {
    /**
   * The default implementation calls AstNode#accept on the specified node.
   * @param node
   */ visit(node) {
        return node.accept(this);
    }
    /**
   * The default implementation initializes the aggregate result to defaultResult(). Before visiting each child, it
   * calls shouldVisitNextChild; if the result is false no more children are visited and the current aggregate result is
   * returned. After visiting a child, the aggregate result is updated by calling aggregateResult with the previous
   * aggregate result and the result of visiting the child.
   */ visitChildren(node) {
        let result = this.defaultResult();
        const children = node.getChildren();
        for(let i = 0; i < children.length; i++){
            if (!this.shouldVisitNextChild(node, result)) break;
            const childResult = children[i].accept(this);
            result = this.aggregateResult(result, childResult);
        }
        return result;
    }
    /**
   * Aggregates the results of visiting multiple children of a node.
   *
   * The default implementation returns `nextResult`, meaning
   * {@link #visitChildren} will return the result of the last child visited
   * (or return the initial value if the node has no children).
   *
   * @param _aggregate The previous aggregate value. In the default
   * implementation, the aggregate value is initialized to
   * {@link #defaultResult}, which is passed as the `aggregate` argument
   * to this method after the first child node is visited.
   * @param nextResult The result of the immediately preceeding call to visit
   * a child node.
   *
   * @returns The updated aggregate result.
   */ aggregateResult(_aggregate, nextResult) {
        return nextResult;
    }
    /**
   * This method is called before visiting each child in
   * {@link #visitChildren}. When the method is first called\ `currentResult`
   * will be the initial value (in the default implementation, the initial value
   * is returned by a call to {@link #defaultResult}).
   *
   * The default implementation always returns `true`, indicating that
   * `visitChildren` should only return after all children are visited.
   * One reason to override this method is to provide a "short circuit"
   * evaluation option for situations where the result of visiting a single
   * child has the potential to determine the result of the visit operation as
   * a whole.
   *
   * @param _node The {@link AstNode} whose children are currently being
   * visited.
   * @param _currentResult The current aggregate result of the children visited
   * to the current point.
   *
   * @returns `true` to continue visiting children. Otherwise return
   * `false` to stop visiting children and immediately return the
   * current aggregate result from {@link #visitChildren}.
   */ shouldVisitNextChild(_node, _currentResult) {
        return true;
    }
}
module.exports["AbstractJastVisitor"] = $e2487d888c058b8a$export$51be62b46ee668fd;

});

parcelRegister("hCuGd", function(module, exports) {

var $bhs7f = parcelRequire("bhs7f");


var $dOBRD = parcelRequire("dOBRD");


var $2nXS3 = parcelRequire("2nXS3");

var $56ams = parcelRequire("56ams");


var $a0unS = parcelRequire("a0unS");


var $jLG6B = parcelRequire("jLG6B");


var $4jT2n = parcelRequire("4jT2n");

class $9032d76e76efa64d$export$d0857f60ff1f385 {
    constructor(){
        this.errors = [];
        this.syntaxError = (_recognizer, offendingSymbol, line, charPositionInLine, msg)=>{
            if (offendingSymbol === undefined) this.errors.push(new (0, $jLG6B.JQLParseError)(msg));
            else this.errors.push(new (0, $4jT2n.JQLSyntaxError)(msg, offendingSymbol.startIndex, offendingSymbol.stopIndex + 1, line, charPositionInLine));
        };
    }
}







class $4faff140f1a988e9$export$d3c14d7188b09387 {
    visit(_tree) {
        throw new Error('Unsupported operation visit(ParseTree)');
    }
    visitChildren(_node) {
        throw new Error('Unsupported operation visitChildren(RuleNode)');
    }
    visitErrorNode(_node) {
        throw new Error('Unsupported operation visitErrorNode(ErrorNode)');
    }
    visitTerminal(_node) {
        throw new Error('Unsupported operation visitTerminal(TerminalNode)');
    }
    constructor(tokens){
        this.tokens = void 0;
        this.tokens = tokens;
    }
}
const $4faff140f1a988e9$export$85a4e6d858dbc6fb = (startToken, stopToken)=>[
        startToken.startIndex,
        (stopToken || startToken).stopIndex + 1
    ];
const $4faff140f1a988e9$export$264629d4cd3cad3f = (ctx)=>[
        ctx.start.startIndex,
        ctx.stop ? ctx.stop.stopIndex + 1 : ctx.start.stopIndex
    ];
const $4faff140f1a988e9$export$30d51184879cbaa8 = (terminalNodes)=>terminalNodes.map((node)=>$4faff140f1a988e9$export$85a4e6d858dbc6fb(node.payload));
const $4faff140f1a988e9$export$7c2714a5250b9239 = (text)=>text.toLowerCase().replace(/\s+/g, ' ');



var $4AL0V = parcelRequire("4AL0V");




/**
 * Type predicate to assert an argument is not undefined.
 */ function $f2ee0a3c79516de1$export$9a1adf421b69c6a(x) {
    return x !== undefined;
}











class $39c92ee036813c9a$export$617850cb96304515 extends (0, $4faff140f1a988e9$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.visitJqlString = (ctx)=>{
            const text = this.tokens.getText(ctx);
            const position = (0, $4faff140f1a988e9$export$264629d4cd3cad3f)(ctx);
            let value;
            if (ctx.QUOTE_STRING()) value = text.replace(/^"|"$/g, '').replace(/(?:\\(.))/g, '$1');
            else if (ctx.SQUOTE_STRING()) value = text.replace(/^'|'$/g, '').replace(/(?:\\(.))/g, '$1');
            else // unquoted string
            value = text;
            return {
                text: text,
                value: value,
                position: position
            };
        };
    }
}


class $9537cab0ea5d5c75$export$46b5a1f6d962d533 extends (0, $4faff140f1a988e9$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.stringVisitor = new (0, $39c92ee036813c9a$export$617850cb96304515)(this.tokens);
        this.visitJqlArgument = (ctx)=>{
            const stringContext = ctx.jqlString();
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $a0unS.internalCreators).argument(stringValue.value, stringValue.text, stringValue.position);
            } else {
                const text = this.tokens.getText(ctx);
                return (0, $a0unS.internalCreators).argument(text, text, (0, $4faff140f1a988e9$export$264629d4cd3cad3f)(ctx));
            }
        };
    }
}




class $15a95c08b6fa2a26$export$c6a85c4c3bf2317d extends (0, $4faff140f1a988e9$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.stringVisitor = new (0, $39c92ee036813c9a$export$617850cb96304515)(this.tokens);
        this.fieldPropertyVisitor = new $15a95c08b6fa2a26$var$FieldPropertyVisitor(this.tokens);
        this.visitJqlNumberField = (ctx)=>{
            const text = this.tokens.getText(ctx);
            return (0, $a0unS.internalCreators).field(text, text, undefined, (0, $4faff140f1a988e9$export$264629d4cd3cad3f)(ctx));
        };
        this.visitJqlNonNumberField = (ctx)=>{
            const stringContext = ctx.jqlString();
            const properties = ctx.jqlFieldProperty().map((context)=>context.accept(this.fieldPropertyVisitor));
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $a0unS.internalCreators).field(stringValue.value, stringValue.text, properties, (0, $4faff140f1a988e9$export$264629d4cd3cad3f)(ctx));
            }
            const text = this.tokens.getText(ctx);
            return (0, $a0unS.internalCreators).field(text, text, properties, (0, $4faff140f1a988e9$export$264629d4cd3cad3f)(ctx));
        };
    }
}
class $15a95c08b6fa2a26$var$FieldPropertyVisitor extends (0, $4faff140f1a988e9$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.argumentVisitor = new (0, $9537cab0ea5d5c75$export$46b5a1f6d962d533)(this.tokens);
        this.propertyArgumentVisitor = new $15a95c08b6fa2a26$var$PropertyArgumentVisitor(this.tokens);
        this.visitJqlFieldProperty = (ctx)=>{
            const argumentContext = ctx.jqlArgument();
            const propertyArgumentContext = ctx.jqlPropertyArgument();
            const path = propertyArgumentContext.map((context)=>context.accept(this.propertyArgumentVisitor));
            return (0, $a0unS.internalCreators).property(argumentContext && argumentContext.accept(this.argumentVisitor), path, (0, $4faff140f1a988e9$export$264629d4cd3cad3f)(ctx));
        };
    }
}
class $15a95c08b6fa2a26$var$PropertyArgumentVisitor extends (0, $4faff140f1a988e9$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.argumentVisitor = new (0, $9537cab0ea5d5c75$export$46b5a1f6d962d533)(this.tokens);
        this.visitJqlPropertyArgument = (ctx)=>{
            return ctx.jqlArgument().accept(this.argumentVisitor);
        };
    }
}


class $f938e0bdef47567d$export$2774b71b99734811 extends (0, $4faff140f1a988e9$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.searchSortVisitor = new $f938e0bdef47567d$var$SearchSortVisitor(this.tokens);
        this.visitJqlOrderBy = (ctx)=>{
            // If this rule returned due to an exception then the order by operator is incomplete so we should exit early,
            // e.g. 'order '.
            if (ctx.exception) return undefined;
            const operator = (0, $a0unS.internalCreators).orderByOperator((0, $4faff140f1a988e9$export$85a4e6d858dbc6fb)(ctx.ORDER().payload, ctx.BY().payload));
            const fields = ctx.jqlSearchSort().map((searchSortCtx)=>searchSortCtx.accept(this.searchSortVisitor)).filter((0, $f2ee0a3c79516de1$export$9a1adf421b69c6a));
            return (0, $a0unS.internalCreators).orderBy(fields, operator, (0, $4faff140f1a988e9$export$264629d4cd3cad3f)(ctx));
        };
    }
}
class $f938e0bdef47567d$var$SearchSortVisitor extends (0, $4faff140f1a988e9$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.fieldVisitor = new (0, $15a95c08b6fa2a26$export$c6a85c4c3bf2317d)(this.tokens);
        this.visitJqlSearchSort = (ctx)=>{
            const fieldCtx = ctx.jqlField();
            // If the field rule is returned due to an exception then we should ignore this search search rule. This happens
            // when there are no fields following and order by clause, e.g. 'order by '
            if (fieldCtx.exception) return undefined;
            let direction;
            const desc = ctx.DESC();
            const asc = ctx.ASC();
            if (desc !== undefined) direction = (0, $a0unS.internalCreators).orderByDirection((0, $4AL0V.ORDER_BY_DIRECTION_DESC), (0, $4faff140f1a988e9$export$85a4e6d858dbc6fb)(desc.payload));
            else if (asc !== undefined) direction = (0, $a0unS.internalCreators).orderByDirection((0, $4AL0V.ORDER_BY_DIRECTION_ASC), (0, $4faff140f1a988e9$export$85a4e6d858dbc6fb)(asc.payload));
            return (0, $a0unS.internalCreators).orderByField(ctx.jqlField().accept(this.fieldVisitor), direction, (0, $4faff140f1a988e9$export$264629d4cd3cad3f)(ctx));
        };
    }
}



var $3iWYJ = parcelRequire("3iWYJ");













var $66cjO = parcelRequire("66cjO");











class $c03c92f696399525$export$a55432f0884633e4 extends (0, $4faff140f1a988e9$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.visitJqlNumber = (ctx)=>{
            const text = this.tokens.getText(ctx);
            return (0, $a0unS.internalCreators).valueOperand(text, text, (0, $4faff140f1a988e9$export$264629d4cd3cad3f)(ctx));
        };
    }
}



class $8ef937084527265f$export$ef8ae1aa15d9c9af extends (0, $4faff140f1a988e9$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.stringVisitor = new (0, $39c92ee036813c9a$export$617850cb96304515)(this.tokens);
        this.numberVisitor = new (0, $c03c92f696399525$export$a55432f0884633e4)(this.tokens);
        this.functionNameVisitor = new $8ef937084527265f$var$FunctionNameVisitor(this.tokens);
        this.argumentListVisitor = new $8ef937084527265f$var$ArgumentListVisitor(this.tokens);
        this.visitJqlOperand = (ctx)=>{
            const operandContext = [
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlList(),
                ctx.jqlFunction()
            ].find((0, $f2ee0a3c79516de1$export$9a1adf421b69c6a));
            return operandContext?.accept(this);
        };
        this.visitJqlEmpty = (ctx)=>{
            // ANTLR will optimistically create a jqlEmpty node in some situations where user input doesn't match the EMPTY
            // token, e.g. when using value operands in IS clauses ("field is value"), where EMPTY is the only valid operand.
            if (ctx.exception) return undefined;
            return (0, $a0unS.internalCreators).keywordOperand((0, $66cjO.OPERAND_EMPTY), (0, $4faff140f1a988e9$export$85a4e6d858dbc6fb)(ctx.EMPTY().payload));
        };
        this.visitJqlValue = (ctx)=>{
            const stringContext = ctx.jqlString();
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $a0unS.internalCreators).valueOperand(stringValue.value, stringValue.text, stringValue.position);
            }
            const numberContext = ctx.jqlNumber();
            if (numberContext !== undefined) return numberContext.accept(this.numberVisitor);
        };
        this.visitJqlList = (ctx)=>{
            const values = ctx.jqlOperand().map((operandCtx)=>operandCtx.accept(this)).filter((0, $f2ee0a3c79516de1$export$9a1adf421b69c6a));
            return (0, $a0unS.internalCreators).listOperand(values, (0, $4faff140f1a988e9$export$264629d4cd3cad3f)(ctx));
        };
        this.visitJqlFunction = (ctx)=>{
            const argumentListContext = ctx.jqlArgumentList();
            return (0, $a0unS.internalCreators).functionOperand(ctx.jqlFunctionName().accept(this.functionNameVisitor), argumentListContext === undefined ? [] : argumentListContext.accept(this.argumentListVisitor), (0, $4faff140f1a988e9$export$264629d4cd3cad3f)(ctx));
        };
    }
}
class $8ef937084527265f$var$FunctionNameVisitor extends (0, $4faff140f1a988e9$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.stringVisitor = new (0, $39c92ee036813c9a$export$617850cb96304515)(this.tokens);
        this.visitJqlFunctionName = (ctx)=>{
            const stringContext = ctx.jqlString();
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $a0unS.internalCreators).functionString(stringValue.value, stringValue.text, stringValue.position);
            } else {
                const text = this.tokens.getText(ctx);
                return (0, $a0unS.internalCreators).functionString(text, text, (0, $4faff140f1a988e9$export$264629d4cd3cad3f)(ctx));
            }
        };
    }
}
class $8ef937084527265f$var$ArgumentListVisitor extends (0, $4faff140f1a988e9$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.argumentVisitor = new (0, $9537cab0ea5d5c75$export$46b5a1f6d962d533)(this.tokens);
        this.visitJqlArgumentList = (ctx)=>{
            return ctx.jqlArgument().map((argumentCtx)=>argumentCtx.accept(this.argumentVisitor));
        };
    }
}






var $dcrz0 = parcelRequire("dcrz0");


class $fd3f20930eb80d96$export$e56f89ba95b51d2a extends (0, $4faff140f1a988e9$export$d3c14d7188b09387) {
    visitJqlEqualsOperator(ctx) {
        const text = this.tokens.getText(ctx);
        if (!(0, $dcrz0.isEqualsOperator)(text)) throw new Error(`'${text}' does not match any of the recognised equals operators`);
        return (0, $a0unS.internalCreators).operator(text, text, (0, $4faff140f1a988e9$export$264629d4cd3cad3f)(ctx));
    }
    visitJqlLikeOperator(ctx) {
        const text = this.tokens.getText(ctx);
        if (!(0, $dcrz0.isLikeOperator)(text)) throw new Error(`'${text}' does not match any of the recognised like operators`);
        return (0, $a0unS.internalCreators).operator(text, text, (0, $4faff140f1a988e9$export$264629d4cd3cad3f)(ctx));
    }
    visitJqlComparisonOperator(ctx) {
        const text = this.tokens.getText(ctx);
        if (!(0, $dcrz0.isComparisonOperator)(text)) throw new Error(`'${text}' does not match any of the recognised comparison operators`);
        return (0, $a0unS.internalCreators).operator(text, text, (0, $4faff140f1a988e9$export$264629d4cd3cad3f)(ctx));
    }
    visitJqlInOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $4faff140f1a988e9$export$7c2714a5250b9239)(text);
        if (!(0, $dcrz0.isInOperator)(value)) // This can happen if an incomplete operator is used, e.g. `status not open`.
        return undefined;
        return (0, $a0unS.internalCreators).operator(value, text, (0, $4faff140f1a988e9$export$264629d4cd3cad3f)(ctx));
    }
    visitJqlIsOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $4faff140f1a988e9$export$7c2714a5250b9239)(text);
        if (!(0, $dcrz0.isIsOperator)(value)) throw new Error(`'${text}' does not match any of the recognised is operators`);
        return (0, $a0unS.internalCreators).operator(value, text, (0, $4faff140f1a988e9$export$264629d4cd3cad3f)(ctx));
    }
    visitJqlWasOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $4faff140f1a988e9$export$7c2714a5250b9239)(text);
        if (!(0, $dcrz0.isWasOperator)(value)) throw new Error(`'${text}' does not match any of the recognised was operators`);
        return (0, $a0unS.internalCreators).operator(value, text, (0, $4faff140f1a988e9$export$264629d4cd3cad3f)(ctx));
    }
    visitJqlWasInOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $4faff140f1a988e9$export$7c2714a5250b9239)(text);
        if (!(0, $dcrz0.isWasInOperator)(value)) throw new Error(`'${text}' does not match any of the recognised was in operators`);
        return (0, $a0unS.internalCreators).operator(value, text, (0, $4faff140f1a988e9$export$264629d4cd3cad3f)(ctx));
    }
    visitJqlChangedOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $4faff140f1a988e9$export$7c2714a5250b9239)(text);
        if (!(0, $dcrz0.isChangedOperator)(value)) throw new Error(`'${text}' does not match any of the recognised changed operators`);
        return (0, $a0unS.internalCreators).operator(value, text, (0, $4faff140f1a988e9$export$264629d4cd3cad3f)(ctx));
    }
    constructor(...args){
        super(...args);
        // Recover from clause type ambiguities, e.g. "issuetype was " (which can be a WAS or WAS IN clause)
        this.visitChildren = (node)=>{
            const { sourceInterval: sourceInterval } = node;
            const text = this.tokens.getText(sourceInterval);
            if (text) {
                const value = (0, $4faff140f1a988e9$export$7c2714a5250b9239)(text);
                const { a: startIndex, b: stopIndex } = sourceInterval;
                const startToken = this.tokens.get(startIndex);
                const stopToken = this.tokens.get(stopIndex);
                const position = (0, $4faff140f1a988e9$export$85a4e6d858dbc6fb)(startToken, stopToken);
                if ((0, $dcrz0.isOperator)(value)) return (0, $a0unS.internalCreators).operator(value, text, position);
            }
            return undefined;
        };
    }
}





const $afee41552f9ad7f5$export$3d56e2ae1b4bbbf9 = 'after';
const $afee41552f9ad7f5$export$f0a816341603bb63 = 'before';
const $afee41552f9ad7f5$export$cdc81c84f768d513 = 'by';
const $afee41552f9ad7f5$export$8a5280c65e704c3d = 'during';
const $afee41552f9ad7f5$export$71f882dcac65f97a = 'from';
const $afee41552f9ad7f5$export$5685a35c6b0a7ee8 = 'on';
const $afee41552f9ad7f5$export$5a83c4789e531a = 'to';
const $afee41552f9ad7f5$export$e200440af9f1d9f = [
    $afee41552f9ad7f5$export$3d56e2ae1b4bbbf9,
    $afee41552f9ad7f5$export$f0a816341603bb63,
    $afee41552f9ad7f5$export$cdc81c84f768d513,
    $afee41552f9ad7f5$export$8a5280c65e704c3d,
    $afee41552f9ad7f5$export$71f882dcac65f97a,
    $afee41552f9ad7f5$export$5685a35c6b0a7ee8,
    $afee41552f9ad7f5$export$5a83c4789e531a
];


const $533c2bc3182a223b$export$188978ad94919403 = (operator)=>(0, $afee41552f9ad7f5$export$e200440af9f1d9f).includes(operator);





class $6ed6d2db016818a9$export$33bb52a35c693109 extends (0, $4faff140f1a988e9$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.predicateOperatorVisitor = new $6ed6d2db016818a9$var$PredicateOperatorVisitor(this.tokens);
        this.predicateOperandVisitor = new $6ed6d2db016818a9$var$PredicateOperandVisitor(this.tokens);
        this.visitJqlWasPredicate = (ctx)=>{
            const operator = this.getOperatorForContexts([
                ctx.jqlDatePredicateOperator(),
                ctx.jqlDateRangePredicateOperator(),
                ctx.jqlUserPredicateOperator()
            ]);
            const operand = ctx.jqlPredicateOperand().accept(this.predicateOperandVisitor);
            const position = (0, $4faff140f1a988e9$export$264629d4cd3cad3f)(ctx);
            return (0, $a0unS.internalCreators).predicate(operator, operand, position);
        };
        this.visitJqlChangedPredicate = (ctx)=>{
            const operator = this.getOperatorForContexts([
                ctx.jqlDatePredicateOperator(),
                ctx.jqlDateRangePredicateOperator(),
                ctx.jqlUserPredicateOperator(),
                ctx.jqlValuePredicateOperator()
            ]);
            const operand = ctx.jqlPredicateOperand().accept(this.predicateOperandVisitor);
            const position = (0, $4faff140f1a988e9$export$264629d4cd3cad3f)(ctx);
            return (0, $a0unS.internalCreators).predicate(operator, operand, position);
        };
        this.getOperatorForContexts = (contexts)=>{
            const operatorContext = contexts.find((0, $f2ee0a3c79516de1$export$9a1adf421b69c6a));
            if (operatorContext !== undefined) return operatorContext.accept(this.predicateOperatorVisitor);
            else throw new Error('Undefined predicate operator context');
        };
    }
}
class $6ed6d2db016818a9$var$PredicateOperatorVisitor extends (0, $4faff140f1a988e9$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.visitJqlDatePredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        };
        this.visitJqlDateRangePredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        };
        this.visitJqlUserPredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        };
        this.visitJqlValuePredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        };
        this.getPredicateOperator = (ctx)=>{
            const text = this.tokens.getText(ctx);
            // Replace consecutive whitespace chars with single space
            const value = text.toLowerCase().replace(/\s+/g, ' ');
            if (!(0, $533c2bc3182a223b$export$188978ad94919403)(value)) throw new Error(`Found a history predicate operator which does not map to a changed time predicate operator in the ast: ${text}`);
            return (0, $a0unS.internalCreators).predicateOperator(value, text, (0, $4faff140f1a988e9$export$264629d4cd3cad3f)(ctx));
        };
    }
}
class $6ed6d2db016818a9$var$PredicateOperandVisitor extends (0, $4faff140f1a988e9$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.operandVisitor = new (0, $8ef937084527265f$export$ef8ae1aa15d9c9af)(this.tokens);
        this.visitJqlPredicateOperand = (ctx)=>{
            return ctx.jqlOperand().accept(this.operandVisitor);
        };
    }
}


class $20ea0ceef29c39e9$export$14576ae5bd1874a9 extends (0, $4faff140f1a988e9$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.fieldVisitor = new (0, $15a95c08b6fa2a26$export$c6a85c4c3bf2317d)(this.tokens);
        this.terminalClauseRhsVisitor = new $20ea0ceef29c39e9$var$TerminalClauseRhsVisitor(this.tokens);
        this.visitJqlTerminalClause = (ctx)=>{
            const field = ctx.jqlField().accept(this.fieldVisitor);
            const { operator: operator, operand: operand, predicates: predicates } = ctx.jqlTerminalClauseRhs().accept(this.terminalClauseRhsVisitor);
            const position = (0, $4faff140f1a988e9$export$264629d4cd3cad3f)(ctx);
            return (0, $a0unS.internalCreators).terminalClause(field, operator, operand, predicates, position);
        };
    }
}
class $20ea0ceef29c39e9$var$TerminalClauseRhsVisitor extends (0, $4faff140f1a988e9$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.operatorVisitor = new (0, $fd3f20930eb80d96$export$e56f89ba95b51d2a)(this.tokens);
        this.terminalClauseOperandVisitor = new $20ea0ceef29c39e9$var$TerminalClauseOperandVisitor(this.tokens);
        this.predicateVisitor = new (0, $6ed6d2db016818a9$export$33bb52a35c693109)(this.tokens);
        this.visitJqlEqualsClause = (ctx)=>{
            const operator = ctx.jqlEqualsOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        };
        this.visitJqlLikeClause = (ctx)=>{
            const operator = ctx.jqlLikeOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        };
        this.visitJqlComparisonClause = (ctx)=>{
            const operator = ctx.jqlComparisonOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        };
        this.visitJqlInClause = (ctx)=>{
            const operator = ctx.jqlInOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        };
        this.visitJqlIsClause = (ctx)=>{
            const operator = ctx.jqlIsOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        };
        this.visitJqlWasClause = (ctx)=>{
            const operator = ctx.jqlWasOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            const predicates = ctx.jqlWasPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, $f2ee0a3c79516de1$export$9a1adf421b69c6a));
            return {
                operator: operator,
                operand: operand,
                predicates: predicates
            };
        };
        this.visitJqlWasInClause = (ctx)=>{
            const operator = ctx.jqlWasInOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            const predicates = ctx.jqlWasPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, $f2ee0a3c79516de1$export$9a1adf421b69c6a));
            return {
                operator: operator,
                operand: operand,
                predicates: predicates
            };
        };
        this.visitJqlChangedClause = (ctx)=>{
            const operator = ctx.jqlChangedOperator().accept(this.operatorVisitor);
            const predicates = ctx.jqlChangedPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, $f2ee0a3c79516de1$export$9a1adf421b69c6a));
            return {
                operator: operator,
                operand: undefined,
                predicates: predicates
            };
        };
        // Recover from clause type ambiguities, e.g. "issuetype was " (which can be a WAS or WAS IN clause)
        this.visitChildren = (node)=>{
            const operator = node.accept(this.operatorVisitor);
            return {
                operator: operator,
                operand: undefined,
                predicates: []
            };
        };
    }
}
class $20ea0ceef29c39e9$var$TerminalClauseOperandVisitor extends (0, $4faff140f1a988e9$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.operandVisitor = new (0, $8ef937084527265f$export$ef8ae1aa15d9c9af)(this.tokens);
        this.visitJqlEqualsClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        };
        this.visitJqlLikeClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        };
        this.visitJqlComparisonClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        };
        this.visitJqlInClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlList(),
                ctx.jqlFunction()
            ]);
        };
        this.visitJqlIsClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty()
            ]);
        };
        this.visitJqlWasClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        };
        this.visitJqlWasInClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlList(),
                ctx.jqlFunction()
            ]);
        };
        this.getOperandForContexts = (contexts)=>{
            const operandContext = contexts.find((0, $f2ee0a3c79516de1$export$9a1adf421b69c6a));
            return operandContext?.accept(this.operandVisitor);
        };
    }
}


class $e94a34ed2b03a162$export$c573472f1d20e15d extends (0, $4faff140f1a988e9$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.terminalClauseVisitor = new (0, $20ea0ceef29c39e9$export$14576ae5bd1874a9)(this.tokens);
        this.visitJqlWhere = (ctx)=>{
            return this.visitJqlOrClause(ctx.jqlOrClause());
        };
        this.visitJqlOrClause = (ctx)=>{
            const clauses = ctx.jqlAndClause().map((andClauseContext)=>andClauseContext.accept(this)).filter((0, $f2ee0a3c79516de1$export$9a1adf421b69c6a));
            if (clauses.length > 1) {
                const operator = (0, $a0unS.internalCreators).compoundOperator((0, $3iWYJ.COMPOUND_OPERATOR_OR), (0, $4faff140f1a988e9$export$30d51184879cbaa8)(ctx.OR()));
                return (0, $a0unS.internalCreators).compoundClause(operator, clauses, (0, $4faff140f1a988e9$export$264629d4cd3cad3f)(ctx));
            }
            return clauses.length === 0 ? undefined : clauses[0];
        };
        this.visitJqlAndClause = (ctx)=>{
            const clauses = ctx.jqlNotClause().map((notClauseContext)=>notClauseContext.accept(this)).filter((0, $f2ee0a3c79516de1$export$9a1adf421b69c6a));
            if (clauses.length > 1) {
                const operator = (0, $a0unS.internalCreators).compoundOperator((0, $3iWYJ.COMPOUND_OPERATOR_AND), (0, $4faff140f1a988e9$export$30d51184879cbaa8)(ctx.AND()));
                return (0, $a0unS.internalCreators).compoundClause(operator, clauses, (0, $4faff140f1a988e9$export$264629d4cd3cad3f)(ctx));
            }
            return clauses.length === 0 ? undefined : clauses[0];
        };
        this.visitJqlNotClause = (ctx)=>{
            const notClauseContext = ctx.jqlNotClause();
            const subClauseContext = ctx.jqlSubClause();
            const terminalClauseContext = ctx.jqlTerminalClause();
            let clause;
            if (notClauseContext !== undefined) clause = notClauseContext.accept(this) || undefined;
            else if (subClauseContext !== undefined) clause = subClauseContext.accept(this) || undefined;
            else if (terminalClauseContext !== undefined) clause = terminalClauseContext.accept(this.terminalClauseVisitor);
            // Our token can be either NOT or !
            let notToken = ctx.NOT();
            notToken = notToken === undefined ? ctx.BANG() : notToken;
            if (notToken && clause) return (0, $a0unS.internalCreators).notClause(clause, (0, $a0unS.internalCreators).notClauseOperator((0, $4faff140f1a988e9$export$85a4e6d858dbc6fb)(notToken.payload)), (0, $4faff140f1a988e9$export$264629d4cd3cad3f)(ctx));
            return clause;
        };
        this.visitJqlSubClause = (ctx)=>{
            return this.visitJqlOrClause(ctx.jqlOrClause());
        };
    }
}


class $f0ca4ebcd3d2aa52$export$418003b930734805 extends (0, $4faff140f1a988e9$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.whereVisitor = new (0, $e94a34ed2b03a162$export$c573472f1d20e15d)(this.tokens);
        this.orderByVisitor = new (0, $f938e0bdef47567d$export$2774b71b99734811)(this.tokens);
        this.visitJqlQuery = (ctx)=>{
            const whereContext = ctx.jqlWhere();
            const orderByContext = ctx.jqlOrderBy();
            return (0, $a0unS.internalCreators).query(whereContext && whereContext.accept(this.whereVisitor), orderByContext && orderByContext.accept(this.orderByVisitor), (0, $4faff140f1a988e9$export$264629d4cd3cad3f)(ctx));
        };
    }
}


class $3a8c8d3c62b422e4$export$99cae18a5a6ba8cf {
    setErrorHandler(errorHandler) {
        this.errorHandler = errorHandler;
        return this;
    }
    setErrorListeners(errorListeners) {
        this.errorListeners = this.errorListeners.concat(errorListeners);
        return this;
    }
    build(value) {
        const tokens = this.getTokens(value);
        const parser = this.getParser(tokens);
        const astErrorListener = new (0, $9032d76e76efa64d$export$d0857f60ff1f385)();
        parser.removeErrorListeners();
        parser.addErrorListener(astErrorListener);
        this.errorListeners.forEach((errorListener)=>parser.addErrorListener(errorListener));
        if (this.errorHandler) {
            parser.errorHandler = this.errorHandler;
            this.errorHandler.reset(parser);
        }
        const visitor = new (0, $f0ca4ebcd3d2aa52$export$418003b930734805)(tokens);
        try {
            const parseTree = parser.jqlQuery();
            const query = parseTree.accept(visitor);
            return (0, $a0unS.default).jast(query, value, astErrorListener.errors);
        } catch (error) {
            return (0, $a0unS.default).jast(undefined, value, [
                new (0, $jLG6B.JQLParseError)(error.message, error)
            ]);
        }
    }
    constructor(){
        this.errorListeners = [];
        this.errorHandler = undefined;
        this.getTokens = (0, $dOBRD.default)((value)=>{
            const chars = (0, $bhs7f.CharStreams).fromString(value);
            const lexer = new (0, $2nXS3.JQLLexer)(chars);
            return new (0, $bhs7f.CommonTokenStream)(lexer);
        });
        this.getParser = (0, $dOBRD.default)((tokens)=>new (0, $56ams.JQLParser)(tokens));
    }
}
module.exports["JastBuilder"] = $3a8c8d3c62b422e4$export$99cae18a5a6ba8cf;

});

parcelRegister("bhs7f", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $8367177e3946986f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8367177e3946986f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8367177e3946986f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8367177e3946986f$var$__exportStar((parcelRequire("ARdMM")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("joXti")), module.exports);

// export * from "./ANTLRFileStream";
$8367177e3946986f$var$__exportStar((parcelRequire("5SlTA")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("d2R0u")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("geTWu")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("5hGFQ")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("9lBaI")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("cRZzh")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("fRlA6")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("eAd9i")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("aK9bI")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("1BCwT")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("6QLt6")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("j3UyO")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("8zXr0")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("c6lgr")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("5BYcl")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("l9UFP")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("6qbZR")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("9P2T1")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("gJMeE")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("f34tW")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("hh2Av")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("lf6D7")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("gm3rl")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("5XMF6")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("9OB0P")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("7HcZT")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("5izRN")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("16dXu")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("c6a5T")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("beMqO")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("bwXFO")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("7rnsN")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("aVYvQ")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("fJ53d")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("9gsnS")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("TNDGs")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("lyL1w")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("1Gdfm")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("4LMM0")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("yaMYv")), module.exports);

// export * from "./UnbufferedCharStream";
// export * from "./UnbufferedTokenStream";
$8367177e3946986f$var$__exportStar((parcelRequire("egzAU")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("56U0W")), module.exports);

$8367177e3946986f$var$__exportStar((parcelRequire("efi0K")), module.exports);

});

parcelRegister("ARdMM", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("joXti", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("5SlTA", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ // ConvertTo-TS run at 2016-10-04T11:26:49.0828748-07:00
var $4472fae4ca16bf6f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ANTLRInputStream = void 0;

var $9Rq82 = parcelRequire("9Rq82");


var $ffTXa = parcelRequire("ffTXa");


var $9P2T1 = parcelRequire("9P2T1");

const $4472fae4ca16bf6f$var$READ_BUFFER_SIZE = 1024;
const $4472fae4ca16bf6f$var$INITIAL_BUFFER_SIZE = 1024;
/**
 * Vacuum all input from a {@link Reader}/{@link InputStream} and then treat it
 * like a `char[]` buffer. Can also pass in a {@link String} or
 * `char[]` to use.
 *
 * If you need encoding, pass in stream/reader with correct encoding.
 *
 * @deprecated as of 4.7, please use `CharStreams` interface.
 */ class $4472fae4ca16bf6f$var$ANTLRInputStream {
    /** Reset the stream so that it's in the same state it was
     *  when the object was created *except* the data array is not
     *  touched.
     */ reset() {
        this.p = 0;
    }
    consume() {
        if (this.p >= this.n) {
            $9Rq82(this.LA(1) === $9P2T1.IntStream.EOF);
            throw new Error("cannot consume EOF");
        }
        //System.out.println("prev p="+p+", c="+(char)data[p]);
        if (this.p < this.n) this.p++;
    }
    LA(i) {
        if (i === 0) return 0; // undefined
        if (i < 0) {
            i++; // e.g., translate LA(-1) to use offset i=0; then data[p+0-1]
            if (this.p + i - 1 < 0) return $9P2T1.IntStream.EOF; // invalid; no char before first char
        }
        if (this.p + i - 1 >= this.n) //System.out.println("char LA("+i+")=EOF; p="+p);
        return $9P2T1.IntStream.EOF;
        //System.out.println("char LA("+i+")="+(char)data[p+i-1]+"; p="+p);
        //System.out.println("LA("+i+"); p="+p+" n="+n+" data.length="+data.length);
        return this.data.charCodeAt(this.p + i - 1);
    }
    LT(i) {
        return this.LA(i);
    }
    /** Return the current input symbol index 0..n where n indicates the
     *  last symbol has been read.  The index is the index of char to
     *  be returned from LA(1).
     */ get index() {
        return this.p;
    }
    get size() {
        return this.n;
    }
    /** mark/release do nothing; we have entire buffer */ mark() {
        return -1;
    }
    release(marker) {
    // No default implementation since this stream buffers the entire input
    }
    /** consume() ahead until p==index; can't just set p=index as we must
     *  update line and charPositionInLine. If we seek backwards, just set p
     */ seek(index) {
        if (index <= this.p) {
            this.p = index; // just jump; don't update stream state (line, ...)
            return;
        }
        // seek forward, consume until p hits index or n (whichever comes first)
        index = Math.min(index, this.n);
        while(this.p < index)this.consume();
    }
    getText(interval) {
        let start = interval.a;
        let stop = interval.b;
        if (stop >= this.n) stop = this.n - 1;
        let count = stop - start + 1;
        if (start >= this.n) return "";
        // System.err.println("data: "+Arrays.toString(data)+", n="+n+
        // 				   ", start="+start+
        // 				   ", stop="+stop);
        return this.data.substr(start, count);
    }
    get sourceName() {
        if (!this.name) return $9P2T1.IntStream.UNKNOWN_SOURCE_NAME;
        return this.name;
    }
    toString() {
        return this.data;
    }
    /** Copy data in string to a local char array */ constructor(input){
        /** 0..n-1 index into string of next char */ this.p = 0;
        this.data = input;
        this.n = input.length;
    }
}
$4472fae4ca16bf6f$var$__decorate([
    $ffTXa.Override
], $4472fae4ca16bf6f$var$ANTLRInputStream.prototype, "consume", null);
$4472fae4ca16bf6f$var$__decorate([
    $ffTXa.Override
], $4472fae4ca16bf6f$var$ANTLRInputStream.prototype, "LA", null);
$4472fae4ca16bf6f$var$__decorate([
    $ffTXa.Override
], $4472fae4ca16bf6f$var$ANTLRInputStream.prototype, "index", null);
$4472fae4ca16bf6f$var$__decorate([
    $ffTXa.Override
], $4472fae4ca16bf6f$var$ANTLRInputStream.prototype, "size", null);
$4472fae4ca16bf6f$var$__decorate([
    $ffTXa.Override
], $4472fae4ca16bf6f$var$ANTLRInputStream.prototype, "mark", null);
$4472fae4ca16bf6f$var$__decorate([
    $ffTXa.Override
], $4472fae4ca16bf6f$var$ANTLRInputStream.prototype, "release", null);
$4472fae4ca16bf6f$var$__decorate([
    $ffTXa.Override
], $4472fae4ca16bf6f$var$ANTLRInputStream.prototype, "seek", null);
$4472fae4ca16bf6f$var$__decorate([
    $ffTXa.Override
], $4472fae4ca16bf6f$var$ANTLRInputStream.prototype, "getText", null);
$4472fae4ca16bf6f$var$__decorate([
    $ffTXa.Override
], $4472fae4ca16bf6f$var$ANTLRInputStream.prototype, "sourceName", null);
$4472fae4ca16bf6f$var$__decorate([
    $ffTXa.Override
], $4472fae4ca16bf6f$var$ANTLRInputStream.prototype, "toString", null);
module.exports.ANTLRInputStream = $4472fae4ca16bf6f$var$ANTLRInputStream;

});

parcelRegister("ffTXa", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SuppressWarnings = module.exports.Override = module.exports.Nullable = module.exports.NotNull = void 0;
function $b1b3a8e66eab4492$var$NotNull(target, propertyKey, propertyDescriptor) {
// intentionally empty
}
module.exports.NotNull = $b1b3a8e66eab4492$var$NotNull;
function $b1b3a8e66eab4492$var$Nullable(target, propertyKey, propertyDescriptor) {
// intentionally empty
}
module.exports.Nullable = $b1b3a8e66eab4492$var$Nullable;
function $b1b3a8e66eab4492$var$Override(target, propertyKey, propertyDescriptor) {
// do something with 'target' ...
}
module.exports.Override = $b1b3a8e66eab4492$var$Override;
function $b1b3a8e66eab4492$var$SuppressWarnings(options) {
    return (target, propertyKey, descriptor)=>{
    // intentionally empty
    };
}
module.exports.SuppressWarnings = $b1b3a8e66eab4492$var$SuppressWarnings;

});

parcelRegister("9P2T1", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntStream = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:51.6934376-07:00
var $726b1dac7b9d96e3$var$IntStream;
(function(IntStream) {
    /**
     * The value returned by {@link #LA LA()} when the end of the stream is
     * reached.
     */ IntStream.EOF = -1;
    /**
     * The value returned by {@link #getSourceName} when the actual name of the
     * underlying source is not known.
     */ IntStream.UNKNOWN_SOURCE_NAME = "<unknown>";
})($726b1dac7b9d96e3$var$IntStream = module.exports.IntStream || (module.exports.IntStream = {}));

});

parcelRegister("d2R0u", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $97f4944f5cb222bd$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BailErrorStrategy = void 0;

var $j3UyO = parcelRequire("j3UyO");


var $l9UFP = parcelRequire("l9UFP");


var $ffTXa = parcelRequire("ffTXa");


var $bXUCC = parcelRequire("bXUCC");

/**
 * This implementation of {@link ANTLRErrorStrategy} responds to syntax errors
 * by immediately canceling the parse operation with a
 * {@link ParseCancellationException}. The implementation ensures that the
 * {@link ParserRuleContext#exception} field is set for all parse tree nodes
 * that were not completed prior to encountering the error.
 *
 * This error strategy is useful in the following scenarios.
 *
 * * **Two-stage parsing:** This error strategy allows the first
 *   stage of two-stage parsing to immediately terminate if an error is
 *   encountered, and immediately fall back to the second stage. In addition to
 *   avoiding wasted work by attempting to recover from errors here, the empty
 *   implementation of {@link BailErrorStrategy#sync} improves the performance of
 *   the first stage.
 * * **Silent validation:** When syntax errors are not being
 *   reported or logged, and the parse result is simply ignored if errors occur,
 *   the {@link BailErrorStrategy} avoids wasting work on recovering from errors
 *   when the result will be ignored either way.
 *
 * ```
 * myparser.errorHandler = new BailErrorStrategy();
 * ```
 *
 * @see Parser.errorHandler
 */ class $97f4944f5cb222bd$var$BailErrorStrategy extends $j3UyO.DefaultErrorStrategy {
    /** Instead of recovering from exception `e`, re-throw it wrapped
     *  in a {@link ParseCancellationException} so it is not caught by the
     *  rule function catches.  Use {@link Exception#getCause()} to get the
     *  original {@link RecognitionException}.
     */ recover(recognizer, e) {
        for(let context = recognizer.context; context; context = context.parent)context.exception = e;
        throw new $bXUCC.ParseCancellationException(e);
    }
    /** Make sure we don't attempt to recover inline; if the parser
     *  successfully recovers, it won't throw an exception.
     */ recoverInline(recognizer) {
        let e = new $l9UFP.InputMismatchException(recognizer);
        for(let context = recognizer.context; context; context = context.parent)context.exception = e;
        throw new $bXUCC.ParseCancellationException(e);
    }
    /** Make sure we don't attempt to recover from problems in subrules. */ sync(recognizer) {
    // intentionally empty
    }
}
$97f4944f5cb222bd$var$__decorate([
    $ffTXa.Override
], $97f4944f5cb222bd$var$BailErrorStrategy.prototype, "recover", null);
$97f4944f5cb222bd$var$__decorate([
    $ffTXa.Override
], $97f4944f5cb222bd$var$BailErrorStrategy.prototype, "recoverInline", null);
$97f4944f5cb222bd$var$__decorate([
    $ffTXa.Override
], $97f4944f5cb222bd$var$BailErrorStrategy.prototype, "sync", null);
module.exports.BailErrorStrategy = $97f4944f5cb222bd$var$BailErrorStrategy;

});

parcelRegister("j3UyO", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $de0a2bdceaefa13d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $de0a2bdceaefa13d$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultErrorStrategy = void 0;

var $2UrJv = parcelRequire("2UrJv");


var $5dqQL = parcelRequire("5dqQL");


var $5BYcl = parcelRequire("5BYcl");


var $l9UFP = parcelRequire("l9UFP");


var $69z5o = parcelRequire("69z5o");


var $gm3rl = parcelRequire("gm3rl");


var $2EGxJ = parcelRequire("2EGxJ");


var $TNDGs = parcelRequire("TNDGs");


var $ffTXa = parcelRequire("ffTXa");

/**
 * This is the default implementation of {@link ANTLRErrorStrategy} used for
 * error reporting and recovery in ANTLR parsers.
 */ class $de0a2bdceaefa13d$var$DefaultErrorStrategy {
    /**
     * {@inheritDoc}
     *
     * The default implementation simply calls {@link #endErrorCondition} to
     * ensure that the handler is not in error recovery mode.
     */ reset(recognizer) {
        this.endErrorCondition(recognizer);
    }
    /**
     * This method is called to enter error recovery mode when a recognition
     * exception is reported.
     *
     * @param recognizer the parser instance
     */ beginErrorCondition(recognizer) {
        this.errorRecoveryMode = true;
    }
    /**
     * {@inheritDoc}
     */ inErrorRecoveryMode(recognizer) {
        return this.errorRecoveryMode;
    }
    /**
     * This method is called to leave error recovery mode after recovering from
     * a recognition exception.
     *
     * @param recognizer
     */ endErrorCondition(recognizer) {
        this.errorRecoveryMode = false;
        this.lastErrorStates = undefined;
        this.lastErrorIndex = -1;
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation simply calls {@link #endErrorCondition}.
     */ reportMatch(recognizer) {
        this.endErrorCondition(recognizer);
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation returns immediately if the handler is already
     * in error recovery mode. Otherwise, it calls {@link #beginErrorCondition}
     * and dispatches the reporting task based on the runtime type of `e`
     * according to the following table.
     *
     * * {@link NoViableAltException}: Dispatches the call to
     *   {@link #reportNoViableAlternative}
     * * {@link InputMismatchException}: Dispatches the call to
     *   {@link #reportInputMismatch}
     * * {@link FailedPredicateException}: Dispatches the call to
     *   {@link #reportFailedPredicate}
     * * All other types: calls {@link Parser#notifyErrorListeners} to report
     *   the exception
     */ reportError(recognizer, e) {
        // if we've already reported an error and have not matched a token
        // yet successfully, don't report any errors.
        if (this.inErrorRecoveryMode(recognizer)) //			System.err.print("[SPURIOUS] ");
        return; // don't report spurious errors
        this.beginErrorCondition(recognizer);
        if (e instanceof $gm3rl.NoViableAltException) this.reportNoViableAlternative(recognizer, e);
        else if (e instanceof $l9UFP.InputMismatchException) this.reportInputMismatch(recognizer, e);
        else if (e instanceof $5BYcl.FailedPredicateException) this.reportFailedPredicate(recognizer, e);
        else {
            console.error(`unknown recognition error type: ${e}`);
            this.notifyErrorListeners(recognizer, e.toString(), e);
        }
    }
    notifyErrorListeners(recognizer, message, e) {
        let offendingToken = e.getOffendingToken(recognizer);
        if (offendingToken === undefined) // Pass null to notifyErrorListeners so it in turn calls the error listeners with undefined as the offending
        // token. If we passed undefined, it would instead call the listeners with currentToken from the parser.
        offendingToken = null;
        recognizer.notifyErrorListeners(message, offendingToken, e);
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation resynchronizes the parser by consuming tokens
     * until we find one in the resynchronization set--loosely the set of tokens
     * that can follow the current rule.
     */ recover(recognizer, e) {
        //		System.out.println("recover in "+recognizer.getRuleInvocationStack()+
        //						   " index="+recognizer.inputStream.index+
        //						   ", lastErrorIndex="+
        //						   lastErrorIndex+
        //						   ", states="+lastErrorStates);
        if (this.lastErrorIndex === recognizer.inputStream.index && this.lastErrorStates && this.lastErrorStates.contains(recognizer.state)) // uh oh, another error at same token index and previously-visited
        // state in ATN; must be a case where LT(1) is in the recovery
        // token set so nothing got consumed. Consume a single token
        // at least to prevent an infinite loop; this is a failsafe.
        //			System.err.println("seen error condition before index="+
        //							   lastErrorIndex+", states="+lastErrorStates);
        //			System.err.println("FAILSAFE consumes "+recognizer.getTokenNames()[recognizer.inputStream.LA(1)]);
        recognizer.consume();
        this.lastErrorIndex = recognizer.inputStream.index;
        if (!this.lastErrorStates) this.lastErrorStates = new $69z5o.IntervalSet();
        this.lastErrorStates.add(recognizer.state);
        let followSet = this.getErrorRecoverySet(recognizer);
        this.consumeUntil(recognizer, followSet);
    }
    /**
     * The default implementation of {@link ANTLRErrorStrategy#sync} makes sure
     * that the current lookahead symbol is consistent with what were expecting
     * at this point in the ATN. You can call this anytime but ANTLR only
     * generates code to check before subrules/loops and each iteration.
     *
     * Implements Jim Idle's magic sync mechanism in closures and optional
     * subrules. E.g.,
     *
     * ```antlr
     * a : sync ( stuff sync )* ;
     * sync : {consume to what can follow sync} ;
     * ```
     *
     * At the start of a sub rule upon error, {@link #sync} performs single
     * token deletion, if possible. If it can't do that, it bails on the current
     * rule and uses the default error recovery, which consumes until the
     * resynchronization set of the current rule.
     *
     * If the sub rule is optional (`(...)?`, `(...)*`, or block
     * with an empty alternative), then the expected set includes what follows
     * the subrule.
     *
     * During loop iteration, it consumes until it sees a token that can start a
     * sub rule or what follows loop. Yes, that is pretty aggressive. We opt to
     * stay in the loop as long as possible.
     *
     * **ORIGINS**
     *
     * Previous versions of ANTLR did a poor job of their recovery within loops.
     * A single mismatch token or missing token would force the parser to bail
     * out of the entire rules surrounding the loop. So, for rule
     *
     * ```antlr
     * classDef : 'class' ID '{' member* '}'
     * ```
     *
     * input with an extra token between members would force the parser to
     * consume until it found the next class definition rather than the next
     * member definition of the current class.
     *
     * This functionality cost a little bit of effort because the parser has to
     * compare token set at the start of the loop and at each iteration. If for
     * some reason speed is suffering for you, you can turn off this
     * functionality by simply overriding this method as a blank { }.
     */ sync(recognizer) {
        let s = recognizer.interpreter.atn.states[recognizer.state];
        //		System.err.println("sync @ "+s.stateNumber+"="+s.getClass().getSimpleName());
        // If already recovering, don't try to sync
        if (this.inErrorRecoveryMode(recognizer)) return;
        let tokens = recognizer.inputStream;
        let la = tokens.LA(1);
        // try cheaper subset first; might get lucky. seems to shave a wee bit off
        let nextTokens = recognizer.atn.nextTokens(s);
        if (nextTokens.contains(la)) {
            // We are sure the token matches
            this.nextTokensContext = undefined;
            this.nextTokensState = $2UrJv.ATNState.INVALID_STATE_NUMBER;
            return;
        }
        if (nextTokens.contains($TNDGs.Token.EPSILON)) {
            if (this.nextTokensContext === undefined) {
                // It's possible the next token won't match; information tracked
                // by sync is restricted for performance.
                this.nextTokensContext = recognizer.context;
                this.nextTokensState = recognizer.state;
            }
            return;
        }
        switch(s.stateType){
            case $5dqQL.ATNStateType.BLOCK_START:
            case $5dqQL.ATNStateType.STAR_BLOCK_START:
            case $5dqQL.ATNStateType.PLUS_BLOCK_START:
            case $5dqQL.ATNStateType.STAR_LOOP_ENTRY:
                // report error and recover if possible
                if (this.singleTokenDeletion(recognizer)) return;
                throw new $l9UFP.InputMismatchException(recognizer);
            case $5dqQL.ATNStateType.PLUS_LOOP_BACK:
            case $5dqQL.ATNStateType.STAR_LOOP_BACK:
                //			System.err.println("at loop back: "+s.getClass().getSimpleName());
                this.reportUnwantedToken(recognizer);
                let expecting = recognizer.getExpectedTokens();
                let whatFollowsLoopIterationOrRule = expecting.or(this.getErrorRecoverySet(recognizer));
                this.consumeUntil(recognizer, whatFollowsLoopIterationOrRule);
                break;
            default:
                break;
        }
    }
    /**
     * This is called by {@link #reportError} when the exception is a
     * {@link NoViableAltException}.
     *
     * @see #reportError
     *
     * @param recognizer the parser instance
     * @param e the recognition exception
     */ reportNoViableAlternative(recognizer, e) {
        let tokens = recognizer.inputStream;
        let input;
        if (tokens) {
            if (e.startToken.type === $TNDGs.Token.EOF) input = "<EOF>";
            else input = tokens.getTextFromRange(e.startToken, e.getOffendingToken());
        } else input = "<unknown input>";
        let msg = "no viable alternative at input " + this.escapeWSAndQuote(input);
        this.notifyErrorListeners(recognizer, msg, e);
    }
    /**
     * This is called by {@link #reportError} when the exception is an
     * {@link InputMismatchException}.
     *
     * @see #reportError
     *
     * @param recognizer the parser instance
     * @param e the recognition exception
     */ reportInputMismatch(recognizer, e) {
        let expected = e.expectedTokens;
        let expectedString = expected ? expected.toStringVocabulary(recognizer.vocabulary) : "";
        let msg = "mismatched input " + this.getTokenErrorDisplay(e.getOffendingToken(recognizer)) + " expecting " + expectedString;
        this.notifyErrorListeners(recognizer, msg, e);
    }
    /**
     * This is called by {@link #reportError} when the exception is a
     * {@link FailedPredicateException}.
     *
     * @see #reportError
     *
     * @param recognizer the parser instance
     * @param e the recognition exception
     */ reportFailedPredicate(recognizer, e) {
        let ruleName = recognizer.ruleNames[recognizer.context.ruleIndex];
        let msg = "rule " + ruleName + " " + e.message;
        this.notifyErrorListeners(recognizer, msg, e);
    }
    /**
     * This method is called to report a syntax error which requires the removal
     * of a token from the input stream. At the time this method is called, the
     * erroneous symbol is current `LT(1)` symbol and has not yet been
     * removed from the input stream. When this method returns,
     * `recognizer` is in error recovery mode.
     *
     * This method is called when {@link #singleTokenDeletion} identifies
     * single-token deletion as a viable recovery strategy for a mismatched
     * input error.
     *
     * The default implementation simply returns if the handler is already in
     * error recovery mode. Otherwise, it calls {@link #beginErrorCondition} to
     * enter error recovery mode, followed by calling
     * {@link Parser#notifyErrorListeners}.
     *
     * @param recognizer the parser instance
     */ reportUnwantedToken(recognizer) {
        if (this.inErrorRecoveryMode(recognizer)) return;
        this.beginErrorCondition(recognizer);
        let t = recognizer.currentToken;
        let tokenName = this.getTokenErrorDisplay(t);
        let expecting = this.getExpectedTokens(recognizer);
        let msg = "extraneous input " + tokenName + " expecting " + expecting.toStringVocabulary(recognizer.vocabulary);
        recognizer.notifyErrorListeners(msg, t, undefined);
    }
    /**
     * This method is called to report a syntax error which requires the
     * insertion of a missing token into the input stream. At the time this
     * method is called, the missing token has not yet been inserted. When this
     * method returns, `recognizer` is in error recovery mode.
     *
     * This method is called when {@link #singleTokenInsertion} identifies
     * single-token insertion as a viable recovery strategy for a mismatched
     * input error.
     *
     * The default implementation simply returns if the handler is already in
     * error recovery mode. Otherwise, it calls {@link #beginErrorCondition} to
     * enter error recovery mode, followed by calling
     * {@link Parser#notifyErrorListeners}.
     *
     * @param recognizer the parser instance
     */ reportMissingToken(recognizer) {
        if (this.inErrorRecoveryMode(recognizer)) return;
        this.beginErrorCondition(recognizer);
        let t = recognizer.currentToken;
        let expecting = this.getExpectedTokens(recognizer);
        let msg = "missing " + expecting.toStringVocabulary(recognizer.vocabulary) + " at " + this.getTokenErrorDisplay(t);
        recognizer.notifyErrorListeners(msg, t, undefined);
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation attempts to recover from the mismatched input
     * by using single token insertion and deletion as described below. If the
     * recovery attempt fails, this method
     * {@link InputMismatchException}.
     *
     * **EXTRA TOKEN** (single token deletion)
     *
     * `LA(1)` is not what we are looking for. If `LA(2)` has the
     * right token, however, then assume `LA(1)` is some extra spurious
     * token and delete it. Then consume and return the next token (which was
     * the `LA(2)` token) as the successful result of the match operation.
     *
     * This recovery strategy is implemented by {@link #singleTokenDeletion}.
     *
     * **MISSING TOKEN** (single token insertion)
     *
     * If current token (at `LA(1)`) is consistent with what could come
     * after the expected `LA(1)` token, then assume the token is missing
     * and use the parser's {@link TokenFactory} to create it on the fly. The
     * "insertion" is performed by returning the created token as the successful
     * result of the match operation.
     *
     * This recovery strategy is implemented by {@link #singleTokenInsertion}.
     *
     * **EXAMPLE**
     *
     * For example, Input `i=(3;` is clearly missing the `')'`. When
     * the parser returns from the nested call to `expr`, it will have
     * call chain:
     *
     * ```
     * stat → expr → atom
     * ```
     *
     * and it will be trying to match the `')'` at this point in the
     * derivation:
     *
     * ```
     * => ID '=' '(' INT ')' ('+' atom)* ';'
     *                    ^
     * ```
     *
     * The attempt to match `')'` will fail when it sees `';'` and
     * call {@link #recoverInline}. To recover, it sees that `LA(1)==';'`
     * is in the set of tokens that can follow the `')'` token reference
     * in rule `atom`. It can assume that you forgot the `')'`.
     */ recoverInline(recognizer) {
        // SINGLE TOKEN DELETION
        let matchedSymbol = this.singleTokenDeletion(recognizer);
        if (matchedSymbol) {
            // we have deleted the extra token.
            // now, move past ttype token as if all were ok
            recognizer.consume();
            return matchedSymbol;
        }
        // SINGLE TOKEN INSERTION
        if (this.singleTokenInsertion(recognizer)) return this.getMissingSymbol(recognizer);
        // even that didn't work; must throw the exception
        if (this.nextTokensContext === undefined) throw new $l9UFP.InputMismatchException(recognizer);
        else throw new $l9UFP.InputMismatchException(recognizer, this.nextTokensState, this.nextTokensContext);
    }
    /**
     * This method implements the single-token insertion inline error recovery
     * strategy. It is called by {@link #recoverInline} if the single-token
     * deletion strategy fails to recover from the mismatched input. If this
     * method returns `true`, `recognizer` will be in error recovery
     * mode.
     *
     * This method determines whether or not single-token insertion is viable by
     * checking if the `LA(1)` input symbol could be successfully matched
     * if it were instead the `LA(2)` symbol. If this method returns
     * `true`, the caller is responsible for creating and inserting a
     * token with the correct type to produce this behavior.
     *
     * @param recognizer the parser instance
     * @returns `true` if single-token insertion is a viable recovery
     * strategy for the current mismatched input, otherwise `false`
     */ singleTokenInsertion(recognizer) {
        let currentSymbolType = recognizer.inputStream.LA(1);
        // if current token is consistent with what could come after current
        // ATN state, then we know we're missing a token; error recovery
        // is free to conjure up and insert the missing token
        let currentState = recognizer.interpreter.atn.states[recognizer.state];
        let next = currentState.transition(0).target;
        let atn = recognizer.interpreter.atn;
        let expectingAtLL2 = atn.nextTokens(next, $2EGxJ.PredictionContext.fromRuleContext(atn, recognizer.context));
        //		console.warn("LT(2) set="+expectingAtLL2.toString(recognizer.getTokenNames()));
        if (expectingAtLL2.contains(currentSymbolType)) {
            this.reportMissingToken(recognizer);
            return true;
        }
        return false;
    }
    /**
     * This method implements the single-token deletion inline error recovery
     * strategy. It is called by {@link #recoverInline} to attempt to recover
     * from mismatched input. If this method returns `undefined`, the parser and error
     * handler state will not have changed. If this method returns non-`undefined`,
     * `recognizer` will *not* be in error recovery mode since the
     * returned token was a successful match.
     *
     * If the single-token deletion is successful, this method calls
     * {@link #reportUnwantedToken} to report the error, followed by
     * {@link Parser#consume} to actually "delete" the extraneous token. Then,
     * before returning {@link #reportMatch} is called to signal a successful
     * match.
     *
     * @param recognizer the parser instance
     * @returns the successfully matched {@link Token} instance if single-token
     * deletion successfully recovers from the mismatched input, otherwise
     * `undefined`
     */ singleTokenDeletion(recognizer) {
        let nextTokenType = recognizer.inputStream.LA(2);
        let expecting = this.getExpectedTokens(recognizer);
        if (expecting.contains(nextTokenType)) {
            this.reportUnwantedToken(recognizer);
            /*
            System.err.println("recoverFromMismatchedToken deleting "+
                               ((TokenStream)recognizer.inputStream).LT(1)+
                               " since "+((TokenStream)recognizer.inputStream).LT(2)+
                               " is what we want");
            */ recognizer.consume(); // simply delete extra token
            // we want to return the token we're actually matching
            let matchedSymbol = recognizer.currentToken;
            this.reportMatch(recognizer); // we know current token is correct
            return matchedSymbol;
        }
        return undefined;
    }
    /** Conjure up a missing token during error recovery.
     *
     *  The recognizer attempts to recover from single missing
     *  symbols. But, actions might refer to that missing symbol.
     *  For example, x=ID {f($x);}. The action clearly assumes
     *  that there has been an identifier matched previously and that
     *  $x points at that token. If that token is missing, but
     *  the next token in the stream is what we want we assume that
     *  this token is missing and we keep going. Because we
     *  have to return some token to replace the missing token,
     *  we have to conjure one up. This method gives the user control
     *  over the tokens returned for missing tokens. Mostly,
     *  you will want to create something special for identifier
     *  tokens. For literals such as '{' and ',', the default
     *  action in the parser or tree parser works. It simply creates
     *  a CommonToken of the appropriate type. The text will be the token.
     *  If you change what tokens must be created by the lexer,
     *  override this method to create the appropriate tokens.
     */ getMissingSymbol(recognizer) {
        let currentSymbol = recognizer.currentToken;
        let expecting = this.getExpectedTokens(recognizer);
        let expectedTokenType = $TNDGs.Token.INVALID_TYPE;
        if (!expecting.isNil) // get any element
        expectedTokenType = expecting.minElement;
        let tokenText;
        if (expectedTokenType === $TNDGs.Token.EOF) tokenText = "<missing EOF>";
        else tokenText = "<missing " + recognizer.vocabulary.getDisplayName(expectedTokenType) + ">";
        let current = currentSymbol;
        let lookback = recognizer.inputStream.tryLT(-1);
        if (current.type === $TNDGs.Token.EOF && lookback != null) current = lookback;
        return this.constructToken(recognizer.inputStream.tokenSource, expectedTokenType, tokenText, current);
    }
    constructToken(tokenSource, expectedTokenType, tokenText, current) {
        let factory = tokenSource.tokenFactory;
        let x = current.tokenSource;
        let stream = x ? x.inputStream : undefined;
        return factory.create({
            source: tokenSource,
            stream: stream
        }, expectedTokenType, tokenText, $TNDGs.Token.DEFAULT_CHANNEL, -1, -1, current.line, current.charPositionInLine);
    }
    getExpectedTokens(recognizer) {
        return recognizer.getExpectedTokens();
    }
    /** How should a token be displayed in an error message? The default
     *  is to display just the text, but during development you might
     *  want to have a lot of information spit out.  Override in that case
     *  to use t.toString() (which, for CommonToken, dumps everything about
     *  the token). This is better than forcing you to override a method in
     *  your token objects because you don't have to go modify your lexer
     *  so that it creates a new Java type.
     */ getTokenErrorDisplay(t) {
        if (!t) return "<no token>";
        let s = this.getSymbolText(t);
        if (!s) {
            if (this.getSymbolType(t) === $TNDGs.Token.EOF) s = "<EOF>";
            else s = `<${this.getSymbolType(t)}>`;
        }
        return this.escapeWSAndQuote(s);
    }
    getSymbolText(symbol) {
        return symbol.text;
    }
    getSymbolType(symbol) {
        return symbol.type;
    }
    escapeWSAndQuote(s) {
        //		if ( s==null ) return s;
        s = s.replace("\n", "\\n");
        s = s.replace("\r", "\\r");
        s = s.replace("\t", "\\t");
        return "'" + s + "'";
    }
    /*  Compute the error recovery set for the current rule.  During
     *  rule invocation, the parser pushes the set of tokens that can
     *  follow that rule reference on the stack; this amounts to
     *  computing FIRST of what follows the rule reference in the
     *  enclosing rule. See LinearApproximator.FIRST().
     *  This local follow set only includes tokens
     *  from within the rule; i.e., the FIRST computation done by
     *  ANTLR stops at the end of a rule.
     *
     *  EXAMPLE
     *
     *  When you find a "no viable alt exception", the input is not
     *  consistent with any of the alternatives for rule r.  The best
     *  thing to do is to consume tokens until you see something that
     *  can legally follow a call to r *or* any rule that called r.
     *  You don't want the exact set of viable next tokens because the
     *  input might just be missing a token--you might consume the
     *  rest of the input looking for one of the missing tokens.
     *
     *  Consider grammar:
     *
     *  a : '[' b ']'
     *    | '(' b ')'
     *    ;
     *  b : c '^' INT ;
     *  c : ID
     *    | INT
     *    ;
     *
     *  At each rule invocation, the set of tokens that could follow
     *  that rule is pushed on a stack.  Here are the various
     *  context-sensitive follow sets:
     *
     *  FOLLOW(b1_in_a) = FIRST(']') = ']'
     *  FOLLOW(b2_in_a) = FIRST(')') = ')'
     *  FOLLOW(c_in_b) = FIRST('^') = '^'
     *
     *  Upon erroneous input "[]", the call chain is
     *
     *  a -> b -> c
     *
     *  and, hence, the follow context stack is:
     *
     *  depth     follow set       start of rule execution
     *    0         <EOF>                    a (from main())
     *    1          ']'                     b
     *    2          '^'                     c
     *
     *  Notice that ')' is not included, because b would have to have
     *  been called from a different context in rule a for ')' to be
     *  included.
     *
     *  For error recovery, we cannot consider FOLLOW(c)
     *  (context-sensitive or otherwise).  We need the combined set of
     *  all context-sensitive FOLLOW sets--the set of all tokens that
     *  could follow any reference in the call chain.  We need to
     *  resync to one of those tokens.  Note that FOLLOW(c)='^' and if
     *  we resync'd to that token, we'd consume until EOF.  We need to
     *  sync to context-sensitive FOLLOWs for a, b, and c: {']','^'}.
     *  In this case, for input "[]", LA(1) is ']' and in the set, so we would
     *  not consume anything. After printing an error, rule c would
     *  return normally.  Rule b would not find the required '^' though.
     *  At this point, it gets a mismatched token error and
     *  exception (since LA(1) is not in the viable following token
     *  set).  The rule exception handler tries to recover, but finds
     *  the same recovery set and doesn't consume anything.  Rule b
     *  exits normally returning to rule a.  Now it finds the ']' (and
     *  with the successful match exits errorRecovery mode).
     *
     *  So, you can see that the parser walks up the call chain looking
     *  for the token that was a member of the recovery set.
     *
     *  Errors are not generated in errorRecovery mode.
     *
     *  ANTLR's error recovery mechanism is based upon original ideas:
     *
     *  "Algorithms + Data Structures = Programs" by Niklaus Wirth
     *
     *  and
     *
     *  "A note on error recovery in recursive descent parsers":
     *  http://portal.acm.org/citation.cfm?id=947902.947905
     *
     *  Later, Josef Grosch had some good ideas:
     *
     *  "Efficient and Comfortable Error Recovery in Recursive Descent
     *  Parsers":
     *  ftp://www.cocolab.com/products/cocktail/doca4.ps/ell.ps.zip
     *
     *  Like Grosch I implement context-sensitive FOLLOW sets that are combined
     *  at run-time upon error to avoid overhead during parsing.
     */ getErrorRecoverySet(recognizer) {
        let atn = recognizer.interpreter.atn;
        let ctx = recognizer.context;
        let recoverSet = new $69z5o.IntervalSet();
        while(ctx && ctx.invokingState >= 0){
            // compute what follows who invoked us
            let invokingState = atn.states[ctx.invokingState];
            let rt = invokingState.transition(0);
            let follow = atn.nextTokens(rt.followState);
            recoverSet.addAll(follow);
            ctx = ctx._parent;
        }
        recoverSet.remove($TNDGs.Token.EPSILON);
        //		System.out.println("recover set "+recoverSet.toString(recognizer.getTokenNames()));
        return recoverSet;
    }
    /** Consume tokens until one matches the given token set. */ consumeUntil(recognizer, set) {
        //		System.err.println("consumeUntil("+set.toString(recognizer.getTokenNames())+")");
        let ttype = recognizer.inputStream.LA(1);
        while(ttype !== $TNDGs.Token.EOF && !set.contains(ttype)){
            //System.out.println("consume during recover LA(1)="+getTokenNames()[input.LA(1)]);
            //			recognizer.inputStream.consume();
            recognizer.consume();
            ttype = recognizer.inputStream.LA(1);
        }
    }
    constructor(){
        /**
         * Indicates whether the error strategy is currently "recovering from an
         * error". This is used to suppress reporting multiple error messages while
         * attempting to recover from a detected syntax error.
         *
         * @see #inErrorRecoveryMode
         */ this.errorRecoveryMode = false;
        /** The index into the input stream where the last error occurred.
         * 	This is used to prevent infinite loops where an error is found
         *  but no token is consumed during recovery...another error is found,
         *  ad nauseum.  This is a failsafe mechanism to guarantee that at least
         *  one token/tree node is consumed for two errors.
         */ this.lastErrorIndex = -1;
        /**
         * @see #nextTokensContext
         */ this.nextTokensState = $2UrJv.ATNState.INVALID_STATE_NUMBER;
    }
}
$de0a2bdceaefa13d$var$__decorate([
    $ffTXa.Override
], $de0a2bdceaefa13d$var$DefaultErrorStrategy.prototype, "reset", null);
$de0a2bdceaefa13d$var$__decorate([
    $de0a2bdceaefa13d$var$__param(0, $ffTXa.NotNull)
], $de0a2bdceaefa13d$var$DefaultErrorStrategy.prototype, "beginErrorCondition", null);
$de0a2bdceaefa13d$var$__decorate([
    $ffTXa.Override
], $de0a2bdceaefa13d$var$DefaultErrorStrategy.prototype, "inErrorRecoveryMode", null);
$de0a2bdceaefa13d$var$__decorate([
    $de0a2bdceaefa13d$var$__param(0, $ffTXa.NotNull)
], $de0a2bdceaefa13d$var$DefaultErrorStrategy.prototype, "endErrorCondition", null);
$de0a2bdceaefa13d$var$__decorate([
    $ffTXa.Override
], $de0a2bdceaefa13d$var$DefaultErrorStrategy.prototype, "reportMatch", null);
$de0a2bdceaefa13d$var$__decorate([
    $ffTXa.Override
], $de0a2bdceaefa13d$var$DefaultErrorStrategy.prototype, "reportError", null);
$de0a2bdceaefa13d$var$__decorate([
    $de0a2bdceaefa13d$var$__param(0, $ffTXa.NotNull)
], $de0a2bdceaefa13d$var$DefaultErrorStrategy.prototype, "notifyErrorListeners", null);
$de0a2bdceaefa13d$var$__decorate([
    $ffTXa.Override
], $de0a2bdceaefa13d$var$DefaultErrorStrategy.prototype, "recover", null);
$de0a2bdceaefa13d$var$__decorate([
    $ffTXa.Override
], $de0a2bdceaefa13d$var$DefaultErrorStrategy.prototype, "sync", null);
$de0a2bdceaefa13d$var$__decorate([
    $de0a2bdceaefa13d$var$__param(0, $ffTXa.NotNull),
    $de0a2bdceaefa13d$var$__param(1, $ffTXa.NotNull)
], $de0a2bdceaefa13d$var$DefaultErrorStrategy.prototype, "reportNoViableAlternative", null);
$de0a2bdceaefa13d$var$__decorate([
    $de0a2bdceaefa13d$var$__param(0, $ffTXa.NotNull),
    $de0a2bdceaefa13d$var$__param(1, $ffTXa.NotNull)
], $de0a2bdceaefa13d$var$DefaultErrorStrategy.prototype, "reportInputMismatch", null);
$de0a2bdceaefa13d$var$__decorate([
    $de0a2bdceaefa13d$var$__param(0, $ffTXa.NotNull),
    $de0a2bdceaefa13d$var$__param(1, $ffTXa.NotNull)
], $de0a2bdceaefa13d$var$DefaultErrorStrategy.prototype, "reportFailedPredicate", null);
$de0a2bdceaefa13d$var$__decorate([
    $de0a2bdceaefa13d$var$__param(0, $ffTXa.NotNull)
], $de0a2bdceaefa13d$var$DefaultErrorStrategy.prototype, "reportUnwantedToken", null);
$de0a2bdceaefa13d$var$__decorate([
    $de0a2bdceaefa13d$var$__param(0, $ffTXa.NotNull)
], $de0a2bdceaefa13d$var$DefaultErrorStrategy.prototype, "reportMissingToken", null);
$de0a2bdceaefa13d$var$__decorate([
    $ffTXa.Override
], $de0a2bdceaefa13d$var$DefaultErrorStrategy.prototype, "recoverInline", null);
$de0a2bdceaefa13d$var$__decorate([
    $de0a2bdceaefa13d$var$__param(0, $ffTXa.NotNull)
], $de0a2bdceaefa13d$var$DefaultErrorStrategy.prototype, "singleTokenInsertion", null);
$de0a2bdceaefa13d$var$__decorate([
    $de0a2bdceaefa13d$var$__param(0, $ffTXa.NotNull)
], $de0a2bdceaefa13d$var$DefaultErrorStrategy.prototype, "singleTokenDeletion", null);
$de0a2bdceaefa13d$var$__decorate([
    $ffTXa.NotNull,
    $de0a2bdceaefa13d$var$__param(0, $ffTXa.NotNull)
], $de0a2bdceaefa13d$var$DefaultErrorStrategy.prototype, "getMissingSymbol", null);
$de0a2bdceaefa13d$var$__decorate([
    $ffTXa.NotNull,
    $de0a2bdceaefa13d$var$__param(0, $ffTXa.NotNull)
], $de0a2bdceaefa13d$var$DefaultErrorStrategy.prototype, "getExpectedTokens", null);
$de0a2bdceaefa13d$var$__decorate([
    $de0a2bdceaefa13d$var$__param(0, $ffTXa.NotNull)
], $de0a2bdceaefa13d$var$DefaultErrorStrategy.prototype, "getSymbolText", null);
$de0a2bdceaefa13d$var$__decorate([
    $de0a2bdceaefa13d$var$__param(0, $ffTXa.NotNull)
], $de0a2bdceaefa13d$var$DefaultErrorStrategy.prototype, "getSymbolType", null);
$de0a2bdceaefa13d$var$__decorate([
    $ffTXa.NotNull,
    $de0a2bdceaefa13d$var$__param(0, $ffTXa.NotNull)
], $de0a2bdceaefa13d$var$DefaultErrorStrategy.prototype, "escapeWSAndQuote", null);
$de0a2bdceaefa13d$var$__decorate([
    $ffTXa.NotNull,
    $de0a2bdceaefa13d$var$__param(0, $ffTXa.NotNull)
], $de0a2bdceaefa13d$var$DefaultErrorStrategy.prototype, "getErrorRecoverySet", null);
$de0a2bdceaefa13d$var$__decorate([
    $de0a2bdceaefa13d$var$__param(0, $ffTXa.NotNull),
    $de0a2bdceaefa13d$var$__param(1, $ffTXa.NotNull)
], $de0a2bdceaefa13d$var$DefaultErrorStrategy.prototype, "consumeUntil", null);
module.exports.DefaultErrorStrategy = $de0a2bdceaefa13d$var$DefaultErrorStrategy;

});

parcelRegister("2UrJv", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $21e652ee23c1b1ed$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNState = void 0;

var $ffTXa = parcelRequire("ffTXa");

const $21e652ee23c1b1ed$var$INITIAL_NUM_TRANSITIONS = 4;
/**
 * The following images show the relation of states and
 * {@link ATNState#transitions} for various grammar constructs.
 *
 * * Solid edges marked with an &#0949; indicate a required
 *   {@link EpsilonTransition}.
 *
 * * Dashed edges indicate locations where any transition derived from
 *   {@link Transition} might appear.
 *
 * * Dashed nodes are place holders for either a sequence of linked
 *   {@link BasicState} states or the inclusion of a block representing a nested
 *   construct in one of the forms below.
 *
 * * Nodes showing multiple outgoing alternatives with a `...` support
 *   any number of alternatives (one or more). Nodes without the `...` only
 *   support the exact number of alternatives shown in the diagram.
 *
 * <h2>Basic Blocks</h2>
 *
 * <h3>Rule</h3>
 *
 * <embed src="images/Rule.svg" type="image/svg+xml"/>
 *
 * <h3>Block of 1 or more alternatives</h3>
 *
 * <embed src="images/Block.svg" type="image/svg+xml"/>
 *
 * <h2>Greedy Loops</h2>
 *
 * <h3>Greedy Closure: `(...)*`</h3>
 *
 * <embed src="images/ClosureGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Greedy Positive Closure: `(...)+`</h3>
 *
 * <embed src="images/PositiveClosureGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Greedy Optional: `(...)?`</h3>
 *
 * <embed src="images/OptionalGreedy.svg" type="image/svg+xml"/>
 *
 * <h2>Non-Greedy Loops</h2>
 *
 * <h3>Non-Greedy Closure: `(...)*?`</h3>
 *
 * <embed src="images/ClosureNonGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Non-Greedy Positive Closure: `(...)+?`</h3>
 *
 * <embed src="images/PositiveClosureNonGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Non-Greedy Optional: `(...)??`</h3>
 *
 * <embed src="images/OptionalNonGreedy.svg" type="image/svg+xml"/>
 */ class $21e652ee23c1b1ed$var$ATNState {
    /**
     * Gets the state number.
     *
     * @returns the state number
     */ getStateNumber() {
        return this.stateNumber;
    }
    /**
     * For all states except {@link RuleStopState}, this returns the state
     * number. Returns -1 for stop states.
     *
     * @returns -1 for {@link RuleStopState}, otherwise the state number
     */ get nonStopStateNumber() {
        return this.getStateNumber();
    }
    hashCode() {
        return this.stateNumber;
    }
    equals(o) {
        // are these states same object?
        if (o instanceof $21e652ee23c1b1ed$var$ATNState) return this.stateNumber === o.stateNumber;
        return false;
    }
    get isNonGreedyExitState() {
        return false;
    }
    toString() {
        return String(this.stateNumber);
    }
    getTransitions() {
        return this.transitions.slice(0);
    }
    get numberOfTransitions() {
        return this.transitions.length;
    }
    addTransition(e, index) {
        if (this.transitions.length === 0) this.epsilonOnlyTransitions = e.isEpsilon;
        else if (this.epsilonOnlyTransitions !== e.isEpsilon) {
            this.epsilonOnlyTransitions = false;
            throw new Error("ATN state " + this.stateNumber + " has both epsilon and non-epsilon transitions.");
        }
        this.transitions.splice(index !== undefined ? index : this.transitions.length, 0, e);
    }
    transition(i) {
        return this.transitions[i];
    }
    setTransition(i, e) {
        this.transitions[i] = e;
    }
    removeTransition(index) {
        return this.transitions.splice(index, 1)[0];
    }
    get onlyHasEpsilonTransitions() {
        return this.epsilonOnlyTransitions;
    }
    setRuleIndex(ruleIndex) {
        this.ruleIndex = ruleIndex;
    }
    get isOptimized() {
        return this.optimizedTransitions !== this.transitions;
    }
    get numberOfOptimizedTransitions() {
        return this.optimizedTransitions.length;
    }
    getOptimizedTransition(i) {
        return this.optimizedTransitions[i];
    }
    addOptimizedTransition(e) {
        if (!this.isOptimized) this.optimizedTransitions = new Array();
        this.optimizedTransitions.push(e);
    }
    setOptimizedTransition(i, e) {
        if (!this.isOptimized) throw new Error("This ATNState is not optimized.");
        this.optimizedTransitions[i] = e;
    }
    removeOptimizedTransition(i) {
        if (!this.isOptimized) throw new Error("This ATNState is not optimized.");
        this.optimizedTransitions.splice(i, 1);
    }
    constructor(){
        this.stateNumber = $21e652ee23c1b1ed$var$ATNState.INVALID_STATE_NUMBER;
        this.ruleIndex = 0; // at runtime, we don't have Rule objects
        this.epsilonOnlyTransitions = false;
        /** Track the transitions emanating from this ATN state. */ this.transitions = [];
        this.optimizedTransitions = this.transitions;
    }
}
$21e652ee23c1b1ed$var$__decorate([
    $ffTXa.Override
], $21e652ee23c1b1ed$var$ATNState.prototype, "hashCode", null);
$21e652ee23c1b1ed$var$__decorate([
    $ffTXa.Override
], $21e652ee23c1b1ed$var$ATNState.prototype, "equals", null);
$21e652ee23c1b1ed$var$__decorate([
    $ffTXa.Override
], $21e652ee23c1b1ed$var$ATNState.prototype, "toString", null);
module.exports.ATNState = $21e652ee23c1b1ed$var$ATNState;
(function(ATNState) {
    ATNState.INVALID_STATE_NUMBER = -1;
})($21e652ee23c1b1ed$var$ATNState = module.exports.ATNState || (module.exports.ATNState = {}));

});

parcelRegister("5dqQL", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNStateType = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:27.4734328-07:00
var $3cc2fe7d1c9c0671$var$ATNStateType;
(function(ATNStateType) {
    ATNStateType[ATNStateType["INVALID_TYPE"] = 0] = "INVALID_TYPE";
    ATNStateType[ATNStateType["BASIC"] = 1] = "BASIC";
    ATNStateType[ATNStateType["RULE_START"] = 2] = "RULE_START";
    ATNStateType[ATNStateType["BLOCK_START"] = 3] = "BLOCK_START";
    ATNStateType[ATNStateType["PLUS_BLOCK_START"] = 4] = "PLUS_BLOCK_START";
    ATNStateType[ATNStateType["STAR_BLOCK_START"] = 5] = "STAR_BLOCK_START";
    ATNStateType[ATNStateType["TOKEN_START"] = 6] = "TOKEN_START";
    ATNStateType[ATNStateType["RULE_STOP"] = 7] = "RULE_STOP";
    ATNStateType[ATNStateType["BLOCK_END"] = 8] = "BLOCK_END";
    ATNStateType[ATNStateType["STAR_LOOP_BACK"] = 9] = "STAR_LOOP_BACK";
    ATNStateType[ATNStateType["STAR_LOOP_ENTRY"] = 10] = "STAR_LOOP_ENTRY";
    ATNStateType[ATNStateType["PLUS_LOOP_BACK"] = 11] = "PLUS_LOOP_BACK";
    ATNStateType[ATNStateType["LOOP_END"] = 12] = "LOOP_END";
})($3cc2fe7d1c9c0671$var$ATNStateType = module.exports.ATNStateType || (module.exports.ATNStateType = {}));

});

parcelRegister("5BYcl", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $415f1a8cd599dc02$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $415f1a8cd599dc02$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FailedPredicateException = void 0;

var $beMqO = parcelRequire("beMqO");


var $ffTXa = parcelRequire("ffTXa");


var $2BviF = parcelRequire("2BviF");

/** A semantic predicate failed during validation.  Validation of predicates
 *  occurs when normally parsing the alternative just like matching a token.
 *  Disambiguating predicate evaluation occurs when we test a predicate during
 *  prediction.
 */ let $415f1a8cd599dc02$var$FailedPredicateException = class FailedPredicateException extends $beMqO.RecognitionException {
    get ruleIndex() {
        return this._ruleIndex;
    }
    get predicateIndex() {
        return this._predicateIndex;
    }
    get predicate() {
        return this._predicate;
    }
    static formatMessage(predicate, message) {
        if (message) return message;
        return `failed predicate: {${predicate}}?`;
    }
    constructor(recognizer, predicate, message){
        super(recognizer, recognizer.inputStream, recognizer.context, FailedPredicateException.formatMessage(predicate, message));
        let s = recognizer.interpreter.atn.states[recognizer.state];
        let trans = s.transition(0);
        if (trans instanceof $2BviF.PredicateTransition) {
            this._ruleIndex = trans.ruleIndex;
            this._predicateIndex = trans.predIndex;
        } else {
            this._ruleIndex = 0;
            this._predicateIndex = 0;
        }
        this._predicate = predicate;
        super.setOffendingToken(recognizer, recognizer.currentToken);
    }
};
$415f1a8cd599dc02$var$__decorate([
    $ffTXa.NotNull
], $415f1a8cd599dc02$var$FailedPredicateException, "formatMessage", null);
$415f1a8cd599dc02$var$FailedPredicateException = $415f1a8cd599dc02$var$__decorate([
    $415f1a8cd599dc02$var$__param(0, $ffTXa.NotNull)
], $415f1a8cd599dc02$var$FailedPredicateException);
module.exports.FailedPredicateException = $415f1a8cd599dc02$var$FailedPredicateException;

});

parcelRegister("beMqO", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecognitionException = void 0;
/** The root of the ANTLR exception hierarchy. In general, ANTLR tracks just
 *  3 kinds of errors: prediction errors, failed predicate errors, and
 *  mismatched input errors. In each case, the parser knows where it is
 *  in the input, where it is in the ATN, the rule invocation stack,
 *  and what kind of problem occurred.
 */ class $82e691fec078e017$var$RecognitionException extends Error {
    /**
     * Get the ATN state number the parser was in at the time the error
     * occurred. For {@link NoViableAltException} and
     * {@link LexerNoViableAltException} exceptions, this is the
     * {@link DecisionState} number. For others, it is the state whose outgoing
     * edge we couldn't match.
     *
     * If the state number is not known, this method returns -1.
     */ get offendingState() {
        return this._offendingState;
    }
    setOffendingState(offendingState) {
        this._offendingState = offendingState;
    }
    /**
     * Gets the set of input symbols which could potentially follow the
     * previously matched symbol at the time this exception was thrown.
     *
     * If the set of expected tokens is not known and could not be computed,
     * this method returns `undefined`.
     *
     * @returns The set of token types that could potentially follow the current
     * state in the ATN, or `undefined` if the information is not available.
     */ get expectedTokens() {
        if (this._recognizer) return this._recognizer.atn.getExpectedTokens(this._offendingState, this.ctx);
        return undefined;
    }
    /**
     * Gets the {@link RuleContext} at the time this exception was thrown.
     *
     * If the context is not available, this method returns `undefined`.
     *
     * @returns The {@link RuleContext} at the time this exception was thrown.
     * If the context is not available, this method returns `undefined`.
     */ get context() {
        return this.ctx;
    }
    /**
     * Gets the input stream which is the symbol source for the recognizer where
     * this exception was thrown.
     *
     * If the input stream is not available, this method returns `undefined`.
     *
     * @returns The input stream which is the symbol source for the recognizer
     * where this exception was thrown, or `undefined` if the stream is not
     * available.
     */ get inputStream() {
        return this.input;
    }
    getOffendingToken(recognizer) {
        if (recognizer && recognizer !== this._recognizer) return undefined;
        return this.offendingToken;
    }
    setOffendingToken(recognizer, offendingToken) {
        if (recognizer === this._recognizer) this.offendingToken = offendingToken;
    }
    /**
     * Gets the {@link Recognizer} where this exception occurred.
     *
     * If the recognizer is not available, this method returns `undefined`.
     *
     * @returns The recognizer where this exception occurred, or `undefined` if
     * the recognizer is not available.
     */ get recognizer() {
        return this._recognizer;
    }
    constructor(recognizer, input, ctx, message){
        super(message);
        this._offendingState = -1;
        this._recognizer = recognizer;
        this.input = input;
        this.ctx = ctx;
        if (recognizer) this._offendingState = recognizer.state;
    }
}
module.exports.RecognitionException = $82e691fec078e017$var$RecognitionException;

});

parcelRegister("2BviF", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $1e5751098600c6a4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $1e5751098600c6a4$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredicateTransition = void 0;

var $b3uXT = parcelRequire("b3uXT");


var $ffTXa = parcelRequire("ffTXa");


var $3LYKb = parcelRequire("3LYKb");

/** TODO: this is old comment:
 *  A tree of semantic predicates from the grammar AST if label==SEMPRED.
 *  In the ATN, labels will always be exactly one predicate, but the DFA
 *  may have to combine a bunch of them as it collects predicates from
 *  multiple ATN configurations into a single DFA state.
 */ let $1e5751098600c6a4$var$PredicateTransition = class PredicateTransition extends $b3uXT.AbstractPredicateTransition {
    get serializationType() {
        return 4 /* PREDICATE */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    get predicate() {
        return new $3LYKb.SemanticContext.Predicate(this.ruleIndex, this.predIndex, this.isCtxDependent);
    }
    toString() {
        return "pred_" + this.ruleIndex + ":" + this.predIndex;
    }
    constructor(target, ruleIndex, predIndex, isCtxDependent){
        super(target);
        this.ruleIndex = ruleIndex;
        this.predIndex = predIndex;
        this.isCtxDependent = isCtxDependent;
    }
};
$1e5751098600c6a4$var$__decorate([
    $ffTXa.Override
], $1e5751098600c6a4$var$PredicateTransition.prototype, "serializationType", null);
$1e5751098600c6a4$var$__decorate([
    $ffTXa.Override
], $1e5751098600c6a4$var$PredicateTransition.prototype, "isEpsilon", null);
$1e5751098600c6a4$var$__decorate([
    $ffTXa.Override
], $1e5751098600c6a4$var$PredicateTransition.prototype, "matches", null);
$1e5751098600c6a4$var$__decorate([
    $ffTXa.Override,
    $ffTXa.NotNull
], $1e5751098600c6a4$var$PredicateTransition.prototype, "toString", null);
$1e5751098600c6a4$var$PredicateTransition = $1e5751098600c6a4$var$__decorate([
    $1e5751098600c6a4$var$__param(0, $ffTXa.NotNull)
], $1e5751098600c6a4$var$PredicateTransition);
module.exports.PredicateTransition = $1e5751098600c6a4$var$PredicateTransition;

});

parcelRegister("b3uXT", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AbstractPredicateTransition = void 0;

var $ikYx7 = parcelRequire("ikYx7");

/**
 *
 * @author Sam Harwell
 */ class $80c7fe8bbab992c5$var$AbstractPredicateTransition extends $ikYx7.Transition {
    constructor(target){
        super(target);
    }
}
module.exports.AbstractPredicateTransition = $80c7fe8bbab992c5$var$AbstractPredicateTransition;

});

parcelRegister("ikYx7", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d5990ce4f42b5f0d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d5990ce4f42b5f0d$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Transition = void 0;

var $ffTXa = parcelRequire("ffTXa");

/** An ATN transition between any two ATN states.  Subclasses define
 *  atom, set, epsilon, action, predicate, rule transitions.
 *
 *  This is a one way link.  It emanates from a state (usually via a list of
 *  transitions) and has a target state.
 *
 *  Since we never have to change the ATN transitions once we construct it,
 *  we can fix these transitions as specific classes. The DFA transitions
 *  on the other hand need to update the labels as it adds transitions to
 *  the states. We'll use the term Edge for the DFA to distinguish them from
 *  ATN transitions.
 */ let $d5990ce4f42b5f0d$var$Transition = class Transition {
    /**
     * Determines if the transition is an "epsilon" transition.
     *
     * The default implementation returns `false`.
     *
     * @returns `true` if traversing this transition in the ATN does not
     * consume an input symbol; otherwise, `false` if traversing this
     * transition consumes (matches) an input symbol.
     */ get isEpsilon() {
        return false;
    }
    get label() {
        return undefined;
    }
    constructor(target){
        if (target == null) throw new Error("target cannot be null.");
        this.target = target;
    }
};
$d5990ce4f42b5f0d$var$Transition.serializationNames = [
    "INVALID",
    "EPSILON",
    "RANGE",
    "RULE",
    "PREDICATE",
    "ATOM",
    "ACTION",
    "SET",
    "NOT_SET",
    "WILDCARD",
    "PRECEDENCE"
];
$d5990ce4f42b5f0d$var$__decorate([
    $ffTXa.NotNull
], $d5990ce4f42b5f0d$var$Transition.prototype, "target", void 0);
$d5990ce4f42b5f0d$var$Transition = $d5990ce4f42b5f0d$var$__decorate([
    $d5990ce4f42b5f0d$var$__param(0, $ffTXa.NotNull)
], $d5990ce4f42b5f0d$var$Transition);
module.exports.Transition = $d5990ce4f42b5f0d$var$Transition;

});

parcelRegister("3LYKb", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $2bf4e15f4ef19514$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $2bf4e15f4ef19514$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SemanticContext = void 0;

var $c90ex = parcelRequire("c90ex");


var $9mjSw = parcelRequire("9mjSw");


var $kPsXR = parcelRequire("kPsXR");


var $ffTXa = parcelRequire("ffTXa");


var $9PlGk = parcelRequire("9PlGk");


var $3jpAZ = parcelRequire("3jpAZ");

function $2bf4e15f4ef19514$var$max(items) {
    let result;
    for (let current of items){
        if (result === undefined) {
            result = current;
            continue;
        }
        let comparison = result.compareTo(current);
        if (comparison < 0) result = current;
    }
    return result;
}
function $2bf4e15f4ef19514$var$min(items) {
    let result;
    for (let current of items){
        if (result === undefined) {
            result = current;
            continue;
        }
        let comparison = result.compareTo(current);
        if (comparison > 0) result = current;
    }
    return result;
}
/** A tree structure used to record the semantic context in which
 *  an ATN configuration is valid.  It's either a single predicate,
 *  a conjunction `p1&&p2`, or a sum of products `p1||p2`.
 *
 *  I have scoped the {@link AND}, {@link OR}, and {@link Predicate} subclasses of
 *  {@link SemanticContext} within the scope of this outer class.
 */ class $2bf4e15f4ef19514$var$SemanticContext {
    /**
     * The default {@link SemanticContext}, which is semantically equivalent to
     * a predicate of the form `{true}?`.
     */ static get NONE() {
        if ($2bf4e15f4ef19514$var$SemanticContext._NONE === undefined) $2bf4e15f4ef19514$var$SemanticContext._NONE = new $2bf4e15f4ef19514$var$SemanticContext.Predicate();
        return $2bf4e15f4ef19514$var$SemanticContext._NONE;
    }
    /**
     * Evaluate the precedence predicates for the context and reduce the result.
     *
     * @param parser The parser instance.
     * @param parserCallStack
     * @returns The simplified semantic context after precedence predicates are
     * evaluated, which will be one of the following values.
     *
     * * {@link #NONE}: if the predicate simplifies to `true` after
     *   precedence predicates are evaluated.
     * * `undefined`: if the predicate simplifies to `false` after
     *   precedence predicates are evaluated.
     * * `this`: if the semantic context is not changed as a result of
     *   precedence predicate evaluation.
     * * A non-`undefined` {@link SemanticContext}: the new simplified
     *   semantic context after precedence predicates are evaluated.
     */ evalPrecedence(parser, parserCallStack) {
        return this;
    }
    static and(a, b) {
        if (!a || a === $2bf4e15f4ef19514$var$SemanticContext.NONE) return b;
        if (b === $2bf4e15f4ef19514$var$SemanticContext.NONE) return a;
        let result = new $2bf4e15f4ef19514$var$SemanticContext.AND(a, b);
        if (result.opnds.length === 1) return result.opnds[0];
        return result;
    }
    /**
     *
     *  @see ParserATNSimulator#getPredsForAmbigAlts
     */ static or(a, b) {
        if (!a) return b;
        if (a === $2bf4e15f4ef19514$var$SemanticContext.NONE || b === $2bf4e15f4ef19514$var$SemanticContext.NONE) return $2bf4e15f4ef19514$var$SemanticContext.NONE;
        let result = new $2bf4e15f4ef19514$var$SemanticContext.OR(a, b);
        if (result.opnds.length === 1) return result.opnds[0];
        return result;
    }
}
module.exports.SemanticContext = $2bf4e15f4ef19514$var$SemanticContext;
(function(SemanticContext) {
    /**
     * This random 30-bit prime represents the value of `AND.class.hashCode()`.
     */ const AND_HASHCODE = 40363613;
    /**
     * This random 30-bit prime represents the value of `OR.class.hashCode()`.
     */ const OR_HASHCODE = 486279973;
    function filterPrecedencePredicates(collection) {
        let result = [];
        for(let i = 0; i < collection.length; i++){
            let context = collection[i];
            if (context instanceof SemanticContext.PrecedencePredicate) {
                result.push(context);
                // Remove the item from 'collection' and move i back so we look at the same index again
                collection.splice(i, 1);
                i--;
            }
        }
        return result;
    }
    class Predicate extends SemanticContext {
        eval(parser, parserCallStack) {
            let localctx = this.isCtxDependent ? parserCallStack : undefined;
            return parser.sempred(localctx, this.ruleIndex, this.predIndex);
        }
        hashCode() {
            let hashCode = $kPsXR.MurmurHash.initialize();
            hashCode = $kPsXR.MurmurHash.update(hashCode, this.ruleIndex);
            hashCode = $kPsXR.MurmurHash.update(hashCode, this.predIndex);
            hashCode = $kPsXR.MurmurHash.update(hashCode, this.isCtxDependent ? 1 : 0);
            hashCode = $kPsXR.MurmurHash.finish(hashCode, 3);
            return hashCode;
        }
        equals(obj) {
            if (!(obj instanceof Predicate)) return false;
            if (this === obj) return true;
            return this.ruleIndex === obj.ruleIndex && this.predIndex === obj.predIndex && this.isCtxDependent === obj.isCtxDependent;
        }
        toString() {
            return "{" + this.ruleIndex + ":" + this.predIndex + "}?";
        }
        constructor(ruleIndex = -1, predIndex = -1, isCtxDependent = false){
            super();
            this.ruleIndex = ruleIndex;
            this.predIndex = predIndex;
            this.isCtxDependent = isCtxDependent;
        }
    }
    $2bf4e15f4ef19514$var$__decorate([
        $ffTXa.Override
    ], Predicate.prototype, "eval", null);
    $2bf4e15f4ef19514$var$__decorate([
        $ffTXa.Override
    ], Predicate.prototype, "hashCode", null);
    $2bf4e15f4ef19514$var$__decorate([
        $ffTXa.Override
    ], Predicate.prototype, "equals", null);
    $2bf4e15f4ef19514$var$__decorate([
        $ffTXa.Override
    ], Predicate.prototype, "toString", null);
    SemanticContext.Predicate = Predicate;
    class PrecedencePredicate extends SemanticContext {
        eval(parser, parserCallStack) {
            return parser.precpred(parserCallStack, this.precedence);
        }
        evalPrecedence(parser, parserCallStack) {
            if (parser.precpred(parserCallStack, this.precedence)) return SemanticContext.NONE;
            else return undefined;
        }
        compareTo(o) {
            return this.precedence - o.precedence;
        }
        hashCode() {
            let hashCode = 1;
            hashCode = 31 * hashCode + this.precedence;
            return hashCode;
        }
        equals(obj) {
            if (!(obj instanceof PrecedencePredicate)) return false;
            if (this === obj) return true;
            return this.precedence === obj.precedence;
        }
        toString() {
            return "{" + this.precedence + ">=prec}?";
        }
        constructor(precedence){
            super();
            this.precedence = precedence;
        }
    }
    $2bf4e15f4ef19514$var$__decorate([
        $ffTXa.Override
    ], PrecedencePredicate.prototype, "eval", null);
    $2bf4e15f4ef19514$var$__decorate([
        $ffTXa.Override
    ], PrecedencePredicate.prototype, "evalPrecedence", null);
    $2bf4e15f4ef19514$var$__decorate([
        $ffTXa.Override
    ], PrecedencePredicate.prototype, "compareTo", null);
    $2bf4e15f4ef19514$var$__decorate([
        $ffTXa.Override
    ], PrecedencePredicate.prototype, "hashCode", null);
    $2bf4e15f4ef19514$var$__decorate([
        $ffTXa.Override
    ], PrecedencePredicate.prototype, "equals", null);
    $2bf4e15f4ef19514$var$__decorate([
        $ffTXa.Override
    ], PrecedencePredicate.prototype, "toString", null);
    SemanticContext.PrecedencePredicate = PrecedencePredicate;
    /**
     * This is the base class for semantic context "operators", which operate on
     * a collection of semantic context "operands".
     *
     * @since 4.3
     */ class Operator extends SemanticContext {
    }
    SemanticContext.Operator = Operator;
    /**
     * A semantic context which is true whenever none of the contained contexts
     * is false.
     */ let AND = class AND extends Operator {
        get operands() {
            return this.opnds;
        }
        equals(obj) {
            if (this === obj) return true;
            if (!(obj instanceof AND)) return false;
            return $9mjSw.ArrayEqualityComparator.INSTANCE.equals(this.opnds, obj.opnds);
        }
        hashCode() {
            return $kPsXR.MurmurHash.hashCode(this.opnds, AND_HASHCODE);
        }
        /**
         * {@inheritDoc}
         *
         * The evaluation of predicates by this context is short-circuiting, but
         * unordered.
         */ eval(parser, parserCallStack) {
            for (let opnd of this.opnds){
                if (!opnd.eval(parser, parserCallStack)) return false;
            }
            return true;
        }
        evalPrecedence(parser, parserCallStack) {
            let differs = false;
            let operands = [];
            for (let context of this.opnds){
                let evaluated = context.evalPrecedence(parser, parserCallStack);
                differs = differs || evaluated !== context;
                if (evaluated == null) // The AND context is false if any element is false
                return undefined;
                else if (evaluated !== SemanticContext.NONE) // Reduce the result by skipping true elements
                operands.push(evaluated);
            }
            if (!differs) return this;
            if (operands.length === 0) // all elements were true, so the AND context is true
            return SemanticContext.NONE;
            let result = operands[0];
            for(let i = 1; i < operands.length; i++)result = SemanticContext.and(result, operands[i]);
            return result;
        }
        toString() {
            return $3jpAZ.join(this.opnds, "&&");
        }
        constructor(a, b){
            super();
            let operands = new $c90ex.Array2DHashSet($9PlGk.ObjectEqualityComparator.INSTANCE);
            if (a instanceof AND) operands.addAll(a.opnds);
            else operands.add(a);
            if (b instanceof AND) operands.addAll(b.opnds);
            else operands.add(b);
            this.opnds = operands.toArray();
            let precedencePredicates = filterPrecedencePredicates(this.opnds);
            // interested in the transition with the lowest precedence
            let reduced = $2bf4e15f4ef19514$var$min(precedencePredicates);
            if (reduced) this.opnds.push(reduced);
        }
    };
    $2bf4e15f4ef19514$var$__decorate([
        $ffTXa.Override
    ], AND.prototype, "operands", null);
    $2bf4e15f4ef19514$var$__decorate([
        $ffTXa.Override
    ], AND.prototype, "equals", null);
    $2bf4e15f4ef19514$var$__decorate([
        $ffTXa.Override
    ], AND.prototype, "hashCode", null);
    $2bf4e15f4ef19514$var$__decorate([
        $ffTXa.Override
    ], AND.prototype, "eval", null);
    $2bf4e15f4ef19514$var$__decorate([
        $ffTXa.Override
    ], AND.prototype, "evalPrecedence", null);
    $2bf4e15f4ef19514$var$__decorate([
        $ffTXa.Override
    ], AND.prototype, "toString", null);
    AND = $2bf4e15f4ef19514$var$__decorate([
        $2bf4e15f4ef19514$var$__param(0, $ffTXa.NotNull),
        $2bf4e15f4ef19514$var$__param(1, $ffTXa.NotNull)
    ], AND);
    SemanticContext.AND = AND;
    /**
     * A semantic context which is true whenever at least one of the contained
     * contexts is true.
     */ let OR = class OR extends Operator {
        get operands() {
            return this.opnds;
        }
        equals(obj) {
            if (this === obj) return true;
            if (!(obj instanceof OR)) return false;
            return $9mjSw.ArrayEqualityComparator.INSTANCE.equals(this.opnds, obj.opnds);
        }
        hashCode() {
            return $kPsXR.MurmurHash.hashCode(this.opnds, OR_HASHCODE);
        }
        /**
         * {@inheritDoc}
         *
         * The evaluation of predicates by this context is short-circuiting, but
         * unordered.
         */ eval(parser, parserCallStack) {
            for (let opnd of this.opnds){
                if (opnd.eval(parser, parserCallStack)) return true;
            }
            return false;
        }
        evalPrecedence(parser, parserCallStack) {
            let differs = false;
            let operands = [];
            for (let context of this.opnds){
                let evaluated = context.evalPrecedence(parser, parserCallStack);
                differs = differs || evaluated !== context;
                if (evaluated === SemanticContext.NONE) // The OR context is true if any element is true
                return SemanticContext.NONE;
                else if (evaluated) // Reduce the result by skipping false elements
                operands.push(evaluated);
            }
            if (!differs) return this;
            if (operands.length === 0) // all elements were false, so the OR context is false
            return undefined;
            let result = operands[0];
            for(let i = 1; i < operands.length; i++)result = SemanticContext.or(result, operands[i]);
            return result;
        }
        toString() {
            return $3jpAZ.join(this.opnds, "||");
        }
        constructor(a, b){
            super();
            let operands = new $c90ex.Array2DHashSet($9PlGk.ObjectEqualityComparator.INSTANCE);
            if (a instanceof OR) operands.addAll(a.opnds);
            else operands.add(a);
            if (b instanceof OR) operands.addAll(b.opnds);
            else operands.add(b);
            this.opnds = operands.toArray();
            let precedencePredicates = filterPrecedencePredicates(this.opnds);
            // interested in the transition with the highest precedence
            let reduced = $2bf4e15f4ef19514$var$max(precedencePredicates);
            if (reduced) this.opnds.push(reduced);
        }
    };
    $2bf4e15f4ef19514$var$__decorate([
        $ffTXa.Override
    ], OR.prototype, "operands", null);
    $2bf4e15f4ef19514$var$__decorate([
        $ffTXa.Override
    ], OR.prototype, "equals", null);
    $2bf4e15f4ef19514$var$__decorate([
        $ffTXa.Override
    ], OR.prototype, "hashCode", null);
    $2bf4e15f4ef19514$var$__decorate([
        $ffTXa.Override
    ], OR.prototype, "eval", null);
    $2bf4e15f4ef19514$var$__decorate([
        $ffTXa.Override
    ], OR.prototype, "evalPrecedence", null);
    $2bf4e15f4ef19514$var$__decorate([
        $ffTXa.Override
    ], OR.prototype, "toString", null);
    OR = $2bf4e15f4ef19514$var$__decorate([
        $2bf4e15f4ef19514$var$__param(0, $ffTXa.NotNull),
        $2bf4e15f4ef19514$var$__param(1, $ffTXa.NotNull)
    ], OR);
    SemanticContext.OR = OR;
})($2bf4e15f4ef19514$var$SemanticContext = module.exports.SemanticContext || (module.exports.SemanticContext = {}));

});

parcelRegister("3jpAZ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toCharArray = module.exports.toMap = module.exports.equals = module.exports.join = module.exports.escapeWhitespace = void 0;
function $269700382372151e$var$escapeWhitespace(s, escapeSpaces) {
    return escapeSpaces ? s.replace(/ /, "\u00B7") : s.replace(/\t/, "\\t").replace(/\n/, "\\n").replace(/\r/, "\\r");
}
module.exports.escapeWhitespace = $269700382372151e$var$escapeWhitespace;
// Seriously: why isn't this built in to java? ugh!
function $269700382372151e$var$join(collection, separator) {
    let buf = "";
    let first = true;
    for (let current of collection){
        if (first) first = false;
        else buf += separator;
        buf += current;
    }
    return buf;
}
module.exports.join = $269700382372151e$var$join;
function $269700382372151e$var$equals(x, y) {
    if (x === y) return true;
    if (x === undefined || y === undefined) return false;
    return x.equals(y);
}
module.exports.equals = $269700382372151e$var$equals;
// export function numNonnull(data: any[]): number {
// 	let n: number =  0;
// 	if ( data == null ) return n;
// 	for (let o of data) {
// 		if ( o!=null ) n++;
// 	}
// 	return n;
// }
// export function removeAllElements<T>(data: Collection<T>, value: T): void {
// 	if ( data==null ) return;
// 	while ( data.contains(value) ) data.remove(value);
// }
// export function writeFile(@NotNull file: File, @NotNull content: Uint8Array): void {
// 	let fos: FileOutputStream = new FileOutputStream(file);
// 	try {
// 		fos.write(content);
// 	} finally {
// 		fos.close();
// 	}
// }
// export function writeFile(@NotNull fileName: string, @NotNull content: string): void {
// 	writeFile(fileName, content, null);
// }
// export function writeFile(@NotNull fileName: string, @NotNull content: string, @Nullable encoding: string): void {
// 	let f: File =  new File(fileName);
// 	let fos: FileOutputStream =  new FileOutputStream(f);
// 	let osw: OutputStreamWriter;
// 	if (encoding != null) {
// 		osw = new OutputStreamWriter(fos, encoding);
// 	}
// 	else {
// 		osw = new OutputStreamWriter(fos);
// 	}
// 	try {
// 		osw.write(content);
// 	}
// 	finally {
// 		osw.close();
// 	}
// }
// @NotNull
// export function readFile(@NotNull fileName: string): char[] {
// 	return readFile(fileName, null);
// }
// @NotNull
// export function readFile(@NotNull fileName: string, @Nullable encoding: string): char[] {
// 	let f: File =  new File(fileName);
// 	let size: number =  (int)f.length();
// 	let isr: InputStreamReader;
// 	let fis: FileInputStream =  new FileInputStream(fileName);
// 	if ( encoding!=null ) {
// 		isr = new InputStreamReader(fis, encoding);
// 	}
// 	else {
// 		isr = new InputStreamReader(fis);
// 	}
// 	let data: char[] =  null;
// 	try {
// 		data = new char[size];
// 		let n: number =  isr.read(data);
// 		if (n < data.length) {
// 			data = Arrays.copyOf(data, n);
// 		}
// 	}
// 	finally {
// 		isr.close();
// 	}
// 	return data;
// }
// export function removeAll<T>(@NotNull predicate: List<T> list,@NotNull Predicate<? super T>): void {
// 	let j: number =  0;
// 	for (let i = 0; i < list.size; i++) {
// 		let item: T =  list.get(i);
// 		if (!predicate.eval(item)) {
// 			if (j != i) {
// 				list.set(j, item);
// 			}
// 			j++;
// 		}
// 	}
// 	if (j < list.size) {
// 		list.subList(j, list.size).clear();
// 	}
// }
// export function removeAll<T>(@NotNull predicate: Iterable<T> iterable,@NotNull Predicate<? super T>): void {
// 	if (iterable instanceof List<?>) {
// 		removeAll((List<T>)iterable, predicate);
// 		return;
// 	}
// 	for (Iterator<T> iterator = iterable.iterator(); iterator.hasNext(); ) {
// 		let item: T =  iterator.next();
// 		if (predicate.eval(item)) {
// 			iterator.remove();
// 		}
// 	}
// }
/** Convert array of strings to string&rarr;index map. Useful for
 *  converting rulenames to name&rarr;ruleindex map.
 */ function $269700382372151e$var$toMap(keys) {
    let m = new Map();
    for(let i = 0; i < keys.length; i++)m.set(keys[i], i);
    return m;
}
module.exports.toMap = $269700382372151e$var$toMap;
function $269700382372151e$var$toCharArray(str) {
    if (typeof str === "string") {
        let result = new Uint16Array(str.length);
        for(let i = 0; i < str.length; i++)result[i] = str.charCodeAt(i);
        return result;
    } else return str.toCharArray();
}
module.exports.toCharArray = $269700382372151e$var$toCharArray; // /**
 // 	* @since 4.5
 // 	*/
 // @NotNull
 // export function toSet(@NotNull bits: BitSet): IntervalSet {
 // 	let s: IntervalSet =  new IntervalSet();
 // 	let i: number =  bits.nextSetBit(0);
 // 	while ( i >= 0 ) {
 // 		s.add(i);
 // 		i = bits.nextSetBit(i+1);
 // 	}
 // 	return s;
 // }

});

parcelRegister("l9UFP", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f676667449b8f14d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f676667449b8f14d$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InputMismatchException = void 0;

var $beMqO = parcelRequire("beMqO");


var $ffTXa = parcelRequire("ffTXa");

/** This signifies any kind of mismatched input exceptions such as
 *  when the current input does not match the expected token.
 */ let $f676667449b8f14d$var$InputMismatchException = class InputMismatchException extends $beMqO.RecognitionException {
    constructor(recognizer, state, context){
        if (context === undefined) context = recognizer.context;
        super(recognizer, recognizer.inputStream, context);
        if (state !== undefined) this.setOffendingState(state);
        this.setOffendingToken(recognizer, recognizer.currentToken);
    }
};
$f676667449b8f14d$var$InputMismatchException = $f676667449b8f14d$var$__decorate([
    $f676667449b8f14d$var$__param(0, $ffTXa.NotNull)
], $f676667449b8f14d$var$InputMismatchException);
module.exports.InputMismatchException = $f676667449b8f14d$var$InputMismatchException;

});

parcelRegister("69z5o", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $47aeccab5f0dc38a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $47aeccab5f0dc38a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntervalSet = void 0;

var $9mjSw = parcelRequire("9mjSw");


var $77InG = parcelRequire("77InG");


var $dQ3yU = parcelRequire("dQ3yU");


var $gJMeE = parcelRequire("gJMeE");


var $kPsXR = parcelRequire("kPsXR");


var $ffTXa = parcelRequire("ffTXa");


var $TNDGs = parcelRequire("TNDGs");

/**
 * This class implements the {@link IntSet} backed by a sorted array of
 * non-overlapping intervals. It is particularly efficient for representing
 * large collections of numbers, where the majority of elements appear as part
 * of a sequential range of numbers that are all part of the set. For example,
 * the set { 1, 2, 3, 4, 7, 8 } may be represented as { [1, 4], [7, 8] }.
 *
 * This class is able to represent sets containing any combination of values in
 * the range {@link Integer#MIN_VALUE} to {@link Integer#MAX_VALUE}
 * (inclusive).
 */ class $47aeccab5f0dc38a$var$IntervalSet {
    static get COMPLETE_CHAR_SET() {
        if ($47aeccab5f0dc38a$var$IntervalSet._COMPLETE_CHAR_SET === undefined) {
            $47aeccab5f0dc38a$var$IntervalSet._COMPLETE_CHAR_SET = $47aeccab5f0dc38a$var$IntervalSet.of($gJMeE.Lexer.MIN_CHAR_VALUE, $gJMeE.Lexer.MAX_CHAR_VALUE);
            $47aeccab5f0dc38a$var$IntervalSet._COMPLETE_CHAR_SET.setReadonly(true);
        }
        return $47aeccab5f0dc38a$var$IntervalSet._COMPLETE_CHAR_SET;
    }
    static get EMPTY_SET() {
        if ($47aeccab5f0dc38a$var$IntervalSet._EMPTY_SET == null) {
            $47aeccab5f0dc38a$var$IntervalSet._EMPTY_SET = new $47aeccab5f0dc38a$var$IntervalSet();
            $47aeccab5f0dc38a$var$IntervalSet._EMPTY_SET.setReadonly(true);
        }
        return $47aeccab5f0dc38a$var$IntervalSet._EMPTY_SET;
    }
    /**
     * Create a set with all ints within range [a..b] (inclusive). If b is omitted, the set contains the single element
     * a.
     */ static of(a, b = a) {
        let s = new $47aeccab5f0dc38a$var$IntervalSet();
        s.add(a, b);
        return s;
    }
    clear() {
        if (this.readonly) throw new Error("can't alter readonly IntervalSet");
        this._intervals.length = 0;
    }
    /** Add interval; i.e., add all integers from a to b to set.
     *  If b&lt;a, do nothing.
     *  Keep list in sorted order (by left range value).
     *  If overlap, combine ranges.  For example,
     *  If this is {1..5, 10..20}, adding 6..7 yields
     *  {1..5, 6..7, 10..20}.  Adding 4..8 yields {1..8, 10..20}.
     */ add(a, b = a) {
        this.addRange($dQ3yU.Interval.of(a, b));
    }
    // copy on write so we can cache a..a intervals and sets of that
    addRange(addition) {
        if (this.readonly) throw new Error("can't alter readonly IntervalSet");
        //System.out.println("add "+addition+" to "+intervals.toString());
        if (addition.b < addition.a) return;
        // find position in list
        // Use iterators as we modify list in place
        for(let i = 0; i < this._intervals.length; i++){
            let r = this._intervals[i];
            if (addition.equals(r)) return;
            if (addition.adjacent(r) || !addition.disjoint(r)) {
                // next to each other, make a single larger interval
                let bigger = addition.union(r);
                this._intervals[i] = bigger;
                // make sure we didn't just create an interval that
                // should be merged with next interval in list
                while(i < this._intervals.length - 1){
                    i++;
                    let next = this._intervals[i];
                    if (!bigger.adjacent(next) && bigger.disjoint(next)) break;
                    // if we bump up against or overlap next, merge
                    // remove this one
                    this._intervals.splice(i, 1);
                    i--;
                    // move backwards to what we just set
                    this._intervals[i] = bigger.union(next);
                // set to 3 merged ones
                }
                // first call to next after previous duplicates the result
                return;
            }
            if (addition.startsBeforeDisjoint(r)) {
                // insert before r
                this._intervals.splice(i, 0, addition);
                return;
            }
        // if disjoint and after r, a future iteration will handle it
        }
        // ok, must be after last interval (and disjoint from last interval)
        // just add it
        this._intervals.push(addition);
    }
    /** combine all sets in the array returned the or'd value */ static or(sets) {
        let r = new $47aeccab5f0dc38a$var$IntervalSet();
        for (let s of sets)r.addAll(s);
        return r;
    }
    addAll(set) {
        if (set == null) return this;
        if (set instanceof $47aeccab5f0dc38a$var$IntervalSet) {
            let other = set;
            // walk set and add each interval
            let n = other._intervals.length;
            for(let i = 0; i < n; i++){
                let I = other._intervals[i];
                this.add(I.a, I.b);
            }
        } else for (let value of set.toArray())this.add(value);
        return this;
    }
    complementRange(minElement, maxElement) {
        return this.complement($47aeccab5f0dc38a$var$IntervalSet.of(minElement, maxElement));
    }
    /** {@inheritDoc} */ complement(vocabulary) {
        if (vocabulary.isNil) // nothing in common with null set
        return $47aeccab5f0dc38a$var$IntervalSet.EMPTY_SET;
        let vocabularyIS;
        if (vocabulary instanceof $47aeccab5f0dc38a$var$IntervalSet) vocabularyIS = vocabulary;
        else {
            vocabularyIS = new $47aeccab5f0dc38a$var$IntervalSet();
            vocabularyIS.addAll(vocabulary);
        }
        return vocabularyIS.subtract(this);
    }
    subtract(a) {
        if (a == null || a.isNil) return new $47aeccab5f0dc38a$var$IntervalSet(this._intervals);
        if (a instanceof $47aeccab5f0dc38a$var$IntervalSet) return $47aeccab5f0dc38a$var$IntervalSet.subtract(this, a);
        let other = new $47aeccab5f0dc38a$var$IntervalSet();
        other.addAll(a);
        return $47aeccab5f0dc38a$var$IntervalSet.subtract(this, other);
    }
    /**
     * Compute the set difference between two interval sets. The specific
     * operation is `left - right`.
     */ static subtract(left, right) {
        if (left.isNil) return new $47aeccab5f0dc38a$var$IntervalSet();
        let result = new $47aeccab5f0dc38a$var$IntervalSet(left._intervals);
        if (right.isNil) // right set has no elements; just return the copy of the current set
        return result;
        let resultI = 0;
        let rightI = 0;
        while(resultI < result._intervals.length && rightI < right._intervals.length){
            let resultInterval = result._intervals[resultI];
            let rightInterval = right._intervals[rightI];
            // operation: (resultInterval - rightInterval) and update indexes
            if (rightInterval.b < resultInterval.a) {
                rightI++;
                continue;
            }
            if (rightInterval.a > resultInterval.b) {
                resultI++;
                continue;
            }
            let beforeCurrent;
            let afterCurrent;
            if (rightInterval.a > resultInterval.a) beforeCurrent = new $dQ3yU.Interval(resultInterval.a, rightInterval.a - 1);
            if (rightInterval.b < resultInterval.b) afterCurrent = new $dQ3yU.Interval(rightInterval.b + 1, resultInterval.b);
            if (beforeCurrent) {
                if (afterCurrent) {
                    // split the current interval into two
                    result._intervals[resultI] = beforeCurrent;
                    result._intervals.splice(resultI + 1, 0, afterCurrent);
                    resultI++;
                    rightI++;
                    continue;
                } else {
                    // replace the current interval
                    result._intervals[resultI] = beforeCurrent;
                    resultI++;
                    continue;
                }
            } else if (afterCurrent) {
                // replace the current interval
                result._intervals[resultI] = afterCurrent;
                rightI++;
                continue;
            } else {
                // remove the current interval (thus no need to increment resultI)
                result._intervals.splice(resultI, 1);
                continue;
            }
        }
        // If rightI reached right.intervals.size, no more intervals to subtract from result.
        // If resultI reached result.intervals.size, we would be subtracting from an empty set.
        // Either way, we are done.
        return result;
    }
    or(a) {
        let o = new $47aeccab5f0dc38a$var$IntervalSet();
        o.addAll(this);
        o.addAll(a);
        return o;
    }
    /** {@inheritDoc} */ and(other) {
        if (other.isNil) // nothing in common with null set
        return new $47aeccab5f0dc38a$var$IntervalSet();
        let myIntervals = this._intervals;
        let theirIntervals = other._intervals;
        let intersection;
        let mySize = myIntervals.length;
        let theirSize = theirIntervals.length;
        let i = 0;
        let j = 0;
        // iterate down both interval lists looking for nondisjoint intervals
        while(i < mySize && j < theirSize){
            let mine = myIntervals[i];
            let theirs = theirIntervals[j];
            //System.out.println("mine="+mine+" and theirs="+theirs);
            if (mine.startsBeforeDisjoint(theirs)) // move this iterator looking for interval that might overlap
            i++;
            else if (theirs.startsBeforeDisjoint(mine)) // move other iterator looking for interval that might overlap
            j++;
            else if (mine.properlyContains(theirs)) {
                // overlap, add intersection, get next theirs
                if (!intersection) intersection = new $47aeccab5f0dc38a$var$IntervalSet();
                intersection.addRange(mine.intersection(theirs));
                j++;
            } else if (theirs.properlyContains(mine)) {
                // overlap, add intersection, get next mine
                if (!intersection) intersection = new $47aeccab5f0dc38a$var$IntervalSet();
                intersection.addRange(mine.intersection(theirs));
                i++;
            } else if (!mine.disjoint(theirs)) {
                // overlap, add intersection
                if (!intersection) intersection = new $47aeccab5f0dc38a$var$IntervalSet();
                intersection.addRange(mine.intersection(theirs));
                // Move the iterator of lower range [a..b], but not
                // the upper range as it may contain elements that will collide
                // with the next iterator. So, if mine=[0..115] and
                // theirs=[115..200], then intersection is 115 and move mine
                // but not theirs as theirs may collide with the next range
                // in thisIter.
                // move both iterators to next ranges
                if (mine.startsAfterNonDisjoint(theirs)) j++;
                else if (theirs.startsAfterNonDisjoint(mine)) i++;
            }
        }
        if (!intersection) return new $47aeccab5f0dc38a$var$IntervalSet();
        return intersection;
    }
    /** {@inheritDoc} */ contains(el) {
        let n = this._intervals.length;
        let l = 0;
        let r = n - 1;
        // Binary search for the element in the (sorted, disjoint) array of intervals.
        while(l <= r){
            let m = l + r >> 1;
            let I = this._intervals[m];
            let a = I.a;
            let b = I.b;
            if (b < el) l = m + 1;
            else if (a > el) r = m - 1;
            else // el >= a && el <= b
            return true;
        }
        return false;
    }
    /** {@inheritDoc} */ get isNil() {
        return this._intervals == null || this._intervals.length === 0;
    }
    /**
     * Returns the maximum value contained in the set if not isNil.
     *
     * @return the maximum value contained in the set.
     * @throws RangeError if set is empty
     */ get maxElement() {
        if (this.isNil) throw new RangeError("set is empty");
        let last = this._intervals[this._intervals.length - 1];
        return last.b;
    }
    /**
     * Returns the minimum value contained in the set if not isNil.
     *
     * @return the minimum value contained in the set.
     * @throws RangeError if set is empty
     */ get minElement() {
        if (this.isNil) throw new RangeError("set is empty");
        return this._intervals[0].a;
    }
    /** Return a list of Interval objects. */ get intervals() {
        return this._intervals;
    }
    hashCode() {
        let hash = $kPsXR.MurmurHash.initialize();
        for (let I of this._intervals){
            hash = $kPsXR.MurmurHash.update(hash, I.a);
            hash = $kPsXR.MurmurHash.update(hash, I.b);
        }
        hash = $kPsXR.MurmurHash.finish(hash, this._intervals.length * 2);
        return hash;
    }
    /** Are two IntervalSets equal?  Because all intervals are sorted
     *  and disjoint, equals is a simple linear walk over both lists
     *  to make sure they are the same.  Interval.equals() is used
     *  by the List.equals() method to check the ranges.
     */ equals(o) {
        if (o == null || !(o instanceof $47aeccab5f0dc38a$var$IntervalSet)) return false;
        return $9mjSw.ArrayEqualityComparator.INSTANCE.equals(this._intervals, o._intervals);
    }
    toString(elemAreChar = false) {
        let buf = "";
        if (this._intervals == null || this._intervals.length === 0) return "{}";
        if (this.size > 1) buf += "{";
        let first = true;
        for (let I of this._intervals){
            if (first) first = false;
            else buf += ", ";
            let a = I.a;
            let b = I.b;
            if (a === b) {
                if (a === $TNDGs.Token.EOF) buf += "<EOF>";
                else if (elemAreChar) buf += "'" + String.fromCodePoint(a) + "'";
                else buf += a;
            } else if (elemAreChar) buf += "'" + String.fromCodePoint(a) + "'..'" + String.fromCodePoint(b) + "'";
            else buf += a + ".." + b;
        }
        if (this.size > 1) buf += "}";
        return buf;
    }
    toStringVocabulary(vocabulary) {
        if (this._intervals == null || this._intervals.length === 0) return "{}";
        let buf = "";
        if (this.size > 1) buf += "{";
        let first = true;
        for (let I of this._intervals){
            if (first) first = false;
            else buf += ", ";
            let a = I.a;
            let b = I.b;
            if (a === b) buf += this.elementName(vocabulary, a);
            else for(let i = a; i <= b; i++){
                if (i > a) buf += ", ";
                buf += this.elementName(vocabulary, i);
            }
        }
        if (this.size > 1) buf += "}";
        return buf;
    }
    elementName(vocabulary, a) {
        if (a === $TNDGs.Token.EOF) return "<EOF>";
        else if (a === $TNDGs.Token.EPSILON) return "<EPSILON>";
        else return vocabulary.getDisplayName(a);
    }
    get size() {
        let n = 0;
        let numIntervals = this._intervals.length;
        if (numIntervals === 1) {
            let firstInterval = this._intervals[0];
            return firstInterval.b - firstInterval.a + 1;
        }
        for(let i = 0; i < numIntervals; i++){
            let I = this._intervals[i];
            n += I.b - I.a + 1;
        }
        return n;
    }
    toIntegerList() {
        let values = new $77InG.IntegerList(this.size);
        let n = this._intervals.length;
        for(let i = 0; i < n; i++){
            let I = this._intervals[i];
            let a = I.a;
            let b = I.b;
            for(let v = a; v <= b; v++)values.add(v);
        }
        return values;
    }
    toSet() {
        let s = new Set();
        for (let I of this._intervals){
            let a = I.a;
            let b = I.b;
            for(let v = a; v <= b; v++)s.add(v);
        }
        return s;
    }
    toArray() {
        let values = new Array();
        let n = this._intervals.length;
        for(let i = 0; i < n; i++){
            let I = this._intervals[i];
            let a = I.a;
            let b = I.b;
            for(let v = a; v <= b; v++)values.push(v);
        }
        return values;
    }
    remove(el) {
        if (this.readonly) throw new Error("can't alter readonly IntervalSet");
        let n = this._intervals.length;
        for(let i = 0; i < n; i++){
            let I = this._intervals[i];
            let a = I.a;
            let b = I.b;
            if (el < a) break; // list is sorted and el is before this interval; not here
            // if whole interval x..x, rm
            if (el === a && el === b) {
                this._intervals.splice(i, 1);
                break;
            }
            // if on left edge x..b, adjust left
            if (el === a) {
                this._intervals[i] = $dQ3yU.Interval.of(I.a + 1, I.b);
                break;
            }
            // if on right edge a..x, adjust right
            if (el === b) {
                this._intervals[i] = $dQ3yU.Interval.of(I.a, I.b - 1);
                break;
            }
            // if in middle a..x..b, split interval
            if (el > a && el < b) {
                let oldb = I.b;
                this._intervals[i] = $dQ3yU.Interval.of(I.a, el - 1); // [a..x-1]
                this.add(el + 1, oldb); // add [x+1..b]
            }
        }
    }
    get isReadonly() {
        return this.readonly;
    }
    setReadonly(readonly) {
        if (this.readonly && !readonly) throw new Error("can't alter readonly IntervalSet");
        this.readonly = readonly;
    }
    constructor(intervals){
        this.readonly = false;
        if (intervals != null) this._intervals = intervals.slice(0);
        else this._intervals = [];
    }
}
$47aeccab5f0dc38a$var$__decorate([
    $ffTXa.Override
], $47aeccab5f0dc38a$var$IntervalSet.prototype, "addAll", null);
$47aeccab5f0dc38a$var$__decorate([
    $ffTXa.Override
], $47aeccab5f0dc38a$var$IntervalSet.prototype, "complement", null);
$47aeccab5f0dc38a$var$__decorate([
    $ffTXa.Override
], $47aeccab5f0dc38a$var$IntervalSet.prototype, "subtract", null);
$47aeccab5f0dc38a$var$__decorate([
    $ffTXa.Override
], $47aeccab5f0dc38a$var$IntervalSet.prototype, "or", null);
$47aeccab5f0dc38a$var$__decorate([
    $ffTXa.Override
], $47aeccab5f0dc38a$var$IntervalSet.prototype, "and", null);
$47aeccab5f0dc38a$var$__decorate([
    $ffTXa.Override
], $47aeccab5f0dc38a$var$IntervalSet.prototype, "contains", null);
$47aeccab5f0dc38a$var$__decorate([
    $ffTXa.Override
], $47aeccab5f0dc38a$var$IntervalSet.prototype, "isNil", null);
$47aeccab5f0dc38a$var$__decorate([
    $ffTXa.Override
], $47aeccab5f0dc38a$var$IntervalSet.prototype, "hashCode", null);
$47aeccab5f0dc38a$var$__decorate([
    $ffTXa.Override
], $47aeccab5f0dc38a$var$IntervalSet.prototype, "equals", null);
$47aeccab5f0dc38a$var$__decorate([
    $47aeccab5f0dc38a$var$__param(0, $ffTXa.NotNull)
], $47aeccab5f0dc38a$var$IntervalSet.prototype, "toStringVocabulary", null);
$47aeccab5f0dc38a$var$__decorate([
    $ffTXa.NotNull,
    $47aeccab5f0dc38a$var$__param(0, $ffTXa.NotNull)
], $47aeccab5f0dc38a$var$IntervalSet.prototype, "elementName", null);
$47aeccab5f0dc38a$var$__decorate([
    $ffTXa.Override
], $47aeccab5f0dc38a$var$IntervalSet.prototype, "size", null);
$47aeccab5f0dc38a$var$__decorate([
    $ffTXa.Override
], $47aeccab5f0dc38a$var$IntervalSet.prototype, "remove", null);
$47aeccab5f0dc38a$var$__decorate([
    $ffTXa.NotNull
], $47aeccab5f0dc38a$var$IntervalSet, "of", null);
$47aeccab5f0dc38a$var$__decorate([
    $ffTXa.NotNull
], $47aeccab5f0dc38a$var$IntervalSet, "subtract", null);
module.exports.IntervalSet = $47aeccab5f0dc38a$var$IntervalSet;

});

parcelRegister("dQ3yU", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a132e5098d2e5774$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Interval = void 0;

var $ffTXa = parcelRequire("ffTXa");

const $a132e5098d2e5774$var$INTERVAL_POOL_MAX_VALUE = 1000;
/** An immutable inclusive interval a..b */ class $a132e5098d2e5774$var$Interval {
    static get INVALID() {
        return $a132e5098d2e5774$var$Interval._INVALID;
    }
    /** Interval objects are used readonly so share all with the
     *  same single value a==b up to some max size.  Use an array as a perfect hash.
     *  Return shared object for 0..INTERVAL_POOL_MAX_VALUE or a new
     *  Interval object with a..a in it.  On Java.g4, 218623 IntervalSets
     *  have a..a (set with 1 element).
     */ static of(a, b) {
        // cache just a..a
        if (a !== b || a < 0 || a > $a132e5098d2e5774$var$INTERVAL_POOL_MAX_VALUE) return new $a132e5098d2e5774$var$Interval(a, b);
        if ($a132e5098d2e5774$var$Interval.cache[a] == null) $a132e5098d2e5774$var$Interval.cache[a] = new $a132e5098d2e5774$var$Interval(a, a);
        return $a132e5098d2e5774$var$Interval.cache[a];
    }
    /** return number of elements between a and b inclusively. x..x is length 1.
     *  if b &lt; a, then length is 0.  9..10 has length 2.
     */ get length() {
        if (this.b < this.a) return 0;
        return this.b - this.a + 1;
    }
    equals(o) {
        if (o === this) return true;
        else if (!(o instanceof $a132e5098d2e5774$var$Interval)) return false;
        return this.a === o.a && this.b === o.b;
    }
    hashCode() {
        let hash = 23;
        hash = hash * 31 + this.a;
        hash = hash * 31 + this.b;
        return hash;
    }
    /** Does this start completely before other? Disjoint */ startsBeforeDisjoint(other) {
        return this.a < other.a && this.b < other.a;
    }
    /** Does this start at or before other? Nondisjoint */ startsBeforeNonDisjoint(other) {
        return this.a <= other.a && this.b >= other.a;
    }
    /** Does this.a start after other.b? May or may not be disjoint */ startsAfter(other) {
        return this.a > other.a;
    }
    /** Does this start completely after other? Disjoint */ startsAfterDisjoint(other) {
        return this.a > other.b;
    }
    /** Does this start after other? NonDisjoint */ startsAfterNonDisjoint(other) {
        return this.a > other.a && this.a <= other.b; // this.b>=other.b implied
    }
    /** Are both ranges disjoint? I.e., no overlap? */ disjoint(other) {
        return this.startsBeforeDisjoint(other) || this.startsAfterDisjoint(other);
    }
    /** Are two intervals adjacent such as 0..41 and 42..42? */ adjacent(other) {
        return this.a === other.b + 1 || this.b === other.a - 1;
    }
    properlyContains(other) {
        return other.a >= this.a && other.b <= this.b;
    }
    /** Return the interval computed from combining this and other */ union(other) {
        return $a132e5098d2e5774$var$Interval.of(Math.min(this.a, other.a), Math.max(this.b, other.b));
    }
    /** Return the interval in common between this and o */ intersection(other) {
        return $a132e5098d2e5774$var$Interval.of(Math.max(this.a, other.a), Math.min(this.b, other.b));
    }
    /** Return the interval with elements from `this` not in `other`;
     *  `other` must not be totally enclosed (properly contained)
     *  within `this`, which would result in two disjoint intervals
     *  instead of the single one returned by this method.
     */ differenceNotProperlyContained(other) {
        let diff;
        if (other.startsBeforeNonDisjoint(this)) // other.a to left of this.a (or same)
        diff = $a132e5098d2e5774$var$Interval.of(Math.max(this.a, other.b + 1), this.b);
        else if (other.startsAfterNonDisjoint(this)) // other.a to right of this.a
        diff = $a132e5098d2e5774$var$Interval.of(this.a, other.a - 1);
        return diff;
    }
    toString() {
        return this.a + ".." + this.b;
    }
    /**
     * @param a The start of the interval
     * @param b The end of the interval (inclusive)
     */ constructor(a, b){
        this.a = a;
        this.b = b;
    }
}
$a132e5098d2e5774$var$Interval._INVALID = new $a132e5098d2e5774$var$Interval(-1, -2);
$a132e5098d2e5774$var$Interval.cache = new Array($a132e5098d2e5774$var$INTERVAL_POOL_MAX_VALUE + 1);
$a132e5098d2e5774$var$__decorate([
    $ffTXa.Override
], $a132e5098d2e5774$var$Interval.prototype, "equals", null);
$a132e5098d2e5774$var$__decorate([
    $ffTXa.Override
], $a132e5098d2e5774$var$Interval.prototype, "hashCode", null);
$a132e5098d2e5774$var$__decorate([
    $ffTXa.Override
], $a132e5098d2e5774$var$Interval.prototype, "toString", null);
module.exports.Interval = $a132e5098d2e5774$var$Interval;

});

parcelRegister("gJMeE", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c2f643da1ce4328b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Lexer = void 0;

var $aK9bI = parcelRequire("aK9bI");


var $be2mo = parcelRequire("be2mo");


var $dQ3yU = parcelRequire("dQ3yU");


var $9P2T1 = parcelRequire("9P2T1");


var $8Dduc = parcelRequire("8Dduc");


var $hh2Av = parcelRequire("hh2Av");


var $ffTXa = parcelRequire("ffTXa");


var $bwXFO = parcelRequire("bwXFO");


var $TNDGs = parcelRequire("TNDGs");

/** A lexer is recognizer that draws input symbols from a character stream.
 *  lexer grammars result in a subclass of this object. A Lexer object
 *  uses simplified match() and error recovery mechanisms in the interest
 *  of speed.
 */ class $c2f643da1ce4328b$var$Lexer extends $bwXFO.Recognizer {
    static get DEFAULT_TOKEN_CHANNEL() {
        return $TNDGs.Token.DEFAULT_CHANNEL;
    }
    static get HIDDEN() {
        return $TNDGs.Token.HIDDEN_CHANNEL;
    }
    reset(resetInput) {
        // wack Lexer state variables
        if (resetInput === undefined || resetInput) this._input.seek(0); // rewind the input
        this._token = undefined;
        this._type = $TNDGs.Token.INVALID_TYPE;
        this._channel = $TNDGs.Token.DEFAULT_CHANNEL;
        this._tokenStartCharIndex = -1;
        this._tokenStartCharPositionInLine = -1;
        this._tokenStartLine = -1;
        this._text = undefined;
        this._hitEOF = false;
        this._mode = $c2f643da1ce4328b$var$Lexer.DEFAULT_MODE;
        this._modeStack.clear();
        this.interpreter.reset();
    }
    /** Return a token from this source; i.e., match a token on the char
     *  stream.
     */ nextToken() {
        if (this._input == null) throw new Error("nextToken requires a non-null input stream.");
        // Mark start location in char stream so unbuffered streams are
        // guaranteed at least have text of current token
        let tokenStartMarker = this._input.mark();
        try {
            outer: while(true){
                if (this._hitEOF) return this.emitEOF();
                this._token = undefined;
                this._channel = $TNDGs.Token.DEFAULT_CHANNEL;
                this._tokenStartCharIndex = this._input.index;
                this._tokenStartCharPositionInLine = this.interpreter.charPositionInLine;
                this._tokenStartLine = this.interpreter.line;
                this._text = undefined;
                do {
                    this._type = $TNDGs.Token.INVALID_TYPE;
                    //				System.out.println("nextToken line "+tokenStartLine+" at "+((char)input.LA(1))+
                    //								   " in mode "+mode+
                    //								   " at index "+input.index);
                    let ttype;
                    try {
                        ttype = this.interpreter.match(this._input, this._mode);
                    } catch (e) {
                        if (e instanceof $hh2Av.LexerNoViableAltException) {
                            this.notifyListeners(e); // report error
                            this.recover(e);
                            ttype = $c2f643da1ce4328b$var$Lexer.SKIP;
                        } else throw e;
                    }
                    if (this._input.LA(1) === $9P2T1.IntStream.EOF) this._hitEOF = true;
                    if (this._type === $TNDGs.Token.INVALID_TYPE) this._type = ttype;
                    if (this._type === $c2f643da1ce4328b$var$Lexer.SKIP) continue outer;
                }while (this._type === $c2f643da1ce4328b$var$Lexer.MORE);
                if (this._token == null) return this.emit();
                return this._token;
            }
        } finally{
            // make sure we release marker after match or
            // unbuffered char stream will keep buffering
            this._input.release(tokenStartMarker);
        }
    }
    /** Instruct the lexer to skip creating a token for current lexer rule
     *  and look for another token.  nextToken() knows to keep looking when
     *  a lexer rule finishes with token set to SKIP_TOKEN.  Recall that
     *  if token==undefined at end of any token rule, it creates one for you
     *  and emits it.
     */ skip() {
        this._type = $c2f643da1ce4328b$var$Lexer.SKIP;
    }
    more() {
        this._type = $c2f643da1ce4328b$var$Lexer.MORE;
    }
    mode(m) {
        this._mode = m;
    }
    pushMode(m) {
        if ($8Dduc.LexerATNSimulator.debug) console.log("pushMode " + m);
        this._modeStack.push(this._mode);
        this.mode(m);
    }
    popMode() {
        if (this._modeStack.isEmpty) throw new Error("EmptyStackException");
        if ($8Dduc.LexerATNSimulator.debug) console.log("popMode back to " + this._modeStack.peek());
        this.mode(this._modeStack.pop());
        return this._mode;
    }
    get tokenFactory() {
        return this._factory;
    }
    // @Override
    set tokenFactory(factory) {
        this._factory = factory;
    }
    get inputStream() {
        return this._input;
    }
    /** Set the char stream and reset the lexer */ set inputStream(input) {
        this.reset(false);
        this._input = input;
        this._tokenFactorySourcePair = {
            source: this,
            stream: this._input
        };
    }
    get sourceName() {
        return this._input.sourceName;
    }
    emit(token) {
        if (!token) token = this._factory.create(this._tokenFactorySourcePair, this._type, this._text, this._channel, this._tokenStartCharIndex, this.charIndex - 1, this._tokenStartLine, this._tokenStartCharPositionInLine);
        this._token = token;
        return token;
    }
    emitEOF() {
        let cpos = this.charPositionInLine;
        let line = this.line;
        let eof = this._factory.create(this._tokenFactorySourcePair, $TNDGs.Token.EOF, undefined, $TNDGs.Token.DEFAULT_CHANNEL, this._input.index, this._input.index - 1, line, cpos);
        this.emit(eof);
        return eof;
    }
    get line() {
        return this.interpreter.line;
    }
    set line(line) {
        this.interpreter.line = line;
    }
    get charPositionInLine() {
        return this.interpreter.charPositionInLine;
    }
    set charPositionInLine(charPositionInLine) {
        this.interpreter.charPositionInLine = charPositionInLine;
    }
    /** What is the index of the current character of lookahead? */ get charIndex() {
        return this._input.index;
    }
    /** Return the text matched so far for the current token or any
     *  text override.
     */ get text() {
        if (this._text != null) return this._text;
        return this.interpreter.getText(this._input);
    }
    /** Set the complete text of this token; it wipes any previous
     *  changes to the text.
     */ set text(text) {
        this._text = text;
    }
    /** Override if emitting multiple tokens. */ get token() {
        return this._token;
    }
    set token(_token) {
        this._token = _token;
    }
    set type(ttype) {
        this._type = ttype;
    }
    get type() {
        return this._type;
    }
    set channel(channel) {
        this._channel = channel;
    }
    get channel() {
        return this._channel;
    }
    /** Return a list of all Token objects in input char stream.
     *  Forces load of all tokens. Does not include EOF token.
     */ getAllTokens() {
        let tokens = [];
        let t = this.nextToken();
        while(t.type !== $TNDGs.Token.EOF){
            tokens.push(t);
            t = this.nextToken();
        }
        return tokens;
    }
    notifyListeners(e) {
        let text = this._input.getText($dQ3yU.Interval.of(this._tokenStartCharIndex, this._input.index));
        let msg = "token recognition error at: '" + this.getErrorDisplay(text) + "'";
        let listener = this.getErrorListenerDispatch();
        if (listener.syntaxError) listener.syntaxError(this, undefined, this._tokenStartLine, this._tokenStartCharPositionInLine, msg, e);
    }
    getErrorDisplay(s) {
        if (typeof s === "number") {
            switch(s){
                case $TNDGs.Token.EOF:
                    return "<EOF>";
                case 0x0a:
                    return "\\n";
                case 0x09:
                    return "\\t";
                case 0x0d:
                    return "\\r";
            }
            return String.fromCharCode(s);
        }
        return s.replace(/\n/g, "\\n").replace(/\t/g, "\\t").replace(/\r/g, "\\r");
    }
    getCharErrorDisplay(c) {
        let s = this.getErrorDisplay(c);
        return "'" + s + "'";
    }
    recover(re) {
        if (re instanceof $hh2Av.LexerNoViableAltException) {
            if (this._input.LA(1) !== $9P2T1.IntStream.EOF) // skip a char and try again
            this.interpreter.consume(this._input);
        } else //System.out.println("consuming char "+(char)input.LA(1)+" during recovery");
        //re.printStackTrace();
        // TODO: Do we lose character or line position information?
        this._input.consume();
    }
    constructor(input){
        super();
        /** How to create token objects */ this._factory = $aK9bI.CommonTokenFactory.DEFAULT;
        /** What character index in the stream did the current token start at?
         *  Needed, for example, to get the text for current token.  Set at
         *  the start of nextToken.
         */ this._tokenStartCharIndex = -1;
        /** The line on which the first character of the token resides */ this._tokenStartLine = 0;
        /** The character position of first character within the line */ this._tokenStartCharPositionInLine = 0;
        /** Once we see EOF on char stream, next token will be EOF.
         *  If you have DONE : EOF ; then you see DONE EOF.
         */ this._hitEOF = false;
        /** The channel number for the current token */ this._channel = 0;
        /** The token type for the current token */ this._type = 0;
        this._modeStack = new $be2mo.IntegerStack();
        this._mode = $c2f643da1ce4328b$var$Lexer.DEFAULT_MODE;
        this._input = input;
        this._tokenFactorySourcePair = {
            source: this,
            stream: input
        };
    }
}
$c2f643da1ce4328b$var$Lexer.DEFAULT_MODE = 0;
$c2f643da1ce4328b$var$Lexer.MORE = -2;
$c2f643da1ce4328b$var$Lexer.SKIP = -3;
$c2f643da1ce4328b$var$Lexer.MIN_CHAR_VALUE = 0x0000;
$c2f643da1ce4328b$var$Lexer.MAX_CHAR_VALUE = 0x10FFFF;
$c2f643da1ce4328b$var$__decorate([
    $ffTXa.Override
], $c2f643da1ce4328b$var$Lexer.prototype, "nextToken", null);
$c2f643da1ce4328b$var$__decorate([
    $ffTXa.Override
], $c2f643da1ce4328b$var$Lexer.prototype, "tokenFactory", null);
$c2f643da1ce4328b$var$__decorate([
    $ffTXa.Override
], $c2f643da1ce4328b$var$Lexer.prototype, "inputStream", null);
$c2f643da1ce4328b$var$__decorate([
    $ffTXa.Override
], $c2f643da1ce4328b$var$Lexer.prototype, "sourceName", null);
$c2f643da1ce4328b$var$__decorate([
    $ffTXa.Override
], $c2f643da1ce4328b$var$Lexer.prototype, "line", null);
$c2f643da1ce4328b$var$__decorate([
    $ffTXa.Override
], $c2f643da1ce4328b$var$Lexer.prototype, "charPositionInLine", null);
module.exports.Lexer = $c2f643da1ce4328b$var$Lexer;

});

parcelRegister("aK9bI", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7d2553cef85c6b91$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommonTokenFactory = void 0;

var $eAd9i = parcelRequire("eAd9i");


var $dQ3yU = parcelRequire("dQ3yU");


var $ffTXa = parcelRequire("ffTXa");

/**
 * This default implementation of {@link TokenFactory} creates
 * {@link CommonToken} objects.
 */ class $7d2553cef85c6b91$var$CommonTokenFactory {
    create(source, type, text, channel, start, stop, line, charPositionInLine) {
        let t = new $eAd9i.CommonToken(type, text, source, channel, start, stop);
        t.line = line;
        t.charPositionInLine = charPositionInLine;
        if (text == null && this.copyText && source.stream != null) t.text = source.stream.getText($dQ3yU.Interval.of(start, stop));
        return t;
    }
    createSimple(type, text) {
        return new $eAd9i.CommonToken(type, text);
    }
    /**
     * Constructs a {@link CommonTokenFactory} with the specified value for
     * {@link #copyText}.
     *
     * When `copyText` is `false`, the {@link #DEFAULT} instance
     * should be used instead of constructing a new instance.
     *
     * @param copyText The value for {@link #copyText}.
     */ constructor(copyText = false){
        this.copyText = copyText;
    }
}
$7d2553cef85c6b91$var$__decorate([
    $ffTXa.Override
], $7d2553cef85c6b91$var$CommonTokenFactory.prototype, "create", null);
$7d2553cef85c6b91$var$__decorate([
    $ffTXa.Override
], $7d2553cef85c6b91$var$CommonTokenFactory.prototype, "createSimple", null);
module.exports.CommonTokenFactory = $7d2553cef85c6b91$var$CommonTokenFactory;
(function(CommonTokenFactory) {
    /**
     * The default {@link CommonTokenFactory} instance.
     *
     * This token factory does not explicitly copy token text when constructing
     * tokens.
     */ CommonTokenFactory.DEFAULT = new CommonTokenFactory();
})($7d2553cef85c6b91$var$CommonTokenFactory = module.exports.CommonTokenFactory || (module.exports.CommonTokenFactory = {}));

});

parcelRegister("eAd9i", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $02bd65afbf20a5b5$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $02bd65afbf20a5b5$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommonToken = void 0;

var $dQ3yU = parcelRequire("dQ3yU");


var $ffTXa = parcelRequire("ffTXa");


var $TNDGs = parcelRequire("TNDGs");

let $02bd65afbf20a5b5$var$CommonToken = class CommonToken {
    /**
     * Constructs a new {@link CommonToken} as a copy of another {@link Token}.
     *
     * If `oldToken` is also a {@link CommonToken} instance, the newly
     * constructed token will share a reference to the {@link #text} field and
     * the {@link Tuple2} stored in {@link #source}. Otherwise, {@link #text} will
     * be assigned the result of calling {@link #getText}, and {@link #source}
     * will be constructed from the result of {@link Token#getTokenSource} and
     * {@link Token#getInputStream}.
     *
     * @param oldToken The token to copy.
     */ static fromToken(oldToken) {
        let result = new CommonToken(oldToken.type, undefined, CommonToken.EMPTY_SOURCE, oldToken.channel, oldToken.startIndex, oldToken.stopIndex);
        result._line = oldToken.line;
        result.index = oldToken.tokenIndex;
        result._charPositionInLine = oldToken.charPositionInLine;
        if (oldToken instanceof CommonToken) {
            result._text = oldToken._text;
            result.source = oldToken.source;
        } else {
            result._text = oldToken.text;
            result.source = {
                source: oldToken.tokenSource,
                stream: oldToken.inputStream
            };
        }
        return result;
    }
    get type() {
        return this._type;
    }
    // @Override
    set type(type) {
        this._type = type;
    }
    get line() {
        return this._line;
    }
    // @Override
    set line(line) {
        this._line = line;
    }
    get text() {
        if (this._text != null) return this._text;
        let input = this.inputStream;
        if (input == null) return undefined;
        let n = input.size;
        if (this.start < n && this.stop < n) return input.getText($dQ3yU.Interval.of(this.start, this.stop));
        else return "<EOF>";
    }
    /**
     * Explicitly set the text for this token. If {code text} is not
     * `undefined`, then {@link #getText} will return this value rather than
     * extracting the text from the input.
     *
     * @param text The explicit text of the token, or `undefined` if the text
     * should be obtained from the input along with the start and stop indexes
     * of the token.
     */ // @Override
    set text(text) {
        this._text = text;
    }
    get charPositionInLine() {
        return this._charPositionInLine;
    }
    // @Override
    set charPositionInLine(charPositionInLine) {
        this._charPositionInLine = charPositionInLine;
    }
    get channel() {
        return this._channel;
    }
    // @Override
    set channel(channel) {
        this._channel = channel;
    }
    get startIndex() {
        return this.start;
    }
    set startIndex(start) {
        this.start = start;
    }
    get stopIndex() {
        return this.stop;
    }
    set stopIndex(stop) {
        this.stop = stop;
    }
    get tokenIndex() {
        return this.index;
    }
    // @Override
    set tokenIndex(index) {
        this.index = index;
    }
    get tokenSource() {
        return this.source.source;
    }
    get inputStream() {
        return this.source.stream;
    }
    toString(recognizer) {
        let channelStr = "";
        if (this._channel > 0) channelStr = ",channel=" + this._channel;
        let txt = this.text;
        if (txt != null) {
            txt = txt.replace(/\n/g, "\\n");
            txt = txt.replace(/\r/g, "\\r");
            txt = txt.replace(/\t/g, "\\t");
        } else txt = "<no text>";
        let typeString = String(this._type);
        if (recognizer) typeString = recognizer.vocabulary.getDisplayName(this._type);
        return "[@" + this.tokenIndex + "," + this.start + ":" + this.stop + "='" + txt + "',<" + typeString + ">" + channelStr + "," + this._line + ":" + this.charPositionInLine + "]";
    }
    constructor(type, text, source = CommonToken.EMPTY_SOURCE, channel = $TNDGs.Token.DEFAULT_CHANNEL, start = 0, stop = 0){
        /**
         * This is the backing field for {@link #getLine} and {@link #setLine}.
         */ this._line = 0;
        /**
         * This is the backing field for {@link #getCharPositionInLine} and
         * {@link #setCharPositionInLine}.
         */ this._charPositionInLine = -1; // set to invalid position
        /**
         * This is the backing field for {@link #getChannel} and
         * {@link #setChannel}.
         */ this._channel = $TNDGs.Token.DEFAULT_CHANNEL;
        /**
         * This is the backing field for `tokenIndex`.
         */ this.index = -1;
        this._text = text;
        this._type = type;
        this.source = source;
        this._channel = channel;
        this.start = start;
        this.stop = stop;
        if (source.source != null) {
            this._line = source.source.line;
            this._charPositionInLine = source.source.charPositionInLine;
        }
    }
};
/**
 * An empty {@link Tuple2} which is used as the default value of
 * {@link #source} for tokens that do not have a source.
 */ $02bd65afbf20a5b5$var$CommonToken.EMPTY_SOURCE = {
    source: undefined,
    stream: undefined
};
$02bd65afbf20a5b5$var$__decorate([
    $ffTXa.NotNull
], $02bd65afbf20a5b5$var$CommonToken.prototype, "source", void 0);
$02bd65afbf20a5b5$var$__decorate([
    $ffTXa.Override
], $02bd65afbf20a5b5$var$CommonToken.prototype, "type", null);
$02bd65afbf20a5b5$var$__decorate([
    $ffTXa.Override
], $02bd65afbf20a5b5$var$CommonToken.prototype, "line", null);
$02bd65afbf20a5b5$var$__decorate([
    $ffTXa.Override
], $02bd65afbf20a5b5$var$CommonToken.prototype, "text", null);
$02bd65afbf20a5b5$var$__decorate([
    $ffTXa.Override
], $02bd65afbf20a5b5$var$CommonToken.prototype, "charPositionInLine", null);
$02bd65afbf20a5b5$var$__decorate([
    $ffTXa.Override
], $02bd65afbf20a5b5$var$CommonToken.prototype, "channel", null);
$02bd65afbf20a5b5$var$__decorate([
    $ffTXa.Override
], $02bd65afbf20a5b5$var$CommonToken.prototype, "startIndex", null);
$02bd65afbf20a5b5$var$__decorate([
    $ffTXa.Override
], $02bd65afbf20a5b5$var$CommonToken.prototype, "stopIndex", null);
$02bd65afbf20a5b5$var$__decorate([
    $ffTXa.Override
], $02bd65afbf20a5b5$var$CommonToken.prototype, "tokenIndex", null);
$02bd65afbf20a5b5$var$__decorate([
    $ffTXa.Override
], $02bd65afbf20a5b5$var$CommonToken.prototype, "tokenSource", null);
$02bd65afbf20a5b5$var$__decorate([
    $ffTXa.Override
], $02bd65afbf20a5b5$var$CommonToken.prototype, "inputStream", null);
$02bd65afbf20a5b5$var$__decorate([
    $ffTXa.Override
], $02bd65afbf20a5b5$var$CommonToken.prototype, "toString", null);
$02bd65afbf20a5b5$var$__decorate([
    $02bd65afbf20a5b5$var$__param(0, $ffTXa.NotNull)
], $02bd65afbf20a5b5$var$CommonToken, "fromToken", null);
$02bd65afbf20a5b5$var$CommonToken = $02bd65afbf20a5b5$var$__decorate([
    $02bd65afbf20a5b5$var$__param(2, $ffTXa.NotNull)
], $02bd65afbf20a5b5$var$CommonToken);
module.exports.CommonToken = $02bd65afbf20a5b5$var$CommonToken;

});

parcelRegister("TNDGs", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Token = void 0;

var $9P2T1 = parcelRequire("9P2T1");

var $0a7ba473ba917288$var$Token;
(function(Token) {
    Token.INVALID_TYPE = 0;
    /** During lookahead operations, this "token" signifies we hit rule end ATN state
     *  and did not follow it despite needing to.
     */ Token.EPSILON = -2;
    Token.MIN_USER_TOKEN_TYPE = 1;
    Token.EOF = $9P2T1.IntStream.EOF;
    /** All tokens go to the parser (unless skip() is called in that rule)
     *  on a particular "channel".  The parser tunes to a particular channel
     *  so that whitespace etc... can go to the parser on a "hidden" channel.
     */ Token.DEFAULT_CHANNEL = 0;
    /** Anything on different channel than DEFAULT_CHANNEL is not parsed
     *  by parser.
     */ Token.HIDDEN_CHANNEL = 1;
    /**
     * This is the minimum constant value which can be assigned to a
     * user-defined token channel.
     *
     * The non-negative numbers less than {@link #MIN_USER_CHANNEL_VALUE} are
     * assigned to the predefined channels {@link #DEFAULT_CHANNEL} and
     * {@link #HIDDEN_CHANNEL}.
     *
     * @see `Token.channel`
     */ Token.MIN_USER_CHANNEL_VALUE = 2;
})($0a7ba473ba917288$var$Token = module.exports.Token || (module.exports.Token = {}));

});

parcelRegister("8Dduc", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $648c6d477196f35c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $648c6d477196f35c$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerATNSimulator = void 0;

var $a9s8D = parcelRequire("a9s8D");


var $3pR6v = parcelRequire("3pR6v");


var $cxg6R = parcelRequire("cxg6R");


var $64vb9 = parcelRequire("64vb9");


var $51Z4d = parcelRequire("51Z4d");


var $kjxTv = parcelRequire("kjxTv");


var $dQ3yU = parcelRequire("dQ3yU");


var $9P2T1 = parcelRequire("9P2T1");


var $gJMeE = parcelRequire("gJMeE");


var $gEp6N = parcelRequire("gEp6N");


var $hh2Av = parcelRequire("hh2Av");


var $ffTXa = parcelRequire("ffTXa");


var $i4PVO = parcelRequire("i4PVO");


var $2EGxJ = parcelRequire("2EGxJ");


var $9v0dI = parcelRequire("9v0dI");


var $TNDGs = parcelRequire("TNDGs");


var $9Rq82 = parcelRequire("9Rq82");

/** "dup" of ParserInterpreter */ let $648c6d477196f35c$var$LexerATNSimulator = class LexerATNSimulator extends $51Z4d.ATNSimulator {
    copyState(simulator) {
        this._charPositionInLine = simulator.charPositionInLine;
        this._line = simulator._line;
        this.mode = simulator.mode;
        this.startIndex = simulator.startIndex;
    }
    match(input, mode) {
        this.mode = mode;
        let mark = input.mark();
        try {
            this.startIndex = input.index;
            this.prevAccept.reset();
            let s0 = this.atn.modeToDFA[mode].s0;
            if (s0 == null) return this.matchATN(input);
            else return this.execATN(input, s0);
        } finally{
            input.release(mark);
        }
    }
    reset() {
        this.prevAccept.reset();
        this.startIndex = -1;
        this._line = 1;
        this._charPositionInLine = 0;
        this.mode = $gJMeE.Lexer.DEFAULT_MODE;
    }
    matchATN(input) {
        let startState = this.atn.modeToStartState[this.mode];
        if (LexerATNSimulator.debug) console.log(`matchATN mode ${this.mode} start: ${startState}`);
        let old_mode = this.mode;
        let s0_closure = this.computeStartState(input, startState);
        let suppressEdge = s0_closure.hasSemanticContext;
        if (suppressEdge) s0_closure.hasSemanticContext = false;
        let next = this.addDFAState(s0_closure);
        if (!suppressEdge) {
            let dfa = this.atn.modeToDFA[this.mode];
            if (!dfa.s0) dfa.s0 = next;
            else next = dfa.s0;
        }
        let predict = this.execATN(input, next);
        if (LexerATNSimulator.debug) console.log(`DFA after matchATN: ${this.atn.modeToDFA[old_mode].toLexerString()}`);
        return predict;
    }
    execATN(input, ds0) {
        // console.log("enter exec index "+input.index+" from "+ds0.configs);
        if (LexerATNSimulator.debug) console.log(`start state closure=${ds0.configs}`);
        if (ds0.isAcceptState) // allow zero-length tokens
        this.captureSimState(this.prevAccept, input, ds0);
        let t = input.LA(1);
        // @NotNull
        let s = ds0; // s is current/from DFA state
        while(true){
            if (LexerATNSimulator.debug) console.log(`execATN loop starting closure: ${s.configs}`);
            // As we move src->trg, src->trg, we keep track of the previous trg to
            // avoid looking up the DFA state again, which is expensive.
            // If the previous target was already part of the DFA, we might
            // be able to avoid doing a reach operation upon t. If s!=null,
            // it means that semantic predicates didn't prevent us from
            // creating a DFA state. Once we know s!=null, we check to see if
            // the DFA state has an edge already for t. If so, we can just reuse
            // it's configuration set; there's no point in re-computing it.
            // This is kind of like doing DFA simulation within the ATN
            // simulation because DFA simulation is really just a way to avoid
            // computing reach/closure sets. Technically, once we know that
            // we have a previously added DFA state, we could jump over to
            // the DFA simulator. But, that would mean popping back and forth
            // a lot and making things more complicated algorithmically.
            // This optimization makes a lot of sense for loops within DFA.
            // A character will take us back to an existing DFA state
            // that already has lots of edges out of it. e.g., .* in comments.
            let target = this.getExistingTargetState(s, t);
            if (target == null) target = this.computeTargetState(input, s, t);
            if (target === $51Z4d.ATNSimulator.ERROR) break;
            // If this is a consumable input element, make sure to consume before
            // capturing the accept state so the input index, line, and char
            // position accurately reflect the state of the interpreter at the
            // end of the token.
            if (t !== $9P2T1.IntStream.EOF) this.consume(input);
            if (target.isAcceptState) {
                this.captureSimState(this.prevAccept, input, target);
                if (t === $9P2T1.IntStream.EOF) break;
            }
            t = input.LA(1);
            s = target; // flip; current DFA target becomes new src/from state
        }
        return this.failOrAccept(this.prevAccept, input, s.configs, t);
    }
    /**
     * Get an existing target state for an edge in the DFA. If the target state
     * for the edge has not yet been computed or is otherwise not available,
     * this method returns `undefined`.
     *
     * @param s The current DFA state
     * @param t The next input symbol
     * @returns The existing target DFA state for the given input symbol
     * `t`, or `undefined` if the target state for this edge is not
     * already cached
     */ getExistingTargetState(s, t) {
        let target = s.getTarget(t);
        if (LexerATNSimulator.debug && target != null) console.log("reuse state " + s.stateNumber + " edge to " + target.stateNumber);
        return target;
    }
    /**
     * Compute a target state for an edge in the DFA, and attempt to add the
     * computed state and corresponding edge to the DFA.
     *
     * @param input The input stream
     * @param s The current DFA state
     * @param t The next input symbol
     *
     * @returns The computed target DFA state for the given input symbol
     * `t`. If `t` does not lead to a valid DFA state, this method
     * returns {@link #ERROR}.
     */ computeTargetState(input, s, t) {
        let reach = new $i4PVO.OrderedATNConfigSet();
        // if we don't find an existing DFA state
        // Fill reach starting from closure, following t transitions
        this.getReachableConfigSet(input, s.configs, reach, t);
        if (reach.isEmpty) {
            if (!reach.hasSemanticContext) // we got nowhere on t, don't throw out this knowledge; it'd
            // cause a failover from DFA later.
            this.addDFAEdge(s, t, $51Z4d.ATNSimulator.ERROR);
            // stop when we can't match any more char
            return $51Z4d.ATNSimulator.ERROR;
        }
        // Add an edge from s to target DFA found/created for reach
        return this.addDFAEdge(s, t, reach);
    }
    failOrAccept(prevAccept, input, reach, t) {
        if (prevAccept.dfaState != null) {
            let lexerActionExecutor = prevAccept.dfaState.lexerActionExecutor;
            this.accept(input, lexerActionExecutor, this.startIndex, prevAccept.index, prevAccept.line, prevAccept.charPos);
            return prevAccept.dfaState.prediction;
        } else {
            // if no accept and EOF is first char, return EOF
            if (t === $9P2T1.IntStream.EOF && input.index === this.startIndex) return $TNDGs.Token.EOF;
            throw new $hh2Av.LexerNoViableAltException(this.recog, input, this.startIndex, reach);
        }
    }
    /** Given a starting configuration set, figure out all ATN configurations
     *  we can reach upon input `t`. Parameter `reach` is a return
     *  parameter.
     */ getReachableConfigSet(input, closure, reach, t) {
        // this is used to skip processing for configs which have a lower priority
        // than a config that already reached an accept state for the same rule
        let skipAlt = $3pR6v.ATN.INVALID_ALT_NUMBER;
        for (let c of closure){
            let currentAltReachedAcceptState = c.alt === skipAlt;
            if (currentAltReachedAcceptState && c.hasPassedThroughNonGreedyDecision) continue;
            if (LexerATNSimulator.debug) console.log(`testing ${this.getTokenName(t)} at ${c.toString(this.recog, true)}`);
            let n = c.state.numberOfOptimizedTransitions;
            for(let ti = 0; ti < n; ti++){
                let trans = c.state.getOptimizedTransition(ti);
                let target = this.getReachableTarget(trans, t);
                if (target != null) {
                    let lexerActionExecutor = c.lexerActionExecutor;
                    let config;
                    if (lexerActionExecutor != null) {
                        lexerActionExecutor = lexerActionExecutor.fixOffsetBeforeMatch(input.index - this.startIndex);
                        config = c.transform(target, true, lexerActionExecutor);
                    } else {
                        $9Rq82(c.lexerActionExecutor == null);
                        config = c.transform(target, true);
                    }
                    let treatEofAsEpsilon = t === $9P2T1.IntStream.EOF;
                    if (this.closure(input, config, reach, currentAltReachedAcceptState, true, treatEofAsEpsilon)) {
                        // any remaining configs for this alt have a lower priority than
                        // the one that just reached an accept state.
                        skipAlt = c.alt;
                        break;
                    }
                }
            }
        }
    }
    accept(input, lexerActionExecutor, startIndex, index, line, charPos) {
        if (LexerATNSimulator.debug) console.log(`ACTION ${lexerActionExecutor}`);
        // seek to after last char in token
        input.seek(index);
        this._line = line;
        this._charPositionInLine = charPos;
        if (lexerActionExecutor != null && this.recog != null) lexerActionExecutor.execute(this.recog, input, startIndex);
    }
    getReachableTarget(trans, t) {
        if (trans.matches(t, $gJMeE.Lexer.MIN_CHAR_VALUE, $gJMeE.Lexer.MAX_CHAR_VALUE)) return trans.target;
        return undefined;
    }
    computeStartState(input, p) {
        let initialContext = $2EGxJ.PredictionContext.EMPTY_FULL;
        let configs = new $i4PVO.OrderedATNConfigSet();
        for(let i = 0; i < p.numberOfTransitions; i++){
            let target = p.transition(i).target;
            let c = $cxg6R.ATNConfig.create(target, i + 1, initialContext);
            this.closure(input, c, configs, false, false, false);
        }
        return configs;
    }
    /**
     * Since the alternatives within any lexer decision are ordered by
     * preference, this method stops pursuing the closure as soon as an accept
     * state is reached. After the first accept state is reached by depth-first
     * search from `config`, all other (potentially reachable) states for
     * this rule would have a lower priority.
     *
     * @returns `true` if an accept state is reached, otherwise
     * `false`.
     */ closure(input, config, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon) {
        if (LexerATNSimulator.debug) console.log("closure(" + config.toString(this.recog, true) + ")");
        if (config.state instanceof $9v0dI.RuleStopState) {
            if (LexerATNSimulator.debug) {
                if (this.recog != null) console.log(`closure at ${this.recog.ruleNames[config.state.ruleIndex]} rule stop ${config}`);
                else console.log(`closure at rule stop ${config}`);
            }
            let context = config.context;
            if (context.isEmpty) {
                configs.add(config);
                return true;
            } else if (context.hasEmpty) {
                configs.add(config.transform(config.state, true, $2EGxJ.PredictionContext.EMPTY_FULL));
                currentAltReachedAcceptState = true;
            }
            for(let i = 0; i < context.size; i++){
                let returnStateNumber = context.getReturnState(i);
                if (returnStateNumber === $2EGxJ.PredictionContext.EMPTY_FULL_STATE_KEY) continue;
                let newContext = context.getParent(i); // "pop" return state
                let returnState = this.atn.states[returnStateNumber];
                let c = config.transform(returnState, false, newContext);
                currentAltReachedAcceptState = this.closure(input, c, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon);
            }
            return currentAltReachedAcceptState;
        }
        // optimization
        if (!config.state.onlyHasEpsilonTransitions) {
            if (!currentAltReachedAcceptState || !config.hasPassedThroughNonGreedyDecision) configs.add(config);
        }
        let p = config.state;
        for(let i = 0; i < p.numberOfOptimizedTransitions; i++){
            let t = p.getOptimizedTransition(i);
            let c = this.getEpsilonTarget(input, config, t, configs, speculative, treatEofAsEpsilon);
            if (c != null) currentAltReachedAcceptState = this.closure(input, c, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon);
        }
        return currentAltReachedAcceptState;
    }
    // side-effect: can alter configs.hasSemanticContext
    getEpsilonTarget(input, config, t, configs, speculative, treatEofAsEpsilon) {
        let c;
        switch(t.serializationType){
            case 3 /* RULE */ :
                let ruleTransition = t;
                if (this.optimize_tail_calls && ruleTransition.optimizedTailCall && !config.context.hasEmpty) c = config.transform(t.target, true);
                else {
                    let newContext = config.context.getChild(ruleTransition.followState.stateNumber);
                    c = config.transform(t.target, true, newContext);
                }
                break;
            case 10 /* PRECEDENCE */ :
                throw new Error("Precedence predicates are not supported in lexers.");
            case 4 /* PREDICATE */ :
                /*  Track traversing semantic predicates. If we traverse,
                    we cannot add a DFA state for this "reach" computation
                    because the DFA would not test the predicate again in the
                    future. Rather than creating collections of semantic predicates
                    like v3 and testing them on prediction, v4 will test them on the
                    fly all the time using the ATN not the DFA. This is slower but
                    semantically it's not used that often. One of the key elements to
                    this predicate mechanism is not adding DFA states that see
                    predicates immediately afterwards in the ATN. For example,
    
                    a : ID {p1}? | ID {p2}? ;
    
                    should create the start state for rule 'a' (to save start state
                    competition), but should not create target of ID state. The
                    collection of ATN states the following ID references includes
                    states reached by traversing predicates. Since this is when we
                    test them, we cannot cash the DFA state target of ID.
                */ let pt = t;
                if (LexerATNSimulator.debug) console.log("EVAL rule " + pt.ruleIndex + ":" + pt.predIndex);
                configs.hasSemanticContext = true;
                if (this.evaluatePredicate(input, pt.ruleIndex, pt.predIndex, speculative)) c = config.transform(t.target, true);
                else c = undefined;
                break;
            case 6 /* ACTION */ :
                if (config.context.hasEmpty) {
                    // execute actions anywhere in the start rule for a token.
                    //
                    // TODO: if the entry rule is invoked recursively, some
                    // actions may be executed during the recursive call. The
                    // problem can appear when hasEmpty is true but
                    // isEmpty is false. In this case, the config needs to be
                    // split into two contexts - one with just the empty path
                    // and another with everything but the empty path.
                    // Unfortunately, the current algorithm does not allow
                    // getEpsilonTarget to return two configurations, so
                    // additional modifications are needed before we can support
                    // the split operation.
                    let lexerActionExecutor = $gEp6N.LexerActionExecutor.append(config.lexerActionExecutor, this.atn.lexerActions[t.actionIndex]);
                    c = config.transform(t.target, true, lexerActionExecutor);
                    break;
                } else {
                    // ignore actions in referenced rules
                    c = config.transform(t.target, true);
                    break;
                }
            case 1 /* EPSILON */ :
                c = config.transform(t.target, true);
                break;
            case 5 /* ATOM */ :
            case 2 /* RANGE */ :
            case 7 /* SET */ :
                if (treatEofAsEpsilon) {
                    if (t.matches($9P2T1.IntStream.EOF, $gJMeE.Lexer.MIN_CHAR_VALUE, $gJMeE.Lexer.MAX_CHAR_VALUE)) {
                        c = config.transform(t.target, false);
                        break;
                    }
                }
                c = undefined;
                break;
            default:
                c = undefined;
                break;
        }
        return c;
    }
    /**
     * Evaluate a predicate specified in the lexer.
     *
     * If `speculative` is `true`, this method was called before
     * {@link #consume} for the matched character. This method should call
     * {@link #consume} before evaluating the predicate to ensure position
     * sensitive values, including {@link Lexer#getText}, {@link Lexer#getLine},
     * and {@link Lexer#getCharPositionInLine}, properly reflect the current
     * lexer state. This method should restore `input` and the simulator
     * to the original state before returning (i.e. undo the actions made by the
     * call to {@link #consume}.
     *
     * @param input The input stream.
     * @param ruleIndex The rule containing the predicate.
     * @param predIndex The index of the predicate within the rule.
     * @param speculative `true` if the current index in `input` is
     * one character before the predicate's location.
     *
     * @returns `true` if the specified predicate evaluates to
     * `true`.
     */ evaluatePredicate(input, ruleIndex, predIndex, speculative) {
        // assume true if no recognizer was provided
        if (this.recog == null) return true;
        if (!speculative) return this.recog.sempred(undefined, ruleIndex, predIndex);
        let savedCharPositionInLine = this._charPositionInLine;
        let savedLine = this._line;
        let index = input.index;
        let marker = input.mark();
        try {
            this.consume(input);
            return this.recog.sempred(undefined, ruleIndex, predIndex);
        } finally{
            this._charPositionInLine = savedCharPositionInLine;
            this._line = savedLine;
            input.seek(index);
            input.release(marker);
        }
    }
    captureSimState(settings, input, dfaState) {
        settings.index = input.index;
        settings.line = this._line;
        settings.charPos = this._charPositionInLine;
        settings.dfaState = dfaState;
    }
    addDFAEdge(p, t, q) {
        if (q instanceof $64vb9.ATNConfigSet) {
            /* leading to this call, ATNConfigSet.hasSemanticContext is used as a
            * marker indicating dynamic predicate evaluation makes this edge
            * dependent on the specific input sequence, so the static edge in the
            * DFA should be omitted. The target DFAState is still created since
            * execATN has the ability to resynchronize with the DFA state cache
            * following the predicate evaluation step.
            *
            * TJP notes: next time through the DFA, we see a pred again and eval.
            * If that gets us to a previously created (but dangling) DFA
            * state, we can continue in pure DFA mode from there.
            */ let suppressEdge = q.hasSemanticContext;
            if (suppressEdge) q.hasSemanticContext = false;
            // @NotNull
            let to = this.addDFAState(q);
            if (suppressEdge) return to;
            this.addDFAEdge(p, t, to);
            return to;
        } else {
            if (LexerATNSimulator.debug) console.log("EDGE " + p + " -> " + q + " upon " + String.fromCharCode(t));
            if (p != null) p.setTarget(t, q);
        }
    }
    /** Add a new DFA state if there isn't one with this set of
     * 	configurations already. This method also detects the first
     * 	configuration containing an ATN rule stop state. Later, when
     * 	traversing the DFA, we will know which rule to accept.
     */ addDFAState(configs) {
        /* the lexer evaluates predicates on-the-fly; by this point configs
         * should not contain any configurations with unevaluated predicates.
         */ $9Rq82(!configs.hasSemanticContext);
        let proposed = new $kjxTv.DFAState(configs);
        let existing = this.atn.modeToDFA[this.mode].states.get(proposed);
        if (existing != null) return existing;
        configs.optimizeConfigs(this);
        let newState = new $kjxTv.DFAState(configs.clone(true));
        let firstConfigWithRuleStopState;
        for (let c of configs)if (c.state instanceof $9v0dI.RuleStopState) {
            firstConfigWithRuleStopState = c;
            break;
        }
        if (firstConfigWithRuleStopState != null) {
            let prediction = this.atn.ruleToTokenType[firstConfigWithRuleStopState.state.ruleIndex];
            let lexerActionExecutor = firstConfigWithRuleStopState.lexerActionExecutor;
            newState.acceptStateInfo = new $a9s8D.AcceptStateInfo(prediction, lexerActionExecutor);
        }
        return this.atn.modeToDFA[this.mode].addState(newState);
    }
    getDFA(mode) {
        return this.atn.modeToDFA[mode];
    }
    /** Get the text matched so far for the current token.
     */ getText(input) {
        // index is first lookahead char, don't include.
        return input.getText($dQ3yU.Interval.of(this.startIndex, input.index - 1));
    }
    get line() {
        return this._line;
    }
    set line(line) {
        this._line = line;
    }
    get charPositionInLine() {
        return this._charPositionInLine;
    }
    set charPositionInLine(charPositionInLine) {
        this._charPositionInLine = charPositionInLine;
    }
    consume(input) {
        let curChar = input.LA(1);
        if (curChar === "\n".charCodeAt(0)) {
            this._line++;
            this._charPositionInLine = 0;
        } else this._charPositionInLine++;
        input.consume();
    }
    getTokenName(t) {
        if (t === -1) return "EOF";
        //if ( atn.g!=null ) return atn.g.getTokenDisplayName(t);
        return "'" + String.fromCharCode(t) + "'";
    }
    constructor(atn, recog){
        super(atn);
        this.optimize_tail_calls = true;
        /** The current token's starting index into the character stream.
         *  Shared across DFA to ATN simulation in case the ATN fails and the
         *  DFA did not have a previous accept state. In this case, we use the
         *  ATN-generated exception object.
         */ this.startIndex = -1;
        /** line number 1..n within the input */ this._line = 1;
        /** The index of the character relative to the beginning of the line 0..n-1 */ this._charPositionInLine = 0;
        this.mode = $gJMeE.Lexer.DEFAULT_MODE;
        /** Used during DFA/ATN exec to record the most recent accept configuration info */ this.prevAccept = new LexerATNSimulator.SimState();
        this.recog = recog;
    }
};
$648c6d477196f35c$var$__decorate([
    $ffTXa.NotNull
], $648c6d477196f35c$var$LexerATNSimulator.prototype, "prevAccept", void 0);
$648c6d477196f35c$var$__decorate([
    $648c6d477196f35c$var$__param(0, $ffTXa.NotNull)
], $648c6d477196f35c$var$LexerATNSimulator.prototype, "copyState", null);
$648c6d477196f35c$var$__decorate([
    $648c6d477196f35c$var$__param(0, $ffTXa.NotNull)
], $648c6d477196f35c$var$LexerATNSimulator.prototype, "match", null);
$648c6d477196f35c$var$__decorate([
    $ffTXa.Override
], $648c6d477196f35c$var$LexerATNSimulator.prototype, "reset", null);
$648c6d477196f35c$var$__decorate([
    $648c6d477196f35c$var$__param(0, $ffTXa.NotNull)
], $648c6d477196f35c$var$LexerATNSimulator.prototype, "matchATN", null);
$648c6d477196f35c$var$__decorate([
    $648c6d477196f35c$var$__param(0, $ffTXa.NotNull),
    $648c6d477196f35c$var$__param(1, $ffTXa.NotNull)
], $648c6d477196f35c$var$LexerATNSimulator.prototype, "execATN", null);
$648c6d477196f35c$var$__decorate([
    $648c6d477196f35c$var$__param(0, $ffTXa.NotNull)
], $648c6d477196f35c$var$LexerATNSimulator.prototype, "getExistingTargetState", null);
$648c6d477196f35c$var$__decorate([
    $ffTXa.NotNull,
    $648c6d477196f35c$var$__param(0, $ffTXa.NotNull),
    $648c6d477196f35c$var$__param(1, $ffTXa.NotNull)
], $648c6d477196f35c$var$LexerATNSimulator.prototype, "computeTargetState", null);
$648c6d477196f35c$var$__decorate([
    $648c6d477196f35c$var$__param(0, $ffTXa.NotNull),
    $648c6d477196f35c$var$__param(1, $ffTXa.NotNull),
    $648c6d477196f35c$var$__param(2, $ffTXa.NotNull)
], $648c6d477196f35c$var$LexerATNSimulator.prototype, "getReachableConfigSet", null);
$648c6d477196f35c$var$__decorate([
    $648c6d477196f35c$var$__param(0, $ffTXa.NotNull)
], $648c6d477196f35c$var$LexerATNSimulator.prototype, "accept", null);
$648c6d477196f35c$var$__decorate([
    $ffTXa.NotNull,
    $648c6d477196f35c$var$__param(0, $ffTXa.NotNull),
    $648c6d477196f35c$var$__param(1, $ffTXa.NotNull)
], $648c6d477196f35c$var$LexerATNSimulator.prototype, "computeStartState", null);
$648c6d477196f35c$var$__decorate([
    $648c6d477196f35c$var$__param(0, $ffTXa.NotNull),
    $648c6d477196f35c$var$__param(1, $ffTXa.NotNull),
    $648c6d477196f35c$var$__param(2, $ffTXa.NotNull)
], $648c6d477196f35c$var$LexerATNSimulator.prototype, "closure", null);
$648c6d477196f35c$var$__decorate([
    $648c6d477196f35c$var$__param(0, $ffTXa.NotNull),
    $648c6d477196f35c$var$__param(1, $ffTXa.NotNull),
    $648c6d477196f35c$var$__param(2, $ffTXa.NotNull),
    $648c6d477196f35c$var$__param(3, $ffTXa.NotNull)
], $648c6d477196f35c$var$LexerATNSimulator.prototype, "getEpsilonTarget", null);
$648c6d477196f35c$var$__decorate([
    $648c6d477196f35c$var$__param(0, $ffTXa.NotNull)
], $648c6d477196f35c$var$LexerATNSimulator.prototype, "evaluatePredicate", null);
$648c6d477196f35c$var$__decorate([
    $648c6d477196f35c$var$__param(0, $ffTXa.NotNull),
    $648c6d477196f35c$var$__param(1, $ffTXa.NotNull),
    $648c6d477196f35c$var$__param(2, $ffTXa.NotNull)
], $648c6d477196f35c$var$LexerATNSimulator.prototype, "captureSimState", null);
$648c6d477196f35c$var$__decorate([
    $ffTXa.NotNull,
    $648c6d477196f35c$var$__param(0, $ffTXa.NotNull)
], $648c6d477196f35c$var$LexerATNSimulator.prototype, "addDFAState", null);
$648c6d477196f35c$var$__decorate([
    $ffTXa.NotNull
], $648c6d477196f35c$var$LexerATNSimulator.prototype, "getDFA", null);
$648c6d477196f35c$var$__decorate([
    $ffTXa.NotNull,
    $648c6d477196f35c$var$__param(0, $ffTXa.NotNull)
], $648c6d477196f35c$var$LexerATNSimulator.prototype, "getText", null);
$648c6d477196f35c$var$__decorate([
    $648c6d477196f35c$var$__param(0, $ffTXa.NotNull)
], $648c6d477196f35c$var$LexerATNSimulator.prototype, "consume", null);
$648c6d477196f35c$var$__decorate([
    $ffTXa.NotNull
], $648c6d477196f35c$var$LexerATNSimulator.prototype, "getTokenName", null);
$648c6d477196f35c$var$LexerATNSimulator = $648c6d477196f35c$var$__decorate([
    $648c6d477196f35c$var$__param(0, $ffTXa.NotNull)
], $648c6d477196f35c$var$LexerATNSimulator);
module.exports.LexerATNSimulator = $648c6d477196f35c$var$LexerATNSimulator;
(function(LexerATNSimulator) {
    LexerATNSimulator.debug = false;
    LexerATNSimulator.dfa_debug = false;
    /** When we hit an accept state in either the DFA or the ATN, we
     *  have to notify the character stream to start buffering characters
     *  via {@link IntStream#mark} and record the current state. The current sim state
     *  includes the current index into the input, the current line,
     *  and current character position in that line. Note that the Lexer is
     *  tracking the starting line and characterization of the token. These
     *  variables track the "state" of the simulator when it hits an accept state.
     *
     *  We track these variables separately for the DFA and ATN simulation
     *  because the DFA simulation often has to fail over to the ATN
     *  simulation. If the ATN simulation fails, we need the DFA to fall
     *  back to its previously accepted state, if any. If the ATN succeeds,
     *  then the ATN does the accept and the DFA simulator that invoked it
     *  can simply return the predicted token type.
     */ class SimState {
        reset() {
            this.index = -1;
            this.line = 0;
            this.charPos = -1;
            this.dfaState = undefined;
        }
        constructor(){
            this.index = -1;
            this.line = 0;
            this.charPos = -1;
        }
    }
    LexerATNSimulator.SimState = SimState;
})($648c6d477196f35c$var$LexerATNSimulator = module.exports.LexerATNSimulator || (module.exports.LexerATNSimulator = {}));
module.exports.LexerATNSimulator = $648c6d477196f35c$var$LexerATNSimulator;

});

parcelRegister("3pR6v", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $27cce641551d937f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $27cce641551d937f$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATN = void 0;

var $5ZofD = parcelRequire("5ZofD");


var $6AYuC = parcelRequire("6AYuC");


var $69z5o = parcelRequire("69z5o");


var $biTmn = parcelRequire("biTmn");


var $acFm6 = parcelRequire("acFm6");


var $ffTXa = parcelRequire("ffTXa");


var $9PlGk = parcelRequire("9PlGk");


var $2EGxJ = parcelRequire("2EGxJ");


var $TNDGs = parcelRequire("TNDGs");


var $9Rq82 = parcelRequire("9Rq82");

/** */ let $27cce641551d937f$var$ATN = class ATN {
    clearDFA() {
        this.decisionToDFA = new Array(this.decisionToState.length);
        for(let i = 0; i < this.decisionToDFA.length; i++)this.decisionToDFA[i] = new $6AYuC.DFA(this.decisionToState[i], i);
        this.modeToDFA = new Array(this.modeToStartState.length);
        for(let i = 0; i < this.modeToDFA.length; i++)this.modeToDFA[i] = new $6AYuC.DFA(this.modeToStartState[i]);
        this.contextCache.clear();
        this.LL1Table.clear();
    }
    get contextCacheSize() {
        return this.contextCache.size;
    }
    getCachedContext(context) {
        return $2EGxJ.PredictionContext.getCachedContext(context, this.contextCache, new $2EGxJ.PredictionContext.IdentityHashMap());
    }
    getDecisionToDFA() {
        $9Rq82(this.decisionToDFA != null && this.decisionToDFA.length === this.decisionToState.length);
        return this.decisionToDFA;
    }
    nextTokens(s, ctx) {
        if (ctx) {
            let anal = new $acFm6.LL1Analyzer(this);
            let next = anal.LOOK(s, ctx);
            return next;
        } else {
            if (s.nextTokenWithinRule) return s.nextTokenWithinRule;
            s.nextTokenWithinRule = this.nextTokens(s, $2EGxJ.PredictionContext.EMPTY_LOCAL);
            s.nextTokenWithinRule.setReadonly(true);
            return s.nextTokenWithinRule;
        }
    }
    addState(state) {
        state.atn = this;
        state.stateNumber = this.states.length;
        this.states.push(state);
    }
    removeState(state) {
        // just replace the state, don't shift states in list
        let invalidState = new $biTmn.InvalidState();
        invalidState.atn = this;
        invalidState.stateNumber = state.stateNumber;
        this.states[state.stateNumber] = invalidState;
    }
    defineMode(name, s) {
        this.modeNameToStartState.set(name, s);
        this.modeToStartState.push(s);
        this.modeToDFA.push(new $6AYuC.DFA(s));
        this.defineDecisionState(s);
    }
    defineDecisionState(s) {
        this.decisionToState.push(s);
        s.decision = this.decisionToState.length - 1;
        this.decisionToDFA.push(new $6AYuC.DFA(s, s.decision));
        return s.decision;
    }
    getDecisionState(decision) {
        if (this.decisionToState.length > 0) return this.decisionToState[decision];
        return undefined;
    }
    get numberOfDecisions() {
        return this.decisionToState.length;
    }
    /**
     * Computes the set of input symbols which could follow ATN state number
     * `stateNumber` in the specified full `context`. This method
     * considers the complete parser context, but does not evaluate semantic
     * predicates (i.e. all predicates encountered during the calculation are
     * assumed true). If a path in the ATN exists from the starting state to the
     * {@link RuleStopState} of the outermost context without matching any
     * symbols, {@link Token#EOF} is added to the returned set.
     *
     * If `context` is `undefined`, it is treated as
     * {@link ParserRuleContext#EMPTY}.
     *
     * Note that this does NOT give you the set of all tokens that could
     * appear at a given token position in the input phrase.  In other words, it
     * does not answer:
     *
     * > Given a specific partial input phrase, return the set of all
     * > tokens that can follow the last token in the input phrase.
     *
     * The big difference is that with just the input, the parser could land
     * right in the middle of a lookahead decision. Getting all
     * *possible* tokens given a partial input stream is a separate
     * computation. See https://github.com/antlr/antlr4/issues/1428
     *
     * For this function, we are specifying an ATN state and call stack to
     * compute what token(s) can come next and specifically: outside of a
     * lookahead decision. That is what you want for error reporting and
     * recovery upon parse error.
     *
     * @param stateNumber the ATN state number
     * @param context the full parse context
     * @returns The set of potentially valid input symbols which could follow the
     * specified state in the specified context.
     * @ if the ATN does not contain a state with
     * number `stateNumber`
     */ getExpectedTokens(stateNumber, context) {
        if (stateNumber < 0 || stateNumber >= this.states.length) throw new RangeError("Invalid state number.");
        let ctx = context;
        let s = this.states[stateNumber];
        let following = this.nextTokens(s);
        if (!following.contains($TNDGs.Token.EPSILON)) return following;
        let expected = new $69z5o.IntervalSet();
        expected.addAll(following);
        expected.remove($TNDGs.Token.EPSILON);
        while(ctx != null && ctx.invokingState >= 0 && following.contains($TNDGs.Token.EPSILON)){
            let invokingState = this.states[ctx.invokingState];
            let rt = invokingState.transition(0);
            following = this.nextTokens(rt.followState);
            expected.addAll(following);
            expected.remove($TNDGs.Token.EPSILON);
            ctx = ctx._parent;
        }
        if (following.contains($TNDGs.Token.EPSILON)) expected.add($TNDGs.Token.EOF);
        return expected;
    }
    /** Used for runtime deserialization of ATNs from strings */ constructor(grammarType, maxTokenType){
        this.states = [];
        /** Each subrule/rule is a decision point and we must track them so we
         *  can go back later and build DFA predictors for them.  This includes
         *  all the rules, subrules, optional blocks, ()+, ()* etc...
         */ this.decisionToState = [];
        this.modeNameToStartState = new Map();
        this.modeToStartState = [];
        this.contextCache = new $5ZofD.Array2DHashMap($9PlGk.ObjectEqualityComparator.INSTANCE);
        this.decisionToDFA = [];
        this.modeToDFA = [];
        this.LL1Table = new Map();
        this.grammarType = grammarType;
        this.maxTokenType = maxTokenType;
    }
};
$27cce641551d937f$var$__decorate([
    $ffTXa.NotNull
], $27cce641551d937f$var$ATN.prototype, "states", void 0);
$27cce641551d937f$var$__decorate([
    $ffTXa.NotNull
], $27cce641551d937f$var$ATN.prototype, "decisionToState", void 0);
$27cce641551d937f$var$__decorate([
    $ffTXa.NotNull
], $27cce641551d937f$var$ATN.prototype, "modeNameToStartState", void 0);
$27cce641551d937f$var$__decorate([
    $ffTXa.NotNull
], $27cce641551d937f$var$ATN.prototype, "modeToStartState", void 0);
$27cce641551d937f$var$__decorate([
    $ffTXa.NotNull
], $27cce641551d937f$var$ATN.prototype, "decisionToDFA", void 0);
$27cce641551d937f$var$__decorate([
    $ffTXa.NotNull
], $27cce641551d937f$var$ATN.prototype, "modeToDFA", void 0);
$27cce641551d937f$var$__decorate([
    $ffTXa.NotNull
], $27cce641551d937f$var$ATN.prototype, "nextTokens", null);
$27cce641551d937f$var$__decorate([
    $27cce641551d937f$var$__param(0, $ffTXa.NotNull)
], $27cce641551d937f$var$ATN.prototype, "removeState", null);
$27cce641551d937f$var$__decorate([
    $27cce641551d937f$var$__param(0, $ffTXa.NotNull),
    $27cce641551d937f$var$__param(1, $ffTXa.NotNull)
], $27cce641551d937f$var$ATN.prototype, "defineMode", null);
$27cce641551d937f$var$__decorate([
    $27cce641551d937f$var$__param(0, $ffTXa.NotNull)
], $27cce641551d937f$var$ATN.prototype, "defineDecisionState", null);
$27cce641551d937f$var$__decorate([
    $ffTXa.NotNull
], $27cce641551d937f$var$ATN.prototype, "getExpectedTokens", null);
$27cce641551d937f$var$ATN = $27cce641551d937f$var$__decorate([
    $27cce641551d937f$var$__param(0, $ffTXa.NotNull)
], $27cce641551d937f$var$ATN);
module.exports.ATN = $27cce641551d937f$var$ATN;
(function(ATN) {
    ATN.INVALID_ALT_NUMBER = 0;
})($27cce641551d937f$var$ATN = module.exports.ATN || (module.exports.ATN = {}));
module.exports.ATN = $27cce641551d937f$var$ATN;

});

parcelRegister("64vb9", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $46bb4d49e2d9fd05$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNConfigSet = void 0;

var $5ZofD = parcelRequire("5ZofD");


var $c90ex = parcelRequire("c90ex");


var $9mjSw = parcelRequire("9mjSw");


var $3pR6v = parcelRequire("3pR6v");


var $cxg6R = parcelRequire("cxg6R");


var $kJZRw = parcelRequire("kJZRw");


var $ffTXa = parcelRequire("ffTXa");


var $9PlGk = parcelRequire("9PlGk");


var $2EGxJ = parcelRequire("2EGxJ");


var $54abU = parcelRequire("54abU");


var $3LYKb = parcelRequire("3LYKb");


var $9Rq82 = parcelRequire("9Rq82");


var $3jpAZ = parcelRequire("3jpAZ");

class $46bb4d49e2d9fd05$var$KeyTypeEqualityComparer {
    hashCode(key) {
        return key.state ^ key.alt;
    }
    equals(a, b) {
        return a.state === b.state && a.alt === b.alt;
    }
}
$46bb4d49e2d9fd05$var$KeyTypeEqualityComparer.INSTANCE = new $46bb4d49e2d9fd05$var$KeyTypeEqualityComparer();
function $46bb4d49e2d9fd05$var$NewKeyedConfigMap(map) {
    if (map) return new $5ZofD.Array2DHashMap(map);
    else return new $5ZofD.Array2DHashMap($46bb4d49e2d9fd05$var$KeyTypeEqualityComparer.INSTANCE);
}
/**
 * Represents a set of ATN configurations (see `ATNConfig`). As configurations are added to the set, they are merged
 * with other `ATNConfig` instances already in the set when possible using the graph-structured stack.
 *
 * An instance of this class represents the complete set of positions (with context) in an ATN which would be associated
 * with a single DFA state. Its internal representation is more complex than traditional state used for NFA to DFA
 * conversion due to performance requirements (both improving speed and reducing memory overhead) as well as supporting
 * features such as semantic predicates and non-greedy operators in a form to support ANTLR's prediction algorithm.
 *
 * @author Sam Harwell
 */ class $46bb4d49e2d9fd05$var$ATNConfigSet {
    /**
     * Get the set of all alternatives represented by configurations in this
     * set.
     */ getRepresentedAlternatives() {
        if (this._conflictInfo != null) return this._conflictInfo.conflictedAlts.clone();
        let alts = new $kJZRw.BitSet();
        for (let config of this)alts.set(config.alt);
        return alts;
    }
    get isReadOnly() {
        return this.mergedConfigs == null;
    }
    get isOutermostConfigSet() {
        return this.outermostConfigSet;
    }
    set isOutermostConfigSet(outermostConfigSet) {
        if (this.outermostConfigSet && !outermostConfigSet) throw new Error("IllegalStateException");
        $9Rq82(!outermostConfigSet || !this._dipsIntoOuterContext);
        this.outermostConfigSet = outermostConfigSet;
    }
    getStates() {
        let states = new $c90ex.Array2DHashSet($9PlGk.ObjectEqualityComparator.INSTANCE);
        for (let c of this.configs)states.add(c.state);
        return states;
    }
    optimizeConfigs(interpreter) {
        if (this.configs.length === 0) return;
        for (let config of this.configs)config.context = interpreter.atn.getCachedContext(config.context);
    }
    clone(readonly) {
        let copy = new $46bb4d49e2d9fd05$var$ATNConfigSet(this, readonly);
        if (!readonly && this.isReadOnly) copy.addAll(this.configs);
        return copy;
    }
    get size() {
        return this.configs.length;
    }
    get isEmpty() {
        return this.configs.length === 0;
    }
    contains(o) {
        if (!(o instanceof $cxg6R.ATNConfig)) return false;
        if (this.mergedConfigs && this.unmerged) {
            let config = o;
            let configKey = this.getKey(config);
            let mergedConfig = this.mergedConfigs.get(configKey);
            if (mergedConfig != null && this.canMerge(config, configKey, mergedConfig)) return mergedConfig.contains(config);
            for (let c of this.unmerged){
                if (c.contains(o)) return true;
            }
        } else for (let c of this.configs){
            if (c.contains(o)) return true;
        }
        return false;
    }
    *[Symbol.iterator]() {
        yield* this.configs;
    }
    toArray() {
        return this.configs;
    }
    add(e, contextCache) {
        this.ensureWritable();
        if (!this.mergedConfigs || !this.unmerged) throw new Error("Covered by ensureWritable but duplicated here for strict null check limitation");
        $9Rq82(!this.outermostConfigSet || !e.reachesIntoOuterContext);
        if (contextCache == null) contextCache = $54abU.PredictionContextCache.UNCACHED;
        let addKey;
        let key = this.getKey(e);
        let mergedConfig = this.mergedConfigs.get(key);
        addKey = mergedConfig == null;
        if (mergedConfig != null && this.canMerge(e, key, mergedConfig)) {
            mergedConfig.outerContextDepth = Math.max(mergedConfig.outerContextDepth, e.outerContextDepth);
            if (e.isPrecedenceFilterSuppressed) mergedConfig.isPrecedenceFilterSuppressed = true;
            let joined = $2EGxJ.PredictionContext.join(mergedConfig.context, e.context, contextCache);
            this.updatePropertiesForMergedConfig(e);
            if (mergedConfig.context === joined) return false;
            mergedConfig.context = joined;
            return true;
        }
        for(let i = 0; i < this.unmerged.length; i++){
            let unmergedConfig = this.unmerged[i];
            if (this.canMerge(e, key, unmergedConfig)) {
                unmergedConfig.outerContextDepth = Math.max(unmergedConfig.outerContextDepth, e.outerContextDepth);
                if (e.isPrecedenceFilterSuppressed) unmergedConfig.isPrecedenceFilterSuppressed = true;
                let joined = $2EGxJ.PredictionContext.join(unmergedConfig.context, e.context, contextCache);
                this.updatePropertiesForMergedConfig(e);
                if (unmergedConfig.context === joined) return false;
                unmergedConfig.context = joined;
                if (addKey) {
                    this.mergedConfigs.put(key, unmergedConfig);
                    this.unmerged.splice(i, 1);
                }
                return true;
            }
        }
        this.configs.push(e);
        if (addKey) this.mergedConfigs.put(key, e);
        else this.unmerged.push(e);
        this.updatePropertiesForAddedConfig(e);
        return true;
    }
    updatePropertiesForMergedConfig(config) {
        // merged configs can't change the alt or semantic context
        this._dipsIntoOuterContext = this._dipsIntoOuterContext || config.reachesIntoOuterContext;
        $9Rq82(!this.outermostConfigSet || !this._dipsIntoOuterContext);
    }
    updatePropertiesForAddedConfig(config) {
        if (this.configs.length === 1) this._uniqueAlt = config.alt;
        else if (this._uniqueAlt !== config.alt) this._uniqueAlt = $3pR6v.ATN.INVALID_ALT_NUMBER;
        this._hasSemanticContext = this._hasSemanticContext || !$3LYKb.SemanticContext.NONE.equals(config.semanticContext);
        this._dipsIntoOuterContext = this._dipsIntoOuterContext || config.reachesIntoOuterContext;
        $9Rq82(!this.outermostConfigSet || !this._dipsIntoOuterContext);
    }
    canMerge(left, leftKey, right) {
        if (left.state.stateNumber !== right.state.stateNumber) return false;
        if (leftKey.alt !== right.alt) return false;
        return left.semanticContext.equals(right.semanticContext);
    }
    getKey(e) {
        return {
            state: e.state.stateNumber,
            alt: e.alt
        };
    }
    containsAll(c) {
        for (let o of c){
            if (!(o instanceof $cxg6R.ATNConfig)) return false;
            if (!this.contains(o)) return false;
        }
        return true;
    }
    addAll(c, contextCache) {
        this.ensureWritable();
        let changed = false;
        for (let group of c)if (this.add(group, contextCache)) changed = true;
        return changed;
    }
    clear() {
        this.ensureWritable();
        if (!this.mergedConfigs || !this.unmerged) throw new Error("Covered by ensureWritable but duplicated here for strict null check limitation");
        this.mergedConfigs.clear();
        this.unmerged.length = 0;
        this.configs.length = 0;
        this._dipsIntoOuterContext = false;
        this._hasSemanticContext = false;
        this._uniqueAlt = $3pR6v.ATN.INVALID_ALT_NUMBER;
        this._conflictInfo = undefined;
    }
    equals(obj) {
        if (this === obj) return true;
        if (!(obj instanceof $46bb4d49e2d9fd05$var$ATNConfigSet)) return false;
        return this.outermostConfigSet === obj.outermostConfigSet && $3jpAZ.equals(this._conflictInfo, obj._conflictInfo) && $9mjSw.ArrayEqualityComparator.INSTANCE.equals(this.configs, obj.configs);
    }
    hashCode() {
        if (this.isReadOnly && this.cachedHashCode !== -1) return this.cachedHashCode;
        let hashCode = 1;
        hashCode = 5 * hashCode ^ (this.outermostConfigSet ? 1 : 0);
        hashCode = 5 * hashCode ^ $9mjSw.ArrayEqualityComparator.INSTANCE.hashCode(this.configs);
        if (this.isReadOnly) this.cachedHashCode = hashCode;
        return hashCode;
    }
    toString(showContext) {
        if (showContext == null) showContext = false;
        let buf = "";
        let sortedConfigs = this.configs.slice(0);
        sortedConfigs.sort((o1, o2)=>{
            if (o1.alt !== o2.alt) return o1.alt - o2.alt;
            else if (o1.state.stateNumber !== o2.state.stateNumber) return o1.state.stateNumber - o2.state.stateNumber;
            else return o1.semanticContext.toString().localeCompare(o2.semanticContext.toString());
        });
        buf += "[";
        for(let i = 0; i < sortedConfigs.length; i++){
            if (i > 0) buf += ", ";
            buf += sortedConfigs[i].toString(undefined, true, showContext);
        }
        buf += "]";
        if (this._hasSemanticContext) buf += ",hasSemanticContext=" + this._hasSemanticContext;
        if (this._uniqueAlt !== $3pR6v.ATN.INVALID_ALT_NUMBER) buf += ",uniqueAlt=" + this._uniqueAlt;
        if (this._conflictInfo != null) {
            buf += ",conflictingAlts=" + this._conflictInfo.conflictedAlts;
            if (!this._conflictInfo.isExact) buf += "*";
        }
        if (this._dipsIntoOuterContext) buf += ",dipsIntoOuterContext";
        return buf.toString();
    }
    get uniqueAlt() {
        return this._uniqueAlt;
    }
    get hasSemanticContext() {
        return this._hasSemanticContext;
    }
    set hasSemanticContext(value) {
        this.ensureWritable();
        this._hasSemanticContext = value;
    }
    get conflictInfo() {
        return this._conflictInfo;
    }
    set conflictInfo(conflictInfo) {
        this.ensureWritable();
        this._conflictInfo = conflictInfo;
    }
    get conflictingAlts() {
        if (this._conflictInfo == null) return undefined;
        return this._conflictInfo.conflictedAlts;
    }
    get isExactConflict() {
        if (this._conflictInfo == null) return false;
        return this._conflictInfo.isExact;
    }
    get dipsIntoOuterContext() {
        return this._dipsIntoOuterContext;
    }
    get(index) {
        return this.configs[index];
    }
    ensureWritable() {
        if (this.isReadOnly) throw new Error("This ATNConfigSet is read only.");
    }
    constructor(set, readonly){
        this._uniqueAlt = 0;
        // Used in parser and lexer. In lexer, it indicates we hit a pred
        // while computing a closure operation.  Don't make a DFA state from this.
        this._hasSemanticContext = false;
        this._dipsIntoOuterContext = false;
        /**
         * When `true`, this config set represents configurations where the entire
         * outer context has been consumed by the ATN interpreter. This prevents the
         * {@link ParserATNSimulator#closure} from pursuing the global FOLLOW when a
         * rule stop state is reached with an empty prediction context.
         *
         * Note: `outermostConfigSet` and {@link #dipsIntoOuterContext} should never
         * be true at the same time.
         */ this.outermostConfigSet = false;
        this.cachedHashCode = -1;
        if (!set) {
            this.mergedConfigs = $46bb4d49e2d9fd05$var$NewKeyedConfigMap();
            this.unmerged = [];
            this.configs = [];
            this._uniqueAlt = $3pR6v.ATN.INVALID_ALT_NUMBER;
        } else {
            if (readonly) {
                this.mergedConfigs = undefined;
                this.unmerged = undefined;
            } else if (!set.isReadOnly) {
                this.mergedConfigs = $46bb4d49e2d9fd05$var$NewKeyedConfigMap(set.mergedConfigs);
                this.unmerged = set.unmerged.slice(0);
            } else {
                this.mergedConfigs = $46bb4d49e2d9fd05$var$NewKeyedConfigMap();
                this.unmerged = [];
            }
            this.configs = set.configs.slice(0);
            this._dipsIntoOuterContext = set._dipsIntoOuterContext;
            this._hasSemanticContext = set._hasSemanticContext;
            this.outermostConfigSet = set.outermostConfigSet;
            if (readonly || !set.isReadOnly) {
                this._uniqueAlt = set._uniqueAlt;
                this._conflictInfo = set._conflictInfo;
            }
        // if (!readonly && set.isReadOnly) -> addAll is called from clone()
        }
    }
}
$46bb4d49e2d9fd05$var$__decorate([
    $ffTXa.NotNull
], $46bb4d49e2d9fd05$var$ATNConfigSet.prototype, "getRepresentedAlternatives", null);
$46bb4d49e2d9fd05$var$__decorate([
    $ffTXa.Override
], $46bb4d49e2d9fd05$var$ATNConfigSet.prototype, "size", null);
$46bb4d49e2d9fd05$var$__decorate([
    $ffTXa.Override
], $46bb4d49e2d9fd05$var$ATNConfigSet.prototype, "isEmpty", null);
$46bb4d49e2d9fd05$var$__decorate([
    $ffTXa.Override
], $46bb4d49e2d9fd05$var$ATNConfigSet.prototype, "contains", null);
$46bb4d49e2d9fd05$var$__decorate([
    $ffTXa.Override
], $46bb4d49e2d9fd05$var$ATNConfigSet.prototype, Symbol.iterator, null);
$46bb4d49e2d9fd05$var$__decorate([
    $ffTXa.Override
], $46bb4d49e2d9fd05$var$ATNConfigSet.prototype, "toArray", null);
$46bb4d49e2d9fd05$var$__decorate([
    $ffTXa.Override
], $46bb4d49e2d9fd05$var$ATNConfigSet.prototype, "containsAll", null);
$46bb4d49e2d9fd05$var$__decorate([
    $ffTXa.Override
], $46bb4d49e2d9fd05$var$ATNConfigSet.prototype, "clear", null);
$46bb4d49e2d9fd05$var$__decorate([
    $ffTXa.Override
], $46bb4d49e2d9fd05$var$ATNConfigSet.prototype, "equals", null);
$46bb4d49e2d9fd05$var$__decorate([
    $ffTXa.Override
], $46bb4d49e2d9fd05$var$ATNConfigSet.prototype, "hashCode", null);
module.exports.ATNConfigSet = $46bb4d49e2d9fd05$var$ATNConfigSet;

});

parcelRegister("cxg6R", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9205102382ff4c76$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9205102382ff4c76$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNConfig = void 0;

var $5ZofD = parcelRequire("5ZofD");


var $gh7Hp = parcelRequire("gh7Hp");


var $kPsXR = parcelRequire("kPsXR");


var $ffTXa = parcelRequire("ffTXa");


var $9PlGk = parcelRequire("9PlGk");


var $2EGxJ = parcelRequire("2EGxJ");


var $3LYKb = parcelRequire("3LYKb");


var $9Rq82 = parcelRequire("9Rq82");

/**
 * This field stores the bit mask for implementing the
 * {@link #isPrecedenceFilterSuppressed} property as a bit within the
 * existing {@link #altAndOuterContextDepth} field.
 */ const $9205102382ff4c76$var$SUPPRESS_PRECEDENCE_FILTER = 0x80000000;
/**
 * Represents a location with context in an ATN. The location is identified by the following values:
 *
 * * The current ATN state
 * * The predicted alternative
 * * The semantic context which must be true for this configuration to be enabled
 * * The syntactic context, which is represented as a graph-structured stack whose path(s) lead to the root of the rule
 *   invocations leading to this state
 *
 * In addition to these values, `ATNConfig` stores several properties about paths taken to get to the location which
 * were added over time to help with performance, correctness, and/or debugging.
 *
 * * `reachesIntoOuterContext`:: Used to ensure semantic predicates are not evaluated in the wrong context.
 * * `hasPassedThroughNonGreedyDecision`: Used for enabling first-match-wins instead of longest-match-wins after
 *   crossing a non-greedy decision.
 * * `lexerActionExecutor`: Used for tracking the lexer action(s) to execute should this instance be selected during
 *   lexing.
 * * `isPrecedenceFilterSuppressed`: A state variable for one of the dynamic disambiguation strategies employed by
 *   `ParserATNSimulator.applyPrecedenceFilter`.
 *
 * Due to the use of a graph-structured stack, a single `ATNConfig` is capable of representing many individual ATN
 * configurations which reached the same location in an ATN by following different paths.
 *
 * PERF: To conserve memory, `ATNConfig` is split into several different concrete types. `ATNConfig` itself stores the
 * minimum amount of information typically used to define an `ATNConfig` instance. Various derived types provide
 * additional storage space for cases where a non-default value is used for some of the object properties. The
 * `ATNConfig.create` and `ATNConfig.transform` methods automatically select the smallest concrete type capable of
 * representing the unique information for any given `ATNConfig`.
 */ let $9205102382ff4c76$var$ATNConfig = class ATNConfig {
    static create(state, alt, context, semanticContext = $3LYKb.SemanticContext.NONE, lexerActionExecutor) {
        if (semanticContext !== $3LYKb.SemanticContext.NONE) {
            if (lexerActionExecutor != null) return new $9205102382ff4c76$var$ActionSemanticContextATNConfig(lexerActionExecutor, semanticContext, state, alt, context, false);
            else return new $9205102382ff4c76$var$SemanticContextATNConfig(semanticContext, state, alt, context);
        } else if (lexerActionExecutor != null) return new $9205102382ff4c76$var$ActionATNConfig(lexerActionExecutor, state, alt, context, false);
        else return new ATNConfig(state, alt, context);
    }
    /** Gets the ATN state associated with this configuration */ get state() {
        return this._state;
    }
    /** What alt (or lexer rule) is predicted by this configuration */ get alt() {
        return this.altAndOuterContextDepth & 0x00FFFFFF;
    }
    get context() {
        return this._context;
    }
    set context(context) {
        this._context = context;
    }
    get reachesIntoOuterContext() {
        return this.outerContextDepth !== 0;
    }
    /**
     * We cannot execute predicates dependent upon local context unless
     * we know for sure we are in the correct context. Because there is
     * no way to do this efficiently, we simply cannot evaluate
     * dependent predicates unless we are in the rule that initially
     * invokes the ATN simulator.
     *
     * closure() tracks the depth of how far we dip into the outer context:
     * depth &gt; 0.  Note that it may not be totally accurate depth since I
     * don't ever decrement. TODO: make it a boolean then
     */ get outerContextDepth() {
        return this.altAndOuterContextDepth >>> 24 & 0x7F;
    }
    set outerContextDepth(outerContextDepth) {
        $9Rq82(outerContextDepth >= 0);
        // saturate at 0x7F - everything but zero/positive is only used for debug information anyway
        outerContextDepth = Math.min(outerContextDepth, 0x7F);
        this.altAndOuterContextDepth = outerContextDepth << 24 | (this.altAndOuterContextDepth & -2130706433) >>> 0;
    }
    get lexerActionExecutor() {
        return undefined;
    }
    get semanticContext() {
        return $3LYKb.SemanticContext.NONE;
    }
    get hasPassedThroughNonGreedyDecision() {
        return false;
    }
    clone() {
        return this.transform(this.state, false);
    }
    transform(/*@NotNull*/ state, checkNonGreedy, arg2) {
        if (arg2 == null) return this.transformImpl(state, this._context, this.semanticContext, checkNonGreedy, this.lexerActionExecutor);
        else if (arg2 instanceof $2EGxJ.PredictionContext) return this.transformImpl(state, arg2, this.semanticContext, checkNonGreedy, this.lexerActionExecutor);
        else if (arg2 instanceof $3LYKb.SemanticContext) return this.transformImpl(state, this._context, arg2, checkNonGreedy, this.lexerActionExecutor);
        else return this.transformImpl(state, this._context, this.semanticContext, checkNonGreedy, arg2);
    }
    transformImpl(state, context, semanticContext, checkNonGreedy, lexerActionExecutor) {
        let passedThroughNonGreedy = checkNonGreedy && ATNConfig.checkNonGreedyDecision(this, state);
        if (semanticContext !== $3LYKb.SemanticContext.NONE) {
            if (lexerActionExecutor != null || passedThroughNonGreedy) return new $9205102382ff4c76$var$ActionSemanticContextATNConfig(lexerActionExecutor, semanticContext, state, this, context, passedThroughNonGreedy);
            else return new $9205102382ff4c76$var$SemanticContextATNConfig(semanticContext, state, this, context);
        } else if (lexerActionExecutor != null || passedThroughNonGreedy) return new $9205102382ff4c76$var$ActionATNConfig(lexerActionExecutor, state, this, context, passedThroughNonGreedy);
        else return new ATNConfig(state, this, context);
    }
    static checkNonGreedyDecision(source, target) {
        return source.hasPassedThroughNonGreedyDecision || target instanceof $gh7Hp.DecisionState && target.nonGreedy;
    }
    appendContext(context, contextCache) {
        if (typeof context === "number") {
            let appendedContext = this.context.appendSingleContext(context, contextCache);
            let result = this.transform(this.state, false, appendedContext);
            return result;
        } else {
            let appendedContext = this.context.appendContext(context, contextCache);
            let result = this.transform(this.state, false, appendedContext);
            return result;
        }
    }
    /**
     * Determines if this `ATNConfig` fully contains another `ATNConfig`.
     *
     * An ATN configuration represents a position (including context) in an ATN during parsing. Since `ATNConfig` stores
     * the context as a graph, a single `ATNConfig` instance is capable of representing many ATN configurations which
     * are all in the same "location" but have different contexts. These `ATNConfig` instances are again merged when
     * they are added to an `ATNConfigSet`. This method supports `ATNConfigSet.contains` by evaluating whether a
     * particular `ATNConfig` contains all of the ATN configurations represented by another `ATNConfig`.
     *
     * An `ATNConfig` _a_ contains another `ATNConfig` _b_ if all of the following conditions are met:
     *
     * * The configurations are in the same state (`state`)
     * * The configurations predict the same alternative (`alt`)
     * * The semantic context of _a_ implies the semantic context of _b_ (this method performs a weaker equality check)
     * * Joining the prediction contexts of _a_ and _b_ results in the prediction context of _a_
     *
     * This method implements a conservative approximation of containment. As a result, when this method returns `true`
     * it is known that parsing from `subconfig` can only recognize a subset of the inputs which can be recognized
     * starting at the current `ATNConfig`. However, due to the imprecise evaluation of implication for the semantic
     * contexts, no assumptions can be made about the relationship between the configurations when this method returns
     * `false`.
     *
     * @param subconfig The sub configuration.
     * @returns `true` if this configuration contains `subconfig`; otherwise, `false`.
     */ contains(subconfig) {
        if (this.state.stateNumber !== subconfig.state.stateNumber || this.alt !== subconfig.alt || !this.semanticContext.equals(subconfig.semanticContext)) return false;
        let leftWorkList = [];
        let rightWorkList = [];
        leftWorkList.push(this.context);
        rightWorkList.push(subconfig.context);
        while(true){
            let left = leftWorkList.pop();
            let right = rightWorkList.pop();
            if (!left || !right) break;
            if (left === right) return true;
            if (left.size < right.size) return false;
            if (right.isEmpty) return left.hasEmpty;
            else for(let i = 0; i < right.size; i++){
                let index = left.findReturnState(right.getReturnState(i));
                if (index < 0) // assumes invokingStates has no duplicate entries
                return false;
                leftWorkList.push(left.getParent(index));
                rightWorkList.push(right.getParent(i));
            }
        }
        return false;
    }
    get isPrecedenceFilterSuppressed() {
        return (this.altAndOuterContextDepth & $9205102382ff4c76$var$SUPPRESS_PRECEDENCE_FILTER) !== 0;
    }
    set isPrecedenceFilterSuppressed(value) {
        if (value) this.altAndOuterContextDepth |= $9205102382ff4c76$var$SUPPRESS_PRECEDENCE_FILTER;
        else this.altAndOuterContextDepth &= ~$9205102382ff4c76$var$SUPPRESS_PRECEDENCE_FILTER;
    }
    /** An ATN configuration is equal to another if both have
     *  the same state, they predict the same alternative, and
     *  syntactic/semantic contexts are the same.
     */ equals(o) {
        if (this === o) return true;
        else if (!(o instanceof ATNConfig)) return false;
        return this.state.stateNumber === o.state.stateNumber && this.alt === o.alt && this.reachesIntoOuterContext === o.reachesIntoOuterContext && this.context.equals(o.context) && this.semanticContext.equals(o.semanticContext) && this.isPrecedenceFilterSuppressed === o.isPrecedenceFilterSuppressed && this.hasPassedThroughNonGreedyDecision === o.hasPassedThroughNonGreedyDecision && $9PlGk.ObjectEqualityComparator.INSTANCE.equals(this.lexerActionExecutor, o.lexerActionExecutor);
    }
    hashCode() {
        let hashCode = $kPsXR.MurmurHash.initialize(7);
        hashCode = $kPsXR.MurmurHash.update(hashCode, this.state.stateNumber);
        hashCode = $kPsXR.MurmurHash.update(hashCode, this.alt);
        hashCode = $kPsXR.MurmurHash.update(hashCode, this.reachesIntoOuterContext ? 1 : 0);
        hashCode = $kPsXR.MurmurHash.update(hashCode, this.context);
        hashCode = $kPsXR.MurmurHash.update(hashCode, this.semanticContext);
        hashCode = $kPsXR.MurmurHash.update(hashCode, this.hasPassedThroughNonGreedyDecision ? 1 : 0);
        hashCode = $kPsXR.MurmurHash.update(hashCode, this.lexerActionExecutor);
        hashCode = $kPsXR.MurmurHash.finish(hashCode, 7);
        return hashCode;
    }
    /**
     * Returns a graphical representation of the current `ATNConfig` in Graphviz format. The graph can be stored to a
     * **.dot** file and then rendered to an image using Graphviz.
     *
     * @returns A Graphviz graph representing the current `ATNConfig`.
     *
     * @see http://www.graphviz.org/
     */ toDotString() {
        let builder = "";
        builder += "digraph G {\n";
        builder += "rankdir=LR;\n";
        let visited = new $5ZofD.Array2DHashMap($2EGxJ.PredictionContext.IdentityEqualityComparator.INSTANCE);
        let workList = [];
        function getOrAddContext(context) {
            let newNumber = visited.size;
            let result = visited.putIfAbsent(context, newNumber);
            if (result != null) // Already saw this context
            return result;
            workList.push(context);
            return newNumber;
        }
        workList.push(this.context);
        visited.put(this.context, 0);
        while(true){
            let current = workList.pop();
            if (!current) break;
            for(let i = 0; i < current.size; i++){
                builder += "  s" + getOrAddContext(current);
                builder += "->";
                builder += "s" + getOrAddContext(current.getParent(i));
                builder += "[label=\"" + current.getReturnState(i) + "\"];\n";
            }
        }
        builder += "}\n";
        return builder.toString();
    }
    toString(recog, showAlt, showContext) {
        // Must check showContext before showAlt to preserve original overload behavior
        if (showContext == null) showContext = showAlt != null;
        if (showAlt == null) showAlt = true;
        let buf = "";
        // if (this.state.ruleIndex >= 0) {
        // 	if (recog != null) {
        // 		buf += (recog.ruleNames[this.state.ruleIndex] + ":");
        // 	} else {
        // 		buf += (this.state.ruleIndex + ":");
        // 	}
        // }
        let contexts;
        if (showContext) contexts = this.context.toStrings(recog, this.state.stateNumber);
        else contexts = [
            "?"
        ];
        let first = true;
        for (let contextDesc of contexts){
            if (first) first = false;
            else buf += ", ";
            buf += "(";
            buf += this.state;
            if (showAlt) {
                buf += ",";
                buf += this.alt;
            }
            if (this.context) {
                buf += ",";
                buf += contextDesc;
            }
            if (this.semanticContext !== $3LYKb.SemanticContext.NONE) {
                buf += ",";
                buf += this.semanticContext;
            }
            if (this.reachesIntoOuterContext) buf += ",up=" + this.outerContextDepth;
            buf += ")";
        }
        return buf.toString();
    }
    constructor(state, altOrConfig, context){
        if (typeof altOrConfig === "number") {
            $9Rq82((altOrConfig & 0xFFFFFF) === altOrConfig);
            this._state = state;
            this.altAndOuterContextDepth = altOrConfig;
            this._context = context;
        } else {
            this._state = state;
            this.altAndOuterContextDepth = altOrConfig.altAndOuterContextDepth;
            this._context = context;
        }
    }
};
$9205102382ff4c76$var$__decorate([
    $ffTXa.NotNull
], $9205102382ff4c76$var$ATNConfig.prototype, "_state", void 0);
$9205102382ff4c76$var$__decorate([
    $ffTXa.NotNull
], $9205102382ff4c76$var$ATNConfig.prototype, "_context", void 0);
$9205102382ff4c76$var$__decorate([
    $ffTXa.NotNull
], $9205102382ff4c76$var$ATNConfig.prototype, "state", null);
$9205102382ff4c76$var$__decorate([
    $ffTXa.NotNull,
    $9205102382ff4c76$var$__param(0, $ffTXa.NotNull)
], $9205102382ff4c76$var$ATNConfig.prototype, "context", null);
$9205102382ff4c76$var$__decorate([
    $ffTXa.NotNull
], $9205102382ff4c76$var$ATNConfig.prototype, "semanticContext", null);
$9205102382ff4c76$var$__decorate([
    $ffTXa.Override
], $9205102382ff4c76$var$ATNConfig.prototype, "clone", null);
$9205102382ff4c76$var$__decorate([
    $9205102382ff4c76$var$__param(0, $ffTXa.NotNull),
    $9205102382ff4c76$var$__param(2, $ffTXa.NotNull)
], $9205102382ff4c76$var$ATNConfig.prototype, "transformImpl", null);
$9205102382ff4c76$var$__decorate([
    $ffTXa.Override
], $9205102382ff4c76$var$ATNConfig.prototype, "equals", null);
$9205102382ff4c76$var$__decorate([
    $ffTXa.Override
], $9205102382ff4c76$var$ATNConfig.prototype, "hashCode", null);
$9205102382ff4c76$var$__decorate([
    $9205102382ff4c76$var$__param(0, $ffTXa.NotNull),
    $9205102382ff4c76$var$__param(3, $ffTXa.NotNull)
], $9205102382ff4c76$var$ATNConfig, "create", null);
$9205102382ff4c76$var$ATNConfig = $9205102382ff4c76$var$__decorate([
    $9205102382ff4c76$var$__param(0, $ffTXa.NotNull),
    $9205102382ff4c76$var$__param(2, $ffTXa.NotNull)
], $9205102382ff4c76$var$ATNConfig);
module.exports.ATNConfig = $9205102382ff4c76$var$ATNConfig;
/**
 * This class was derived from `ATNConfig` purely as a memory optimization. It allows for the creation of an `ATNConfig`
 * with a non-default semantic context.
 *
 * See the `ATNConfig` documentation for more information about conserving memory through the use of several concrete
 * types.
 */ let $9205102382ff4c76$var$SemanticContextATNConfig = class SemanticContextATNConfig extends $9205102382ff4c76$var$ATNConfig {
    get semanticContext() {
        return this._semanticContext;
    }
    constructor(semanticContext, state, altOrConfig, context){
        if (typeof altOrConfig === "number") super(state, altOrConfig, context);
        else super(state, altOrConfig, context);
        this._semanticContext = semanticContext;
    }
};
$9205102382ff4c76$var$__decorate([
    $ffTXa.NotNull
], $9205102382ff4c76$var$SemanticContextATNConfig.prototype, "_semanticContext", void 0);
$9205102382ff4c76$var$__decorate([
    $ffTXa.Override
], $9205102382ff4c76$var$SemanticContextATNConfig.prototype, "semanticContext", null);
$9205102382ff4c76$var$SemanticContextATNConfig = $9205102382ff4c76$var$__decorate([
    $9205102382ff4c76$var$__param(1, $ffTXa.NotNull),
    $9205102382ff4c76$var$__param(2, $ffTXa.NotNull)
], $9205102382ff4c76$var$SemanticContextATNConfig);
/**
 * This class was derived from `ATNConfig` purely as a memory optimization. It allows for the creation of an `ATNConfig`
 * with a lexer action.
 *
 * See the `ATNConfig` documentation for more information about conserving memory through the use of several concrete
 * types.
 */ let $9205102382ff4c76$var$ActionATNConfig = class ActionATNConfig extends $9205102382ff4c76$var$ATNConfig {
    get lexerActionExecutor() {
        return this._lexerActionExecutor;
    }
    get hasPassedThroughNonGreedyDecision() {
        return this.passedThroughNonGreedyDecision;
    }
    constructor(lexerActionExecutor, state, altOrConfig, context, passedThroughNonGreedyDecision){
        if (typeof altOrConfig === "number") super(state, altOrConfig, context);
        else {
            super(state, altOrConfig, context);
            if (altOrConfig.semanticContext !== $3LYKb.SemanticContext.NONE) throw new Error("Not supported");
        }
        this._lexerActionExecutor = lexerActionExecutor;
        this.passedThroughNonGreedyDecision = passedThroughNonGreedyDecision;
    }
};
$9205102382ff4c76$var$__decorate([
    $ffTXa.Override
], $9205102382ff4c76$var$ActionATNConfig.prototype, "lexerActionExecutor", null);
$9205102382ff4c76$var$__decorate([
    $ffTXa.Override
], $9205102382ff4c76$var$ActionATNConfig.prototype, "hasPassedThroughNonGreedyDecision", null);
$9205102382ff4c76$var$ActionATNConfig = $9205102382ff4c76$var$__decorate([
    $9205102382ff4c76$var$__param(1, $ffTXa.NotNull),
    $9205102382ff4c76$var$__param(2, $ffTXa.NotNull)
], $9205102382ff4c76$var$ActionATNConfig);
/**
 * This class was derived from `SemanticContextATNConfig` purely as a memory optimization. It allows for the creation of
 * an `ATNConfig` with both a lexer action and a non-default semantic context.
 *
 * See the `ATNConfig` documentation for more information about conserving memory through the use of several concrete
 * types.
 */ let $9205102382ff4c76$var$ActionSemanticContextATNConfig = class ActionSemanticContextATNConfig extends $9205102382ff4c76$var$SemanticContextATNConfig {
    get lexerActionExecutor() {
        return this._lexerActionExecutor;
    }
    get hasPassedThroughNonGreedyDecision() {
        return this.passedThroughNonGreedyDecision;
    }
    constructor(lexerActionExecutor, semanticContext, state, altOrConfig, context, passedThroughNonGreedyDecision){
        if (typeof altOrConfig === "number") super(semanticContext, state, altOrConfig, context);
        else super(semanticContext, state, altOrConfig, context);
        this._lexerActionExecutor = lexerActionExecutor;
        this.passedThroughNonGreedyDecision = passedThroughNonGreedyDecision;
    }
};
$9205102382ff4c76$var$__decorate([
    $ffTXa.Override
], $9205102382ff4c76$var$ActionSemanticContextATNConfig.prototype, "lexerActionExecutor", null);
$9205102382ff4c76$var$__decorate([
    $ffTXa.Override
], $9205102382ff4c76$var$ActionSemanticContextATNConfig.prototype, "hasPassedThroughNonGreedyDecision", null);
$9205102382ff4c76$var$ActionSemanticContextATNConfig = $9205102382ff4c76$var$__decorate([
    $9205102382ff4c76$var$__param(1, $ffTXa.NotNull),
    $9205102382ff4c76$var$__param(2, $ffTXa.NotNull)
], $9205102382ff4c76$var$ActionSemanticContextATNConfig);

});

parcelRegister("gh7Hp", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DecisionState = void 0;

var $2UrJv = parcelRequire("2UrJv");

class $bd9434c43e49bf9b$var$DecisionState extends $2UrJv.ATNState {
    constructor(){
        super(...arguments);
        this.decision = -1;
        this.nonGreedy = false;
        this.sll = false;
    }
}
module.exports.DecisionState = $bd9434c43e49bf9b$var$DecisionState;

});

parcelRegister("2EGxJ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $1ef05160d5d5e5fe$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $1ef05160d5d5e5fe$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SingletonPredictionContext = module.exports.PredictionContext = void 0;

var $5ZofD = parcelRequire("5ZofD");


var $c90ex = parcelRequire("c90ex");


var $kzQll = parcelRequire("kzQll");


var $kPsXR = parcelRequire("kPsXR");


var $ffTXa = parcelRequire("ffTXa");


var $54abU = parcelRequire("54abU");


var $9Rq82 = parcelRequire("9Rq82");

const $1ef05160d5d5e5fe$var$INITIAL_HASH = 1;
class $1ef05160d5d5e5fe$var$PredictionContext {
    static calculateEmptyHashCode() {
        let hash = $kPsXR.MurmurHash.initialize($1ef05160d5d5e5fe$var$INITIAL_HASH);
        hash = $kPsXR.MurmurHash.finish(hash, 0);
        return hash;
    }
    static calculateSingleHashCode(parent, returnState) {
        let hash = $kPsXR.MurmurHash.initialize($1ef05160d5d5e5fe$var$INITIAL_HASH);
        hash = $kPsXR.MurmurHash.update(hash, parent);
        hash = $kPsXR.MurmurHash.update(hash, returnState);
        hash = $kPsXR.MurmurHash.finish(hash, 2);
        return hash;
    }
    static calculateHashCode(parents, returnStates) {
        let hash = $kPsXR.MurmurHash.initialize($1ef05160d5d5e5fe$var$INITIAL_HASH);
        for (let parent of parents)hash = $kPsXR.MurmurHash.update(hash, parent);
        for (let returnState of returnStates)hash = $kPsXR.MurmurHash.update(hash, returnState);
        hash = $kPsXR.MurmurHash.finish(hash, 2 * parents.length);
        return hash;
    }
    static fromRuleContext(atn, outerContext, fullContext = true) {
        if (outerContext.isEmpty) return fullContext ? $1ef05160d5d5e5fe$var$PredictionContext.EMPTY_FULL : $1ef05160d5d5e5fe$var$PredictionContext.EMPTY_LOCAL;
        let parent;
        if (outerContext._parent) parent = $1ef05160d5d5e5fe$var$PredictionContext.fromRuleContext(atn, outerContext._parent, fullContext);
        else parent = fullContext ? $1ef05160d5d5e5fe$var$PredictionContext.EMPTY_FULL : $1ef05160d5d5e5fe$var$PredictionContext.EMPTY_LOCAL;
        let state = atn.states[outerContext.invokingState];
        let transition = state.transition(0);
        return parent.getChild(transition.followState.stateNumber);
    }
    static addEmptyContext(context) {
        return context.addEmptyContext();
    }
    static removeEmptyContext(context) {
        return context.removeEmptyContext();
    }
    static join(context0, context1, contextCache = $54abU.PredictionContextCache.UNCACHED) {
        if (context0 === context1) return context0;
        if (context0.isEmpty) return $1ef05160d5d5e5fe$var$PredictionContext.isEmptyLocal(context0) ? context0 : $1ef05160d5d5e5fe$var$PredictionContext.addEmptyContext(context1);
        else if (context1.isEmpty) return $1ef05160d5d5e5fe$var$PredictionContext.isEmptyLocal(context1) ? context1 : $1ef05160d5d5e5fe$var$PredictionContext.addEmptyContext(context0);
        let context0size = context0.size;
        let context1size = context1.size;
        if (context0size === 1 && context1size === 1 && context0.getReturnState(0) === context1.getReturnState(0)) {
            let merged = contextCache.join(context0.getParent(0), context1.getParent(0));
            if (merged === context0.getParent(0)) return context0;
            else if (merged === context1.getParent(0)) return context1;
            else return merged.getChild(context0.getReturnState(0));
        }
        let count = 0;
        let parentsList = new Array(context0size + context1size);
        let returnStatesList = new Array(parentsList.length);
        let leftIndex = 0;
        let rightIndex = 0;
        let canReturnLeft = true;
        let canReturnRight = true;
        while(leftIndex < context0size && rightIndex < context1size){
            if (context0.getReturnState(leftIndex) === context1.getReturnState(rightIndex)) {
                parentsList[count] = contextCache.join(context0.getParent(leftIndex), context1.getParent(rightIndex));
                returnStatesList[count] = context0.getReturnState(leftIndex);
                canReturnLeft = canReturnLeft && parentsList[count] === context0.getParent(leftIndex);
                canReturnRight = canReturnRight && parentsList[count] === context1.getParent(rightIndex);
                leftIndex++;
                rightIndex++;
            } else if (context0.getReturnState(leftIndex) < context1.getReturnState(rightIndex)) {
                parentsList[count] = context0.getParent(leftIndex);
                returnStatesList[count] = context0.getReturnState(leftIndex);
                canReturnRight = false;
                leftIndex++;
            } else {
                $9Rq82(context1.getReturnState(rightIndex) < context0.getReturnState(leftIndex));
                parentsList[count] = context1.getParent(rightIndex);
                returnStatesList[count] = context1.getReturnState(rightIndex);
                canReturnLeft = false;
                rightIndex++;
            }
            count++;
        }
        while(leftIndex < context0size){
            parentsList[count] = context0.getParent(leftIndex);
            returnStatesList[count] = context0.getReturnState(leftIndex);
            leftIndex++;
            canReturnRight = false;
            count++;
        }
        while(rightIndex < context1size){
            parentsList[count] = context1.getParent(rightIndex);
            returnStatesList[count] = context1.getReturnState(rightIndex);
            rightIndex++;
            canReturnLeft = false;
            count++;
        }
        if (canReturnLeft) return context0;
        else if (canReturnRight) return context1;
        if (count < parentsList.length) {
            parentsList = parentsList.slice(0, count);
            returnStatesList = returnStatesList.slice(0, count);
        }
        if (parentsList.length === 0) // if one of them was EMPTY_LOCAL, it would be empty and handled at the beginning of the method
        return $1ef05160d5d5e5fe$var$PredictionContext.EMPTY_FULL;
        else if (parentsList.length === 1) return new $1ef05160d5d5e5fe$var$SingletonPredictionContext(parentsList[0], returnStatesList[0]);
        else return new $1ef05160d5d5e5fe$var$ArrayPredictionContext(parentsList, returnStatesList);
    }
    static isEmptyLocal(context) {
        return context === $1ef05160d5d5e5fe$var$PredictionContext.EMPTY_LOCAL;
    }
    static getCachedContext(context, contextCache, visited) {
        if (context.isEmpty) return context;
        let existing = visited.get(context);
        if (existing) return existing;
        existing = contextCache.get(context);
        if (existing) {
            visited.put(context, existing);
            return existing;
        }
        let changed = false;
        let parents = new Array(context.size);
        for(let i = 0; i < parents.length; i++){
            let parent = $1ef05160d5d5e5fe$var$PredictionContext.getCachedContext(context.getParent(i), contextCache, visited);
            if (changed || parent !== context.getParent(i)) {
                if (!changed) {
                    parents = new Array(context.size);
                    for(let j = 0; j < context.size; j++)parents[j] = context.getParent(j);
                    changed = true;
                }
                parents[i] = parent;
            }
        }
        if (!changed) {
            existing = contextCache.putIfAbsent(context, context);
            visited.put(context, existing != null ? existing : context);
            return context;
        }
        // We know parents.length>0 because context.isEmpty is checked at the beginning of the method.
        let updated;
        if (parents.length === 1) updated = new $1ef05160d5d5e5fe$var$SingletonPredictionContext(parents[0], context.getReturnState(0));
        else {
            let returnStates = new Array(context.size);
            for(let i = 0; i < context.size; i++)returnStates[i] = context.getReturnState(i);
            updated = new $1ef05160d5d5e5fe$var$ArrayPredictionContext(parents, returnStates, context.hashCode());
        }
        existing = contextCache.putIfAbsent(updated, updated);
        visited.put(updated, existing || updated);
        visited.put(context, existing || updated);
        return updated;
    }
    appendSingleContext(returnContext, contextCache) {
        return this.appendContext($1ef05160d5d5e5fe$var$PredictionContext.EMPTY_FULL.getChild(returnContext), contextCache);
    }
    getChild(returnState) {
        return new $1ef05160d5d5e5fe$var$SingletonPredictionContext(this, returnState);
    }
    hashCode() {
        return this.cachedHashCode;
    }
    toStrings(recognizer, currentState, stop = $1ef05160d5d5e5fe$var$PredictionContext.EMPTY_FULL) {
        let result = [];
        outer: for(let perm = 0;; perm++){
            let offset = 0;
            let last = true;
            let p = this;
            let stateNumber = currentState;
            let localBuffer = "";
            localBuffer += "[";
            while(!p.isEmpty && p !== stop){
                let index = 0;
                if (p.size > 0) {
                    let bits = 1;
                    while(1 << bits >>> 0 < p.size)bits++;
                    let mask = (1 << bits >>> 0) - 1;
                    index = perm >> offset & mask;
                    last = last && index >= p.size - 1;
                    if (index >= p.size) continue outer;
                    offset += bits;
                }
                if (recognizer) {
                    if (localBuffer.length > 1) // first char is '[', if more than that this isn't the first rule
                    localBuffer += " ";
                    let atn = recognizer.atn;
                    let s = atn.states[stateNumber];
                    let ruleName = recognizer.ruleNames[s.ruleIndex];
                    localBuffer += ruleName;
                } else if (p.getReturnState(index) !== $1ef05160d5d5e5fe$var$PredictionContext.EMPTY_FULL_STATE_KEY) {
                    if (!p.isEmpty) {
                        if (localBuffer.length > 1) // first char is '[', if more than that this isn't the first rule
                        localBuffer += " ";
                        localBuffer += p.getReturnState(index);
                    }
                }
                stateNumber = p.getReturnState(index);
                p = p.getParent(index);
            }
            localBuffer += "]";
            result.push(localBuffer);
            if (last) break;
        }
        return result;
    }
    constructor(cachedHashCode){
        this.cachedHashCode = cachedHashCode;
    }
}
$1ef05160d5d5e5fe$var$__decorate([
    $ffTXa.Override
], $1ef05160d5d5e5fe$var$PredictionContext.prototype, "hashCode", null);
$1ef05160d5d5e5fe$var$__decorate([
    $1ef05160d5d5e5fe$var$__param(0, $ffTXa.NotNull),
    $1ef05160d5d5e5fe$var$__param(1, $ffTXa.NotNull),
    $1ef05160d5d5e5fe$var$__param(2, $ffTXa.NotNull)
], $1ef05160d5d5e5fe$var$PredictionContext, "join", null);
$1ef05160d5d5e5fe$var$__decorate([
    $1ef05160d5d5e5fe$var$__param(0, $ffTXa.NotNull),
    $1ef05160d5d5e5fe$var$__param(1, $ffTXa.NotNull),
    $1ef05160d5d5e5fe$var$__param(2, $ffTXa.NotNull)
], $1ef05160d5d5e5fe$var$PredictionContext, "getCachedContext", null);
module.exports.PredictionContext = $1ef05160d5d5e5fe$var$PredictionContext;
class $1ef05160d5d5e5fe$var$EmptyPredictionContext extends $1ef05160d5d5e5fe$var$PredictionContext {
    get isFullContext() {
        return this.fullContext;
    }
    addEmptyContext() {
        return this;
    }
    removeEmptyContext() {
        throw new Error("Cannot remove the empty context from itself.");
    }
    getParent(index) {
        throw new Error("index out of bounds");
    }
    getReturnState(index) {
        throw new Error("index out of bounds");
    }
    findReturnState(returnState) {
        return -1;
    }
    get size() {
        return 0;
    }
    appendSingleContext(returnContext, contextCache) {
        return contextCache.getChild(this, returnContext);
    }
    appendContext(suffix, contextCache) {
        return suffix;
    }
    get isEmpty() {
        return true;
    }
    get hasEmpty() {
        return true;
    }
    equals(o) {
        return this === o;
    }
    toStrings(recognizer, currentState, stop) {
        return [
            "[]"
        ];
    }
    constructor(fullContext){
        super($1ef05160d5d5e5fe$var$PredictionContext.calculateEmptyHashCode());
        this.fullContext = fullContext;
    }
}
$1ef05160d5d5e5fe$var$__decorate([
    $ffTXa.Override
], $1ef05160d5d5e5fe$var$EmptyPredictionContext.prototype, "addEmptyContext", null);
$1ef05160d5d5e5fe$var$__decorate([
    $ffTXa.Override
], $1ef05160d5d5e5fe$var$EmptyPredictionContext.prototype, "removeEmptyContext", null);
$1ef05160d5d5e5fe$var$__decorate([
    $ffTXa.Override
], $1ef05160d5d5e5fe$var$EmptyPredictionContext.prototype, "getParent", null);
$1ef05160d5d5e5fe$var$__decorate([
    $ffTXa.Override
], $1ef05160d5d5e5fe$var$EmptyPredictionContext.prototype, "getReturnState", null);
$1ef05160d5d5e5fe$var$__decorate([
    $ffTXa.Override
], $1ef05160d5d5e5fe$var$EmptyPredictionContext.prototype, "findReturnState", null);
$1ef05160d5d5e5fe$var$__decorate([
    $ffTXa.Override
], $1ef05160d5d5e5fe$var$EmptyPredictionContext.prototype, "size", null);
$1ef05160d5d5e5fe$var$__decorate([
    $ffTXa.Override
], $1ef05160d5d5e5fe$var$EmptyPredictionContext.prototype, "appendSingleContext", null);
$1ef05160d5d5e5fe$var$__decorate([
    $ffTXa.Override
], $1ef05160d5d5e5fe$var$EmptyPredictionContext.prototype, "appendContext", null);
$1ef05160d5d5e5fe$var$__decorate([
    $ffTXa.Override
], $1ef05160d5d5e5fe$var$EmptyPredictionContext.prototype, "isEmpty", null);
$1ef05160d5d5e5fe$var$__decorate([
    $ffTXa.Override
], $1ef05160d5d5e5fe$var$EmptyPredictionContext.prototype, "hasEmpty", null);
$1ef05160d5d5e5fe$var$__decorate([
    $ffTXa.Override
], $1ef05160d5d5e5fe$var$EmptyPredictionContext.prototype, "equals", null);
$1ef05160d5d5e5fe$var$__decorate([
    $ffTXa.Override
], $1ef05160d5d5e5fe$var$EmptyPredictionContext.prototype, "toStrings", null);
let $1ef05160d5d5e5fe$var$ArrayPredictionContext = class ArrayPredictionContext extends $1ef05160d5d5e5fe$var$PredictionContext {
    getParent(index) {
        return this.parents[index];
    }
    getReturnState(index) {
        return this.returnStates[index];
    }
    findReturnState(returnState) {
        return $kzQll.Arrays.binarySearch(this.returnStates, returnState);
    }
    get size() {
        return this.returnStates.length;
    }
    get isEmpty() {
        return false;
    }
    get hasEmpty() {
        return this.returnStates[this.returnStates.length - 1] === $1ef05160d5d5e5fe$var$PredictionContext.EMPTY_FULL_STATE_KEY;
    }
    addEmptyContext() {
        if (this.hasEmpty) return this;
        let parents2 = this.parents.slice(0);
        let returnStates2 = this.returnStates.slice(0);
        parents2.push($1ef05160d5d5e5fe$var$PredictionContext.EMPTY_FULL);
        returnStates2.push($1ef05160d5d5e5fe$var$PredictionContext.EMPTY_FULL_STATE_KEY);
        return new ArrayPredictionContext(parents2, returnStates2);
    }
    removeEmptyContext() {
        if (!this.hasEmpty) return this;
        if (this.returnStates.length === 2) return new $1ef05160d5d5e5fe$var$SingletonPredictionContext(this.parents[0], this.returnStates[0]);
        else {
            let parents2 = this.parents.slice(0, this.parents.length - 1);
            let returnStates2 = this.returnStates.slice(0, this.returnStates.length - 1);
            return new ArrayPredictionContext(parents2, returnStates2);
        }
    }
    appendContext(suffix, contextCache) {
        return ArrayPredictionContext.appendContextImpl(this, suffix, new $1ef05160d5d5e5fe$var$PredictionContext.IdentityHashMap());
    }
    static appendContextImpl(context, suffix, visited) {
        if (suffix.isEmpty) {
            if ($1ef05160d5d5e5fe$var$PredictionContext.isEmptyLocal(suffix)) {
                if (context.hasEmpty) return $1ef05160d5d5e5fe$var$PredictionContext.EMPTY_LOCAL;
                throw new Error("what to do here?");
            }
            return context;
        }
        if (suffix.size !== 1) throw new Error("Appending a tree suffix is not yet supported.");
        let result = visited.get(context);
        if (!result) {
            if (context.isEmpty) result = suffix;
            else {
                let parentCount = context.size;
                if (context.hasEmpty) parentCount--;
                let updatedParents = new Array(parentCount);
                let updatedReturnStates = new Array(parentCount);
                for(let i = 0; i < parentCount; i++)updatedReturnStates[i] = context.getReturnState(i);
                for(let i = 0; i < parentCount; i++)updatedParents[i] = ArrayPredictionContext.appendContextImpl(context.getParent(i), suffix, visited);
                if (updatedParents.length === 1) result = new $1ef05160d5d5e5fe$var$SingletonPredictionContext(updatedParents[0], updatedReturnStates[0]);
                else {
                    $9Rq82(updatedParents.length > 1);
                    result = new ArrayPredictionContext(updatedParents, updatedReturnStates);
                }
                if (context.hasEmpty) result = $1ef05160d5d5e5fe$var$PredictionContext.join(result, suffix);
            }
            visited.put(context, result);
        }
        return result;
    }
    equals(o) {
        if (this === o) return true;
        else if (!(o instanceof ArrayPredictionContext)) return false;
        if (this.hashCode() !== o.hashCode()) // can't be same if hash is different
        return false;
        let other = o;
        return this.equalsImpl(other, new $c90ex.Array2DHashSet());
    }
    equalsImpl(other, visited) {
        let selfWorkList = [];
        let otherWorkList = [];
        selfWorkList.push(this);
        otherWorkList.push(other);
        while(true){
            let currentSelf = selfWorkList.pop();
            let currentOther = otherWorkList.pop();
            if (!currentSelf || !currentOther) break;
            let operands = new $54abU.PredictionContextCache.IdentityCommutativePredictionContextOperands(currentSelf, currentOther);
            if (!visited.add(operands)) continue;
            let selfSize = operands.x.size;
            if (selfSize === 0) {
                if (!operands.x.equals(operands.y)) return false;
                continue;
            }
            let otherSize = operands.y.size;
            if (selfSize !== otherSize) return false;
            for(let i = 0; i < selfSize; i++){
                if (operands.x.getReturnState(i) !== operands.y.getReturnState(i)) return false;
                let selfParent = operands.x.getParent(i);
                let otherParent = operands.y.getParent(i);
                if (selfParent.hashCode() !== otherParent.hashCode()) return false;
                if (selfParent !== otherParent) {
                    selfWorkList.push(selfParent);
                    otherWorkList.push(otherParent);
                }
            }
        }
        return true;
    }
    constructor(parents, returnStates, hashCode){
        super(hashCode || $1ef05160d5d5e5fe$var$PredictionContext.calculateHashCode(parents, returnStates));
        $9Rq82(parents.length === returnStates.length);
        $9Rq82(returnStates.length > 1 || returnStates[0] !== $1ef05160d5d5e5fe$var$PredictionContext.EMPTY_FULL_STATE_KEY, "Should be using PredictionContext.EMPTY instead.");
        this.parents = parents;
        this.returnStates = returnStates;
    }
};
$1ef05160d5d5e5fe$var$__decorate([
    $ffTXa.NotNull
], $1ef05160d5d5e5fe$var$ArrayPredictionContext.prototype, "parents", void 0);
$1ef05160d5d5e5fe$var$__decorate([
    $ffTXa.NotNull
], $1ef05160d5d5e5fe$var$ArrayPredictionContext.prototype, "returnStates", void 0);
$1ef05160d5d5e5fe$var$__decorate([
    $ffTXa.Override
], $1ef05160d5d5e5fe$var$ArrayPredictionContext.prototype, "getParent", null);
$1ef05160d5d5e5fe$var$__decorate([
    $ffTXa.Override
], $1ef05160d5d5e5fe$var$ArrayPredictionContext.prototype, "getReturnState", null);
$1ef05160d5d5e5fe$var$__decorate([
    $ffTXa.Override
], $1ef05160d5d5e5fe$var$ArrayPredictionContext.prototype, "findReturnState", null);
$1ef05160d5d5e5fe$var$__decorate([
    $ffTXa.Override
], $1ef05160d5d5e5fe$var$ArrayPredictionContext.prototype, "size", null);
$1ef05160d5d5e5fe$var$__decorate([
    $ffTXa.Override
], $1ef05160d5d5e5fe$var$ArrayPredictionContext.prototype, "isEmpty", null);
$1ef05160d5d5e5fe$var$__decorate([
    $ffTXa.Override
], $1ef05160d5d5e5fe$var$ArrayPredictionContext.prototype, "hasEmpty", null);
$1ef05160d5d5e5fe$var$__decorate([
    $ffTXa.Override
], $1ef05160d5d5e5fe$var$ArrayPredictionContext.prototype, "addEmptyContext", null);
$1ef05160d5d5e5fe$var$__decorate([
    $ffTXa.Override
], $1ef05160d5d5e5fe$var$ArrayPredictionContext.prototype, "removeEmptyContext", null);
$1ef05160d5d5e5fe$var$__decorate([
    $ffTXa.Override
], $1ef05160d5d5e5fe$var$ArrayPredictionContext.prototype, "appendContext", null);
$1ef05160d5d5e5fe$var$__decorate([
    $ffTXa.Override
], $1ef05160d5d5e5fe$var$ArrayPredictionContext.prototype, "equals", null);
$1ef05160d5d5e5fe$var$ArrayPredictionContext = $1ef05160d5d5e5fe$var$__decorate([
    $1ef05160d5d5e5fe$var$__param(0, $ffTXa.NotNull)
], $1ef05160d5d5e5fe$var$ArrayPredictionContext);
let $1ef05160d5d5e5fe$var$SingletonPredictionContext = class SingletonPredictionContext extends $1ef05160d5d5e5fe$var$PredictionContext {
    getParent(index) {
        // assert(index == 0);
        return this.parent;
    }
    getReturnState(index) {
        // assert(index == 0);
        return this.returnState;
    }
    findReturnState(returnState) {
        return this.returnState === returnState ? 0 : -1;
    }
    get size() {
        return 1;
    }
    get isEmpty() {
        return false;
    }
    get hasEmpty() {
        return false;
    }
    appendContext(suffix, contextCache) {
        return contextCache.getChild(this.parent.appendContext(suffix, contextCache), this.returnState);
    }
    addEmptyContext() {
        let parents = [
            this.parent,
            $1ef05160d5d5e5fe$var$PredictionContext.EMPTY_FULL
        ];
        let returnStates = [
            this.returnState,
            $1ef05160d5d5e5fe$var$PredictionContext.EMPTY_FULL_STATE_KEY
        ];
        return new $1ef05160d5d5e5fe$var$ArrayPredictionContext(parents, returnStates);
    }
    removeEmptyContext() {
        return this;
    }
    equals(o) {
        if (o === this) return true;
        else if (!(o instanceof SingletonPredictionContext)) return false;
        let other = o;
        if (this.hashCode() !== other.hashCode()) return false;
        return this.returnState === other.returnState && this.parent.equals(other.parent);
    }
    constructor(parent, returnState){
        super($1ef05160d5d5e5fe$var$PredictionContext.calculateSingleHashCode(parent, returnState));
        // assert(returnState != PredictionContext.EMPTY_FULL_STATE_KEY && returnState != PredictionContext.EMPTY_LOCAL_STATE_KEY);
        this.parent = parent;
        this.returnState = returnState;
    }
};
$1ef05160d5d5e5fe$var$__decorate([
    $ffTXa.NotNull
], $1ef05160d5d5e5fe$var$SingletonPredictionContext.prototype, "parent", void 0);
$1ef05160d5d5e5fe$var$__decorate([
    $ffTXa.Override
], $1ef05160d5d5e5fe$var$SingletonPredictionContext.prototype, "getParent", null);
$1ef05160d5d5e5fe$var$__decorate([
    $ffTXa.Override
], $1ef05160d5d5e5fe$var$SingletonPredictionContext.prototype, "getReturnState", null);
$1ef05160d5d5e5fe$var$__decorate([
    $ffTXa.Override
], $1ef05160d5d5e5fe$var$SingletonPredictionContext.prototype, "findReturnState", null);
$1ef05160d5d5e5fe$var$__decorate([
    $ffTXa.Override
], $1ef05160d5d5e5fe$var$SingletonPredictionContext.prototype, "size", null);
$1ef05160d5d5e5fe$var$__decorate([
    $ffTXa.Override
], $1ef05160d5d5e5fe$var$SingletonPredictionContext.prototype, "isEmpty", null);
$1ef05160d5d5e5fe$var$__decorate([
    $ffTXa.Override
], $1ef05160d5d5e5fe$var$SingletonPredictionContext.prototype, "hasEmpty", null);
$1ef05160d5d5e5fe$var$__decorate([
    $ffTXa.Override
], $1ef05160d5d5e5fe$var$SingletonPredictionContext.prototype, "appendContext", null);
$1ef05160d5d5e5fe$var$__decorate([
    $ffTXa.Override
], $1ef05160d5d5e5fe$var$SingletonPredictionContext.prototype, "addEmptyContext", null);
$1ef05160d5d5e5fe$var$__decorate([
    $ffTXa.Override
], $1ef05160d5d5e5fe$var$SingletonPredictionContext.prototype, "removeEmptyContext", null);
$1ef05160d5d5e5fe$var$__decorate([
    $ffTXa.Override
], $1ef05160d5d5e5fe$var$SingletonPredictionContext.prototype, "equals", null);
$1ef05160d5d5e5fe$var$SingletonPredictionContext = $1ef05160d5d5e5fe$var$__decorate([
    $1ef05160d5d5e5fe$var$__param(0, $ffTXa.NotNull)
], $1ef05160d5d5e5fe$var$SingletonPredictionContext);
module.exports.SingletonPredictionContext = $1ef05160d5d5e5fe$var$SingletonPredictionContext;
(function(PredictionContext) {
    PredictionContext.EMPTY_LOCAL = new $1ef05160d5d5e5fe$var$EmptyPredictionContext(false);
    PredictionContext.EMPTY_FULL = new $1ef05160d5d5e5fe$var$EmptyPredictionContext(true);
    PredictionContext.EMPTY_LOCAL_STATE_KEY = -2147483648;
    PredictionContext.EMPTY_FULL_STATE_KEY = 2147483647;
    class IdentityHashMap extends $5ZofD.Array2DHashMap {
        constructor(){
            super(IdentityEqualityComparator.INSTANCE);
        }
    }
    PredictionContext.IdentityHashMap = IdentityHashMap;
    class IdentityEqualityComparator {
        IdentityEqualityComparator() {
        // intentionally empty
        }
        hashCode(obj) {
            return obj.hashCode();
        }
        equals(a, b) {
            return a === b;
        }
    }
    IdentityEqualityComparator.INSTANCE = new IdentityEqualityComparator();
    $1ef05160d5d5e5fe$var$__decorate([
        $ffTXa.Override
    ], IdentityEqualityComparator.prototype, "hashCode", null);
    $1ef05160d5d5e5fe$var$__decorate([
        $ffTXa.Override
    ], IdentityEqualityComparator.prototype, "equals", null);
    PredictionContext.IdentityEqualityComparator = IdentityEqualityComparator;
})($1ef05160d5d5e5fe$var$PredictionContext = module.exports.PredictionContext || (module.exports.PredictionContext = {}));

});

parcelRegister("54abU", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $3b053b35831c9a14$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredictionContextCache = void 0;

var $5ZofD = parcelRequire("5ZofD");


var $ffTXa = parcelRequire("ffTXa");


var $9PlGk = parcelRequire("9PlGk");


var $2EGxJ = parcelRequire("2EGxJ");


var $9Rq82 = parcelRequire("9Rq82");

/** Used to cache {@link PredictionContext} objects. Its used for the shared
 *  context cash associated with contexts in DFA states. This cache
 *  can be used for both lexers and parsers.
 *
 * @author Sam Harwell
 */ class $3b053b35831c9a14$var$PredictionContextCache {
    getAsCached(context) {
        if (!this.enableCache) return context;
        let result = this.contexts.get(context);
        if (!result) {
            result = context;
            this.contexts.put(context, context);
        }
        return result;
    }
    getChild(context, invokingState) {
        if (!this.enableCache) return context.getChild(invokingState);
        let operands = new $3b053b35831c9a14$var$PredictionContextCache.PredictionContextAndInt(context, invokingState);
        let result = this.childContexts.get(operands);
        if (!result) {
            result = context.getChild(invokingState);
            result = this.getAsCached(result);
            this.childContexts.put(operands, result);
        }
        return result;
    }
    join(x, y) {
        if (!this.enableCache) return $2EGxJ.PredictionContext.join(x, y, this);
        let operands = new $3b053b35831c9a14$var$PredictionContextCache.IdentityCommutativePredictionContextOperands(x, y);
        let result = this.joinContexts.get(operands);
        if (result) return result;
        result = $2EGxJ.PredictionContext.join(x, y, this);
        result = this.getAsCached(result);
        this.joinContexts.put(operands, result);
        return result;
    }
    constructor(enableCache = true){
        this.contexts = new $5ZofD.Array2DHashMap($9PlGk.ObjectEqualityComparator.INSTANCE);
        this.childContexts = new $5ZofD.Array2DHashMap($9PlGk.ObjectEqualityComparator.INSTANCE);
        this.joinContexts = new $5ZofD.Array2DHashMap($9PlGk.ObjectEqualityComparator.INSTANCE);
        this.enableCache = enableCache;
    }
}
module.exports.PredictionContextCache = $3b053b35831c9a14$var$PredictionContextCache;
$3b053b35831c9a14$var$PredictionContextCache.UNCACHED = new $3b053b35831c9a14$var$PredictionContextCache(false);
(function(PredictionContextCache) {
    class PredictionContextAndInt {
        equals(obj) {
            if (!(obj instanceof PredictionContextAndInt)) return false;
            else if (obj === this) return true;
            let other = obj;
            return this.value === other.value && (this.obj === other.obj || this.obj != null && this.obj.equals(other.obj));
        }
        hashCode() {
            let hashCode = 5;
            hashCode = 7 * hashCode + (this.obj != null ? this.obj.hashCode() : 0);
            hashCode = 7 * hashCode + this.value;
            return hashCode;
        }
        constructor(obj, value){
            this.obj = obj;
            this.value = value;
        }
    }
    $3b053b35831c9a14$var$__decorate([
        $ffTXa.Override
    ], PredictionContextAndInt.prototype, "equals", null);
    $3b053b35831c9a14$var$__decorate([
        $ffTXa.Override
    ], PredictionContextAndInt.prototype, "hashCode", null);
    PredictionContextCache.PredictionContextAndInt = PredictionContextAndInt;
    class IdentityCommutativePredictionContextOperands {
        get x() {
            return this._x;
        }
        get y() {
            return this._y;
        }
        equals(o) {
            if (!(o instanceof IdentityCommutativePredictionContextOperands)) return false;
            else if (this === o) return true;
            let other = o;
            return this._x === other._x && this._y === other._y || this._x === other._y && this._y === other._x;
        }
        hashCode() {
            return this._x.hashCode() ^ this._y.hashCode();
        }
        constructor(x, y){
            $9Rq82(x != null);
            $9Rq82(y != null);
            this._x = x;
            this._y = y;
        }
    }
    $3b053b35831c9a14$var$__decorate([
        $ffTXa.Override
    ], IdentityCommutativePredictionContextOperands.prototype, "equals", null);
    $3b053b35831c9a14$var$__decorate([
        $ffTXa.Override
    ], IdentityCommutativePredictionContextOperands.prototype, "hashCode", null);
    PredictionContextCache.IdentityCommutativePredictionContextOperands = IdentityCommutativePredictionContextOperands;
})($3b053b35831c9a14$var$PredictionContextCache = module.exports.PredictionContextCache || (module.exports.PredictionContextCache = {}));

});

parcelRegister("51Z4d", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $3a9c6a6523d4cd3d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $3a9c6a6523d4cd3d$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNSimulator = void 0;

var $64vb9 = parcelRequire("64vb9");


var $kjxTv = parcelRequire("kjxTv");


var $ffTXa = parcelRequire("ffTXa");


var $2EGxJ = parcelRequire("2EGxJ");

let $3a9c6a6523d4cd3d$var$ATNSimulator = class ATNSimulator {
    static get ERROR() {
        if (!ATNSimulator._ERROR) {
            ATNSimulator._ERROR = new $kjxTv.DFAState(new $64vb9.ATNConfigSet());
            ATNSimulator._ERROR.stateNumber = $2EGxJ.PredictionContext.EMPTY_FULL_STATE_KEY;
        }
        return ATNSimulator._ERROR;
    }
    /**
     * Clear the DFA cache used by the current instance. Since the DFA cache may
     * be shared by multiple ATN simulators, this method may affect the
     * performance (but not accuracy) of other parsers which are being used
     * concurrently.
     *
     * @ if the current instance does not
     * support clearing the DFA.
     *
     * @since 4.3
     */ clearDFA() {
        this.atn.clearDFA();
    }
    constructor(atn){
        this.atn = atn;
    }
};
$3a9c6a6523d4cd3d$var$__decorate([
    $ffTXa.NotNull
], $3a9c6a6523d4cd3d$var$ATNSimulator.prototype, "atn", void 0);
$3a9c6a6523d4cd3d$var$__decorate([
    $ffTXa.NotNull
], $3a9c6a6523d4cd3d$var$ATNSimulator, "ERROR", null);
$3a9c6a6523d4cd3d$var$ATNSimulator = $3a9c6a6523d4cd3d$var$__decorate([
    $3a9c6a6523d4cd3d$var$__param(0, $ffTXa.NotNull)
], $3a9c6a6523d4cd3d$var$ATNSimulator);
module.exports.ATNSimulator = $3a9c6a6523d4cd3d$var$ATNSimulator;
(function(ATNSimulator) {
    const RULE_VARIANT_DELIMITER = "$";
    const RULE_LF_VARIANT_MARKER = "$lf$";
    const RULE_NOLF_VARIANT_MARKER = "$nolf$";
})($3a9c6a6523d4cd3d$var$ATNSimulator = module.exports.ATNSimulator || (module.exports.ATNSimulator = {}));
module.exports.ATNSimulator = $3a9c6a6523d4cd3d$var$ATNSimulator;

});

parcelRegister("bwXFO", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $8650f8c0c71fc39c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $8650f8c0c71fc39c$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Recognizer = void 0;

var $6QLt6 = parcelRequire("6QLt6");


var $16dXu = parcelRequire("16dXu");


var $ffTXa = parcelRequire("ffTXa");


var $TNDGs = parcelRequire("TNDGs");


var $3jpAZ = parcelRequire("3jpAZ");

class $8650f8c0c71fc39c$var$Recognizer {
    /**
     * Get a map from token names to token types.
     *
     * Used for XPath and tree pattern compilation.
     */ getTokenTypeMap() {
        let vocabulary = this.vocabulary;
        let result = $8650f8c0c71fc39c$var$Recognizer.tokenTypeMapCache.get(vocabulary);
        if (result == null) {
            let intermediateResult = new Map();
            for(let i = 0; i <= this.atn.maxTokenType; i++){
                let literalName = vocabulary.getLiteralName(i);
                if (literalName != null) intermediateResult.set(literalName, i);
                let symbolicName = vocabulary.getSymbolicName(i);
                if (symbolicName != null) intermediateResult.set(symbolicName, i);
            }
            intermediateResult.set("EOF", $TNDGs.Token.EOF);
            result = intermediateResult;
            $8650f8c0c71fc39c$var$Recognizer.tokenTypeMapCache.set(vocabulary, result);
        }
        return result;
    }
    /**
     * Get a map from rule names to rule indexes.
     *
     * Used for XPath and tree pattern compilation.
     */ getRuleIndexMap() {
        let ruleNames = this.ruleNames;
        if (ruleNames == null) throw new Error("The current recognizer does not provide a list of rule names.");
        let result = $8650f8c0c71fc39c$var$Recognizer.ruleIndexMapCache.get(ruleNames);
        if (result == null) {
            result = $3jpAZ.toMap(ruleNames);
            $8650f8c0c71fc39c$var$Recognizer.ruleIndexMapCache.set(ruleNames, result);
        }
        return result;
    }
    getTokenType(tokenName) {
        let ttype = this.getTokenTypeMap().get(tokenName);
        if (ttype != null) return ttype;
        return $TNDGs.Token.INVALID_TYPE;
    }
    /**
     * If this recognizer was generated, it will have a serialized ATN
     * representation of the grammar.
     *
     * For interpreters, we don't know their serialized ATN despite having
     * created the interpreter from it.
     */ get serializedATN() {
        throw new Error("there is no serialized ATN");
    }
    /**
     * Get the {@link ATN} used by the recognizer for prediction.
     *
     * @returns The {@link ATN} used by the recognizer for prediction.
     */ get atn() {
        return this._interp.atn;
    }
    /**
     * Get the ATN interpreter used by the recognizer for prediction.
     *
     * @returns The ATN interpreter used by the recognizer for prediction.
     */ get interpreter() {
        return this._interp;
    }
    /**
     * Set the ATN interpreter used by the recognizer for prediction.
     *
     * @param interpreter The ATN interpreter used by the recognizer for
     * prediction.
     */ set interpreter(interpreter) {
        this._interp = interpreter;
    }
    /** If profiling during the parse/lex, this will return DecisionInfo records
     *  for each decision in recognizer in a ParseInfo object.
     *
     * @since 4.3
     */ get parseInfo() {
        return Promise.resolve(undefined);
    }
    /** What is the error header, normally line/character position information? */ getErrorHeader(e) {
        let token = e.getOffendingToken();
        if (!token) return "";
        let line = token.line;
        let charPositionInLine = token.charPositionInLine;
        return "line " + line + ":" + charPositionInLine;
    }
    /**
     * @exception NullPointerException if `listener` is `undefined`.
     */ addErrorListener(listener) {
        if (!listener) throw new TypeError("listener must not be null");
        this._listeners.push(listener);
    }
    removeErrorListener(listener) {
        let position = this._listeners.indexOf(listener);
        if (position !== -1) this._listeners.splice(position, 1);
    }
    removeErrorListeners() {
        this._listeners.length = 0;
    }
    getErrorListeners() {
        return this._listeners.slice(0);
    }
    getErrorListenerDispatch() {
        return new $16dXu.ProxyErrorListener(this.getErrorListeners());
    }
    // subclass needs to override these if there are sempreds or actions
    // that the ATN interp needs to execute
    sempred(_localctx, ruleIndex, actionIndex) {
        return true;
    }
    precpred(localctx, precedence) {
        return true;
    }
    action(_localctx, ruleIndex, actionIndex) {
    // intentionally empty
    }
    get state() {
        return this._stateNumber;
    }
    /** Indicate that the recognizer has changed internal state that is
     *  consistent with the ATN state passed in.  This way we always know
     *  where we are in the ATN as the parser goes along. The rule
     *  context objects form a stack that lets us see the stack of
     *  invoking rules. Combine this and we have complete ATN
     *  configuration information.
     */ set state(atnState) {
        //		System.err.println("setState "+atnState);
        this._stateNumber = atnState;
    //		if ( traceATNStates ) _ctx.trace(atnState);
    }
    constructor(){
        this._listeners = [
            $6QLt6.ConsoleErrorListener.INSTANCE
        ];
        this._stateNumber = -1;
    }
}
$8650f8c0c71fc39c$var$Recognizer.EOF = -1;
$8650f8c0c71fc39c$var$Recognizer.tokenTypeMapCache = new WeakMap();
$8650f8c0c71fc39c$var$Recognizer.ruleIndexMapCache = new WeakMap();
$8650f8c0c71fc39c$var$__decorate([
    $ffTXa.SuppressWarnings("serial"),
    $ffTXa.NotNull
], $8650f8c0c71fc39c$var$Recognizer.prototype, "_listeners", void 0);
$8650f8c0c71fc39c$var$__decorate([
    $ffTXa.NotNull
], $8650f8c0c71fc39c$var$Recognizer.prototype, "getTokenTypeMap", null);
$8650f8c0c71fc39c$var$__decorate([
    $ffTXa.NotNull
], $8650f8c0c71fc39c$var$Recognizer.prototype, "getRuleIndexMap", null);
$8650f8c0c71fc39c$var$__decorate([
    $ffTXa.NotNull
], $8650f8c0c71fc39c$var$Recognizer.prototype, "serializedATN", null);
$8650f8c0c71fc39c$var$__decorate([
    $ffTXa.NotNull
], $8650f8c0c71fc39c$var$Recognizer.prototype, "atn", null);
$8650f8c0c71fc39c$var$__decorate([
    $ffTXa.NotNull,
    $8650f8c0c71fc39c$var$__param(0, $ffTXa.NotNull)
], $8650f8c0c71fc39c$var$Recognizer.prototype, "interpreter", null);
$8650f8c0c71fc39c$var$__decorate([
    $ffTXa.NotNull,
    $8650f8c0c71fc39c$var$__param(0, $ffTXa.NotNull)
], $8650f8c0c71fc39c$var$Recognizer.prototype, "getErrorHeader", null);
$8650f8c0c71fc39c$var$__decorate([
    $8650f8c0c71fc39c$var$__param(0, $ffTXa.NotNull)
], $8650f8c0c71fc39c$var$Recognizer.prototype, "addErrorListener", null);
$8650f8c0c71fc39c$var$__decorate([
    $8650f8c0c71fc39c$var$__param(0, $ffTXa.NotNull)
], $8650f8c0c71fc39c$var$Recognizer.prototype, "removeErrorListener", null);
$8650f8c0c71fc39c$var$__decorate([
    $ffTXa.NotNull
], $8650f8c0c71fc39c$var$Recognizer.prototype, "getErrorListeners", null);
module.exports.Recognizer = $8650f8c0c71fc39c$var$Recognizer;

});

parcelRegister("6QLt6", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConsoleErrorListener = void 0;
/**
 *
 * @author Sam Harwell
 */ class $4fcc6baa082b1716$var$ConsoleErrorListener {
    /**
     * {@inheritDoc}
     *
     * This implementation prints messages to {@link System#err} containing the
     * values of `line`, `charPositionInLine`, and `msg` using
     * the following format.
     *
     * <pre>
     * line *line*:*charPositionInLine* *msg*
     * </pre>
     */ syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e) {
        console.error(`line ${line}:${charPositionInLine} ${msg}`);
    }
}
module.exports.ConsoleErrorListener = $4fcc6baa082b1716$var$ConsoleErrorListener;
/**
 * Provides a default instance of {@link ConsoleErrorListener}.
 */ $4fcc6baa082b1716$var$ConsoleErrorListener.INSTANCE = new $4fcc6baa082b1716$var$ConsoleErrorListener();

});

parcelRegister("16dXu", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $0cd12dd8ccdcda24$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $0cd12dd8ccdcda24$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProxyErrorListener = void 0;

var $ffTXa = parcelRequire("ffTXa");

/**
 * This implementation of {@link ANTLRErrorListener} dispatches all calls to a
 * collection of delegate listeners. This reduces the effort required to support multiple
 * listeners.
 *
 * @author Sam Harwell
 */ class $0cd12dd8ccdcda24$var$ProxyErrorListener {
    getDelegates() {
        return this.delegates;
    }
    syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e) {
        this.delegates.forEach((listener)=>{
            if (listener.syntaxError) listener.syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e);
        });
    }
    constructor(delegates){
        this.delegates = delegates;
        if (!delegates) throw new Error("Invalid delegates");
    }
}
$0cd12dd8ccdcda24$var$__decorate([
    $ffTXa.Override,
    $0cd12dd8ccdcda24$var$__param(0, $ffTXa.NotNull),
    $0cd12dd8ccdcda24$var$__param(4, $ffTXa.NotNull)
], $0cd12dd8ccdcda24$var$ProxyErrorListener.prototype, "syntaxError", null);
module.exports.ProxyErrorListener = $0cd12dd8ccdcda24$var$ProxyErrorListener;

});

parcelRegister("56U0W", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $3b88f6852464944f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VocabularyImpl = void 0;

var $ffTXa = parcelRequire("ffTXa");


var $TNDGs = parcelRequire("TNDGs");

/**
 * This class provides a default implementation of the {@link Vocabulary}
 * interface.
 *
 * @author Sam Harwell
 */ class $3b88f6852464944f$var$VocabularyImpl {
    get maxTokenType() {
        return this._maxTokenType;
    }
    getLiteralName(tokenType) {
        if (tokenType >= 0 && tokenType < this.literalNames.length) return this.literalNames[tokenType];
        return undefined;
    }
    getSymbolicName(tokenType) {
        if (tokenType >= 0 && tokenType < this.symbolicNames.length) return this.symbolicNames[tokenType];
        if (tokenType === $TNDGs.Token.EOF) return "EOF";
        return undefined;
    }
    getDisplayName(tokenType) {
        if (tokenType >= 0 && tokenType < this.displayNames.length) {
            let displayName = this.displayNames[tokenType];
            if (displayName) return displayName;
        }
        let literalName = this.getLiteralName(tokenType);
        if (literalName) return literalName;
        let symbolicName = this.getSymbolicName(tokenType);
        if (symbolicName) return symbolicName;
        return String(tokenType);
    }
    /**
     * Constructs a new instance of {@link VocabularyImpl} from the specified
     * literal, symbolic, and display token names.
     *
     * @param literalNames The literal names assigned to tokens, or an empty array
     * if no literal names are assigned.
     * @param symbolicNames The symbolic names assigned to tokens, or
     * an empty array if no symbolic names are assigned.
     * @param displayNames The display names assigned to tokens, or an empty array
     * to use the values in `literalNames` and `symbolicNames` as
     * the source of display names, as described in
     * {@link #getDisplayName(int)}.
     *
     * @see #getLiteralName(int)
     * @see #getSymbolicName(int)
     * @see #getDisplayName(int)
     */ constructor(literalNames, symbolicNames, displayNames){
        this.literalNames = literalNames;
        this.symbolicNames = symbolicNames;
        this.displayNames = displayNames;
        // See note here on -1 part: https://github.com/antlr/antlr4/pull/1146
        this._maxTokenType = Math.max(this.displayNames.length, Math.max(this.literalNames.length, this.symbolicNames.length)) - 1;
    }
}
/**
 * Gets an empty {@link Vocabulary} instance.
 *
 * No literal or symbol names are assigned to token types, so
 * {@link #getDisplayName(int)} returns the numeric value for all tokens
 * except {@link Token#EOF}.
 */ $3b88f6852464944f$var$VocabularyImpl.EMPTY_VOCABULARY = new $3b88f6852464944f$var$VocabularyImpl([], [], []);
$3b88f6852464944f$var$__decorate([
    $ffTXa.NotNull
], $3b88f6852464944f$var$VocabularyImpl.prototype, "literalNames", void 0);
$3b88f6852464944f$var$__decorate([
    $ffTXa.NotNull
], $3b88f6852464944f$var$VocabularyImpl.prototype, "symbolicNames", void 0);
$3b88f6852464944f$var$__decorate([
    $ffTXa.NotNull
], $3b88f6852464944f$var$VocabularyImpl.prototype, "displayNames", void 0);
$3b88f6852464944f$var$__decorate([
    $ffTXa.Override
], $3b88f6852464944f$var$VocabularyImpl.prototype, "maxTokenType", null);
$3b88f6852464944f$var$__decorate([
    $ffTXa.Override
], $3b88f6852464944f$var$VocabularyImpl.prototype, "getLiteralName", null);
$3b88f6852464944f$var$__decorate([
    $ffTXa.Override
], $3b88f6852464944f$var$VocabularyImpl.prototype, "getSymbolicName", null);
$3b88f6852464944f$var$__decorate([
    $ffTXa.Override,
    $ffTXa.NotNull
], $3b88f6852464944f$var$VocabularyImpl.prototype, "getDisplayName", null);
$3b88f6852464944f$var$__decorate([
    $ffTXa.NotNull
], $3b88f6852464944f$var$VocabularyImpl, "EMPTY_VOCABULARY", void 0);
module.exports.VocabularyImpl = $3b88f6852464944f$var$VocabularyImpl;

});

parcelRegister("YUl9W", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $0b714eb79511fe79$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarLoopEntryState = void 0;

var $5dqQL = parcelRequire("5dqQL");


var $kJZRw = parcelRequire("kJZRw");


var $gh7Hp = parcelRequire("gh7Hp");


var $ffTXa = parcelRequire("ffTXa");

class $0b714eb79511fe79$var$StarLoopEntryState extends $gh7Hp.DecisionState {
    get stateType() {
        return $5dqQL.ATNStateType.STAR_LOOP_ENTRY;
    }
    constructor(){
        super(...arguments);
        /**
         * Indicates whether this state can benefit from a precedence DFA during SLL
         * decision making.
         *
         * This is a computed property that is calculated during ATN deserialization
         * and stored for use in {@link ParserATNSimulator} and
         * {@link ParserInterpreter}.
         *
         * @see `DFA.isPrecedenceDfa`
         */ this.precedenceRuleDecision = false;
        /**
         * For precedence decisions, this set marks states *S* which have all
         * of the following characteristics:
         *
         * * One or more invocation sites of the current rule returns to
         *   *S*.
         * * The closure from *S* includes the current decision without
         *   passing through any rule invocations or stepping out of the current
         *   rule.
         *
         * This field is not used when {@link #precedenceRuleDecision} is
         * `false`.
         */ this.precedenceLoopbackStates = new $kJZRw.BitSet();
    }
}
$0b714eb79511fe79$var$__decorate([
    $ffTXa.Override
], $0b714eb79511fe79$var$StarLoopEntryState.prototype, "stateType", null);
module.exports.StarLoopEntryState = $0b714eb79511fe79$var$StarLoopEntryState;

});

parcelRegister("biTmn", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $83ac517ed82138f6$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidState = void 0;

var $5dqQL = parcelRequire("5dqQL");


var $heKTD = parcelRequire("heKTD");


var $ffTXa = parcelRequire("ffTXa");

/**
 *
 * @author Sam Harwell
 */ class $83ac517ed82138f6$var$InvalidState extends $heKTD.BasicState {
    get stateType() {
        return $5dqQL.ATNStateType.INVALID_TYPE;
    }
}
$83ac517ed82138f6$var$__decorate([
    $ffTXa.Override
], $83ac517ed82138f6$var$InvalidState.prototype, "stateType", null);
module.exports.InvalidState = $83ac517ed82138f6$var$InvalidState;

});

parcelRegister("heKTD", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c8c81f18f8350640$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BasicState = void 0;

var $2UrJv = parcelRequire("2UrJv");


var $5dqQL = parcelRequire("5dqQL");


var $ffTXa = parcelRequire("ffTXa");

/**
 *
 * @author Sam Harwell
 */ class $c8c81f18f8350640$var$BasicState extends $2UrJv.ATNState {
    get stateType() {
        return $5dqQL.ATNStateType.BASIC;
    }
}
$c8c81f18f8350640$var$__decorate([
    $ffTXa.Override
], $c8c81f18f8350640$var$BasicState.prototype, "stateType", null);
module.exports.BasicState = $c8c81f18f8350640$var$BasicState;

});

parcelRegister("acFm6", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $76db1ab008aefb6a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $76db1ab008aefb6a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LL1Analyzer = void 0;

var $b3uXT = parcelRequire("b3uXT");


var $c90ex = parcelRequire("c90ex");


var $cxg6R = parcelRequire("cxg6R");


var $kJZRw = parcelRequire("kJZRw");


var $69z5o = parcelRequire("69z5o");


var $ffTXa = parcelRequire("ffTXa");


var $37IiV = parcelRequire("37IiV");


var $9PlGk = parcelRequire("9PlGk");


var $2EGxJ = parcelRequire("2EGxJ");


var $9v0dI = parcelRequire("9v0dI");


var $1zwkT = parcelRequire("1zwkT");


var $TNDGs = parcelRequire("TNDGs");


var $awsDh = parcelRequire("awsDh");

let $76db1ab008aefb6a$var$LL1Analyzer = class LL1Analyzer {
    /**
     * Calculates the SLL(1) expected lookahead set for each outgoing transition
     * of an {@link ATNState}. The returned array has one element for each
     * outgoing transition in `s`. If the closure from transition
     * *i* leads to a semantic predicate before matching a symbol, the
     * element at index *i* of the result will be `undefined`.
     *
     * @param s the ATN state
     * @returns the expected symbols for each outgoing transition of `s`.
     */ getDecisionLookahead(s) {
        //		System.out.println("LOOK("+s.stateNumber+")");
        if (s == null) return undefined;
        let look = new Array(s.numberOfTransitions);
        for(let alt = 0; alt < s.numberOfTransitions; alt++){
            let current = new $69z5o.IntervalSet();
            look[alt] = current;
            let lookBusy = new $c90ex.Array2DHashSet($9PlGk.ObjectEqualityComparator.INSTANCE);
            let seeThruPreds = false; // fail to get lookahead upon pred
            this._LOOK(s.transition(alt).target, undefined, $2EGxJ.PredictionContext.EMPTY_LOCAL, current, lookBusy, new $kJZRw.BitSet(), seeThruPreds, false);
            // Wipe out lookahead for this alternative if we found nothing
            // or we had a predicate when we !seeThruPreds
            if (current.size === 0 || current.contains(LL1Analyzer.HIT_PRED)) {
                current = undefined;
                look[alt] = current;
            }
        }
        return look;
    }
    LOOK(s, ctx, stopState) {
        if (stopState === undefined) {
            if (s.atn == null) throw new Error("Illegal state");
            stopState = s.atn.ruleToStopState[s.ruleIndex];
        } else if (stopState === null) // This is an explicit request to pass undefined as the stopState to _LOOK. Used to distinguish an overload
        // from the method which simply omits the stopState parameter.
        stopState = undefined;
        let r = new $69z5o.IntervalSet();
        let seeThruPreds = true; // ignore preds; get all lookahead
        let addEOF = true;
        this._LOOK(s, stopState, ctx, r, new $c90ex.Array2DHashSet(), new $kJZRw.BitSet(), seeThruPreds, addEOF);
        return r;
    }
    /**
     * Compute set of tokens that can follow `s` in the ATN in the
     * specified `ctx`.
     * <p/>
     * If `ctx` is {@link PredictionContext#EMPTY_LOCAL} and
     * `stopState` or the end of the rule containing `s` is reached,
     * {@link Token#EPSILON} is added to the result set. If `ctx` is not
     * {@link PredictionContext#EMPTY_LOCAL} and `addEOF` is `true`
     * and `stopState` or the end of the outermost rule is reached,
     * {@link Token#EOF} is added to the result set.
     *
     * @param s the ATN state.
     * @param stopState the ATN state to stop at. This can be a
     * {@link BlockEndState} to detect epsilon paths through a closure.
     * @param ctx The outer context, or {@link PredictionContext#EMPTY_LOCAL} if
     * the outer context should not be used.
     * @param look The result lookahead set.
     * @param lookBusy A set used for preventing epsilon closures in the ATN
     * from causing a stack overflow. Outside code should pass
     * `new HashSet<ATNConfig>` for this argument.
     * @param calledRuleStack A set used for preventing left recursion in the
     * ATN from causing a stack overflow. Outside code should pass
     * `new BitSet()` for this argument.
     * @param seeThruPreds `true` to true semantic predicates as
     * implicitly `true` and "see through them", otherwise `false`
     * to treat semantic predicates as opaque and add {@link #HIT_PRED} to the
     * result if one is encountered.
     * @param addEOF Add {@link Token#EOF} to the result if the end of the
     * outermost context is reached. This parameter has no effect if `ctx`
     * is {@link PredictionContext#EMPTY_LOCAL}.
     */ _LOOK(s, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF) {
        //		System.out.println("_LOOK("+s.stateNumber+", ctx="+ctx);
        let c = $cxg6R.ATNConfig.create(s, 0, ctx);
        if (!lookBusy.add(c)) return;
        if (s === stopState) {
            if ($2EGxJ.PredictionContext.isEmptyLocal(ctx)) {
                look.add($TNDGs.Token.EPSILON);
                return;
            } else if (ctx.isEmpty) {
                if (addEOF) look.add($TNDGs.Token.EOF);
                return;
            }
        }
        if (s instanceof $9v0dI.RuleStopState) {
            if (ctx.isEmpty && !$2EGxJ.PredictionContext.isEmptyLocal(ctx)) {
                if (addEOF) look.add($TNDGs.Token.EOF);
                return;
            }
            let removed = calledRuleStack.get(s.ruleIndex);
            try {
                calledRuleStack.clear(s.ruleIndex);
                for(let i = 0; i < ctx.size; i++){
                    if (ctx.getReturnState(i) === $2EGxJ.PredictionContext.EMPTY_FULL_STATE_KEY) continue;
                    let returnState = this.atn.states[ctx.getReturnState(i)];
                    //					System.out.println("popping back to "+retState);
                    this._LOOK(returnState, stopState, ctx.getParent(i), look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                }
            } finally{
                if (removed) calledRuleStack.set(s.ruleIndex);
            }
        }
        let n = s.numberOfTransitions;
        for(let i = 0; i < n; i++){
            let t = s.transition(i);
            if (t instanceof $1zwkT.RuleTransition) {
                if (calledRuleStack.get(t.ruleIndex)) continue;
                let newContext = ctx.getChild(t.followState.stateNumber);
                try {
                    calledRuleStack.set(t.ruleIndex);
                    this._LOOK(t.target, stopState, newContext, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                } finally{
                    calledRuleStack.clear(t.ruleIndex);
                }
            } else if (t instanceof $b3uXT.AbstractPredicateTransition) {
                if (seeThruPreds) this._LOOK(t.target, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                else look.add(LL1Analyzer.HIT_PRED);
            } else if (t.isEpsilon) this._LOOK(t.target, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
            else if (t instanceof $awsDh.WildcardTransition) look.addAll($69z5o.IntervalSet.of($TNDGs.Token.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType));
            else {
                //				System.out.println("adding "+ t);
                let set = t.label;
                if (set != null) {
                    if (t instanceof $37IiV.NotSetTransition) set = set.complement($69z5o.IntervalSet.of($TNDGs.Token.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType));
                    look.addAll(set);
                }
            }
        }
    }
    constructor(atn){
        this.atn = atn;
    }
};
/** Special value added to the lookahead sets to indicate that we hit
 *  a predicate during analysis if `seeThruPreds==false`.
 */ $76db1ab008aefb6a$var$LL1Analyzer.HIT_PRED = $TNDGs.Token.INVALID_TYPE;
$76db1ab008aefb6a$var$__decorate([
    $ffTXa.NotNull
], $76db1ab008aefb6a$var$LL1Analyzer.prototype, "atn", void 0);
$76db1ab008aefb6a$var$__decorate([
    $ffTXa.NotNull,
    $76db1ab008aefb6a$var$__param(0, $ffTXa.NotNull),
    $76db1ab008aefb6a$var$__param(1, $ffTXa.NotNull)
], $76db1ab008aefb6a$var$LL1Analyzer.prototype, "LOOK", null);
$76db1ab008aefb6a$var$__decorate([
    $76db1ab008aefb6a$var$__param(0, $ffTXa.NotNull),
    $76db1ab008aefb6a$var$__param(2, $ffTXa.NotNull),
    $76db1ab008aefb6a$var$__param(3, $ffTXa.NotNull),
    $76db1ab008aefb6a$var$__param(4, $ffTXa.NotNull),
    $76db1ab008aefb6a$var$__param(5, $ffTXa.NotNull)
], $76db1ab008aefb6a$var$LL1Analyzer.prototype, "_LOOK", null);
$76db1ab008aefb6a$var$LL1Analyzer = $76db1ab008aefb6a$var$__decorate([
    $76db1ab008aefb6a$var$__param(0, $ffTXa.NotNull)
], $76db1ab008aefb6a$var$LL1Analyzer);
module.exports.LL1Analyzer = $76db1ab008aefb6a$var$LL1Analyzer;

});

parcelRegister("37IiV", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $246464709879120d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $246464709879120d$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NotSetTransition = void 0;

var $ffTXa = parcelRequire("ffTXa");


var $3VIrd = parcelRequire("3VIrd");

let $246464709879120d$var$NotSetTransition = class NotSetTransition extends $3VIrd.SetTransition {
    get serializationType() {
        return 8 /* NOT_SET */ ;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return symbol >= minVocabSymbol && symbol <= maxVocabSymbol && !super.matches(symbol, minVocabSymbol, maxVocabSymbol);
    }
    toString() {
        return "~" + super.toString();
    }
    constructor(target, set){
        super(target, set);
    }
};
$246464709879120d$var$__decorate([
    $ffTXa.Override
], $246464709879120d$var$NotSetTransition.prototype, "serializationType", null);
$246464709879120d$var$__decorate([
    $ffTXa.Override
], $246464709879120d$var$NotSetTransition.prototype, "matches", null);
$246464709879120d$var$__decorate([
    $ffTXa.Override
], $246464709879120d$var$NotSetTransition.prototype, "toString", null);
$246464709879120d$var$NotSetTransition = $246464709879120d$var$__decorate([
    $246464709879120d$var$__param(0, $ffTXa.NotNull),
    $246464709879120d$var$__param(1, $ffTXa.Nullable)
], $246464709879120d$var$NotSetTransition);
module.exports.NotSetTransition = $246464709879120d$var$NotSetTransition;

});

parcelRegister("3VIrd", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $2dc92a6c59c0e25a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $2dc92a6c59c0e25a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SetTransition = void 0;

var $69z5o = parcelRequire("69z5o");


var $ffTXa = parcelRequire("ffTXa");


var $TNDGs = parcelRequire("TNDGs");


var $ikYx7 = parcelRequire("ikYx7");

/** A transition containing a set of values. */ let $2dc92a6c59c0e25a$var$SetTransition = class SetTransition extends $ikYx7.Transition {
    get serializationType() {
        return 7 /* SET */ ;
    }
    get label() {
        return this.set;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return this.set.contains(symbol);
    }
    toString() {
        return this.set.toString();
    }
    // TODO (sam): should we really allow undefined here?
    constructor(target, set){
        super(target);
        if (set == null) set = $69z5o.IntervalSet.of($TNDGs.Token.INVALID_TYPE);
        this.set = set;
    }
};
$2dc92a6c59c0e25a$var$__decorate([
    $ffTXa.NotNull
], $2dc92a6c59c0e25a$var$SetTransition.prototype, "set", void 0);
$2dc92a6c59c0e25a$var$__decorate([
    $ffTXa.Override
], $2dc92a6c59c0e25a$var$SetTransition.prototype, "serializationType", null);
$2dc92a6c59c0e25a$var$__decorate([
    $ffTXa.Override,
    $ffTXa.NotNull
], $2dc92a6c59c0e25a$var$SetTransition.prototype, "label", null);
$2dc92a6c59c0e25a$var$__decorate([
    $ffTXa.Override
], $2dc92a6c59c0e25a$var$SetTransition.prototype, "matches", null);
$2dc92a6c59c0e25a$var$__decorate([
    $ffTXa.Override,
    $ffTXa.NotNull
], $2dc92a6c59c0e25a$var$SetTransition.prototype, "toString", null);
$2dc92a6c59c0e25a$var$SetTransition = $2dc92a6c59c0e25a$var$__decorate([
    $2dc92a6c59c0e25a$var$__param(0, $ffTXa.NotNull),
    $2dc92a6c59c0e25a$var$__param(1, $ffTXa.Nullable)
], $2dc92a6c59c0e25a$var$SetTransition);
module.exports.SetTransition = $2dc92a6c59c0e25a$var$SetTransition;

});

parcelRegister("9v0dI", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $6ea72e06cb5d79e3$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleStopState = void 0;

var $2UrJv = parcelRequire("2UrJv");


var $5dqQL = parcelRequire("5dqQL");


var $ffTXa = parcelRequire("ffTXa");

/** The last node in the ATN for a rule, unless that rule is the start symbol.
 *  In that case, there is one transition to EOF. Later, we might encode
 *  references to all calls to this rule to compute FOLLOW sets for
 *  error handling.
 */ class $6ea72e06cb5d79e3$var$RuleStopState extends $2UrJv.ATNState {
    get nonStopStateNumber() {
        return -1;
    }
    get stateType() {
        return $5dqQL.ATNStateType.RULE_STOP;
    }
}
$6ea72e06cb5d79e3$var$__decorate([
    $ffTXa.Override
], $6ea72e06cb5d79e3$var$RuleStopState.prototype, "nonStopStateNumber", null);
$6ea72e06cb5d79e3$var$__decorate([
    $ffTXa.Override
], $6ea72e06cb5d79e3$var$RuleStopState.prototype, "stateType", null);
module.exports.RuleStopState = $6ea72e06cb5d79e3$var$RuleStopState;

});

parcelRegister("1zwkT", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $12522492aa0a8b6e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $12522492aa0a8b6e$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleTransition = void 0;

var $ffTXa = parcelRequire("ffTXa");


var $ikYx7 = parcelRequire("ikYx7");

/** */ let $12522492aa0a8b6e$var$RuleTransition = class RuleTransition extends $ikYx7.Transition {
    get serializationType() {
        return 3 /* RULE */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    constructor(ruleStart, ruleIndex, precedence, followState){
        super(ruleStart);
        this.tailCall = false;
        this.optimizedTailCall = false;
        this.ruleIndex = ruleIndex;
        this.precedence = precedence;
        this.followState = followState;
    }
};
$12522492aa0a8b6e$var$__decorate([
    $ffTXa.NotNull
], $12522492aa0a8b6e$var$RuleTransition.prototype, "followState", void 0);
$12522492aa0a8b6e$var$__decorate([
    $ffTXa.Override
], $12522492aa0a8b6e$var$RuleTransition.prototype, "serializationType", null);
$12522492aa0a8b6e$var$__decorate([
    $ffTXa.Override
], $12522492aa0a8b6e$var$RuleTransition.prototype, "isEpsilon", null);
$12522492aa0a8b6e$var$__decorate([
    $ffTXa.Override
], $12522492aa0a8b6e$var$RuleTransition.prototype, "matches", null);
$12522492aa0a8b6e$var$RuleTransition = $12522492aa0a8b6e$var$__decorate([
    $12522492aa0a8b6e$var$__param(0, $ffTXa.NotNull),
    $12522492aa0a8b6e$var$__param(3, $ffTXa.NotNull)
], $12522492aa0a8b6e$var$RuleTransition);
module.exports.RuleTransition = $12522492aa0a8b6e$var$RuleTransition;

});

parcelRegister("awsDh", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7a931a60b3260804$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $7a931a60b3260804$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WildcardTransition = void 0;

var $ffTXa = parcelRequire("ffTXa");


var $ikYx7 = parcelRequire("ikYx7");

let $7a931a60b3260804$var$WildcardTransition = class WildcardTransition extends $ikYx7.Transition {
    get serializationType() {
        return 9 /* WILDCARD */ ;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return symbol >= minVocabSymbol && symbol <= maxVocabSymbol;
    }
    toString() {
        return ".";
    }
    constructor(target){
        super(target);
    }
};
$7a931a60b3260804$var$__decorate([
    $ffTXa.Override
], $7a931a60b3260804$var$WildcardTransition.prototype, "serializationType", null);
$7a931a60b3260804$var$__decorate([
    $ffTXa.Override
], $7a931a60b3260804$var$WildcardTransition.prototype, "matches", null);
$7a931a60b3260804$var$__decorate([
    $ffTXa.Override,
    $ffTXa.NotNull
], $7a931a60b3260804$var$WildcardTransition.prototype, "toString", null);
$7a931a60b3260804$var$WildcardTransition = $7a931a60b3260804$var$__decorate([
    $7a931a60b3260804$var$__param(0, $ffTXa.NotNull)
], $7a931a60b3260804$var$WildcardTransition);
module.exports.WildcardTransition = $7a931a60b3260804$var$WildcardTransition;

});

parcelRegister("gEp6N", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c1f3dbd5176133cf$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c1f3dbd5176133cf$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerActionExecutor = void 0;

var $9mjSw = parcelRequire("9mjSw");


var $hSOfH = parcelRequire("hSOfH");


var $kPsXR = parcelRequire("kPsXR");


var $ffTXa = parcelRequire("ffTXa");

/**
 * Represents an executor for a sequence of lexer actions which traversed during
 * the matching operation of a lexer rule (token).
 *
 * The executor tracks position information for position-dependent lexer actions
 * efficiently, ensuring that actions appearing only at the end of the rule do
 * not cause bloating of the {@link DFA} created for the lexer.
 *
 * @author Sam Harwell
 * @since 4.2
 */ let $c1f3dbd5176133cf$var$LexerActionExecutor = class LexerActionExecutor {
    /**
     * Creates a {@link LexerActionExecutor} which executes the actions for
     * the input `lexerActionExecutor` followed by a specified
     * `lexerAction`.
     *
     * @param lexerActionExecutor The executor for actions already traversed by
     * the lexer while matching a token within a particular
     * {@link ATNConfig}. If this is `undefined`, the method behaves as though
     * it were an empty executor.
     * @param lexerAction The lexer action to execute after the actions
     * specified in `lexerActionExecutor`.
     *
     * @returns A {@link LexerActionExecutor} for executing the combine actions
     * of `lexerActionExecutor` and `lexerAction`.
     */ static append(lexerActionExecutor, lexerAction) {
        if (!lexerActionExecutor) return new LexerActionExecutor([
            lexerAction
        ]);
        let lexerActions = lexerActionExecutor._lexerActions.slice(0);
        lexerActions.push(lexerAction);
        return new LexerActionExecutor(lexerActions);
    }
    /**
     * Creates a {@link LexerActionExecutor} which encodes the current offset
     * for position-dependent lexer actions.
     *
     * Normally, when the executor encounters lexer actions where
     * {@link LexerAction#isPositionDependent} returns `true`, it calls
     * {@link IntStream#seek} on the input {@link CharStream} to set the input
     * position to the *end* of the current token. This behavior provides
     * for efficient DFA representation of lexer actions which appear at the end
     * of a lexer rule, even when the lexer rule matches a variable number of
     * characters.
     *
     * Prior to traversing a match transition in the ATN, the current offset
     * from the token start index is assigned to all position-dependent lexer
     * actions which have not already been assigned a fixed offset. By storing
     * the offsets relative to the token start index, the DFA representation of
     * lexer actions which appear in the middle of tokens remains efficient due
     * to sharing among tokens of the same length, regardless of their absolute
     * position in the input stream.
     *
     * If the current executor already has offsets assigned to all
     * position-dependent lexer actions, the method returns `this`.
     *
     * @param offset The current offset to assign to all position-dependent
     * lexer actions which do not already have offsets assigned.
     *
     * @returns A {@link LexerActionExecutor} which stores input stream offsets
     * for all position-dependent lexer actions.
     */ fixOffsetBeforeMatch(offset) {
        let updatedLexerActions;
        for(let i = 0; i < this._lexerActions.length; i++)if (this._lexerActions[i].isPositionDependent && !(this._lexerActions[i] instanceof $hSOfH.LexerIndexedCustomAction)) {
            if (!updatedLexerActions) updatedLexerActions = this._lexerActions.slice(0);
            updatedLexerActions[i] = new $hSOfH.LexerIndexedCustomAction(offset, this._lexerActions[i]);
        }
        if (!updatedLexerActions) return this;
        return new LexerActionExecutor(updatedLexerActions);
    }
    /**
     * Gets the lexer actions to be executed by this executor.
     * @returns The lexer actions to be executed by this executor.
     */ get lexerActions() {
        return this._lexerActions;
    }
    /**
     * Execute the actions encapsulated by this executor within the context of a
     * particular {@link Lexer}.
     *
     * This method calls {@link IntStream#seek} to set the position of the
     * `input` {@link CharStream} prior to calling
     * {@link LexerAction#execute} on a position-dependent action. Before the
     * method returns, the input position will be restored to the same position
     * it was in when the method was invoked.
     *
     * @param lexer The lexer instance.
     * @param input The input stream which is the source for the current token.
     * When this method is called, the current {@link IntStream#index} for
     * `input` should be the start of the following token, i.e. 1
     * character past the end of the current token.
     * @param startIndex The token start index. This value may be passed to
     * {@link IntStream#seek} to set the `input` position to the beginning
     * of the token.
     */ execute(lexer, input, startIndex) {
        let requiresSeek = false;
        let stopIndex = input.index;
        try {
            for (let lexerAction of this._lexerActions){
                if (lexerAction instanceof $hSOfH.LexerIndexedCustomAction) {
                    let offset = lexerAction.offset;
                    input.seek(startIndex + offset);
                    lexerAction = lexerAction.action;
                    requiresSeek = startIndex + offset !== stopIndex;
                } else if (lexerAction.isPositionDependent) {
                    input.seek(stopIndex);
                    requiresSeek = false;
                }
                lexerAction.execute(lexer);
            }
        } finally{
            if (requiresSeek) input.seek(stopIndex);
        }
    }
    hashCode() {
        return this.cachedHashCode;
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof LexerActionExecutor)) return false;
        return this.cachedHashCode === obj.cachedHashCode && $9mjSw.ArrayEqualityComparator.INSTANCE.equals(this._lexerActions, obj._lexerActions);
    }
    /**
     * Constructs an executor for a sequence of {@link LexerAction} actions.
     * @param lexerActions The lexer actions to execute.
     */ constructor(lexerActions){
        this._lexerActions = lexerActions;
        let hash = $kPsXR.MurmurHash.initialize();
        for (let lexerAction of lexerActions)hash = $kPsXR.MurmurHash.update(hash, lexerAction);
        this.cachedHashCode = $kPsXR.MurmurHash.finish(hash, lexerActions.length);
    }
};
$c1f3dbd5176133cf$var$__decorate([
    $ffTXa.NotNull
], $c1f3dbd5176133cf$var$LexerActionExecutor.prototype, "_lexerActions", void 0);
$c1f3dbd5176133cf$var$__decorate([
    $ffTXa.NotNull
], $c1f3dbd5176133cf$var$LexerActionExecutor.prototype, "lexerActions", null);
$c1f3dbd5176133cf$var$__decorate([
    $c1f3dbd5176133cf$var$__param(0, $ffTXa.NotNull)
], $c1f3dbd5176133cf$var$LexerActionExecutor.prototype, "execute", null);
$c1f3dbd5176133cf$var$__decorate([
    $ffTXa.Override
], $c1f3dbd5176133cf$var$LexerActionExecutor.prototype, "hashCode", null);
$c1f3dbd5176133cf$var$__decorate([
    $ffTXa.Override
], $c1f3dbd5176133cf$var$LexerActionExecutor.prototype, "equals", null);
$c1f3dbd5176133cf$var$__decorate([
    $ffTXa.NotNull,
    $c1f3dbd5176133cf$var$__param(1, $ffTXa.NotNull)
], $c1f3dbd5176133cf$var$LexerActionExecutor, "append", null);
$c1f3dbd5176133cf$var$LexerActionExecutor = $c1f3dbd5176133cf$var$__decorate([
    $c1f3dbd5176133cf$var$__param(0, $ffTXa.NotNull)
], $c1f3dbd5176133cf$var$LexerActionExecutor);
module.exports.LexerActionExecutor = $c1f3dbd5176133cf$var$LexerActionExecutor;

});

parcelRegister("hSOfH", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d04e75d7fa68a20e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d04e75d7fa68a20e$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerIndexedCustomAction = void 0;

var $kPsXR = parcelRequire("kPsXR");


var $ffTXa = parcelRequire("ffTXa");

/**
 * This implementation of {@link LexerAction} is used for tracking input offsets
 * for position-dependent actions within a {@link LexerActionExecutor}.
 *
 * This action is not serialized as part of the ATN, and is only required for
 * position-dependent lexer actions which appear at a location other than the
 * end of a rule. For more information about DFA optimizations employed for
 * lexer actions, see {@link LexerActionExecutor#append} and
 * {@link LexerActionExecutor#fixOffsetBeforeMatch}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ let $d04e75d7fa68a20e$var$LexerIndexedCustomAction = class LexerIndexedCustomAction {
    /**
     * Gets the location in the input {@link CharStream} at which the lexer
     * action should be executed. The value is interpreted as an offset relative
     * to the token start index.
     *
     * @returns The location in the input {@link CharStream} at which the lexer
     * action should be executed.
     */ get offset() {
        return this._offset;
    }
    /**
     * Gets the lexer action to execute.
     *
     * @returns A {@link LexerAction} object which executes the lexer action.
     */ get action() {
        return this._action;
    }
    /**
     * {@inheritDoc}
     *
     * @returns This method returns the result of calling {@link #getActionType}
     * on the {@link LexerAction} returned by {@link #getAction}.
     */ get actionType() {
        return this._action.actionType;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `true`.
     */ get isPositionDependent() {
        return true;
    }
    /**
     * {@inheritDoc}
     *
     * This method calls {@link #execute} on the result of {@link #getAction}
     * using the provided `lexer`.
     */ execute(lexer) {
        // assume the input stream position was properly set by the calling code
        this._action.execute(lexer);
    }
    hashCode() {
        let hash = $kPsXR.MurmurHash.initialize();
        hash = $kPsXR.MurmurHash.update(hash, this._offset);
        hash = $kPsXR.MurmurHash.update(hash, this._action);
        return $kPsXR.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof LexerIndexedCustomAction)) return false;
        return this._offset === obj._offset && this._action.equals(obj._action);
    }
    /**
     * Constructs a new indexed custom action by associating a character offset
     * with a {@link LexerAction}.
     *
     * Note: This class is only required for lexer actions for which
     * {@link LexerAction#isPositionDependent} returns `true`.
     *
     * @param offset The offset into the input {@link CharStream}, relative to
     * the token start index, at which the specified lexer action should be
     * executed.
     * @param action The lexer action to execute at a particular offset in the
     * input {@link CharStream}.
     */ constructor(offset, action){
        this._offset = offset;
        this._action = action;
    }
};
$d04e75d7fa68a20e$var$__decorate([
    $ffTXa.NotNull
], $d04e75d7fa68a20e$var$LexerIndexedCustomAction.prototype, "action", null);
$d04e75d7fa68a20e$var$__decorate([
    $ffTXa.Override
], $d04e75d7fa68a20e$var$LexerIndexedCustomAction.prototype, "actionType", null);
$d04e75d7fa68a20e$var$__decorate([
    $ffTXa.Override
], $d04e75d7fa68a20e$var$LexerIndexedCustomAction.prototype, "isPositionDependent", null);
$d04e75d7fa68a20e$var$__decorate([
    $ffTXa.Override
], $d04e75d7fa68a20e$var$LexerIndexedCustomAction.prototype, "execute", null);
$d04e75d7fa68a20e$var$__decorate([
    $ffTXa.Override
], $d04e75d7fa68a20e$var$LexerIndexedCustomAction.prototype, "hashCode", null);
$d04e75d7fa68a20e$var$__decorate([
    $ffTXa.Override
], $d04e75d7fa68a20e$var$LexerIndexedCustomAction.prototype, "equals", null);
$d04e75d7fa68a20e$var$LexerIndexedCustomAction = $d04e75d7fa68a20e$var$__decorate([
    $d04e75d7fa68a20e$var$__param(1, $ffTXa.NotNull)
], $d04e75d7fa68a20e$var$LexerIndexedCustomAction);
module.exports.LexerIndexedCustomAction = $d04e75d7fa68a20e$var$LexerIndexedCustomAction;

});

parcelRegister("hh2Av", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c936080f14a5c87a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c936080f14a5c87a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerNoViableAltException = void 0;

var $beMqO = parcelRequire("beMqO");


var $ffTXa = parcelRequire("ffTXa");


var $dQ3yU = parcelRequire("dQ3yU");


var $3jpAZ = parcelRequire("3jpAZ");

let $c936080f14a5c87a$var$LexerNoViableAltException = class LexerNoViableAltException extends $beMqO.RecognitionException {
    get startIndex() {
        return this._startIndex;
    }
    get deadEndConfigs() {
        return this._deadEndConfigs;
    }
    get inputStream() {
        return super.inputStream;
    }
    toString() {
        let symbol = "";
        if (this._startIndex >= 0 && this._startIndex < this.inputStream.size) {
            symbol = this.inputStream.getText($dQ3yU.Interval.of(this._startIndex, this._startIndex));
            symbol = $3jpAZ.escapeWhitespace(symbol, false);
        }
        // return String.format(Locale.getDefault(), "%s('%s')", LexerNoViableAltException.class.getSimpleName(), symbol);
        return `LexerNoViableAltException('${symbol}')`;
    }
    constructor(lexer, input, startIndex, deadEndConfigs){
        super(lexer, input);
        this._startIndex = startIndex;
        this._deadEndConfigs = deadEndConfigs;
    }
};
$c936080f14a5c87a$var$__decorate([
    $ffTXa.Override
], $c936080f14a5c87a$var$LexerNoViableAltException.prototype, "inputStream", null);
$c936080f14a5c87a$var$__decorate([
    $ffTXa.Override
], $c936080f14a5c87a$var$LexerNoViableAltException.prototype, "toString", null);
$c936080f14a5c87a$var$LexerNoViableAltException = $c936080f14a5c87a$var$__decorate([
    $c936080f14a5c87a$var$__param(1, $ffTXa.NotNull)
], $c936080f14a5c87a$var$LexerNoViableAltException);
module.exports.LexerNoViableAltException = $c936080f14a5c87a$var$LexerNoViableAltException;

});

parcelRegister("i4PVO", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d290e23ed7d1a405$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OrderedATNConfigSet = void 0;

var $64vb9 = parcelRequire("64vb9");


var $ffTXa = parcelRequire("ffTXa");

/**
 *
 * @author Sam Harwell
 */ class $d290e23ed7d1a405$var$OrderedATNConfigSet extends $64vb9.ATNConfigSet {
    clone(readonly) {
        let copy = new $d290e23ed7d1a405$var$OrderedATNConfigSet(this, readonly);
        if (!readonly && this.isReadOnly) copy.addAll(this);
        return copy;
    }
    getKey(e) {
        // This is a specially crafted key to ensure configurations are only merged if they are equal
        return {
            state: 0,
            alt: e.hashCode()
        };
    }
    canMerge(left, leftKey, right) {
        return left.equals(right);
    }
    constructor(set, readonly){
        if (set != null && readonly != null) super(set, readonly);
        else super();
    }
}
$d290e23ed7d1a405$var$__decorate([
    $ffTXa.Override
], $d290e23ed7d1a405$var$OrderedATNConfigSet.prototype, "clone", null);
$d290e23ed7d1a405$var$__decorate([
    $ffTXa.Override
], $d290e23ed7d1a405$var$OrderedATNConfigSet.prototype, "getKey", null);
$d290e23ed7d1a405$var$__decorate([
    $ffTXa.Override
], $d290e23ed7d1a405$var$OrderedATNConfigSet.prototype, "canMerge", null);
module.exports.OrderedATNConfigSet = $d290e23ed7d1a405$var$OrderedATNConfigSet;

});

parcelRegister("gm3rl", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $be815e8722fbbcff$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NoViableAltException = void 0;

var $5XMF6 = parcelRequire("5XMF6");


var $beMqO = parcelRequire("beMqO");


var $ffTXa = parcelRequire("ffTXa");

/** Indicates that the parser could not decide which of two or more paths
 *  to take based upon the remaining input. It tracks the starting token
 *  of the offending input and also knows where the parser was
 *  in the various paths when the error. Reported by reportNoViableAlternative()
 */ class $be815e8722fbbcff$var$NoViableAltException extends $beMqO.RecognitionException {
    get startToken() {
        return this._startToken;
    }
    get deadEndConfigs() {
        return this._deadEndConfigs;
    }
    constructor(recognizer, input, startToken, offendingToken, deadEndConfigs, ctx){
        if (recognizer instanceof $5XMF6.Parser) {
            if (input === undefined) input = recognizer.inputStream;
            if (startToken === undefined) startToken = recognizer.currentToken;
            if (offendingToken === undefined) offendingToken = recognizer.currentToken;
            if (ctx === undefined) ctx = recognizer.context;
        }
        super(recognizer, input, ctx);
        this._deadEndConfigs = deadEndConfigs;
        this._startToken = startToken;
        this.setOffendingToken(recognizer, offendingToken);
    }
}
$be815e8722fbbcff$var$__decorate([
    $ffTXa.NotNull
], $be815e8722fbbcff$var$NoViableAltException.prototype, "_startToken", void 0);
module.exports.NoViableAltException = $be815e8722fbbcff$var$NoViableAltException;

});

parcelRegister("5XMF6", function(module, exports) {

var $1P2f3 = parcelRequire("1P2f3");

"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $457835b2fa78bb76$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $457835b2fa78bb76$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var $457835b2fa78bb76$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Parser = void 0;

var $3jpAZ = parcelRequire("3jpAZ");


var $3zuoE = parcelRequire("3zuoE");


var $lso6d = parcelRequire("lso6d");


var $j3UyO = parcelRequire("j3UyO");


var $g9j02 = parcelRequire("g9j02");


var $be2mo = parcelRequire("be2mo");


var $gJMeE = parcelRequire("gJMeE");


var $ffTXa = parcelRequire("ffTXa");


var $eXZgF = parcelRequire("eXZgF");


var $lORdS = parcelRequire("lORdS");


var $c6a5T = parcelRequire("c6a5T");


var $bwXFO = parcelRequire("bwXFO");


var $1FMAL = parcelRequire("1FMAL");


var $TNDGs = parcelRequire("TNDGs");

class $457835b2fa78bb76$var$TraceListener {
    enterEveryRule(ctx) {
        console.log("enter   " + this.ruleNames[ctx.ruleIndex] + ", LT(1)=" + this.tokenStream.LT(1).text);
    }
    exitEveryRule(ctx) {
        console.log("exit    " + this.ruleNames[ctx.ruleIndex] + ", LT(1)=" + this.tokenStream.LT(1).text);
    }
    visitErrorNode(node) {
    // intentionally empty
    }
    visitTerminal(node) {
        let parent = node.parent.ruleContext;
        let token = node.symbol;
        console.log("consume " + token + " rule " + this.ruleNames[parent.ruleIndex]);
    }
    constructor(ruleNames, tokenStream){
        this.ruleNames = ruleNames;
        this.tokenStream = tokenStream;
    }
}
$457835b2fa78bb76$var$__decorate([
    $ffTXa.Override
], $457835b2fa78bb76$var$TraceListener.prototype, "enterEveryRule", null);
$457835b2fa78bb76$var$__decorate([
    $ffTXa.Override
], $457835b2fa78bb76$var$TraceListener.prototype, "exitEveryRule", null);
$457835b2fa78bb76$var$__decorate([
    $ffTXa.Override
], $457835b2fa78bb76$var$TraceListener.prototype, "visitErrorNode", null);
$457835b2fa78bb76$var$__decorate([
    $ffTXa.Override
], $457835b2fa78bb76$var$TraceListener.prototype, "visitTerminal", null);



/** This is all the parsing support code essentially; most of it is error recovery stuff. */ class $457835b2fa78bb76$var$Parser extends $bwXFO.Recognizer {
    reset(resetInput) {
        // Note: this method executes when not parsing, so _ctx can be undefined
        if (resetInput === undefined || resetInput) this.inputStream.seek(0);
        this._errHandler.reset(this);
        this._ctx = undefined;
        this._syntaxErrors = 0;
        this.matchedEOF = false;
        this.isTrace = false;
        this._precedenceStack.clear();
        this._precedenceStack.push(0);
        let interpreter = this.interpreter;
        if (interpreter != null) interpreter.reset();
    }
    /**
     * Match current input symbol against `ttype`. If the symbol type
     * matches, {@link ANTLRErrorStrategy#reportMatch} and {@link #consume} are
     * called to complete the match process.
     *
     * If the symbol type does not match,
     * {@link ANTLRErrorStrategy#recoverInline} is called on the current error
     * strategy to attempt recovery. If {@link #getBuildParseTree} is
     * `true` and the token index of the symbol returned by
     * {@link ANTLRErrorStrategy#recoverInline} is -1, the symbol is added to
     * the parse tree by calling {@link #createErrorNode(ParserRuleContext, Token)} then
     * {@link ParserRuleContext#addErrorNode(ErrorNode)}.
     *
     * @param ttype the token type to match
     * @returns the matched symbol
     * @ if the current input symbol did not match
     * `ttype` and the error strategy could not recover from the
     * mismatched symbol
     */ match(ttype) {
        let t = this.currentToken;
        if (t.type === ttype) {
            if (ttype === $TNDGs.Token.EOF) this.matchedEOF = true;
            this._errHandler.reportMatch(this);
            this.consume();
        } else {
            t = this._errHandler.recoverInline(this);
            if (this._buildParseTrees && t.tokenIndex === -1) // we must have conjured up a new token during single token insertion
            // if it's not the current symbol
            this._ctx.addErrorNode(this.createErrorNode(this._ctx, t));
        }
        return t;
    }
    /**
     * Match current input symbol as a wildcard. If the symbol type matches
     * (i.e. has a value greater than 0), {@link ANTLRErrorStrategy#reportMatch}
     * and {@link #consume} are called to complete the match process.
     *
     * If the symbol type does not match,
     * {@link ANTLRErrorStrategy#recoverInline} is called on the current error
     * strategy to attempt recovery. If {@link #getBuildParseTree} is
     * `true` and the token index of the symbol returned by
     * {@link ANTLRErrorStrategy#recoverInline} is -1, the symbol is added to
     * the parse tree by calling {@link Parser#createErrorNode(ParserRuleContext, Token)} then
     * {@link ParserRuleContext#addErrorNode(ErrorNode)}.
     *
     * @returns the matched symbol
     * @ if the current input symbol did not match
     * a wildcard and the error strategy could not recover from the mismatched
     * symbol
     */ matchWildcard() {
        let t = this.currentToken;
        if (t.type > 0) {
            this._errHandler.reportMatch(this);
            this.consume();
        } else {
            t = this._errHandler.recoverInline(this);
            if (this._buildParseTrees && t.tokenIndex === -1) // we must have conjured up a new token during single token insertion
            // if it's not the current symbol
            this._ctx.addErrorNode(this.createErrorNode(this._ctx, t));
        }
        return t;
    }
    /**
     * Track the {@link ParserRuleContext} objects during the parse and hook
     * them up using the {@link ParserRuleContext#children} list so that it
     * forms a parse tree. The {@link ParserRuleContext} returned from the start
     * rule represents the root of the parse tree.
     *
     * Note that if we are not building parse trees, rule contexts only point
     * upwards. When a rule exits, it returns the context but that gets garbage
     * collected if nobody holds a reference. It points upwards but nobody
     * points at it.
     *
     * When we build parse trees, we are adding all of these contexts to
     * {@link ParserRuleContext#children} list. Contexts are then not candidates
     * for garbage collection.
     */ set buildParseTree(buildParseTrees) {
        this._buildParseTrees = buildParseTrees;
    }
    /**
     * Gets whether or not a complete parse tree will be constructed while
     * parsing. This property is `true` for a newly constructed parser.
     *
     * @returns `true` if a complete parse tree will be constructed while
     * parsing, otherwise `false`
     */ get buildParseTree() {
        return this._buildParseTrees;
    }
    getParseListeners() {
        return this._parseListeners;
    }
    /**
     * Registers `listener` to receive events during the parsing process.
     *
     * To support output-preserving grammar transformations (including but not
     * limited to left-recursion removal, automated left-factoring, and
     * optimized code generation), calls to listener methods during the parse
     * may differ substantially from calls made by
     * {@link ParseTreeWalker#DEFAULT} used after the parse is complete. In
     * particular, rule entry and exit events may occur in a different order
     * during the parse than after the parser. In addition, calls to certain
     * rule entry methods may be omitted.
     *
     * With the following specific exceptions, calls to listener events are
     * *deterministic*, i.e. for identical input the calls to listener
     * methods will be the same.
     *
     * * Alterations to the grammar used to generate code may change the
     *   behavior of the listener calls.
     * * Alterations to the command line options passed to ANTLR 4 when
     *   generating the parser may change the behavior of the listener calls.
     * * Changing the version of the ANTLR Tool used to generate the parser
     *   may change the behavior of the listener calls.
     *
     * @param listener the listener to add
     *
     * @throws {@link TypeError} if `listener` is `undefined`
     */ addParseListener(listener) {
        if (listener == null) throw new TypeError("listener cannot be null");
        this._parseListeners.push(listener);
    }
    /**
     * Remove `listener` from the list of parse listeners.
     *
     * If `listener` is `undefined` or has not been added as a parse
     * listener, this method does nothing.
     *
     * @see #addParseListener
     *
     * @param listener the listener to remove
     */ removeParseListener(listener) {
        let index = this._parseListeners.findIndex((l)=>l === listener);
        if (index !== -1) this._parseListeners.splice(index, 1);
    }
    /**
     * Remove all parse listeners.
     *
     * @see #addParseListener
     */ removeParseListeners() {
        this._parseListeners.length = 0;
    }
    /**
     * Notify any parse listeners of an enter rule event.
     *
     * @see #addParseListener
     */ triggerEnterRuleEvent() {
        for (let listener of this._parseListeners){
            if (listener.enterEveryRule) listener.enterEveryRule(this._ctx);
            this._ctx.enterRule(listener);
        }
    }
    /**
     * Notify any parse listeners of an exit rule event.
     *
     * @see #addParseListener
     */ triggerExitRuleEvent() {
        // reverse order walk of listeners
        for(let i = this._parseListeners.length - 1; i >= 0; i--){
            let listener = this._parseListeners[i];
            this._ctx.exitRule(listener);
            if (listener.exitEveryRule) listener.exitEveryRule(this._ctx);
        }
    }
    /**
     * Gets the number of syntax errors reported during parsing. This value is
     * incremented each time {@link #notifyErrorListeners} is called.
     *
     * @see #notifyErrorListeners
     */ get numberOfSyntaxErrors() {
        return this._syntaxErrors;
    }
    get tokenFactory() {
        return this._input.tokenSource.tokenFactory;
    }
    /**
     * The ATN with bypass alternatives is expensive to create so we create it
     * lazily.
     *
     * @ if the current parser does not
     * implement the `serializedATN` property.
     */ getATNWithBypassAlts() {
        let serializedAtn = this.serializedATN;
        if (serializedAtn == null) throw new Error("The current parser does not support an ATN with bypass alternatives.");
        let result = $457835b2fa78bb76$var$Parser.bypassAltsAtnCache.get(serializedAtn);
        if (result == null) {
            let deserializationOptions = new $3zuoE.ATNDeserializationOptions();
            deserializationOptions.isGenerateRuleBypassTransitions = true;
            result = new $lso6d.ATNDeserializer(deserializationOptions).deserialize($3jpAZ.toCharArray(serializedAtn));
            $457835b2fa78bb76$var$Parser.bypassAltsAtnCache.set(serializedAtn, result);
        }
        return result;
    }
    compileParseTreePattern(pattern, patternRuleIndex, lexer) {
        return $457835b2fa78bb76$var$__awaiter(this, void 0, void 0, function*() {
            if (!lexer) {
                if (this.inputStream) {
                    let tokenSource = this.inputStream.tokenSource;
                    if (tokenSource instanceof $gJMeE.Lexer) lexer = tokenSource;
                }
                if (!lexer) throw new Error("Parser can't discover a lexer to use");
            }
            let currentLexer = lexer;
            let m = yield Promise.resolve().then(()=>(parcelRequire("5s5a8")));
            let matcher = new m.ParseTreePatternMatcher(currentLexer, this);
            return matcher.compile(pattern, patternRuleIndex);
        });
    }
    get errorHandler() {
        return this._errHandler;
    }
    set errorHandler(handler) {
        this._errHandler = handler;
    }
    get inputStream() {
        return this._input;
    }
    /** Set the token stream and reset the parser. */ set inputStream(input) {
        this.reset(false);
        this._input = input;
    }
    /** Match needs to return the current input symbol, which gets put
     *  into the label for the associated token ref; e.g., x=ID.
     */ get currentToken() {
        return this._input.LT(1);
    }
    notifyErrorListeners(msg, offendingToken, e) {
        if (offendingToken === undefined) offendingToken = this.currentToken;
        else if (offendingToken === null) offendingToken = undefined;
        this._syntaxErrors++;
        let line = -1;
        let charPositionInLine = -1;
        if (offendingToken != null) {
            line = offendingToken.line;
            charPositionInLine = offendingToken.charPositionInLine;
        }
        let listener = this.getErrorListenerDispatch();
        if (listener.syntaxError) listener.syntaxError(this, offendingToken, line, charPositionInLine, msg, e);
    }
    /**
     * Consume and return the [current symbol](`currentToken`).
     *
     * E.g., given the following input with `A` being the current
     * lookahead symbol, this function moves the cursor to `B` and returns
     * `A`.
     *
     * ```
     * A B
     * ^
     * ```
     *
     * If the parser is not in error recovery mode, the consumed symbol is added
     * to the parse tree using {@link ParserRuleContext#addChild(TerminalNode)}, and
     * {@link ParseTreeListener#visitTerminal} is called on any parse listeners.
     * If the parser *is* in error recovery mode, the consumed symbol is
     * added to the parse tree using {@link #createErrorNode(ParserRuleContext, Token)} then
     * {@link ParserRuleContext#addErrorNode(ErrorNode)} and
     * {@link ParseTreeListener#visitErrorNode} is called on any parse
     * listeners.
     */ consume() {
        let o = this.currentToken;
        if (o.type !== $457835b2fa78bb76$var$Parser.EOF) this.inputStream.consume();
        let hasListener = this._parseListeners.length !== 0;
        if (this._buildParseTrees || hasListener) {
            if (this._errHandler.inErrorRecoveryMode(this)) {
                let node = this._ctx.addErrorNode(this.createErrorNode(this._ctx, o));
                if (hasListener) {
                    for (let listener of this._parseListeners)if (listener.visitErrorNode) listener.visitErrorNode(node);
                }
            } else {
                let node = this.createTerminalNode(this._ctx, o);
                this._ctx.addChild(node);
                if (hasListener) {
                    for (let listener of this._parseListeners)if (listener.visitTerminal) listener.visitTerminal(node);
                }
            }
        }
        return o;
    }
    /**
     * How to create a token leaf node associated with a parent.
     * Typically, the terminal node to create is not a function of the parent.
     *
     * @since 4.7
     */ createTerminalNode(parent, t) {
        return new $1FMAL.TerminalNode(t);
    }
    /**
     * How to create an error node, given a token, associated with a parent.
     * Typically, the error node to create is not a function of the parent.
     *
     * @since 4.7
     */ createErrorNode(parent, t) {
        return new $g9j02.ErrorNode(t);
    }
    addContextToParseTree() {
        let parent = this._ctx._parent;
        // add current context to parent if we have a parent
        if (parent != null) parent.addChild(this._ctx);
    }
    /**
     * Always called by generated parsers upon entry to a rule. Access field
     * {@link #_ctx} get the current context.
     */ enterRule(localctx, state, ruleIndex) {
        this.state = state;
        this._ctx = localctx;
        this._ctx._start = this._input.LT(1);
        if (this._buildParseTrees) this.addContextToParseTree();
        this.triggerEnterRuleEvent();
    }
    enterLeftFactoredRule(localctx, state, ruleIndex) {
        this.state = state;
        if (this._buildParseTrees) {
            let factoredContext = this._ctx.getChild(this._ctx.childCount - 1);
            this._ctx.removeLastChild();
            factoredContext._parent = localctx;
            localctx.addChild(factoredContext);
        }
        this._ctx = localctx;
        this._ctx._start = this._input.LT(1);
        if (this._buildParseTrees) this.addContextToParseTree();
        this.triggerEnterRuleEvent();
    }
    exitRule() {
        if (this.matchedEOF) // if we have matched EOF, it cannot consume past EOF so we use LT(1) here
        this._ctx._stop = this._input.LT(1); // LT(1) will be end of file
        else this._ctx._stop = this._input.tryLT(-1); // stop node is what we just matched
        // trigger event on _ctx, before it reverts to parent
        this.triggerExitRuleEvent();
        this.state = this._ctx.invokingState;
        this._ctx = this._ctx._parent;
    }
    enterOuterAlt(localctx, altNum) {
        localctx.altNumber = altNum;
        // if we have new localctx, make sure we replace existing ctx
        // that is previous child of parse tree
        if (this._buildParseTrees && this._ctx !== localctx) {
            let parent = this._ctx._parent;
            if (parent != null) {
                parent.removeLastChild();
                parent.addChild(localctx);
            }
        }
        this._ctx = localctx;
    }
    /**
     * Get the precedence level for the top-most precedence rule.
     *
     * @returns The precedence level for the top-most precedence rule, or -1 if
     * the parser context is not nested within a precedence rule.
     */ get precedence() {
        if (this._precedenceStack.isEmpty) return -1;
        return this._precedenceStack.peek();
    }
    enterRecursionRule(localctx, state, ruleIndex, precedence) {
        this.state = state;
        this._precedenceStack.push(precedence);
        this._ctx = localctx;
        this._ctx._start = this._input.LT(1);
        this.triggerEnterRuleEvent(); // simulates rule entry for left-recursive rules
    }
    /** Like {@link #enterRule} but for recursive rules.
     *  Make the current context the child of the incoming localctx.
     */ pushNewRecursionContext(localctx, state, ruleIndex) {
        let previous = this._ctx;
        previous._parent = localctx;
        previous.invokingState = state;
        previous._stop = this._input.tryLT(-1);
        this._ctx = localctx;
        this._ctx._start = previous._start;
        if (this._buildParseTrees) this._ctx.addChild(previous);
        this.triggerEnterRuleEvent(); // simulates rule entry for left-recursive rules
    }
    unrollRecursionContexts(_parentctx) {
        this._precedenceStack.pop();
        this._ctx._stop = this._input.tryLT(-1);
        let retctx = this._ctx; // save current ctx (return value)
        // unroll so _ctx is as it was before call to recursive method
        if (this._parseListeners.length > 0) while(this._ctx !== _parentctx){
            this.triggerExitRuleEvent();
            this._ctx = this._ctx._parent;
        }
        else this._ctx = _parentctx;
        // hook into tree
        retctx._parent = _parentctx;
        if (this._buildParseTrees && _parentctx != null) // add return ctx into invoking rule's tree
        _parentctx.addChild(retctx);
    }
    getInvokingContext(ruleIndex) {
        let p = this._ctx;
        while(p && p.ruleIndex !== ruleIndex)p = p._parent;
        return p;
    }
    get context() {
        return this._ctx;
    }
    set context(ctx) {
        this._ctx = ctx;
    }
    precpred(localctx, precedence) {
        return precedence >= this._precedenceStack.peek();
    }
    getErrorListenerDispatch() {
        return new $c6a5T.ProxyParserErrorListener(this.getErrorListeners());
    }
    inContext(context) {
        // TODO: useful in parser?
        return false;
    }
    /**
     * Checks whether or not `symbol` can follow the current state in the
     * ATN. The behavior of this method is equivalent to the following, but is
     * implemented such that the complete context-sensitive follow set does not
     * need to be explicitly constructed.
     *
     * ```
     * return getExpectedTokens().contains(symbol);
     * ```
     *
     * @param symbol the symbol type to check
     * @returns `true` if `symbol` can follow the current state in
     * the ATN, otherwise `false`.
     */ isExpectedToken(symbol) {
        //   		return interpreter.atn.nextTokens(_ctx);
        let atn = this.interpreter.atn;
        let ctx = this._ctx;
        let s = atn.states[this.state];
        let following = atn.nextTokens(s);
        if (following.contains(symbol)) return true;
        //        System.out.println("following "+s+"="+following);
        if (!following.contains($TNDGs.Token.EPSILON)) return false;
        while(ctx != null && ctx.invokingState >= 0 && following.contains($TNDGs.Token.EPSILON)){
            let invokingState = atn.states[ctx.invokingState];
            let rt = invokingState.transition(0);
            following = atn.nextTokens(rt.followState);
            if (following.contains(symbol)) return true;
            ctx = ctx._parent;
        }
        if (following.contains($TNDGs.Token.EPSILON) && symbol === $TNDGs.Token.EOF) return true;
        return false;
    }
    get isMatchedEOF() {
        return this.matchedEOF;
    }
    /**
     * Computes the set of input symbols which could follow the current parser
     * state and context, as given by {@link #getState} and {@link #getContext},
     * respectively.
     *
     * @see ATN#getExpectedTokens(int, RuleContext)
     */ getExpectedTokens() {
        return this.atn.getExpectedTokens(this.state, this.context);
    }
    getExpectedTokensWithinCurrentRule() {
        let atn = this.interpreter.atn;
        let s = atn.states[this.state];
        return atn.nextTokens(s);
    }
    /** Get a rule's index (i.e., `RULE_ruleName` field) or -1 if not found. */ getRuleIndex(ruleName) {
        let ruleIndex = this.getRuleIndexMap().get(ruleName);
        if (ruleIndex != null) return ruleIndex;
        return -1;
    }
    get ruleContext() {
        return this._ctx;
    }
    /** Return List&lt;String&gt; of the rule names in your parser instance
     *  leading up to a call to the current rule.  You could override if
     *  you want more details such as the file/line info of where
     *  in the ATN a rule is invoked.
     *
     *  This is very useful for error messages.
     */ getRuleInvocationStack(ctx = this._ctx) {
        let p = ctx; // Workaround for Microsoft/TypeScript#14487
        let ruleNames = this.ruleNames;
        let stack = [];
        while(p != null){
            // compute what follows who invoked us
            let ruleIndex = p.ruleIndex;
            if (ruleIndex < 0) stack.push("n/a");
            else stack.push(ruleNames[ruleIndex]);
            p = p._parent;
        }
        return stack;
    }
    /** For debugging and other purposes. */ getDFAStrings() {
        let s = [];
        for (let dfa of this._interp.atn.decisionToDFA)s.push(dfa.toString(this.vocabulary, this.ruleNames));
        return s;
    }
    /** For debugging and other purposes. */ dumpDFA() {
        let seenOne = false;
        for (let dfa of this._interp.atn.decisionToDFA)if (!dfa.isEmpty) {
            if (seenOne) console.log();
            console.log("Decision " + dfa.decision + ":");
            $1P2f3.stdout.write(dfa.toString(this.vocabulary, this.ruleNames));
            seenOne = true;
        }
    }
    get sourceName() {
        return this._input.sourceName;
    }
    get parseInfo() {
        return Promise.resolve().then(()=>(parcelRequire("d2I3G"))).then((m)=>{
            let interp = this.interpreter;
            if (interp instanceof m.ProfilingATNSimulator) return new $eXZgF.ParseInfo(interp);
            return undefined;
        });
    }
    /**
     * @since 4.3
     */ setProfile(profile) {
        return $457835b2fa78bb76$var$__awaiter(this, void 0, void 0, function*() {
            let m = yield Promise.resolve().then(()=>(parcelRequire("d2I3G")));
            let interp = this.interpreter;
            if (profile) {
                if (!(interp instanceof m.ProfilingATNSimulator)) this.interpreter = new m.ProfilingATNSimulator(this);
            } else if (interp instanceof m.ProfilingATNSimulator) this.interpreter = new $lORdS.ParserATNSimulator(this.atn, this);
            this.interpreter.setPredictionMode(interp.getPredictionMode());
        });
    }
    /** During a parse is sometimes useful to listen in on the rule entry and exit
     *  events as well as token matches. This is for quick and dirty debugging.
     */ set isTrace(trace) {
        if (!trace) {
            if (this._tracer) {
                this.removeParseListener(this._tracer);
                this._tracer = undefined;
            }
        } else {
            if (this._tracer) this.removeParseListener(this._tracer);
            else this._tracer = new $457835b2fa78bb76$var$TraceListener(this.ruleNames, this._input);
            this.addParseListener(this._tracer);
        }
    }
    /**
     * Gets whether a {@link TraceListener} is registered as a parse listener
     * for the parser.
     */ get isTrace() {
        return this._tracer != null;
    }
    constructor(input){
        super();
        /**
         * The error handling strategy for the parser. The default value is a new
         * instance of {@link DefaultErrorStrategy}.
         *
         * @see #getErrorHandler
         * @see #setErrorHandler
         */ this._errHandler = new $j3UyO.DefaultErrorStrategy();
        this._precedenceStack = new $be2mo.IntegerStack();
        /**
         * Specifies whether or not the parser should construct a parse tree during
         * the parsing process. The default value is `true`.
         *
         * @see `buildParseTree`
         */ this._buildParseTrees = true;
        /**
         * The list of {@link ParseTreeListener} listeners registered to receive
         * events during the parse.
         *
         * @see #addParseListener
         */ this._parseListeners = [];
        /**
         * The number of syntax errors reported during parsing. This value is
         * incremented each time {@link #notifyErrorListeners} is called.
         */ this._syntaxErrors = 0;
        /** Indicates parser has match()ed EOF token. See {@link #exitRule()}. */ this.matchedEOF = false;
        this._precedenceStack.push(0);
        this.inputStream = input;
    }
}
/**
 * This field maps from the serialized ATN string to the deserialized {@link ATN} with
 * bypass alternatives.
 *
 * @see ATNDeserializationOptions.isGenerateRuleBypassTransitions
 */ $457835b2fa78bb76$var$Parser.bypassAltsAtnCache = new Map();
$457835b2fa78bb76$var$__decorate([
    $ffTXa.NotNull
], $457835b2fa78bb76$var$Parser.prototype, "_errHandler", void 0);
$457835b2fa78bb76$var$__decorate([
    $ffTXa.NotNull
], $457835b2fa78bb76$var$Parser.prototype, "match", null);
$457835b2fa78bb76$var$__decorate([
    $ffTXa.NotNull
], $457835b2fa78bb76$var$Parser.prototype, "matchWildcard", null);
$457835b2fa78bb76$var$__decorate([
    $ffTXa.NotNull
], $457835b2fa78bb76$var$Parser.prototype, "getParseListeners", null);
$457835b2fa78bb76$var$__decorate([
    $457835b2fa78bb76$var$__param(0, $ffTXa.NotNull)
], $457835b2fa78bb76$var$Parser.prototype, "addParseListener", null);
$457835b2fa78bb76$var$__decorate([
    $ffTXa.NotNull
], $457835b2fa78bb76$var$Parser.prototype, "getATNWithBypassAlts", null);
$457835b2fa78bb76$var$__decorate([
    $ffTXa.NotNull,
    $457835b2fa78bb76$var$__param(0, $ffTXa.NotNull)
], $457835b2fa78bb76$var$Parser.prototype, "errorHandler", null);
$457835b2fa78bb76$var$__decorate([
    $ffTXa.Override
], $457835b2fa78bb76$var$Parser.prototype, "inputStream", null);
$457835b2fa78bb76$var$__decorate([
    $ffTXa.NotNull
], $457835b2fa78bb76$var$Parser.prototype, "currentToken", null);
$457835b2fa78bb76$var$__decorate([
    $457835b2fa78bb76$var$__param(0, $ffTXa.NotNull)
], $457835b2fa78bb76$var$Parser.prototype, "enterRule", null);
$457835b2fa78bb76$var$__decorate([
    $ffTXa.Override,
    $457835b2fa78bb76$var$__param(0, $ffTXa.Nullable)
], $457835b2fa78bb76$var$Parser.prototype, "precpred", null);
$457835b2fa78bb76$var$__decorate([
    $ffTXa.Override
], $457835b2fa78bb76$var$Parser.prototype, "getErrorListenerDispatch", null);
$457835b2fa78bb76$var$__decorate([
    $ffTXa.NotNull
], $457835b2fa78bb76$var$Parser.prototype, "getExpectedTokens", null);
$457835b2fa78bb76$var$__decorate([
    $ffTXa.NotNull
], $457835b2fa78bb76$var$Parser.prototype, "getExpectedTokensWithinCurrentRule", null);
$457835b2fa78bb76$var$__decorate([
    $ffTXa.Override
], $457835b2fa78bb76$var$Parser.prototype, "parseInfo", null);
module.exports.Parser = $457835b2fa78bb76$var$Parser;

});

parcelRegister("3zuoE", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $299c381ca31fa191$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNDeserializationOptions = void 0;

var $ffTXa = parcelRequire("ffTXa");

/**
 *
 * @author Sam Harwell
 */ class $299c381ca31fa191$var$ATNDeserializationOptions {
    static get defaultOptions() {
        if ($299c381ca31fa191$var$ATNDeserializationOptions._defaultOptions == null) {
            $299c381ca31fa191$var$ATNDeserializationOptions._defaultOptions = new $299c381ca31fa191$var$ATNDeserializationOptions();
            $299c381ca31fa191$var$ATNDeserializationOptions._defaultOptions.makeReadOnly();
        }
        return $299c381ca31fa191$var$ATNDeserializationOptions._defaultOptions;
    }
    get isReadOnly() {
        return this.readOnly;
    }
    makeReadOnly() {
        this.readOnly = true;
    }
    get isVerifyATN() {
        return this.verifyATN;
    }
    set isVerifyATN(verifyATN) {
        this.throwIfReadOnly();
        this.verifyATN = verifyATN;
    }
    get isGenerateRuleBypassTransitions() {
        return this.generateRuleBypassTransitions;
    }
    set isGenerateRuleBypassTransitions(generateRuleBypassTransitions) {
        this.throwIfReadOnly();
        this.generateRuleBypassTransitions = generateRuleBypassTransitions;
    }
    get isOptimize() {
        return this.optimize;
    }
    set isOptimize(optimize) {
        this.throwIfReadOnly();
        this.optimize = optimize;
    }
    throwIfReadOnly() {
        if (this.isReadOnly) throw new Error("The object is read only.");
    }
    constructor(options){
        this.readOnly = false;
        if (options) {
            this.verifyATN = options.verifyATN;
            this.generateRuleBypassTransitions = options.generateRuleBypassTransitions;
            this.optimize = options.optimize;
        } else {
            this.verifyATN = true;
            this.generateRuleBypassTransitions = false;
            this.optimize = true;
        }
    }
}
$299c381ca31fa191$var$__decorate([
    $ffTXa.NotNull
], $299c381ca31fa191$var$ATNDeserializationOptions, "defaultOptions", null);
module.exports.ATNDeserializationOptions = $299c381ca31fa191$var$ATNDeserializationOptions;

});

parcelRegister("lso6d", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f9eee81d1a0d08a6$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f9eee81d1a0d08a6$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNDeserializer = void 0;

var $infuR = parcelRequire("infuR");


var $c90ex = parcelRequire("c90ex");


var $3pR6v = parcelRequire("3pR6v");


var $3zuoE = parcelRequire("3zuoE");


var $5dqQL = parcelRequire("5dqQL");


var $4KTBo = parcelRequire("4KTBo");


var $3yMjI = parcelRequire("3yMjI");


var $heKTD = parcelRequire("heKTD");


var $kJZRw = parcelRequire("kJZRw");


var $iuXsF = parcelRequire("iuXsF");


var $iqCbM = parcelRequire("iqCbM");


var $gh7Hp = parcelRequire("gh7Hp");


var $6AYuC = parcelRequire("6AYuC");


var $iqeSR = parcelRequire("iqeSR");


var $69z5o = parcelRequire("69z5o");


var $biTmn = parcelRequire("biTmn");


var $gWJ2Z = parcelRequire("gWJ2Z");


var $3IsE6 = parcelRequire("3IsE6");


var $dzC4v = parcelRequire("dzC4v");


var $iFBQD = parcelRequire("iFBQD");


var $fcrMf = parcelRequire("fcrMf");


var $9wWRj = parcelRequire("9wWRj");


var $9swWO = parcelRequire("9swWO");


var $fO0NG = parcelRequire("fO0NG");


var $ewXgZ = parcelRequire("ewXgZ");


var $ffTXa = parcelRequire("ffTXa");


var $37IiV = parcelRequire("37IiV");


var $lORdS = parcelRequire("lORdS");


var $eGHKd = parcelRequire("eGHKd");


var $Q73wd = parcelRequire("Q73wd");


var $aQIOE = parcelRequire("aQIOE");


var $2BviF = parcelRequire("2BviF");


var $1t50n = parcelRequire("1t50n");


var $kdHyX = parcelRequire("kdHyX");


var $9v0dI = parcelRequire("9v0dI");


var $1zwkT = parcelRequire("1zwkT");


var $3VIrd = parcelRequire("3VIrd");


var $bWUSi = parcelRequire("bWUSi");


var $e3CzM = parcelRequire("e3CzM");


var $YUl9W = parcelRequire("YUl9W");


var $TNDGs = parcelRequire("TNDGs");


var $3ImLJ = parcelRequire("3ImLJ");


var $80194 = parcelRequire("80194");


var $awsDh = parcelRequire("awsDh");

var $f9eee81d1a0d08a6$var$UnicodeDeserializingMode;
(function(UnicodeDeserializingMode) {
    UnicodeDeserializingMode[UnicodeDeserializingMode["UNICODE_BMP"] = 0] = "UNICODE_BMP";
    UnicodeDeserializingMode[UnicodeDeserializingMode["UNICODE_SMP"] = 1] = "UNICODE_SMP";
})($f9eee81d1a0d08a6$var$UnicodeDeserializingMode || ($f9eee81d1a0d08a6$var$UnicodeDeserializingMode = {}));
/**
 *
 * @author Sam Harwell
 */ class $f9eee81d1a0d08a6$var$ATNDeserializer {
    static get SERIALIZED_VERSION() {
        /* This value should never change. Updates following this version are
         * reflected as change in the unique ID SERIALIZED_UUID.
         */ return 3;
    }
    /**
     * Determines if a particular serialized representation of an ATN supports
     * a particular feature, identified by the {@link UUID} used for serializing
     * the ATN at the time the feature was first introduced.
     *
     * @param feature The {@link UUID} marking the first time the feature was
     * supported in the serialized ATN.
     * @param actualUuid The {@link UUID} of the actual serialized ATN which is
     * currently being deserialized.
     * @returns `true` if the `actualUuid` value represents a
     * serialized ATN at or after the feature identified by `feature` was
     * introduced; otherwise, `false`.
     */ static isFeatureSupported(feature, actualUuid) {
        let featureIndex = $f9eee81d1a0d08a6$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(feature));
        if (featureIndex < 0) return false;
        return $f9eee81d1a0d08a6$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(actualUuid)) >= featureIndex;
    }
    static getUnicodeDeserializer(mode) {
        if (mode === 0 /* UNICODE_BMP */ ) return {
            readUnicode: (data, p)=>{
                return $f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p]);
            },
            size: 1
        };
        else return {
            readUnicode: (data, p)=>{
                return $f9eee81d1a0d08a6$var$ATNDeserializer.toInt32(data, p);
            },
            size: 2
        };
    }
    deserialize(data) {
        data = data.slice(0);
        // Each Uint16 value in data is shifted by +2 at the entry to this method. This is an encoding optimization
        // targeting the serialized values 0 and -1 (serialized to 0xFFFF), each of which are very common in the
        // serialized form of the ATN. In the modified UTF-8 that Java uses for compiled string literals, these two
        // character values have multi-byte forms. By shifting each value by +2, they become characters 2 and 1 prior to
        // writing the string, each of which have single-byte representations. Since the shift occurs in the tool during
        // ATN serialization, each target is responsible for adjusting the values during deserialization.
        //
        // As a special case, note that the first element of data is not adjusted because it contains the major version
        // number of the serialized ATN, which was fixed at 3 at the time the value shifting was implemented.
        for(let i = 1; i < data.length; i++)data[i] = data[i] - 2 & 0xFFFF;
        let p = 0;
        let version = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p++]);
        if (version !== $f9eee81d1a0d08a6$var$ATNDeserializer.SERIALIZED_VERSION) {
            let reason = `Could not deserialize ATN with version ${version} (expected ${$f9eee81d1a0d08a6$var$ATNDeserializer.SERIALIZED_VERSION}).`;
            throw new Error(reason);
        }
        let uuid = $f9eee81d1a0d08a6$var$ATNDeserializer.toUUID(data, p);
        p += 8;
        if ($f9eee81d1a0d08a6$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(uuid)) < 0) {
            let reason = `Could not deserialize ATN with UUID ${uuid} (expected ${$f9eee81d1a0d08a6$var$ATNDeserializer.SERIALIZED_UUID} or a legacy UUID).`;
            throw new Error(reason);
        }
        let supportsLexerActions = $f9eee81d1a0d08a6$var$ATNDeserializer.isFeatureSupported($f9eee81d1a0d08a6$var$ATNDeserializer.ADDED_LEXER_ACTIONS, uuid);
        let grammarType = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p++]);
        let maxTokenType = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p++]);
        let atn = new $3pR6v.ATN(grammarType, maxTokenType);
        //
        // STATES
        //
        let loopBackStateNumbers = [];
        let endStateNumbers = [];
        let nstates = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nstates; i++){
            let stype = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p++]);
            // ignore bad type of states
            if (stype === $5dqQL.ATNStateType.INVALID_TYPE) {
                atn.addState(new $biTmn.InvalidState());
                continue;
            }
            let ruleIndex = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p++]);
            if (ruleIndex === 0xFFFF) ruleIndex = -1;
            let s = this.stateFactory(stype, ruleIndex);
            if (stype === $5dqQL.ATNStateType.LOOP_END) {
                let loopBackStateNumber = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p++]);
                loopBackStateNumbers.push([
                    s,
                    loopBackStateNumber
                ]);
            } else if (s instanceof $iqCbM.BlockStartState) {
                let endStateNumber = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p++]);
                endStateNumbers.push([
                    s,
                    endStateNumber
                ]);
            }
            atn.addState(s);
        }
        // delay the assignment of loop back and end states until we know all the state instances have been initialized
        for (let pair of loopBackStateNumbers)pair[0].loopBackState = atn.states[pair[1]];
        for (let pair of endStateNumbers)pair[0].endState = atn.states[pair[1]];
        let numNonGreedyStates = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < numNonGreedyStates; i++){
            let stateNumber = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p++]);
            atn.states[stateNumber].nonGreedy = true;
        }
        let numSllDecisions = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < numSllDecisions; i++){
            let stateNumber = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p++]);
            atn.states[stateNumber].sll = true;
        }
        let numPrecedenceStates = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < numPrecedenceStates; i++){
            let stateNumber = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p++]);
            atn.states[stateNumber].isPrecedenceRule = true;
        }
        //
        // RULES
        //
        let nrules = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p++]);
        if (atn.grammarType === 0 /* LEXER */ ) atn.ruleToTokenType = new Int32Array(nrules);
        atn.ruleToStartState = new Array(nrules);
        for(let i = 0; i < nrules; i++){
            let s = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p++]);
            let startState = atn.states[s];
            startState.leftFactored = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p++]) !== 0;
            atn.ruleToStartState[i] = startState;
            if (atn.grammarType === 0 /* LEXER */ ) {
                let tokenType = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p++]);
                if (tokenType === 0xFFFF) tokenType = $TNDGs.Token.EOF;
                atn.ruleToTokenType[i] = tokenType;
                if (!$f9eee81d1a0d08a6$var$ATNDeserializer.isFeatureSupported($f9eee81d1a0d08a6$var$ATNDeserializer.ADDED_LEXER_ACTIONS, uuid)) {
                    // this piece of unused metadata was serialized prior to the
                    // addition of LexerAction
                    let actionIndexIgnored = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p++]);
                    if (actionIndexIgnored === 0xFFFF) actionIndexIgnored = -1;
                }
            }
        }
        atn.ruleToStopState = new Array(nrules);
        for (let state of atn.states){
            if (!(state instanceof $9v0dI.RuleStopState)) continue;
            atn.ruleToStopState[state.ruleIndex] = state;
            atn.ruleToStartState[state.ruleIndex].stopState = state;
        }
        //
        // MODES
        //
        let nmodes = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nmodes; i++){
            let s = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p++]);
            atn.modeToStartState.push(atn.states[s]);
        }
        atn.modeToDFA = new Array(nmodes);
        for(let i = 0; i < nmodes; i++)atn.modeToDFA[i] = new $6AYuC.DFA(atn.modeToStartState[i]);
        //
        // SETS
        //
        let sets = [];
        // First, read all sets with 16-bit Unicode code points <= U+FFFF.
        p = this.deserializeSets(data, p, sets, $f9eee81d1a0d08a6$var$ATNDeserializer.getUnicodeDeserializer(0 /* UNICODE_BMP */ ));
        // Next, if the ATN was serialized with the Unicode SMP feature,
        // deserialize sets with 32-bit arguments <= U+10FFFF.
        if ($f9eee81d1a0d08a6$var$ATNDeserializer.isFeatureSupported($f9eee81d1a0d08a6$var$ATNDeserializer.ADDED_UNICODE_SMP, uuid)) p = this.deserializeSets(data, p, sets, $f9eee81d1a0d08a6$var$ATNDeserializer.getUnicodeDeserializer(1 /* UNICODE_SMP */ ));
        //
        // EDGES
        //
        let nedges = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nedges; i++){
            let src = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p]);
            let trg = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p + 1]);
            let ttype = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p + 2]);
            let arg1 = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p + 3]);
            let arg2 = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p + 4]);
            let arg3 = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p + 5]);
            let trans = this.edgeFactory(atn, ttype, src, trg, arg1, arg2, arg3, sets);
            // console.log(`EDGE ${trans.constructor.name} ${src}->${trg} ${Transition.serializationNames[ttype]} ${arg1},${arg2},${arg3}`);
            let srcState = atn.states[src];
            srcState.addTransition(trans);
            p += 6;
        }
        let returnTransitionsSet = new $c90ex.Array2DHashSet({
            hashCode: (o)=>o.stopState ^ o.returnState ^ o.outermostPrecedenceReturn,
            equals: (a, b)=>{
                return a.stopState === b.stopState && a.returnState === b.returnState && a.outermostPrecedenceReturn === b.outermostPrecedenceReturn;
            }
        });
        let returnTransitions = [];
        for (let state of atn.states){
            let returningToLeftFactored = state.ruleIndex >= 0 && atn.ruleToStartState[state.ruleIndex].leftFactored;
            for(let i = 0; i < state.numberOfTransitions; i++){
                let t = state.transition(i);
                if (!(t instanceof $1zwkT.RuleTransition)) continue;
                let ruleTransition = t;
                let returningFromLeftFactored = atn.ruleToStartState[ruleTransition.target.ruleIndex].leftFactored;
                if (!returningFromLeftFactored && returningToLeftFactored) continue;
                let outermostPrecedenceReturn = -1;
                if (atn.ruleToStartState[ruleTransition.target.ruleIndex].isPrecedenceRule) {
                    if (ruleTransition.precedence === 0) outermostPrecedenceReturn = ruleTransition.target.ruleIndex;
                }
                let current = {
                    stopState: ruleTransition.target.ruleIndex,
                    returnState: ruleTransition.followState.stateNumber,
                    outermostPrecedenceReturn: outermostPrecedenceReturn
                };
                if (returnTransitionsSet.add(current)) returnTransitions.push(current);
            }
        }
        // Add all elements from returnTransitions to the ATN
        for (let returnTransition of returnTransitions){
            let transition = new $iqeSR.EpsilonTransition(atn.states[returnTransition.returnState], returnTransition.outermostPrecedenceReturn);
            atn.ruleToStopState[returnTransition.stopState].addTransition(transition);
        }
        for (let state of atn.states){
            if (state instanceof $iqCbM.BlockStartState) {
                // we need to know the end state to set its start state
                if (state.endState === undefined) throw new Error("IllegalStateException");
                // block end states can only be associated to a single block start state
                if (state.endState.startState !== undefined) throw new Error("IllegalStateException");
                state.endState.startState = state;
            }
            if (state instanceof $Q73wd.PlusLoopbackState) {
                let loopbackState = state;
                for(let i = 0; i < loopbackState.numberOfTransitions; i++){
                    let target = loopbackState.transition(i).target;
                    if (target instanceof $eGHKd.PlusBlockStartState) target.loopBackState = loopbackState;
                }
            } else if (state instanceof $e3CzM.StarLoopbackState) {
                let loopbackState = state;
                for(let i = 0; i < loopbackState.numberOfTransitions; i++){
                    let target = loopbackState.transition(i).target;
                    if (target instanceof $YUl9W.StarLoopEntryState) target.loopBackState = loopbackState;
                }
            }
        }
        //
        // DECISIONS
        //
        let ndecisions = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 1; i <= ndecisions; i++){
            let s = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p++]);
            let decState = atn.states[s];
            atn.decisionToState.push(decState);
            decState.decision = i - 1;
        }
        //
        // LEXER ACTIONS
        //
        if (atn.grammarType === 0 /* LEXER */ ) {
            if (supportsLexerActions) {
                atn.lexerActions = new Array($f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p++]));
                for(let i = 0; i < atn.lexerActions.length; i++){
                    let actionType = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p++]);
                    let data1 = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p++]);
                    if (data1 === 0xFFFF) data1 = -1;
                    let data2 = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p++]);
                    if (data2 === 0xFFFF) data2 = -1;
                    let lexerAction = this.lexerActionFactory(actionType, data1, data2);
                    atn.lexerActions[i] = lexerAction;
                }
            } else {
                // for compatibility with older serialized ATNs, convert the old
                // serialized action index for action transitions to the new
                // form, which is the index of a LexerCustomAction
                let legacyLexerActions = [];
                for (let state of atn.states)for(let i = 0; i < state.numberOfTransitions; i++){
                    let transition = state.transition(i);
                    if (!(transition instanceof $infuR.ActionTransition)) continue;
                    let ruleIndex = transition.ruleIndex;
                    let actionIndex = transition.actionIndex;
                    let lexerAction = new $3IsE6.LexerCustomAction(ruleIndex, actionIndex);
                    state.setTransition(i, new $infuR.ActionTransition(transition.target, ruleIndex, legacyLexerActions.length, false));
                    legacyLexerActions.push(lexerAction);
                }
                atn.lexerActions = legacyLexerActions;
            }
        }
        this.markPrecedenceDecisions(atn);
        atn.decisionToDFA = new Array(ndecisions);
        for(let i = 0; i < ndecisions; i++)atn.decisionToDFA[i] = new $6AYuC.DFA(atn.decisionToState[i], i);
        if (this.deserializationOptions.isVerifyATN) this.verifyATN(atn);
        if (this.deserializationOptions.isGenerateRuleBypassTransitions && atn.grammarType === 1 /* PARSER */ ) {
            atn.ruleToTokenType = new Int32Array(atn.ruleToStartState.length);
            for(let i = 0; i < atn.ruleToStartState.length; i++)atn.ruleToTokenType[i] = atn.maxTokenType + i + 1;
            for(let i = 0; i < atn.ruleToStartState.length; i++){
                let bypassStart = new $3yMjI.BasicBlockStartState();
                bypassStart.ruleIndex = i;
                atn.addState(bypassStart);
                let bypassStop = new $iuXsF.BlockEndState();
                bypassStop.ruleIndex = i;
                atn.addState(bypassStop);
                bypassStart.endState = bypassStop;
                atn.defineDecisionState(bypassStart);
                bypassStop.startState = bypassStart;
                let endState;
                let excludeTransition;
                if (atn.ruleToStartState[i].isPrecedenceRule) {
                    // wrap from the beginning of the rule to the StarLoopEntryState
                    endState = undefined;
                    for (let state of atn.states){
                        if (state.ruleIndex !== i) continue;
                        if (!(state instanceof $YUl9W.StarLoopEntryState)) continue;
                        let maybeLoopEndState = state.transition(state.numberOfTransitions - 1).target;
                        if (!(maybeLoopEndState instanceof $ewXgZ.LoopEndState)) continue;
                        if (maybeLoopEndState.epsilonOnlyTransitions && maybeLoopEndState.transition(0).target instanceof $9v0dI.RuleStopState) {
                            endState = state;
                            break;
                        }
                    }
                    if (!endState) throw new Error("Couldn't identify final state of the precedence rule prefix section.");
                    excludeTransition = endState.loopBackState.transition(0);
                } else endState = atn.ruleToStopState[i];
                // all non-excluded transitions that currently target end state need to target blockEnd instead
                for (let state of atn.states)for(let i = 0; i < state.numberOfTransitions; i++){
                    let transition = state.transition(i);
                    if (transition === excludeTransition) continue;
                    if (transition.target === endState) transition.target = bypassStop;
                }
                // all transitions leaving the rule start state need to leave blockStart instead
                while(atn.ruleToStartState[i].numberOfTransitions > 0){
                    let transition = atn.ruleToStartState[i].removeTransition(atn.ruleToStartState[i].numberOfTransitions - 1);
                    bypassStart.addTransition(transition);
                }
                // link the new states
                atn.ruleToStartState[i].addTransition(new $iqeSR.EpsilonTransition(bypassStart));
                bypassStop.addTransition(new $iqeSR.EpsilonTransition(endState));
                let matchState = new $heKTD.BasicState();
                atn.addState(matchState);
                matchState.addTransition(new $4KTBo.AtomTransition(bypassStop, atn.ruleToTokenType[i]));
                bypassStart.addTransition(new $iqeSR.EpsilonTransition(matchState));
            }
            if (this.deserializationOptions.isVerifyATN) // reverify after modification
            this.verifyATN(atn);
        }
        if (this.deserializationOptions.isOptimize) {
            while(true){
                let optimizationCount = 0;
                optimizationCount += $f9eee81d1a0d08a6$var$ATNDeserializer.inlineSetRules(atn);
                optimizationCount += $f9eee81d1a0d08a6$var$ATNDeserializer.combineChainedEpsilons(atn);
                let preserveOrder = atn.grammarType === 0 /* LEXER */ ;
                optimizationCount += $f9eee81d1a0d08a6$var$ATNDeserializer.optimizeSets(atn, preserveOrder);
                if (optimizationCount === 0) break;
            }
            if (this.deserializationOptions.isVerifyATN) // reverify after modification
            this.verifyATN(atn);
        }
        $f9eee81d1a0d08a6$var$ATNDeserializer.identifyTailCalls(atn);
        return atn;
    }
    deserializeSets(data, p, sets, unicodeDeserializer) {
        let nsets = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nsets; i++){
            let nintervals = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p]);
            p++;
            let set = new $69z5o.IntervalSet();
            sets.push(set);
            let containsEof = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt(data[p++]) !== 0;
            if (containsEof) set.add(-1);
            for(let j = 0; j < nintervals; j++){
                let a = unicodeDeserializer.readUnicode(data, p);
                p += unicodeDeserializer.size;
                let b = unicodeDeserializer.readUnicode(data, p);
                p += unicodeDeserializer.size;
                set.add(a, b);
            }
        }
        return p;
    }
    /**
     * Analyze the {@link StarLoopEntryState} states in the specified ATN to set
     * the {@link StarLoopEntryState#precedenceRuleDecision} field to the
     * correct value.
     *
     * @param atn The ATN.
     */ markPrecedenceDecisions(atn) {
        // Map rule index -> precedence decision for that rule
        let rulePrecedenceDecisions = new Map();
        for (let state of atn.states){
            if (!(state instanceof $YUl9W.StarLoopEntryState)) continue;
            /* We analyze the ATN to determine if this ATN decision state is the
             * decision for the closure block that determines whether a
             * precedence rule should continue or complete.
             */ if (atn.ruleToStartState[state.ruleIndex].isPrecedenceRule) {
                let maybeLoopEndState = state.transition(state.numberOfTransitions - 1).target;
                if (maybeLoopEndState instanceof $ewXgZ.LoopEndState) {
                    if (maybeLoopEndState.epsilonOnlyTransitions && maybeLoopEndState.transition(0).target instanceof $9v0dI.RuleStopState) {
                        rulePrecedenceDecisions.set(state.ruleIndex, state);
                        state.precedenceRuleDecision = true;
                        state.precedenceLoopbackStates = new $kJZRw.BitSet(atn.states.length);
                    }
                }
            }
        }
        // After marking precedence decisions, we go back through and fill in
        // StarLoopEntryState.precedenceLoopbackStates.
        for (let precedenceDecision of rulePrecedenceDecisions)for (let transition of atn.ruleToStopState[precedenceDecision[0]].getTransitions()){
            if (transition.serializationType !== 1 /* EPSILON */ ) continue;
            let epsilonTransition = transition;
            if (epsilonTransition.outermostPrecedenceReturn !== -1) continue;
            precedenceDecision[1].precedenceLoopbackStates.set(transition.target.stateNumber);
        }
    }
    verifyATN(atn) {
        // verify assumptions
        for (let state of atn.states){
            this.checkCondition(state !== undefined, "ATN states should not be undefined.");
            if (state.stateType === $5dqQL.ATNStateType.INVALID_TYPE) continue;
            this.checkCondition(state.onlyHasEpsilonTransitions || state.numberOfTransitions <= 1);
            if (state instanceof $eGHKd.PlusBlockStartState) this.checkCondition(state.loopBackState !== undefined);
            if (state instanceof $YUl9W.StarLoopEntryState) {
                let starLoopEntryState = state;
                this.checkCondition(starLoopEntryState.loopBackState !== undefined);
                this.checkCondition(starLoopEntryState.numberOfTransitions === 2);
                if (starLoopEntryState.transition(0).target instanceof $bWUSi.StarBlockStartState) {
                    this.checkCondition(starLoopEntryState.transition(1).target instanceof $ewXgZ.LoopEndState);
                    this.checkCondition(!starLoopEntryState.nonGreedy);
                } else if (starLoopEntryState.transition(0).target instanceof $ewXgZ.LoopEndState) {
                    this.checkCondition(starLoopEntryState.transition(1).target instanceof $bWUSi.StarBlockStartState);
                    this.checkCondition(starLoopEntryState.nonGreedy);
                } else throw new Error("IllegalStateException");
            }
            if (state instanceof $e3CzM.StarLoopbackState) {
                this.checkCondition(state.numberOfTransitions === 1);
                this.checkCondition(state.transition(0).target instanceof $YUl9W.StarLoopEntryState);
            }
            if (state instanceof $ewXgZ.LoopEndState) this.checkCondition(state.loopBackState !== undefined);
            if (state instanceof $kdHyX.RuleStartState) this.checkCondition(state.stopState !== undefined);
            if (state instanceof $iqCbM.BlockStartState) this.checkCondition(state.endState !== undefined);
            if (state instanceof $iuXsF.BlockEndState) this.checkCondition(state.startState !== undefined);
            if (state instanceof $gh7Hp.DecisionState) {
                let decisionState = state;
                this.checkCondition(decisionState.numberOfTransitions <= 1 || decisionState.decision >= 0);
            } else this.checkCondition(state.numberOfTransitions <= 1 || state instanceof $9v0dI.RuleStopState);
        }
    }
    checkCondition(condition, message) {
        if (!condition) throw new Error("IllegalStateException: " + message);
    }
    static inlineSetRules(atn) {
        let inlinedCalls = 0;
        let ruleToInlineTransition = new Array(atn.ruleToStartState.length);
        for(let i = 0; i < atn.ruleToStartState.length; i++){
            let startState = atn.ruleToStartState[i];
            let middleState = startState;
            while(middleState.onlyHasEpsilonTransitions && middleState.numberOfOptimizedTransitions === 1 && middleState.getOptimizedTransition(0).serializationType === 1 /* EPSILON */ )middleState = middleState.getOptimizedTransition(0).target;
            if (middleState.numberOfOptimizedTransitions !== 1) continue;
            let matchTransition = middleState.getOptimizedTransition(0);
            let matchTarget = matchTransition.target;
            if (matchTransition.isEpsilon || !matchTarget.onlyHasEpsilonTransitions || matchTarget.numberOfOptimizedTransitions !== 1 || !(matchTarget.getOptimizedTransition(0).target instanceof $9v0dI.RuleStopState)) continue;
            switch(matchTransition.serializationType){
                case 5 /* ATOM */ :
                case 2 /* RANGE */ :
                case 7 /* SET */ :
                    ruleToInlineTransition[i] = matchTransition;
                    break;
                case 8 /* NOT_SET */ :
                case 9 /* WILDCARD */ :
                    continue;
                default:
                    continue;
            }
        }
        for (let state of atn.states){
            if (state.ruleIndex < 0) continue;
            let optimizedTransitions;
            for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                let transition = state.getOptimizedTransition(i);
                if (!(transition instanceof $1zwkT.RuleTransition)) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue;
                }
                let ruleTransition = transition;
                let effective = ruleToInlineTransition[ruleTransition.target.ruleIndex];
                if (effective === undefined) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue;
                }
                if (optimizedTransitions === undefined) {
                    optimizedTransitions = [];
                    for(let j = 0; j < i; j++)optimizedTransitions.push(state.getOptimizedTransition(i));
                }
                inlinedCalls++;
                let target = ruleTransition.followState;
                let intermediateState = new $heKTD.BasicState();
                intermediateState.setRuleIndex(target.ruleIndex);
                atn.addState(intermediateState);
                optimizedTransitions.push(new $iqeSR.EpsilonTransition(intermediateState));
                switch(effective.serializationType){
                    case 5 /* ATOM */ :
                        intermediateState.addTransition(new $4KTBo.AtomTransition(target, effective._label));
                        break;
                    case 2 /* RANGE */ :
                        intermediateState.addTransition(new $1t50n.RangeTransition(target, effective.from, effective.to));
                        break;
                    case 7 /* SET */ :
                        intermediateState.addTransition(new $3VIrd.SetTransition(target, effective.label));
                        break;
                    default:
                        throw new Error("UnsupportedOperationException");
                }
            }
            if (optimizedTransitions !== undefined) {
                if (state.isOptimized) while(state.numberOfOptimizedTransitions > 0)state.removeOptimizedTransition(state.numberOfOptimizedTransitions - 1);
                for (let transition of optimizedTransitions)state.addOptimizedTransition(transition);
            }
        }
        if ($lORdS.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + inlinedCalls + " rule invocations by inlining sets.");
        return inlinedCalls;
    }
    static combineChainedEpsilons(atn) {
        let removedEdges = 0;
        for (let state of atn.states){
            if (!state.onlyHasEpsilonTransitions || state instanceof $9v0dI.RuleStopState) continue;
            let optimizedTransitions;
            nextTransition: for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                let transition = state.getOptimizedTransition(i);
                let intermediate = transition.target;
                if (transition.serializationType !== 1 /* EPSILON */  || transition.outermostPrecedenceReturn !== -1 || intermediate.stateType !== $5dqQL.ATNStateType.BASIC || !intermediate.onlyHasEpsilonTransitions) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue nextTransition;
                }
                for(let j = 0; j < intermediate.numberOfOptimizedTransitions; j++)if (intermediate.getOptimizedTransition(j).serializationType !== 1 /* EPSILON */  || intermediate.getOptimizedTransition(j).outermostPrecedenceReturn !== -1) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue nextTransition;
                }
                removedEdges++;
                if (optimizedTransitions === undefined) {
                    optimizedTransitions = [];
                    for(let j = 0; j < i; j++)optimizedTransitions.push(state.getOptimizedTransition(j));
                }
                for(let j = 0; j < intermediate.numberOfOptimizedTransitions; j++){
                    let target = intermediate.getOptimizedTransition(j).target;
                    optimizedTransitions.push(new $iqeSR.EpsilonTransition(target));
                }
            }
            if (optimizedTransitions !== undefined) {
                if (state.isOptimized) while(state.numberOfOptimizedTransitions > 0)state.removeOptimizedTransition(state.numberOfOptimizedTransitions - 1);
                for (let transition of optimizedTransitions)state.addOptimizedTransition(transition);
            }
        }
        if ($lORdS.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + removedEdges + " transitions by combining chained epsilon transitions.");
        return removedEdges;
    }
    static optimizeSets(atn, preserveOrder) {
        if (preserveOrder) // this optimization currently doesn't preserve edge order.
        return 0;
        let removedPaths = 0;
        let decisions = atn.decisionToState;
        for (let decision of decisions){
            let setTransitions = new $69z5o.IntervalSet();
            for(let i = 0; i < decision.numberOfOptimizedTransitions; i++){
                let epsTransition = decision.getOptimizedTransition(i);
                if (!(epsTransition instanceof $iqeSR.EpsilonTransition)) continue;
                if (epsTransition.target.numberOfOptimizedTransitions !== 1) continue;
                let transition = epsTransition.target.getOptimizedTransition(0);
                if (!(transition.target instanceof $iuXsF.BlockEndState)) continue;
                if (transition instanceof $37IiV.NotSetTransition) continue;
                if (transition instanceof $4KTBo.AtomTransition || transition instanceof $1t50n.RangeTransition || transition instanceof $3VIrd.SetTransition) setTransitions.add(i);
            }
            if (setTransitions.size <= 1) continue;
            let optimizedTransitions = [];
            for(let i = 0; i < decision.numberOfOptimizedTransitions; i++)if (!setTransitions.contains(i)) optimizedTransitions.push(decision.getOptimizedTransition(i));
            let blockEndState = decision.getOptimizedTransition(setTransitions.minElement).target.getOptimizedTransition(0).target;
            let matchSet = new $69z5o.IntervalSet();
            for (let interval of setTransitions.intervals)for(let j = interval.a; j <= interval.b; j++){
                let matchTransition = decision.getOptimizedTransition(j).target.getOptimizedTransition(0);
                if (matchTransition instanceof $37IiV.NotSetTransition) throw new Error("Not yet implemented.");
                else matchSet.addAll(matchTransition.label);
            }
            let newTransition;
            if (matchSet.intervals.length === 1) {
                if (matchSet.size === 1) newTransition = new $4KTBo.AtomTransition(blockEndState, matchSet.minElement);
                else {
                    let matchInterval = matchSet.intervals[0];
                    newTransition = new $1t50n.RangeTransition(blockEndState, matchInterval.a, matchInterval.b);
                }
            } else newTransition = new $3VIrd.SetTransition(blockEndState, matchSet);
            let setOptimizedState = new $heKTD.BasicState();
            setOptimizedState.setRuleIndex(decision.ruleIndex);
            atn.addState(setOptimizedState);
            setOptimizedState.addTransition(newTransition);
            optimizedTransitions.push(new $iqeSR.EpsilonTransition(setOptimizedState));
            removedPaths += decision.numberOfOptimizedTransitions - optimizedTransitions.length;
            if (decision.isOptimized) while(decision.numberOfOptimizedTransitions > 0)decision.removeOptimizedTransition(decision.numberOfOptimizedTransitions - 1);
            for (let transition of optimizedTransitions)decision.addOptimizedTransition(transition);
        }
        if ($lORdS.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + removedPaths + " paths by collapsing sets.");
        return removedPaths;
    }
    static identifyTailCalls(atn) {
        for (let state of atn.states){
            for(let i = 0; i < state.numberOfTransitions; i++){
                let transition = state.transition(i);
                if (!(transition instanceof $1zwkT.RuleTransition)) continue;
                transition.tailCall = this.testTailCall(atn, transition, false);
                transition.optimizedTailCall = this.testTailCall(atn, transition, true);
            }
            if (!state.isOptimized) continue;
            for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                let transition = state.getOptimizedTransition(i);
                if (!(transition instanceof $1zwkT.RuleTransition)) continue;
                transition.tailCall = this.testTailCall(atn, transition, false);
                transition.optimizedTailCall = this.testTailCall(atn, transition, true);
            }
        }
    }
    static testTailCall(atn, transition, optimizedPath) {
        if (!optimizedPath && transition.tailCall) return true;
        if (optimizedPath && transition.optimizedTailCall) return true;
        let reachable = new $kJZRw.BitSet(atn.states.length);
        let worklist = [];
        worklist.push(transition.followState);
        while(true){
            let state = worklist.pop();
            if (!state) break;
            if (reachable.get(state.stateNumber)) continue;
            if (state instanceof $9v0dI.RuleStopState) continue;
            if (!state.onlyHasEpsilonTransitions) return false;
            let transitionCount = optimizedPath ? state.numberOfOptimizedTransitions : state.numberOfTransitions;
            for(let i = 0; i < transitionCount; i++){
                let t = optimizedPath ? state.getOptimizedTransition(i) : state.transition(i);
                if (t.serializationType !== 1 /* EPSILON */ ) return false;
                worklist.push(t.target);
            }
        }
        return true;
    }
    static toInt(c) {
        return c;
    }
    static toInt32(data, offset) {
        return (data[offset] | data[offset + 1] << 16) >>> 0;
    }
    static toUUID(data, offset) {
        let leastSigBits = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt32(data, offset);
        let lessSigBits = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt32(data, offset + 2);
        let moreSigBits = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt32(data, offset + 4);
        let mostSigBits = $f9eee81d1a0d08a6$var$ATNDeserializer.toInt32(data, offset + 6);
        return new $80194.UUID(mostSigBits, moreSigBits, lessSigBits, leastSigBits);
    }
    edgeFactory(atn, type, src, trg, arg1, arg2, arg3, sets) {
        let target = atn.states[trg];
        switch(type){
            case 1 /* EPSILON */ :
                return new $iqeSR.EpsilonTransition(target);
            case 2 /* RANGE */ :
                if (arg3 !== 0) return new $1t50n.RangeTransition(target, $TNDGs.Token.EOF, arg2);
                else return new $1t50n.RangeTransition(target, arg1, arg2);
            case 3 /* RULE */ :
                let rt = new $1zwkT.RuleTransition(atn.states[arg1], arg2, arg3, target);
                return rt;
            case 4 /* PREDICATE */ :
                let pt = new $2BviF.PredicateTransition(target, arg1, arg2, arg3 !== 0);
                return pt;
            case 10 /* PRECEDENCE */ :
                return new $aQIOE.PrecedencePredicateTransition(target, arg1);
            case 5 /* ATOM */ :
                if (arg3 !== 0) return new $4KTBo.AtomTransition(target, $TNDGs.Token.EOF);
                else return new $4KTBo.AtomTransition(target, arg1);
            case 6 /* ACTION */ :
                let a = new $infuR.ActionTransition(target, arg1, arg2, arg3 !== 0);
                return a;
            case 7 /* SET */ :
                return new $3VIrd.SetTransition(target, sets[arg1]);
            case 8 /* NOT_SET */ :
                return new $37IiV.NotSetTransition(target, sets[arg1]);
            case 9 /* WILDCARD */ :
                return new $awsDh.WildcardTransition(target);
        }
        throw new Error("The specified transition type is not valid.");
    }
    stateFactory(type, ruleIndex) {
        let s;
        switch(type){
            case $5dqQL.ATNStateType.INVALID_TYPE:
                return new $biTmn.InvalidState();
            case $5dqQL.ATNStateType.BASIC:
                s = new $heKTD.BasicState();
                break;
            case $5dqQL.ATNStateType.RULE_START:
                s = new $kdHyX.RuleStartState();
                break;
            case $5dqQL.ATNStateType.BLOCK_START:
                s = new $3yMjI.BasicBlockStartState();
                break;
            case $5dqQL.ATNStateType.PLUS_BLOCK_START:
                s = new $eGHKd.PlusBlockStartState();
                break;
            case $5dqQL.ATNStateType.STAR_BLOCK_START:
                s = new $bWUSi.StarBlockStartState();
                break;
            case $5dqQL.ATNStateType.TOKEN_START:
                s = new $3ImLJ.TokensStartState();
                break;
            case $5dqQL.ATNStateType.RULE_STOP:
                s = new $9v0dI.RuleStopState();
                break;
            case $5dqQL.ATNStateType.BLOCK_END:
                s = new $iuXsF.BlockEndState();
                break;
            case $5dqQL.ATNStateType.STAR_LOOP_BACK:
                s = new $e3CzM.StarLoopbackState();
                break;
            case $5dqQL.ATNStateType.STAR_LOOP_ENTRY:
                s = new $YUl9W.StarLoopEntryState();
                break;
            case $5dqQL.ATNStateType.PLUS_LOOP_BACK:
                s = new $Q73wd.PlusLoopbackState();
                break;
            case $5dqQL.ATNStateType.LOOP_END:
                s = new $ewXgZ.LoopEndState();
                break;
            default:
                let message = `The specified state type ${type} is not valid.`;
                throw new Error(message);
        }
        s.ruleIndex = ruleIndex;
        return s;
    }
    lexerActionFactory(type, data1, data2) {
        switch(type){
            case 0 /* CHANNEL */ :
                return new $gWJ2Z.LexerChannelAction(data1);
            case 1 /* CUSTOM */ :
                return new $3IsE6.LexerCustomAction(data1, data2);
            case 2 /* MODE */ :
                return new $dzC4v.LexerModeAction(data1);
            case 3 /* MORE */ :
                return $iFBQD.LexerMoreAction.INSTANCE;
            case 4 /* POP_MODE */ :
                return $fcrMf.LexerPopModeAction.INSTANCE;
            case 5 /* PUSH_MODE */ :
                return new $9wWRj.LexerPushModeAction(data1);
            case 6 /* SKIP */ :
                return $9swWO.LexerSkipAction.INSTANCE;
            case 7 /* TYPE */ :
                return new $fO0NG.LexerTypeAction(data1);
            default:
                let message = `The specified lexer action type ${type} is not valid.`;
                throw new Error(message);
        }
    }
    constructor(deserializationOptions){
        if (deserializationOptions === undefined) deserializationOptions = $3zuoE.ATNDeserializationOptions.defaultOptions;
        this.deserializationOptions = deserializationOptions;
    }
}
/* WARNING: DO NOT MERGE THESE LINES. If UUIDs differ during a merge,
 * resolve the conflict by generating a new ID!
 */ /**
 * This is the earliest supported serialized UUID.
 */ $f9eee81d1a0d08a6$var$ATNDeserializer.BASE_SERIALIZED_UUID = $80194.UUID.fromString("E4178468-DF95-44D0-AD87-F22A5D5FB6D3");
/**
 * This UUID indicates an extension of {@link #ADDED_PRECEDENCE_TRANSITIONS}
 * for the addition of lexer actions encoded as a sequence of
 * {@link LexerAction} instances.
 */ $f9eee81d1a0d08a6$var$ATNDeserializer.ADDED_LEXER_ACTIONS = $80194.UUID.fromString("AB35191A-1603-487E-B75A-479B831EAF6D");
/**
 * This UUID indicates the serialized ATN contains two sets of
 * IntervalSets, where the second set's values are encoded as
 * 32-bit integers to support the full Unicode SMP range up to U+10FFFF.
 */ $f9eee81d1a0d08a6$var$ATNDeserializer.ADDED_UNICODE_SMP = $80194.UUID.fromString("C23FEA89-0605-4f51-AFB8-058BCAB8C91B");
/**
 * This list contains all of the currently supported UUIDs, ordered by when
 * the feature first appeared in this branch.
 */ $f9eee81d1a0d08a6$var$ATNDeserializer.SUPPORTED_UUIDS = [
    $f9eee81d1a0d08a6$var$ATNDeserializer.BASE_SERIALIZED_UUID,
    $f9eee81d1a0d08a6$var$ATNDeserializer.ADDED_LEXER_ACTIONS,
    $f9eee81d1a0d08a6$var$ATNDeserializer.ADDED_UNICODE_SMP
];
/**
 * This is the current serialized UUID.
 */ $f9eee81d1a0d08a6$var$ATNDeserializer.SERIALIZED_UUID = $f9eee81d1a0d08a6$var$ATNDeserializer.ADDED_UNICODE_SMP;
$f9eee81d1a0d08a6$var$__decorate([
    $ffTXa.NotNull
], $f9eee81d1a0d08a6$var$ATNDeserializer.prototype, "deserializationOptions", void 0);
$f9eee81d1a0d08a6$var$__decorate([
    $f9eee81d1a0d08a6$var$__param(0, $ffTXa.NotNull)
], $f9eee81d1a0d08a6$var$ATNDeserializer.prototype, "deserialize", null);
$f9eee81d1a0d08a6$var$__decorate([
    $f9eee81d1a0d08a6$var$__param(0, $ffTXa.NotNull)
], $f9eee81d1a0d08a6$var$ATNDeserializer.prototype, "markPrecedenceDecisions", null);
$f9eee81d1a0d08a6$var$__decorate([
    $ffTXa.NotNull,
    $f9eee81d1a0d08a6$var$__param(0, $ffTXa.NotNull)
], $f9eee81d1a0d08a6$var$ATNDeserializer.prototype, "edgeFactory", null);
module.exports.ATNDeserializer = $f9eee81d1a0d08a6$var$ATNDeserializer;

});

parcelRegister("infuR", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d606654c1ce9538f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d606654c1ce9538f$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActionTransition = void 0;

var $ffTXa = parcelRequire("ffTXa");


var $ikYx7 = parcelRequire("ikYx7");

let $d606654c1ce9538f$var$ActionTransition = class ActionTransition extends $ikYx7.Transition {
    get serializationType() {
        return 6 /* ACTION */ ;
    }
    get isEpsilon() {
        return true; // we are to be ignored by analysis 'cept for predicates
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    toString() {
        return "action_" + this.ruleIndex + ":" + this.actionIndex;
    }
    constructor(target, ruleIndex, actionIndex = -1, isCtxDependent = false){
        super(target);
        this.ruleIndex = ruleIndex;
        this.actionIndex = actionIndex;
        this.isCtxDependent = isCtxDependent;
    }
};
$d606654c1ce9538f$var$__decorate([
    $ffTXa.Override
], $d606654c1ce9538f$var$ActionTransition.prototype, "serializationType", null);
$d606654c1ce9538f$var$__decorate([
    $ffTXa.Override
], $d606654c1ce9538f$var$ActionTransition.prototype, "isEpsilon", null);
$d606654c1ce9538f$var$__decorate([
    $ffTXa.Override
], $d606654c1ce9538f$var$ActionTransition.prototype, "matches", null);
$d606654c1ce9538f$var$__decorate([
    $ffTXa.Override
], $d606654c1ce9538f$var$ActionTransition.prototype, "toString", null);
$d606654c1ce9538f$var$ActionTransition = $d606654c1ce9538f$var$__decorate([
    $d606654c1ce9538f$var$__param(0, $ffTXa.NotNull)
], $d606654c1ce9538f$var$ActionTransition);
module.exports.ActionTransition = $d606654c1ce9538f$var$ActionTransition;

});

parcelRegister("4KTBo", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $376696b61e54b38d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $376696b61e54b38d$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AtomTransition = void 0;

var $69z5o = parcelRequire("69z5o");


var $ffTXa = parcelRequire("ffTXa");


var $ikYx7 = parcelRequire("ikYx7");

/** TODO: make all transitions sets? no, should remove set edges */ let $376696b61e54b38d$var$AtomTransition = class AtomTransition extends $ikYx7.Transition {
    get serializationType() {
        return 5 /* ATOM */ ;
    }
    get label() {
        return $69z5o.IntervalSet.of(this._label);
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return this._label === symbol;
    }
    toString() {
        return String(this.label);
    }
    constructor(target, label){
        super(target);
        this._label = label;
    }
};
$376696b61e54b38d$var$__decorate([
    $ffTXa.Override
], $376696b61e54b38d$var$AtomTransition.prototype, "serializationType", null);
$376696b61e54b38d$var$__decorate([
    $ffTXa.Override,
    $ffTXa.NotNull
], $376696b61e54b38d$var$AtomTransition.prototype, "label", null);
$376696b61e54b38d$var$__decorate([
    $ffTXa.Override
], $376696b61e54b38d$var$AtomTransition.prototype, "matches", null);
$376696b61e54b38d$var$__decorate([
    $ffTXa.Override,
    $ffTXa.NotNull
], $376696b61e54b38d$var$AtomTransition.prototype, "toString", null);
$376696b61e54b38d$var$AtomTransition = $376696b61e54b38d$var$__decorate([
    $376696b61e54b38d$var$__param(0, $ffTXa.NotNull)
], $376696b61e54b38d$var$AtomTransition);
module.exports.AtomTransition = $376696b61e54b38d$var$AtomTransition;

});

parcelRegister("3yMjI", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $297a06d208ce9eb2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BasicBlockStartState = void 0;

var $5dqQL = parcelRequire("5dqQL");


var $iqCbM = parcelRequire("iqCbM");


var $ffTXa = parcelRequire("ffTXa");

/**
 *
 * @author Sam Harwell
 */ class $297a06d208ce9eb2$var$BasicBlockStartState extends $iqCbM.BlockStartState {
    get stateType() {
        return $5dqQL.ATNStateType.BLOCK_START;
    }
}
$297a06d208ce9eb2$var$__decorate([
    $ffTXa.Override
], $297a06d208ce9eb2$var$BasicBlockStartState.prototype, "stateType", null);
module.exports.BasicBlockStartState = $297a06d208ce9eb2$var$BasicBlockStartState;

});

parcelRegister("iqCbM", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlockStartState = void 0;

var $gh7Hp = parcelRequire("gh7Hp");

/**  The start of a regular `(...)` block. */ class $d6a8473ca0c98b30$var$BlockStartState extends $gh7Hp.DecisionState {
}
module.exports.BlockStartState = $d6a8473ca0c98b30$var$BlockStartState;

});

parcelRegister("iuXsF", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d779271aa51fa8a8$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlockEndState = void 0;

var $2UrJv = parcelRequire("2UrJv");


var $5dqQL = parcelRequire("5dqQL");


var $ffTXa = parcelRequire("ffTXa");

/** Terminal node of a simple `(a|b|c)` block. */ class $d779271aa51fa8a8$var$BlockEndState extends $2UrJv.ATNState {
    get stateType() {
        return $5dqQL.ATNStateType.BLOCK_END;
    }
}
$d779271aa51fa8a8$var$__decorate([
    $ffTXa.Override
], $d779271aa51fa8a8$var$BlockEndState.prototype, "stateType", null);
module.exports.BlockEndState = $d779271aa51fa8a8$var$BlockEndState;

});

parcelRegister("iqeSR", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d69633522b133266$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d69633522b133266$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EpsilonTransition = void 0;

var $ffTXa = parcelRequire("ffTXa");


var $ikYx7 = parcelRequire("ikYx7");

let $d69633522b133266$var$EpsilonTransition = class EpsilonTransition extends $ikYx7.Transition {
    /**
     * @returns the rule index of a precedence rule for which this transition is
     * returning from, where the precedence value is 0; otherwise, -1.
     *
     * @see ATNConfig.isPrecedenceFilterSuppressed
     * @see ParserATNSimulator#applyPrecedenceFilter(ATNConfigSet, ParserRuleContext, PredictionContextCache)
     * @since 4.4.1
     */ get outermostPrecedenceReturn() {
        return this._outermostPrecedenceReturn;
    }
    get serializationType() {
        return 1 /* EPSILON */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    toString() {
        return "epsilon";
    }
    constructor(target, outermostPrecedenceReturn = -1){
        super(target);
        this._outermostPrecedenceReturn = outermostPrecedenceReturn;
    }
};
$d69633522b133266$var$__decorate([
    $ffTXa.Override
], $d69633522b133266$var$EpsilonTransition.prototype, "serializationType", null);
$d69633522b133266$var$__decorate([
    $ffTXa.Override
], $d69633522b133266$var$EpsilonTransition.prototype, "isEpsilon", null);
$d69633522b133266$var$__decorate([
    $ffTXa.Override
], $d69633522b133266$var$EpsilonTransition.prototype, "matches", null);
$d69633522b133266$var$__decorate([
    $ffTXa.Override,
    $ffTXa.NotNull
], $d69633522b133266$var$EpsilonTransition.prototype, "toString", null);
$d69633522b133266$var$EpsilonTransition = $d69633522b133266$var$__decorate([
    $d69633522b133266$var$__param(0, $ffTXa.NotNull)
], $d69633522b133266$var$EpsilonTransition);
module.exports.EpsilonTransition = $d69633522b133266$var$EpsilonTransition;

});

parcelRegister("gWJ2Z", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c565018d6588bf7d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c565018d6588bf7d$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerChannelAction = void 0;

var $kPsXR = parcelRequire("kPsXR");


var $ffTXa = parcelRequire("ffTXa");

/**
 * Implements the `channel` lexer action by calling
 * {@link Lexer#setChannel} with the assigned channel.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $c565018d6588bf7d$var$LexerChannelAction {
    /**
     * Gets the channel to use for the {@link Token} created by the lexer.
     *
     * @returns The channel to use for the {@link Token} created by the lexer.
     */ get channel() {
        return this._channel;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#CHANNEL}.
     */ get actionType() {
        return 0 /* CHANNEL */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#setChannel} with the
     * value provided by {@link #getChannel}.
     */ execute(lexer) {
        lexer.channel = this._channel;
    }
    hashCode() {
        let hash = $kPsXR.MurmurHash.initialize();
        hash = $kPsXR.MurmurHash.update(hash, this.actionType);
        hash = $kPsXR.MurmurHash.update(hash, this._channel);
        return $kPsXR.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $c565018d6588bf7d$var$LexerChannelAction)) return false;
        return this._channel === obj._channel;
    }
    toString() {
        return `channel(${this._channel})`;
    }
    /**
     * Constructs a new `channel` action with the specified channel value.
     * @param channel The channel value to pass to {@link Lexer#setChannel}.
     */ constructor(channel){
        this._channel = channel;
    }
}
$c565018d6588bf7d$var$__decorate([
    $ffTXa.Override
], $c565018d6588bf7d$var$LexerChannelAction.prototype, "actionType", null);
$c565018d6588bf7d$var$__decorate([
    $ffTXa.Override
], $c565018d6588bf7d$var$LexerChannelAction.prototype, "isPositionDependent", null);
$c565018d6588bf7d$var$__decorate([
    $ffTXa.Override,
    $c565018d6588bf7d$var$__param(0, $ffTXa.NotNull)
], $c565018d6588bf7d$var$LexerChannelAction.prototype, "execute", null);
$c565018d6588bf7d$var$__decorate([
    $ffTXa.Override
], $c565018d6588bf7d$var$LexerChannelAction.prototype, "hashCode", null);
$c565018d6588bf7d$var$__decorate([
    $ffTXa.Override
], $c565018d6588bf7d$var$LexerChannelAction.prototype, "equals", null);
$c565018d6588bf7d$var$__decorate([
    $ffTXa.Override
], $c565018d6588bf7d$var$LexerChannelAction.prototype, "toString", null);
module.exports.LexerChannelAction = $c565018d6588bf7d$var$LexerChannelAction;

});

parcelRegister("3IsE6", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $2b4bb3a38578a23c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $2b4bb3a38578a23c$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerCustomAction = void 0;

var $kPsXR = parcelRequire("kPsXR");


var $ffTXa = parcelRequire("ffTXa");

/**
 * Executes a custom lexer action by calling {@link Recognizer#action} with the
 * rule and action indexes assigned to the custom action. The implementation of
 * a custom action is added to the generated code for the lexer in an override
 * of {@link Recognizer#action} when the grammar is compiled.
 *
 * This class may represent embedded actions created with the `{...}`
 * syntax in ANTLR 4, as well as actions created for lexer commands where the
 * command argument could not be evaluated when the grammar was compiled.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $2b4bb3a38578a23c$var$LexerCustomAction {
    /**
     * Gets the rule index to use for calls to {@link Recognizer#action}.
     *
     * @returns The rule index for the custom action.
     */ get ruleIndex() {
        return this._ruleIndex;
    }
    /**
     * Gets the action index to use for calls to {@link Recognizer#action}.
     *
     * @returns The action index for the custom action.
     */ get actionIndex() {
        return this._actionIndex;
    }
    /**
     * {@inheritDoc}
     *
     * @returns This method returns {@link LexerActionType#CUSTOM}.
     */ get actionType() {
        return 1 /* CUSTOM */ ;
    }
    /**
     * Gets whether the lexer action is position-dependent. Position-dependent
     * actions may have different semantics depending on the {@link CharStream}
     * index at the time the action is executed.
     *
     * Custom actions are position-dependent since they may represent a
     * user-defined embedded action which makes calls to methods like
     * {@link Lexer#getText}.
     *
     * @returns This method returns `true`.
     */ get isPositionDependent() {
        return true;
    }
    /**
     * {@inheritDoc}
     *
     * Custom actions are implemented by calling {@link Lexer#action} with the
     * appropriate rule and action indexes.
     */ execute(lexer) {
        lexer.action(undefined, this._ruleIndex, this._actionIndex);
    }
    hashCode() {
        let hash = $kPsXR.MurmurHash.initialize();
        hash = $kPsXR.MurmurHash.update(hash, this.actionType);
        hash = $kPsXR.MurmurHash.update(hash, this._ruleIndex);
        hash = $kPsXR.MurmurHash.update(hash, this._actionIndex);
        return $kPsXR.MurmurHash.finish(hash, 3);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $2b4bb3a38578a23c$var$LexerCustomAction)) return false;
        return this._ruleIndex === obj._ruleIndex && this._actionIndex === obj._actionIndex;
    }
    /**
     * Constructs a custom lexer action with the specified rule and action
     * indexes.
     *
     * @param ruleIndex The rule index to use for calls to
     * {@link Recognizer#action}.
     * @param actionIndex The action index to use for calls to
     * {@link Recognizer#action}.
     */ constructor(ruleIndex, actionIndex){
        this._ruleIndex = ruleIndex;
        this._actionIndex = actionIndex;
    }
}
$2b4bb3a38578a23c$var$__decorate([
    $ffTXa.Override
], $2b4bb3a38578a23c$var$LexerCustomAction.prototype, "actionType", null);
$2b4bb3a38578a23c$var$__decorate([
    $ffTXa.Override
], $2b4bb3a38578a23c$var$LexerCustomAction.prototype, "isPositionDependent", null);
$2b4bb3a38578a23c$var$__decorate([
    $ffTXa.Override,
    $2b4bb3a38578a23c$var$__param(0, $ffTXa.NotNull)
], $2b4bb3a38578a23c$var$LexerCustomAction.prototype, "execute", null);
$2b4bb3a38578a23c$var$__decorate([
    $ffTXa.Override
], $2b4bb3a38578a23c$var$LexerCustomAction.prototype, "hashCode", null);
$2b4bb3a38578a23c$var$__decorate([
    $ffTXa.Override
], $2b4bb3a38578a23c$var$LexerCustomAction.prototype, "equals", null);
module.exports.LexerCustomAction = $2b4bb3a38578a23c$var$LexerCustomAction;

});

parcelRegister("dzC4v", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9e1c137726767622$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9e1c137726767622$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerModeAction = void 0;

var $kPsXR = parcelRequire("kPsXR");


var $ffTXa = parcelRequire("ffTXa");

/**
 * Implements the `mode` lexer action by calling {@link Lexer#mode} with
 * the assigned mode.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $9e1c137726767622$var$LexerModeAction {
    /**
     * Get the lexer mode this action should transition the lexer to.
     *
     * @returns The lexer mode for this `mode` command.
     */ get mode() {
        return this._mode;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#MODE}.
     */ get actionType() {
        return 2 /* MODE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#mode} with the
     * value provided by {@link #getMode}.
     */ execute(lexer) {
        lexer.mode(this._mode);
    }
    hashCode() {
        let hash = $kPsXR.MurmurHash.initialize();
        hash = $kPsXR.MurmurHash.update(hash, this.actionType);
        hash = $kPsXR.MurmurHash.update(hash, this._mode);
        return $kPsXR.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $9e1c137726767622$var$LexerModeAction)) return false;
        return this._mode === obj._mode;
    }
    toString() {
        return `mode(${this._mode})`;
    }
    /**
     * Constructs a new `mode` action with the specified mode value.
     * @param mode The mode value to pass to {@link Lexer#mode}.
     */ constructor(mode){
        this._mode = mode;
    }
}
$9e1c137726767622$var$__decorate([
    $ffTXa.Override
], $9e1c137726767622$var$LexerModeAction.prototype, "actionType", null);
$9e1c137726767622$var$__decorate([
    $ffTXa.Override
], $9e1c137726767622$var$LexerModeAction.prototype, "isPositionDependent", null);
$9e1c137726767622$var$__decorate([
    $ffTXa.Override,
    $9e1c137726767622$var$__param(0, $ffTXa.NotNull)
], $9e1c137726767622$var$LexerModeAction.prototype, "execute", null);
$9e1c137726767622$var$__decorate([
    $ffTXa.Override
], $9e1c137726767622$var$LexerModeAction.prototype, "hashCode", null);
$9e1c137726767622$var$__decorate([
    $ffTXa.Override
], $9e1c137726767622$var$LexerModeAction.prototype, "equals", null);
$9e1c137726767622$var$__decorate([
    $ffTXa.Override
], $9e1c137726767622$var$LexerModeAction.prototype, "toString", null);
module.exports.LexerModeAction = $9e1c137726767622$var$LexerModeAction;

});

parcelRegister("iFBQD", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d9796a294a32322e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d9796a294a32322e$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerMoreAction = void 0;

var $kPsXR = parcelRequire("kPsXR");


var $ffTXa = parcelRequire("ffTXa");

/**
 * Implements the `more` lexer action by calling {@link Lexer#more}.
 *
 * The `more` command does not have any parameters, so this action is
 * implemented as a singleton instance exposed by {@link #INSTANCE}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $d9796a294a32322e$var$LexerMoreAction {
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#MORE}.
     */ get actionType() {
        return 3 /* MORE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#more}.
     */ execute(lexer) {
        lexer.more();
    }
    hashCode() {
        let hash = $kPsXR.MurmurHash.initialize();
        hash = $kPsXR.MurmurHash.update(hash, this.actionType);
        return $kPsXR.MurmurHash.finish(hash, 1);
    }
    equals(obj) {
        return obj === this;
    }
    toString() {
        return "more";
    }
    /**
     * Constructs the singleton instance of the lexer `more` command.
     */ constructor(){
    // intentionally empty
    }
}
$d9796a294a32322e$var$__decorate([
    $ffTXa.Override
], $d9796a294a32322e$var$LexerMoreAction.prototype, "actionType", null);
$d9796a294a32322e$var$__decorate([
    $ffTXa.Override
], $d9796a294a32322e$var$LexerMoreAction.prototype, "isPositionDependent", null);
$d9796a294a32322e$var$__decorate([
    $ffTXa.Override,
    $d9796a294a32322e$var$__param(0, $ffTXa.NotNull)
], $d9796a294a32322e$var$LexerMoreAction.prototype, "execute", null);
$d9796a294a32322e$var$__decorate([
    $ffTXa.Override
], $d9796a294a32322e$var$LexerMoreAction.prototype, "hashCode", null);
$d9796a294a32322e$var$__decorate([
    $ffTXa.Override
], $d9796a294a32322e$var$LexerMoreAction.prototype, "equals", null);
$d9796a294a32322e$var$__decorate([
    $ffTXa.Override
], $d9796a294a32322e$var$LexerMoreAction.prototype, "toString", null);
module.exports.LexerMoreAction = $d9796a294a32322e$var$LexerMoreAction;
(function(LexerMoreAction) {
    /**
     * Provides a singleton instance of this parameterless lexer action.
     */ LexerMoreAction.INSTANCE = new LexerMoreAction();
})($d9796a294a32322e$var$LexerMoreAction = module.exports.LexerMoreAction || (module.exports.LexerMoreAction = {}));

});

parcelRegister("fcrMf", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $b10d85fbc0370bf7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $b10d85fbc0370bf7$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerPopModeAction = void 0;

var $kPsXR = parcelRequire("kPsXR");


var $ffTXa = parcelRequire("ffTXa");

/**
 * Implements the `popMode` lexer action by calling {@link Lexer#popMode}.
 *
 * The `popMode` command does not have any parameters, so this action is
 * implemented as a singleton instance exposed by {@link #INSTANCE}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $b10d85fbc0370bf7$var$LexerPopModeAction {
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#POP_MODE}.
     */ get actionType() {
        return 4 /* POP_MODE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#popMode}.
     */ execute(lexer) {
        lexer.popMode();
    }
    hashCode() {
        let hash = $kPsXR.MurmurHash.initialize();
        hash = $kPsXR.MurmurHash.update(hash, this.actionType);
        return $kPsXR.MurmurHash.finish(hash, 1);
    }
    equals(obj) {
        return obj === this;
    }
    toString() {
        return "popMode";
    }
    /**
     * Constructs the singleton instance of the lexer `popMode` command.
     */ constructor(){
    // intentionally empty
    }
}
$b10d85fbc0370bf7$var$__decorate([
    $ffTXa.Override
], $b10d85fbc0370bf7$var$LexerPopModeAction.prototype, "actionType", null);
$b10d85fbc0370bf7$var$__decorate([
    $ffTXa.Override
], $b10d85fbc0370bf7$var$LexerPopModeAction.prototype, "isPositionDependent", null);
$b10d85fbc0370bf7$var$__decorate([
    $ffTXa.Override,
    $b10d85fbc0370bf7$var$__param(0, $ffTXa.NotNull)
], $b10d85fbc0370bf7$var$LexerPopModeAction.prototype, "execute", null);
$b10d85fbc0370bf7$var$__decorate([
    $ffTXa.Override
], $b10d85fbc0370bf7$var$LexerPopModeAction.prototype, "hashCode", null);
$b10d85fbc0370bf7$var$__decorate([
    $ffTXa.Override
], $b10d85fbc0370bf7$var$LexerPopModeAction.prototype, "equals", null);
$b10d85fbc0370bf7$var$__decorate([
    $ffTXa.Override
], $b10d85fbc0370bf7$var$LexerPopModeAction.prototype, "toString", null);
module.exports.LexerPopModeAction = $b10d85fbc0370bf7$var$LexerPopModeAction;
(function(LexerPopModeAction) {
    /**
     * Provides a singleton instance of this parameterless lexer action.
     */ LexerPopModeAction.INSTANCE = new LexerPopModeAction();
})($b10d85fbc0370bf7$var$LexerPopModeAction = module.exports.LexerPopModeAction || (module.exports.LexerPopModeAction = {}));

});

parcelRegister("9wWRj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $6f04c25d4bdc412e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $6f04c25d4bdc412e$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerPushModeAction = void 0;

var $kPsXR = parcelRequire("kPsXR");


var $ffTXa = parcelRequire("ffTXa");

/**
 * Implements the `pushMode` lexer action by calling
 * {@link Lexer#pushMode} with the assigned mode.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $6f04c25d4bdc412e$var$LexerPushModeAction {
    /**
     * Get the lexer mode this action should transition the lexer to.
     *
     * @returns The lexer mode for this `pushMode` command.
     */ get mode() {
        return this._mode;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#PUSH_MODE}.
     */ get actionType() {
        return 5 /* PUSH_MODE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#pushMode} with the
     * value provided by {@link #getMode}.
     */ execute(lexer) {
        lexer.pushMode(this._mode);
    }
    hashCode() {
        let hash = $kPsXR.MurmurHash.initialize();
        hash = $kPsXR.MurmurHash.update(hash, this.actionType);
        hash = $kPsXR.MurmurHash.update(hash, this._mode);
        return $kPsXR.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $6f04c25d4bdc412e$var$LexerPushModeAction)) return false;
        return this._mode === obj._mode;
    }
    toString() {
        return `pushMode(${this._mode})`;
    }
    /**
     * Constructs a new `pushMode` action with the specified mode value.
     * @param mode The mode value to pass to {@link Lexer#pushMode}.
     */ constructor(mode){
        this._mode = mode;
    }
}
$6f04c25d4bdc412e$var$__decorate([
    $ffTXa.Override
], $6f04c25d4bdc412e$var$LexerPushModeAction.prototype, "actionType", null);
$6f04c25d4bdc412e$var$__decorate([
    $ffTXa.Override
], $6f04c25d4bdc412e$var$LexerPushModeAction.prototype, "isPositionDependent", null);
$6f04c25d4bdc412e$var$__decorate([
    $ffTXa.Override,
    $6f04c25d4bdc412e$var$__param(0, $ffTXa.NotNull)
], $6f04c25d4bdc412e$var$LexerPushModeAction.prototype, "execute", null);
$6f04c25d4bdc412e$var$__decorate([
    $ffTXa.Override
], $6f04c25d4bdc412e$var$LexerPushModeAction.prototype, "hashCode", null);
$6f04c25d4bdc412e$var$__decorate([
    $ffTXa.Override
], $6f04c25d4bdc412e$var$LexerPushModeAction.prototype, "equals", null);
$6f04c25d4bdc412e$var$__decorate([
    $ffTXa.Override
], $6f04c25d4bdc412e$var$LexerPushModeAction.prototype, "toString", null);
module.exports.LexerPushModeAction = $6f04c25d4bdc412e$var$LexerPushModeAction;

});

parcelRegister("9swWO", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $6e30494781677380$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $6e30494781677380$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerSkipAction = void 0;

var $kPsXR = parcelRequire("kPsXR");


var $ffTXa = parcelRequire("ffTXa");

/**
 * Implements the `skip` lexer action by calling {@link Lexer#skip}.
 *
 * The `skip` command does not have any parameters, so this action is
 * implemented as a singleton instance exposed by {@link #INSTANCE}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $6e30494781677380$var$LexerSkipAction {
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#SKIP}.
     */ get actionType() {
        return 6 /* SKIP */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#skip}.
     */ execute(lexer) {
        lexer.skip();
    }
    hashCode() {
        let hash = $kPsXR.MurmurHash.initialize();
        hash = $kPsXR.MurmurHash.update(hash, this.actionType);
        return $kPsXR.MurmurHash.finish(hash, 1);
    }
    equals(obj) {
        return obj === this;
    }
    toString() {
        return "skip";
    }
    /**
     * Constructs the singleton instance of the lexer `skip` command.
     */ constructor(){
    // intentionally empty
    }
}
$6e30494781677380$var$__decorate([
    $ffTXa.Override
], $6e30494781677380$var$LexerSkipAction.prototype, "actionType", null);
$6e30494781677380$var$__decorate([
    $ffTXa.Override
], $6e30494781677380$var$LexerSkipAction.prototype, "isPositionDependent", null);
$6e30494781677380$var$__decorate([
    $ffTXa.Override,
    $6e30494781677380$var$__param(0, $ffTXa.NotNull)
], $6e30494781677380$var$LexerSkipAction.prototype, "execute", null);
$6e30494781677380$var$__decorate([
    $ffTXa.Override
], $6e30494781677380$var$LexerSkipAction.prototype, "hashCode", null);
$6e30494781677380$var$__decorate([
    $ffTXa.Override
], $6e30494781677380$var$LexerSkipAction.prototype, "equals", null);
$6e30494781677380$var$__decorate([
    $ffTXa.Override
], $6e30494781677380$var$LexerSkipAction.prototype, "toString", null);
module.exports.LexerSkipAction = $6e30494781677380$var$LexerSkipAction;
(function(LexerSkipAction) {
    /**
     * Provides a singleton instance of this parameterless lexer action.
     */ LexerSkipAction.INSTANCE = new LexerSkipAction();
})($6e30494781677380$var$LexerSkipAction = module.exports.LexerSkipAction || (module.exports.LexerSkipAction = {}));

});

parcelRegister("fO0NG", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $b81c256fe0394f6a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $b81c256fe0394f6a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerTypeAction = void 0;

var $kPsXR = parcelRequire("kPsXR");


var $ffTXa = parcelRequire("ffTXa");

/**
 * Implements the `type` lexer action by setting `Lexer.type`
 * with the assigned type.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $b81c256fe0394f6a$var$LexerTypeAction {
    /**
     * Gets the type to assign to a token created by the lexer.
     * @returns The type to assign to a token created by the lexer.
     */ get type() {
        return this._type;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#TYPE}.
     */ get actionType() {
        return 7 /* TYPE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by setting `Lexer.type` with the
     * value provided by `type`.
     */ execute(lexer) {
        lexer.type = this._type;
    }
    hashCode() {
        let hash = $kPsXR.MurmurHash.initialize();
        hash = $kPsXR.MurmurHash.update(hash, this.actionType);
        hash = $kPsXR.MurmurHash.update(hash, this._type);
        return $kPsXR.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $b81c256fe0394f6a$var$LexerTypeAction)) return false;
        return this._type === obj._type;
    }
    toString() {
        return `type(${this._type})`;
    }
    /**
     * Constructs a new `type` action with the specified token type value.
     * @param type The type to assign to the token using `Lexer.type`.
     */ constructor(type){
        this._type = type;
    }
}
$b81c256fe0394f6a$var$__decorate([
    $ffTXa.Override
], $b81c256fe0394f6a$var$LexerTypeAction.prototype, "actionType", null);
$b81c256fe0394f6a$var$__decorate([
    $ffTXa.Override
], $b81c256fe0394f6a$var$LexerTypeAction.prototype, "isPositionDependent", null);
$b81c256fe0394f6a$var$__decorate([
    $ffTXa.Override,
    $b81c256fe0394f6a$var$__param(0, $ffTXa.NotNull)
], $b81c256fe0394f6a$var$LexerTypeAction.prototype, "execute", null);
$b81c256fe0394f6a$var$__decorate([
    $ffTXa.Override
], $b81c256fe0394f6a$var$LexerTypeAction.prototype, "hashCode", null);
$b81c256fe0394f6a$var$__decorate([
    $ffTXa.Override
], $b81c256fe0394f6a$var$LexerTypeAction.prototype, "equals", null);
$b81c256fe0394f6a$var$__decorate([
    $ffTXa.Override
], $b81c256fe0394f6a$var$LexerTypeAction.prototype, "toString", null);
module.exports.LexerTypeAction = $b81c256fe0394f6a$var$LexerTypeAction;

});

parcelRegister("ewXgZ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a942083ada8d69a7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoopEndState = void 0;

var $2UrJv = parcelRequire("2UrJv");


var $5dqQL = parcelRequire("5dqQL");


var $ffTXa = parcelRequire("ffTXa");

/** Mark the end of a * or + loop. */ class $a942083ada8d69a7$var$LoopEndState extends $2UrJv.ATNState {
    get stateType() {
        return $5dqQL.ATNStateType.LOOP_END;
    }
}
$a942083ada8d69a7$var$__decorate([
    $ffTXa.Override
], $a942083ada8d69a7$var$LoopEndState.prototype, "stateType", null);
module.exports.LoopEndState = $a942083ada8d69a7$var$LoopEndState;

});

parcelRegister("lORdS", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $fe278d6f2e8515fe$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $fe278d6f2e8515fe$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParserATNSimulator = void 0;

var $a9s8D = parcelRequire("a9s8D");


var $infuR = parcelRequire("infuR");


var $c90ex = parcelRequire("c90ex");


var $kzQll = parcelRequire("kzQll");


var $3pR6v = parcelRequire("3pR6v");


var $cxg6R = parcelRequire("cxg6R");


var $64vb9 = parcelRequire("64vb9");


var $51Z4d = parcelRequire("51Z4d");


var $5dqQL = parcelRequire("5dqQL");


var $4KTBo = parcelRequire("4KTBo");


var $kJZRw = parcelRequire("kJZRw");


var $dr7WR = parcelRequire("dr7WR");


var $gh7Hp = parcelRequire("gh7Hp");


var $kjxTv = parcelRequire("kjxTv");


var $77InG = parcelRequire("77InG");


var $dQ3yU = parcelRequire("dQ3yU");


var $9P2T1 = parcelRequire("9P2T1");


var $ffTXa = parcelRequire("ffTXa");


var $37IiV = parcelRequire("37IiV");


var $gm3rl = parcelRequire("gm3rl");


var $9PlGk = parcelRequire("9PlGk");


var $5izRN = parcelRequire("5izRN");


var $2EGxJ = parcelRequire("2EGxJ");


var $54abU = parcelRequire("54abU");


var $67XvK = parcelRequire("67XvK");


var $9v0dI = parcelRequire("9v0dI");


var $1zwkT = parcelRequire("1zwkT");


var $3LYKb = parcelRequire("3LYKb");


var $3VIrd = parcelRequire("3VIrd");


var $23Sey = parcelRequire("23Sey");


var $TNDGs = parcelRequire("TNDGs");


var $56U0W = parcelRequire("56U0W");


var $9Rq82 = parcelRequire("9Rq82");

const $fe278d6f2e8515fe$var$MAX_SHORT_VALUE = 0xFFFF;
const $fe278d6f2e8515fe$var$MIN_INTEGER_VALUE = -2147483648;
/**
 * The embodiment of the adaptive LL(*), ALL(*), parsing strategy.
 *
 * The basic complexity of the adaptive strategy makes it harder to understand.
 * We begin with ATN simulation to build paths in a DFA. Subsequent prediction
 * requests go through the DFA first. If they reach a state without an edge for
 * the current symbol, the algorithm fails over to the ATN simulation to
 * complete the DFA path for the current input (until it finds a conflict state
 * or uniquely predicting state).
 *
 * All of that is done without using the outer context because we want to create
 * a DFA that is not dependent upon the rule invocation stack when we do a
 * prediction. One DFA works in all contexts. We avoid using context not
 * necessarily because it's slower, although it can be, but because of the DFA
 * caching problem. The closure routine only considers the rule invocation stack
 * created during prediction beginning in the decision rule. For example, if
 * prediction occurs without invoking another rule's ATN, there are no context
 * stacks in the configurations. When lack of context leads to a conflict, we
 * don't know if it's an ambiguity or a weakness in the strong LL(*) parsing
 * strategy (versus full LL(*)).
 *
 * When SLL yields a configuration set with conflict, we rewind the input and
 * retry the ATN simulation, this time using full outer context without adding
 * to the DFA. Configuration context stacks will be the full invocation stacks
 * from the start rule. If we get a conflict using full context, then we can
 * definitively say we have a true ambiguity for that input sequence. If we
 * don't get a conflict, it implies that the decision is sensitive to the outer
 * context. (It is not context-sensitive in the sense of context-sensitive
 * grammars.)
 *
 * The next time we reach this DFA state with an SLL conflict, through DFA
 * simulation, we will again retry the ATN simulation using full context mode.
 * This is slow because we can't save the results and have to "interpret" the
 * ATN each time we get that input.
 *
 * **CACHING FULL CONTEXT PREDICTIONS**
 *
 * We could cache results from full context to predicted alternative easily and
 * that saves a lot of time but doesn't work in presence of predicates. The set
 * of visible predicates from the ATN start state changes depending on the
 * context, because closure can fall off the end of a rule. I tried to cache
 * tuples (stack context, semantic context, predicted alt) but it was slower
 * than interpreting and much more complicated. Also required a huge amount of
 * memory. The goal is not to create the world's fastest parser anyway. I'd like
 * to keep this algorithm simple. By launching multiple threads, we can improve
 * the speed of parsing across a large number of files.
 *
 * There is no strict ordering between the amount of input used by SLL vs LL,
 * which makes it really hard to build a cache for full context. Let's say that
 * we have input A B C that leads to an SLL conflict with full context X. That
 * implies that using X we might only use A B but we could also use A B C D to
 * resolve conflict. Input A B C D could predict alternative 1 in one position
 * in the input and A B C E could predict alternative 2 in another position in
 * input. The conflicting SLL configurations could still be non-unique in the
 * full context prediction, which would lead us to requiring more input than the
 * original A B C.	To make a	prediction cache work, we have to track	the exact
 * input	used during the previous prediction. That amounts to a cache that maps
 * X to a specific DFA for that context.
 *
 * Something should be done for left-recursive expression predictions. They are
 * likely LL(1) + pred eval. Easier to do the whole SLL unless error and retry
 * with full LL thing Sam does.
 *
 * **AVOIDING FULL CONTEXT PREDICTION**
 *
 * We avoid doing full context retry when the outer context is empty, we did not
 * dip into the outer context by falling off the end of the decision state rule,
 * or when we force SLL mode.
 *
 * As an example of the not dip into outer context case, consider as super
 * constructor calls versus function calls. One grammar might look like
 * this:
 *
 * ```antlr
 * ctorBody
 *   : '{' superCall? stat* '}'
 *   ;
 * ```
 *
 * Or, you might see something like
 *
 * ```antlr
 * stat
 *   : superCall ';'
 *   | expression ';'
 *   | ...
 *   ;
 * ```
 *
 * In both cases I believe that no closure operations will dip into the outer
 * context. In the first case ctorBody in the worst case will stop at the '}'.
 * In the 2nd case it should stop at the ';'. Both cases should stay within the
 * entry rule and not dip into the outer context.
 *
 * **PREDICATES**
 *
 * Predicates are always evaluated if present in either SLL or LL both. SLL and
 * LL simulation deals with predicates differently. SLL collects predicates as
 * it performs closure operations like ANTLR v3 did. It delays predicate
 * evaluation until it reaches and accept state. This allows us to cache the SLL
 * ATN simulation whereas, if we had evaluated predicates on-the-fly during
 * closure, the DFA state configuration sets would be different and we couldn't
 * build up a suitable DFA.
 *
 * When building a DFA accept state during ATN simulation, we evaluate any
 * predicates and return the sole semantically valid alternative. If there is
 * more than 1 alternative, we report an ambiguity. If there are 0 alternatives,
 * we throw an exception. Alternatives without predicates act like they have
 * true predicates. The simple way to think about it is to strip away all
 * alternatives with false predicates and choose the minimum alternative that
 * remains.
 *
 * When we start in the DFA and reach an accept state that's predicated, we test
 * those and return the minimum semantically viable alternative. If no
 * alternatives are viable, we throw an exception.
 *
 * During full LL ATN simulation, closure always evaluates predicates and
 * on-the-fly. This is crucial to reducing the configuration set size during
 * closure. It hits a landmine when parsing with the Java grammar, for example,
 * without this on-the-fly evaluation.
 *
 * **SHARING DFA**
 *
 * All instances of the same parser share the same decision DFAs through a
 * static field. Each instance gets its own ATN simulator but they share the
 * same {@link ATN#decisionToDFA} field. They also share a
 * {@link PredictionContextCache} object that makes sure that all
 * {@link PredictionContext} objects are shared among the DFA states. This makes
 * a big size difference.
 *
 * **THREAD SAFETY**
 *
 * The {@link ParserATNSimulator} locks on the {@link ATN#decisionToDFA} field when
 * it adds a new DFA object to that array. {@link #addDFAEdge}
 * locks on the DFA for the current decision when setting the
 * {@link DFAState#edges} field. {@link #addDFAState} locks on
 * the DFA for the current decision when looking up a DFA state to see if it
 * already exists. We must make sure that all requests to add DFA states that
 * are equivalent result in the same shared DFA object. This is because lots of
 * threads will be trying to update the DFA at once. The
 * {@link #addDFAState} method also locks inside the DFA lock
 * but this time on the shared context cache when it rebuilds the
 * configurations' {@link PredictionContext} objects using cached
 * subgraphs/nodes. No other locking occurs, even during DFA simulation. This is
 * safe as long as we can guarantee that all threads referencing
 * `s.edge[t]` get the same physical target {@link DFAState}, or
 * `undefined`. Once into the DFA, the DFA simulation does not reference the
 * {@link DFA#states} map. It follows the {@link DFAState#edges} field to new
 * targets. The DFA simulator will either find {@link DFAState#edges} to be
 * `undefined`, to be non-`undefined` and `dfa.edges[t]` undefined, or
 * `dfa.edges[t]` to be non-undefined. The
 * {@link #addDFAEdge} method could be racing to set the field
 * but in either case the DFA simulator works; if `undefined`, and requests ATN
 * simulation. It could also race trying to get `dfa.edges[t]`, but either
 * way it will work because it's not doing a test and set operation.
 *
 * **Starting with SLL then failing to combined SLL/LL (Two-Stage
 * Parsing)**
 *
 * Sam pointed out that if SLL does not give a syntax error, then there is no
 * point in doing full LL, which is slower. We only have to try LL if we get a
 * syntax error. For maximum speed, Sam starts the parser set to pure SLL
 * mode with the {@link BailErrorStrategy}:
 *
 * ```
 * parser.interpreter.{@link #setPredictionMode setPredictionMode}`(`{@link PredictionMode#SLL}`)`;
 * parser.{@link Parser#setErrorHandler setErrorHandler}(new {@link BailErrorStrategy}());
 * ```
 *
 * If it does not get a syntax error, then we're done. If it does get a syntax
 * error, we need to retry with the combined SLL/LL strategy.
 *
 * The reason this works is as follows. If there are no SLL conflicts, then the
 * grammar is SLL (at least for that input set). If there is an SLL conflict,
 * the full LL analysis must yield a set of viable alternatives which is a
 * subset of the alternatives reported by SLL. If the LL set is a singleton,
 * then the grammar is LL but not SLL. If the LL set is the same size as the SLL
 * set, the decision is SLL. If the LL set has size &gt; 1, then that decision
 * is truly ambiguous on the current input. If the LL set is smaller, then the
 * SLL conflict resolution might choose an alternative that the full LL would
 * rule out as a possibility based upon better context information. If that's
 * the case, then the SLL parse will definitely get an error because the full LL
 * analysis says it's not viable. If SLL conflict resolution chooses an
 * alternative within the LL set, them both SLL and LL would choose the same
 * alternative because they both choose the minimum of multiple conflicting
 * alternatives.
 *
 * Let's say we have a set of SLL conflicting alternatives `{1, 2, 3}` and
 * a smaller LL set called *s*. If *s* is `{2, 3}`, then SLL
 * parsing will get an error because SLL will pursue alternative 1. If
 * *s* is `{1, 2}` or `{1, 3}` then both SLL and LL will
 * choose the same alternative because alternative one is the minimum of either
 * set. If *s* is `{2}` or `{3}` then SLL will get a syntax
 * error. If *s* is `{1}` then SLL will succeed.
 *
 * Of course, if the input is invalid, then we will get an error for sure in
 * both SLL and LL parsing. Erroneous input will therefore require 2 passes over
 * the input.
 */ let $fe278d6f2e8515fe$var$ParserATNSimulator = class ParserATNSimulator extends $51Z4d.ATNSimulator {
    getPredictionMode() {
        return this.predictionMode;
    }
    setPredictionMode(predictionMode) {
        this.predictionMode = predictionMode;
    }
    reset() {
    // intentionally empty
    }
    adaptivePredict(input, decision, outerContext, useContext) {
        if (useContext === undefined) useContext = false;
        let dfa = this.atn.decisionToDFA[decision];
        $9Rq82(dfa != null);
        if (this.optimize_ll1 && !dfa.isPrecedenceDfa && !dfa.isEmpty) {
            let ll_1 = input.LA(1);
            if (ll_1 >= 0 && ll_1 <= 0xFFFF) {
                let key = (decision << 16 >>> 0) + ll_1;
                let alt = this.atn.LL1Table.get(key);
                if (alt != null) return alt;
            }
        }
        this.dfa = dfa;
        if (this.force_global_context) useContext = true;
        else if (!this.always_try_local_context) useContext = useContext || dfa.isContextSensitive;
        this.userWantsCtxSensitive = useContext || this.predictionMode !== $67XvK.PredictionMode.SLL && outerContext != null && !this.atn.decisionToState[decision].sll;
        if (outerContext == null) outerContext = $5izRN.ParserRuleContext.emptyContext();
        let state;
        if (!dfa.isEmpty) state = this.getStartState(dfa, input, outerContext, useContext);
        if (state == null) {
            if (outerContext == null) outerContext = $5izRN.ParserRuleContext.emptyContext();
            if (ParserATNSimulator.debug) console.log("ATN decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input) + ", outerContext=" + outerContext.toString(this._parser));
            state = this.computeStartState(dfa, outerContext, useContext);
        }
        let m = input.mark();
        let index = input.index;
        try {
            let alt = this.execDFA(dfa, input, index, state);
            if (ParserATNSimulator.debug) console.log("DFA after predictATN: " + dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
            return alt;
        } finally{
            this.dfa = undefined;
            input.seek(index);
            input.release(m);
        }
    }
    getStartState(dfa, input, outerContext, useContext) {
        if (!useContext) {
            if (dfa.isPrecedenceDfa) {
                // the start state for a precedence DFA depends on the current
                // parser precedence, and is provided by a DFA method.
                let state = dfa.getPrecedenceStartState(this._parser.precedence, false);
                if (state == null) return undefined;
                return new $23Sey.SimulatorState(outerContext, state, false, outerContext);
            } else {
                if (dfa.s0 == null) return undefined;
                return new $23Sey.SimulatorState(outerContext, dfa.s0, false, outerContext);
            }
        }
        if (!this.enable_global_context_dfa) return undefined;
        let remainingContext = outerContext;
        $9Rq82(outerContext != null);
        let s0;
        if (dfa.isPrecedenceDfa) s0 = dfa.getPrecedenceStartState(this._parser.precedence, true);
        else s0 = dfa.s0full;
        while(remainingContext != null && s0 != null && s0.isContextSensitive){
            remainingContext = this.skipTailCalls(remainingContext);
            s0 = s0.getContextTarget(this.getReturnState(remainingContext));
            if (remainingContext.isEmpty) $9Rq82(s0 == null || !s0.isContextSensitive);
            else remainingContext = remainingContext.parent;
        }
        if (s0 == null) return undefined;
        return new $23Sey.SimulatorState(outerContext, s0, useContext, remainingContext);
    }
    execDFA(dfa, input, startIndex, state) {
        let outerContext = state.outerContext;
        if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input) + ", outerContext=" + outerContext.toString(this._parser));
        if (ParserATNSimulator.dfa_debug) console.log(dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
        let s = state.s0;
        let t = input.LA(1);
        let remainingOuterContext = state.remainingOuterContext;
        while(true){
            if (ParserATNSimulator.dfa_debug) console.log("DFA state " + s.stateNumber + " LA(1)==" + this.getLookaheadName(input));
            if (state.useContext) while(s.isContextSymbol(t)){
                let next;
                if (remainingOuterContext != null) {
                    remainingOuterContext = this.skipTailCalls(remainingOuterContext);
                    next = s.getContextTarget(this.getReturnState(remainingOuterContext));
                }
                if (next == null) {
                    // fail over to ATN
                    let initialState = new $23Sey.SimulatorState(state.outerContext, s, state.useContext, remainingOuterContext);
                    return this.execATN(dfa, input, startIndex, initialState);
                }
                $9Rq82(remainingOuterContext != null);
                remainingOuterContext = remainingOuterContext.parent;
                s = next;
            }
            if (this.isAcceptState(s, state.useContext)) {
                if (s.predicates != null) {
                    if (ParserATNSimulator.dfa_debug) console.log("accept " + s);
                } else if (ParserATNSimulator.dfa_debug) console.log("accept; predict " + s.prediction + " in state " + s.stateNumber);
                break;
            }
            // t is not updated if one of these states is reached
            $9Rq82(!this.isAcceptState(s, state.useContext));
            // if no edge, pop over to ATN interpreter, update DFA and return
            let target = this.getExistingTargetState(s, t);
            if (target == null) {
                if (ParserATNSimulator.dfa_debug && t >= 0) console.log("no edge for " + this._parser.vocabulary.getDisplayName(t));
                let alt;
                if (ParserATNSimulator.dfa_debug) {
                    let interval = $dQ3yU.Interval.of(startIndex, this._parser.inputStream.index);
                    console.log("ATN exec upon " + this._parser.inputStream.getText(interval) + " at DFA state " + s.stateNumber);
                }
                let initialState = new $23Sey.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                alt = this.execATN(dfa, input, startIndex, initialState);
                if (ParserATNSimulator.dfa_debug) console.log("back from DFA update, alt=" + alt + ", dfa=\n" + dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
                // action already executed
                if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " predicts " + alt);
                return alt; // we've updated DFA, exec'd action, and have our deepest answer
            } else if (target === $51Z4d.ATNSimulator.ERROR) {
                let errorState = new $23Sey.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                return this.handleNoViableAlt(input, startIndex, errorState);
            }
            s = target;
            if (!this.isAcceptState(s, state.useContext) && t !== $9P2T1.IntStream.EOF) {
                input.consume();
                t = input.LA(1);
            }
        }
        //		if ( acceptState==null ) {
        //			if ( debug ) System.out.println("!!! no viable alt in dfa");
        //			return -1;
        //		}
        if (!state.useContext && s.configs.conflictInfo != null) {
            if (dfa.atnStartState instanceof $gh7Hp.DecisionState) {
                if (!this.userWantsCtxSensitive || !s.configs.dipsIntoOuterContext && s.configs.isExactConflict || this.treat_sllk1_conflict_as_ambiguity && input.index === startIndex) ;
                else {
                    $9Rq82(!state.useContext);
                    // Before attempting full context prediction, check to see if there are
                    // disambiguating or validating predicates to evaluate which allow an
                    // immediate decision
                    let conflictingAlts;
                    let predicates = s.predicates;
                    if (predicates != null) {
                        let conflictIndex = input.index;
                        if (conflictIndex !== startIndex) input.seek(startIndex);
                        conflictingAlts = this.evalSemanticContext(predicates, outerContext, true);
                        if (conflictingAlts.cardinality() === 1) return conflictingAlts.nextSetBit(0);
                        if (conflictIndex !== startIndex) // restore the index so reporting the fallback to full
                        // context occurs with the index at the correct spot
                        input.seek(conflictIndex);
                    }
                    if (this.reportAmbiguities) {
                        let conflictState = new $23Sey.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                        this.reportAttemptingFullContext(dfa, conflictingAlts, conflictState, startIndex, input.index);
                    }
                    input.seek(startIndex);
                    return this.adaptivePredict(input, dfa.decision, outerContext, true);
                }
            }
        }
        // Before jumping to prediction, check to see if there are
        // disambiguating or validating predicates to evaluate
        let predicates = s.predicates;
        if (predicates != null) {
            let stopIndex = input.index;
            if (startIndex !== stopIndex) input.seek(startIndex);
            let alts = this.evalSemanticContext(predicates, outerContext, this.reportAmbiguities && this.predictionMode === $67XvK.PredictionMode.LL_EXACT_AMBIG_DETECTION);
            switch(alts.cardinality()){
                case 0:
                    throw this.noViableAlt(input, outerContext, s.configs, startIndex);
                case 1:
                    return alts.nextSetBit(0);
                default:
                    // report ambiguity after predicate evaluation to make sure the correct
                    // set of ambig alts is reported.
                    if (startIndex !== stopIndex) input.seek(stopIndex);
                    this.reportAmbiguity(dfa, s, startIndex, stopIndex, s.configs.isExactConflict, alts, s.configs);
                    return alts.nextSetBit(0);
            }
        }
        if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " predicts " + s.prediction);
        return s.prediction;
    }
    /**
     * Determines if a particular DFA state should be treated as an accept state
     * for the current prediction mode. In addition to the `useContext`
     * parameter, the {@link #getPredictionMode()} method provides the
     * prediction mode controlling the prediction algorithm as a whole.
     *
     * The default implementation simply returns the value of
     * `DFAState.isAcceptState` except for conflict states when
     * `useContext` is `true` and {@link #getPredictionMode()} is
     * {@link PredictionMode#LL_EXACT_AMBIG_DETECTION}. In that case, only
     * conflict states where {@link ATNConfigSet#isExactConflict} is
     * `true` are considered accept states.
     *
     * @param state The DFA state to check.
     * @param useContext `true` if the prediction algorithm is currently
     * considering the full parser context; otherwise, `false` if the
     * algorithm is currently performing a local context prediction.
     *
     * @returns `true` if the specified `state` is an accept state;
     * otherwise, `false`.
     */ isAcceptState(state, useContext) {
        if (!state.isAcceptState) return false;
        if (state.configs.conflictingAlts == null) // unambiguous
        return true;
        // More picky when we need exact conflicts
        if (useContext && this.predictionMode === $67XvK.PredictionMode.LL_EXACT_AMBIG_DETECTION) return state.configs.isExactConflict;
        return true;
    }
    /** Performs ATN simulation to compute a predicted alternative based
     *  upon the remaining input, but also updates the DFA cache to avoid
     *  having to traverse the ATN again for the same input sequence.
     *
     * There are some key conditions we're looking for after computing a new
     * set of ATN configs (proposed DFA state):
     *
     * * if the set is empty, there is no viable alternative for current symbol
     * * does the state uniquely predict an alternative?
     * * does the state have a conflict that would prevent us from
     *   putting it on the work list?
     * * if in non-greedy decision is there a config at a rule stop state?
     *
     * We also have some key operations to do:
     *
     * * add an edge from previous DFA state to potentially new DFA state, D,
     *   upon current symbol but only if adding to work list, which means in all
     *   cases except no viable alternative (and possibly non-greedy decisions?)
     * * collecting predicates and adding semantic context to DFA accept states
     * * adding rule context to context-sensitive DFA accept states
     * * consuming an input symbol
     * * reporting a conflict
     * * reporting an ambiguity
     * * reporting a context sensitivity
     * * reporting insufficient predicates
     *
     * We should isolate those operations, which are side-effecting, to the
     * main work loop. We can isolate lots of code into other functions, but
     * they should be side effect free. They can return package that
     * indicates whether we should report something, whether we need to add a
     * DFA edge, whether we need to augment accept state with semantic
     * context or rule invocation context. Actually, it seems like we always
     * add predicates if they exist, so that can simply be done in the main
     * loop for any accept state creation or modification request.
     *
     * cover these cases:
     *   dead end
     *   single alt
     *   single alt + preds
     *   conflict
     *   conflict + preds
     *
     * TODO: greedy + those
     */ execATN(dfa, input, startIndex, initialState) {
        if (ParserATNSimulator.debug) console.log("execATN decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input));
        let outerContext = initialState.outerContext;
        let useContext = initialState.useContext;
        let t = input.LA(1);
        let previous = initialState;
        let contextCache = new $54abU.PredictionContextCache();
        while(true){
            let nextState = this.computeReachSet(dfa, previous, t, contextCache);
            if (nextState == null) {
                this.setDFAEdge(previous.s0, input.LA(1), $51Z4d.ATNSimulator.ERROR);
                return this.handleNoViableAlt(input, startIndex, previous);
            }
            let D = nextState.s0;
            // predicted alt => accept state
            $9Rq82(D.isAcceptState || D.prediction === $3pR6v.ATN.INVALID_ALT_NUMBER);
            // conflicted => accept state
            $9Rq82(D.isAcceptState || D.configs.conflictInfo == null);
            if (this.isAcceptState(D, useContext)) {
                let conflictingAlts = D.configs.conflictingAlts;
                let predictedAlt = conflictingAlts == null ? D.prediction : $3pR6v.ATN.INVALID_ALT_NUMBER;
                if (predictedAlt !== $3pR6v.ATN.INVALID_ALT_NUMBER) {
                    if (this.optimize_ll1 && input.index === startIndex && !dfa.isPrecedenceDfa && nextState.outerContext === nextState.remainingOuterContext && dfa.decision >= 0 && !D.configs.hasSemanticContext) {
                        if (t >= 0 && t <= $fe278d6f2e8515fe$var$MAX_SHORT_VALUE) {
                            let key = (dfa.decision << 16 >>> 0) + t;
                            this.atn.LL1Table.set(key, predictedAlt);
                        }
                    }
                    if (useContext && this.always_try_local_context) this.reportContextSensitivity(dfa, predictedAlt, nextState, startIndex, input.index);
                }
                predictedAlt = D.prediction;
                //				int k = input.index - startIndex + 1; // how much input we used
                //				System.out.println("used k="+k);
                let attemptFullContext = conflictingAlts != null && this.userWantsCtxSensitive;
                if (attemptFullContext) // Only exact conflicts are known to be ambiguous when local
                // prediction does not step out of the decision rule.
                attemptFullContext = !useContext && (D.configs.dipsIntoOuterContext || !D.configs.isExactConflict) && (!this.treat_sllk1_conflict_as_ambiguity || input.index !== startIndex);
                if (D.configs.hasSemanticContext) {
                    let predPredictions = D.predicates;
                    if (predPredictions != null) {
                        let conflictIndex = input.index;
                        if (conflictIndex !== startIndex) input.seek(startIndex);
                        // use complete evaluation here if we'll want to retry with full context if still ambiguous
                        conflictingAlts = this.evalSemanticContext(predPredictions, outerContext, attemptFullContext || this.reportAmbiguities);
                        switch(conflictingAlts.cardinality()){
                            case 0:
                                throw this.noViableAlt(input, outerContext, D.configs, startIndex);
                            case 1:
                                return conflictingAlts.nextSetBit(0);
                            default:
                                break;
                        }
                        if (conflictIndex !== startIndex) // restore the index so reporting the fallback to full
                        // context occurs with the index at the correct spot
                        input.seek(conflictIndex);
                    }
                }
                if (!attemptFullContext) {
                    if (conflictingAlts != null) {
                        if (this.reportAmbiguities && conflictingAlts.cardinality() > 1) this.reportAmbiguity(dfa, D, startIndex, input.index, D.configs.isExactConflict, conflictingAlts, D.configs);
                        predictedAlt = conflictingAlts.nextSetBit(0);
                    }
                    return predictedAlt;
                } else {
                    $9Rq82(!useContext);
                    $9Rq82(this.isAcceptState(D, false));
                    if (ParserATNSimulator.debug) console.log("RETRY with outerContext=" + outerContext);
                    let fullContextState = this.computeStartState(dfa, outerContext, true);
                    if (this.reportAmbiguities) this.reportAttemptingFullContext(dfa, conflictingAlts, nextState, startIndex, input.index);
                    input.seek(startIndex);
                    return this.execATN(dfa, input, startIndex, fullContextState);
                }
            }
            previous = nextState;
            if (t !== $9P2T1.IntStream.EOF) {
                input.consume();
                t = input.LA(1);
            }
        }
    }
    /**
     * This method is used to improve the localization of error messages by
     * choosing an alternative rather than throwing a
     * {@link NoViableAltException} in particular prediction scenarios where the
     * {@link #ERROR} state was reached during ATN simulation.
     *
     * The default implementation of this method uses the following
     * algorithm to identify an ATN configuration which successfully parsed the
     * decision entry rule. Choosing such an alternative ensures that the
     * {@link ParserRuleContext} returned by the calling rule will be complete
     * and valid, and the syntax error will be reported later at a more
     * localized location.
     *
     * * If no configuration in `configs` reached the end of the
     *   decision rule, return {@link ATN#INVALID_ALT_NUMBER}.
     * * If all configurations in `configs` which reached the end of the
     *   decision rule predict the same alternative, return that alternative.
     * * If the configurations in `configs` which reached the end of the
     *   decision rule predict multiple alternatives (call this *S*),
     *   choose an alternative in the following order.
     *
     *     1. Filter the configurations in `configs` to only those
     *        configurations which remain viable after evaluating semantic predicates.
     *        If the set of these filtered configurations which also reached the end of
     *        the decision rule is not empty, return the minimum alternative
     *        represented in this set.
     *     1. Otherwise, choose the minimum alternative in *S*.
     *
     * In some scenarios, the algorithm described above could predict an
     * alternative which will result in a {@link FailedPredicateException} in
     * parser. Specifically, this could occur if the *only* configuration
     * capable of successfully parsing to the end of the decision rule is
     * blocked by a semantic predicate. By choosing this alternative within
     * {@link #adaptivePredict} instead of throwing a
     * {@link NoViableAltException}, the resulting
     * {@link FailedPredicateException} in the parser will identify the specific
     * predicate which is preventing the parser from successfully parsing the
     * decision rule, which helps developers identify and correct logic errors
     * in semantic predicates.
     *
     * @param input The input {@link TokenStream}
     * @param startIndex The start index for the current prediction, which is
     * the input index where any semantic context in `configs` should be
     * evaluated
     * @param previous The ATN simulation state immediately before the
     * {@link #ERROR} state was reached
     *
     * @returns The value to return from {@link #adaptivePredict}, or
     * {@link ATN#INVALID_ALT_NUMBER} if a suitable alternative was not
     * identified and {@link #adaptivePredict} should report an error instead.
     */ handleNoViableAlt(input, startIndex, previous) {
        if (previous.s0 != null) {
            let alts = new $kJZRw.BitSet();
            let maxAlt = 0;
            for (let config of previous.s0.configs)if (config.reachesIntoOuterContext || config.state instanceof $9v0dI.RuleStopState) {
                alts.set(config.alt);
                maxAlt = Math.max(maxAlt, config.alt);
            }
            switch(alts.cardinality()){
                case 0:
                    break;
                case 1:
                    return alts.nextSetBit(0);
                default:
                    if (!previous.s0.configs.hasSemanticContext) // configs doesn't contain any predicates, so the predicate
                    // filtering code below would be pointless
                    return alts.nextSetBit(0);
                    /*
                     * Try to find a configuration set that not only dipped into the outer
                     * context, but also isn't eliminated by a predicate.
                     */ let filteredConfigs = new $64vb9.ATNConfigSet();
                    for (let config of previous.s0.configs)if (config.reachesIntoOuterContext || config.state instanceof $9v0dI.RuleStopState) filteredConfigs.add(config);
                    /* The following code blocks are adapted from predicateDFAState with
                     * the following key changes.
                     *
                     *  1. The code operates on an ATNConfigSet rather than a DFAState.
                     *  2. Predicates are collected for all alternatives represented in
                     *     filteredConfigs, rather than restricting the evaluation to
                     *     conflicting and/or unique configurations.
                     */ let altToPred = this.getPredsForAmbigAlts(alts, filteredConfigs, maxAlt);
                    if (altToPred != null) {
                        let predicates = this.getPredicatePredictions(alts, altToPred);
                        if (predicates != null) {
                            let stopIndex = input.index;
                            try {
                                input.seek(startIndex);
                                let filteredAlts = this.evalSemanticContext(predicates, previous.outerContext, false);
                                if (!filteredAlts.isEmpty) return filteredAlts.nextSetBit(0);
                            } finally{
                                input.seek(stopIndex);
                            }
                        }
                    }
                    return alts.nextSetBit(0);
            }
        }
        throw this.noViableAlt(input, previous.outerContext, previous.s0.configs, startIndex);
    }
    computeReachSet(dfa, previous, t, contextCache) {
        let useContext = previous.useContext;
        let remainingGlobalContext = previous.remainingOuterContext;
        let s = previous.s0;
        if (useContext) while(s.isContextSymbol(t)){
            let next;
            if (remainingGlobalContext != null) {
                remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                next = s.getContextTarget(this.getReturnState(remainingGlobalContext));
            }
            if (next == null) break;
            $9Rq82(remainingGlobalContext != null);
            remainingGlobalContext = remainingGlobalContext.parent;
            s = next;
        }
        $9Rq82(!this.isAcceptState(s, useContext));
        if (this.isAcceptState(s, useContext)) return new $23Sey.SimulatorState(previous.outerContext, s, useContext, remainingGlobalContext);
        let s0 = s;
        let target = this.getExistingTargetState(s0, t);
        if (target == null) {
            let result = this.computeTargetState(dfa, s0, remainingGlobalContext, t, useContext, contextCache);
            target = result[0];
            remainingGlobalContext = result[1];
        }
        if (target === $51Z4d.ATNSimulator.ERROR) return undefined;
        $9Rq82(!useContext || !target.configs.dipsIntoOuterContext);
        return new $23Sey.SimulatorState(previous.outerContext, target, useContext, remainingGlobalContext);
    }
    /**
     * Get an existing target state for an edge in the DFA. If the target state
     * for the edge has not yet been computed or is otherwise not available,
     * this method returns `undefined`.
     *
     * @param s The current DFA state
     * @param t The next input symbol
     * @returns The existing target DFA state for the given input symbol
     * `t`, or `undefined` if the target state for this edge is not
     * already cached
     */ getExistingTargetState(s, t) {
        return s.getTarget(t);
    }
    /**
     * Compute a target state for an edge in the DFA, and attempt to add the
     * computed state and corresponding edge to the DFA.
     *
     * @param dfa
     * @param s The current DFA state
     * @param remainingGlobalContext
     * @param t The next input symbol
     * @param useContext
     * @param contextCache
     *
     * @returns The computed target DFA state for the given input symbol
     * `t`. If `t` does not lead to a valid DFA state, this method
     * returns {@link #ERROR}.
     */ computeTargetState(dfa, s, remainingGlobalContext, t, useContext, contextCache) {
        let closureConfigs = s.configs.toArray();
        let contextElements;
        let reach = new $64vb9.ATNConfigSet();
        let stepIntoGlobal;
        do {
            let hasMoreContext = !useContext || remainingGlobalContext != null;
            if (!hasMoreContext) reach.isOutermostConfigSet = true;
            let reachIntermediate = new $64vb9.ATNConfigSet();
            /* Configurations already in a rule stop state indicate reaching the end
             * of the decision rule (local context) or end of the start rule (full
             * context). Once reached, these configurations are never updated by a
             * closure operation, so they are handled separately for the performance
             * advantage of having a smaller intermediate set when calling closure.
             *
             * For full-context reach operations, separate handling is required to
             * ensure that the alternative matching the longest overall sequence is
             * chosen when multiple such configurations can match the input.
             */ let skippedStopStates;
            for (let c of closureConfigs){
                if (ParserATNSimulator.debug) console.log("testing " + this.getTokenName(t) + " at " + c.toString());
                if (c.state instanceof $9v0dI.RuleStopState) {
                    $9Rq82(c.context.isEmpty);
                    if (useContext && !c.reachesIntoOuterContext || t === $9P2T1.IntStream.EOF) {
                        if (skippedStopStates == null) skippedStopStates = [];
                        skippedStopStates.push(c);
                    }
                    continue;
                }
                let n = c.state.numberOfOptimizedTransitions;
                for(let ti = 0; ti < n; ti++){
                    let trans = c.state.getOptimizedTransition(ti);
                    let target = this.getReachableTarget(c, trans, t);
                    if (target != null) reachIntermediate.add(c.transform(target, false), contextCache);
                }
            }
            /* This block optimizes the reach operation for intermediate sets which
             * trivially indicate a termination state for the overall
             * adaptivePredict operation.
             *
             * The conditions assume that intermediate
             * contains all configurations relevant to the reach set, but this
             * condition is not true when one or more configurations have been
             * withheld in skippedStopStates, or when the current symbol is EOF.
             */ if (this.optimize_unique_closure && skippedStopStates == null && t !== $TNDGs.Token.EOF && reachIntermediate.uniqueAlt !== $3pR6v.ATN.INVALID_ALT_NUMBER) {
                reachIntermediate.isOutermostConfigSet = reach.isOutermostConfigSet;
                reach = reachIntermediate;
                break;
            }
            /* If the reach set could not be trivially determined, perform a closure
             * operation on the intermediate set to compute its initial value.
             */ let collectPredicates = false;
            let treatEofAsEpsilon = t === $TNDGs.Token.EOF;
            this.closure(reachIntermediate, reach, collectPredicates, hasMoreContext, contextCache, treatEofAsEpsilon);
            stepIntoGlobal = reach.dipsIntoOuterContext;
            if (t === $9P2T1.IntStream.EOF) /* After consuming EOF no additional input is possible, so we are
                 * only interested in configurations which reached the end of the
                 * decision rule (local context) or end of the start rule (full
                 * context). Update reach to contain only these configurations. This
                 * handles both explicit EOF transitions in the grammar and implicit
                 * EOF transitions following the end of the decision or start rule.
                 *
                 * This is handled before the configurations in skippedStopStates,
                 * because any configurations potentially added from that list are
                 * already guaranteed to meet this condition whether or not it's
                 * required.
                 */ reach = this.removeAllConfigsNotInRuleStopState(reach, contextCache);
            /* If skippedStopStates is not undefined, then it contains at least one
             * configuration. For full-context reach operations, these
             * configurations reached the end of the start rule, in which case we
             * only add them back to reach if no configuration during the current
             * closure operation reached such a state. This ensures adaptivePredict
             * chooses an alternative matching the longest overall sequence when
             * multiple alternatives are viable.
             */ if (skippedStopStates != null && (!useContext || !$67XvK.PredictionMode.hasConfigInRuleStopState(reach))) {
                $9Rq82(skippedStopStates.length > 0);
                for (let c of skippedStopStates)reach.add(c, contextCache);
            }
            if (useContext && stepIntoGlobal) {
                reach.clear();
                // We know remainingGlobalContext is not undefined at this point (why?)
                remainingGlobalContext;
                remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                let nextContextElement = this.getReturnState(remainingGlobalContext);
                if (contextElements == null) contextElements = new $77InG.IntegerList();
                if (remainingGlobalContext.isEmpty) remainingGlobalContext = undefined;
                else remainingGlobalContext = remainingGlobalContext.parent;
                contextElements.add(nextContextElement);
                if (nextContextElement !== $2EGxJ.PredictionContext.EMPTY_FULL_STATE_KEY) for(let i = 0; i < closureConfigs.length; i++)closureConfigs[i] = closureConfigs[i].appendContext(nextContextElement, contextCache);
            }
        }while (useContext && stepIntoGlobal);
        if (reach.isEmpty) {
            this.setDFAEdge(s, t, $51Z4d.ATNSimulator.ERROR);
            return [
                $51Z4d.ATNSimulator.ERROR,
                remainingGlobalContext
            ];
        }
        let result = this.addDFAEdge(dfa, s, t, contextElements, reach, contextCache);
        return [
            result,
            remainingGlobalContext
        ];
    }
    /**
     * Return a configuration set containing only the configurations from
     * `configs` which are in a {@link RuleStopState}. If all
     * configurations in `configs` are already in a rule stop state, this
     * method simply returns `configs`.
     *
     * @param configs the configuration set to update
     * @param contextCache the {@link PredictionContext} cache
     *
     * @returns `configs` if all configurations in `configs` are in a
     * rule stop state, otherwise return a new configuration set containing only
     * the configurations from `configs` which are in a rule stop state
     */ removeAllConfigsNotInRuleStopState(configs, contextCache) {
        if ($67XvK.PredictionMode.allConfigsInRuleStopStates(configs)) return configs;
        let result = new $64vb9.ATNConfigSet();
        for (let config of configs){
            if (!(config.state instanceof $9v0dI.RuleStopState)) continue;
            result.add(config, contextCache);
        }
        return result;
    }
    computeStartState(dfa, globalContext, useContext) {
        let s0 = dfa.isPrecedenceDfa ? dfa.getPrecedenceStartState(this._parser.precedence, useContext) : useContext ? dfa.s0full : dfa.s0;
        if (s0 != null) {
            if (!useContext) return new $23Sey.SimulatorState(globalContext, s0, useContext, globalContext);
            s0.setContextSensitive(this.atn);
        }
        let decision = dfa.decision;
        // @NotNull
        let p = dfa.atnStartState;
        let previousContext = 0;
        let remainingGlobalContext = globalContext;
        let initialContext = useContext ? $2EGxJ.PredictionContext.EMPTY_FULL : $2EGxJ.PredictionContext.EMPTY_LOCAL; // always at least the implicit call to start rule
        let contextCache = new $54abU.PredictionContextCache();
        if (useContext) {
            if (!this.enable_global_context_dfa) {
                while(remainingGlobalContext != null)if (remainingGlobalContext.isEmpty) {
                    previousContext = $2EGxJ.PredictionContext.EMPTY_FULL_STATE_KEY;
                    remainingGlobalContext = undefined;
                } else {
                    previousContext = this.getReturnState(remainingGlobalContext);
                    initialContext = initialContext.appendSingleContext(previousContext, contextCache);
                    remainingGlobalContext = remainingGlobalContext.parent;
                }
            }
            while(s0 != null && s0.isContextSensitive && remainingGlobalContext != null){
                let next;
                remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                if (remainingGlobalContext.isEmpty) {
                    next = s0.getContextTarget($2EGxJ.PredictionContext.EMPTY_FULL_STATE_KEY);
                    previousContext = $2EGxJ.PredictionContext.EMPTY_FULL_STATE_KEY;
                    remainingGlobalContext = undefined;
                } else {
                    previousContext = this.getReturnState(remainingGlobalContext);
                    next = s0.getContextTarget(previousContext);
                    initialContext = initialContext.appendSingleContext(previousContext, contextCache);
                    remainingGlobalContext = remainingGlobalContext.parent;
                }
                if (next == null) break;
                s0 = next;
            }
        }
        if (s0 != null && !s0.isContextSensitive) return new $23Sey.SimulatorState(globalContext, s0, useContext, remainingGlobalContext);
        let configs = new $64vb9.ATNConfigSet();
        while(true){
            let reachIntermediate = new $64vb9.ATNConfigSet();
            let n = p.numberOfTransitions;
            for(let ti = 0; ti < n; ti++){
                // for each transition
                let target = p.transition(ti).target;
                reachIntermediate.add($cxg6R.ATNConfig.create(target, ti + 1, initialContext));
            }
            let hasMoreContext = remainingGlobalContext != null;
            if (!hasMoreContext) configs.isOutermostConfigSet = true;
            let collectPredicates = true;
            this.closure(reachIntermediate, configs, collectPredicates, hasMoreContext, contextCache, false);
            let stepIntoGlobal = configs.dipsIntoOuterContext;
            let next;
            if (useContext && !this.enable_global_context_dfa) {
                s0 = this.addDFAState(dfa, configs, contextCache);
                break;
            } else if (s0 == null) {
                if (!dfa.isPrecedenceDfa) {
                    next = this.addDFAState(dfa, configs, contextCache);
                    if (useContext) {
                        if (!dfa.s0full) dfa.s0full = next;
                        else next = dfa.s0full;
                    } else if (!dfa.s0) dfa.s0 = next;
                    else next = dfa.s0;
                } else {
                    /* If this is a precedence DFA, we use applyPrecedenceFilter
                     * to convert the computed start state to a precedence start
                     * state. We then use DFA.setPrecedenceStartState to set the
                     * appropriate start state for the precedence level rather
                     * than simply setting DFA.s0.
                     */ configs = this.applyPrecedenceFilter(configs, globalContext, contextCache);
                    next = this.addDFAState(dfa, configs, contextCache);
                    dfa.setPrecedenceStartState(this._parser.precedence, useContext, next);
                }
            } else {
                if (dfa.isPrecedenceDfa) configs = this.applyPrecedenceFilter(configs, globalContext, contextCache);
                next = this.addDFAState(dfa, configs, contextCache);
                s0.setContextTarget(previousContext, next);
            }
            s0 = next;
            if (!useContext || !stepIntoGlobal) break;
            // TODO: make sure it distinguishes empty stack states
            next.setContextSensitive(this.atn);
            // We know remainingGlobalContext is not undefined at this point (why?)
            remainingGlobalContext;
            configs.clear();
            remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
            let nextContextElement = this.getReturnState(remainingGlobalContext);
            if (remainingGlobalContext.isEmpty) remainingGlobalContext = undefined;
            else remainingGlobalContext = remainingGlobalContext.parent;
            if (nextContextElement !== $2EGxJ.PredictionContext.EMPTY_FULL_STATE_KEY) initialContext = initialContext.appendSingleContext(nextContextElement, contextCache);
            previousContext = nextContextElement;
        }
        return new $23Sey.SimulatorState(globalContext, s0, useContext, remainingGlobalContext);
    }
    /**
     * This method transforms the start state computed by
     * {@link #computeStartState} to the special start state used by a
     * precedence DFA for a particular precedence value. The transformation
     * process applies the following changes to the start state's configuration
     * set.
     *
     * 1. Evaluate the precedence predicates for each configuration using
     *    {@link SemanticContext#evalPrecedence}.
     * 1. When {@link ATNConfig#isPrecedenceFilterSuppressed} is `false`,
     *    remove all configurations which predict an alternative greater than 1,
     *    for which another configuration that predicts alternative 1 is in the
     *    same ATN state with the same prediction context. This transformation is
     *    valid for the following reasons:
     *
     *     * The closure block cannot contain any epsilon transitions which bypass
     *       the body of the closure, so all states reachable via alternative 1 are
     *       part of the precedence alternatives of the transformed left-recursive
     *       rule.
     *     * The "primary" portion of a left recursive rule cannot contain an
     *       epsilon transition, so the only way an alternative other than 1 can exist
     *       in a state that is also reachable via alternative 1 is by nesting calls
     *       to the left-recursive rule, with the outer calls not being at the
     *       preferred precedence level. The
     *       {@link ATNConfig#isPrecedenceFilterSuppressed} property marks ATN
     *       configurations which do not meet this condition, and therefore are not
     *       eligible for elimination during the filtering process.
     *
     * The prediction context must be considered by this filter to address
     * situations like the following.
     *
     * ```antlr
     * grammar TA;
     * prog: statement* EOF;
     * statement: letterA | statement letterA 'b' ;
     * letterA: 'a';
     * ```
     *
     * If the above grammar, the ATN state immediately before the token
     * reference `'a'` in `letterA` is reachable from the left edge
     * of both the primary and closure blocks of the left-recursive rule
     * `statement`. The prediction context associated with each of these
     * configurations distinguishes between them, and prevents the alternative
     * which stepped out to `prog` (and then back in to `statement`
     * from being eliminated by the filter.
     *
     * @param configs The configuration set computed by
     * {@link #computeStartState} as the start state for the DFA.
     * @returns The transformed configuration set representing the start state
     * for a precedence DFA at a particular precedence level (determined by
     * calling {@link Parser#getPrecedence}).
     */ applyPrecedenceFilter(configs, globalContext, contextCache) {
        let statesFromAlt1 = new Map();
        let configSet = new $64vb9.ATNConfigSet();
        for (let config of configs){
            // handle alt 1 first
            if (config.alt !== 1) continue;
            let updatedContext = config.semanticContext.evalPrecedence(this._parser, globalContext);
            if (updatedContext == null) continue;
            statesFromAlt1.set(config.state.stateNumber, config.context);
            if (updatedContext !== config.semanticContext) configSet.add(config.transform(config.state, false, updatedContext), contextCache);
            else configSet.add(config, contextCache);
        }
        for (let config of configs){
            if (config.alt === 1) continue;
            if (!config.isPrecedenceFilterSuppressed) {
                /* In the future, this elimination step could be updated to also
                 * filter the prediction context for alternatives predicting alt>1
                 * (basically a graph subtraction algorithm).
                 */ let context = statesFromAlt1.get(config.state.stateNumber);
                if (context != null && context.equals(config.context)) continue;
            }
            configSet.add(config, contextCache);
        }
        return configSet;
    }
    getReachableTarget(source, trans, ttype) {
        if (trans.matches(ttype, 0, this.atn.maxTokenType)) return trans.target;
        return undefined;
    }
    /** collect and set D's semantic context */ predicateDFAState(D, configs, nalts) {
        let conflictingAlts = this.getConflictingAltsFromConfigSet(configs);
        if (!conflictingAlts) throw new Error("This unhandled scenario is intended to be unreachable, but I'm currently not sure of why we know that's the case.");
        if (ParserATNSimulator.debug) console.log("predicateDFAState " + D);
        let altToPred = this.getPredsForAmbigAlts(conflictingAlts, configs, nalts);
        // altToPred[uniqueAlt] is now our validating predicate (if any)
        let predPredictions;
        if (altToPred != null) {
            // we have a validating predicate; test it
            // Update DFA so reach becomes accept state with predicate
            predPredictions = this.getPredicatePredictions(conflictingAlts, altToPred);
            D.predicates = predPredictions;
        }
        return predPredictions;
    }
    getPredsForAmbigAlts(ambigAlts, configs, nalts) {
        // REACH=[1|1|[]|0:0, 1|2|[]|0:1]
        /* altToPred starts as an array of all undefined contexts. The entry at index i
         * corresponds to alternative i. altToPred[i] may have one of three values:
         *   1. undefined: no ATNConfig c is found such that c.alt===i
         *   2. SemanticContext.NONE: At least one ATNConfig c exists such that
         *      c.alt===i and c.semanticContext===SemanticContext.NONE. In other words,
         *      alt i has at least one unpredicated config.
         *   3. Non-NONE Semantic Context: There exists at least one, and for all
         *      ATNConfig c such that c.alt===i, c.semanticContext!==SemanticContext.NONE.
         *
         * From this, it is clear that NONE||anything==NONE.
         */ let altToPred = new Array(nalts + 1);
        let n = altToPred.length;
        for (let c of configs)if (ambigAlts.get(c.alt)) altToPred[c.alt] = $3LYKb.SemanticContext.or(altToPred[c.alt], c.semanticContext);
        let nPredAlts = 0;
        for(let i = 0; i < n; i++){
            if (altToPred[i] == null) altToPred[i] = $3LYKb.SemanticContext.NONE;
            else if (altToPred[i] !== $3LYKb.SemanticContext.NONE) nPredAlts++;
        }
        // At this point we know `altToPred` doesn't contain any undefined entries
        let result = altToPred;
        // nonambig alts are undefined in result
        if (nPredAlts === 0) result = undefined;
        if (ParserATNSimulator.debug) console.log("getPredsForAmbigAlts result " + (result ? $kzQll.Arrays.toString(result) : "undefined"));
        return result;
    }
    getPredicatePredictions(ambigAlts, altToPred) {
        let pairs = [];
        let containsPredicate = false;
        for(let i = 1; i < altToPred.length; i++){
            let pred = altToPred[i];
            // unpredicated is indicated by SemanticContext.NONE
            $9Rq82(pred != null);
            // find first unpredicated but ambig alternative, if any.
            // Only ambiguous alternatives will have SemanticContext.NONE.
            // Any unambig alts or ambig naked alts after first ambig naked are ignored
            // (undefined, i) means alt i is the default prediction
            // if no (undefined, i), then no default prediction.
            if (ambigAlts != null && ambigAlts.get(i) && pred === $3LYKb.SemanticContext.NONE) pairs.push(new $kjxTv.DFAState.PredPrediction(pred, i));
            else if (pred !== $3LYKb.SemanticContext.NONE) {
                containsPredicate = true;
                pairs.push(new $kjxTv.DFAState.PredPrediction(pred, i));
            }
        }
        if (!containsPredicate) return undefined;
        //		System.out.println(Arrays.toString(altToPred)+"->"+pairs);
        return pairs;
    }
    /** Look through a list of predicate/alt pairs, returning alts for the
     *  pairs that win. An `undefined` predicate indicates an alt containing an
     *  unpredicated config which behaves as "always true."
     */ evalSemanticContext(predPredictions, outerContext, complete) {
        let predictions = new $kJZRw.BitSet();
        for (let pair of predPredictions){
            if (pair.pred === $3LYKb.SemanticContext.NONE) {
                predictions.set(pair.alt);
                if (!complete) break;
                continue;
            }
            let evaluatedResult = this.evalSemanticContextImpl(pair.pred, outerContext, pair.alt);
            if (ParserATNSimulator.debug || ParserATNSimulator.dfa_debug) console.log("eval pred " + pair + "=" + evaluatedResult);
            if (evaluatedResult) {
                if (ParserATNSimulator.debug || ParserATNSimulator.dfa_debug) console.log("PREDICT " + pair.alt);
                predictions.set(pair.alt);
                if (!complete) break;
            }
        }
        return predictions;
    }
    /**
     * Evaluate a semantic context within a specific parser context.
     *
     * This method might not be called for every semantic context evaluated
     * during the prediction process. In particular, we currently do not
     * evaluate the following but it may change in the future:
     *
     * * Precedence predicates (represented by
     *   {@link SemanticContext.PrecedencePredicate}) are not currently evaluated
     *   through this method.
     * * Operator predicates (represented by {@link SemanticContext.AND} and
     *   {@link SemanticContext.OR}) are evaluated as a single semantic
     *   context, rather than evaluating the operands individually.
     *   Implementations which require evaluation results from individual
     *   predicates should override this method to explicitly handle evaluation of
     *   the operands within operator predicates.
     *
     * @param pred The semantic context to evaluate
     * @param parserCallStack The parser context in which to evaluate the
     * semantic context
     * @param alt The alternative which is guarded by `pred`
     *
     * @since 4.3
     */ evalSemanticContextImpl(pred, parserCallStack, alt) {
        return pred.eval(this._parser, parserCallStack);
    }
    /* TODO: If we are doing predicates, there is no point in pursuing
         closure operations if we reach a DFA state that uniquely predicts
         alternative. We will not be caching that DFA state and it is a
         waste to pursue the closure. Might have to advance when we do
         ambig detection thought :(
          */ closure(sourceConfigs, configs, collectPredicates, hasMoreContext, contextCache, treatEofAsEpsilon) {
        if (contextCache == null) contextCache = $54abU.PredictionContextCache.UNCACHED;
        let currentConfigs = sourceConfigs;
        let closureBusy = new $c90ex.Array2DHashSet($9PlGk.ObjectEqualityComparator.INSTANCE);
        while(currentConfigs.size > 0){
            let intermediate = new $64vb9.ATNConfigSet();
            for (let config of currentConfigs)this.closureImpl(config, configs, intermediate, closureBusy, collectPredicates, hasMoreContext, contextCache, 0, treatEofAsEpsilon);
            currentConfigs = intermediate;
        }
    }
    closureImpl(config, configs, intermediate, closureBusy, collectPredicates, hasMoreContexts, contextCache, depth, treatEofAsEpsilon) {
        if (ParserATNSimulator.debug) console.log("closure(" + config.toString(this._parser, true) + ")");
        if (config.state instanceof $9v0dI.RuleStopState) {
            // We hit rule end. If we have context info, use it
            if (!config.context.isEmpty) {
                let hasEmpty = config.context.hasEmpty;
                let nonEmptySize = config.context.size - (hasEmpty ? 1 : 0);
                for(let i = 0; i < nonEmptySize; i++){
                    let newContext = config.context.getParent(i); // "pop" return state
                    let returnState = this.atn.states[config.context.getReturnState(i)];
                    let c = $cxg6R.ATNConfig.create(returnState, config.alt, newContext, config.semanticContext);
                    // While we have context to pop back from, we may have
                    // gotten that context AFTER having fallen off a rule.
                    // Make sure we track that we are now out of context.
                    c.outerContextDepth = config.outerContextDepth;
                    c.isPrecedenceFilterSuppressed = config.isPrecedenceFilterSuppressed;
                    $9Rq82(depth > $fe278d6f2e8515fe$var$MIN_INTEGER_VALUE);
                    this.closureImpl(c, configs, intermediate, closureBusy, collectPredicates, hasMoreContexts, contextCache, depth - 1, treatEofAsEpsilon);
                }
                if (!hasEmpty || !hasMoreContexts) return;
                config = config.transform(config.state, false, $2EGxJ.PredictionContext.EMPTY_LOCAL);
            } else if (!hasMoreContexts) {
                configs.add(config, contextCache);
                return;
            } else {
                // else if we have no context info, just chase follow links (if greedy)
                if (ParserATNSimulator.debug) console.log("FALLING off rule " + this.getRuleName(config.state.ruleIndex));
                if (config.context === $2EGxJ.PredictionContext.EMPTY_FULL) // no need to keep full context overhead when we step out
                config = config.transform(config.state, false, $2EGxJ.PredictionContext.EMPTY_LOCAL);
                else if (!config.reachesIntoOuterContext && $2EGxJ.PredictionContext.isEmptyLocal(config.context)) // add stop state when leaving decision rule for the first time
                configs.add(config, contextCache);
            }
        }
        let p = config.state;
        // optimization
        if (!p.onlyHasEpsilonTransitions) {
            configs.add(config, contextCache);
            // make sure to not return here, because EOF transitions can act as
            // both epsilon transitions and non-epsilon transitions.
            if (ParserATNSimulator.debug) console.log("added config " + configs);
        }
        for(let i = 0; i < p.numberOfOptimizedTransitions; i++){
            // This block implements first-edge elimination of ambiguous LR
            // alternatives as part of dynamic disambiguation during prediction.
            // See antlr/antlr4#1398.
            if (i === 0 && p.stateType === $5dqQL.ATNStateType.STAR_LOOP_ENTRY && p.precedenceRuleDecision && !config.context.hasEmpty) {
                let precedenceDecision = p;
                // When suppress is true, it means the outgoing edge i==0 is
                // ambiguous with the outgoing edge i==1, and thus the closure
                // operation can dynamically disambiguate by suppressing this
                // edge during the closure operation.
                let suppress = true;
                for(let j = 0; j < config.context.size; j++)if (!precedenceDecision.precedenceLoopbackStates.get(config.context.getReturnState(j))) {
                    suppress = false;
                    break;
                }
                if (suppress) continue;
            }
            let t = p.getOptimizedTransition(i);
            let continueCollecting = !(t instanceof $infuR.ActionTransition) && collectPredicates;
            let c = this.getEpsilonTarget(config, t, continueCollecting, depth === 0, contextCache, treatEofAsEpsilon);
            if (c != null) {
                if (t instanceof $1zwkT.RuleTransition) {
                    if (intermediate != null && !collectPredicates) {
                        intermediate.add(c, contextCache);
                        continue;
                    }
                }
                let newDepth = depth;
                if (config.state instanceof $9v0dI.RuleStopState) {
                    // target fell off end of rule; mark resulting c as having dipped into outer context
                    // We can't get here if incoming config was rule stop and we had context
                    // track how far we dip into outer context.  Might
                    // come in handy and we avoid evaluating context dependent
                    // preds if this is > 0.
                    if (this.dfa != null && this.dfa.isPrecedenceDfa) {
                        let outermostPrecedenceReturn = t.outermostPrecedenceReturn;
                        if (outermostPrecedenceReturn === this.dfa.atnStartState.ruleIndex) c.isPrecedenceFilterSuppressed = true;
                    }
                    c.outerContextDepth = c.outerContextDepth + 1;
                    if (!closureBusy.add(c)) continue;
                    $9Rq82(newDepth > $fe278d6f2e8515fe$var$MIN_INTEGER_VALUE);
                    newDepth--;
                    if (ParserATNSimulator.debug) console.log("dips into outer ctx: " + c);
                } else if (t instanceof $1zwkT.RuleTransition) {
                    if (this.optimize_tail_calls && t.optimizedTailCall && (!this.tail_call_preserves_sll || !$2EGxJ.PredictionContext.isEmptyLocal(config.context))) {
                        $9Rq82(c.context === config.context);
                        if (newDepth === 0) {
                            // the pop/push of a tail call would keep the depth
                            // constant, except we latch if it goes negative
                            newDepth--;
                            if (!this.tail_call_preserves_sll && $2EGxJ.PredictionContext.isEmptyLocal(config.context)) // make sure the SLL config "dips into the outer context" or prediction may not fall back to LL on conflict
                            c.outerContextDepth = c.outerContextDepth + 1;
                        }
                    } else // latch when newDepth goes negative - once we step out of the entry context we can't return
                    if (newDepth >= 0) newDepth++;
                } else {
                    if (!t.isEpsilon && !closureBusy.add(c)) continue;
                }
                this.closureImpl(c, configs, intermediate, closureBusy, continueCollecting, hasMoreContexts, contextCache, newDepth, treatEofAsEpsilon);
            }
        }
    }
    getRuleName(index) {
        if (this._parser != null && index >= 0) return this._parser.ruleNames[index];
        return "<rule " + index + ">";
    }
    getEpsilonTarget(config, t, collectPredicates, inContext, contextCache, treatEofAsEpsilon) {
        switch(t.serializationType){
            case 3 /* RULE */ :
                return this.ruleTransition(config, t, contextCache);
            case 10 /* PRECEDENCE */ :
                return this.precedenceTransition(config, t, collectPredicates, inContext);
            case 4 /* PREDICATE */ :
                return this.predTransition(config, t, collectPredicates, inContext);
            case 6 /* ACTION */ :
                return this.actionTransition(config, t);
            case 1 /* EPSILON */ :
                return config.transform(t.target, false);
            case 5 /* ATOM */ :
            case 2 /* RANGE */ :
            case 7 /* SET */ :
                // EOF transitions act like epsilon transitions after the first EOF
                // transition is traversed
                if (treatEofAsEpsilon) {
                    if (t.matches($TNDGs.Token.EOF, 0, 1)) return config.transform(t.target, false);
                }
                return undefined;
            default:
                return undefined;
        }
    }
    actionTransition(config, t) {
        if (ParserATNSimulator.debug) console.log("ACTION edge " + t.ruleIndex + ":" + t.actionIndex);
        return config.transform(t.target, false);
    }
    precedenceTransition(config, pt, collectPredicates, inContext) {
        if (ParserATNSimulator.debug) {
            console.log("PRED (collectPredicates=" + collectPredicates + ") " + pt.precedence + ">=_p" + ", ctx dependent=true");
            if (this._parser != null) console.log("context surrounding pred is " + this._parser.getRuleInvocationStack());
        }
        let c;
        if (collectPredicates && inContext) {
            let newSemCtx = $3LYKb.SemanticContext.and(config.semanticContext, pt.predicate);
            c = config.transform(pt.target, false, newSemCtx);
        } else c = config.transform(pt.target, false);
        if (ParserATNSimulator.debug) console.log("config from pred transition=" + c);
        return c;
    }
    predTransition(config, pt, collectPredicates, inContext) {
        if (ParserATNSimulator.debug) {
            console.log("PRED (collectPredicates=" + collectPredicates + ") " + pt.ruleIndex + ":" + pt.predIndex + ", ctx dependent=" + pt.isCtxDependent);
            if (this._parser != null) console.log("context surrounding pred is " + this._parser.getRuleInvocationStack());
        }
        let c;
        if (collectPredicates && (!pt.isCtxDependent || pt.isCtxDependent && inContext)) {
            let newSemCtx = $3LYKb.SemanticContext.and(config.semanticContext, pt.predicate);
            c = config.transform(pt.target, false, newSemCtx);
        } else c = config.transform(pt.target, false);
        if (ParserATNSimulator.debug) console.log("config from pred transition=" + c);
        return c;
    }
    ruleTransition(config, t, contextCache) {
        if (ParserATNSimulator.debug) console.log("CALL rule " + this.getRuleName(t.target.ruleIndex) + ", ctx=" + config.context);
        let returnState = t.followState;
        let newContext;
        if (this.optimize_tail_calls && t.optimizedTailCall && (!this.tail_call_preserves_sll || !$2EGxJ.PredictionContext.isEmptyLocal(config.context))) newContext = config.context;
        else if (contextCache != null) newContext = contextCache.getChild(config.context, returnState.stateNumber);
        else newContext = config.context.getChild(returnState.stateNumber);
        return config.transform(t.target, false, newContext);
    }
    isConflicted(configset, contextCache) {
        if (configset.uniqueAlt !== $3pR6v.ATN.INVALID_ALT_NUMBER || configset.size <= 1) return undefined;
        let configs = configset.toArray();
        configs.sort(ParserATNSimulator.STATE_ALT_SORT_COMPARATOR);
        let exact = !configset.dipsIntoOuterContext;
        let alts = new $kJZRw.BitSet();
        let minAlt = configs[0].alt;
        alts.set(minAlt);
        /* Quick checks come first (single pass, no context joining):
         *  1. Make sure first config in the sorted list predicts the minimum
         *     represented alternative.
         *  2. Make sure every represented state has at least one configuration
         *     which predicts the minimum represented alternative.
         *  3. (exact only) make sure every represented state has at least one
         *     configuration which predicts each represented alternative.
         */ // quick check 1 & 2 => if we assume #1 holds and check #2 against the
        // minAlt from the first state, #2 will fail if the assumption was
        // incorrect
        let currentState = configs[0].state.nonStopStateNumber;
        for (let config of configs){
            let stateNumber = config.state.nonStopStateNumber;
            if (stateNumber !== currentState) {
                if (config.alt !== minAlt) return undefined;
                currentState = stateNumber;
            }
        }
        let representedAlts;
        if (exact) {
            currentState = configs[0].state.nonStopStateNumber;
            // get the represented alternatives of the first state
            representedAlts = new $kJZRw.BitSet();
            let maxAlt = minAlt;
            for (let config of configs){
                if (config.state.nonStopStateNumber !== currentState) break;
                let alt = config.alt;
                representedAlts.set(alt);
                maxAlt = alt;
            }
            // quick check #3:
            currentState = configs[0].state.nonStopStateNumber;
            let currentAlt = minAlt;
            for (let config of configs){
                let stateNumber = config.state.nonStopStateNumber;
                let alt = config.alt;
                if (stateNumber !== currentState) {
                    if (currentAlt !== maxAlt) {
                        exact = false;
                        break;
                    }
                    currentState = stateNumber;
                    currentAlt = minAlt;
                } else if (alt !== currentAlt) {
                    if (alt !== representedAlts.nextSetBit(currentAlt + 1)) {
                        exact = false;
                        break;
                    }
                    currentAlt = alt;
                }
            }
        }
        currentState = configs[0].state.nonStopStateNumber;
        let firstIndexCurrentState = 0;
        let lastIndexCurrentStateMinAlt = 0;
        let joinedCheckContext = configs[0].context;
        for(let i = 1; i < configs.length; i++){
            let config = configs[i];
            if (config.alt !== minAlt) break;
            if (config.state.nonStopStateNumber !== currentState) break;
            lastIndexCurrentStateMinAlt = i;
            joinedCheckContext = contextCache.join(joinedCheckContext, configs[i].context);
        }
        for(let i = lastIndexCurrentStateMinAlt + 1; i < configs.length; i++){
            let config = configs[i];
            let state = config.state;
            alts.set(config.alt);
            if (state.nonStopStateNumber !== currentState) {
                currentState = state.nonStopStateNumber;
                firstIndexCurrentState = i;
                lastIndexCurrentStateMinAlt = i;
                joinedCheckContext = config.context;
                for(let j = firstIndexCurrentState + 1; j < configs.length; j++){
                    let config2 = configs[j];
                    if (config2.alt !== minAlt) break;
                    if (config2.state.nonStopStateNumber !== currentState) break;
                    lastIndexCurrentStateMinAlt = j;
                    joinedCheckContext = contextCache.join(joinedCheckContext, config2.context);
                }
                i = lastIndexCurrentStateMinAlt;
                continue;
            }
            let joinedCheckContext2 = config.context;
            let currentAlt = config.alt;
            let lastIndexCurrentStateCurrentAlt = i;
            for(let j = lastIndexCurrentStateCurrentAlt + 1; j < configs.length; j++){
                let config2 = configs[j];
                if (config2.alt !== currentAlt) break;
                if (config2.state.nonStopStateNumber !== currentState) break;
                lastIndexCurrentStateCurrentAlt = j;
                joinedCheckContext2 = contextCache.join(joinedCheckContext2, config2.context);
            }
            i = lastIndexCurrentStateCurrentAlt;
            let check = contextCache.join(joinedCheckContext, joinedCheckContext2);
            if (!joinedCheckContext.equals(check)) return undefined;
            // update exact if necessary
            exact = exact && joinedCheckContext.equals(joinedCheckContext2);
        }
        return new $dr7WR.ConflictInfo(alts, exact);
    }
    getConflictingAltsFromConfigSet(configs) {
        let conflictingAlts = configs.conflictingAlts;
        if (conflictingAlts == null && configs.uniqueAlt !== $3pR6v.ATN.INVALID_ALT_NUMBER) {
            conflictingAlts = new $kJZRw.BitSet();
            conflictingAlts.set(configs.uniqueAlt);
        }
        return conflictingAlts;
    }
    getTokenName(t) {
        if (t === $TNDGs.Token.EOF) return "EOF";
        let vocabulary = this._parser != null ? this._parser.vocabulary : $56U0W.VocabularyImpl.EMPTY_VOCABULARY;
        let displayName = vocabulary.getDisplayName(t);
        if (displayName === String(t)) return displayName;
        return displayName + "<" + t + ">";
    }
    getLookaheadName(input) {
        return this.getTokenName(input.LA(1));
    }
    dumpDeadEndConfigs(nvae) {
        console.log("dead end configs: ");
        let deadEndConfigs = nvae.deadEndConfigs;
        if (!deadEndConfigs) return;
        for (let c of deadEndConfigs){
            let trans = "no edges";
            if (c.state.numberOfOptimizedTransitions > 0) {
                let t = c.state.getOptimizedTransition(0);
                if (t instanceof $4KTBo.AtomTransition) trans = "Atom " + this.getTokenName(t._label);
                else if (t instanceof $3VIrd.SetTransition) {
                    let not = t instanceof $37IiV.NotSetTransition;
                    trans = (not ? "~" : "") + "Set " + t.set.toString();
                }
            }
            console.log(c.toString(this._parser, true) + ":" + trans);
        }
    }
    noViableAlt(input, outerContext, configs, startIndex) {
        return new $gm3rl.NoViableAltException(this._parser, input, input.get(startIndex), input.LT(1), configs, outerContext);
    }
    getUniqueAlt(configs) {
        let alt = $3pR6v.ATN.INVALID_ALT_NUMBER;
        for (let c of configs){
            if (alt === $3pR6v.ATN.INVALID_ALT_NUMBER) alt = c.alt; // found first alt
            else if (c.alt !== alt) return $3pR6v.ATN.INVALID_ALT_NUMBER;
        }
        return alt;
    }
    configWithAltAtStopState(configs, alt) {
        for (let c of configs)if (c.alt === alt) {
            if (c.state instanceof $9v0dI.RuleStopState) return true;
        }
        return false;
    }
    addDFAEdge(dfa, fromState, t, contextTransitions, toConfigs, contextCache) {
        $9Rq82(contextTransitions == null || contextTransitions.isEmpty || dfa.isContextSensitive);
        let from = fromState;
        let to = this.addDFAState(dfa, toConfigs, contextCache);
        if (contextTransitions != null) for (let context of contextTransitions.toArray()){
            if (context === $2EGxJ.PredictionContext.EMPTY_FULL_STATE_KEY) {
                if (from.configs.isOutermostConfigSet) continue;
            }
            from.setContextSensitive(this.atn);
            from.setContextSymbol(t);
            let next = from.getContextTarget(context);
            if (next != null) {
                from = next;
                continue;
            }
            next = this.addDFAContextState(dfa, from.configs, context, contextCache);
            $9Rq82(context !== $2EGxJ.PredictionContext.EMPTY_FULL_STATE_KEY || next.configs.isOutermostConfigSet);
            from.setContextTarget(context, next);
            from = next;
        }
        if (ParserATNSimulator.debug) console.log("EDGE " + from + " -> " + to + " upon " + this.getTokenName(t));
        this.setDFAEdge(from, t, to);
        if (ParserATNSimulator.debug) console.log("DFA=\n" + dfa.toString(this._parser != null ? this._parser.vocabulary : $56U0W.VocabularyImpl.EMPTY_VOCABULARY, this._parser != null ? this._parser.ruleNames : undefined));
        return to;
    }
    setDFAEdge(p, t, q) {
        if (p != null) p.setTarget(t, q);
    }
    /** See comment on LexerInterpreter.addDFAState. */ addDFAContextState(dfa, configs, returnContext, contextCache) {
        if (returnContext !== $2EGxJ.PredictionContext.EMPTY_FULL_STATE_KEY) {
            let contextConfigs = new $64vb9.ATNConfigSet();
            for (let config of configs)contextConfigs.add(config.appendContext(returnContext, contextCache));
            return this.addDFAState(dfa, contextConfigs, contextCache);
        } else {
            $9Rq82(!configs.isOutermostConfigSet, "Shouldn't be adding a duplicate edge.");
            configs = configs.clone(true);
            configs.isOutermostConfigSet = true;
            return this.addDFAState(dfa, configs, contextCache);
        }
    }
    /** See comment on LexerInterpreter.addDFAState. */ addDFAState(dfa, configs, contextCache) {
        let enableDfa = this.enable_global_context_dfa || !configs.isOutermostConfigSet;
        if (enableDfa) {
            if (!configs.isReadOnly) configs.optimizeConfigs(this);
            let proposed = this.createDFAState(dfa, configs);
            let existing = dfa.states.get(proposed);
            if (existing != null) return existing;
        }
        if (!configs.isReadOnly) {
            if (configs.conflictInfo == null) configs.conflictInfo = this.isConflicted(configs, contextCache);
        }
        let newState = this.createDFAState(dfa, configs.clone(true));
        // getDecisionState won't return undefined when we request a known valid decision
        let decisionState = this.atn.getDecisionState(dfa.decision);
        let predictedAlt = this.getUniqueAlt(configs);
        if (predictedAlt !== $3pR6v.ATN.INVALID_ALT_NUMBER) newState.acceptStateInfo = new $a9s8D.AcceptStateInfo(predictedAlt);
        else if (configs.conflictingAlts != null) {
            let conflictingAlts = configs.conflictingAlts;
            if (conflictingAlts) newState.acceptStateInfo = new $a9s8D.AcceptStateInfo(conflictingAlts.nextSetBit(0));
        }
        if (newState.isAcceptState && configs.hasSemanticContext) this.predicateDFAState(newState, configs, decisionState.numberOfTransitions);
        if (!enableDfa) return newState;
        let added = dfa.addState(newState);
        if (ParserATNSimulator.debug && added === newState) console.log("adding new DFA state: " + newState);
        return added;
    }
    createDFAState(dfa, configs) {
        return new $kjxTv.DFAState(configs);
    }
    reportAttemptingFullContext(dfa, conflictingAlts, conflictState, startIndex, stopIndex) {
        if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
            let interval = $dQ3yU.Interval.of(startIndex, stopIndex);
            console.log("reportAttemptingFullContext decision=" + dfa.decision + ":" + conflictState.s0.configs + ", input=" + this._parser.inputStream.getText(interval));
        }
        if (this._parser != null) {
            let listener = this._parser.getErrorListenerDispatch();
            if (listener.reportAttemptingFullContext) listener.reportAttemptingFullContext(this._parser, dfa, startIndex, stopIndex, conflictingAlts, conflictState);
        }
    }
    reportContextSensitivity(dfa, prediction, acceptState, startIndex, stopIndex) {
        if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
            let interval = $dQ3yU.Interval.of(startIndex, stopIndex);
            console.log("reportContextSensitivity decision=" + dfa.decision + ":" + acceptState.s0.configs + ", input=" + this._parser.inputStream.getText(interval));
        }
        if (this._parser != null) {
            let listener = this._parser.getErrorListenerDispatch();
            if (listener.reportContextSensitivity) listener.reportContextSensitivity(this._parser, dfa, startIndex, stopIndex, prediction, acceptState);
        }
    }
    /** If context sensitive parsing, we know it's ambiguity not conflict */ reportAmbiguity(dfa, D, startIndex, stopIndex, exact, ambigAlts, configs) {
        if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
            let interval = $dQ3yU.Interval.of(startIndex, stopIndex);
            console.log("reportAmbiguity " + ambigAlts + ":" + configs + ", input=" + this._parser.inputStream.getText(interval));
        }
        if (this._parser != null) {
            let listener = this._parser.getErrorListenerDispatch();
            if (listener.reportAmbiguity) listener.reportAmbiguity(this._parser, dfa, startIndex, stopIndex, exact, ambigAlts, configs);
        }
    }
    getReturnState(context) {
        if (context.isEmpty) return $2EGxJ.PredictionContext.EMPTY_FULL_STATE_KEY;
        let state = this.atn.states[context.invokingState];
        let transition = state.transition(0);
        return transition.followState.stateNumber;
    }
    skipTailCalls(context) {
        if (!this.optimize_tail_calls) return context;
        while(!context.isEmpty){
            let state = this.atn.states[context.invokingState];
            $9Rq82(state.numberOfTransitions === 1 && state.transition(0).serializationType === 3 /* RULE */ );
            let transition = state.transition(0);
            if (!transition.tailCall) break;
            // This method requires that the root ancestor of the ParserRuleContext be empty. If we make it to this
            // line, we know the current node is not empty, which means it does have a parent.
            context = context.parent;
        }
        return context;
    }
    /**
     * @since 4.3
     */ get parser() {
        return this._parser;
    }
    constructor(atn, parser){
        super(atn);
        this.predictionMode = $67XvK.PredictionMode.LL;
        this.force_global_context = false;
        this.always_try_local_context = true;
        /**
         * Determines whether the DFA is used for full-context predictions. When
         * `true`, the DFA stores transition information for both full-context
         * and SLL parsing; otherwise, the DFA only stores SLL transition
         * information.
         *
         * For some grammars, enabling the full-context DFA can result in a
         * substantial performance improvement. However, this improvement typically
         * comes at the expense of memory used for storing the cached DFA states,
         * configuration sets, and prediction contexts.
         *
         * The default value is `false`.
         */ this.enable_global_context_dfa = false;
        this.optimize_unique_closure = true;
        this.optimize_ll1 = true;
        this.optimize_tail_calls = true;
        this.tail_call_preserves_sll = true;
        this.treat_sllk1_conflict_as_ambiguity = false;
        /**
         * When `true`, ambiguous alternatives are reported when they are
         * encountered within {@link #execATN}. When `false`, these messages
         * are suppressed. The default is `false`.
         *
         * When messages about ambiguous alternatives are not required, setting this
         * to `false` enables additional internal optimizations which may lose
         * this information.
         */ this.reportAmbiguities = false;
        /** By default we do full context-sensitive LL(*) parsing not
         *  Strong LL(*) parsing. If we fail with Strong LL(*) we
         *  try full LL(*). That means we rewind and use context information
         *  when closure operations fall off the end of the rule that
         *  holds the decision were evaluating.
         */ this.userWantsCtxSensitive = true;
        this._parser = parser;
    }
};
$fe278d6f2e8515fe$var$ParserATNSimulator.debug = false;
$fe278d6f2e8515fe$var$ParserATNSimulator.dfa_debug = false;
$fe278d6f2e8515fe$var$ParserATNSimulator.retry_debug = false;
$fe278d6f2e8515fe$var$ParserATNSimulator.STATE_ALT_SORT_COMPARATOR = (o1, o2)=>{
    let diff = o1.state.nonStopStateNumber - o2.state.nonStopStateNumber;
    if (diff !== 0) return diff;
    diff = o1.alt - o2.alt;
    if (diff !== 0) return diff;
    return 0;
};
$fe278d6f2e8515fe$var$__decorate([
    $ffTXa.NotNull
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "predictionMode", void 0);
$fe278d6f2e8515fe$var$__decorate([
    $ffTXa.NotNull
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "getPredictionMode", null);
$fe278d6f2e8515fe$var$__decorate([
    $fe278d6f2e8515fe$var$__param(0, $ffTXa.NotNull)
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "setPredictionMode", null);
$fe278d6f2e8515fe$var$__decorate([
    $ffTXa.Override
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "reset", null);
$fe278d6f2e8515fe$var$__decorate([
    $fe278d6f2e8515fe$var$__param(0, $ffTXa.NotNull)
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "adaptivePredict", null);
$fe278d6f2e8515fe$var$__decorate([
    $fe278d6f2e8515fe$var$__param(0, $ffTXa.NotNull),
    $fe278d6f2e8515fe$var$__param(1, $ffTXa.NotNull),
    $fe278d6f2e8515fe$var$__param(2, $ffTXa.NotNull)
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "getStartState", null);
$fe278d6f2e8515fe$var$__decorate([
    $fe278d6f2e8515fe$var$__param(0, $ffTXa.NotNull),
    $fe278d6f2e8515fe$var$__param(1, $ffTXa.NotNull),
    $fe278d6f2e8515fe$var$__param(3, $ffTXa.NotNull)
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "execDFA", null);
$fe278d6f2e8515fe$var$__decorate([
    $fe278d6f2e8515fe$var$__param(0, $ffTXa.NotNull),
    $fe278d6f2e8515fe$var$__param(1, $ffTXa.NotNull),
    $fe278d6f2e8515fe$var$__param(3, $ffTXa.NotNull)
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "execATN", null);
$fe278d6f2e8515fe$var$__decorate([
    $fe278d6f2e8515fe$var$__param(0, $ffTXa.NotNull),
    $fe278d6f2e8515fe$var$__param(2, $ffTXa.NotNull)
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "handleNoViableAlt", null);
$fe278d6f2e8515fe$var$__decorate([
    $fe278d6f2e8515fe$var$__param(0, $ffTXa.NotNull)
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "getExistingTargetState", null);
$fe278d6f2e8515fe$var$__decorate([
    $ffTXa.NotNull,
    $fe278d6f2e8515fe$var$__param(0, $ffTXa.NotNull),
    $fe278d6f2e8515fe$var$__param(1, $ffTXa.NotNull)
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "computeTargetState", null);
$fe278d6f2e8515fe$var$__decorate([
    $ffTXa.NotNull,
    $fe278d6f2e8515fe$var$__param(0, $ffTXa.NotNull)
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "removeAllConfigsNotInRuleStopState", null);
$fe278d6f2e8515fe$var$__decorate([
    $ffTXa.NotNull
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "computeStartState", null);
$fe278d6f2e8515fe$var$__decorate([
    $ffTXa.NotNull,
    $fe278d6f2e8515fe$var$__param(0, $ffTXa.NotNull)
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "applyPrecedenceFilter", null);
$fe278d6f2e8515fe$var$__decorate([
    $fe278d6f2e8515fe$var$__param(0, $ffTXa.NotNull),
    $fe278d6f2e8515fe$var$__param(1, $ffTXa.NotNull)
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "getReachableTarget", null);
$fe278d6f2e8515fe$var$__decorate([
    $fe278d6f2e8515fe$var$__param(0, $ffTXa.NotNull),
    $fe278d6f2e8515fe$var$__param(1, $ffTXa.NotNull)
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "getPredsForAmbigAlts", null);
$fe278d6f2e8515fe$var$__decorate([
    $fe278d6f2e8515fe$var$__param(0, $ffTXa.NotNull)
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "evalSemanticContext", null);
$fe278d6f2e8515fe$var$__decorate([
    $fe278d6f2e8515fe$var$__param(0, $ffTXa.NotNull)
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "evalSemanticContextImpl", null);
$fe278d6f2e8515fe$var$__decorate([
    $fe278d6f2e8515fe$var$__param(1, $ffTXa.NotNull),
    $fe278d6f2e8515fe$var$__param(4, $ffTXa.Nullable)
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "closure", null);
$fe278d6f2e8515fe$var$__decorate([
    $fe278d6f2e8515fe$var$__param(0, $ffTXa.NotNull),
    $fe278d6f2e8515fe$var$__param(1, $ffTXa.NotNull),
    $fe278d6f2e8515fe$var$__param(2, $ffTXa.Nullable),
    $fe278d6f2e8515fe$var$__param(3, $ffTXa.NotNull),
    $fe278d6f2e8515fe$var$__param(6, $ffTXa.NotNull)
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "closureImpl", null);
$fe278d6f2e8515fe$var$__decorate([
    $ffTXa.NotNull
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "getRuleName", null);
$fe278d6f2e8515fe$var$__decorate([
    $fe278d6f2e8515fe$var$__param(0, $ffTXa.NotNull),
    $fe278d6f2e8515fe$var$__param(1, $ffTXa.NotNull)
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "getEpsilonTarget", null);
$fe278d6f2e8515fe$var$__decorate([
    $ffTXa.NotNull,
    $fe278d6f2e8515fe$var$__param(0, $ffTXa.NotNull),
    $fe278d6f2e8515fe$var$__param(1, $ffTXa.NotNull)
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "actionTransition", null);
$fe278d6f2e8515fe$var$__decorate([
    $ffTXa.Nullable,
    $fe278d6f2e8515fe$var$__param(0, $ffTXa.NotNull),
    $fe278d6f2e8515fe$var$__param(1, $ffTXa.NotNull)
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "precedenceTransition", null);
$fe278d6f2e8515fe$var$__decorate([
    $ffTXa.Nullable,
    $fe278d6f2e8515fe$var$__param(0, $ffTXa.NotNull),
    $fe278d6f2e8515fe$var$__param(1, $ffTXa.NotNull)
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "predTransition", null);
$fe278d6f2e8515fe$var$__decorate([
    $ffTXa.NotNull,
    $fe278d6f2e8515fe$var$__param(0, $ffTXa.NotNull),
    $fe278d6f2e8515fe$var$__param(1, $ffTXa.NotNull),
    $fe278d6f2e8515fe$var$__param(2, $ffTXa.Nullable)
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "ruleTransition", null);
$fe278d6f2e8515fe$var$__decorate([
    $fe278d6f2e8515fe$var$__param(0, $ffTXa.NotNull)
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "isConflicted", null);
$fe278d6f2e8515fe$var$__decorate([
    $ffTXa.NotNull
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "getTokenName", null);
$fe278d6f2e8515fe$var$__decorate([
    $fe278d6f2e8515fe$var$__param(0, $ffTXa.NotNull)
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "dumpDeadEndConfigs", null);
$fe278d6f2e8515fe$var$__decorate([
    $ffTXa.NotNull,
    $fe278d6f2e8515fe$var$__param(0, $ffTXa.NotNull),
    $fe278d6f2e8515fe$var$__param(1, $ffTXa.NotNull),
    $fe278d6f2e8515fe$var$__param(2, $ffTXa.NotNull)
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "noViableAlt", null);
$fe278d6f2e8515fe$var$__decorate([
    $fe278d6f2e8515fe$var$__param(0, $ffTXa.NotNull)
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "getUniqueAlt", null);
$fe278d6f2e8515fe$var$__decorate([
    $fe278d6f2e8515fe$var$__param(0, $ffTXa.NotNull)
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "configWithAltAtStopState", null);
$fe278d6f2e8515fe$var$__decorate([
    $ffTXa.NotNull,
    $fe278d6f2e8515fe$var$__param(0, $ffTXa.NotNull),
    $fe278d6f2e8515fe$var$__param(1, $ffTXa.NotNull),
    $fe278d6f2e8515fe$var$__param(4, $ffTXa.NotNull)
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "addDFAEdge", null);
$fe278d6f2e8515fe$var$__decorate([
    $fe278d6f2e8515fe$var$__param(0, $ffTXa.Nullable),
    $fe278d6f2e8515fe$var$__param(2, $ffTXa.Nullable)
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "setDFAEdge", null);
$fe278d6f2e8515fe$var$__decorate([
    $ffTXa.NotNull,
    $fe278d6f2e8515fe$var$__param(0, $ffTXa.NotNull),
    $fe278d6f2e8515fe$var$__param(1, $ffTXa.NotNull)
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "addDFAContextState", null);
$fe278d6f2e8515fe$var$__decorate([
    $ffTXa.NotNull,
    $fe278d6f2e8515fe$var$__param(0, $ffTXa.NotNull),
    $fe278d6f2e8515fe$var$__param(1, $ffTXa.NotNull)
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "addDFAState", null);
$fe278d6f2e8515fe$var$__decorate([
    $ffTXa.NotNull,
    $fe278d6f2e8515fe$var$__param(0, $ffTXa.NotNull),
    $fe278d6f2e8515fe$var$__param(1, $ffTXa.NotNull)
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "createDFAState", null);
$fe278d6f2e8515fe$var$__decorate([
    $fe278d6f2e8515fe$var$__param(0, $ffTXa.NotNull),
    $fe278d6f2e8515fe$var$__param(2, $ffTXa.NotNull)
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "reportAttemptingFullContext", null);
$fe278d6f2e8515fe$var$__decorate([
    $fe278d6f2e8515fe$var$__param(0, $ffTXa.NotNull),
    $fe278d6f2e8515fe$var$__param(2, $ffTXa.NotNull)
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "reportContextSensitivity", null);
$fe278d6f2e8515fe$var$__decorate([
    $fe278d6f2e8515fe$var$__param(0, $ffTXa.NotNull),
    $fe278d6f2e8515fe$var$__param(5, $ffTXa.NotNull),
    $fe278d6f2e8515fe$var$__param(6, $ffTXa.NotNull)
], $fe278d6f2e8515fe$var$ParserATNSimulator.prototype, "reportAmbiguity", null);
$fe278d6f2e8515fe$var$ParserATNSimulator = $fe278d6f2e8515fe$var$__decorate([
    $fe278d6f2e8515fe$var$__param(0, $ffTXa.NotNull)
], $fe278d6f2e8515fe$var$ParserATNSimulator);
module.exports.ParserATNSimulator = $fe278d6f2e8515fe$var$ParserATNSimulator;

});

parcelRegister("dr7WR", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9c83f65a6d3b5718$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConflictInfo = void 0;

var $ffTXa = parcelRequire("ffTXa");


var $3jpAZ = parcelRequire("3jpAZ");

/**
 * This class stores information about a configuration conflict.
 *
 * @author Sam Harwell
 */ class $9c83f65a6d3b5718$var$ConflictInfo {
    /**
     * Gets the set of conflicting alternatives for the configuration set.
     */ get conflictedAlts() {
        return this._conflictedAlts;
    }
    /**
     * Gets whether or not the configuration conflict is an exact conflict.
     * An exact conflict occurs when the prediction algorithm determines that
     * the represented alternatives for a particular configuration set cannot be
     * further reduced by consuming additional input. After reaching an exact
     * conflict during an SLL prediction, only switch to full-context prediction
     * could reduce the set of viable alternatives. In LL prediction, an exact
     * conflict indicates a true ambiguity in the input.
     *
     * For the {@link PredictionMode#LL_EXACT_AMBIG_DETECTION} prediction mode,
     * accept states are conflicting but not exact are treated as non-accept
     * states.
     */ get isExact() {
        return this.exact;
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $9c83f65a6d3b5718$var$ConflictInfo)) return false;
        return this.isExact === obj.isExact && $3jpAZ.equals(this.conflictedAlts, obj.conflictedAlts);
    }
    hashCode() {
        return this.conflictedAlts.hashCode();
    }
    constructor(conflictedAlts, exact){
        this._conflictedAlts = conflictedAlts;
        this.exact = exact;
    }
}
$9c83f65a6d3b5718$var$__decorate([
    $ffTXa.Override
], $9c83f65a6d3b5718$var$ConflictInfo.prototype, "equals", null);
$9c83f65a6d3b5718$var$__decorate([
    $ffTXa.Override
], $9c83f65a6d3b5718$var$ConflictInfo.prototype, "hashCode", null);
module.exports.ConflictInfo = $9c83f65a6d3b5718$var$ConflictInfo;

});

parcelRegister("5izRN", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $3dba7496322974e4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParserRuleContext = void 0;

var $g9j02 = parcelRequire("g9j02");


var $dQ3yU = parcelRequire("dQ3yU");


var $ffTXa = parcelRequire("ffTXa");


var $7rnsN = parcelRequire("7rnsN");


var $1FMAL = parcelRequire("1FMAL");

/** A rule invocation record for parsing.
 *
 *  Contains all of the information about the current rule not stored in the
 *  RuleContext. It handles parse tree children list, Any ATN state
 *  tracing, and the default values available for rule invocations:
 *  start, stop, rule index, current alt number.
 *
 *  Subclasses made for each rule and grammar track the parameters,
 *  return values, locals, and labels specific to that rule. These
 *  are the objects that are returned from rules.
 *
 *  Note text is not an actual field of a rule return value; it is computed
 *  from start and stop using the input stream's toString() method.  I
 *  could add a ctor to this so that we can pass in and store the input
 *  stream, but I'm not sure we want to do that.  It would seem to be undefined
 *  to get the .text property anyway if the rule matches tokens from multiple
 *  input streams.
 *
 *  I do not use getters for fields of objects that are used simply to
 *  group values such as this aggregate.  The getters/setters are there to
 *  satisfy the superclass interface.
 */ class $3dba7496322974e4$var$ParserRuleContext extends $7rnsN.RuleContext {
    static emptyContext() {
        return $3dba7496322974e4$var$ParserRuleContext.EMPTY;
    }
    /**
     * COPY a ctx (I'm deliberately not using copy constructor) to avoid
     * confusion with creating node with parent. Does not copy children
     * (except error leaves).
     *
     * This is used in the generated parser code to flip a generic XContext
     * node for rule X to a YContext for alt label Y. In that sense, it is not
     * really a generic copy function.
     *
     * If we do an error sync() at start of a rule, we might add error nodes
     * to the generic XContext so this function must copy those nodes to the
     * YContext as well else they are lost!
     */ copyFrom(ctx) {
        this._parent = ctx._parent;
        this.invokingState = ctx.invokingState;
        this._start = ctx._start;
        this._stop = ctx._stop;
        // copy any error nodes to alt label node
        if (ctx.children) {
            this.children = [];
            // reset parent pointer for any error nodes
            for (let child of ctx.children)if (child instanceof $g9j02.ErrorNode) this.addChild(child);
        }
    }
    // Double dispatch methods for listeners
    enterRule(listener) {
    // intentionally empty
    }
    exitRule(listener) {
    // intentionally empty
    }
    /** Add a parse tree node to this as a child.  Works for
     *  internal and leaf nodes. Does not set parent link;
     *  other add methods must do that. Other addChild methods
     *  call this.
     *
     *  We cannot set the parent pointer of the incoming node
     *  because the existing interfaces do not have a setParent()
     *  method and I don't want to break backward compatibility for this.
     *
     *  @since 4.7
     */ addAnyChild(t) {
        if (!this.children) this.children = [
            t
        ];
        else this.children.push(t);
        return t;
    }
    addChild(t) {
        let result;
        if (t instanceof $1FMAL.TerminalNode) {
            t.setParent(this);
            this.addAnyChild(t);
            return;
        } else if (t instanceof $7rnsN.RuleContext) {
            // Does not set parent link
            this.addAnyChild(t);
            return;
        } else {
            // Deprecated code path
            t = new $1FMAL.TerminalNode(t);
            this.addAnyChild(t);
            t.setParent(this);
            return t;
        }
    }
    addErrorNode(node) {
        if (node instanceof $g9j02.ErrorNode) {
            const errorNode = node;
            errorNode.setParent(this);
            return this.addAnyChild(errorNode);
        } else {
            // deprecated path
            const badToken = node;
            let t = new $g9j02.ErrorNode(badToken);
            this.addAnyChild(t);
            t.setParent(this);
            return t;
        }
    }
    //	public void trace(int s) {
    //		if ( states==null ) states = new ArrayList<Integer>();
    //		states.add(s);
    //	}
    /** Used by enterOuterAlt to toss out a RuleContext previously added as
     *  we entered a rule. If we have # label, we will need to remove
     *  generic ruleContext object.
     */ removeLastChild() {
        if (this.children) this.children.pop();
    }
    get parent() {
        let parent = super.parent;
        if (parent === undefined || parent instanceof $3dba7496322974e4$var$ParserRuleContext) return parent;
        throw new TypeError("Invalid parent type for ParserRuleContext");
    }
    // Note: in TypeScript, order or arguments reversed
    getChild(i, ctxType) {
        if (!this.children || i < 0 || i >= this.children.length) throw new RangeError("index parameter must be between >= 0 and <= number of children.");
        if (ctxType == null) return this.children[i];
        let result = this.tryGetChild(i, ctxType);
        if (result === undefined) throw new Error("The specified node does not exist");
        return result;
    }
    tryGetChild(i, ctxType) {
        if (!this.children || i < 0 || i >= this.children.length) return undefined;
        let j = -1; // what node with ctxType have we found?
        for (let o of this.children)if (o instanceof ctxType) {
            j++;
            if (j === i) return o;
        }
        return undefined;
    }
    getToken(ttype, i) {
        let result = this.tryGetToken(ttype, i);
        if (result === undefined) throw new Error("The specified token does not exist");
        return result;
    }
    tryGetToken(ttype, i) {
        if (!this.children || i < 0 || i >= this.children.length) return undefined;
        let j = -1; // what token with ttype have we found?
        for (let o of this.children)if (o instanceof $1FMAL.TerminalNode) {
            let symbol = o.symbol;
            if (symbol.type === ttype) {
                j++;
                if (j === i) return o;
            }
        }
        return undefined;
    }
    getTokens(ttype) {
        let tokens = [];
        if (!this.children) return tokens;
        for (let o of this.children)if (o instanceof $1FMAL.TerminalNode) {
            let symbol = o.symbol;
            if (symbol.type === ttype) tokens.push(o);
        }
        return tokens;
    }
    get ruleContext() {
        return this;
    }
    // NOTE: argument order change from Java version
    getRuleContext(i, ctxType) {
        return this.getChild(i, ctxType);
    }
    tryGetRuleContext(i, ctxType) {
        return this.tryGetChild(i, ctxType);
    }
    getRuleContexts(ctxType) {
        let contexts = [];
        if (!this.children) return contexts;
        for (let o of this.children)if (o instanceof ctxType) contexts.push(o);
        return contexts;
    }
    get childCount() {
        return this.children ? this.children.length : 0;
    }
    get sourceInterval() {
        if (!this._start) return $dQ3yU.Interval.INVALID;
        if (!this._stop || this._stop.tokenIndex < this._start.tokenIndex) return $dQ3yU.Interval.of(this._start.tokenIndex, this._start.tokenIndex - 1); // empty
        return $dQ3yU.Interval.of(this._start.tokenIndex, this._stop.tokenIndex);
    }
    /**
     * Get the initial token in this context.
     * Note that the range from start to stop is inclusive, so for rules that do not consume anything
     * (for example, zero length or error productions) this token may exceed stop.
     */ get start() {
        return this._start;
    }
    /**
     * Get the final token in this context.
     * Note that the range from start to stop is inclusive, so for rules that do not consume anything
     * (for example, zero length or error productions) this token may precede start.
     */ get stop() {
        return this._stop;
    }
    /** Used for rule context info debugging during parse-time, not so much for ATN debugging */ toInfoString(recognizer) {
        let rules = recognizer.getRuleInvocationStack(this).reverse();
        return "ParserRuleContext" + rules + "{" + "start=" + this._start + ", stop=" + this._stop + "}";
    }
    constructor(parent, invokingStateNumber){
        if (invokingStateNumber == null) super();
        else super(parent, invokingStateNumber);
    }
}
$3dba7496322974e4$var$ParserRuleContext.EMPTY = new $3dba7496322974e4$var$ParserRuleContext();
$3dba7496322974e4$var$__decorate([
    $ffTXa.Override
], $3dba7496322974e4$var$ParserRuleContext.prototype, "parent", null);
$3dba7496322974e4$var$__decorate([
    $ffTXa.Override
], $3dba7496322974e4$var$ParserRuleContext.prototype, "childCount", null);
$3dba7496322974e4$var$__decorate([
    $ffTXa.Override
], $3dba7496322974e4$var$ParserRuleContext.prototype, "sourceInterval", null);
module.exports.ParserRuleContext = $3dba7496322974e4$var$ParserRuleContext;

});

parcelRegister("1FMAL", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $137f50258b736ed6$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TerminalNode = void 0;

var $dQ3yU = parcelRequire("dQ3yU");


var $ffTXa = parcelRequire("ffTXa");


var $TNDGs = parcelRequire("TNDGs");

class $137f50258b736ed6$var$TerminalNode {
    getChild(i) {
        throw new RangeError("Terminal Node has no children.");
    }
    get symbol() {
        return this._symbol;
    }
    get parent() {
        return this._parent;
    }
    setParent(parent) {
        this._parent = parent;
    }
    get payload() {
        return this._symbol;
    }
    get sourceInterval() {
        let tokenIndex = this._symbol.tokenIndex;
        return new $dQ3yU.Interval(tokenIndex, tokenIndex);
    }
    get childCount() {
        return 0;
    }
    accept(visitor) {
        return visitor.visitTerminal(this);
    }
    get text() {
        return this._symbol.text || "";
    }
    toStringTree(parser) {
        return this.toString();
    }
    toString() {
        if (this._symbol.type === $TNDGs.Token.EOF) return "<EOF>";
        return this._symbol.text || "";
    }
    constructor(symbol){
        this._symbol = symbol;
    }
}
$137f50258b736ed6$var$__decorate([
    $ffTXa.Override
], $137f50258b736ed6$var$TerminalNode.prototype, "getChild", null);
$137f50258b736ed6$var$__decorate([
    $ffTXa.Override
], $137f50258b736ed6$var$TerminalNode.prototype, "parent", null);
$137f50258b736ed6$var$__decorate([
    $ffTXa.Override
], $137f50258b736ed6$var$TerminalNode.prototype, "setParent", null);
$137f50258b736ed6$var$__decorate([
    $ffTXa.Override
], $137f50258b736ed6$var$TerminalNode.prototype, "payload", null);
$137f50258b736ed6$var$__decorate([
    $ffTXa.Override
], $137f50258b736ed6$var$TerminalNode.prototype, "sourceInterval", null);
$137f50258b736ed6$var$__decorate([
    $ffTXa.Override
], $137f50258b736ed6$var$TerminalNode.prototype, "childCount", null);
$137f50258b736ed6$var$__decorate([
    $ffTXa.Override
], $137f50258b736ed6$var$TerminalNode.prototype, "accept", null);
$137f50258b736ed6$var$__decorate([
    $ffTXa.Override
], $137f50258b736ed6$var$TerminalNode.prototype, "text", null);
$137f50258b736ed6$var$__decorate([
    $ffTXa.Override
], $137f50258b736ed6$var$TerminalNode.prototype, "toStringTree", null);
$137f50258b736ed6$var$__decorate([
    $ffTXa.Override
], $137f50258b736ed6$var$TerminalNode.prototype, "toString", null);
module.exports.TerminalNode = $137f50258b736ed6$var$TerminalNode;

});

parcelRegister("7rnsN", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $56ad41600c4fb456$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleContext = void 0;

var $3pR6v = parcelRequire("3pR6v");


var $bwXFO = parcelRequire("bwXFO");


var $daldP = parcelRequire("daldP");


var $dQ3yU = parcelRequire("dQ3yU");


var $ffTXa = parcelRequire("ffTXa");


var $2mNy3 = parcelRequire("2mNy3");


var $5izRN = parcelRequire("5izRN");

/** A rule context is a record of a single rule invocation.
 *
 *  We form a stack of these context objects using the parent
 *  pointer. A parent pointer of `undefined` indicates that the current
 *  context is the bottom of the stack. The ParserRuleContext subclass
 *  as a children list so that we can turn this data structure into a
 *  tree.
 *
 *  The root node always has a `undefined` pointer and invokingState of -1.
 *
 *  Upon entry to parsing, the first invoked rule function creates a
 *  context object (a subclass specialized for that rule such as
 *  SContext) and makes it the root of a parse tree, recorded by field
 *  Parser._ctx.
 *
 *  public final SContext s() throws RecognitionException {
 *      SContext _localctx = new SContext(_ctx, state); <-- create new node
 *      enterRule(_localctx, 0, RULE_s);                     <-- push it
 *      ...
 *      exitRule();                                          <-- pop back to _localctx
 *      return _localctx;
 *  }
 *
 *  A subsequent rule invocation of r from the start rule s pushes a
 *  new context object for r whose parent points at s and use invoking
 *  state is the state with r emanating as edge label.
 *
 *  The invokingState fields from a context object to the root
 *  together form a stack of rule indication states where the root
 *  (bottom of the stack) has a -1 sentinel value. If we invoke start
 *  symbol s then call r1, which calls r2, the  would look like
 *  this:
 *
 *     SContext[-1]   <- root node (bottom of the stack)
 *     R1Context[p]   <- p in rule s called r1
 *     R2Context[q]   <- q in rule r1 called r2
 *
 *  So the top of the stack, _ctx, represents a call to the current
 *  rule and it holds the return address from another rule that invoke
 *  to this rule. To invoke a rule, we must always have a current context.
 *
 *  The parent contexts are useful for computing lookahead sets and
 *  getting error information.
 *
 *  These objects are used during parsing and prediction.
 *  For the special case of parsers, we use the subclass
 *  ParserRuleContext.
 *
 *  @see ParserRuleContext
 */ class $56ad41600c4fb456$var$RuleContext extends $daldP.RuleNode {
    static getChildContext(parent, invokingState) {
        return new $56ad41600c4fb456$var$RuleContext(parent, invokingState);
    }
    depth() {
        let n = 0;
        let p = this;
        while(p){
            p = p._parent;
            n++;
        }
        return n;
    }
    /** A context is empty if there is no invoking state; meaning nobody called
     *  current context.
     */ get isEmpty() {
        return this.invokingState === -1;
    }
    // satisfy the ParseTree / SyntaxTree interface
    get sourceInterval() {
        return $dQ3yU.Interval.INVALID;
    }
    get ruleContext() {
        return this;
    }
    get parent() {
        return this._parent;
    }
    /** @since 4.7. {@see ParseTree#setParent} comment */ setParent(parent) {
        this._parent = parent;
    }
    get payload() {
        return this;
    }
    /** Return the combined text of all child nodes. This method only considers
     *  tokens which have been added to the parse tree.
     *
     *  Since tokens on hidden channels (e.g. whitespace or comments) are not
     *  added to the parse trees, they will not appear in the output of this
     *  method.
     */ get text() {
        if (this.childCount === 0) return "";
        let builder = "";
        for(let i = 0; i < this.childCount; i++)builder += this.getChild(i).text;
        return builder.toString();
    }
    get ruleIndex() {
        return -1;
    }
    /** For rule associated with this parse tree internal node, return
     *  the outer alternative number used to match the input. Default
     *  implementation does not compute nor store this alt num. Create
     *  a subclass of ParserRuleContext with backing field and set
     *  option contextSuperClass.
     *  to set it.
     *
     *  @since 4.5.3
     */ get altNumber() {
        return $3pR6v.ATN.INVALID_ALT_NUMBER;
    }
    /** Set the outer alternative number for this context node. Default
     *  implementation does nothing to avoid backing field overhead for
     *  trees that don't need it.  Create
     *  a subclass of ParserRuleContext with backing field and set
     *  option contextSuperClass.
     *
     *  @since 4.5.3
     */ set altNumber(altNumber) {
    // intentionally ignored by the base implementation
    }
    getChild(i) {
        throw new RangeError("i must be greater than or equal to 0 and less than childCount");
    }
    get childCount() {
        return 0;
    }
    accept(visitor) {
        return visitor.visitChildren(this);
    }
    toStringTree(recog) {
        return $2mNy3.Trees.toStringTree(this, recog);
    }
    toString(arg1, stop) {
        const ruleNames = arg1 instanceof $bwXFO.Recognizer ? arg1.ruleNames : arg1;
        stop = stop || $5izRN.ParserRuleContext.emptyContext();
        let buf = "";
        let p = this;
        buf += "[";
        while(p && p !== stop){
            if (!ruleNames) {
                if (!p.isEmpty) buf += p.invokingState;
            } else {
                let ruleIndex = p.ruleIndex;
                let ruleName = ruleIndex >= 0 && ruleIndex < ruleNames.length ? ruleNames[ruleIndex] : ruleIndex.toString();
                buf += ruleName;
            }
            if (p._parent && (ruleNames || !p._parent.isEmpty)) buf += " ";
            p = p._parent;
        }
        buf += "]";
        return buf.toString();
    }
    constructor(parent, invokingState){
        super();
        this._parent = parent;
        this.invokingState = invokingState != null ? invokingState : -1;
    }
}
$56ad41600c4fb456$var$__decorate([
    $ffTXa.Override
], $56ad41600c4fb456$var$RuleContext.prototype, "sourceInterval", null);
$56ad41600c4fb456$var$__decorate([
    $ffTXa.Override
], $56ad41600c4fb456$var$RuleContext.prototype, "ruleContext", null);
$56ad41600c4fb456$var$__decorate([
    $ffTXa.Override
], $56ad41600c4fb456$var$RuleContext.prototype, "parent", null);
$56ad41600c4fb456$var$__decorate([
    $ffTXa.Override
], $56ad41600c4fb456$var$RuleContext.prototype, "setParent", null);
$56ad41600c4fb456$var$__decorate([
    $ffTXa.Override
], $56ad41600c4fb456$var$RuleContext.prototype, "payload", null);
$56ad41600c4fb456$var$__decorate([
    $ffTXa.Override
], $56ad41600c4fb456$var$RuleContext.prototype, "text", null);
$56ad41600c4fb456$var$__decorate([
    $ffTXa.Override
], $56ad41600c4fb456$var$RuleContext.prototype, "getChild", null);
$56ad41600c4fb456$var$__decorate([
    $ffTXa.Override
], $56ad41600c4fb456$var$RuleContext.prototype, "childCount", null);
$56ad41600c4fb456$var$__decorate([
    $ffTXa.Override
], $56ad41600c4fb456$var$RuleContext.prototype, "accept", null);
$56ad41600c4fb456$var$__decorate([
    $ffTXa.Override
], $56ad41600c4fb456$var$RuleContext.prototype, "toStringTree", null);
module.exports.RuleContext = $56ad41600c4fb456$var$RuleContext;

});

parcelRegister("daldP", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleNode = void 0;
class $995cabc6c0facd72$var$RuleNode {
}
module.exports.RuleNode = $995cabc6c0facd72$var$RuleNode;

});

parcelRegister("2mNy3", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $1b941219782ea5c8$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $1b941219782ea5c8$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Trees = void 0;

var $3pR6v = parcelRequire("3pR6v");


var $eAd9i = parcelRequire("eAd9i");


var $g9j02 = parcelRequire("g9j02");


var $ffTXa = parcelRequire("ffTXa");


var $5XMF6 = parcelRequire("5XMF6");


var $5izRN = parcelRequire("5izRN");


var $daldP = parcelRequire("daldP");


var $1FMAL = parcelRequire("1FMAL");


var $TNDGs = parcelRequire("TNDGs");


var $3jpAZ = parcelRequire("3jpAZ");

/** A set of utility routines useful for all kinds of ANTLR trees. */ class $1b941219782ea5c8$var$Trees {
    static toStringTree(t, arg2) {
        let ruleNames;
        if (arg2 instanceof $5XMF6.Parser) ruleNames = arg2.ruleNames;
        else ruleNames = arg2;
        let s = $3jpAZ.escapeWhitespace(this.getNodeText(t, ruleNames), false);
        if (t.childCount === 0) return s;
        let buf = "";
        buf += "(";
        s = $3jpAZ.escapeWhitespace(this.getNodeText(t, ruleNames), false);
        buf += s;
        buf += " ";
        for(let i = 0; i < t.childCount; i++){
            if (i > 0) buf += " ";
            buf += this.toStringTree(t.getChild(i), ruleNames);
        }
        buf += ")";
        return buf;
    }
    static getNodeText(t, arg2) {
        let ruleNames;
        if (arg2 instanceof $5XMF6.Parser) ruleNames = arg2.ruleNames;
        else if (arg2) ruleNames = arg2;
        else {
            // no recog or rule names
            let payload = t.payload;
            if (typeof payload.text === "string") return payload.text;
            return t.payload.toString();
        }
        if (t instanceof $daldP.RuleNode) {
            let ruleContext = t.ruleContext;
            let ruleIndex = ruleContext.ruleIndex;
            let ruleName = ruleNames[ruleIndex];
            let altNumber = ruleContext.altNumber;
            if (altNumber !== $3pR6v.ATN.INVALID_ALT_NUMBER) return ruleName + ":" + altNumber;
            return ruleName;
        } else if (t instanceof $g9j02.ErrorNode) return t.toString();
        else if (t instanceof $1FMAL.TerminalNode) {
            let symbol = t.symbol;
            return symbol.text || "";
        }
        throw new TypeError("Unexpected node type");
    }
    static getChildren(t) {
        let kids = [];
        for(let i = 0; i < t.childCount; i++)kids.push(t.getChild(i));
        return kids;
    }
    static getAncestors(t) {
        let ancestors = [];
        let p = t.parent;
        while(p){
            ancestors.unshift(p); // insert at start
            p = p.parent;
        }
        return ancestors;
    }
    /** Return true if t is u's parent or a node on path to root from u.
     *  Use === not equals().
     *
     *  @since 4.5.1
     */ static isAncestorOf(t, u) {
        if (!t || !u || !t.parent) return false;
        let p = u.parent;
        while(p){
            if (t === p) return true;
            p = p.parent;
        }
        return false;
    }
    static findAllTokenNodes(t, ttype) {
        return $1b941219782ea5c8$var$Trees.findAllNodes(t, ttype, true);
    }
    static findAllRuleNodes(t, ruleIndex) {
        return $1b941219782ea5c8$var$Trees.findAllNodes(t, ruleIndex, false);
    }
    static findAllNodes(t, index, findTokens) {
        let nodes = [];
        $1b941219782ea5c8$var$Trees._findAllNodes(t, index, findTokens, nodes);
        return nodes;
    }
    static _findAllNodes(t, index, findTokens, nodes) {
        // check this node (the root) first
        if (findTokens && t instanceof $1FMAL.TerminalNode) {
            if (t.symbol.type === index) nodes.push(t);
        } else if (!findTokens && t instanceof $5izRN.ParserRuleContext) {
            if (t.ruleIndex === index) nodes.push(t);
        }
        // check children
        for(let i = 0; i < t.childCount; i++)$1b941219782ea5c8$var$Trees._findAllNodes(t.getChild(i), index, findTokens, nodes);
    }
    /** Get all descendents; includes t itself.
     *
     * @since 4.5.1
     */ static getDescendants(t) {
        let nodes = [];
        function recurse(e) {
            nodes.push(e);
            const n = e.childCount;
            for(let i = 0; i < n; i++)recurse(e.getChild(i));
        }
        recurse(t);
        return nodes;
    }
    /** Find smallest subtree of t enclosing range startTokenIndex..stopTokenIndex
     *  inclusively using postorder traversal.  Recursive depth-first-search.
     *
     *  @since 4.5
     */ static getRootOfSubtreeEnclosingRegion(t, startTokenIndex, stopTokenIndex) {
        let n = t.childCount;
        for(let i = 0; i < n; i++){
            let child = t.getChild(i);
            let r = $1b941219782ea5c8$var$Trees.getRootOfSubtreeEnclosingRegion(child, startTokenIndex, stopTokenIndex);
            if (r) return r;
        }
        if (t instanceof $5izRN.ParserRuleContext) {
            let stopToken = t.stop;
            if (startTokenIndex >= t.start.tokenIndex && // is range fully contained in t?
            (stopToken == null || stopTokenIndex <= stopToken.tokenIndex)) // note: r.stop==null likely implies that we bailed out of parser and there's nothing to the right
            return t;
        }
        return undefined;
    }
    /** Replace any subtree siblings of root that are completely to left
     *  or right of lookahead range with a CommonToken(Token.INVALID_TYPE,"...")
     *  node. The source interval for t is not altered to suit smaller range!
     *
     *  WARNING: destructive to t.
     *
     *  @since 4.5.1
     */ static stripChildrenOutOfRange(t, root, startIndex, stopIndex) {
        if (!t) return;
        let count = t.childCount;
        for(let i = 0; i < count; i++){
            let child = t.getChild(i);
            let range = child.sourceInterval;
            if (child instanceof $5izRN.ParserRuleContext && (range.b < startIndex || range.a > stopIndex)) {
                if ($1b941219782ea5c8$var$Trees.isAncestorOf(child, root)) {
                    let abbrev = new $eAd9i.CommonToken($TNDGs.Token.INVALID_TYPE, "...");
                    t.children[i] = new $1FMAL.TerminalNode(abbrev); // HACK access to private
                }
            }
        }
    }
    static findNodeSuchThat(t, pred) {
        // No type check needed as long as users only use one of the available overloads
        if (pred(t)) return t;
        let n = t.childCount;
        for(let i = 0; i < n; i++){
            let u = $1b941219782ea5c8$var$Trees.findNodeSuchThat(t.getChild(i), pred);
            if (u !== undefined) return u;
        }
        return undefined;
    }
}
$1b941219782ea5c8$var$__decorate([
    $1b941219782ea5c8$var$__param(0, $ffTXa.NotNull)
], $1b941219782ea5c8$var$Trees, "toStringTree", null);
$1b941219782ea5c8$var$__decorate([
    $ffTXa.NotNull,
    $1b941219782ea5c8$var$__param(0, $ffTXa.NotNull)
], $1b941219782ea5c8$var$Trees, "getAncestors", null);
$1b941219782ea5c8$var$__decorate([
    $1b941219782ea5c8$var$__param(0, $ffTXa.NotNull)
], $1b941219782ea5c8$var$Trees, "getRootOfSubtreeEnclosingRegion", null);
module.exports.Trees = $1b941219782ea5c8$var$Trees;

});

parcelRegister("67XvK", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $47618f32cfd622c1$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredictionMode = void 0;

var $5ZofD = parcelRequire("5ZofD");


var $kPsXR = parcelRequire("kPsXR");


var $ffTXa = parcelRequire("ffTXa");


var $9v0dI = parcelRequire("9v0dI");

/**
 * This enumeration defines the prediction modes available in ANTLR 4 along with
 * utility methods for analyzing configuration sets for conflicts and/or
 * ambiguities.
 */ var $47618f32cfd622c1$var$PredictionMode;
(function(PredictionMode) {
    /**
     * The SLL(*) prediction mode. This prediction mode ignores the current
     * parser context when making predictions. This is the fastest prediction
     * mode, and provides correct results for many grammars. This prediction
     * mode is more powerful than the prediction mode provided by ANTLR 3, but
     * may result in syntax errors for grammar and input combinations which are
     * not SLL.
     *
     * When using this prediction mode, the parser will either return a correct
     * parse tree (i.e. the same parse tree that would be returned with the
     * {@link #LL} prediction mode), or it will report a syntax error. If a
     * syntax error is encountered when using the {@link #SLL} prediction mode,
     * it may be due to either an actual syntax error in the input or indicate
     * that the particular combination of grammar and input requires the more
     * powerful {@link #LL} prediction abilities to complete successfully.
     *
     * This prediction mode does not provide any guarantees for prediction
     * behavior for syntactically-incorrect inputs.
     */ PredictionMode[PredictionMode["SLL"] = 0] = "SLL";
    /**
     * The LL(*) prediction mode. This prediction mode allows the current parser
     * context to be used for resolving SLL conflicts that occur during
     * prediction. This is the fastest prediction mode that guarantees correct
     * parse results for all combinations of grammars with syntactically correct
     * inputs.
     *
     * When using this prediction mode, the parser will make correct decisions
     * for all syntactically-correct grammar and input combinations. However, in
     * cases where the grammar is truly ambiguous this prediction mode might not
     * report a precise answer for *exactly which* alternatives are
     * ambiguous.
     *
     * This prediction mode does not provide any guarantees for prediction
     * behavior for syntactically-incorrect inputs.
     */ PredictionMode[PredictionMode["LL"] = 1] = "LL";
    /**
     * The LL(*) prediction mode with exact ambiguity detection. In addition to
     * the correctness guarantees provided by the {@link #LL} prediction mode,
     * this prediction mode instructs the prediction algorithm to determine the
     * complete and exact set of ambiguous alternatives for every ambiguous
     * decision encountered while parsing.
     *
     * This prediction mode may be used for diagnosing ambiguities during
     * grammar development. Due to the performance overhead of calculating sets
     * of ambiguous alternatives, this prediction mode should be avoided when
     * the exact results are not necessary.
     *
     * This prediction mode does not provide any guarantees for prediction
     * behavior for syntactically-incorrect inputs.
     */ PredictionMode[PredictionMode["LL_EXACT_AMBIG_DETECTION"] = 2] = "LL_EXACT_AMBIG_DETECTION";
})($47618f32cfd622c1$var$PredictionMode = module.exports.PredictionMode || (module.exports.PredictionMode = {}));
(function(PredictionMode) {
    /** A Map that uses just the state and the stack context as the key. */ // NOTE: Base type used to be FlexibleHashMap<ATNConfig, BitSet>
    class AltAndContextMap extends $5ZofD.Array2DHashMap {
        constructor(){
            super(AltAndContextConfigEqualityComparator.INSTANCE);
        }
    }
    class AltAndContextConfigEqualityComparator {
        AltAndContextConfigEqualityComparator() {
        // intentionally empty
        }
        /**
         * The hash code is only a function of the {@link ATNState#stateNumber}
         * and {@link ATNConfig#context}.
         */ hashCode(o) {
            let hashCode = $kPsXR.MurmurHash.initialize(7);
            hashCode = $kPsXR.MurmurHash.update(hashCode, o.state.stateNumber);
            hashCode = $kPsXR.MurmurHash.update(hashCode, o.context);
            hashCode = $kPsXR.MurmurHash.finish(hashCode, 2);
            return hashCode;
        }
        equals(a, b) {
            if (a === b) return true;
            if (a == null || b == null) return false;
            return a.state.stateNumber === b.state.stateNumber && a.context.equals(b.context);
        }
    }
    AltAndContextConfigEqualityComparator.INSTANCE = new AltAndContextConfigEqualityComparator();
    $47618f32cfd622c1$var$__decorate([
        $ffTXa.Override
    ], AltAndContextConfigEqualityComparator.prototype, "hashCode", null);
    $47618f32cfd622c1$var$__decorate([
        $ffTXa.Override
    ], AltAndContextConfigEqualityComparator.prototype, "equals", null);
    /**
     * Checks if any configuration in `configs` is in a
     * {@link RuleStopState}. Configurations meeting this condition have reached
     * the end of the decision rule (local context) or end of start rule (full
     * context).
     *
     * @param configs the configuration set to test
     * @returns `true` if any configuration in `configs` is in a
     * {@link RuleStopState}, otherwise `false`
     */ function hasConfigInRuleStopState(configs) {
        for (let c of configs){
            if (c.state instanceof $9v0dI.RuleStopState) return true;
        }
        return false;
    }
    PredictionMode.hasConfigInRuleStopState = hasConfigInRuleStopState;
    /**
     * Checks if all configurations in `configs` are in a
     * {@link RuleStopState}. Configurations meeting this condition have reached
     * the end of the decision rule (local context) or end of start rule (full
     * context).
     *
     * @param configs the configuration set to test
     * @returns `true` if all configurations in `configs` are in a
     * {@link RuleStopState}, otherwise `false`
     */ function allConfigsInRuleStopStates(/*@NotNull*/ configs) {
        for (let config of configs){
            if (!(config.state instanceof $9v0dI.RuleStopState)) return false;
        }
        return true;
    }
    PredictionMode.allConfigsInRuleStopStates = allConfigsInRuleStopStates;
})($47618f32cfd622c1$var$PredictionMode = module.exports.PredictionMode || (module.exports.PredictionMode = {}));

});

parcelRegister("23Sey", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $1805ee4613e1eeae$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $1805ee4613e1eeae$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SimulatorState = void 0;

var $ffTXa = parcelRequire("ffTXa");


var $5izRN = parcelRequire("5izRN");

/**
 *
 * @author Sam Harwell
 */ let $1805ee4613e1eeae$var$SimulatorState = class SimulatorState {
    constructor(outerContext, s0, useContext, remainingOuterContext){
        this.outerContext = outerContext != null ? outerContext : $5izRN.ParserRuleContext.emptyContext();
        this.s0 = s0;
        this.useContext = useContext;
        this.remainingOuterContext = remainingOuterContext;
    }
};
$1805ee4613e1eeae$var$SimulatorState = $1805ee4613e1eeae$var$__decorate([
    $1805ee4613e1eeae$var$__param(1, $ffTXa.NotNull)
], $1805ee4613e1eeae$var$SimulatorState);
module.exports.SimulatorState = $1805ee4613e1eeae$var$SimulatorState;

});

parcelRegister("eGHKd", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ab16ebacd3e99c5f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PlusBlockStartState = void 0;

var $5dqQL = parcelRequire("5dqQL");


var $iqCbM = parcelRequire("iqCbM");


var $ffTXa = parcelRequire("ffTXa");

/** Start of `(A|B|...)+` loop. Technically a decision state, but
 *  we don't use for code generation; somebody might need it, so I'm defining
 *  it for completeness. In reality, the {@link PlusLoopbackState} node is the
 *  real decision-making note for `A+`.
 */ class $ab16ebacd3e99c5f$var$PlusBlockStartState extends $iqCbM.BlockStartState {
    get stateType() {
        return $5dqQL.ATNStateType.PLUS_BLOCK_START;
    }
}
$ab16ebacd3e99c5f$var$__decorate([
    $ffTXa.Override
], $ab16ebacd3e99c5f$var$PlusBlockStartState.prototype, "stateType", null);
module.exports.PlusBlockStartState = $ab16ebacd3e99c5f$var$PlusBlockStartState;

});

parcelRegister("Q73wd", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $09ca549192e28e19$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PlusLoopbackState = void 0;

var $5dqQL = parcelRequire("5dqQL");


var $gh7Hp = parcelRequire("gh7Hp");


var $ffTXa = parcelRequire("ffTXa");

/** Decision state for `A+` and `(A|B)+`.  It has two transitions:
 *  one to the loop back to start of the block and one to exit.
 */ class $09ca549192e28e19$var$PlusLoopbackState extends $gh7Hp.DecisionState {
    get stateType() {
        return $5dqQL.ATNStateType.PLUS_LOOP_BACK;
    }
}
$09ca549192e28e19$var$__decorate([
    $ffTXa.Override
], $09ca549192e28e19$var$PlusLoopbackState.prototype, "stateType", null);
module.exports.PlusLoopbackState = $09ca549192e28e19$var$PlusLoopbackState;

});

parcelRegister("aQIOE", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7e61863a94ee3fe7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $7e61863a94ee3fe7$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrecedencePredicateTransition = void 0;

var $b3uXT = parcelRequire("b3uXT");


var $ffTXa = parcelRequire("ffTXa");


var $3LYKb = parcelRequire("3LYKb");

/**
 *
 * @author Sam Harwell
 */ let $7e61863a94ee3fe7$var$PrecedencePredicateTransition = class PrecedencePredicateTransition extends $b3uXT.AbstractPredicateTransition {
    get serializationType() {
        return 10 /* PRECEDENCE */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    get predicate() {
        return new $3LYKb.SemanticContext.PrecedencePredicate(this.precedence);
    }
    toString() {
        return this.precedence + " >= _p";
    }
    constructor(target, precedence){
        super(target);
        this.precedence = precedence;
    }
};
$7e61863a94ee3fe7$var$__decorate([
    $ffTXa.Override
], $7e61863a94ee3fe7$var$PrecedencePredicateTransition.prototype, "serializationType", null);
$7e61863a94ee3fe7$var$__decorate([
    $ffTXa.Override
], $7e61863a94ee3fe7$var$PrecedencePredicateTransition.prototype, "isEpsilon", null);
$7e61863a94ee3fe7$var$__decorate([
    $ffTXa.Override
], $7e61863a94ee3fe7$var$PrecedencePredicateTransition.prototype, "matches", null);
$7e61863a94ee3fe7$var$__decorate([
    $ffTXa.Override
], $7e61863a94ee3fe7$var$PrecedencePredicateTransition.prototype, "toString", null);
$7e61863a94ee3fe7$var$PrecedencePredicateTransition = $7e61863a94ee3fe7$var$__decorate([
    $7e61863a94ee3fe7$var$__param(0, $ffTXa.NotNull)
], $7e61863a94ee3fe7$var$PrecedencePredicateTransition);
module.exports.PrecedencePredicateTransition = $7e61863a94ee3fe7$var$PrecedencePredicateTransition;

});

parcelRegister("1t50n", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $111c61cbb15b6a43$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $111c61cbb15b6a43$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RangeTransition = void 0;

var $69z5o = parcelRequire("69z5o");


var $ffTXa = parcelRequire("ffTXa");


var $ikYx7 = parcelRequire("ikYx7");

let $111c61cbb15b6a43$var$RangeTransition = class RangeTransition extends $ikYx7.Transition {
    get serializationType() {
        return 2 /* RANGE */ ;
    }
    get label() {
        return $69z5o.IntervalSet.of(this.from, this.to);
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return symbol >= this.from && symbol <= this.to;
    }
    toString() {
        return "'" + String.fromCodePoint(this.from) + "'..'" + String.fromCodePoint(this.to) + "'";
    }
    constructor(target, from, to){
        super(target);
        this.from = from;
        this.to = to;
    }
};
$111c61cbb15b6a43$var$__decorate([
    $ffTXa.Override
], $111c61cbb15b6a43$var$RangeTransition.prototype, "serializationType", null);
$111c61cbb15b6a43$var$__decorate([
    $ffTXa.Override,
    $ffTXa.NotNull
], $111c61cbb15b6a43$var$RangeTransition.prototype, "label", null);
$111c61cbb15b6a43$var$__decorate([
    $ffTXa.Override
], $111c61cbb15b6a43$var$RangeTransition.prototype, "matches", null);
$111c61cbb15b6a43$var$__decorate([
    $ffTXa.Override,
    $ffTXa.NotNull
], $111c61cbb15b6a43$var$RangeTransition.prototype, "toString", null);
$111c61cbb15b6a43$var$RangeTransition = $111c61cbb15b6a43$var$__decorate([
    $111c61cbb15b6a43$var$__param(0, $ffTXa.NotNull)
], $111c61cbb15b6a43$var$RangeTransition);
module.exports.RangeTransition = $111c61cbb15b6a43$var$RangeTransition;

});

parcelRegister("kdHyX", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $eb86d03963195e46$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleStartState = void 0;

var $2UrJv = parcelRequire("2UrJv");


var $5dqQL = parcelRequire("5dqQL");


var $ffTXa = parcelRequire("ffTXa");

class $eb86d03963195e46$var$RuleStartState extends $2UrJv.ATNState {
    get stateType() {
        return $5dqQL.ATNStateType.RULE_START;
    }
    constructor(){
        super(...arguments);
        this.isPrecedenceRule = false;
        this.leftFactored = false;
    }
}
$eb86d03963195e46$var$__decorate([
    $ffTXa.Override
], $eb86d03963195e46$var$RuleStartState.prototype, "stateType", null);
module.exports.RuleStartState = $eb86d03963195e46$var$RuleStartState;

});

parcelRegister("bWUSi", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $8b313aa21a395af7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarBlockStartState = void 0;

var $5dqQL = parcelRequire("5dqQL");


var $iqCbM = parcelRequire("iqCbM");


var $ffTXa = parcelRequire("ffTXa");

/** The block that begins a closure loop. */ class $8b313aa21a395af7$var$StarBlockStartState extends $iqCbM.BlockStartState {
    get stateType() {
        return $5dqQL.ATNStateType.STAR_BLOCK_START;
    }
}
$8b313aa21a395af7$var$__decorate([
    $ffTXa.Override
], $8b313aa21a395af7$var$StarBlockStartState.prototype, "stateType", null);
module.exports.StarBlockStartState = $8b313aa21a395af7$var$StarBlockStartState;

});

parcelRegister("e3CzM", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a3bf44efaac4a2c4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarLoopbackState = void 0;

var $2UrJv = parcelRequire("2UrJv");


var $5dqQL = parcelRequire("5dqQL");


var $ffTXa = parcelRequire("ffTXa");

class $a3bf44efaac4a2c4$var$StarLoopbackState extends $2UrJv.ATNState {
    get loopEntryState() {
        return this.transition(0).target;
    }
    get stateType() {
        return $5dqQL.ATNStateType.STAR_LOOP_BACK;
    }
}
$a3bf44efaac4a2c4$var$__decorate([
    $ffTXa.Override
], $a3bf44efaac4a2c4$var$StarLoopbackState.prototype, "stateType", null);
module.exports.StarLoopbackState = $a3bf44efaac4a2c4$var$StarLoopbackState;

});

parcelRegister("3ImLJ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $2b472496bba93e92$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TokensStartState = void 0;

var $5dqQL = parcelRequire("5dqQL");


var $gh7Hp = parcelRequire("gh7Hp");


var $ffTXa = parcelRequire("ffTXa");

/** The Tokens rule start state linking to each lexer rule start state */ class $2b472496bba93e92$var$TokensStartState extends $gh7Hp.DecisionState {
    get stateType() {
        return $5dqQL.ATNStateType.TOKEN_START;
    }
}
$2b472496bba93e92$var$__decorate([
    $ffTXa.Override
], $2b472496bba93e92$var$TokensStartState.prototype, "stateType", null);
module.exports.TokensStartState = $2b472496bba93e92$var$TokensStartState;

});

parcelRegister("eXZgF", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ae5619e899a20a5b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $ae5619e899a20a5b$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParseInfo = void 0;

var $ffTXa = parcelRequire("ffTXa");

/**
 * This class provides access to specific and aggregate statistics gathered
 * during profiling of a parser.
 *
 * @since 4.3
 */ let $ae5619e899a20a5b$var$ParseInfo = class ParseInfo {
    /**
     * Gets an array of {@link DecisionInfo} instances containing the profiling
     * information gathered for each decision in the ATN.
     *
     * @returns An array of {@link DecisionInfo} instances, indexed by decision
     * number.
     */ getDecisionInfo() {
        return this.atnSimulator.getDecisionInfo();
    }
    /**
     * Gets the decision numbers for decisions that required one or more
     * full-context predictions during parsing. These are decisions for which
     * {@link DecisionInfo#LL_Fallback} is non-zero.
     *
     * @returns A list of decision numbers which required one or more
     * full-context predictions during parsing.
     */ getLLDecisions() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let LL = [];
        for(let i = 0; i < decisions.length; i++){
            let fallBack = decisions[i].LL_Fallback;
            if (fallBack > 0) LL.push(i);
        }
        return LL;
    }
    /**
     * Gets the total time spent during prediction across all decisions made
     * during parsing. This value is the sum of
     * {@link DecisionInfo#timeInPrediction} for all decisions.
     */ getTotalTimeInPrediction() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let t = 0;
        for (let decision of decisions)t += decision.timeInPrediction;
        return t;
    }
    /**
     * Gets the total number of SLL lookahead operations across all decisions
     * made during parsing. This value is the sum of
     * {@link DecisionInfo#SLL_TotalLook} for all decisions.
     */ getTotalSLLLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.SLL_TotalLook;
        return k;
    }
    /**
     * Gets the total number of LL lookahead operations across all decisions
     * made during parsing. This value is the sum of
     * {@link DecisionInfo#LL_TotalLook} for all decisions.
     */ getTotalLLLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.LL_TotalLook;
        return k;
    }
    /**
     * Gets the total number of ATN lookahead operations for SLL prediction
     * across all decisions made during parsing.
     */ getTotalSLLATNLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.SLL_ATNTransitions;
        return k;
    }
    /**
     * Gets the total number of ATN lookahead operations for LL prediction
     * across all decisions made during parsing.
     */ getTotalLLATNLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.LL_ATNTransitions;
        return k;
    }
    /**
     * Gets the total number of ATN lookahead operations for SLL and LL
     * prediction across all decisions made during parsing.
     *
     * This value is the sum of {@link #getTotalSLLATNLookaheadOps} and
     * {@link #getTotalLLATNLookaheadOps}.
     */ getTotalATNLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions){
            k += decision.SLL_ATNTransitions;
            k += decision.LL_ATNTransitions;
        }
        return k;
    }
    getDFASize(decision) {
        if (decision) {
            let decisionToDFA = this.atnSimulator.atn.decisionToDFA[decision];
            return decisionToDFA.states.size;
        } else {
            let n = 0;
            let decisionToDFA = this.atnSimulator.atn.decisionToDFA;
            for(let i = 0; i < decisionToDFA.length; i++)n += this.getDFASize(i);
            return n;
        }
    }
    constructor(atnSimulator){
        this.atnSimulator = atnSimulator;
    }
};
$ae5619e899a20a5b$var$__decorate([
    $ffTXa.NotNull
], $ae5619e899a20a5b$var$ParseInfo.prototype, "getDecisionInfo", null);
$ae5619e899a20a5b$var$__decorate([
    $ffTXa.NotNull
], $ae5619e899a20a5b$var$ParseInfo.prototype, "getLLDecisions", null);
$ae5619e899a20a5b$var$ParseInfo = $ae5619e899a20a5b$var$__decorate([
    $ae5619e899a20a5b$var$__param(0, $ffTXa.NotNull)
], $ae5619e899a20a5b$var$ParseInfo);
module.exports.ParseInfo = $ae5619e899a20a5b$var$ParseInfo;

});

parcelRegister("c6a5T", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $8cede00cee72e611$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProxyParserErrorListener = void 0;

var $16dXu = parcelRequire("16dXu");


var $ffTXa = parcelRequire("ffTXa");

/**
 * @author Sam Harwell
 */ class $8cede00cee72e611$var$ProxyParserErrorListener extends $16dXu.ProxyErrorListener {
    reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs) {
        this.getDelegates().forEach((listener)=>{
            if (listener.reportAmbiguity) listener.reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs);
        });
    }
    reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState) {
        this.getDelegates().forEach((listener)=>{
            if (listener.reportAttemptingFullContext) listener.reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState);
        });
    }
    reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState) {
        this.getDelegates().forEach((listener)=>{
            if (listener.reportContextSensitivity) listener.reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState);
        });
    }
    constructor(delegates){
        super(delegates);
    }
}
$8cede00cee72e611$var$__decorate([
    $ffTXa.Override
], $8cede00cee72e611$var$ProxyParserErrorListener.prototype, "reportAmbiguity", null);
$8cede00cee72e611$var$__decorate([
    $ffTXa.Override
], $8cede00cee72e611$var$ProxyParserErrorListener.prototype, "reportAttemptingFullContext", null);
$8cede00cee72e611$var$__decorate([
    $ffTXa.Override
], $8cede00cee72e611$var$ProxyParserErrorListener.prototype, "reportContextSensitivity", null);
module.exports.ProxyParserErrorListener = $8cede00cee72e611$var$ProxyParserErrorListener;

});

parcelRegister("5s5a8", function(module, exports) {

let $3f83926dfd87aa50$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3f83926dfd87aa50$var$load("cDkM1").then(()=>parcelRequire('cfEtH'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("d2I3G", function(module, exports) {

let $97eda35c65147715$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $97eda35c65147715$var$load("eqAkJ").then(()=>parcelRequire('7di2z'));

});

parcelRegister("bXUCC", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParseCancellationException = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:42.5447085-07:00
/**
 * This exception is thrown to cancel a parsing operation. This exception does
 * not extend {@link RecognitionException}, allowing it to bypass the standard
 * error recovery mechanisms. {@link BailErrorStrategy} throws this exception in
 * response to a parse error.
 *
 * @author Sam Harwell
 */ class $8b6120590e207cb8$var$ParseCancellationException extends Error {
    getCause() {
        return this.cause;
    }
    constructor(cause){
        super(cause.message);
        this.cause = cause;
        this.stack = cause.stack;
    }
}
module.exports.ParseCancellationException = $8b6120590e207cb8$var$ParseCancellationException;

});

parcelRegister("geTWu", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $bd295923d25c13ab$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $bd295923d25c13ab$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BufferedTokenStream = void 0;

var $9Rq82 = parcelRequire("9Rq82");


var $eAd9i = parcelRequire("eAd9i");


var $dQ3yU = parcelRequire("dQ3yU");


var $gJMeE = parcelRequire("gJMeE");


var $ffTXa = parcelRequire("ffTXa");


var $TNDGs = parcelRequire("TNDGs");

/**
 * This implementation of {@link TokenStream} loads tokens from a
 * {@link TokenSource} on-demand, and places the tokens in a buffer to provide
 * access to any previous token by index.
 *
 * This token stream ignores the value of {@link Token#getChannel}. If your
 * parser requires the token stream filter tokens to only those on a particular
 * channel, such as {@link Token#DEFAULT_CHANNEL} or
 * {@link Token#HIDDEN_CHANNEL}, use a filtering token stream such a
 * {@link CommonTokenStream}.
 */ let $bd295923d25c13ab$var$BufferedTokenStream = class BufferedTokenStream {
    get tokenSource() {
        return this._tokenSource;
    }
    /** Reset this token stream by setting its token source. */ set tokenSource(tokenSource) {
        this._tokenSource = tokenSource;
        this.tokens.length = 0;
        this.p = -1;
        this.fetchedEOF = false;
    }
    get index() {
        return this.p;
    }
    mark() {
        return 0;
    }
    release(marker) {
    // no resources to release
    }
    seek(index) {
        this.lazyInit();
        this.p = this.adjustSeekIndex(index);
    }
    get size() {
        return this.tokens.length;
    }
    consume() {
        let skipEofCheck;
        if (this.p >= 0) {
            if (this.fetchedEOF) // the last token in tokens is EOF. skip check if p indexes any
            // fetched token except the last.
            skipEofCheck = this.p < this.tokens.length - 1;
            else // no EOF token in tokens. skip check if p indexes a fetched token.
            skipEofCheck = this.p < this.tokens.length;
        } else // not yet initialized
        skipEofCheck = false;
        if (!skipEofCheck && this.LA(1) === $TNDGs.Token.EOF) throw new Error("cannot consume EOF");
        if (this.sync(this.p + 1)) this.p = this.adjustSeekIndex(this.p + 1);
    }
    /** Make sure index `i` in tokens has a token.
     *
     * @returns `true` if a token is located at index `i`, otherwise
     *    `false`.
     * @see #get(int i)
     */ sync(i) {
        $9Rq82(i >= 0);
        let n = i - this.tokens.length + 1; // how many more elements we need?
        //System.out.println("sync("+i+") needs "+n);
        if (n > 0) {
            let fetched = this.fetch(n);
            return fetched >= n;
        }
        return true;
    }
    /** Add `n` elements to buffer.
     *
     * @returns The actual number of elements added to the buffer.
     */ fetch(n) {
        if (this.fetchedEOF) return 0;
        for(let i = 0; i < n; i++){
            let t = this.tokenSource.nextToken();
            if (this.isWritableToken(t)) t.tokenIndex = this.tokens.length;
            this.tokens.push(t);
            if (t.type === $TNDGs.Token.EOF) {
                this.fetchedEOF = true;
                return i + 1;
            }
        }
        return n;
    }
    get(i) {
        if (i < 0 || i >= this.tokens.length) throw new RangeError("token index " + i + " out of range 0.." + (this.tokens.length - 1));
        return this.tokens[i];
    }
    /** Get all tokens from start..stop inclusively. */ getRange(start, stop) {
        if (start < 0 || stop < 0) return [];
        this.lazyInit();
        let subset = new Array();
        if (stop >= this.tokens.length) stop = this.tokens.length - 1;
        for(let i = start; i <= stop; i++){
            let t = this.tokens[i];
            if (t.type === $TNDGs.Token.EOF) break;
            subset.push(t);
        }
        return subset;
    }
    LA(i) {
        let token = this.LT(i);
        if (!token) return $TNDGs.Token.INVALID_TYPE;
        return token.type;
    }
    tryLB(k) {
        if (this.p - k < 0) return undefined;
        return this.tokens[this.p - k];
    }
    LT(k) {
        let result = this.tryLT(k);
        if (result === undefined) throw new RangeError("requested lookback index out of range");
        return result;
    }
    tryLT(k) {
        this.lazyInit();
        if (k === 0) throw new RangeError("0 is not a valid lookahead index");
        if (k < 0) return this.tryLB(-k);
        let i = this.p + k - 1;
        this.sync(i);
        if (i >= this.tokens.length) // return EOF token
        // EOF must be last token
        return this.tokens[this.tokens.length - 1];
        //		if ( i>range ) range = i;
        return this.tokens[i];
    }
    /**
     * Allowed derived classes to modify the behavior of operations which change
     * the current stream position by adjusting the target token index of a seek
     * operation. The default implementation simply returns `i`. If an
     * exception is thrown in this method, the current stream index should not be
     * changed.
     *
     * For example, {@link CommonTokenStream} overrides this method to ensure that
     * the seek target is always an on-channel token.
     *
     * @param i The target token index.
     * @returns The adjusted target token index.
     */ adjustSeekIndex(i) {
        return i;
    }
    lazyInit() {
        if (this.p === -1) this.setup();
    }
    setup() {
        this.sync(0);
        this.p = this.adjustSeekIndex(0);
    }
    /** Given a start and stop index, return a `List` of all tokens in
     *  the token type `BitSet`.  Return an empty array if no tokens were found.  This
     *  method looks at both on and off channel tokens.
     */ getTokens(start, stop, types) {
        this.lazyInit();
        if (start === undefined) {
            $9Rq82(stop === undefined && types === undefined);
            return this.tokens;
        } else if (stop === undefined) stop = this.tokens.length - 1;
        if (start < 0 || stop >= this.tokens.length || stop < 0 || start >= this.tokens.length) throw new RangeError("start " + start + " or stop " + stop + " not in 0.." + (this.tokens.length - 1));
        if (start > stop) return [];
        if (types === undefined) return this.tokens.slice(start, stop + 1);
        else if (typeof types === "number") types = new Set().add(types);
        let typesSet = types;
        // list = tokens[start:stop]:{T t, t.type in types}
        let filteredTokens = this.tokens.slice(start, stop + 1);
        filteredTokens = filteredTokens.filter((value)=>typesSet.has(value.type));
        return filteredTokens;
    }
    /**
     * Given a starting index, return the index of the next token on channel.
     * Return `i` if `tokens[i]` is on channel. Return the index of
     * the EOF token if there are no tokens on channel between `i` and
     * EOF.
     */ nextTokenOnChannel(i, channel) {
        this.sync(i);
        if (i >= this.size) return this.size - 1;
        let token = this.tokens[i];
        while(token.channel !== channel){
            if (token.type === $TNDGs.Token.EOF) return i;
            i++;
            this.sync(i);
            token = this.tokens[i];
        }
        return i;
    }
    /**
     * Given a starting index, return the index of the previous token on
     * channel. Return `i` if `tokens[i]` is on channel. Return -1
     * if there are no tokens on channel between `i` and 0.
     *
     * If `i` specifies an index at or after the EOF token, the EOF token
     * index is returned. This is due to the fact that the EOF token is treated
     * as though it were on every channel.
     */ previousTokenOnChannel(i, channel) {
        this.sync(i);
        if (i >= this.size) // the EOF token is on every channel
        return this.size - 1;
        while(i >= 0){
            let token = this.tokens[i];
            if (token.type === $TNDGs.Token.EOF || token.channel === channel) return i;
            i--;
        }
        return i;
    }
    /** Collect all tokens on specified channel to the right of
     *  the current token up until we see a token on {@link Lexer#DEFAULT_TOKEN_CHANNEL} or
     *  EOF. If `channel` is `-1`, find any non default channel token.
     */ getHiddenTokensToRight(tokenIndex, channel = -1) {
        this.lazyInit();
        if (tokenIndex < 0 || tokenIndex >= this.tokens.length) throw new RangeError(tokenIndex + " not in 0.." + (this.tokens.length - 1));
        let nextOnChannel = this.nextTokenOnChannel(tokenIndex + 1, $gJMeE.Lexer.DEFAULT_TOKEN_CHANNEL);
        let to;
        let from = tokenIndex + 1;
        // if none onchannel to right, nextOnChannel=-1 so set to = last token
        if (nextOnChannel === -1) to = this.size - 1;
        else to = nextOnChannel;
        return this.filterForChannel(from, to, channel);
    }
    /** Collect all tokens on specified channel to the left of
     *  the current token up until we see a token on {@link Lexer#DEFAULT_TOKEN_CHANNEL}.
     *  If `channel` is `-1`, find any non default channel token.
     */ getHiddenTokensToLeft(tokenIndex, channel = -1) {
        this.lazyInit();
        if (tokenIndex < 0 || tokenIndex >= this.tokens.length) throw new RangeError(tokenIndex + " not in 0.." + (this.tokens.length - 1));
        if (tokenIndex === 0) // obviously no tokens can appear before the first token
        return [];
        let prevOnChannel = this.previousTokenOnChannel(tokenIndex - 1, $gJMeE.Lexer.DEFAULT_TOKEN_CHANNEL);
        if (prevOnChannel === tokenIndex - 1) return [];
        // if none onchannel to left, prevOnChannel=-1 then from=0
        let from = prevOnChannel + 1;
        let to = tokenIndex - 1;
        return this.filterForChannel(from, to, channel);
    }
    filterForChannel(from, to, channel) {
        let hidden = new Array();
        for(let i = from; i <= to; i++){
            let t = this.tokens[i];
            if (channel === -1) {
                if (t.channel !== $gJMeE.Lexer.DEFAULT_TOKEN_CHANNEL) hidden.push(t);
            } else if (t.channel === channel) hidden.push(t);
        }
        return hidden;
    }
    get sourceName() {
        return this.tokenSource.sourceName;
    }
    getText(interval) {
        if (interval === undefined) interval = $dQ3yU.Interval.of(0, this.size - 1);
        else if (!(interval instanceof $dQ3yU.Interval)) // Note: the more obvious check for 'instanceof RuleContext' results in a circular dependency problem
        interval = interval.sourceInterval;
        let start = interval.a;
        let stop = interval.b;
        if (start < 0 || stop < 0) return "";
        this.fill();
        if (stop >= this.tokens.length) stop = this.tokens.length - 1;
        let buf = "";
        for(let i = start; i <= stop; i++){
            let t = this.tokens[i];
            if (t.type === $TNDGs.Token.EOF) break;
            buf += t.text;
        }
        return buf.toString();
    }
    getTextFromRange(start, stop) {
        if (this.isToken(start) && this.isToken(stop)) return this.getText($dQ3yU.Interval.of(start.tokenIndex, stop.tokenIndex));
        return "";
    }
    /** Get all tokens from lexer until EOF. */ fill() {
        this.lazyInit();
        const blockSize = 1000;
        while(true){
            let fetched = this.fetch(blockSize);
            if (fetched < blockSize) return;
        }
    }
    // TODO: Figure out a way to make this more flexible?
    isWritableToken(t) {
        return t instanceof $eAd9i.CommonToken;
    }
    // TODO: Figure out a way to make this more flexible?
    isToken(t) {
        return t instanceof $eAd9i.CommonToken;
    }
    constructor(tokenSource){
        /**
         * A collection of all tokens fetched from the token source. The list is
         * considered a complete view of the input once {@link #fetchedEOF} is set
         * to `true`.
         */ this.tokens = [];
        /**
         * The index into {@link #tokens} of the current token (next token to
         * {@link #consume}). {@link #tokens}`[`{@link #p}`]` should be
         * {@link #LT LT(1)}.
         *
         * This field is set to -1 when the stream is first constructed or when
         * {@link #setTokenSource} is called, indicating that the first token has
         * not yet been fetched from the token source. For additional information,
         * see the documentation of {@link IntStream} for a description of
         * Initializing Methods.
         */ this.p = -1;
        /**
         * Indicates whether the {@link Token#EOF} token has been fetched from
         * {@link #tokenSource} and added to {@link #tokens}. This field improves
         * performance for the following cases:
         *
         * * {@link #consume}: The lookahead check in {@link #consume} to prevent
         *   consuming the EOF symbol is optimized by checking the values of
         *   {@link #fetchedEOF} and {@link #p} instead of calling {@link #LA}.
         * * {@link #fetch}: The check to prevent adding multiple EOF symbols into
         *   {@link #tokens} is trivial with this field.
         */ this.fetchedEOF = false;
        if (tokenSource == null) throw new Error("tokenSource cannot be null");
        this._tokenSource = tokenSource;
    }
};
$bd295923d25c13ab$var$__decorate([
    $ffTXa.NotNull
], $bd295923d25c13ab$var$BufferedTokenStream.prototype, "_tokenSource", void 0);
$bd295923d25c13ab$var$__decorate([
    $ffTXa.Override
], $bd295923d25c13ab$var$BufferedTokenStream.prototype, "tokenSource", null);
$bd295923d25c13ab$var$__decorate([
    $ffTXa.Override
], $bd295923d25c13ab$var$BufferedTokenStream.prototype, "index", null);
$bd295923d25c13ab$var$__decorate([
    $ffTXa.Override
], $bd295923d25c13ab$var$BufferedTokenStream.prototype, "mark", null);
$bd295923d25c13ab$var$__decorate([
    $ffTXa.Override
], $bd295923d25c13ab$var$BufferedTokenStream.prototype, "release", null);
$bd295923d25c13ab$var$__decorate([
    $ffTXa.Override
], $bd295923d25c13ab$var$BufferedTokenStream.prototype, "seek", null);
$bd295923d25c13ab$var$__decorate([
    $ffTXa.Override
], $bd295923d25c13ab$var$BufferedTokenStream.prototype, "size", null);
$bd295923d25c13ab$var$__decorate([
    $ffTXa.Override
], $bd295923d25c13ab$var$BufferedTokenStream.prototype, "consume", null);
$bd295923d25c13ab$var$__decorate([
    $ffTXa.Override
], $bd295923d25c13ab$var$BufferedTokenStream.prototype, "get", null);
$bd295923d25c13ab$var$__decorate([
    $ffTXa.Override
], $bd295923d25c13ab$var$BufferedTokenStream.prototype, "LA", null);
$bd295923d25c13ab$var$__decorate([
    $ffTXa.NotNull,
    $ffTXa.Override
], $bd295923d25c13ab$var$BufferedTokenStream.prototype, "LT", null);
$bd295923d25c13ab$var$__decorate([
    $ffTXa.Override
], $bd295923d25c13ab$var$BufferedTokenStream.prototype, "sourceName", null);
$bd295923d25c13ab$var$__decorate([
    $ffTXa.NotNull,
    $ffTXa.Override
], $bd295923d25c13ab$var$BufferedTokenStream.prototype, "getText", null);
$bd295923d25c13ab$var$__decorate([
    $ffTXa.NotNull,
    $ffTXa.Override
], $bd295923d25c13ab$var$BufferedTokenStream.prototype, "getTextFromRange", null);
$bd295923d25c13ab$var$BufferedTokenStream = $bd295923d25c13ab$var$__decorate([
    $bd295923d25c13ab$var$__param(0, $ffTXa.NotNull)
], $bd295923d25c13ab$var$BufferedTokenStream);
module.exports.BufferedTokenStream = $bd295923d25c13ab$var$BufferedTokenStream;

});

parcelRegister("5hGFQ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9lBaI", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CharStreams = void 0;

var $cRZzh = parcelRequire("cRZzh");


var $fRlA6 = parcelRequire("fRlA6");


var $9P2T1 = parcelRequire("9P2T1");

// const DEFAULT_BUFFER_SIZE: number = 4096;
/** This class represents the primary interface for creating {@link CharStream}s
 *  from a variety of sources as of 4.7.  The motivation was to support
 *  Unicode code points > U+FFFF.  {@link ANTLRInputStream} and
 *  {@link ANTLRFileStream} are now deprecated in favor of the streams created
 *  by this interface.
 *
 *  DEPRECATED: {@code new ANTLRFileStream("myinputfile")}
 *  NEW:        {@code CharStreams.fromFileName("myinputfile")}
 *
 *  WARNING: If you use both the deprecated and the new streams, you will see
 *  a nontrivial performance degradation. This speed hit is because the
 *  {@link Lexer}'s internal code goes from a monomorphic to megamorphic
 *  dynamic dispatch to get characters from the input stream. Java's
 *  on-the-fly compiler (JIT) is unable to perform the same optimizations
 *  so stick with either the old or the new streams, if performance is
 *  a primary concern. See the extreme debugging and spelunking
 *  needed to identify this issue in our timing rig:
 *
 *      https://github.com/antlr/antlr4/pull/1781
 *
 *  The ANTLR character streams still buffer all the input when you create
 *  the stream, as they have done for ~20 years. If you need unbuffered
 *  access, please note that it becomes challenging to create
 *  parse trees. The parse tree has to point to tokens which will either
 *  point into a stale location in an unbuffered stream or you have to copy
 *  the characters out of the buffer into the token. That defeats the purpose
 *  of unbuffered input. Per the ANTLR book, unbuffered streams are primarily
 *  useful for processing infinite streams *during the parse.*
 *
 *  The new streams also use 8-bit buffers when possible so this new
 *  interface supports character streams that use half as much memory
 *  as the old {@link ANTLRFileStream}, which assumed 16-bit characters.
 *
 *  A big shout out to Ben Hamilton (github bhamiltoncx) for his superhuman
 *  efforts across all targets to get true Unicode 3.1 support for U+10FFFF.
 *
 *  @since 4.7
 */ var $6ce2e8cb6e179693$var$CharStreams;
(function(CharStreams) {
    // /**
    //  * Creates a {@link CharStream} given a path to a UTF-8
    //  * encoded file on disk.
    //  *
    //  * Reads the entire contents of the file into the result before returning.
    //  */
    // export function fromFile(file: File): CharStream;
    // export function fromFile(file: File, charset: Charset): CharStream;
    // export function fromFile(file: File, charset?: Charset): CharStream {
    // 	if (charset === undefined) {
    // 		charset = Charset.forName("UTF-8");
    // 	}
    function fromString(s, sourceName) {
        if (sourceName === undefined || sourceName.length === 0) sourceName = $9P2T1.IntStream.UNKNOWN_SOURCE_NAME;
        // Initial guess assumes no code points > U+FFFF: one code
        // point for each code unit in the string
        let codePointBufferBuilder = $cRZzh.CodePointBuffer.builder(s.length);
        // TODO: CharBuffer.wrap(String) rightfully returns a read-only buffer
        // which doesn't expose its array, so we make a copy.
        let cb = new Uint16Array(s.length);
        for(let i = 0; i < s.length; i++)cb[i] = s.charCodeAt(i);
        codePointBufferBuilder.append(cb);
        return $fRlA6.CodePointCharStream.fromBuffer(codePointBufferBuilder.build(), sourceName);
    }
    CharStreams.fromString = fromString;
// export function bufferFromChannel(
// 	channel: ReadableByteChannel,
// 	charset: Charset,
// 	bufferSize: number,
// 	decodingErrorAction: CodingErrorAction,
// 	inputSize: number): CodePointBuffer {
// 	try {
// 		let utf8BytesIn: Uint8Array = new Uint8Array(bufferSize);
// 		let utf16CodeUnitsOut: Uint16Array = new Uint16Array(bufferSize);
// 		if (inputSize === -1) {
// 			inputSize = bufferSize;
// 		} else if (inputSize > Integer.MAX_VALUE) {
// 			// ByteBuffer et al don't support long sizes
// 			throw new RangeError(`inputSize ${inputSize} larger than max ${Integer.MAX_VALUE}`);
// 		}
// 		let codePointBufferBuilder: CodePointBuffer.Builder = CodePointBuffer.builder(inputSize);
// 		let decoder: CharsetDecoder = charset
// 				.newDecoder()
// 				.onMalformedInput(decodingErrorAction)
// 				.onUnmappableCharacter(decodingErrorAction);
// 		let endOfInput: boolean = false;
// 		while (!endOfInput) {
// 			let bytesRead: number = channel.read(utf8BytesIn);
// 			endOfInput = (bytesRead === -1);
// 			utf8BytesIn.flip();
// 			let result: CoderResult = decoder.decode(
// 				utf8BytesIn,
// 				utf16CodeUnitsOut,
// 				endOfInput);
// 			if (result.isError() && decodingErrorAction === CodingErrorAction.REPORT) {
// 				result.throwException();
// 			}
// 			utf16CodeUnitsOut.flip();
// 			codePointBufferBuilder.append(utf16CodeUnitsOut);
// 			utf8BytesIn.compact();
// 			utf16CodeUnitsOut.compact();
// 		}
// 		// Handle any bytes at the end of the file which need to
// 		// be represented as errors or substitution characters.
// 		let flushResult: CoderResult = decoder.flush(utf16CodeUnitsOut);
// 		if (flushResult.isError() && decodingErrorAction === CodingErrorAction.REPORT) {
// 			flushResult.throwException();
// 		}
// 		utf16CodeUnitsOut.flip();
// 		codePointBufferBuilder.append(utf16CodeUnitsOut);
// 		return codePointBufferBuilder.build();
// 	}
// 	finally {
// 		channel.close();
// 	}
// }
})($6ce2e8cb6e179693$var$CharStreams = module.exports.CharStreams || (module.exports.CharStreams = {}));

});

parcelRegister("cRZzh", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CodePointBuffer = void 0;

var $9Rq82 = parcelRequire("9Rq82");


var $9Ltjs = parcelRequire("9Ltjs");

/**
 * Wrapper for `Uint8Array` / `Uint16Array` / `Int32Array`.
 */ class $95ea316103e1b53a$var$CodePointBuffer {
    static withArray(buffer) {
        return new $95ea316103e1b53a$var$CodePointBuffer(buffer, buffer.length);
    }
    get position() {
        return this._position;
    }
    set position(newPosition) {
        if (newPosition < 0 || newPosition > this._size) throw new RangeError();
        this._position = newPosition;
    }
    get remaining() {
        return this._size - this.position;
    }
    get(offset) {
        return this.buffer[offset];
    }
    array() {
        return this.buffer.slice(0, this._size);
    }
    static builder(initialBufferSize) {
        return new $95ea316103e1b53a$var$CodePointBuffer.Builder(initialBufferSize);
    }
    constructor(buffer, size){
        this.buffer = buffer;
        this._position = 0;
        this._size = size;
    }
}
module.exports.CodePointBuffer = $95ea316103e1b53a$var$CodePointBuffer;
(function(CodePointBuffer) {
    let Type;
    (function(Type) {
        Type[Type["BYTE"] = 0] = "BYTE";
        Type[Type["CHAR"] = 1] = "CHAR";
        Type[Type["INT"] = 2] = "INT";
    })(Type || (Type = {}));
    class Builder {
        build() {
            return new CodePointBuffer(this.buffer, this.position);
        }
        static roundUpToNextPowerOfTwo(i) {
            let nextPowerOfTwo = 32 - Math.clz32(i - 1);
            return Math.pow(2, nextPowerOfTwo);
        }
        ensureRemaining(remainingNeeded) {
            switch(this.type){
                case 0 /* BYTE */ :
                    if (this.buffer.length - this.position < remainingNeeded) {
                        let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                        let newBuffer = new Uint8Array(newCapacity);
                        newBuffer.set(this.buffer.subarray(0, this.position), 0);
                        this.buffer = newBuffer;
                    }
                    break;
                case 1 /* CHAR */ :
                    if (this.buffer.length - this.position < remainingNeeded) {
                        let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                        let newBuffer = new Uint16Array(newCapacity);
                        newBuffer.set(this.buffer.subarray(0, this.position), 0);
                        this.buffer = newBuffer;
                    }
                    break;
                case 2 /* INT */ :
                    if (this.buffer.length - this.position < remainingNeeded) {
                        let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                        let newBuffer = new Int32Array(newCapacity);
                        newBuffer.set(this.buffer.subarray(0, this.position), 0);
                        this.buffer = newBuffer;
                    }
                    break;
            }
        }
        append(utf16In) {
            this.ensureRemaining(utf16In.length);
            this.appendArray(utf16In);
        }
        appendArray(utf16In) {
            switch(this.type){
                case 0 /* BYTE */ :
                    this.appendArrayByte(utf16In);
                    break;
                case 1 /* CHAR */ :
                    this.appendArrayChar(utf16In);
                    break;
                case 2 /* INT */ :
                    this.appendArrayInt(utf16In);
                    break;
            }
        }
        appendArrayByte(utf16In) {
            $9Rq82(this.prevHighSurrogate === -1);
            let input = utf16In;
            let inOffset = 0;
            let inLimit = utf16In.length;
            let outByte = this.buffer;
            let outOffset = this.position;
            while(inOffset < inLimit){
                let c = input[inOffset];
                if (c <= 0xFF) outByte[outOffset] = c;
                else {
                    utf16In = utf16In.subarray(inOffset, inLimit);
                    this.position = outOffset;
                    if (!$9Ltjs.isHighSurrogate(c)) {
                        this.byteToCharBuffer(utf16In.length);
                        this.appendArrayChar(utf16In);
                        return;
                    } else {
                        this.byteToIntBuffer(utf16In.length);
                        this.appendArrayInt(utf16In);
                        return;
                    }
                }
                inOffset++;
                outOffset++;
            }
            this.position = outOffset;
        }
        appendArrayChar(utf16In) {
            $9Rq82(this.prevHighSurrogate === -1);
            let input = utf16In;
            let inOffset = 0;
            let inLimit = utf16In.length;
            let outChar = this.buffer;
            let outOffset = this.position;
            while(inOffset < inLimit){
                let c = input[inOffset];
                if (!$9Ltjs.isHighSurrogate(c)) outChar[outOffset] = c;
                else {
                    utf16In = utf16In.subarray(inOffset, inLimit);
                    this.position = outOffset;
                    this.charToIntBuffer(utf16In.length);
                    this.appendArrayInt(utf16In);
                    return;
                }
                inOffset++;
                outOffset++;
            }
            this.position = outOffset;
        }
        appendArrayInt(utf16In) {
            let input = utf16In;
            let inOffset = 0;
            let inLimit = utf16In.length;
            let outInt = this.buffer;
            let outOffset = this.position;
            while(inOffset < inLimit){
                let c = input[inOffset];
                inOffset++;
                if (this.prevHighSurrogate !== -1) {
                    if ($9Ltjs.isLowSurrogate(c)) {
                        outInt[outOffset] = String.fromCharCode(this.prevHighSurrogate, c).codePointAt(0);
                        outOffset++;
                        this.prevHighSurrogate = -1;
                    } else {
                        // Dangling high surrogate
                        outInt[outOffset] = this.prevHighSurrogate;
                        outOffset++;
                        if ($9Ltjs.isHighSurrogate(c)) this.prevHighSurrogate = c;
                        else {
                            outInt[outOffset] = c;
                            outOffset++;
                            this.prevHighSurrogate = -1;
                        }
                    }
                } else if ($9Ltjs.isHighSurrogate(c)) this.prevHighSurrogate = c;
                else {
                    outInt[outOffset] = c;
                    outOffset++;
                }
            }
            if (this.prevHighSurrogate !== -1) {
                // Dangling high surrogate
                outInt[outOffset] = this.prevHighSurrogate;
                outOffset++;
            }
            this.position = outOffset;
        }
        byteToCharBuffer(toAppend) {
            // CharBuffers hold twice as much per unit as ByteBuffers, so start with half the capacity.
            let newBuffer = new Uint16Array(Math.max(this.position + toAppend, this.buffer.length >> 1));
            newBuffer.set(this.buffer.subarray(0, this.position), 0);
            this.type = 1 /* CHAR */ ;
            this.buffer = newBuffer;
        }
        byteToIntBuffer(toAppend) {
            // IntBuffers hold four times as much per unit as ByteBuffers, so start with one quarter the capacity.
            let newBuffer = new Int32Array(Math.max(this.position + toAppend, this.buffer.length >> 2));
            newBuffer.set(this.buffer.subarray(0, this.position), 0);
            this.type = 2 /* INT */ ;
            this.buffer = newBuffer;
        }
        charToIntBuffer(toAppend) {
            // IntBuffers hold two times as much per unit as ByteBuffers, so start with one half the capacity.
            let newBuffer = new Int32Array(Math.max(this.position + toAppend, this.buffer.length >> 1));
            newBuffer.set(this.buffer.subarray(0, this.position), 0);
            this.type = 2 /* INT */ ;
            this.buffer = newBuffer;
        }
        constructor(initialBufferSize){
            this.type = 0 /* BYTE */ ;
            this.buffer = new Uint8Array(initialBufferSize);
            this.prevHighSurrogate = -1;
            this.position = 0;
        }
    }
    CodePointBuffer.Builder = Builder;
})($95ea316103e1b53a$var$CodePointBuffer = module.exports.CodePointBuffer || (module.exports.CodePointBuffer = {}));

});

parcelRegister("9Ltjs", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isSupplementaryCodePoint = module.exports.isLowSurrogate = module.exports.isHighSurrogate = void 0;
function $71bf3dc1b6efe9cd$var$isHighSurrogate(ch) {
    return ch >= 0xD800 && ch <= 0xDBFF;
}
module.exports.isHighSurrogate = $71bf3dc1b6efe9cd$var$isHighSurrogate;
function $71bf3dc1b6efe9cd$var$isLowSurrogate(ch) {
    return ch >= 0xDC00 && ch <= 0xDFFF;
}
module.exports.isLowSurrogate = $71bf3dc1b6efe9cd$var$isLowSurrogate;
function $71bf3dc1b6efe9cd$var$isSupplementaryCodePoint(ch) {
    return ch >= 0x10000;
}
module.exports.isSupplementaryCodePoint = $71bf3dc1b6efe9cd$var$isSupplementaryCodePoint;

});

parcelRegister("fRlA6", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $b8bc8bd54dfadcd7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CodePointCharStream = void 0;

var $9Rq82 = parcelRequire("9Rq82");


var $9P2T1 = parcelRequire("9P2T1");


var $dQ3yU = parcelRequire("dQ3yU");


var $ffTXa = parcelRequire("ffTXa");

/**
 * Alternative to {@link ANTLRInputStream} which treats the input
 * as a series of Unicode code points, instead of a series of UTF-16
 * code units.
 *
 * Use this if you need to parse input which potentially contains
 * Unicode values > U+FFFF.
 */ class $b8bc8bd54dfadcd7$var$CodePointCharStream {
    get internalStorage() {
        return this._array;
    }
    static fromBuffer(codePointBuffer, name) {
        if (name === undefined || name.length === 0) name = $9P2T1.IntStream.UNKNOWN_SOURCE_NAME;
        // Java lacks generics on primitive types.
        //
        // To avoid lots of calls to virtual methods in the
        // very hot codepath of LA() below, we construct one
        // of three concrete subclasses.
        //
        // The concrete subclasses directly access the code
        // points stored in the underlying array (byte[],
        // char[], or int[]), so we can avoid lots of virtual
        // method calls to ByteBuffer.get(offset).
        return new $b8bc8bd54dfadcd7$var$CodePointCharStream(codePointBuffer.array(), codePointBuffer.position, codePointBuffer.remaining, name);
    }
    consume() {
        if (this._size - this._position === 0) {
            $9Rq82(this.LA(1) === $9P2T1.IntStream.EOF);
            throw new RangeError("cannot consume EOF");
        }
        this._position++;
    }
    get index() {
        return this._position;
    }
    get size() {
        return this._size;
    }
    /** mark/release do nothing; we have entire buffer */ mark() {
        return -1;
    }
    release(marker) {
    // No default implementation since this stream buffers the entire input
    }
    seek(index) {
        this._position = index;
    }
    get sourceName() {
        return this._name;
    }
    toString() {
        return this.getText($dQ3yU.Interval.of(0, this.size - 1));
    }
    LA(i) {
        let offset;
        switch(Math.sign(i)){
            case -1:
                offset = this.index + i;
                if (offset < 0) return $9P2T1.IntStream.EOF;
                return this._array[offset];
            case 0:
                // Undefined
                return 0;
            case 1:
                offset = this.index + i - 1;
                if (offset >= this.size) return $9P2T1.IntStream.EOF;
                return this._array[offset];
        }
        throw new RangeError("Not reached");
    }
    /** Return the UTF-16 encoded string for the given interval */ getText(interval) {
        const startIdx = Math.min(interval.a, this.size);
        const len = Math.min(interval.b - interval.a + 1, this.size - startIdx);
        if (this._array instanceof Int32Array) return String.fromCodePoint(...Array.from(this._array.subarray(startIdx, startIdx + len)));
        else return String.fromCharCode(...Array.from(this._array.subarray(startIdx, startIdx + len)));
    }
    // Use the factory method {@link #fromBuffer(CodePointBuffer)} to
    // construct instances of this type.
    constructor(array, position, remaining, name){
        // TODO
        $9Rq82(position === 0);
        this._array = array;
        this._size = remaining;
        this._name = name;
        this._position = 0;
    }
}
$b8bc8bd54dfadcd7$var$__decorate([
    $ffTXa.Override
], $b8bc8bd54dfadcd7$var$CodePointCharStream.prototype, "consume", null);
$b8bc8bd54dfadcd7$var$__decorate([
    $ffTXa.Override
], $b8bc8bd54dfadcd7$var$CodePointCharStream.prototype, "index", null);
$b8bc8bd54dfadcd7$var$__decorate([
    $ffTXa.Override
], $b8bc8bd54dfadcd7$var$CodePointCharStream.prototype, "size", null);
$b8bc8bd54dfadcd7$var$__decorate([
    $ffTXa.Override
], $b8bc8bd54dfadcd7$var$CodePointCharStream.prototype, "mark", null);
$b8bc8bd54dfadcd7$var$__decorate([
    $ffTXa.Override
], $b8bc8bd54dfadcd7$var$CodePointCharStream.prototype, "release", null);
$b8bc8bd54dfadcd7$var$__decorate([
    $ffTXa.Override
], $b8bc8bd54dfadcd7$var$CodePointCharStream.prototype, "seek", null);
$b8bc8bd54dfadcd7$var$__decorate([
    $ffTXa.Override
], $b8bc8bd54dfadcd7$var$CodePointCharStream.prototype, "sourceName", null);
$b8bc8bd54dfadcd7$var$__decorate([
    $ffTXa.Override
], $b8bc8bd54dfadcd7$var$CodePointCharStream.prototype, "toString", null);
$b8bc8bd54dfadcd7$var$__decorate([
    $ffTXa.Override
], $b8bc8bd54dfadcd7$var$CodePointCharStream.prototype, "LA", null);
$b8bc8bd54dfadcd7$var$__decorate([
    $ffTXa.Override
], $b8bc8bd54dfadcd7$var$CodePointCharStream.prototype, "getText", null);
module.exports.CodePointCharStream = $b8bc8bd54dfadcd7$var$CodePointCharStream;

});

parcelRegister("1BCwT", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $12b72250d6d200a8$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $12b72250d6d200a8$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommonTokenStream = void 0;

var $geTWu = parcelRequire("geTWu");


var $ffTXa = parcelRequire("ffTXa");


var $TNDGs = parcelRequire("TNDGs");

/**
 * This class extends {@link BufferedTokenStream} with functionality to filter
 * token streams to tokens on a particular channel (tokens where
 * {@link Token#getChannel} returns a particular value).
 *
 * This token stream provides access to all tokens by index or when calling
 * methods like {@link #getText}. The channel filtering is only used for code
 * accessing tokens via the lookahead methods {@link #LA}, {@link #LT}, and
 * {@link #LB}.
 *
 * By default, tokens are placed on the default channel
 * ({@link Token#DEFAULT_CHANNEL}), but may be reassigned by using the
 * `->channel(HIDDEN)` lexer command, or by using an embedded action to
 * call {@link Lexer#setChannel}.
 *
 * Note: lexer rules which use the `->skip` lexer command or call
 * {@link Lexer#skip} do not produce tokens at all, so input text matched by
 * such a rule will not be available as part of the token stream, regardless of
 * channel.
 */ let $12b72250d6d200a8$var$CommonTokenStream = class CommonTokenStream extends $geTWu.BufferedTokenStream {
    adjustSeekIndex(i) {
        return this.nextTokenOnChannel(i, this.channel);
    }
    tryLB(k) {
        if (this.p - k < 0) return undefined;
        let i = this.p;
        let n = 1;
        // find k good tokens looking backwards
        while(n <= k && i > 0){
            // skip off-channel tokens
            i = this.previousTokenOnChannel(i - 1, this.channel);
            n++;
        }
        if (i < 0) return undefined;
        return this.tokens[i];
    }
    tryLT(k) {
        //System.out.println("enter LT("+k+")");
        this.lazyInit();
        if (k === 0) throw new RangeError("0 is not a valid lookahead index");
        if (k < 0) return this.tryLB(-k);
        let i = this.p;
        let n = 1; // we know tokens[p] is a good one
        // find k good tokens
        while(n < k){
            // skip off-channel tokens, but make sure to not look past EOF
            if (this.sync(i + 1)) i = this.nextTokenOnChannel(i + 1, this.channel);
            n++;
        }
        //		if ( i>range ) range = i;
        return this.tokens[i];
    }
    /** Count EOF just once. */ getNumberOfOnChannelTokens() {
        let n = 0;
        this.fill();
        for (let t of this.tokens){
            if (t.channel === this.channel) n++;
            if (t.type === $TNDGs.Token.EOF) break;
        }
        return n;
    }
    /**
     * Constructs a new {@link CommonTokenStream} using the specified token
     * source and filtering tokens to the specified channel. Only tokens whose
     * {@link Token#getChannel} matches `channel` or have the
     * `Token.type` equal to {@link Token#EOF} will be returned by the
     * token stream lookahead methods.
     *
     * @param tokenSource The token source.
     * @param channel The channel to use for filtering tokens.
     */ constructor(tokenSource, channel = $TNDGs.Token.DEFAULT_CHANNEL){
        super(tokenSource);
        this.channel = channel;
    }
};
$12b72250d6d200a8$var$__decorate([
    $ffTXa.Override
], $12b72250d6d200a8$var$CommonTokenStream.prototype, "adjustSeekIndex", null);
$12b72250d6d200a8$var$__decorate([
    $ffTXa.Override
], $12b72250d6d200a8$var$CommonTokenStream.prototype, "tryLB", null);
$12b72250d6d200a8$var$__decorate([
    $ffTXa.Override
], $12b72250d6d200a8$var$CommonTokenStream.prototype, "tryLT", null);
$12b72250d6d200a8$var$CommonTokenStream = $12b72250d6d200a8$var$__decorate([
    $12b72250d6d200a8$var$__param(0, $ffTXa.NotNull)
], $12b72250d6d200a8$var$CommonTokenStream);
module.exports.CommonTokenStream = $12b72250d6d200a8$var$CommonTokenStream;

});

parcelRegister("8zXr0", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Dependents = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:51.1349829-07:00
/**
 *
 * @author Sam Harwell
 */ var $63efb214710bc076$var$Dependents;
(function(Dependents) {
    /**
     * The element is dependent upon the specified rule.
     */ Dependents[Dependents["SELF"] = 0] = "SELF";
    /**
     * The element is dependent upon the set of the specified rule's parents
     * (rules which directly reference it).
     */ Dependents[Dependents["PARENTS"] = 1] = "PARENTS";
    /**
     * The element is dependent upon the set of the specified rule's children
     * (rules which it directly references).
     */ Dependents[Dependents["CHILDREN"] = 2] = "CHILDREN";
    /**
     * The element is dependent upon the set of the specified rule's ancestors
     * (the transitive closure of `PARENTS` rules).
     */ Dependents[Dependents["ANCESTORS"] = 3] = "ANCESTORS";
    /**
     * The element is dependent upon the set of the specified rule's descendants
     * (the transitive closure of `CHILDREN` rules).
     */ Dependents[Dependents["DESCENDANTS"] = 4] = "DESCENDANTS";
    /**
     * The element is dependent upon the set of the specified rule's siblings
     * (the union of `CHILDREN` of its `PARENTS`).
     */ Dependents[Dependents["SIBLINGS"] = 5] = "SIBLINGS";
    /**
     * The element is dependent upon the set of the specified rule's preceeding
     * siblings (the union of `CHILDREN` of its `PARENTS` which
     * appear before a reference to the rule).
     */ Dependents[Dependents["PRECEEDING_SIBLINGS"] = 6] = "PRECEEDING_SIBLINGS";
    /**
     * The element is dependent upon the set of the specified rule's following
     * siblings (the union of `CHILDREN` of its `PARENTS` which
     * appear after a reference to the rule).
     */ Dependents[Dependents["FOLLOWING_SIBLINGS"] = 7] = "FOLLOWING_SIBLINGS";
    /**
     * The element is dependent upon the set of the specified rule's preceeding
     * elements (rules which might end before the start of the specified rule
     * while parsing). This is calculated by taking the
     * `PRECEEDING_SIBLINGS` of the rule and each of its
     * `ANCESTORS`, along with the `DESCENDANTS` of those
     * elements.
     */ Dependents[Dependents["PRECEEDING"] = 8] = "PRECEEDING";
    /**
     * The element is dependent upon the set of the specified rule's following
     * elements (rules which might start after the end of the specified rule
     * while parsing). This is calculated by taking the
     * `FOLLOWING_SIBLINGS` of the rule and each of its
     * `ANCESTORS`, along with the `DESCENDANTS` of those
     * elements.
     */ Dependents[Dependents["FOLLOWING"] = 9] = "FOLLOWING";
})($63efb214710bc076$var$Dependents = module.exports.Dependents || (module.exports.Dependents = {}));

});

parcelRegister("c6lgr", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $8cf68a2eadb75a17$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $8cf68a2eadb75a17$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DiagnosticErrorListener = void 0;

var $kJZRw = parcelRequire("kJZRw");


var $ffTXa = parcelRequire("ffTXa");


var $dQ3yU = parcelRequire("dQ3yU");

/**
 * This implementation of {@link ANTLRErrorListener} can be used to identify
 * certain potential correctness and performance problems in grammars. "Reports"
 * are made by calling {@link Parser#notifyErrorListeners} with the appropriate
 * message.
 *
 * * **Ambiguities**: These are cases where more than one path through the
 *   grammar can match the input.
 * * **Weak context sensitivity**: These are cases where full-context
 *   prediction resolved an SLL conflict to a unique alternative which equaled the
 *   minimum alternative of the SLL conflict.
 * * **Strong (forced) context sensitivity**: These are cases where the
 *   full-context prediction resolved an SLL conflict to a unique alternative,
 *   *and* the minimum alternative of the SLL conflict was found to not be
 *   a truly viable alternative. Two-stage parsing cannot be used for inputs where
 *   this situation occurs.
 *
 * @author Sam Harwell
 */ class $8cf68a2eadb75a17$var$DiagnosticErrorListener {
    syntaxError(/*@NotNull*/ recognizer, offendingSymbol, line, charPositionInLine, /*@NotNull*/ msg, e) {
    // intentionally empty
    }
    reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs) {
        if (this.exactOnly && !exact) return;
        let decision = this.getDecisionDescription(recognizer, dfa);
        let conflictingAlts = this.getConflictingAlts(ambigAlts, configs);
        let text = recognizer.inputStream.getText($dQ3yU.Interval.of(startIndex, stopIndex));
        let message = `reportAmbiguity d=${decision}: ambigAlts=${conflictingAlts}, input='${text}'`;
        recognizer.notifyErrorListeners(message);
    }
    reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState) {
        let format = "reportAttemptingFullContext d=%s, input='%s'";
        let decision = this.getDecisionDescription(recognizer, dfa);
        let text = recognizer.inputStream.getText($dQ3yU.Interval.of(startIndex, stopIndex));
        let message = `reportAttemptingFullContext d=${decision}, input='${text}'`;
        recognizer.notifyErrorListeners(message);
    }
    reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState) {
        let format = "reportContextSensitivity d=%s, input='%s'";
        let decision = this.getDecisionDescription(recognizer, dfa);
        let text = recognizer.inputStream.getText($dQ3yU.Interval.of(startIndex, stopIndex));
        let message = `reportContextSensitivity d=${decision}, input='${text}'`;
        recognizer.notifyErrorListeners(message);
    }
    getDecisionDescription(recognizer, dfa) {
        let decision = dfa.decision;
        let ruleIndex = dfa.atnStartState.ruleIndex;
        let ruleNames = recognizer.ruleNames;
        if (ruleIndex < 0 || ruleIndex >= ruleNames.length) return decision.toString();
        let ruleName = ruleNames[ruleIndex];
        if (!ruleName) return decision.toString();
        return `${decision} (${ruleName})`;
    }
    /**
     * Computes the set of conflicting or ambiguous alternatives from a
     * configuration set, if that information was not already provided by the
     * parser.
     *
     * @param reportedAlts The set of conflicting or ambiguous alternatives, as
     * reported by the parser.
     * @param configs The conflicting or ambiguous configuration set.
     * @returns Returns `reportedAlts` if it is not `undefined`, otherwise
     * returns the set of alternatives represented in `configs`.
     */ getConflictingAlts(reportedAlts, configs) {
        if (reportedAlts != null) return reportedAlts;
        let result = new $kJZRw.BitSet();
        for (let config of configs)result.set(config.alt);
        return result;
    }
    /**
     * Initializes a new instance of {@link DiagnosticErrorListener}, specifying
     * whether all ambiguities or only exact ambiguities are reported.
     *
     * @param exactOnly `true` to report only exact ambiguities, otherwise
     * `false` to report all ambiguities.  Defaults to true.
     */ constructor(exactOnly = true){
        this.exactOnly = exactOnly;
        this.exactOnly = exactOnly;
    }
}
$8cf68a2eadb75a17$var$__decorate([
    $ffTXa.Override
], $8cf68a2eadb75a17$var$DiagnosticErrorListener.prototype, "syntaxError", null);
$8cf68a2eadb75a17$var$__decorate([
    $ffTXa.Override,
    $8cf68a2eadb75a17$var$__param(0, $ffTXa.NotNull),
    $8cf68a2eadb75a17$var$__param(1, $ffTXa.NotNull),
    $8cf68a2eadb75a17$var$__param(6, $ffTXa.NotNull)
], $8cf68a2eadb75a17$var$DiagnosticErrorListener.prototype, "reportAmbiguity", null);
$8cf68a2eadb75a17$var$__decorate([
    $ffTXa.Override,
    $8cf68a2eadb75a17$var$__param(0, $ffTXa.NotNull),
    $8cf68a2eadb75a17$var$__param(1, $ffTXa.NotNull),
    $8cf68a2eadb75a17$var$__param(5, $ffTXa.NotNull)
], $8cf68a2eadb75a17$var$DiagnosticErrorListener.prototype, "reportAttemptingFullContext", null);
$8cf68a2eadb75a17$var$__decorate([
    $ffTXa.Override,
    $8cf68a2eadb75a17$var$__param(0, $ffTXa.NotNull),
    $8cf68a2eadb75a17$var$__param(1, $ffTXa.NotNull),
    $8cf68a2eadb75a17$var$__param(5, $ffTXa.NotNull)
], $8cf68a2eadb75a17$var$DiagnosticErrorListener.prototype, "reportContextSensitivity", null);
$8cf68a2eadb75a17$var$__decorate([
    $8cf68a2eadb75a17$var$__param(0, $ffTXa.NotNull),
    $8cf68a2eadb75a17$var$__param(1, $ffTXa.NotNull)
], $8cf68a2eadb75a17$var$DiagnosticErrorListener.prototype, "getDecisionDescription", null);
$8cf68a2eadb75a17$var$__decorate([
    $ffTXa.NotNull,
    $8cf68a2eadb75a17$var$__param(1, $ffTXa.NotNull)
], $8cf68a2eadb75a17$var$DiagnosticErrorListener.prototype, "getConflictingAlts", null);
module.exports.DiagnosticErrorListener = $8cf68a2eadb75a17$var$DiagnosticErrorListener;

});

parcelRegister("6qbZR", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $4ace7a1405072e12$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InterpreterRuleContext = void 0;

var $ffTXa = parcelRequire("ffTXa");


var $5izRN = parcelRequire("5izRN");

/**
 * This class extends {@link ParserRuleContext} by allowing the value of
 * {@link #getRuleIndex} to be explicitly set for the context.
 *
 * {@link ParserRuleContext} does not include field storage for the rule index
 * since the context classes created by the code generator override the
 * {@link #getRuleIndex} method to return the correct value for that context.
 * Since the parser interpreter does not use the context classes generated for a
 * parser, this class (with slightly more memory overhead per node) is used to
 * provide equivalent functionality.
 */ class $4ace7a1405072e12$var$InterpreterRuleContext extends $5izRN.ParserRuleContext {
    get ruleIndex() {
        return this._ruleIndex;
    }
    constructor(ruleIndex, parent, invokingStateNumber){
        if (invokingStateNumber !== undefined) super(parent, invokingStateNumber);
        else super();
        this._ruleIndex = ruleIndex;
    }
}
$4ace7a1405072e12$var$__decorate([
    $ffTXa.Override
], $4ace7a1405072e12$var$InterpreterRuleContext.prototype, "ruleIndex", null);
module.exports.InterpreterRuleContext = $4ace7a1405072e12$var$InterpreterRuleContext;

});

parcelRegister("f34tW", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $02d3c8b92304b7fc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $02d3c8b92304b7fc$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerInterpreter = void 0;

var $gJMeE = parcelRequire("gJMeE");


var $8Dduc = parcelRequire("8Dduc");


var $ffTXa = parcelRequire("ffTXa");




let $02d3c8b92304b7fc$var$LexerInterpreter = class LexerInterpreter extends $gJMeE.Lexer {
    get atn() {
        return this._atn;
    }
    get grammarFileName() {
        return this._grammarFileName;
    }
    get ruleNames() {
        return this._ruleNames;
    }
    get channelNames() {
        return this._channelNames;
    }
    get modeNames() {
        return this._modeNames;
    }
    get vocabulary() {
        return this._vocabulary;
    }
    constructor(grammarFileName, vocabulary, ruleNames, channelNames, modeNames, atn, input){
        super(input);
        if (atn.grammarType !== 0 /* LEXER */ ) throw new Error("IllegalArgumentException: The ATN must be a lexer ATN.");
        this._grammarFileName = grammarFileName;
        this._atn = atn;
        this._ruleNames = ruleNames.slice(0);
        this._channelNames = channelNames.slice(0);
        this._modeNames = modeNames.slice(0);
        this._vocabulary = vocabulary;
        this._interp = new $8Dduc.LexerATNSimulator(atn, this);
    }
};
$02d3c8b92304b7fc$var$__decorate([
    $ffTXa.NotNull
], $02d3c8b92304b7fc$var$LexerInterpreter.prototype, "_vocabulary", void 0);
$02d3c8b92304b7fc$var$__decorate([
    $ffTXa.Override
], $02d3c8b92304b7fc$var$LexerInterpreter.prototype, "atn", null);
$02d3c8b92304b7fc$var$__decorate([
    $ffTXa.Override
], $02d3c8b92304b7fc$var$LexerInterpreter.prototype, "grammarFileName", null);
$02d3c8b92304b7fc$var$__decorate([
    $ffTXa.Override
], $02d3c8b92304b7fc$var$LexerInterpreter.prototype, "ruleNames", null);
$02d3c8b92304b7fc$var$__decorate([
    $ffTXa.Override
], $02d3c8b92304b7fc$var$LexerInterpreter.prototype, "channelNames", null);
$02d3c8b92304b7fc$var$__decorate([
    $ffTXa.Override
], $02d3c8b92304b7fc$var$LexerInterpreter.prototype, "modeNames", null);
$02d3c8b92304b7fc$var$__decorate([
    $ffTXa.Override
], $02d3c8b92304b7fc$var$LexerInterpreter.prototype, "vocabulary", null);
$02d3c8b92304b7fc$var$LexerInterpreter = $02d3c8b92304b7fc$var$__decorate([
    $02d3c8b92304b7fc$var$__param(1, $ffTXa.NotNull)
], $02d3c8b92304b7fc$var$LexerInterpreter);
module.exports.LexerInterpreter = $02d3c8b92304b7fc$var$LexerInterpreter;

});

parcelRegister("lf6D7", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f7702445081f9038$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f7702445081f9038$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ListTokenSource = void 0;

var $aK9bI = parcelRequire("aK9bI");


var $ffTXa = parcelRequire("ffTXa");


var $TNDGs = parcelRequire("TNDGs");

/**
 * Provides an implementation of {@link TokenSource} as a wrapper around a list
 * of {@link Token} objects.
 *
 * If the final token in the list is an {@link Token#EOF} token, it will be used
 * as the EOF token for every call to {@link #nextToken} after the end of the
 * list is reached. Otherwise, an EOF token will be created.
 */ let $f7702445081f9038$var$ListTokenSource = class ListTokenSource {
    /**
     * {@inheritDoc}
     */ get charPositionInLine() {
        if (this.i < this.tokens.length) return this.tokens[this.i].charPositionInLine;
        else if (this.eofToken != null) return this.eofToken.charPositionInLine;
        else if (this.tokens.length > 0) {
            // have to calculate the result from the line/column of the previous
            // token, along with the text of the token.
            let lastToken = this.tokens[this.tokens.length - 1];
            let tokenText = lastToken.text;
            if (tokenText != null) {
                let lastNewLine = tokenText.lastIndexOf("\n");
                if (lastNewLine >= 0) return tokenText.length - lastNewLine - 1;
            }
            return lastToken.charPositionInLine + lastToken.stopIndex - lastToken.startIndex + 1;
        }
        // only reach this if tokens is empty, meaning EOF occurs at the first
        // position in the input
        return 0;
    }
    /**
     * {@inheritDoc}
     */ nextToken() {
        if (this.i >= this.tokens.length) {
            if (this.eofToken == null) {
                let start = -1;
                if (this.tokens.length > 0) {
                    let previousStop = this.tokens[this.tokens.length - 1].stopIndex;
                    if (previousStop !== -1) start = previousStop + 1;
                }
                let stop = Math.max(-1, start - 1);
                this.eofToken = this._factory.create({
                    source: this,
                    stream: this.inputStream
                }, $TNDGs.Token.EOF, "EOF", $TNDGs.Token.DEFAULT_CHANNEL, start, stop, this.line, this.charPositionInLine);
            }
            return this.eofToken;
        }
        let t = this.tokens[this.i];
        if (this.i === this.tokens.length - 1 && t.type === $TNDGs.Token.EOF) this.eofToken = t;
        this.i++;
        return t;
    }
    /**
     * {@inheritDoc}
     */ get line() {
        if (this.i < this.tokens.length) return this.tokens[this.i].line;
        else if (this.eofToken != null) return this.eofToken.line;
        else if (this.tokens.length > 0) {
            // have to calculate the result from the line/column of the previous
            // token, along with the text of the token.
            let lastToken = this.tokens[this.tokens.length - 1];
            let line = lastToken.line;
            let tokenText = lastToken.text;
            if (tokenText != null) {
                for(let i = 0; i < tokenText.length; i++)if (tokenText.charAt(i) === "\n") line++;
            }
            // if no text is available, assume the token did not contain any newline characters.
            return line;
        }
        // only reach this if tokens is empty, meaning EOF occurs at the first
        // position in the input
        return 1;
    }
    /**
     * {@inheritDoc}
     */ get inputStream() {
        if (this.i < this.tokens.length) return this.tokens[this.i].inputStream;
        else if (this.eofToken != null) return this.eofToken.inputStream;
        else if (this.tokens.length > 0) return this.tokens[this.tokens.length - 1].inputStream;
        // no input stream information is available
        return undefined;
    }
    /**
     * {@inheritDoc}
     */ get sourceName() {
        if (this._sourceName) return this._sourceName;
        let inputStream = this.inputStream;
        if (inputStream != null) return inputStream.sourceName;
        return "List";
    }
    /**
     * {@inheritDoc}
     */ // @Override
    set tokenFactory(factory) {
        this._factory = factory;
    }
    /**
     * {@inheritDoc}
     */ get tokenFactory() {
        return this._factory;
    }
    /**
     * Constructs a new {@link ListTokenSource} instance from the specified
     * collection of {@link Token} objects and source name.
     *
     * @param tokens The collection of {@link Token} objects to provide as a
     * {@link TokenSource}.
     * @param sourceName The name of the {@link TokenSource}. If this value is
     * `undefined`, {@link #getSourceName} will attempt to infer the name from
     * the next {@link Token} (or the previous token if the end of the input has
     * been reached).
     *
     * @exception NullPointerException if `tokens` is `undefined`
     */ constructor(tokens, sourceName){
        /**
         * The index into {@link #tokens} of token to return by the next call to
         * {@link #nextToken}. The end of the input is indicated by this value
         * being greater than or equal to the number of items in {@link #tokens}.
         */ this.i = 0;
        /**
         * This is the backing field for {@link #getTokenFactory} and
         * {@link setTokenFactory}.
         */ this._factory = $aK9bI.CommonTokenFactory.DEFAULT;
        if (tokens == null) throw new Error("tokens cannot be null");
        this.tokens = tokens;
        this._sourceName = sourceName;
    }
};
$f7702445081f9038$var$__decorate([
    $ffTXa.Override
], $f7702445081f9038$var$ListTokenSource.prototype, "charPositionInLine", null);
$f7702445081f9038$var$__decorate([
    $ffTXa.Override
], $f7702445081f9038$var$ListTokenSource.prototype, "nextToken", null);
$f7702445081f9038$var$__decorate([
    $ffTXa.Override
], $f7702445081f9038$var$ListTokenSource.prototype, "line", null);
$f7702445081f9038$var$__decorate([
    $ffTXa.Override
], $f7702445081f9038$var$ListTokenSource.prototype, "inputStream", null);
$f7702445081f9038$var$__decorate([
    $ffTXa.Override
], $f7702445081f9038$var$ListTokenSource.prototype, "sourceName", null);
$f7702445081f9038$var$__decorate([
    $ffTXa.Override,
    $ffTXa.NotNull,
    $f7702445081f9038$var$__param(0, $ffTXa.NotNull)
], $f7702445081f9038$var$ListTokenSource.prototype, "tokenFactory", null);
$f7702445081f9038$var$ListTokenSource = $f7702445081f9038$var$__decorate([
    $f7702445081f9038$var$__param(0, $ffTXa.NotNull)
], $f7702445081f9038$var$ListTokenSource);
module.exports.ListTokenSource = $f7702445081f9038$var$ListTokenSource;

});

parcelRegister("9OB0P", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("7HcZT", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $59a6a185a8c94431$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $59a6a185a8c94431$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParserInterpreter = void 0;

var $2UrJv = parcelRequire("2UrJv");


var $5dqQL = parcelRequire("5dqQL");


var $kJZRw = parcelRequire("kJZRw");


var $5BYcl = parcelRequire("5BYcl");


var $l9UFP = parcelRequire("l9UFP");


var $6qbZR = parcelRequire("6qbZR");


var $ewXgZ = parcelRequire("ewXgZ");


var $ffTXa = parcelRequire("ffTXa");





var $5XMF6 = parcelRequire("5XMF6");


var $lORdS = parcelRequire("lORdS");


var $beMqO = parcelRequire("beMqO");


var $YUl9W = parcelRequire("YUl9W");


var $TNDGs = parcelRequire("TNDGs");

/** A parser simulator that mimics what ANTLR's generated
 *  parser code does. A ParserATNSimulator is used to make
 *  predictions via adaptivePredict but this class moves a pointer through the
 *  ATN to simulate parsing. ParserATNSimulator just
 *  makes us efficient rather than having to backtrack, for example.
 *
 *  This properly creates parse trees even for left recursive rules.
 *
 *  We rely on the left recursive rule invocation and special predicate
 *  transitions to make left recursive rules work.
 *
 *  See TestParserInterpreter for examples.
 */ let $59a6a185a8c94431$var$ParserInterpreter = class ParserInterpreter extends $5XMF6.Parser {
    reset(resetInput) {
        if (resetInput === undefined) super.reset();
        else super.reset(resetInput);
        this.overrideDecisionReached = false;
        this._overrideDecisionRoot = undefined;
    }
    get atn() {
        return this._atn;
    }
    get vocabulary() {
        return this._vocabulary;
    }
    get ruleNames() {
        return this._ruleNames;
    }
    get grammarFileName() {
        return this._grammarFileName;
    }
    /** Begin parsing at startRuleIndex */ parse(startRuleIndex) {
        let startRuleStartState = this._atn.ruleToStartState[startRuleIndex];
        this._rootContext = this.createInterpreterRuleContext(undefined, $2UrJv.ATNState.INVALID_STATE_NUMBER, startRuleIndex);
        if (startRuleStartState.isPrecedenceRule) this.enterRecursionRule(this._rootContext, startRuleStartState.stateNumber, startRuleIndex, 0);
        else this.enterRule(this._rootContext, startRuleStartState.stateNumber, startRuleIndex);
        while(true){
            let p = this.atnState;
            switch(p.stateType){
                case $5dqQL.ATNStateType.RULE_STOP:
                    // pop; return from rule
                    if (this._ctx.isEmpty) {
                        if (startRuleStartState.isPrecedenceRule) {
                            let result = this._ctx;
                            let parentContext = this._parentContextStack.pop();
                            this.unrollRecursionContexts(parentContext[0]);
                            return result;
                        } else {
                            this.exitRule();
                            return this._rootContext;
                        }
                    }
                    this.visitRuleStopState(p);
                    break;
                default:
                    try {
                        this.visitState(p);
                    } catch (e) {
                        if (e instanceof $beMqO.RecognitionException) {
                            this.state = this._atn.ruleToStopState[p.ruleIndex].stateNumber;
                            this.context.exception = e;
                            this.errorHandler.reportError(this, e);
                            this.recover(e);
                        } else throw e;
                    }
                    break;
            }
        }
    }
    enterRecursionRule(localctx, state, ruleIndex, precedence) {
        this._parentContextStack.push([
            this._ctx,
            localctx.invokingState
        ]);
        super.enterRecursionRule(localctx, state, ruleIndex, precedence);
    }
    get atnState() {
        return this._atn.states[this.state];
    }
    visitState(p) {
        let predictedAlt = 1;
        if (p.numberOfTransitions > 1) predictedAlt = this.visitDecisionState(p);
        let transition = p.transition(predictedAlt - 1);
        switch(transition.serializationType){
            case 1 /* EPSILON */ :
                if (this.pushRecursionContextStates.get(p.stateNumber) && !(transition.target instanceof $ewXgZ.LoopEndState)) {
                    // We are at the start of a left recursive rule's (...)* loop
                    // and we're not taking the exit branch of loop.
                    let parentContext = this._parentContextStack[this._parentContextStack.length - 1];
                    let localctx = this.createInterpreterRuleContext(parentContext[0], parentContext[1], this._ctx.ruleIndex);
                    this.pushNewRecursionContext(localctx, this._atn.ruleToStartState[p.ruleIndex].stateNumber, this._ctx.ruleIndex);
                }
                break;
            case 5 /* ATOM */ :
                this.match(transition._label);
                break;
            case 2 /* RANGE */ :
            case 7 /* SET */ :
            case 8 /* NOT_SET */ :
                if (!transition.matches(this._input.LA(1), $TNDGs.Token.MIN_USER_TOKEN_TYPE, 65535)) this.recoverInline();
                this.matchWildcard();
                break;
            case 9 /* WILDCARD */ :
                this.matchWildcard();
                break;
            case 3 /* RULE */ :
                let ruleStartState = transition.target;
                let ruleIndex = ruleStartState.ruleIndex;
                let newctx = this.createInterpreterRuleContext(this._ctx, p.stateNumber, ruleIndex);
                if (ruleStartState.isPrecedenceRule) this.enterRecursionRule(newctx, ruleStartState.stateNumber, ruleIndex, transition.precedence);
                else this.enterRule(newctx, transition.target.stateNumber, ruleIndex);
                break;
            case 4 /* PREDICATE */ :
                let predicateTransition = transition;
                if (!this.sempred(this._ctx, predicateTransition.ruleIndex, predicateTransition.predIndex)) throw new $5BYcl.FailedPredicateException(this);
                break;
            case 6 /* ACTION */ :
                let actionTransition = transition;
                this.action(this._ctx, actionTransition.ruleIndex, actionTransition.actionIndex);
                break;
            case 10 /* PRECEDENCE */ :
                if (!this.precpred(this._ctx, transition.precedence)) {
                    let precedence = transition.precedence;
                    throw new $5BYcl.FailedPredicateException(this, `precpred(_ctx, ${precedence})`);
                }
                break;
            default:
                throw new Error("UnsupportedOperationException: Unrecognized ATN transition type.");
        }
        this.state = transition.target.stateNumber;
    }
    /** Method visitDecisionState() is called when the interpreter reaches
     *  a decision state (instance of DecisionState). It gives an opportunity
     *  for subclasses to track interesting things.
     */ visitDecisionState(p) {
        let predictedAlt;
        this.errorHandler.sync(this);
        let decision = p.decision;
        if (decision === this.overrideDecision && this._input.index === this.overrideDecisionInputIndex && !this.overrideDecisionReached) {
            predictedAlt = this.overrideDecisionAlt;
            this.overrideDecisionReached = true;
        } else predictedAlt = this.interpreter.adaptivePredict(this._input, decision, this._ctx);
        return predictedAlt;
    }
    /** Provide simple "factory" for InterpreterRuleContext's.
     *  @since 4.5.1
     */ createInterpreterRuleContext(parent, invokingStateNumber, ruleIndex) {
        return new $6qbZR.InterpreterRuleContext(ruleIndex, parent, invokingStateNumber);
    }
    visitRuleStopState(p) {
        let ruleStartState = this._atn.ruleToStartState[p.ruleIndex];
        if (ruleStartState.isPrecedenceRule) {
            let parentContext = this._parentContextStack.pop();
            this.unrollRecursionContexts(parentContext[0]);
            this.state = parentContext[1];
        } else this.exitRule();
        let ruleTransition = this._atn.states[this.state].transition(0);
        this.state = ruleTransition.followState.stateNumber;
    }
    /** Override this parser interpreters normal decision-making process
     *  at a particular decision and input token index. Instead of
     *  allowing the adaptive prediction mechanism to choose the
     *  first alternative within a block that leads to a successful parse,
     *  force it to take the alternative, 1..n for n alternatives.
     *
     *  As an implementation limitation right now, you can only specify one
     *  override. This is sufficient to allow construction of different
     *  parse trees for ambiguous input. It means re-parsing the entire input
     *  in general because you're never sure where an ambiguous sequence would
     *  live in the various parse trees. For example, in one interpretation,
     *  an ambiguous input sequence would be matched completely in expression
     *  but in another it could match all the way back to the root.
     *
     *  s : e '!'? ;
     *  e : ID
     *    | ID '!'
     *    ;
     *
     *  Here, x! can be matched as (s (e ID) !) or (s (e ID !)). In the first
     *  case, the ambiguous sequence is fully contained only by the root.
     *  In the second case, the ambiguous sequences fully contained within just
     *  e, as in: (e ID !).
     *
     *  Rather than trying to optimize this and make
     *  some intelligent decisions for optimization purposes, I settled on
     *  just re-parsing the whole input and then using
     *  {link Trees#getRootOfSubtreeEnclosingRegion} to find the minimal
     *  subtree that contains the ambiguous sequence. I originally tried to
     *  record the call stack at the point the parser detected and ambiguity but
     *  left recursive rules create a parse tree stack that does not reflect
     *  the actual call stack. That impedance mismatch was enough to make
     *  it it challenging to restart the parser at a deeply nested rule
     *  invocation.
     *
     *  Only parser interpreters can override decisions so as to avoid inserting
     *  override checking code in the critical ALL(*) prediction execution path.
     *
     *  @since 4.5
     */ addDecisionOverride(decision, tokenIndex, forcedAlt) {
        this.overrideDecision = decision;
        this.overrideDecisionInputIndex = tokenIndex;
        this.overrideDecisionAlt = forcedAlt;
    }
    get overrideDecisionRoot() {
        return this._overrideDecisionRoot;
    }
    /** Rely on the error handler for this parser but, if no tokens are consumed
     *  to recover, add an error node. Otherwise, nothing is seen in the parse
     *  tree.
     */ recover(e) {
        let i = this._input.index;
        this.errorHandler.recover(this, e);
        if (this._input.index === i) {
            // no input consumed, better add an error node
            let tok = e.getOffendingToken();
            if (!tok) throw new Error("Expected exception to have an offending token");
            let source = tok.tokenSource;
            let stream = source !== undefined ? source.inputStream : undefined;
            let sourcePair = {
                source: source,
                stream: stream
            };
            if (e instanceof $l9UFP.InputMismatchException) {
                let expectedTokens = e.expectedTokens;
                if (expectedTokens === undefined) throw new Error("Expected the exception to provide expected tokens");
                let expectedTokenType = $TNDGs.Token.INVALID_TYPE;
                if (!expectedTokens.isNil) // get any element
                expectedTokenType = expectedTokens.minElement;
                let errToken = this.tokenFactory.create(sourcePair, expectedTokenType, tok.text, $TNDGs.Token.DEFAULT_CHANNEL, -1, -1, tok.line, tok.charPositionInLine);
                this._ctx.addErrorNode(this.createErrorNode(this._ctx, errToken));
            } else {
                let source = tok.tokenSource;
                let errToken = this.tokenFactory.create(sourcePair, $TNDGs.Token.INVALID_TYPE, tok.text, $TNDGs.Token.DEFAULT_CHANNEL, -1, -1, tok.line, tok.charPositionInLine);
                this._ctx.addErrorNode(this.createErrorNode(this._ctx, errToken));
            }
        }
    }
    recoverInline() {
        return this._errHandler.recoverInline(this);
    }
    /** Return the root of the parse, which can be useful if the parser
     *  bails out. You still can access the top node. Note that,
     *  because of the way left recursive rules add children, it's possible
     *  that the root will not have any children if the start rule immediately
     *  called and left recursive rule that fails.
     *
     * @since 4.5.1
     */ get rootContext() {
        return this._rootContext;
    }
    constructor(grammarFileName, vocabulary, ruleNames, atn, input){
        super(grammarFileName instanceof ParserInterpreter ? grammarFileName.inputStream : input);
        /** This stack corresponds to the _parentctx, _parentState pair of locals
         *  that would exist on call stack frames with a recursive descent parser;
         *  in the generated function for a left-recursive rule you'd see:
         *
         *  private EContext e(int _p) {
         *      ParserRuleContext _parentctx = _ctx;    // Pair.a
         *      int _parentState = state;          // Pair.b
         *      ...
         *  }
         *
         *  Those values are used to create new recursive rule invocation contexts
         *  associated with left operand of an alt like "expr '*' expr".
         */ this._parentContextStack = [];
        /** We need a map from (decision,inputIndex)->forced alt for computing ambiguous
         *  parse trees. For now, we allow exactly one override.
         */ this.overrideDecision = -1;
        this.overrideDecisionInputIndex = -1;
        this.overrideDecisionAlt = -1;
        this.overrideDecisionReached = false; // latch and only override once; error might trigger infinite loop
        /** What is the current context when we override a decisions?  This tells
         *  us what the root of the parse tree is when using override
         *  for an ambiguity/lookahead check.
         */ this._overrideDecisionRoot = undefined;
        if (grammarFileName instanceof ParserInterpreter) {
            let old = grammarFileName;
            this._grammarFileName = old._grammarFileName;
            this._atn = old._atn;
            this.pushRecursionContextStates = old.pushRecursionContextStates;
            this._ruleNames = old._ruleNames;
            this._vocabulary = old._vocabulary;
            this.interpreter = new $lORdS.ParserATNSimulator(this._atn, this);
        } else {
            // The second constructor requires non-null arguments
            vocabulary;
            ruleNames;
            atn;
            this._grammarFileName = grammarFileName;
            this._atn = atn;
            this._ruleNames = ruleNames.slice(0);
            this._vocabulary = vocabulary;
            // identify the ATN states where pushNewRecursionContext() must be called
            this.pushRecursionContextStates = new $kJZRw.BitSet(atn.states.length);
            for (let state of atn.states){
                if (!(state instanceof $YUl9W.StarLoopEntryState)) continue;
                if (state.precedenceRuleDecision) this.pushRecursionContextStates.set(state.stateNumber);
            }
            // get atn simulator that knows how to do predictions
            this.interpreter = new $lORdS.ParserATNSimulator(atn, this);
        }
    }
};
$59a6a185a8c94431$var$__decorate([
    $ffTXa.NotNull
], $59a6a185a8c94431$var$ParserInterpreter.prototype, "_vocabulary", void 0);
$59a6a185a8c94431$var$__decorate([
    $ffTXa.Override
], $59a6a185a8c94431$var$ParserInterpreter.prototype, "reset", null);
$59a6a185a8c94431$var$__decorate([
    $ffTXa.Override
], $59a6a185a8c94431$var$ParserInterpreter.prototype, "atn", null);
$59a6a185a8c94431$var$__decorate([
    $ffTXa.Override
], $59a6a185a8c94431$var$ParserInterpreter.prototype, "vocabulary", null);
$59a6a185a8c94431$var$__decorate([
    $ffTXa.Override
], $59a6a185a8c94431$var$ParserInterpreter.prototype, "ruleNames", null);
$59a6a185a8c94431$var$__decorate([
    $ffTXa.Override
], $59a6a185a8c94431$var$ParserInterpreter.prototype, "grammarFileName", null);
$59a6a185a8c94431$var$__decorate([
    $ffTXa.Override
], $59a6a185a8c94431$var$ParserInterpreter.prototype, "enterRecursionRule", null);
$59a6a185a8c94431$var$ParserInterpreter = $59a6a185a8c94431$var$__decorate([
    $59a6a185a8c94431$var$__param(1, $ffTXa.NotNull)
], $59a6a185a8c94431$var$ParserInterpreter);
module.exports.ParserInterpreter = $59a6a185a8c94431$var$ParserInterpreter;

});

parcelRegister("aVYvQ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7f5e2ac8bc68df86$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleContextWithAltNum = void 0;

var $3pR6v = parcelRequire("3pR6v");


var $ffTXa = parcelRequire("ffTXa");


var $5izRN = parcelRequire("5izRN");

/** A handy class for use with
 *
 *  options {contextSuperClass=org.antlr.v4.runtime.RuleContextWithAltNum;}
 *
 *  that provides a backing field / impl for the outer alternative number
 *  matched for an internal parse tree node.
 *
 *  I'm only putting into Java runtime as I'm certain I'm the only one that
 *  will really every use this.
 */ class $7f5e2ac8bc68df86$var$RuleContextWithAltNum extends $5izRN.ParserRuleContext {
    get altNumber() {
        return this._altNumber;
    }
    // @Override
    set altNumber(altNum) {
        this._altNumber = altNum;
    }
    constructor(parent, invokingStateNumber){
        if (invokingStateNumber !== undefined) super(parent, invokingStateNumber);
        else super();
        this._altNumber = $3pR6v.ATN.INVALID_ALT_NUMBER;
    }
}
$7f5e2ac8bc68df86$var$__decorate([
    $ffTXa.Override
], $7f5e2ac8bc68df86$var$RuleContextWithAltNum.prototype, "altNumber", null);
module.exports.RuleContextWithAltNum = $7f5e2ac8bc68df86$var$RuleContextWithAltNum;

});

parcelRegister("fJ53d", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleDependency = void 0;
/**
 * Declares a dependency upon a grammar rule, along with a set of zero or more dependent rules.
 *
 * Version numbers within a grammar should be assigned on a monotonically increasing basis to allow for accurate
 * tracking of dependent rules.
 *
 * @author Sam Harwell
 */ function $b72ef9f51eba9533$var$RuleDependency(dependency) {
    return (target, propertyKey, propertyDescriptor)=>{
    // intentionally empty
    };
}
module.exports.RuleDependency = $b72ef9f51eba9533$var$RuleDependency;

});

parcelRegister("9gsnS", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleVersion = void 0;
/**
 *
 * @author Sam Harwell
 */ function $6beba030a2520a51$var$RuleVersion(version) {
    return (target, propertyKey, propertyDescriptor)=>{
    // intentionally empty
    };
}
module.exports.RuleVersion = $6beba030a2520a51$var$RuleVersion;

});

parcelRegister("lyL1w", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("1Gdfm", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("4LMM0", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("yaMYv", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $066b8b8b66bc067e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RewriteOperation = module.exports.TokenStreamRewriter = void 0;

var $dQ3yU = parcelRequire("dQ3yU");


var $ffTXa = parcelRequire("ffTXa");


var $TNDGs = parcelRequire("TNDGs");

/**
 * Useful for rewriting out a buffered input token stream after doing some
 * augmentation or other manipulations on it.
 *
 * You can insert stuff, replace, and delete chunks. Note that the operations
 * are done lazily--only if you convert the buffer to a {@link String} with
 * {@link TokenStream#getText()}. This is very efficient because you are not
 * moving data around all the time. As the buffer of tokens is converted to
 * strings, the {@link #getText()} method(s) scan the input token stream and
 * check to see if there is an operation at the current index. If so, the
 * operation is done and then normal {@link String} rendering continues on the
 * buffer. This is like having multiple Turing machine instruction streams
 * (programs) operating on a single input tape. :)
 *
 * This rewriter makes no modifications to the token stream. It does not ask the
 * stream to fill itself up nor does it advance the input cursor. The token
 * stream `TokenStream.index` will return the same value before and
 * after any {@link #getText()} call.
 *
 * The rewriter only works on tokens that you have in the buffer and ignores the
 * current input cursor. If you are buffering tokens on-demand, calling
 * {@link #getText()} halfway through the input will only do rewrites for those
 * tokens in the first half of the file.
 *
 * Since the operations are done lazily at {@link #getText}-time, operations do
 * not screw up the token index values. That is, an insert operation at token
 * index `i` does not change the index values for tokens
 * `i`+1..n-1.
 *
 * Because operations never actually alter the buffer, you may always get the
 * original token stream back without undoing anything. Since the instructions
 * are queued up, you can easily simulate transactions and roll back any changes
 * if there is an error just by removing instructions. For example,
 *
 * ```
 * CharStream input = new ANTLRFileStream("input");
 * TLexer lex = new TLexer(input);
 * CommonTokenStream tokens = new CommonTokenStream(lex);
 * T parser = new T(tokens);
 * TokenStreamRewriter rewriter = new TokenStreamRewriter(tokens);
 * parser.startRule();
 * ```
 *
 * Then in the rules, you can execute (assuming rewriter is visible):
 *
 * ```
 * Token t,u;
 * ...
 * rewriter.insertAfter(t, "text to put after t");}
 * rewriter.insertAfter(u, "text after u");}
 * System.out.println(rewriter.getText());
 * ```
 *
 * You can also have multiple "instruction streams" and get multiple rewrites
 * from a single pass over the input. Just name the instruction streams and use
 * that name again when printing the buffer. This could be useful for generating
 * a C file and also its header file--all from the same buffer:
 *
 * ```
 * rewriter.insertAfter("pass1", t, "text to put after t");}
 * rewriter.insertAfter("pass2", u, "text after u");}
 * System.out.println(rewriter.getText("pass1"));
 * System.out.println(rewriter.getText("pass2"));
 * ```
 *
 * If you don't use named rewrite streams, a "default" stream is used as the
 * first example shows.
 */ class $066b8b8b66bc067e$var$TokenStreamRewriter {
    getTokenStream() {
        return this.tokens;
    }
    rollback(instructionIndex, programName = $066b8b8b66bc067e$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let is = this.programs.get(programName);
        if (is != null) this.programs.set(programName, is.slice($066b8b8b66bc067e$var$TokenStreamRewriter.MIN_TOKEN_INDEX, instructionIndex));
    }
    deleteProgram(programName = $066b8b8b66bc067e$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        this.rollback($066b8b8b66bc067e$var$TokenStreamRewriter.MIN_TOKEN_INDEX, programName);
    }
    insertAfter(tokenOrIndex, text, programName = $066b8b8b66bc067e$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let index;
        if (typeof tokenOrIndex === "number") index = tokenOrIndex;
        else index = tokenOrIndex.tokenIndex;
        // to insert after, just insert before next index (even if past end)
        let rewrites = this.getProgram(programName);
        let op = new $066b8b8b66bc067e$var$InsertAfterOp(this.tokens, index, rewrites.length, text);
        rewrites.push(op);
    }
    insertBefore(tokenOrIndex, text, programName = $066b8b8b66bc067e$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let index;
        if (typeof tokenOrIndex === "number") index = tokenOrIndex;
        else index = tokenOrIndex.tokenIndex;
        let rewrites = this.getProgram(programName);
        let op = new $066b8b8b66bc067e$var$InsertBeforeOp(this.tokens, index, rewrites.length, text);
        rewrites.push(op);
    }
    replaceSingle(index, text) {
        if (typeof index === "number") this.replace(index, index, text);
        else this.replace(index, index, text);
    }
    replace(from, to, text, programName = $066b8b8b66bc067e$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        if (typeof from !== "number") from = from.tokenIndex;
        if (typeof to !== "number") to = to.tokenIndex;
        if (from > to || from < 0 || to < 0 || to >= this.tokens.size) throw new RangeError(`replace: range invalid: ${from}..${to}(size=${this.tokens.size})`);
        let rewrites = this.getProgram(programName);
        let op = new $066b8b8b66bc067e$var$ReplaceOp(this.tokens, from, to, rewrites.length, text);
        rewrites.push(op);
    }
    delete(from, to, programName = $066b8b8b66bc067e$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        if (to === undefined) to = from;
        if (typeof from === "number") this.replace(from, to, "", programName);
        else this.replace(from, to, "", programName);
    }
    getLastRewriteTokenIndex(programName = $066b8b8b66bc067e$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let I = this.lastRewriteTokenIndexes.get(programName);
        if (I == null) return -1;
        return I;
    }
    setLastRewriteTokenIndex(programName, i) {
        this.lastRewriteTokenIndexes.set(programName, i);
    }
    getProgram(name) {
        let is = this.programs.get(name);
        if (is == null) is = this.initializeProgram(name);
        return is;
    }
    initializeProgram(name) {
        let is = [];
        this.programs.set(name, is);
        return is;
    }
    getText(intervalOrProgram, programName = $066b8b8b66bc067e$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let interval;
        if (intervalOrProgram instanceof $dQ3yU.Interval) interval = intervalOrProgram;
        else interval = $dQ3yU.Interval.of(0, this.tokens.size - 1);
        if (typeof intervalOrProgram === "string") programName = intervalOrProgram;
        let rewrites = this.programs.get(programName);
        let start = interval.a;
        let stop = interval.b;
        // ensure start/end are in range
        if (stop > this.tokens.size - 1) stop = this.tokens.size - 1;
        if (start < 0) start = 0;
        if (rewrites == null || rewrites.length === 0) return this.tokens.getText(interval); // no instructions to execute
        let buf = [];
        // First, optimize instruction stream
        let indexToOp = this.reduceToSingleOperationPerIndex(rewrites);
        // Walk buffer, executing instructions and emitting tokens
        let i = start;
        while(i <= stop && i < this.tokens.size){
            let op = indexToOp.get(i);
            indexToOp.delete(i); // remove so any left have index size-1
            let t = this.tokens.get(i);
            if (op == null) {
                // no operation at that index, just dump token
                if (t.type !== $TNDGs.Token.EOF) buf.push(String(t.text));
                i++; // move to next token
            } else i = op.execute(buf); // execute operation and skip
        }
        // include stuff after end if it's last index in buffer
        // So, if they did an insertAfter(lastValidIndex, "foo"), include
        // foo if end==lastValidIndex.
        if (stop === this.tokens.size - 1) {
            // Scan any remaining operations after last token
            // should be included (they will be inserts).
            for (let op of indexToOp.values())if (op.index >= this.tokens.size - 1) buf.push(op.text.toString());
        }
        return buf.join("");
    }
    /** We need to combine operations and report invalid operations (like
     *  overlapping replaces that are not completed nested). Inserts to
     *  same index need to be combined etc...  Here are the cases:
     *
     *  I.i.u I.j.v								leave alone, nonoverlapping
     *  I.i.u I.i.v								combine: Iivu
     *
     *  R.i-j.u R.x-y.v	| i-j in x-y			delete first R
     *  R.i-j.u R.i-j.v							delete first R
     *  R.i-j.u R.x-y.v	| x-y in i-j			ERROR
     *  R.i-j.u R.x-y.v	| boundaries overlap	ERROR
     *
     *  Delete special case of replace (text==undefined):
     *  D.i-j.u D.x-y.v	| boundaries overlap	combine to max(min)..max(right)
     *
     *  I.i.u R.x-y.v | i in (x+1)-y			delete I (since insert before
     * 											we're not deleting i)
     *  I.i.u R.x-y.v | i not in (x+1)-y		leave alone, nonoverlapping
     *  R.x-y.v I.i.u | i in x-y				ERROR
     *  R.x-y.v I.x.u 							R.x-y.uv (combine, delete I)
     *  R.x-y.v I.i.u | i not in x-y			leave alone, nonoverlapping
     *
     *  I.i.u = insert u before op @ index i
     *  R.x-y.u = replace x-y indexed tokens with u
     *
     *  First we need to examine replaces. For any replace op:
     *
     * 		1. wipe out any insertions before op within that range.
     * 		2. Drop any replace op before that is contained completely within
     * 	 that range.
     * 		3. Throw exception upon boundary overlap with any previous replace.
     *
     *  Then we can deal with inserts:
     *
     * 		1. for any inserts to same index, combine even if not adjacent.
     * 		2. for any prior replace with same left boundary, combine this
     * 	 insert with replace and delete this replace.
     * 		3. throw exception if index in same range as previous replace
     *
     *  Don't actually delete; make op undefined in list. Easier to walk list.
     *  Later we can throw as we add to index &rarr; op map.
     *
     *  Note that I.2 R.2-2 will wipe out I.2 even though, technically, the
     *  inserted stuff would be before the replace range. But, if you
     *  add tokens in front of a method body '{' and then delete the method
     *  body, I think the stuff before the '{' you added should disappear too.
     *
     *  Return a map from token index to operation.
     */ reduceToSingleOperationPerIndex(rewrites) {
        // console.log(`rewrites=[${Utils.join(rewrites, ", ")}]`);
        // WALK REPLACES
        for(let i = 0; i < rewrites.length; i++){
            let op = rewrites[i];
            if (op == null) continue;
            if (!(op instanceof $066b8b8b66bc067e$var$ReplaceOp)) continue;
            let rop = op;
            // Wipe prior inserts within range
            let inserts = this.getKindOfOps(rewrites, $066b8b8b66bc067e$var$InsertBeforeOp, i);
            for (let iop of inserts){
                if (iop.index === rop.index) {
                    // E.g., insert before 2, delete 2..2; update replace
                    // text to include insert before, kill insert
                    rewrites[iop.instructionIndex] = undefined;
                    rop.text = iop.text.toString() + (rop.text != null ? rop.text.toString() : "");
                } else if (iop.index > rop.index && iop.index <= rop.lastIndex) // delete insert as it's a no-op.
                rewrites[iop.instructionIndex] = undefined;
            }
            // Drop any prior replaces contained within
            let prevReplaces = this.getKindOfOps(rewrites, $066b8b8b66bc067e$var$ReplaceOp, i);
            for (let prevRop of prevReplaces){
                if (prevRop.index >= rop.index && prevRop.lastIndex <= rop.lastIndex) {
                    // delete replace as it's a no-op.
                    rewrites[prevRop.instructionIndex] = undefined;
                    continue;
                }
                // throw exception unless disjoint or identical
                let disjoint = prevRop.lastIndex < rop.index || prevRop.index > rop.lastIndex;
                // Delete special case of replace (text==null):
                // D.i-j.u D.x-y.v	| boundaries overlap	combine to max(min)..max(right)
                if (prevRop.text == null && rop.text == null && !disjoint) {
                    // console.log(`overlapping deletes: ${prevRop}, ${rop}`);
                    rewrites[prevRop.instructionIndex] = undefined; // kill first delete
                    rop.index = Math.min(prevRop.index, rop.index);
                    rop.lastIndex = Math.max(prevRop.lastIndex, rop.lastIndex);
                // console.log(`new rop ${rop}`);
                } else if (!disjoint) throw new Error(`replace op boundaries of ${rop} overlap with previous ${prevRop}`);
            }
        }
        // WALK INSERTS
        for(let i = 0; i < rewrites.length; i++){
            let op = rewrites[i];
            if (op == null) continue;
            if (!(op instanceof $066b8b8b66bc067e$var$InsertBeforeOp)) continue;
            let iop = op;
            // combine current insert with prior if any at same index
            let prevInserts = this.getKindOfOps(rewrites, $066b8b8b66bc067e$var$InsertBeforeOp, i);
            for (let prevIop of prevInserts)if (prevIop.index === iop.index) {
                if (prevIop instanceof $066b8b8b66bc067e$var$InsertAfterOp) {
                    iop.text = this.catOpText(prevIop.text, iop.text);
                    rewrites[prevIop.instructionIndex] = undefined;
                } else if (prevIop instanceof $066b8b8b66bc067e$var$InsertBeforeOp) {
                    // convert to strings...we're in process of toString'ing
                    // whole token buffer so no lazy eval issue with any templates
                    iop.text = this.catOpText(iop.text, prevIop.text);
                    // delete redundant prior insert
                    rewrites[prevIop.instructionIndex] = undefined;
                }
            }
            // look for replaces where iop.index is in range; error
            let prevReplaces = this.getKindOfOps(rewrites, $066b8b8b66bc067e$var$ReplaceOp, i);
            for (let rop of prevReplaces){
                if (iop.index === rop.index) {
                    rop.text = this.catOpText(iop.text, rop.text);
                    rewrites[i] = undefined; // delete current insert
                    continue;
                }
                if (iop.index >= rop.index && iop.index <= rop.lastIndex) throw new Error(`insert op ${iop} within boundaries of previous ${rop}`);
            }
        }
        // console.log(`rewrites after=[${Utils.join(rewrites, ", ")}]`);
        let m = new Map();
        for (let op of rewrites){
            if (op == null) continue;
            if (m.get(op.index) != null) throw new Error("should only be one op per index");
            m.set(op.index, op);
        }
        // console.log(`index to op: ${m}`);
        return m;
    }
    catOpText(a, b) {
        let x = "";
        let y = "";
        if (a != null) x = a.toString();
        if (b != null) y = b.toString();
        return x + y;
    }
    /** Get all operations before an index of a particular kind */ getKindOfOps(rewrites, kind, before) {
        let ops = [];
        for(let i = 0; i < before && i < rewrites.length; i++){
            let op = rewrites[i];
            if (op == null) continue;
            if (op instanceof kind) ops.push(op);
        }
        return ops;
    }
    constructor(tokens){
        this.tokens = tokens;
        this.programs = new Map();
        this.programs.set($066b8b8b66bc067e$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME, []);
        this.lastRewriteTokenIndexes = new Map();
    }
}
module.exports.TokenStreamRewriter = $066b8b8b66bc067e$var$TokenStreamRewriter;
$066b8b8b66bc067e$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME = "default";
$066b8b8b66bc067e$var$TokenStreamRewriter.PROGRAM_INIT_SIZE = 100;
$066b8b8b66bc067e$var$TokenStreamRewriter.MIN_TOKEN_INDEX = 0;
// Define the rewrite operation hierarchy
class $066b8b8b66bc067e$var$RewriteOperation {
    /** Execute the rewrite operation by possibly adding to the buffer.
     *  Return the index of the next token to operate on.
     */ execute(buf) {
        return this.index;
    }
    toString() {
        let opName = this.constructor.name;
        let $index = opName.indexOf("$");
        opName = opName.substring($index + 1, opName.length);
        return "<" + opName + "@" + this.tokens.get(this.index) + ":\"" + this.text + "\">";
    }
    constructor(tokens, index, instructionIndex, text){
        this.tokens = tokens;
        this.instructionIndex = instructionIndex;
        this.index = index;
        this.text = text === undefined ? "" : text;
    }
}
$066b8b8b66bc067e$var$__decorate([
    $ffTXa.Override
], $066b8b8b66bc067e$var$RewriteOperation.prototype, "toString", null);
module.exports.RewriteOperation = $066b8b8b66bc067e$var$RewriteOperation;
class $066b8b8b66bc067e$var$InsertBeforeOp extends $066b8b8b66bc067e$var$RewriteOperation {
    execute(buf) {
        buf.push(this.text.toString());
        if (this.tokens.get(this.index).type !== $TNDGs.Token.EOF) buf.push(String(this.tokens.get(this.index).text));
        return this.index + 1;
    }
    constructor(tokens, index, instructionIndex, text){
        super(tokens, index, instructionIndex, text);
    }
}
$066b8b8b66bc067e$var$__decorate([
    $ffTXa.Override
], $066b8b8b66bc067e$var$InsertBeforeOp.prototype, "execute", null);
/** Distinguish between insert after/before to do the "insert afters"
 *  first and then the "insert befores" at same index. Implementation
 *  of "insert after" is "insert before index+1".
 */ class $066b8b8b66bc067e$var$InsertAfterOp extends $066b8b8b66bc067e$var$InsertBeforeOp {
    constructor(tokens, index, instructionIndex, text){
        super(tokens, index + 1, instructionIndex, text); // insert after is insert before index+1
    }
}
/** I'm going to try replacing range from x..y with (y-x)+1 ReplaceOp
 *  instructions.
 */ class $066b8b8b66bc067e$var$ReplaceOp extends $066b8b8b66bc067e$var$RewriteOperation {
    execute(buf) {
        if (this.text != null) buf.push(this.text.toString());
        return this.lastIndex + 1;
    }
    toString() {
        if (this.text == null) return "<DeleteOp@" + this.tokens.get(this.index) + ".." + this.tokens.get(this.lastIndex) + ">";
        return "<ReplaceOp@" + this.tokens.get(this.index) + ".." + this.tokens.get(this.lastIndex) + ":\"" + this.text + "\">";
    }
    constructor(tokens, from, to, instructionIndex, text){
        super(tokens, from, instructionIndex, text);
        this.lastIndex = to;
    }
}
$066b8b8b66bc067e$var$__decorate([
    $ffTXa.Override
], $066b8b8b66bc067e$var$ReplaceOp.prototype, "execute", null);
$066b8b8b66bc067e$var$__decorate([
    $ffTXa.Override
], $066b8b8b66bc067e$var$ReplaceOp.prototype, "toString", null);

});

parcelRegister("egzAU", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("efi0K", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("2nXS3", function(module, exports) {

var $lso6d = parcelRequire("lso6d");


var $gJMeE = parcelRequire("gJMeE");


var $8Dduc = parcelRequire("8Dduc");


var $56U0W = parcelRequire("56U0W");


var $3jpAZ = parcelRequire("3jpAZ");

var $6632c2804e382a8c$var$_JQLLexer;
class $6632c2804e382a8c$export$375c79404cc64c7f extends (0, $gJMeE.Lexer) {
    // @Override
    // @NotNull
    get vocabulary() {
        return $6632c2804e382a8c$export$375c79404cc64c7f.VOCABULARY;
    }
    // @Override
    get grammarFileName() {
        return 'JQLLexer.g4';
    }
    // @Override
    get ruleNames() {
        return $6632c2804e382a8c$export$375c79404cc64c7f.ruleNames;
    }
    // @Override
    get serializedATN() {
        return $6632c2804e382a8c$export$375c79404cc64c7f._serializedATN;
    }
    // @Override
    get channelNames() {
        return $6632c2804e382a8c$export$375c79404cc64c7f.channelNames;
    }
    // @Override
    get modeNames() {
        return $6632c2804e382a8c$export$375c79404cc64c7f.modeNames;
    }
    static get _ATN() {
        if (!$6632c2804e382a8c$export$375c79404cc64c7f.__ATN) $6632c2804e382a8c$export$375c79404cc64c7f.__ATN = new (0, $lso6d.ATNDeserializer)().deserialize($3jpAZ.toCharArray($6632c2804e382a8c$export$375c79404cc64c7f._serializedATN));
        return $6632c2804e382a8c$export$375c79404cc64c7f.__ATN;
    }
    // tslint:enable:no-trailing-whitespace
    constructor(input){
        super(input);
        this._interp = new (0, $8Dduc.LexerATNSimulator)($6632c2804e382a8c$export$375c79404cc64c7f._ATN, this);
    }
}
$6632c2804e382a8c$var$_JQLLexer = $6632c2804e382a8c$export$375c79404cc64c7f;
$6632c2804e382a8c$export$375c79404cc64c7f.LPAREN = 1;
$6632c2804e382a8c$export$375c79404cc64c7f.RPAREN = 2;
$6632c2804e382a8c$export$375c79404cc64c7f.COMMA = 3;
$6632c2804e382a8c$export$375c79404cc64c7f.LBRACKET = 4;
$6632c2804e382a8c$export$375c79404cc64c7f.RBRACKET = 5;
$6632c2804e382a8c$export$375c79404cc64c7f.BANG = 6;
$6632c2804e382a8c$export$375c79404cc64c7f.LT = 7;
$6632c2804e382a8c$export$375c79404cc64c7f.GT = 8;
$6632c2804e382a8c$export$375c79404cc64c7f.GTEQ = 9;
$6632c2804e382a8c$export$375c79404cc64c7f.LTEQ = 10;
$6632c2804e382a8c$export$375c79404cc64c7f.EQUALS = 11;
$6632c2804e382a8c$export$375c79404cc64c7f.NOT_EQUALS = 12;
$6632c2804e382a8c$export$375c79404cc64c7f.LIKE = 13;
$6632c2804e382a8c$export$375c79404cc64c7f.NOT_LIKE = 14;
$6632c2804e382a8c$export$375c79404cc64c7f.IN = 15;
$6632c2804e382a8c$export$375c79404cc64c7f.IS = 16;
$6632c2804e382a8c$export$375c79404cc64c7f.AND = 17;
$6632c2804e382a8c$export$375c79404cc64c7f.OR = 18;
$6632c2804e382a8c$export$375c79404cc64c7f.NOT = 19;
$6632c2804e382a8c$export$375c79404cc64c7f.EMPTY = 20;
$6632c2804e382a8c$export$375c79404cc64c7f.WAS = 21;
$6632c2804e382a8c$export$375c79404cc64c7f.CHANGED = 22;
$6632c2804e382a8c$export$375c79404cc64c7f.BEFORE = 23;
$6632c2804e382a8c$export$375c79404cc64c7f.AFTER = 24;
$6632c2804e382a8c$export$375c79404cc64c7f.FROM = 25;
$6632c2804e382a8c$export$375c79404cc64c7f.TO = 26;
$6632c2804e382a8c$export$375c79404cc64c7f.ON = 27;
$6632c2804e382a8c$export$375c79404cc64c7f.DURING = 28;
$6632c2804e382a8c$export$375c79404cc64c7f.ORDER = 29;
$6632c2804e382a8c$export$375c79404cc64c7f.BY = 30;
$6632c2804e382a8c$export$375c79404cc64c7f.ASC = 31;
$6632c2804e382a8c$export$375c79404cc64c7f.DESC = 32;
$6632c2804e382a8c$export$375c79404cc64c7f.POSNUMBER = 33;
$6632c2804e382a8c$export$375c79404cc64c7f.NEGNUMBER = 34;
$6632c2804e382a8c$export$375c79404cc64c7f.CUSTOMFIELD = 35;
$6632c2804e382a8c$export$375c79404cc64c7f.RESERVED_WORD = 36;
$6632c2804e382a8c$export$375c79404cc64c7f.STRING = 37;
$6632c2804e382a8c$export$375c79404cc64c7f.MATCHWS = 38;
$6632c2804e382a8c$export$375c79404cc64c7f.ERROR_RESERVED = 39;
$6632c2804e382a8c$export$375c79404cc64c7f.ERRORCHAR = 40;
$6632c2804e382a8c$export$375c79404cc64c7f.QUOTE_STRING = 41;
$6632c2804e382a8c$export$375c79404cc64c7f.UNCLOSED_QUOTE_STRING = 42;
$6632c2804e382a8c$export$375c79404cc64c7f.INVALID_QUOTE_STRING = 43;
$6632c2804e382a8c$export$375c79404cc64c7f.SQUOTE_STRING = 44;
$6632c2804e382a8c$export$375c79404cc64c7f.UNCLOSED_SQUOTE_STRING = 45;
$6632c2804e382a8c$export$375c79404cc64c7f.INVALID_SQUOTE_STRING = 46;
$6632c2804e382a8c$export$375c79404cc64c7f.QUOTED_STR = 1;
$6632c2804e382a8c$export$375c79404cc64c7f.SQUOTED_STR = 2;
// tslint:disable:no-trailing-whitespace
$6632c2804e382a8c$export$375c79404cc64c7f.channelNames = [
    'DEFAULT_TOKEN_CHANNEL',
    'HIDDEN'
];
// tslint:disable:no-trailing-whitespace
$6632c2804e382a8c$export$375c79404cc64c7f.modeNames = [
    'DEFAULT_MODE',
    'QUOTED_STR',
    'SQUOTED_STR'
];
$6632c2804e382a8c$export$375c79404cc64c7f.ruleNames = [
    'LPAREN',
    'RPAREN',
    'COMMA',
    'LBRACKET',
    'RBRACKET',
    'LQUOTE',
    'LSQUOTE',
    'BANG',
    'LT',
    'GT',
    'GTEQ',
    'LTEQ',
    'EQUALS',
    'NOT_EQUALS',
    'LIKE',
    'NOT_LIKE',
    'IN',
    'IS',
    'AND',
    'OR',
    'NOT',
    'EMPTY',
    'WAS',
    'CHANGED',
    'BEFORE',
    'AFTER',
    'FROM',
    'TO',
    'ON',
    'DURING',
    'ORDER',
    'BY',
    'ASC',
    'DESC',
    'POSNUMBER',
    'NEGNUMBER',
    'CUSTOMFIELD',
    'RESERVED_WORD',
    'STRING',
    'MATCHWS',
    'ERROR_RESERVED',
    'ERRORCHAR',
    'QUOTE_STRING',
    'QUOTED_CONTENT',
    'UNCLOSED_QUOTE_STRING',
    'INVALID_QUOTE_STRING',
    'SQUOTE_STRING',
    'SQUOTED_CONTENT',
    'UNCLOSED_SQUOTE_STRING',
    'INVALID_SQUOTE_STRING',
    'VALID_UNQUOTED_CHARS',
    'VALID_QUOTED_CHARS',
    'VALID_SQUOTED_CHARS',
    'RESERVED_CHARS',
    'QUOTE',
    'SQUOTE',
    'BSLASH',
    'NL',
    'CR',
    'SPACE',
    'AMPER',
    'AMPER_AMPER',
    'PIPE',
    'PIPE_PIPE',
    'ESCAPE',
    'NEWLINE',
    'HEXDIGIT',
    'WS',
    'MINUS',
    'DIGIT',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z'
];
$6632c2804e382a8c$export$375c79404cc64c7f._LITERAL_NAMES = [
    undefined,
    "'('",
    "')'",
    "','",
    "'['",
    "']'",
    "'!'",
    "'<'",
    "'>'",
    "'>='",
    "'<='",
    "'='",
    "'!='",
    "'~'",
    "'!~'"
];
$6632c2804e382a8c$export$375c79404cc64c7f._SYMBOLIC_NAMES = [
    undefined,
    'LPAREN',
    'RPAREN',
    'COMMA',
    'LBRACKET',
    'RBRACKET',
    'BANG',
    'LT',
    'GT',
    'GTEQ',
    'LTEQ',
    'EQUALS',
    'NOT_EQUALS',
    'LIKE',
    'NOT_LIKE',
    'IN',
    'IS',
    'AND',
    'OR',
    'NOT',
    'EMPTY',
    'WAS',
    'CHANGED',
    'BEFORE',
    'AFTER',
    'FROM',
    'TO',
    'ON',
    'DURING',
    'ORDER',
    'BY',
    'ASC',
    'DESC',
    'POSNUMBER',
    'NEGNUMBER',
    'CUSTOMFIELD',
    'RESERVED_WORD',
    'STRING',
    'MATCHWS',
    'ERROR_RESERVED',
    'ERRORCHAR',
    'QUOTE_STRING',
    'UNCLOSED_QUOTE_STRING',
    'INVALID_QUOTE_STRING',
    'SQUOTE_STRING',
    'UNCLOSED_SQUOTE_STRING',
    'INVALID_SQUOTE_STRING'
];
$6632c2804e382a8c$export$375c79404cc64c7f.VOCABULARY = new (0, $56U0W.VocabularyImpl)($6632c2804e382a8c$var$_JQLLexer._LITERAL_NAMES, $6632c2804e382a8c$var$_JQLLexer._SYMBOLIC_NAMES, []);
$6632c2804e382a8c$export$375c79404cc64c7f._serializedATNSegments = 3;
$6632c2804e382a8c$export$375c79404cc64c7f._serializedATNSegment0 = "\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x020\u062E\b\x01\b\x01\b\x01\x04\x02	\x02\x04\x03	\x03\x04\x04	\x04\x04\x05	\x05\x04\x06	\x06\x04\x07	\x07\x04\b	\b\x04			\x04\n	\n\x04\v	\v\x04\f	\f\x04\r	\r\x04\x0e	\x0e\x04\x0f	\x0f\x04\x10	\x10\x04\x11	\x11\x04\x12	\x12\x04\x13	\x13\x04\x14	\x14\x04\x15	\x15\x04\x16	\x16\x04\x17	\x17\x04\x18	\x18\x04\x19	\x19\x04\x1a	\x1a\x04\x1b	\x1b\x04\x1c	\x1c\x04\x1d	\x1d\x04\x1e	\x1e\x04\x1f	\x1f\x04 	 \x04!	!\x04\"	\"\x04#	#\x04$	$\x04%	%\x04&	&\x04'	'\x04(	(\x04)	)\x04*	*\x04+	+\x04,	,\x04-	-\x04.	.\x04/	/\x040	0\x041	1\x042	2\x043	3\x044	4\x045	5\x046	6\x047	7\x048	8\x049	9\x04:	:\x04;	;\x04<	<\x04=	=\x04>	>\x04?	?\x04@	@\x04A	A\x04B	B\x04C	C\x04D	D\x04E	E\x04F	F\x04G	G\x04H	H\x04I	I\x04J	J\x04K	K\x04L	L\x04M	M\x04N	N\x04O	O\x04P	P\x04Q	Q\x04R	R\x04S	S\x04T	T\x04U	U\x04V	V\x04W	W\x04X	X\x04Y	Y\x04Z	Z\x04[	[\x04\\	\\\x04]	]\x04^	^\x04_	_\x04`	`\x04a	a\x03\x02\x03\x02\x03\x03\x03\x03\x03\x04\x03\x04\x03\x05\x03\x05\x03\x06\x03\x06\x03\x07\x03\x07\x03\x07\x03\x07\x03\x07\x03\b\x03\b\x03\b\x03\b\x03\b\x03	\x03	\x03\n\x03\n\x03\v\x03\v\x03\f\x03\f\x03\f\x03\r\x03\r\x03\r\x03\x0e\x03\x0e\x03\x0f\x03\x0f\x03\x0f\x03\x10\x03\x10\x03\x11\x03\x11\x03\x11\x03\x12\x03\x12\x03\x12\x03\x13\x03\x13\x03\x13\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x05\x14\xfc\n\x14\x03\x15\x03\x15\x03\x15\x03\x15\x03\x15\x05\x15\u0103\n\x15\x03\x16\x03\x16\x03\x16\x03\x16\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x05\x17\u0114\n\x17\x03\x18\x03\x18\x03\x18\x03\x18\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1c\x03\x1c\x03\x1c\x03\x1c\x03\x1c\x03\x1d\x03\x1d\x03\x1d\x03\x1e\x03\x1e\x03\x1e\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03 \x03 \x03 \x03 \x03 \x03 \x03!\x03!\x03!\x03\"\x03\"\x03\"\x03\"\x03#\x03#\x03#\x03#\x03#\x03$\x06$\u0154\n$\r$\x0e$\u0155\x03%\x03%\x06%\u015A\n%\r%\x0e%\u015B\x03&\x03&\x03&\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x05'\u0582\n'\x03(\x03(\x06(\u0586\n(\r(\x0e(\u0587\x03)\x06)\u058B\n)\r)\x0e)\u058C\x03)\x03)\x03*\x03*\x03+\x03+\x03,\x03,\x03,\x03,\x03-\x03-\x05-\u059B\n-\x03-\x03-\x03.\x03.\x03.\x03.\x03/\x03/\x03/\x03/\x030\x030\x030\x030\x031\x031\x051\u05AD\n1\x031\x031\x032\x032\x032\x032\x033\x033\x033\x033\x034\x034\x035\x035\x036\x036\x037\x037\x038\x038\x039\x039\x03:\x03:\x03;\x03;\x03<\x03<\x03=\x03=\x03>\x03>\x03?\x03?\x03?\x03@\x03@\x03A\x03A\x03A\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x05B\u05E3\nB\x03C\x03C\x05C\u05E7\nC\x03D\x03D\x03D\x03D\x03D\x03D\x03D\x05D\u05F0\nD\x03E\x03E\x03E\x05E\u05F5\nE\x03F\x03F\x03G\x03G\x03H\x03H\x03I\x03I\x03J\x03J\x03K\x03K\x03L\x03L\x03M\x03M\x03N\x03N\x03O\x03O\x03P\x03P\x03Q\x03Q\x03R\x03R\x03S\x03S\x03T\x03T\x03U\x03U\x03V\x03V\x03W\x03W\x03X\x03X\x03Y\x03Y\x03Z\x03Z\x03[\x03[\x03\\\x03\\\x03]\x03]\x03^\x03^\x03_\x03_\x03`\x03`\x03a\x03a\x02\x02\x02b\x05\x02\x03\x07\x02\x04	\x02\x05\v\x02\x06\r\x02\x07\x0f\x02\x02\x11\x02\x02\x13\x02\b\x15\x02	\x17\x02\n\x19\x02\v\x1b\x02\f\x1d\x02\r\x1f\x02\x0e!\x02\x0f#\x02\x10%\x02\x11'\x02\x12)\x02\x13+\x02\x14-\x02\x15/\x02\x161\x02\x173\x02\x185\x02\x197\x02\x1a9\x02\x1b;\x02\x1c=\x02\x1d?\x02\x1eA\x02\x1fC\x02 E\x02!G\x02\"I\x02#K\x02$M\x02%O\x02&Q\x02'S\x02(U\x02)W\x02*Y\x02+[\x02\x02]\x02,_\x02-a\x02.c\x02\x02e\x02/g\x020i\x02\x02k\x02\x02m\x02\x02o\x02\x02q\x02\x02s\x02\x02u\x02\x02w\x02\x02y\x02\x02{\x02\x02}\x02\x02\x7f\x02\x02\x81\x02\x02\x83\x02\x02\x85\x02\x02\x87\x02\x02\x89\x02\x02\x8b\x02\x02\x8d\x02\x02\x8f\x02\x02\x91\x02\x02\x93\x02\x02\x95\x02\x02\x97\x02\x02\x99\x02\x02\x9b\x02\x02\x9d\x02\x02\x9f\x02\x02\xa1\x02\x02\xa3\x02\x02\xa5\x02\x02\xa7\x02\x02\xa9\x02\x02\xab\x02\x02\xad\x02\x02\xaf\x02\x02\xb1\x02\x02\xb3\x02\x02\xb5\x02\x02\xb7\x02\x02\xb9\x02\x02\xbb\x02\x02\xbd\x02\x02\xbf\x02\x02\xc1\x02\x02\xc3\x02\x02\x05\x02\x03\x04\"	\x02\x02.11=B]`}\xa1\uFDD2\uFDF1\0\x01\n\x02\x02\v\r\x0e\x10!$$^^\x81\xa1\uFDD2\uFDF1\0\x01\n\x02\x02\v\r\x0e\x10!))^^\x81\xa1\uFDD2\uFDF1\0\x01\n\x02%',-11==AB``}}\x7f\x7f\x05\x02ppttvv\x03\x022;\x04\x02CCcc\x04\x02DDdd\x04\x02EEee\x04\x02FFff\x04\x02GGgg\x04\x02HHhh\x04\x02IIii\x04\x02JJjj\x04\x02KKkk\x04\x02LLll\x04\x02MMmm\x04\x02NNnn\x04\x02OOoo\x04\x02PPpp\x04\x02QQqq\x04\x02RRrr\x04\x02SSss\x04\x02TTtt\x04\x02UUuu\x04\x02VVvv\x04\x02WWww\x04\x02XXxx\x04\x02YYyy\x04\x02ZZzz\x04\x02[[{{\x04\x02\\\\||\x02\u06B5\x02\x05\x03\x02\x02\x02\x02\x07\x03\x02\x02\x02\x02	\x03\x02\x02\x02\x02\v\x03\x02\x02\x02\x02\r\x03\x02\x02\x02\x02\x0f\x03\x02\x02\x02\x02\x11\x03\x02\x02\x02\x02\x13\x03\x02\x02\x02\x02\x15\x03\x02\x02\x02\x02\x17\x03\x02\x02\x02\x02\x19\x03\x02\x02\x02\x02\x1b\x03\x02\x02\x02\x02\x1d\x03\x02\x02\x02\x02\x1f\x03\x02\x02\x02\x02!\x03\x02\x02\x02\x02#\x03\x02\x02\x02\x02%\x03\x02\x02\x02\x02'\x03\x02\x02\x02\x02)\x03\x02\x02\x02\x02+\x03\x02\x02\x02\x02-\x03\x02\x02\x02\x02/\x03\x02\x02\x02\x021\x03\x02\x02\x02\x023\x03\x02\x02\x02\x025\x03\x02\x02\x02\x027\x03\x02\x02\x02\x029\x03\x02\x02\x02\x02;\x03\x02\x02\x02\x02=\x03\x02\x02\x02\x02?\x03\x02\x02\x02\x02A\x03\x02\x02\x02\x02C\x03\x02\x02\x02\x02E\x03\x02\x02\x02\x02G\x03\x02\x02\x02\x02I\x03\x02\x02\x02\x02K\x03\x02\x02\x02\x02M\x03\x02\x02\x02\x02O\x03\x02\x02\x02\x02Q\x03\x02\x02\x02\x02S\x03\x02\x02\x02\x02U\x03\x02\x02\x02\x02W\x03\x02\x02\x02\x03Y\x03\x02\x02\x02\x03[\x03\x02\x02\x02\x03]\x03\x02\x02\x02\x03_\x03\x02\x02\x02\x04a\x03\x02\x02\x02\x04c\x03\x02\x02\x02\x04e\x03\x02\x02\x02\x04g\x03\x02\x02\x02\x05\xc5\x03\x02\x02\x02\x07\xc7\x03\x02\x02\x02	\xc9\x03\x02\x02\x02\v\xcb\x03\x02\x02\x02\r\xcd\x03\x02\x02\x02\x0f\xcf\x03\x02\x02\x02\x11\xd4\x03\x02\x02\x02\x13\xd9\x03\x02\x02\x02\x15\xdb\x03\x02\x02\x02\x17\xdd\x03\x02\x02\x02\x19\xdf\x03\x02\x02\x02\x1b\xe2\x03\x02\x02\x02\x1d\xe5\x03\x02\x02\x02\x1f\xe7\x03\x02\x02\x02!\xea\x03\x02\x02\x02#\xec\x03\x02\x02\x02%\xef\x03\x02\x02\x02'\xf2\x03\x02\x02\x02)\xfb\x03\x02\x02\x02+\u0102\x03\x02\x02\x02-\u0104\x03\x02\x02\x02/\u0113\x03\x02\x02\x021\u0115\x03\x02\x02\x023\u0119\x03\x02\x02\x025\u0121\x03\x02\x02\x027\u0128\x03\x02\x02\x029\u012E\x03\x02\x02\x02;\u0133\x03\x02\x02\x02=\u0136\x03\x02\x02\x02?\u0139\x03\x02\x02\x02A\u0140\x03\x02\x02\x02C\u0146\x03\x02\x02\x02E\u0149\x03\x02\x02\x02G\u014D\x03\x02\x02\x02I\u0153\x03\x02\x02\x02K\u0157\x03\x02\x02\x02M\u015D\x03\x02\x02\x02O\u0581\x03\x02\x02\x02Q\u0585\x03\x02\x02\x02S\u058A\x03\x02\x02\x02U\u0590\x03\x02\x02\x02W\u0592\x03\x02\x02\x02Y\u0594\x03\x02\x02\x02[\u059A\x03\x02\x02\x02]\u059E\x03\x02\x02\x02_\u05A2\x03\x02\x02\x02a\u05A6\x03\x02\x02\x02c\u05AC\x03\x02\x02\x02e\u05B0\x03\x02\x02\x02g\u05B4\x03\x02\x02\x02i\u05B8\x03\x02\x02\x02k\u05BA\x03\x02\x02\x02m\u05BC\x03\x02\x02\x02o\u05BE\x03\x02\x02\x02q\u05C0\x03\x02\x02\x02s\u05C2\x03\x02\x02\x02u\u05C4\x03\x02\x02\x02w\u05C6\x03\x02\x02\x02y\u05C8\x03\x02\x02\x02{\u05CA\x03\x02\x02\x02}\u05CC\x03\x02\x02\x02\x7f\u05CE\x03\x02\x02\x02\x81\u05D1\x03\x02\x02\x02\x83\u05D3\x03\x02\x02\x02\x85\u05D6\x03\x02\x02\x02\x87\u05E6\x03\x02\x02\x02\x89\u05EF\x03\x02\x02\x02\x8b\u05F4\x03\x02\x02\x02\x8d\u05F6\x03\x02\x02\x02\x8f\u05F8\x03\x02\x02\x02\x91\u05FA\x03\x02\x02\x02\x93\u05FC\x03\x02\x02\x02\x95\u05FE\x03\x02\x02\x02\x97\u0600\x03\x02\x02\x02\x99\u0602\x03\x02\x02\x02\x9b\u0604\x03\x02\x02\x02\x9d\u0606\x03\x02\x02\x02\x9f\u0608\x03\x02\x02\x02\xa1\u060A\x03\x02\x02\x02\xa3\u060C\x03\x02\x02\x02\xa5\u060E\x03\x02\x02\x02\xa7\u0610\x03\x02\x02\x02\xa9\u0612\x03\x02\x02\x02\xab\u0614\x03\x02\x02\x02\xad\u0616\x03\x02\x02\x02\xaf\u0618\x03\x02\x02\x02\xb1\u061A\x03\x02\x02\x02\xb3\u061C\x03\x02\x02\x02\xb5\u061E\x03\x02\x02\x02\xb7\u0620\x03\x02\x02\x02\xb9\u0622\x03\x02\x02\x02\xbb\u0624\x03\x02\x02\x02\xbd\u0626\x03\x02\x02\x02\xbf\u0628\x03\x02\x02\x02\xc1\u062A\x03\x02\x02\x02\xc3\u062C\x03\x02\x02\x02\xc5\xc6\x07*\x02\x02\xc6\x06\x03\x02\x02\x02\xc7\xc8\x07+\x02\x02\xc8\b\x03\x02\x02\x02\xc9\xca\x07.\x02\x02\xca\n\x03\x02\x02\x02\xcb\xcc\x07]\x02\x02\xcc\f\x03\x02\x02\x02\xcd\xce\x07_\x02\x02\xce\x0e\x03\x02\x02\x02\xcf\xd0\x05q8\x02\xd0\xd1\x03\x02\x02\x02\xd1\xd2\b\x07\x02\x02\xd2\xd3\b\x07\x03\x02\xd3\x10\x03\x02\x02\x02\xd4\xd5\x05s9\x02\xd5\xd6\x03\x02\x02\x02\xd6\xd7\b\b\x02\x02\xd7\xd8\b\b\x04\x02\xd8\x12\x03\x02\x02\x02\xd9\xda\x07#\x02\x02\xda\x14\x03\x02\x02\x02\xdb\xdc\x07>\x02\x02\xdc\x16\x03\x02\x02\x02\xdd\xde\x07@\x02\x02\xde\x18\x03\x02\x02\x02\xdf\xe0\x07@\x02\x02\xe0\xe1\x07?\x02\x02\xe1\x1a\x03\x02\x02\x02\xe2\xe3\x07>\x02\x02\xe3\xe4\x07?\x02\x02\xe4\x1c\x03\x02\x02\x02\xe5\xe6\x07?\x02\x02\xe6\x1e\x03\x02\x02\x02\xe7\xe8\x07#\x02\x02\xe8\xe9\x07?\x02\x02\xe9 \x03\x02\x02\x02\xea\xeb\x07\x80\x02\x02\xeb\"\x03\x02\x02\x02\xec\xed\x07#\x02\x02\xed\xee\x07\x80\x02\x02\xee$\x03\x02\x02\x02\xef\xf0\x05\xa1P\x02\xf0\xf1\x05\xabU\x02\xf1&\x03\x02\x02\x02\xf2\xf3\x05\xa1P\x02\xf3\xf4\x05\xb5Z\x02\xf4(\x03\x02\x02\x02\xf5\xf6\x05\x91H\x02\xf6\xf7\x05\xabU\x02\xf7\xf8\x05\x97K\x02\xf8\xfc\x03\x02\x02\x02\xf9\xfc\x05}>\x02\xfa\xfc\x05\x7f?\x02\xfb\xf5\x03\x02\x02\x02\xfb\xf9\x03\x02\x02\x02\xfb\xfa\x03\x02\x02\x02\xfc*\x03\x02\x02\x02\xfd\xfe\x05\xadV\x02\xfe\xff\x05\xb3Y\x02\xff\u0103\x03\x02\x02\x02\u0100\u0103\x05\x81@\x02\u0101\u0103\x05\x83A\x02\u0102\xfd\x03\x02\x02\x02\u0102\u0100\x03\x02\x02\x02\u0102\u0101\x03\x02\x02\x02\u0103";
$6632c2804e382a8c$export$375c79404cc64c7f._serializedATNSegment1 = ",\x03\x02\x02\x02\u0104\u0105\x05\xabU\x02\u0105\u0106\x05\xadV\x02\u0106\u0107\x05\xb7[\x02\u0107.\x03\x02\x02\x02\u0108\u0109\x05\x99L\x02\u0109\u010A\x05\xa9T\x02\u010A\u010B\x05\xafW\x02\u010B\u010C\x05\xb7[\x02\u010C\u010D\x05\xc1`\x02\u010D\u0114\x03\x02\x02\x02\u010E\u010F\x05\xabU\x02\u010F\u0110\x05\xb9\\\x02\u0110\u0111\x05\xa7S\x02\u0111\u0112\x05\xa7S\x02\u0112\u0114\x03\x02\x02\x02\u0113\u0108\x03\x02\x02\x02\u0113\u010E\x03\x02\x02\x02\u01140\x03\x02\x02\x02\u0115\u0116\x05\xbd^\x02\u0116\u0117\x05\x91H\x02\u0117\u0118\x05\xb5Z\x02\u01182\x03\x02\x02\x02\u0119\u011A\x05\x95J\x02\u011A\u011B\x05\x9fO\x02\u011B\u011C\x05\x91H\x02\u011C\u011D\x05\xabU\x02\u011D\u011E\x05\x9dN\x02\u011E\u011F\x05\x99L\x02\u011F\u0120\x05\x97K\x02\u01204\x03\x02\x02\x02\u0121\u0122\x05\x93I\x02\u0122\u0123\x05\x99L\x02\u0123\u0124\x05\x9bM\x02\u0124\u0125\x05\xadV\x02\u0125\u0126\x05\xb3Y\x02\u0126\u0127\x05\x99L\x02\u01276\x03\x02\x02\x02\u0128\u0129\x05\x91H\x02\u0129\u012A\x05\x9bM\x02\u012A\u012B\x05\xb7[\x02\u012B\u012C\x05\x99L\x02\u012C\u012D\x05\xb3Y\x02\u012D8\x03\x02\x02\x02\u012E\u012F\x05\x9bM\x02\u012F\u0130\x05\xb3Y\x02\u0130\u0131\x05\xadV\x02\u0131\u0132\x05\xa9T\x02\u0132:\x03\x02\x02\x02\u0133\u0134\x05\xb7[\x02\u0134\u0135\x05\xadV\x02\u0135<\x03\x02\x02\x02\u0136\u0137\x05\xadV\x02\u0137\u0138\x05\xabU\x02\u0138>\x03\x02\x02\x02\u0139\u013A\x05\x97K\x02\u013A\u013B\x05\xb9\\\x02\u013B\u013C\x05\xb3Y\x02\u013C\u013D\x05\xa1P\x02\u013D\u013E\x05\xabU\x02\u013E\u013F\x05\x9dN\x02\u013F@\x03\x02\x02\x02\u0140\u0141\x05\xadV\x02\u0141\u0142\x05\xb3Y\x02\u0142\u0143\x05\x97K\x02\u0143\u0144\x05\x99L\x02\u0144\u0145\x05\xb3Y\x02\u0145B\x03\x02\x02\x02\u0146\u0147\x05\x93I\x02\u0147\u0148\x05\xc1`\x02\u0148D\x03\x02\x02\x02\u0149\u014A\x05\x91H\x02\u014A\u014B\x05\xb5Z\x02\u014B\u014C\x05\x95J\x02\u014CF\x03\x02\x02\x02\u014D\u014E\x05\x97K\x02\u014E\u014F\x05\x99L\x02\u014F\u0150\x05\xb5Z\x02\u0150\u0151\x05\x95J\x02\u0151H\x03\x02\x02\x02\u0152\u0154\x05\x8fG\x02\u0153\u0152\x03\x02\x02\x02\u0154\u0155\x03\x02\x02\x02\u0155\u0153\x03\x02\x02\x02\u0155\u0156\x03\x02\x02\x02\u0156J\x03\x02\x02\x02\u0157\u0159\x05\x8dF\x02\u0158\u015A\x05\x8fG\x02\u0159\u0158\x03\x02\x02\x02\u015A\u015B\x03\x02\x02\x02\u015B\u0159\x03\x02\x02\x02\u015B\u015C\x03\x02\x02\x02\u015CL\x03\x02\x02\x02\u015D\u015E\x05\x95J\x02\u015E\u015F\x05\x9bM\x02\u015FN\x03\x02\x02\x02\u0160\u0161\x05\x91H\x02\u0161\u0162\x05\x93I\x02\u0162\u0163\x05\xadV\x02\u0163\u0164\x05\xb3Y\x02\u0164\u0165\x05\xb7[\x02\u0165\u0582\x03\x02\x02\x02\u0166\u0167\x05\x91H\x02\u0167\u0168\x05\x95J\x02\u0168\u0169\x05\x95J\x02\u0169\u016A\x05\x99L\x02\u016A\u016B\x05\xb5Z\x02\u016B\u016C\x05\xb5Z\x02\u016C\u0582\x03\x02\x02\x02\u016D\u016E\x05\x91H\x02\u016E\u016F\x05\x97K\x02\u016F\u0170\x05\x97K\x02\u0170\u0582\x03\x02\x02\x02\u0171\u0172\x05\x91H\x02\u0172\u0173\x05\xa7S\x02\u0173\u0174\x05\xa1P\x02\u0174\u0175\x05\x91H\x02\u0175\u0176\x05\xb5Z\x02\u0176\u0582\x03\x02\x02\x02\u0177\u0178\x05\x91H\x02\u0178\u0179\x05\xa7S\x02\u0179\u017A\x05\xb7[\x02\u017A\u017B\x05\x99L\x02\u017B\u017C\x05\xb3Y\x02\u017C\u0582\x03\x02\x02\x02\u017D\u017E\x05\x91H\x02\u017E\u017F\x05\xabU\x02\u017F\u0180\x05\xc1`\x02\u0180\u0582\x03\x02\x02\x02\u0181\u0182\x05\x91H\x02\u0182\u0183\x05\xb5Z\x02\u0183\u0582\x03\x02\x02\x02\u0184\u0185\x05\x91H\x02\u0185\u0186\x05\xb9\\\x02\u0186\u0187\x05\x97K\x02\u0187\u0188\x05\xa1P\x02\u0188\u0189\x05\xb7[\x02\u0189\u0582\x03\x02\x02\x02\u018A\u018B\x05\x91H\x02\u018B\u018C\x05\xbb]\x02\u018C\u018D\x05\x9dN\x02\u018D\u0582\x03\x02\x02\x02\u018E\u018F\x05\x93I\x02\u018F\u0190\x05\x99L\x02\u0190\u0191\x05\x9dN\x02\u0191\u0192\x05\xa1P\x02\u0192\u0193\x05\xabU\x02\u0193\u0582\x03\x02\x02\x02\u0194\u0195\x05\x93I\x02\u0195\u0196\x05\x99L\x02\u0196\u0197\x05\xb7[\x02\u0197\u0198\x05\xbd^\x02\u0198\u0199\x05\x99L\x02\u0199\u019A\x05\x99L\x02\u019A\u019B\x05\xabU\x02\u019B\u0582\x03\x02\x02\x02\u019C\u019D\x05\x93I\x02\u019D\u019E\x05\xadV\x02\u019E\u019F\x05\xadV\x02\u019F\u01A0\x05\xa7S\x02\u01A0\u01A1\x05\x99L\x02\u01A1\u01A2\x05\x91H\x02\u01A2\u01A3\x05\xabU\x02\u01A3\u0582\x03\x02\x02\x02\u01A4\u01A5\x05\x93I\x02\u01A5\u01A6\x05\xb3Y\x02\u01A6\u01A7\x05\x99L\x02\u01A7\u01A8\x05\x91H\x02\u01A8\u01A9\x05\xa5R\x02\u01A9\u0582\x03\x02\x02\x02\u01AA\u01AB\x05\x93I\x02\u01AB\u01AC\x05\xc1`\x02\u01AC\u01AD\x05\xb7[\x02\u01AD\u01AE\x05\x99L\x02\u01AE\u0582\x03\x02\x02\x02\u01AF\u01B0\x05\x95J\x02\u01B0\u01B1\x05\x91H\x02\u01B1\u01B2\x05\xb7[\x02\u01B2\u01B3\x05\x95J\x02\u01B3\u01B4\x05\x9fO\x02\u01B4\u0582\x03\x02\x02\x02\u01B5\u01B6\x05\x95J\x02\u01B6\u01B7\x05\x9fO\x02\u01B7\u01B8\x05\x91H\x02\u01B8\u01B9\x05\xb3Y\x02\u01B9\u0582\x03\x02\x02\x02\u01BA\u01BB\x05\x95J\x02\u01BB\u01BC\x05\x9fO\x02\u01BC\u01BD\x05\x91H\x02\u01BD\u01BE\x05\xb3Y\x02\u01BE\u01BF\x05\x91H\x02\u01BF\u01C0\x05\x95J\x02\u01C0\u01C1\x05\xb7[\x02\u01C1\u01C2\x05\x99L\x02\u01C2\u01C3\x05\xb3Y\x02\u01C3\u0582\x03\x02\x02\x02\u01C4\u01C5\x05\x95J\x02\u01C5\u01C6\x05\x9fO\x02\u01C6\u01C7\x05\x99L\x02\u01C7\u01C8\x05\x95J\x02\u01C8\u01C9\x05\xa5R\x02\u01C9\u0582\x03\x02\x02\x02\u01CA\u01CB\x05\x95J\x02\u01CB\u01CC\x05\x9fO\x02\u01CC\u01CD\x05\x99L\x02\u01CD\u01CE\x05\x95J\x02\u01CE\u01CF\x05\xa5R\x02\u01CF\u01D0\x05\xafW\x02\u01D0\u01D1\x05\xadV\x02\u01D1\u01D2\x05\xa1P\x02\u01D2\u01D3\x05\xabU\x02\u01D3\u01D4\x05\xb7[\x02\u01D4\u0582\x03\x02\x02\x02\u01D5\u01D6\x05\x95J\x02\u01D6\u01D7\x05\xadV\x02\u01D7\u01D8\x05\xa7S\x02\u01D8\u01D9\x05\xa7S\x02\u01D9\u01DA\x05\x91H\x02\u01DA\u01DB\x05\xb7[\x02\u01DB\u01DC\x05\x99L\x02\u01DC\u0582\x03\x02\x02\x02\u01DD\u01DE\x05\x95J\x02\u01DE\u01DF\x05\xadV\x02\u01DF\u01E0\x05\xa7S\x02\u01E0\u01E1\x05\xa7S\x02\u01E1\u01E2\x05\x91H\x02\u01E2\u01E3\x05\xb7[\x02\u01E3\u01E4\x05\xa1P\x02\u01E4\u01E5\x05\xadV\x02\u01E5\u01E6\x05\xabU\x02\u01E6\u0582\x03\x02\x02\x02\u01E7\u01E8\x05\x95J\x02\u01E8\u01E9\x05\xadV\x02\u01E9\u01EA\x05\xa7S\x02\u01EA\u01EB\x05\xb9\\\x02\u01EB\u01EC\x05\xa9T\x02\u01EC\u01ED\x05\xabU\x02\u01ED\u0582\x03\x02\x02\x02\u01EE\u01EF\x05\x95J\x02\u01EF\u01F0\x05\xadV\x02\u01F0\u01F1\x05\xa9T\x02\u01F1\u01F2\x05\xa9T\x02\u01F2\u01F3\x05\xa1P\x02\u01F3\u01F4\x05\xb7[\x02\u01F4\u0582\x03\x02\x02\x02\u01F5\u01F6\x05\x95J\x02\u01F6\u01F7\x05\xadV\x02\u01F7\u01F8\x05\xabU\x02\u01F8\u01F9\x05\xabU\x02\u01F9\u01FA\x05\x99L\x02\u01FA\u01FB\x05\x95J\x02\u01FB\u01FC\x05\xb7[\x02\u01FC\u0582\x03\x02\x02\x02\u01FD\u01FE\x05\x95J\x02\u01FE\u01FF\x05\xadV\x02\u01FF\u0200\x05\xabU\x02\u0200\u0201\x05\xb7[\x02\u0201\u0202\x05\xa1P\x02\u0202\u0203\x05\xabU\x02\u0203\u0204\x05\xb9\\\x02\u0204\u0205\x05\x99L\x02\u0205\u0582\x03\x02\x02\x02\u0206\u0207\x05\x95J\x02\u0207\u0208\x05\xadV\x02\u0208\u0209\x05\xb9\\\x02\u0209\u020A\x05\xabU\x02\u020A\u020B\x05\xb7[\x02\u020B\u0582\x03\x02\x02\x02\u020C\u020D\x05\x95J\x02\u020D\u020E\x05\xb3Y\x02\u020E\u020F\x05\x99L\x02\u020F\u0210\x05\x91H\x02\u0210\u0211\x05\xb7[\x02\u0211\u0212\x05\x99L\x02\u0212\u0582\x03\x02\x02\x02\u0213\u0214\x05\x95J\x02\u0214\u0215\x05\xb9\\\x02\u0215\u0216\x05\xb3Y\x02\u0216\u0217\x05\xb3Y\x02\u0217\u0218\x05\x99L\x02\u0218\u0219\x05\xabU\x02\u0219\u021A\x05\xb7[\x02\u021A\u0582\x03\x02\x02\x02\u021B\u021C\x05\x97K\x02\u021C\u021D\x05\x91H\x02\u021D\u021E\x05\xb7[\x02\u021E\u021F\x05\x99L\x02\u021F\u0582\x03\x02\x02\x02\u0220\u0221\x05\x97K\x02\u0221\u0222\x05\x99L\x02\u0222\u0223\x05\x95J\x02\u0223\u0224\x05\xa1P\x02\u0224\u0225\x05\xa9T\x02\u0225\u0226\x05\x91H\x02\u0226\u0227\x05\xa7S\x02\u0227\u0582\x03\x02\x02\x02\u0228\u0229\x05\x97K\x02\u0229\u022A\x05\x99L\x02\u022A\u022B\x05\x95J\x02\u022B\u022C\x05\xa7S\x02\u022C\u022D\x05\x91H\x02\u022D\u022E\x05\xb3Y\x02\u022E\u022F\x05\x99L\x02\u022F\u0582\x03\x02\x02\x02\u0230\u0231\x05\x97K\x02\u0231\u0232\x05\x99L\x02\u0232\u0233\x05\x95J\x02\u0233\u0234\x05\xb3Y\x02\u0234\u0235\x05\x99L\x02\u0235\u0236\x05\xa9T\x02\u0236\u0237\x05\x99L\x02\u0237\u0238\x05\xabU\x02\u0238\u0239\x05\xb7[\x02\u0239\u0582\x03\x02\x02\x02\u023A\u023B\x05\x97K\x02\u023B\u023C\x05\x99L\x02\u023C\u023D\x05\x9bM\x02\u023D\u023E\x05\x91H\x02\u023E\u023F\x05\xb9\\\x02\u023F\u0240\x05\xa7S\x02\u0240\u0241\x05\xb7[\x02\u0241\u0582\x03\x02\x02\x02\u0242\u0243\x05\x97K\x02\u0243\u0244\x05\x99L\x02\u0244\u0245\x05\x9bM\x02\u0245\u0246\x05\x91H\x02\u0246\u0247\x05\xb9\\\x02\u0247\u0248\x05\xa7S\x02\u0248\u0249\x05\xb7[\x02\u0249\u024A\x05\xb5Z\x02\u024A\u0582\x03\x02\x02\x02\u024B\u024C\x05\x97K\x02\u024C\u024D\x05\x99L\x02\u024D\u024E\x05\x9bM\x02\u024E\u024F\x05\xa1P\x02\u024F\u0250\x05\xabU\x02\u0250\u0251\x05\x99L\x02\u0251\u0582\x03\x02\x02\x02\u0252\u0253\x05\x97K\x02\u0253\u0254\x05\x99L\x02\u0254\u0255\x05\xa7S\x02\u0255\u0256\x05\x99L\x02\u0256\u0257\x05\xb7[\x02\u0257\u0258\x05\x99L\x02\u0258\u0582\x03\x02\x02\x02\u0259\u025A\x05\x97K\x02\u025A\u025B\x05\x99L\x02\u025B\u025C\x05\xa7S\x02\u025C\u025D\x05\xa1P\x02\u025D\u025E\x05\xa9T\x02\u025E\u025F\x05\xa1P\x02\u025F\u0260\x05\xb7[\x02\u0260\u0261\x05\x99L\x02\u0261\u0262\x05\xb3Y\x02\u0262\u0582\x03\x02\x02\x02\u0263\u0264\x05\x97K\x02\u0264\u0265\x05\xa1P\x02\u0265\u0266\x05\x9bM\x02\u0266\u0267\x05\x9bM\x02\u0267\u0268\x05\x99L\x02\u0268\u0269\x05\xb3Y\x02\u0269\u026A\x05\x99L\x02\u026A\u026B\x05\xabU\x02\u026B\u026C\x05\x95J\x02\u026C\u026D\x05\x99L\x02\u026D\u0582\x03\x02\x02\x02\u026E\u026F\x05\x97K\x02\u026F\u0270\x05\xa1P\x02\u0270\u0271\x05\xb5Z\x02\u0271\u0272\x05\xb7[\x02\u0272\u0273\x05\xa1P\x02\u0273\u0274\x05\xabU\x02\u0274\u0275\x05\x95J\x02\u0275\u0276\x05\xb7[\x02\u0276\u0582\x03\x02\x02\x02\u0277\u0278\x05\x97K\x02\u0278\u0279\x05\xa1P\x02\u0279\u027A\x05\xbb]\x02\u027A\u027B\x05\xa1P\x02\u027B\u027C\x05\x97K\x02\u027C\u027D\x05\x99L\x02\u027D\u0582\x03\x02\x02\x02\u027E\u027F\x05\x97K\x02\u027F\u0280\x05\xadV\x02\u0280\u0582\x03\x02\x02\x02\u0281\u0282\x05\x97K\x02\u0282\u0283\x05\xadV\x02\u0283\u0284\x05\xb9\\\x02\u0284\u0285\x05\x93I\x02\u0285\u0286\x05\xa7S\x02\u0286\u0287\x05\x99L\x02\u0287\u0582\x03\x02\x02\x02\u0288\u0289\x05\x97K\x02\u0289\u028A\x05\xb3Y\x02\u028A\u028B\x05\xadV\x02\u028B\u028C\x05\xafW\x02\u028C\u0582\x03\x02\x02\x02\u028D\u028E\x05\x99L\x02\u028E\u028F\x05\xa7S\x02\u028F\u0290\x05\xb5Z\x02\u0290\u0291\x05\x99L\x02\u0291\u0582\x03\x02\x02\x02\u0292\u0293\x05\x99L\x02\u0293\u0294\x05\xabU\x02\u0294\u0295\x05\x95J\x02\u0295\u0296\x05\xadV\x02\u0296\u0297\x05\x97K\x02\u0297\u0298\x05\xa1P\x02\u0298\u0299\x05\xabU\x02\u0299\u029A\x05\x9dN\x02\u029A\u0582\x03\x02\x02\x02\u029B\u029C\x05\x99L\x02\u029C\u029D\x05\xabU\x02\u029D\u029E\x05\x97K\x02\u029E\u0582\x03\x02\x02\x02\u029F\u02A0\x05\x99L\x02\u02A0\u02A1\x05\xb1X\x02\u02A1\u02A2\x05\xb9\\\x02\u02A2\u02A3\x05\x91H\x02\u02A3\u02A4\x05\xa7S\x02\u02A4\u02A5\x05\xb5Z\x02\u02A5\u0582\x03\x02\x02\x02\u02A6\u02A7\x05\x99L\x02\u02A7\u02A8\x05\xb5Z\x02\u02A8\u02A9\x05\x95J\x02\u02A9\u02AA\x05\x91H\x02\u02AA\u02AB\x05\xafW\x02\u02AB\u02AC\x05\x99L\x02\u02AC\u0582\x03\x02\x02\x02\u02AD\u02AE\x05\x99L\x02\u02AE\u02AF\x05\xbf_\x02\u02AF\u02B0\x05\x95J\x02\u02B0\u02B1\x05\xa7S\x02\u02B1\u02B2\x05\xb9\\\x02\u02B2\u02B3\x05\xb5Z\x02\u02B3\u02B4\x05\xa1P\x02\u02B4\u02B5\x05\xbb]\x02\u02B5\u02B6\x05\x99L\x02\u02B6\u0582\x03\x02\x02\x02\u02B7\u02B8\x05\x99L\x02\u02B8\u02B9\x05\xbf_\x02\u02B9\u02BA\x05\x99L\x02\u02BA\u02BB\x05\x95J\x02\u02BB\u0582\x03\x02\x02\x02\u02BC\u02BD\x05\x99L\x02\u02BD\u02BE\x05\xbf_\x02\u02BE\u02BF\x05\x99L\x02\u02BF\u02C0\x05\x95J\x02\u02C0\u02C1\x05\xb9\\\x02\u02C1\u02C2\x05\xb7[\x02\u02C2\u02C3\x05\x99L\x02\u02C3\u0582\x03\x02\x02\x02\u02C4\u02C5\x05\x99L\x02\u02C5\u02C6\x05\xbf_\x02\u02C6\u02C7\x05\xa1P\x02\u02C7\u02C8\x05\xb5Z\x02\u02C8\u02C9\x05\xb7[\x02\u02C9\u02CA\x05\xb5Z\x02\u02CA\u0582\x03\x02\x02\x02\u02CB\u02CC\x05\x99L\x02\u02CC\u02CD\x05\xbf_\x02\u02CD\u02CE\x05\xafW\x02\u02CE\u02CF\x05\xa7S\x02\u02CF\u02D0\x05\x91H\x02\u02D0\u02D1\x05\xa1P\x02\u02D1\u02D2\x05\xabU\x02\u02D2\u0582\x03\x02\x02\x02\u02D3\u02D4\x05\x9bM\x02\u02D4\u02D5\x05\x91H\x02\u02D5\u02D6\x05\xa7S\x02\u02D6\u02D7\x05\xb5Z\x02\u02D7\u02D8\x05\x99L\x02\u02D8\u0582\x03\x02\x02\x02\u02D9\u02DA\x05\x9bM\x02\u02DA\u02DB\x05\x99L\x02\u02DB\u02DC\x05\xb7[\x02\u02DC\u02DD\x05\x95J\x02\u02DD\u02DE\x05\x9fO\x02\u02DE\u0582\x03\x02\x02\x02\u02DF\u02E0\x05\x9bM\x02\u02E0\u02E1\x05\xa1P\x02\u02E1\u02E2\x05\xa7S\x02\u02E2\u02E3\x05\x99L\x02\u02E3\u0582\x03\x02\x02\x02\u02E4\u02E5\x05\x9bM\x02\u02E5\u02E6\x05\xa1P\x02\u02E6\u02E7\x05\x99L\x02\u02E7\u02E8\x05\xa7S\x02\u02E8\u02E9\x05\x97K\x02\u02E9\u0582\x03\x02\x02\x02\u02EA\u02EB\x05\x9bM\x02\u02EB\u02EC\x05\xa1P\x02\u02EC\u02ED\x05\xb3Y\x02\u02ED\u02EE\x05\xb5Z\x02\u02EE\u02EF\x05\xb7[\x02\u02EF\u0582\x03\x02\x02\x02\u02F0\u02F1\x05\x9bM\x02\u02F1\u02F2\x05\xa7S\x02\u02F2\u02F3\x05\xadV\x02\u02F3\u02F4\x05\x91H\x02\u02F4\u02F5\x05\xb7[\x02\u02F5\u0582\x03\x02\x02\x02\u02F6\u02F7\x05\x9bM\x02\u02F7\u02F8\x05\xadV\x02\u02F8\u02F9\x05\xb3Y\x02\u02F9\u0582\x03\x02\x02\x02\u02FA\u02FB\x05\x9bM\x02\u02FB\u02FC\x05\xb9\\\x02\u02FC\u02FD\x05\xabU\x02\u02FD\u02FE\x05\x95J\x02\u02FE\u02FF\x05\xb7[\x02\u02FF\u0300\x05\xa1P\x02\u0300\u0301\x05\xadV\x02\u0301\u0302\x05\xabU\x02\u0302\u0582\x03\x02\x02\x02\u0303\u0304\x05\x9dN\x02\u0304\u0305\x05\xadV\x02\u0305\u0582\x03\x02\x02\x02\u0306\u0307\x05\x9dN\x02\u0307\u0308\x05\xadV\x02\u0308\u0309\x05\xb7[\x02\u0309\u030A\x05\xadV\x02\u030A\u0582\x03\x02\x02\x02\u030B\u030C\x05\x9dN\x02\u030C\u030D\x05\xb3Y\x02\u030D\u030E\x05\x91H\x02\u030E\u030F\x05\xabU\x02\u030F\u0310\x05\xb7[\x02\u0310\u0582\x03\x02\x02\x02\u0311\u0312\x05\x9dN\x02\u0312\u0313\x05\xb3Y\x02\u0313\u0314\x05\x99L\x02\u0314\u0315\x05\x91H\x02\u0315\u0316\x05\xb7[\x02\u0316\u0317\x05\x99L\x02\u0317\u0318\x05\xb3Y\x02\u0318\u0582\x03\x02\x02\x02\u0319\u031A\x05\x9dN\x02\u031A\u031B\x05\xb3Y\x02\u031B\u031C\x05\xadV\x02\u031C\u031D\x05\xb9\\\x02\u031D\u031E\x05\xafW\x02\u031E\u0582\x03\x02\x02\x02\u031F\u0320\x05\x9fO\x02\u0320\u0321\x05\x91H\x02\u0321\u0322\x05\xbb]\x02\u0322\u0323\x05\xa1P\x02\u0323\u0324\x05\xabU\x02\u0324\u0325\x05\x9dN\x02\u0325\u0582\x03\x02\x02\x02\u0326\u0327\x05\xa1P\x02\u0327\u0328\x05\x97K\x02\u0328\u0329\x05\x99L\x02\u0329\u032A\x05\xabU\x02\u032A\u032B\x05\xb7[\x02\u032B\u032C\x05\xa1P\x02\u032C\u032D\x05\x9bM\x02\u032D\u032E\x05\xa1P\x02\u032E\u032F\x05\x99L\x02\u032F\u0330\x05\x97K\x02\u0330\u0582\x03\x02\x02\x02\u0331\u0332\x05\xa1P\x02\u0332\u0333\x05\x9bM\x02\u0333\u0582\x03\x02\x02\x02\u0334\u0335\x05\xa1P\x02\u0335\u0336\x05\xa9T\x02\u0336\u0337\x05\xa9T\x02\u0337\u0338\x05\x99L\x02\u0338\u0339\x05\x97K\x02\u0339\u033A\x05\xa1P\x02\u033A\u033B\x05\x91H\x02\u033B\u033C\x05\xb7[\x02\u033C\u033D\x05\x99L\x02\u033D\u0582\x03\x02\x02\x02\u033E\u033F\x05\xa1P\x02\u033F\u0340\x05\xabU\x02\u0340\u0341\x05\x95J\x02\u0341\u0342\x05\xb3Y\x02\u0342\u0343\x05\x99L\x02\u0343\u0344\x05\xa9T\x02\u0344\u0345\x05\x99L\x02\u0345\u0346\x05\xabU\x02\u0346\u0347\x05\xb7[\x02\u0347\u0582\x03\x02\x02\x02\u0348\u0349\x05\xa1P\x02\u0349\u034A\x05\xabU\x02\u034A\u034B\x05\x97K\x02\u034B\u034C\x05\x99L\x02\u034C\u034D\x05\xbf_\x02\u034D\u0582\x03\x02\x02\x02\u034E\u034F\x05\xa1P\x02\u034F\u0350\x05\xabU\x02\u0350\u0351\x05\xa1P\x02\u0351\u0352\x05\xb7[\x02\u0352\u0353\x05\xa1P\x02\u0353\u0354\x05\x91H\x02\u0354\u0355\x05\xa7S\x02\u0355\u0582\x03\x02\x02\x02\u0356\u0357\x05\xa1P\x02\u0357\u0358\x05\xabU\x02\u0358\u0359\x05\xabU\x02\u0359\u035A\x05\x99L\x02\u035A\u035B\x05\xb3Y\x02\u035B\u0582\x03\x02\x02\x02\u035C\u035D\x05\xa1P\x02\u035D\u035E\x05\xabU\x02\u035E\u035F\x05\xadV\x02\u035F\u0360\x05\xb9\\\x02\u0360\u0361\x05\xb7[\x02\u0361\u0582\x03\x02\x02\x02\u0362\u0363\x05\xa1P\x02\u0363\u0364\x05\xabU\x02\u0364\u0365\x05\xafW\x02\u0365\u0366\x05\xb9\\\x02\u0366\u0367\x05\xb7[\x02\u0367\u0582\x03\x02\x02\x02\u0368\u0369\x05\xa1P\x02\u0369\u036A\x05\xabU\x02\u036A\u036B\x05\xb5Z\x02\u036B\u036C\x05\x99L\x02\u036C\u036D\x05\xb3Y\x02\u036D\u036E\x05\xb7[\x02\u036E\u0582\x03\x02\x02\x02\u036F\u0370\x05\xa1P\x02\u0370\u0371\x05\xabU\x02\u0371\u0372\x05\xb7[\x02\u0372\u0582\x03\x02\x02\x02\u0373\u0374\x05\xa1P\x02\u0374\u0375\x05\xabU\x02\u0375\u0376\x05\xb7[\x02\u0376\u0377\x05\x99L\x02\u0377\u0378\x05\x9dN\x02\u0378\u0379\x05\x99L\x02\u0379\u037A\x05\xb3Y\x02\u037A\u0582\x03\x02\x02\x02\u037B\u037C\x05\xa1P\x02\u037C\u037D\x05\xabU\x02\u037D\u037E\x05\xb7[\x02\u037E\u037F\x05\x99L\x02\u037F\u0380\x05\xb3Y\x02\u0380\u0381\x05\xb5Z\x02\u0381\u0382\x05\x99L\x02\u0382\u0383\x05\x95J\x02\u0383\u0384\x05\xb7[\x02\u0384\u0582\x03\x02\x02\x02\u0385\u0386\x05\xa1P\x02\u0386\u0387\x05\xabU\x02\u0387\u0388\x05\xb7[\x02\u0388\u0389\x05\x99L\x02\u0389\u038A\x05\xb3Y\x02\u038A\u038B\x05\xb5Z\x02\u038B\u038C\x05\x99L\x02\u038C\u038D\x05\x95J\x02\u038D\u038E\x05\xb7[\x02\u038E\u038F\x05\xa1P\x02\u038F\u0390\x05\xadV\x02\u0390\u0391\x05\xabU\x02\u0391\u0582\x03\x02\x02\x02\u0392\u0393\x05\xa1P\x02\u0393\u0394\x05\xabU\x02\u0394\u0395\x05\xb7[\x02\u0395\u0396\x05\xadV\x02\u0396\u0582\x03\x02\x02\x02\u0397\u0398\x05\xa1P\x02\u0398\u0399\x05\xb5Z\x02\u0399\u039A\x05\x99L\x02\u039A\u039B\x05\xa9T\x02\u039B\u039C\x05\xafW\x02\u039C\u039D\x05\xb7[\x02\u039D\u039E\x05\xc1`\x02\u039E\u0582\x03\x02\x02\x02\u039F\u03A0\x05\xa1P\x02\u03A0\u03A1\x05\xb5Z\x02\u03A1\u03A2\x05\xabU\x02\u03A2\u03A3\x05\xb9\\\x02\u03A3\u03A4\x05\xa7S\x02\u03A4\u03A5\x05\xa7S\x02\u03A5\u0582\x03\x02\x02\x02\u03A6\u03A7\x05\xa3Q\x02\u03A7\u03A8\x05\xadV\x02\u03A8\u03A9\x05\xa1P\x02\u03A9\u03AA\x05\xabU\x02\u03AA\u0582\x03\x02\x02\x02\u03AB\u03AC\x05\xa7S\x02\u03AC\u03AD\x05\x91H\x02\u03AD\u03AE\x05\xb5Z\x02\u03AE\u03AF\x05\xb7[\x02\u03AF\u0582\x03\x02\x02\x02\u03B0\u03B1\x05\xa7S\x02\u03B1\u03B2\x05\x99L\x02\u03B2\u03B3\x05\x9bM\x02\u03B3\u03B4\x05\xb7[\x02\u03B4\u0582\x03\x02\x02\x02\u03B5\u03B6\x05\xa7S\x02\u03B6\u03B7\x05\x99L\x02\u03B7\u03B8\x05\xb5Z\x02\u03B8\u03B9\x05\xb5Z\x02\u03B9\u0582\x03\x02\x02\x02\u03BA\u03BB\x05\xa7S\x02\u03BB\u03BC\x05\xa1P\x02\u03BC\u03BD\x05\xa5R\x02\u03BD\u03BE\x05\x99L\x02\u03BE\u0582\x03\x02\x02\x02\u03BF\u03C0\x05\xa7S\x02\u03C0\u03C1\x05\xa1P\x02\u03C1\u03C2\x05\xa9T\x02\u03C2\u03C3\x05\xa1P\x02\u03C3\u03C4\x05\xb7[\x02\u03C4\u0582\x03\x02\x02\x02\u03C5\u03C6\x05\xa7S\x02\u03C6\u03C7\x05\xadV\x02\u03C7\u03C8\x05\x95J\x02\u03C8\u03C9\x05\xa5R\x02\u03C9\u0582\x03\x02\x02\x02\u03CA\u03CB\x05\xa7S\x02\u03CB\u03CC\x05\xadV\x02\u03CC\u03CD\x05\xabU\x02\u03CD\u03CE\x05\x9dN\x02\u03CE\u0582\x03\x02\x02\x02\u03CF\u03D0\x05\xa9T\x02\u03D0\u03D1\x05\x91H\x02\u03D1\u03D2\x05\xbf_\x02\u03D2\u0582\x03\x02\x02\x02\u03D3\u03D4\x05\xa9T\x02\u03D4\u03D5\x05\xa1P\x02\u03D5\u03D6\x05\xabU\x02\u03D6\u0582\x03\x02\x02\x02\u03D7\u03D8\x05\xa9T\x02\u03D8\u03D9\x05\xa1P\x02\u03D9\u03DA\x05\xabU\x02\u03DA\u03DB\x05\xb9\\\x02\u03DB\u03DC\x05\xb5Z\x02\u03DC\u0582\x03\x02\x02\x02\u03DD\u03DE\x05\xa9T\x02\u03DE\u03DF\x05\xadV\x02\u03DF\u03E0\x05\x97K\x02\u03E0\u03E1\x05\x99L\x02\u03E1\u0582\x03\x02\x02\x02\u03E2\u03E3\x05\xa9T\x02\u03E3\u03E4\x05\xadV\x02\u03E4\u03E5\x05\x97K\x02\u03E5\u03E6\x05\xa1P\x02\u03E6\u03E7\x05\x9bM\x02\u03E7\u03E8\x05\xc1`\x02\u03E8\u0582\x03\x02\x02\x02\u03E9\u03EA\x05\xa9T\x02\u03EA\u03EB\x05\xadV\x02\u03EB\u03EC\x05\x97K\x02\u03EC\u03ED\x05\xb9\\\x02\u03ED\u03EE\x05\xa7S\x02\u03EE\u03EF\x05\xadV\x02\u03EF\u0582\x03\x02\x02\x02\u03F0\u03F1\x05\xa9T\x02\u03F1\u03F2\x05\xadV\x02\u03F2\u03F3\x05\xb3Y\x02\u03F3\u03F4\x05\x99L\x02\u03F4\u0582\x03\x02\x02\x02\u03F5\u03F6\x05\xa9T\x02\u03F6\u03F7\x05\xb9\\\x02\u03F7\u03F8\x05\xa7S\x02\u03F8\u03F9\x05\xb7[\x02\u03F9\u03FA\x05\xa1P\x02\u03FA\u03FB\x05\xafW\x02\u03FB\u03FC\x05\xa7S\x02\u03FC\u03FD\x05\xc1`\x02\u03FD\u0582\x03\x02\x02\x02\u03FE\u03FF\x05\xabU\x02\u03FF\u0400\x05\x99L\x02\u0400\u0401\x05\xbf_\x02\u0401\u0402\x05\xb7[\x02\u0402\u0582\x03\x02\x02\x02\u0403\u0404\x05\xabU\x02\u0404\u0405\x05\xadV\x02\u0405\u0406\x05\x91H\x02\u0406\u0407\x05\xb9\\\x02\u0407\u0408\x05\x97K\x02\u0408\u0409\x05\xa1P\x02\u0409\u040A\x05\xb7[\x02\u040A\u0582\x03\x02\x02\x02\u040B\u040C\x05\xabU\x02\u040C\u040D\x05\xadV\x02\u040D\u040E\x05\xb7[\x02\u040E\u040F\x05\xa1P\x02\u040F\u0410\x05\xabU\x02\u0410\u0582\x03\x02\x02\x02\u0411\u0412\x05\xabU\x02\u0412\u0413\x05\xadV\x02\u0413\u0414\x05\xbd^\x02\u0414\u0415\x05\x91H\x02\u0415\u0416\x05\xa1P\x02\u0416\u0417\x05\xb7[\x02\u0417\u0582\x03\x02\x02\x02\u0418\u0419\x05\xabU\x02\u0419\u041A\x05\xb9\\\x02\u041A\u041B\x05\xa9T\x02\u041B\u041C\x05\x93I\x02\u041C\u041D\x05\x99L\x02\u041D\u041E\x05\xb3Y\x02\u041E\u0582\x03\x02\x02\x02\u041F\u0420\x05\xadV\x02\u0420\u0421\x05\x93I\x02\u0421\u0422\x05\xa3Q\x02\u0422\u0423\x05\x99L\x02\u0423\u0424\x05\x95J\x02\u0424\u0425\x05\xb7[\x02\u0425\u0582\x03\x02\x02\x02\u0426\u0427\x05\xadV\x02\u0427\u0428\x05\x9bM\x02\u0428\u0582\x03\x02\x02\x02\u0429\u042A\x05\xadV\x02\u042A\u042B\x05\xafW\x02\u042B\u042C\x05\xb7[\x02\u042C\u042D\x05\xa1P\x02\u042D\u042E\x05\xadV\x02\u042E\u042F\x05\xabU\x02\u042F\u0582\x03\x02\x02\x02\u0430\u0431\x05\xadV\x02\u0431\u0432\x05\xb9\\\x02\u0432\u0433\x05\xb7[\x02\u0433\u0434\x05\x99L\x02\u0434\u0435\x05\xb3Y\x02\u0435\u0582\x03\x02\x02\x02\u0436\u0437\x05\xadV\x02\u0437\u0438\x05\xb9\\\x02\u0438\u0439\x05\xb7[\x02\u0439\u043A\x05\xafW\x02\u043A\u043B\x05\xb9\\\x02\u043B\u043C\x05\xb7[\x02\u043C\u0582\x03\x02\x02\x02\u043D\u043E\x05\xafW\x02\u043E\u043F\x05\xadV\x02\u043F\u0440\x05\xbd^\x02\u0440\u0441\x05\x99L\x02\u0441\u0442\x05";
$6632c2804e382a8c$export$375c79404cc64c7f._serializedATNSegment2 = '\xb3Y\x02\u0442\u0582\x03\x02\x02\x02\u0443\u0444\x05\xafW\x02\u0444\u0445\x05\xb3Y\x02\u0445\u0446\x05\x99L\x02\u0446\u0447\x05\xbb]\x02\u0447\u0448\x05\xa1P\x02\u0448\u0449\x05\xadV\x02\u0449\u044A\x05\xb9\\\x02\u044A\u044B\x05\xb5Z\x02\u044B\u0582\x03\x02\x02\x02\u044C\u044D\x05\xafW\x02\u044D\u044E\x05\xb3Y\x02\u044E\u044F\x05\xa1P\x02\u044F\u0450\x05\xadV\x02\u0450\u0451\x05\xb3Y\x02\u0451\u0582\x03\x02\x02\x02\u0452\u0453\x05\xafW\x02\u0453\u0454\x05\xb3Y\x02\u0454\u0455\x05\xa1P\x02\u0455\u0456\x05\xbb]\x02\u0456\u0457\x05\xa1P\x02\u0457\u0458\x05\xa7S\x02\u0458\u0459\x05\x99L\x02\u0459\u045A\x05\x9dN\x02\u045A\u045B\x05\x99L\x02\u045B\u045C\x05\xb5Z\x02\u045C\u0582\x03\x02\x02\x02\u045D\u045E\x05\xafW\x02\u045E\u045F\x05\xb9\\\x02\u045F\u0460\x05\x93I\x02\u0460\u0461\x05\xa7S\x02\u0461\u0462\x05\xa1P\x02\u0462\u0463\x05\x95J\x02\u0463\u0582\x03\x02\x02\x02\u0464\u0465\x05\xb3Y\x02\u0465\u0466\x05\x91H\x02\u0466\u0467\x05\xa1P\x02\u0467\u0468\x05\xb5Z\x02\u0468\u0469\x05\x99L\x02\u0469\u0582\x03\x02\x02\x02\u046A\u046B\x05\xb3Y\x02\u046B\u046C\x05\x91H\x02\u046C\u046D\x05\xbd^\x02\u046D\u0582\x03\x02\x02\x02\u046E\u046F\x05\xb3Y\x02\u046F\u0470\x05\x99L\x02\u0470\u0471\x05\xa9T\x02\u0471\u0472\x05\x91H\x02\u0472\u0473\x05\xa1P\x02\u0473\u0474\x05\xabU\x02\u0474\u0475\x05\x97K\x02\u0475\u0476\x05\x99L\x02\u0476\u0477\x05\xb3Y\x02\u0477\u0582\x03\x02\x02\x02\u0478\u0479\x05\xb3Y\x02\u0479\u047A\x05\x99L\x02\u047A\u047B\x05\xabU\x02\u047B\u047C\x05\x91H\x02\u047C\u047D\x05\xa9T\x02\u047D\u047E\x05\x99L\x02\u047E\u0582\x03\x02\x02\x02\u047F\u0480\x05\xb3Y\x02\u0480\u0481\x05\x99L\x02\u0481\u0482\x05\xb5Z\x02\u0482\u0483\x05\xadV\x02\u0483\u0484\x05\xb9\\\x02\u0484\u0485\x05\xb3Y\x02\u0485\u0486\x05\x95J\x02\u0486\u0487\x05\x99L\x02\u0487\u0582\x03\x02\x02\x02\u0488\u0489\x05\xb3Y\x02\u0489\u048A\x05\x99L\x02\u048A\u048B\x05\xb7[\x02\u048B\u048C\x05\xb9\\\x02\u048C\u048D\x05\xb3Y\x02\u048D\u048E\x05\xabU\x02\u048E\u0582\x03\x02\x02\x02\u048F\u0490\x05\xb3Y\x02\u0490\u0491\x05\x99L\x02\u0491\u0492\x05\xb7[\x02\u0492\u0493\x05\xb9\\\x02\u0493\u0494\x05\xb3Y\x02\u0494\u0495\x05\xabU\x02\u0495\u0496\x05\xb5Z\x02\u0496\u0582\x03\x02\x02\x02\u0497\u0498\x05\xb3Y\x02\u0498\u0499\x05\x99L\x02\u0499\u049A\x05\xbb]\x02\u049A\u049B\x05\xadV\x02\u049B\u049C\x05\xa5R\x02\u049C\u049D\x05\x99L\x02\u049D\u0582\x03\x02\x02\x02\u049E\u049F\x05\xb3Y\x02\u049F\u04A0\x05\xa1P\x02\u04A0\u04A1\x05\x9dN\x02\u04A1\u04A2\x05\x9fO\x02\u04A2\u04A3\x05\xb7[\x02\u04A3\u0582\x03\x02\x02\x02\u04A4\u04A5\x05\xb3Y\x02\u04A5\u04A6\x05\xadV\x02\u04A6\u04A7\x05\xbd^\x02\u04A7\u0582\x03\x02\x02\x02\u04A8\u04A9\x05\xb3Y\x02\u04A9\u04AA\x05\xadV\x02\u04AA\u04AB\x05\xbd^\x02\u04AB\u04AC\x05\xa1P\x02\u04AC\u04AD\x05\x97K\x02\u04AD\u0582\x03\x02\x02\x02\u04AE\u04AF\x05\xb3Y\x02\u04AF\u04B0\x05\xadV\x02\u04B0\u04B1\x05\xbd^\x02\u04B1\u04B2\x05\xabU\x02\u04B2\u04B3\x05\xb9\\\x02\u04B3\u04B4\x05\xa9T\x02\u04B4\u0582\x03\x02\x02\x02\u04B5\u04B6\x05\xb3Y\x02\u04B6\u04B7\x05\xadV\x02\u04B7\u04B8\x05\xbd^\x02\u04B8\u04B9\x05\xb5Z\x02\u04B9\u0582\x03\x02\x02\x02\u04BA\u04BB\x05\xb5Z\x02\u04BB\u04BC\x05\x99L\x02\u04BC\u04BD\x05\xa7S\x02\u04BD\u04BE\x05\x99L\x02\u04BE\u04BF\x05\x95J\x02\u04BF\u04C0\x05\xb7[\x02\u04C0\u0582\x03\x02\x02\x02\u04C1\u04C2\x05\xb5Z\x02\u04C2\u04C3\x05\x99L\x02\u04C3\u04C4\x05\xb5Z\x02\u04C4\u04C5\x05\xb5Z\x02\u04C5\u04C6\x05\xa1P\x02\u04C6\u04C7\x05\xadV\x02\u04C7\u04C8\x05\xabU\x02\u04C8\u0582\x03\x02\x02\x02\u04C9\u04CA\x05\xb5Z\x02\u04CA\u04CB\x05\x99L\x02\u04CB\u04CC\x05\xb7[\x02\u04CC\u0582\x03\x02\x02\x02\u04CD\u04CE\x05\xb5Z\x02\u04CE\u04CF\x05\x9fO\x02\u04CF\u04D0\x05\x91H\x02\u04D0\u04D1\x05\xb3Y\x02\u04D1\u04D2\x05\x99L\x02\u04D2\u0582\x03\x02\x02\x02\u04D3\u04D4\x05\xb5Z\x02\u04D4\u04D5\x05\xa1P\x02\u04D5\u04D6\x05\xc3a\x02\u04D6\u04D7\x05\x99L\x02\u04D7\u0582\x03\x02\x02\x02\u04D8\u04D9\x05\xb5Z\x02\u04D9\u04DA\x05\xb1X\x02\u04DA\u04DB\x05\xb3Y\x02\u04DB\u04DC\x05\xb7[\x02\u04DC\u0582\x03\x02\x02\x02\u04DD\u04DE\x05\xb5Z\x02\u04DE\u04DF\x05\xb7[\x02\u04DF\u04E0\x05\x91H\x02\u04E0\u04E1\x05\xb3Y\x02\u04E1\u04E2\x05\xb7[\x02\u04E2\u0582\x03\x02\x02\x02\u04E3\u04E4\x05\xb5Z\x02\u04E4\u04E5\x05\xb7[\x02\u04E5\u04E6\x05\xb3Y\x02\u04E6\u04E7\x05\xa1P\x02\u04E7\u04E8\x05\x95J\x02\u04E8\u04E9\x05\xb7[\x02\u04E9\u0582\x03\x02\x02\x02\u04EA\u04EB\x05\xb5Z\x02\u04EB\u04EC\x05\xb7[\x02\u04EC\u04ED\x05\xb3Y\x02\u04ED\u04EE\x05\xa1P\x02\u04EE\u04EF\x05\xabU\x02\u04EF\u04F0\x05\x9dN\x02\u04F0\u0582\x03\x02\x02\x02\u04F1\u04F2\x05\xb5Z\x02\u04F2\u04F3\x05\xb9\\\x02\u04F3\u04F4\x05\x93I\x02\u04F4\u04F5\x05\xb7[\x02\u04F5\u04F6\x05\xb3Y\x02\u04F6\u04F7\x05\x91H\x02\u04F7\u04F8\x05\x95J\x02\u04F8\u04F9\x05\xb7[\x02\u04F9\u0582\x03\x02\x02\x02\u04FA\u04FB\x05\xb5Z\x02\u04FB\u04FC\x05\xb9\\\x02\u04FC\u04FD\x05\xa9T\x02\u04FD\u0582\x03\x02\x02\x02\u04FE\u04FF\x05\xb5Z\x02\u04FF\u0500\x05\xc1`\x02\u0500\u0501\x05\xabU\x02\u0501\u0502\x05\xadV\x02\u0502\u0503\x05\xabU\x02\u0503\u0504\x05\xc1`\x02\u0504\u0505\x05\xa9T\x02\u0505\u0582\x03\x02\x02\x02\u0506\u0507\x05\xb7[\x02\u0507\u0508\x05\x91H\x02\u0508\u0509\x05\x93I\x02\u0509\u050A\x05\xa7S\x02\u050A\u050B\x05\x99L\x02\u050B\u0582\x03\x02\x02\x02\u050C\u050D\x05\xb7[\x02\u050D\u050E\x05\x9fO\x02\u050E\u050F\x05\x99L\x02\u050F\u0510\x05\xabU\x02\u0510\u0582\x03\x02\x02\x02\u0511\u0512\x05\xb7[\x02\u0512\u0513\x05\xb3Y\x02\u0513\u0514\x05\x91H\x02\u0514\u0515\x05\xabU\x02\u0515\u0516\x05\xb5Z\x02\u0516\u0582\x03\x02\x02\x02\u0517\u0518\x05\xb7[\x02\u0518\u0519\x05\xb3Y\x02\u0519\u051A\x05\x91H\x02\u051A\u051B\x05\xabU\x02\u051B\u051C\x05\xb5Z\x02\u051C\u051D\x05\x91H\x02\u051D\u051E\x05\x95J\x02\u051E\u051F\x05\xb7[\x02\u051F\u0520\x05\xa1P\x02\u0520\u0521\x05\xadV\x02\u0521\u0522\x05\xabU\x02\u0522\u0582\x03\x02\x02\x02\u0523\u0524\x05\xb7[\x02\u0524\u0525\x05\xb3Y\x02\u0525\u0526\x05\xa1P\x02\u0526\u0527\x05\x9dN\x02\u0527\u0528\x05\x9dN\x02\u0528\u0529\x05\x99L\x02\u0529\u052A\x05\xb3Y\x02\u052A\u0582\x03\x02\x02\x02\u052B\u052C\x05\xb7[\x02\u052C\u052D\x05\xb3Y\x02\u052D\u052E\x05\xb9\\\x02\u052E\u052F\x05\x99L\x02\u052F\u0582\x03\x02\x02\x02\u0530\u0531\x05\xb9\\\x02\u0531\u0532\x05\xa1P\x02\u0532\u0533\x05\x97K\x02\u0533\u0582\x03\x02\x02\x02\u0534\u0535\x05\xb9\\\x02\u0535\u0536\x05\xabU\x02\u0536\u0537\x05\xa1P\x02\u0537\u0538\x05\xadV\x02\u0538\u0539\x05\xabU\x02\u0539\u0582\x03\x02\x02\x02\u053A\u053B\x05\xb9\\\x02\u053B\u053C\x05\xabU\x02\u053C\u053D\x05\xa1P\x02\u053D\u053E\x05\xb1X\x02\u053E\u053F\x05\xb9\\\x02\u053F\u0540\x05\x99L\x02\u0540\u0582\x03\x02\x02\x02\u0541\u0542\x05\xb9\\\x02\u0542\u0543\x05\xafW\x02\u0543\u0544\x05\x97K\x02\u0544\u0545\x05\x91H\x02\u0545\u0546\x05\xb7[\x02\u0546\u0547\x05\x99L\x02\u0547\u0582\x03\x02\x02\x02\u0548\u0549\x05\xb9\\\x02\u0549\u054A\x05\xb5Z\x02\u054A\u054B\x05\x99L\x02\u054B\u054C\x05\xb3Y\x02\u054C\u0582\x03\x02\x02\x02\u054D\u054E\x05\xbb]\x02\u054E\u054F\x05\x91H\x02\u054F\u0550\x05\xa7S\x02\u0550\u0551\x05\xa1P\x02\u0551\u0552\x05\x97K\x02\u0552\u0553\x05\x91H\x02\u0553\u0554\x05\xb7[\x02\u0554\u0555\x05\x99L\x02\u0555\u0582\x03\x02\x02\x02\u0556\u0557\x05\xbb]\x02\u0557\u0558\x05\x91H\x02\u0558\u0559\x05\xa7S\x02\u0559\u055A\x05\xb9\\\x02\u055A\u055B\x05\x99L\x02\u055B\u055C\x05\xb5Z\x02\u055C\u0582\x03\x02\x02\x02\u055D\u055E\x05\xbb]\x02\u055E\u055F\x05\xa1P\x02\u055F\u0560\x05\x99L\x02\u0560\u0561\x05\xbd^\x02\u0561\u0582\x03\x02\x02\x02\u0562\u0563\x05\xbd^\x02\u0563\u0564\x05\x9fO\x02\u0564\u0565\x05\x99L\x02\u0565\u0566\x05\xabU\x02\u0566\u0582\x03\x02\x02\x02\u0567\u0568\x05\xbd^\x02\u0568\u0569\x05\x9fO\x02\u0569\u056A\x05\x99L\x02\u056A\u056B\x05\xabU\x02\u056B\u056C\x05\x99L\x02\u056C\u056D\x05\xbb]\x02\u056D\u056E\x05\x99L\x02\u056E\u056F\x05\xb3Y\x02\u056F\u0582\x03\x02\x02\x02\u0570\u0571\x05\xbd^\x02\u0571\u0572\x05\x9fO\x02\u0572\u0573\x05\x99L\x02\u0573\u0574\x05\xb3Y\x02\u0574\u0575\x05\x99L\x02\u0575\u0582\x03\x02\x02\x02\u0576\u0577\x05\xbd^\x02\u0577\u0578\x05\x9fO\x02\u0578\u0579\x05\xa1P\x02\u0579\u057A\x05\xa7S\x02\u057A\u057B\x05\x99L\x02\u057B\u0582\x03\x02\x02\x02\u057C\u057D\x05\xbd^\x02\u057D\u057E\x05\xa1P\x02\u057E\u057F\x05\xb7[\x02\u057F\u0580\x05\x9fO\x02\u0580\u0582\x03\x02\x02\x02\u0581\u0160\x03\x02\x02\x02\u0581\u0166\x03\x02\x02\x02\u0581\u016D\x03\x02\x02\x02\u0581\u0171\x03\x02\x02\x02\u0581\u0177\x03\x02\x02\x02\u0581\u017D\x03\x02\x02\x02\u0581\u0181\x03\x02\x02\x02\u0581\u0184\x03\x02\x02\x02\u0581\u018A\x03\x02\x02\x02\u0581\u018E\x03\x02\x02\x02\u0581\u0194\x03\x02\x02\x02\u0581\u019C\x03\x02\x02\x02\u0581\u01A4\x03\x02\x02\x02\u0581\u01AA\x03\x02\x02\x02\u0581\u01AF\x03\x02\x02\x02\u0581\u01B5\x03\x02\x02\x02\u0581\u01BA\x03\x02\x02\x02\u0581\u01C4\x03\x02\x02\x02\u0581\u01CA\x03\x02\x02\x02\u0581\u01D5\x03\x02\x02\x02\u0581\u01DD\x03\x02\x02\x02\u0581\u01E7\x03\x02\x02\x02\u0581\u01EE\x03\x02\x02\x02\u0581\u01F5\x03\x02\x02\x02\u0581\u01FD\x03\x02\x02\x02\u0581\u0206\x03\x02\x02\x02\u0581\u020C\x03\x02\x02\x02\u0581\u0213\x03\x02\x02\x02\u0581\u021B\x03\x02\x02\x02\u0581\u0220\x03\x02\x02\x02\u0581\u0228\x03\x02\x02\x02\u0581\u0230\x03\x02\x02\x02\u0581\u023A\x03\x02\x02\x02\u0581\u0242\x03\x02\x02\x02\u0581\u024B\x03\x02\x02\x02\u0581\u0252\x03\x02\x02\x02\u0581\u0259\x03\x02\x02\x02\u0581\u0263\x03\x02\x02\x02\u0581\u026E\x03\x02\x02\x02\u0581\u0277\x03\x02\x02\x02\u0581\u027E\x03\x02\x02\x02\u0581\u0281\x03\x02\x02\x02\u0581\u0288\x03\x02\x02\x02\u0581\u028D\x03\x02\x02\x02\u0581\u0292\x03\x02\x02\x02\u0581\u029B\x03\x02\x02\x02\u0581\u029F\x03\x02\x02\x02\u0581\u02A6\x03\x02\x02\x02\u0581\u02AD\x03\x02\x02\x02\u0581\u02B7\x03\x02\x02\x02\u0581\u02BC\x03\x02\x02\x02\u0581\u02C4\x03\x02\x02\x02\u0581\u02CB\x03\x02\x02\x02\u0581\u02D3\x03\x02\x02\x02\u0581\u02D9\x03\x02\x02\x02\u0581\u02DF\x03\x02\x02\x02\u0581\u02E4\x03\x02\x02\x02\u0581\u02EA\x03\x02\x02\x02\u0581\u02F0\x03\x02\x02\x02\u0581\u02F6\x03\x02\x02\x02\u0581\u02FA\x03\x02\x02\x02\u0581\u0303\x03\x02\x02\x02\u0581\u0306\x03\x02\x02\x02\u0581\u030B\x03\x02\x02\x02\u0581\u0311\x03\x02\x02\x02\u0581\u0319\x03\x02\x02\x02\u0581\u031F\x03\x02\x02\x02\u0581\u0326\x03\x02\x02\x02\u0581\u0331\x03\x02\x02\x02\u0581\u0334\x03\x02\x02\x02\u0581\u033E\x03\x02\x02\x02\u0581\u0348\x03\x02\x02\x02\u0581\u034E\x03\x02\x02\x02\u0581\u0356\x03\x02\x02\x02\u0581\u035C\x03\x02\x02\x02\u0581\u0362\x03\x02\x02\x02\u0581\u0368\x03\x02\x02\x02\u0581\u036F\x03\x02\x02\x02\u0581\u0373\x03\x02\x02\x02\u0581\u037B\x03\x02\x02\x02\u0581\u0385\x03\x02\x02\x02\u0581\u0392\x03\x02\x02\x02\u0581\u0397\x03\x02\x02\x02\u0581\u039F\x03\x02\x02\x02\u0581\u03A6\x03\x02\x02\x02\u0581\u03AB\x03\x02\x02\x02\u0581\u03B0\x03\x02\x02\x02\u0581\u03B5\x03\x02\x02\x02\u0581\u03BA\x03\x02\x02\x02\u0581\u03BF\x03\x02\x02\x02\u0581\u03C5\x03\x02\x02\x02\u0581\u03CA\x03\x02\x02\x02\u0581\u03CF\x03\x02\x02\x02\u0581\u03D3\x03\x02\x02\x02\u0581\u03D7\x03\x02\x02\x02\u0581\u03DD\x03\x02\x02\x02\u0581\u03E2\x03\x02\x02\x02\u0581\u03E9\x03\x02\x02\x02\u0581\u03F0\x03\x02\x02\x02\u0581\u03F5\x03\x02\x02\x02\u0581\u03FE\x03\x02\x02\x02\u0581\u0403\x03\x02\x02\x02\u0581\u040B\x03\x02\x02\x02\u0581\u0411\x03\x02\x02\x02\u0581\u0418\x03\x02\x02\x02\u0581\u041F\x03\x02\x02\x02\u0581\u0426\x03\x02\x02\x02\u0581\u0429\x03\x02\x02\x02\u0581\u0430\x03\x02\x02\x02\u0581\u0436\x03\x02\x02\x02\u0581\u043D\x03\x02\x02\x02\u0581\u0443\x03\x02\x02\x02\u0581\u044C\x03\x02\x02\x02\u0581\u0452\x03\x02\x02\x02\u0581\u045D\x03\x02\x02\x02\u0581\u0464\x03\x02\x02\x02\u0581\u046A\x03\x02\x02\x02\u0581\u046E\x03\x02\x02\x02\u0581\u0478\x03\x02\x02\x02\u0581\u047F\x03\x02\x02\x02\u0581\u0488\x03\x02\x02\x02\u0581\u048F\x03\x02\x02\x02\u0581\u0497\x03\x02\x02\x02\u0581\u049E\x03\x02\x02\x02\u0581\u04A4\x03\x02\x02\x02\u0581\u04A8\x03\x02\x02\x02\u0581\u04AE\x03\x02\x02\x02\u0581\u04B5\x03\x02\x02\x02\u0581\u04BA\x03\x02\x02\x02\u0581\u04C1\x03\x02\x02\x02\u0581\u04C9\x03\x02\x02\x02\u0581\u04CD\x03\x02\x02\x02\u0581\u04D3\x03\x02\x02\x02\u0581\u04D8\x03\x02\x02\x02\u0581\u04DD\x03\x02\x02\x02\u0581\u04E3\x03\x02\x02\x02\u0581\u04EA\x03\x02\x02\x02\u0581\u04F1\x03\x02\x02\x02\u0581\u04FA\x03\x02\x02\x02\u0581\u04FE\x03\x02\x02\x02\u0581\u0506\x03\x02\x02\x02\u0581\u050C\x03\x02\x02\x02\u0581\u0511\x03\x02\x02\x02\u0581\u0517\x03\x02\x02\x02\u0581\u0523\x03\x02\x02\x02\u0581\u052B\x03\x02\x02\x02\u0581\u0530\x03\x02\x02\x02\u0581\u0534\x03\x02\x02\x02\u0581\u053A\x03\x02\x02\x02\u0581\u0541\x03\x02\x02\x02\u0581\u0548\x03\x02\x02\x02\u0581\u054D\x03\x02\x02\x02\u0581\u0556\x03\x02\x02\x02\u0581\u055D\x03\x02\x02\x02\u0581\u0562\x03\x02\x02\x02\u0581\u0567\x03\x02\x02\x02\u0581\u0570\x03\x02\x02\x02\u0581\u0576\x03\x02\x02\x02\u0581\u057C\x03\x02\x02\x02\u0582P\x03\x02\x02\x02\u0583\u0586\x05\x85B\x02\u0584\u0586\x05i4\x02\u0585\u0583\x03\x02\x02\x02\u0585\u0584\x03\x02\x02\x02\u0586\u0587\x03\x02\x02\x02\u0587\u0585\x03\x02\x02\x02\u0587\u0588\x03\x02\x02\x02\u0588R\x03\x02\x02\x02\u0589\u058B\x05\x8bE\x02\u058A\u0589\x03\x02\x02\x02\u058B\u058C\x03\x02\x02\x02\u058C\u058A\x03\x02\x02\x02\u058C\u058D\x03\x02\x02\x02\u058D\u058E\x03\x02\x02\x02\u058E\u058F\b)\x05\x02\u058FT\x03\x02\x02\x02\u0590\u0591\x05o7\x02\u0591V\x03\x02\x02\x02\u0592\u0593\v\x02\x02\x02\u0593X\x03\x02\x02\x02\u0594\u0595\x05q8\x02\u0595\u0596\x03\x02\x02\x02\u0596\u0597\b,\x06\x02\u0597Z\x03\x02\x02\x02\u0598\u059B\x05\x85B\x02\u0599\u059B\x05k5\x02\u059A\u0598\x03\x02\x02\x02\u059A\u0599\x03\x02\x02\x02\u059B\u059C\x03\x02\x02\x02\u059C\u059D\b-\x02\x02\u059D\\\x03\x02\x02\x02\u059E\u059F\x07\x02\x02\x03\u059F\u05A0\x03\x02\x02\x02\u05A0\u05A1\b.\x06\x02\u05A1^\x03\x02\x02\x02\u05A2\u05A3\v\x02\x02\x02\u05A3\u05A4\x03\x02\x02\x02\u05A4\u05A5\b/\x06\x02\u05A5`\x03\x02\x02\x02\u05A6\u05A7\x05s9\x02\u05A7\u05A8\x03\x02\x02\x02\u05A8\u05A9\b0\x06\x02\u05A9b\x03\x02\x02\x02\u05AA\u05AD\x05\x85B\x02\u05AB\u05AD\x05m6\x02\u05AC\u05AA\x03\x02\x02\x02\u05AC\u05AB\x03\x02\x02\x02\u05AD\u05AE\x03\x02\x02\x02\u05AE\u05AF\b1\x02\x02\u05AFd\x03\x02\x02\x02\u05B0\u05B1\x07\x02\x02\x03\u05B1\u05B2\x03\x02\x02\x02\u05B2\u05B3\b2\x06\x02\u05B3f\x03\x02\x02\x02\u05B4\u05B5\v\x02\x02\x02\u05B5\u05B6\x03\x02\x02\x02\u05B6\u05B7\b3\x06\x02\u05B7h\x03\x02\x02\x02\u05B8\u05B9\n\x02\x02\x02\u05B9j\x03\x02\x02\x02\u05BA\u05BB\n\x03\x02\x02\u05BBl\x03\x02\x02\x02\u05BC\u05BD\n\x04\x02\x02\u05BDn\x03\x02\x02\x02\u05BE\u05BF	\x05\x02\x02\u05BFp\x03\x02\x02\x02\u05C0\u05C1\x07$\x02\x02\u05C1r\x03\x02\x02\x02\u05C2\u05C3\x07)\x02\x02\u05C3t\x03\x02\x02\x02\u05C4\u05C5\x07^\x02\x02\u05C5v\x03\x02\x02\x02\u05C6\u05C7\x07\x0f\x02\x02\u05C7x\x03\x02\x02\x02\u05C8\u05C9\x07\f\x02\x02\u05C9z\x03\x02\x02\x02\u05CA\u05CB\x07"\x02\x02\u05CB|\x03\x02\x02\x02\u05CC\u05CD\x07(\x02\x02\u05CD~\x03\x02\x02\x02\u05CE\u05CF\x07(\x02\x02\u05CF\u05D0\x07(\x02\x02\u05D0\x80\x03\x02\x02\x02\u05D1\u05D2\x07~\x02\x02\u05D2\x82\x03\x02\x02\x02\u05D3\u05D4\x07~\x02\x02\u05D4\u05D5\x07~\x02\x02\u05D5\x84\x03\x02\x02\x02\u05D6\u05E2\x05u:\x02\u05D7\u05E3	\x06\x02\x02\u05D8\u05E3\x05q8\x02\u05D9\u05E3\x05s9\x02\u05DA\u05E3\x05u:\x02\u05DB\u05E3\x05{=\x02\u05DC\u05DD\x07w\x02\x02\u05DD\u05DE\x05\x89D\x02\u05DE\u05DF\x05\x89D\x02\u05DF\u05E0\x05\x89D\x02\u05E0\u05E1\x05\x89D\x02\u05E1\u05E3\x03\x02\x02\x02\u05E2\u05D7\x03\x02\x02\x02\u05E2\u05D8\x03\x02\x02\x02\u05E2\u05D9\x03\x02\x02\x02\u05E2\u05DA\x03\x02\x02\x02\u05E2\u05DB\x03\x02\x02\x02\u05E2\u05DC\x03\x02\x02\x02\u05E3\x86\x03\x02\x02\x02\u05E4\u05E7\x05w;\x02\u05E5\u05E7\x05y<\x02\u05E6\u05E4\x03\x02\x02\x02\u05E6\u05E5\x03\x02\x02\x02\u05E7\x88\x03\x02\x02\x02\u05E8\u05F0\x05\x8fG\x02\u05E9\u05F0\x05\x91H\x02\u05EA\u05F0\x05\x93I\x02\u05EB\u05F0\x05\x95J\x02\u05EC\u05F0\x05\x97K\x02\u05ED\u05F0\x05\x99L\x02\u05EE\u05F0\x05\x9bM\x02\u05EF\u05E8\x03\x02\x02\x02\u05EF\u05E9\x03\x02\x02\x02\u05EF\u05EA\x03\x02\x02\x02\u05EF\u05EB\x03\x02\x02\x02\u05EF\u05EC\x03\x02\x02\x02\u05EF\u05ED\x03\x02\x02\x02\u05EF\u05EE\x03\x02\x02\x02\u05F0\x8a\x03\x02\x02\x02\u05F1\u05F5\x05{=\x02\u05F2\u05F5\x07\v\x02\x02\u05F3\u05F5\x05\x87C\x02\u05F4\u05F1\x03\x02\x02\x02\u05F4\u05F2\x03\x02\x02\x02\u05F4\u05F3\x03\x02\x02\x02\u05F5\x8c\x03\x02\x02\x02\u05F6\u05F7\x07/\x02\x02\u05F7\x8e\x03\x02\x02\x02\u05F8\u05F9	\x07\x02\x02\u05F9\x90\x03\x02\x02\x02\u05FA\u05FB	\b\x02\x02\u05FB\x92\x03\x02\x02\x02\u05FC\u05FD		\x02\x02\u05FD\x94\x03\x02\x02\x02\u05FE\u05FF	\n\x02\x02\u05FF\x96\x03\x02\x02\x02\u0600\u0601	\v\x02\x02\u0601\x98\x03\x02\x02\x02\u0602\u0603	\f\x02\x02\u0603\x9a\x03\x02\x02\x02\u0604\u0605	\r\x02\x02\u0605\x9c\x03\x02\x02\x02\u0606\u0607	\x0e\x02\x02\u0607\x9e\x03\x02\x02\x02\u0608\u0609	\x0f\x02\x02\u0609\xa0\x03\x02\x02\x02\u060A\u060B	\x10\x02\x02\u060B\xa2\x03\x02\x02\x02\u060C\u060D	\x11\x02\x02\u060D\xa4\x03\x02\x02\x02\u060E\u060F	\x12\x02\x02\u060F\xa6\x03\x02\x02\x02\u0610\u0611	\x13\x02\x02\u0611\xa8\x03\x02\x02\x02\u0612\u0613	\x14\x02\x02\u0613\xaa\x03\x02\x02\x02\u0614\u0615	\x15\x02\x02\u0615\xac\x03\x02\x02\x02\u0616\u0617	\x16\x02\x02\u0617\xae\x03\x02\x02\x02\u0618\u0619	\x17\x02\x02\u0619\xb0\x03\x02\x02\x02\u061A\u061B	\x18\x02\x02\u061B\xb2\x03\x02\x02\x02\u061C\u061D	\x19\x02\x02\u061D\xb4\x03\x02\x02\x02\u061E\u061F	\x1a\x02\x02\u061F\xb6\x03\x02\x02\x02\u0620\u0621	\x1b\x02\x02\u0621\xb8\x03\x02\x02\x02\u0622\u0623	\x1c\x02\x02\u0623\xba\x03\x02\x02\x02\u0624\u0625	\x1d\x02\x02\u0625\xbc\x03\x02\x02\x02\u0626\u0627	\x1e\x02\x02\u0627\xbe\x03\x02\x02\x02\u0628\u0629	\x1f\x02\x02\u0629\xc0\x03\x02\x02\x02\u062A\u062B	 \x02\x02\u062B\xc2\x03\x02\x02\x02\u062C\u062D	!\x02\x02\u062D\xc4\x03\x02\x02\x02\x14\x02\x03\x04\xfb\u0102\u0113\u0155\u015B\u0581\u0585\u0587\u058C\u059A\u05AC\u05E2\u05E6\u05EF\u05F4\x07\x05\x02\x02\x04\x03\x02\x04\x04\x02\x02\x03\x02\x04\x02\x02';
$6632c2804e382a8c$export$375c79404cc64c7f._serializedATN = $3jpAZ.join([
    $6632c2804e382a8c$var$_JQLLexer._serializedATNSegment0,
    $6632c2804e382a8c$var$_JQLLexer._serializedATNSegment1,
    $6632c2804e382a8c$var$_JQLLexer._serializedATNSegment2
], '');
$6632c2804e382a8c$export$375c79404cc64c7f.__ATN = void 0;
module.exports["JQLLexer"] = $6632c2804e382a8c$export$375c79404cc64c7f;

});

parcelRegister("56ams", function(module, exports) {

var $lso6d = parcelRequire("lso6d");


var $gm3rl = parcelRequire("gm3rl");


var $5XMF6 = parcelRequire("5XMF6");


var $5izRN = parcelRequire("5izRN");


var $lORdS = parcelRequire("lORdS");


var $beMqO = parcelRequire("beMqO");


var $TNDGs = parcelRequire("TNDGs");


var $56U0W = parcelRequire("56U0W");


var $3jpAZ = parcelRequire("3jpAZ");

var $6551c3dece3fff4e$var$_JQLParser;
class $6551c3dece3fff4e$export$9c4772e191bdb810 extends (0, $5XMF6.Parser) {
    // @Override
    // @NotNull
    get vocabulary() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.VOCABULARY;
    }
    // tslint:enable:no-trailing-whitespace
    // @Override
    get grammarFileName() {
        return 'JQLParser.g4';
    }
    // @Override
    get ruleNames() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.ruleNames;
    }
    // @Override
    get serializedATN() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810._serializedATN;
    }
    // @RuleVersion(0)
    jqlQuery() {
        let _localctx = new $6551c3dece3fff4e$export$ff413535b9575c8(this._ctx, this.state);
        this.enterRule(_localctx, 0, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlQuery);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 83;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if ((_la & -32) === 0 && (1 << _la & (1 << $6551c3dece3fff4e$export$9c4772e191bdb810.LPAREN | 1 << $6551c3dece3fff4e$export$9c4772e191bdb810.BANG | 1 << $6551c3dece3fff4e$export$9c4772e191bdb810.NOT)) !== 0 || (_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $6551c3dece3fff4e$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $6551c3dece3fff4e$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $6551c3dece3fff4e$export$9c4772e191bdb810.CUSTOMFIELD - 33 | 1 << $6551c3dece3fff4e$export$9c4772e191bdb810.STRING - 33 | 1 << $6551c3dece3fff4e$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $6551c3dece3fff4e$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0) {
                this.state = 82;
                this.jqlWhere();
            }
            this.state = 86;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if (_la === $6551c3dece3fff4e$export$9c4772e191bdb810.ORDER) {
                this.state = 85;
                this.jqlOrderBy();
            }
            this.state = 88;
            this.match($6551c3dece3fff4e$export$9c4772e191bdb810.EOF);
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWhere() {
        let _localctx = new $6551c3dece3fff4e$export$4148a879cab28017(this._ctx, this.state);
        this.enterRule(_localctx, 2, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlWhere);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 90;
            this.jqlOrClause();
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlOrClause() {
        let _localctx = new $6551c3dece3fff4e$export$d69831d387793480(this._ctx, this.state);
        this.enterRule(_localctx, 4, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlOrClause);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 92;
            this.jqlAndClause();
            this.state = 97;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $6551c3dece3fff4e$export$9c4772e191bdb810.OR){
                this.state = 93;
                this.match($6551c3dece3fff4e$export$9c4772e191bdb810.OR);
                this.state = 94;
                this.jqlAndClause();
                this.state = 99;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlAndClause() {
        let _localctx = new $6551c3dece3fff4e$export$f16819001158b9e(this._ctx, this.state);
        this.enterRule(_localctx, 6, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlAndClause);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 100;
            this.jqlNotClause();
            this.state = 105;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $6551c3dece3fff4e$export$9c4772e191bdb810.AND){
                this.state = 101;
                this.match($6551c3dece3fff4e$export$9c4772e191bdb810.AND);
                this.state = 102;
                this.jqlNotClause();
                this.state = 107;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlNotClause() {
        let _localctx = new $6551c3dece3fff4e$export$5e9146f8d5cf1330(this._ctx, this.state);
        this.enterRule(_localctx, 8, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlNotClause);
        let _la;
        try {
            this.state = 112;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $6551c3dece3fff4e$export$9c4772e191bdb810.BANG:
                case $6551c3dece3fff4e$export$9c4772e191bdb810.NOT:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 108;
                    _la = this._input.LA(1);
                    if (!(_la === $6551c3dece3fff4e$export$9c4772e191bdb810.BANG || _la === $6551c3dece3fff4e$export$9c4772e191bdb810.NOT)) this._errHandler.recoverInline(this);
                    else {
                        if (this._input.LA(1) === (0, $TNDGs.Token).EOF) this.matchedEOF = true;
                        this._errHandler.reportMatch(this);
                        this.consume();
                    }
                    this.state = 109;
                    this.jqlNotClause();
                    break;
                case $6551c3dece3fff4e$export$9c4772e191bdb810.LPAREN:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 110;
                    this.jqlSubClause();
                    break;
                case $6551c3dece3fff4e$export$9c4772e191bdb810.POSNUMBER:
                case $6551c3dece3fff4e$export$9c4772e191bdb810.NEGNUMBER:
                case $6551c3dece3fff4e$export$9c4772e191bdb810.CUSTOMFIELD:
                case $6551c3dece3fff4e$export$9c4772e191bdb810.STRING:
                case $6551c3dece3fff4e$export$9c4772e191bdb810.QUOTE_STRING:
                case $6551c3dece3fff4e$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 3);
                    this.state = 111;
                    this.jqlTerminalClause();
                    break;
                default:
                    throw new (0, $gm3rl.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlSubClause() {
        let _localctx = new $6551c3dece3fff4e$export$a136a0e9655bfb04(this._ctx, this.state);
        this.enterRule(_localctx, 10, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlSubClause);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 114;
            this.match($6551c3dece3fff4e$export$9c4772e191bdb810.LPAREN);
            this.state = 115;
            this.jqlOrClause();
            this.state = 116;
            this.match($6551c3dece3fff4e$export$9c4772e191bdb810.RPAREN);
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlTerminalClause() {
        let _localctx = new $6551c3dece3fff4e$export$23486a2f2ddd5bcd(this._ctx, this.state);
        this.enterRule(_localctx, 12, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlTerminalClause);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 118;
            this.jqlField();
            this.state = 119;
            this.jqlTerminalClauseRhs();
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlTerminalClauseRhs() {
        let _localctx = new $6551c3dece3fff4e$export$93924a205c12d32c(this._ctx, this.state);
        this.enterRule(_localctx, 14, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlTerminalClauseRhs);
        let _la;
        try {
            this.state = 176;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 14, this._ctx)){
                case 1:
                    _localctx = new $6551c3dece3fff4e$export$c428f709a58396e5(_localctx);
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 121;
                    this.jqlEqualsOperator();
                    this.state = 125;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 5, this._ctx)){
                        case 1:
                            this.state = 122;
                            this.jqlEmpty();
                            break;
                        case 2:
                            this.state = 123;
                            this.jqlValue();
                            break;
                        case 3:
                            this.state = 124;
                            this.jqlFunction();
                            break;
                    }
                    break;
                case 2:
                    _localctx = new $6551c3dece3fff4e$export$1b131204ef9fa33d(_localctx);
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 127;
                    this.jqlLikeOperator();
                    this.state = 131;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 6, this._ctx)){
                        case 1:
                            this.state = 128;
                            this.jqlEmpty();
                            break;
                        case 2:
                            this.state = 129;
                            this.jqlValue();
                            break;
                        case 3:
                            this.state = 130;
                            this.jqlFunction();
                            break;
                    }
                    break;
                case 3:
                    _localctx = new $6551c3dece3fff4e$export$d83706ee80a9852a(_localctx);
                    this.enterOuterAlt(_localctx, 3);
                    this.state = 133;
                    this.jqlComparisonOperator();
                    this.state = 136;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 7, this._ctx)){
                        case 1:
                            this.state = 134;
                            this.jqlValue();
                            break;
                        case 2:
                            this.state = 135;
                            this.jqlFunction();
                            break;
                    }
                    break;
                case 4:
                    _localctx = new $6551c3dece3fff4e$export$2934b8ff22fddd2d(_localctx);
                    this.enterOuterAlt(_localctx, 4);
                    this.state = 138;
                    this.jqlInOperator();
                    this.state = 141;
                    this._errHandler.sync(this);
                    switch(this._input.LA(1)){
                        case $6551c3dece3fff4e$export$9c4772e191bdb810.LPAREN:
                            this.state = 139;
                            this.jqlList();
                            break;
                        case $6551c3dece3fff4e$export$9c4772e191bdb810.POSNUMBER:
                        case $6551c3dece3fff4e$export$9c4772e191bdb810.NEGNUMBER:
                        case $6551c3dece3fff4e$export$9c4772e191bdb810.STRING:
                        case $6551c3dece3fff4e$export$9c4772e191bdb810.QUOTE_STRING:
                        case $6551c3dece3fff4e$export$9c4772e191bdb810.SQUOTE_STRING:
                            this.state = 140;
                            this.jqlFunction();
                            break;
                        default:
                            throw new (0, $gm3rl.NoViableAltException)(this);
                    }
                    break;
                case 5:
                    _localctx = new $6551c3dece3fff4e$export$8b84310182afcf93(_localctx);
                    this.enterOuterAlt(_localctx, 5);
                    this.state = 143;
                    this.jqlIsOperator();
                    this.state = 144;
                    this.jqlEmpty();
                    break;
                case 6:
                    _localctx = new $6551c3dece3fff4e$export$5df295dc7a2cac7c(_localctx);
                    this.enterOuterAlt(_localctx, 6);
                    this.state = 146;
                    this.jqlWasOperator();
                    this.state = 150;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 9, this._ctx)){
                        case 1:
                            this.state = 147;
                            this.jqlEmpty();
                            break;
                        case 2:
                            this.state = 148;
                            this.jqlValue();
                            break;
                        case 3:
                            this.state = 149;
                            this.jqlFunction();
                            break;
                    }
                    this.state = 155;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while((_la & -32) === 0 && (1 << _la & (1 << $6551c3dece3fff4e$export$9c4772e191bdb810.BEFORE | 1 << $6551c3dece3fff4e$export$9c4772e191bdb810.AFTER | 1 << $6551c3dece3fff4e$export$9c4772e191bdb810.ON | 1 << $6551c3dece3fff4e$export$9c4772e191bdb810.DURING | 1 << $6551c3dece3fff4e$export$9c4772e191bdb810.BY)) !== 0){
                        this.state = 152;
                        this.jqlWasPredicate();
                        this.state = 157;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
                case 7:
                    _localctx = new $6551c3dece3fff4e$export$9ac3367aee261b32(_localctx);
                    this.enterOuterAlt(_localctx, 7);
                    this.state = 158;
                    this.jqlWasInOperator();
                    this.state = 161;
                    this._errHandler.sync(this);
                    switch(this._input.LA(1)){
                        case $6551c3dece3fff4e$export$9c4772e191bdb810.LPAREN:
                            this.state = 159;
                            this.jqlList();
                            break;
                        case $6551c3dece3fff4e$export$9c4772e191bdb810.POSNUMBER:
                        case $6551c3dece3fff4e$export$9c4772e191bdb810.NEGNUMBER:
                        case $6551c3dece3fff4e$export$9c4772e191bdb810.STRING:
                        case $6551c3dece3fff4e$export$9c4772e191bdb810.QUOTE_STRING:
                        case $6551c3dece3fff4e$export$9c4772e191bdb810.SQUOTE_STRING:
                            this.state = 160;
                            this.jqlFunction();
                            break;
                        default:
                            throw new (0, $gm3rl.NoViableAltException)(this);
                    }
                    this.state = 166;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while((_la & -32) === 0 && (1 << _la & (1 << $6551c3dece3fff4e$export$9c4772e191bdb810.BEFORE | 1 << $6551c3dece3fff4e$export$9c4772e191bdb810.AFTER | 1 << $6551c3dece3fff4e$export$9c4772e191bdb810.ON | 1 << $6551c3dece3fff4e$export$9c4772e191bdb810.DURING | 1 << $6551c3dece3fff4e$export$9c4772e191bdb810.BY)) !== 0){
                        this.state = 163;
                        this.jqlWasPredicate();
                        this.state = 168;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
                case 8:
                    _localctx = new $6551c3dece3fff4e$export$7a7defca8628a13c(_localctx);
                    this.enterOuterAlt(_localctx, 8);
                    this.state = 169;
                    this.jqlChangedOperator();
                    this.state = 173;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while((_la & -32) === 0 && (1 << _la & (1 << $6551c3dece3fff4e$export$9c4772e191bdb810.BEFORE | 1 << $6551c3dece3fff4e$export$9c4772e191bdb810.AFTER | 1 << $6551c3dece3fff4e$export$9c4772e191bdb810.FROM | 1 << $6551c3dece3fff4e$export$9c4772e191bdb810.TO | 1 << $6551c3dece3fff4e$export$9c4772e191bdb810.ON | 1 << $6551c3dece3fff4e$export$9c4772e191bdb810.DURING | 1 << $6551c3dece3fff4e$export$9c4772e191bdb810.BY)) !== 0){
                        this.state = 170;
                        this.jqlChangedPredicate();
                        this.state = 175;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlEqualsOperator() {
        let _localctx = new $6551c3dece3fff4e$export$41e475fc1988e413(this._ctx, this.state);
        this.enterRule(_localctx, 16, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlEqualsOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 178;
            _la = this._input.LA(1);
            if (!(_la === $6551c3dece3fff4e$export$9c4772e191bdb810.EQUALS || _la === $6551c3dece3fff4e$export$9c4772e191bdb810.NOT_EQUALS)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $TNDGs.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlLikeOperator() {
        let _localctx = new $6551c3dece3fff4e$export$b76fe5387fdd7efd(this._ctx, this.state);
        this.enterRule(_localctx, 18, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlLikeOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 180;
            _la = this._input.LA(1);
            if (!(_la === $6551c3dece3fff4e$export$9c4772e191bdb810.LIKE || _la === $6551c3dece3fff4e$export$9c4772e191bdb810.NOT_LIKE)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $TNDGs.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlComparisonOperator() {
        let _localctx = new $6551c3dece3fff4e$export$d821da0716b3ec95(this._ctx, this.state);
        this.enterRule(_localctx, 20, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlComparisonOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 182;
            _la = this._input.LA(1);
            if (!((_la & -32) === 0 && (1 << _la & (1 << $6551c3dece3fff4e$export$9c4772e191bdb810.LT | 1 << $6551c3dece3fff4e$export$9c4772e191bdb810.GT | 1 << $6551c3dece3fff4e$export$9c4772e191bdb810.GTEQ | 1 << $6551c3dece3fff4e$export$9c4772e191bdb810.LTEQ)) !== 0)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $TNDGs.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlInOperator() {
        let _localctx = new $6551c3dece3fff4e$export$178478bfa8292f72(this._ctx, this.state);
        this.enterRule(_localctx, 22, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlInOperator);
        try {
            this.state = 187;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $6551c3dece3fff4e$export$9c4772e191bdb810.IN:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 184;
                    this.match($6551c3dece3fff4e$export$9c4772e191bdb810.IN);
                    break;
                case $6551c3dece3fff4e$export$9c4772e191bdb810.NOT:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 185;
                    this.match($6551c3dece3fff4e$export$9c4772e191bdb810.NOT);
                    this.state = 186;
                    this.match($6551c3dece3fff4e$export$9c4772e191bdb810.IN);
                    break;
                default:
                    throw new (0, $gm3rl.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlIsOperator() {
        let _localctx = new $6551c3dece3fff4e$export$e64c31d2830b66e4(this._ctx, this.state);
        this.enterRule(_localctx, 24, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlIsOperator);
        try {
            this.state = 192;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 16, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 189;
                    this.match($6551c3dece3fff4e$export$9c4772e191bdb810.IS);
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 190;
                    this.match($6551c3dece3fff4e$export$9c4772e191bdb810.IS);
                    this.state = 191;
                    this.match($6551c3dece3fff4e$export$9c4772e191bdb810.NOT);
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWasOperator() {
        let _localctx = new $6551c3dece3fff4e$export$7e283636700e4a6c(this._ctx, this.state);
        this.enterRule(_localctx, 26, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlWasOperator);
        try {
            this.state = 197;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 17, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 194;
                    this.match($6551c3dece3fff4e$export$9c4772e191bdb810.WAS);
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 195;
                    this.match($6551c3dece3fff4e$export$9c4772e191bdb810.WAS);
                    this.state = 196;
                    this.match($6551c3dece3fff4e$export$9c4772e191bdb810.NOT);
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWasInOperator() {
        let _localctx = new $6551c3dece3fff4e$export$b9118b1ed9a78d66(this._ctx, this.state);
        this.enterRule(_localctx, 28, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlWasInOperator);
        try {
            this.state = 204;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 18, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 199;
                    this.match($6551c3dece3fff4e$export$9c4772e191bdb810.WAS);
                    this.state = 200;
                    this.match($6551c3dece3fff4e$export$9c4772e191bdb810.IN);
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 201;
                    this.match($6551c3dece3fff4e$export$9c4772e191bdb810.WAS);
                    this.state = 202;
                    this.match($6551c3dece3fff4e$export$9c4772e191bdb810.NOT);
                    this.state = 203;
                    this.match($6551c3dece3fff4e$export$9c4772e191bdb810.IN);
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlChangedOperator() {
        let _localctx = new $6551c3dece3fff4e$export$493d626ed78ca66(this._ctx, this.state);
        this.enterRule(_localctx, 30, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlChangedOperator);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 206;
            this.match($6551c3dece3fff4e$export$9c4772e191bdb810.CHANGED);
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlField() {
        let _localctx = new $6551c3dece3fff4e$export$b33300c3d916229a(this._ctx, this.state);
        this.enterRule(_localctx, 32, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlField);
        let _la;
        try {
            this.state = 219;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $6551c3dece3fff4e$export$9c4772e191bdb810.POSNUMBER:
                case $6551c3dece3fff4e$export$9c4772e191bdb810.NEGNUMBER:
                    _localctx = new $6551c3dece3fff4e$export$11fec15307d2e17b(_localctx);
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 208;
                    this.jqlNumber();
                    break;
                case $6551c3dece3fff4e$export$9c4772e191bdb810.CUSTOMFIELD:
                case $6551c3dece3fff4e$export$9c4772e191bdb810.STRING:
                case $6551c3dece3fff4e$export$9c4772e191bdb810.QUOTE_STRING:
                case $6551c3dece3fff4e$export$9c4772e191bdb810.SQUOTE_STRING:
                    _localctx = new $6551c3dece3fff4e$export$b8b24f99f985ebb3(_localctx);
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 211;
                    this._errHandler.sync(this);
                    switch(this._input.LA(1)){
                        case $6551c3dece3fff4e$export$9c4772e191bdb810.STRING:
                        case $6551c3dece3fff4e$export$9c4772e191bdb810.QUOTE_STRING:
                        case $6551c3dece3fff4e$export$9c4772e191bdb810.SQUOTE_STRING:
                            this.state = 209;
                            this.jqlString();
                            break;
                        case $6551c3dece3fff4e$export$9c4772e191bdb810.CUSTOMFIELD:
                            this.state = 210;
                            this.jqlCustomField();
                            break;
                        default:
                            throw new (0, $gm3rl.NoViableAltException)(this);
                    }
                    this.state = 216;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while(_la === $6551c3dece3fff4e$export$9c4772e191bdb810.LBRACKET){
                        this.state = 213;
                        this.jqlFieldProperty();
                        this.state = 218;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
                default:
                    throw new (0, $gm3rl.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlFieldProperty() {
        let _localctx = new $6551c3dece3fff4e$export$b02d0b6637ce0593(this._ctx, this.state);
        this.enterRule(_localctx, 34, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlFieldProperty);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 221;
            this.match($6551c3dece3fff4e$export$9c4772e191bdb810.LBRACKET);
            this.state = 222;
            this.jqlArgument();
            this.state = 223;
            this.match($6551c3dece3fff4e$export$9c4772e191bdb810.RBRACKET);
            this.state = 228;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while((_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $6551c3dece3fff4e$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $6551c3dece3fff4e$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $6551c3dece3fff4e$export$9c4772e191bdb810.STRING - 33 | 1 << $6551c3dece3fff4e$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $6551c3dece3fff4e$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0){
                this.state = 225;
                this.jqlPropertyArgument();
                this.state = 230;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlCustomField() {
        let _localctx = new $6551c3dece3fff4e$export$401a038855cc5b15(this._ctx, this.state);
        this.enterRule(_localctx, 36, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlCustomField);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 231;
            this.match($6551c3dece3fff4e$export$9c4772e191bdb810.CUSTOMFIELD);
            this.state = 232;
            this.match($6551c3dece3fff4e$export$9c4772e191bdb810.LBRACKET);
            this.state = 233;
            this.match($6551c3dece3fff4e$export$9c4772e191bdb810.POSNUMBER);
            this.state = 234;
            this.match($6551c3dece3fff4e$export$9c4772e191bdb810.RBRACKET);
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlString() {
        let _localctx = new $6551c3dece3fff4e$export$bde73d8ad7c8b71e(this._ctx, this.state);
        this.enterRule(_localctx, 38, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlString);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 236;
            _la = this._input.LA(1);
            if (!((_la - 37 & -32) === 0 && (1 << _la - 37 & (1 << $6551c3dece3fff4e$export$9c4772e191bdb810.STRING - 37 | 1 << $6551c3dece3fff4e$export$9c4772e191bdb810.QUOTE_STRING - 37 | 1 << $6551c3dece3fff4e$export$9c4772e191bdb810.SQUOTE_STRING - 37)) !== 0)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $TNDGs.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlNumber() {
        let _localctx = new $6551c3dece3fff4e$export$8737d94a1880e8b3(this._ctx, this.state);
        this.enterRule(_localctx, 40, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlNumber);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 238;
            _localctx._jqlNum = this._input.LT(1);
            _la = this._input.LA(1);
            if (!(_la === $6551c3dece3fff4e$export$9c4772e191bdb810.POSNUMBER || _la === $6551c3dece3fff4e$export$9c4772e191bdb810.NEGNUMBER)) _localctx._jqlNum = this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $TNDGs.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlOperand() {
        let _localctx = new $6551c3dece3fff4e$export$2eaac5a9828bf647(this._ctx, this.state);
        this.enterRule(_localctx, 42, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlOperand);
        try {
            this.state = 244;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 23, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 240;
                    this.jqlEmpty();
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 241;
                    this.jqlValue();
                    break;
                case 3:
                    this.enterOuterAlt(_localctx, 3);
                    this.state = 242;
                    this.jqlFunction();
                    break;
                case 4:
                    this.enterOuterAlt(_localctx, 4);
                    this.state = 243;
                    this.jqlList();
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlEmpty() {
        let _localctx = new $6551c3dece3fff4e$export$d85a062f90025e5c(this._ctx, this.state);
        this.enterRule(_localctx, 44, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlEmpty);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 246;
            this.match($6551c3dece3fff4e$export$9c4772e191bdb810.EMPTY);
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlValue() {
        let _localctx = new $6551c3dece3fff4e$export$2e17d457b0933bec(this._ctx, this.state);
        this.enterRule(_localctx, 46, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlValue);
        try {
            this.state = 250;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $6551c3dece3fff4e$export$9c4772e191bdb810.STRING:
                case $6551c3dece3fff4e$export$9c4772e191bdb810.QUOTE_STRING:
                case $6551c3dece3fff4e$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 248;
                    this.jqlString();
                    break;
                case $6551c3dece3fff4e$export$9c4772e191bdb810.POSNUMBER:
                case $6551c3dece3fff4e$export$9c4772e191bdb810.NEGNUMBER:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 249;
                    this.jqlNumber();
                    break;
                default:
                    throw new (0, $gm3rl.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlFunction() {
        let _localctx = new $6551c3dece3fff4e$export$ebf0cc785e9ee41a(this._ctx, this.state);
        this.enterRule(_localctx, 48, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlFunction);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 252;
            this.jqlFunctionName();
            this.state = 253;
            this.match($6551c3dece3fff4e$export$9c4772e191bdb810.LPAREN);
            this.state = 255;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if ((_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $6551c3dece3fff4e$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $6551c3dece3fff4e$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $6551c3dece3fff4e$export$9c4772e191bdb810.STRING - 33 | 1 << $6551c3dece3fff4e$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $6551c3dece3fff4e$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0) {
                this.state = 254;
                this.jqlArgumentList();
            }
            this.state = 257;
            this.match($6551c3dece3fff4e$export$9c4772e191bdb810.RPAREN);
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlFunctionName() {
        let _localctx = new $6551c3dece3fff4e$export$1f5f7ac816788f44(this._ctx, this.state);
        this.enterRule(_localctx, 50, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlFunctionName);
        try {
            this.state = 261;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $6551c3dece3fff4e$export$9c4772e191bdb810.STRING:
                case $6551c3dece3fff4e$export$9c4772e191bdb810.QUOTE_STRING:
                case $6551c3dece3fff4e$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 259;
                    this.jqlString();
                    break;
                case $6551c3dece3fff4e$export$9c4772e191bdb810.POSNUMBER:
                case $6551c3dece3fff4e$export$9c4772e191bdb810.NEGNUMBER:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 260;
                    this.jqlNumber();
                    break;
                default:
                    throw new (0, $gm3rl.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlArgumentList() {
        let _localctx = new $6551c3dece3fff4e$export$83d7c13849b931c3(this._ctx, this.state);
        this.enterRule(_localctx, 52, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlArgumentList);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 263;
            this.jqlArgument();
            this.state = 268;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $6551c3dece3fff4e$export$9c4772e191bdb810.COMMA){
                this.state = 264;
                this.match($6551c3dece3fff4e$export$9c4772e191bdb810.COMMA);
                this.state = 265;
                this.jqlArgument();
                this.state = 270;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlList() {
        let _localctx = new $6551c3dece3fff4e$export$9cb97a63f2be4864(this._ctx, this.state);
        this.enterRule(_localctx, 54, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlList);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 271;
            this.jqlListStart();
            this.state = 272;
            this.jqlOperand();
            this.state = 277;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $6551c3dece3fff4e$export$9c4772e191bdb810.COMMA){
                this.state = 273;
                this.match($6551c3dece3fff4e$export$9c4772e191bdb810.COMMA);
                this.state = 274;
                this.jqlOperand();
                this.state = 279;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
            this.state = 280;
            this.jqlListEnd();
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlListStart() {
        let _localctx = new $6551c3dece3fff4e$export$c419f717bfc46a5d(this._ctx, this.state);
        this.enterRule(_localctx, 56, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlListStart);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 282;
            this.match($6551c3dece3fff4e$export$9c4772e191bdb810.LPAREN);
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlListEnd() {
        let _localctx = new $6551c3dece3fff4e$export$f6cd3e372f5ab120(this._ctx, this.state);
        this.enterRule(_localctx, 58, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlListEnd);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 284;
            this.match($6551c3dece3fff4e$export$9c4772e191bdb810.RPAREN);
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlPropertyArgument() {
        let _localctx = new $6551c3dece3fff4e$export$e20ce4a2ed16372c(this._ctx, this.state);
        this.enterRule(_localctx, 60, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlPropertyArgument);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 286;
            this.jqlArgument();
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlArgument() {
        let _localctx = new $6551c3dece3fff4e$export$a95583953c237f88(this._ctx, this.state);
        this.enterRule(_localctx, 62, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlArgument);
        try {
            this.state = 290;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $6551c3dece3fff4e$export$9c4772e191bdb810.STRING:
                case $6551c3dece3fff4e$export$9c4772e191bdb810.QUOTE_STRING:
                case $6551c3dece3fff4e$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 288;
                    this.jqlString();
                    break;
                case $6551c3dece3fff4e$export$9c4772e191bdb810.POSNUMBER:
                case $6551c3dece3fff4e$export$9c4772e191bdb810.NEGNUMBER:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 289;
                    this.jqlNumber();
                    break;
                default:
                    throw new (0, $gm3rl.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWasPredicate() {
        let _localctx = new $6551c3dece3fff4e$export$9fa1e4d63f31b911(this._ctx, this.state);
        this.enterRule(_localctx, 64, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlWasPredicate);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 295;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $6551c3dece3fff4e$export$9c4772e191bdb810.BEFORE:
                case $6551c3dece3fff4e$export$9c4772e191bdb810.AFTER:
                case $6551c3dece3fff4e$export$9c4772e191bdb810.ON:
                    this.state = 292;
                    this.jqlDatePredicateOperator();
                    break;
                case $6551c3dece3fff4e$export$9c4772e191bdb810.DURING:
                    this.state = 293;
                    this.jqlDateRangePredicateOperator();
                    break;
                case $6551c3dece3fff4e$export$9c4772e191bdb810.BY:
                    this.state = 294;
                    this.jqlUserPredicateOperator();
                    break;
                default:
                    throw new (0, $gm3rl.NoViableAltException)(this);
            }
            this.state = 297;
            this.jqlPredicateOperand();
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlChangedPredicate() {
        let _localctx = new $6551c3dece3fff4e$export$e77e479a48133015(this._ctx, this.state);
        this.enterRule(_localctx, 66, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlChangedPredicate);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 303;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $6551c3dece3fff4e$export$9c4772e191bdb810.BEFORE:
                case $6551c3dece3fff4e$export$9c4772e191bdb810.AFTER:
                case $6551c3dece3fff4e$export$9c4772e191bdb810.ON:
                    this.state = 299;
                    this.jqlDatePredicateOperator();
                    break;
                case $6551c3dece3fff4e$export$9c4772e191bdb810.DURING:
                    this.state = 300;
                    this.jqlDateRangePredicateOperator();
                    break;
                case $6551c3dece3fff4e$export$9c4772e191bdb810.BY:
                    this.state = 301;
                    this.jqlUserPredicateOperator();
                    break;
                case $6551c3dece3fff4e$export$9c4772e191bdb810.FROM:
                case $6551c3dece3fff4e$export$9c4772e191bdb810.TO:
                    this.state = 302;
                    this.jqlValuePredicateOperator();
                    break;
                default:
                    throw new (0, $gm3rl.NoViableAltException)(this);
            }
            this.state = 305;
            this.jqlPredicateOperand();
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlDatePredicateOperator() {
        let _localctx = new $6551c3dece3fff4e$export$dc01290aee731418(this._ctx, this.state);
        this.enterRule(_localctx, 68, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlDatePredicateOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 307;
            _la = this._input.LA(1);
            if (!((_la & -32) === 0 && (1 << _la & (1 << $6551c3dece3fff4e$export$9c4772e191bdb810.BEFORE | 1 << $6551c3dece3fff4e$export$9c4772e191bdb810.AFTER | 1 << $6551c3dece3fff4e$export$9c4772e191bdb810.ON)) !== 0)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $TNDGs.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlDateRangePredicateOperator() {
        let _localctx = new $6551c3dece3fff4e$export$75412b8b6a6442e1(this._ctx, this.state);
        this.enterRule(_localctx, 70, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlDateRangePredicateOperator);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 309;
            this.match($6551c3dece3fff4e$export$9c4772e191bdb810.DURING);
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlUserPredicateOperator() {
        let _localctx = new $6551c3dece3fff4e$export$ad402332075c8656(this._ctx, this.state);
        this.enterRule(_localctx, 72, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlUserPredicateOperator);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 311;
            this.match($6551c3dece3fff4e$export$9c4772e191bdb810.BY);
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlValuePredicateOperator() {
        let _localctx = new $6551c3dece3fff4e$export$4239d7c0fbafd3f1(this._ctx, this.state);
        this.enterRule(_localctx, 74, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlValuePredicateOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 313;
            _la = this._input.LA(1);
            if (!(_la === $6551c3dece3fff4e$export$9c4772e191bdb810.FROM || _la === $6551c3dece3fff4e$export$9c4772e191bdb810.TO)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $TNDGs.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlPredicateOperand() {
        let _localctx = new $6551c3dece3fff4e$export$6b796c5a4b8c18e(this._ctx, this.state);
        this.enterRule(_localctx, 76, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlPredicateOperand);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 315;
            this.jqlOperand();
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlOrderBy() {
        let _localctx = new $6551c3dece3fff4e$export$534469b9c8f44139(this._ctx, this.state);
        this.enterRule(_localctx, 78, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlOrderBy);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 317;
            this.match($6551c3dece3fff4e$export$9c4772e191bdb810.ORDER);
            this.state = 318;
            this.match($6551c3dece3fff4e$export$9c4772e191bdb810.BY);
            this.state = 319;
            this.jqlSearchSort();
            this.state = 324;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $6551c3dece3fff4e$export$9c4772e191bdb810.COMMA){
                this.state = 320;
                this.match($6551c3dece3fff4e$export$9c4772e191bdb810.COMMA);
                this.state = 321;
                this.jqlSearchSort();
                this.state = 326;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlSearchSort() {
        let _localctx = new $6551c3dece3fff4e$export$c7d8f03f36952a46(this._ctx, this.state);
        this.enterRule(_localctx, 80, $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlSearchSort);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 327;
            this.jqlField();
            this.state = 329;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if (_la === $6551c3dece3fff4e$export$9c4772e191bdb810.ASC || _la === $6551c3dece3fff4e$export$9c4772e191bdb810.DESC) {
                this.state = 328;
                _la = this._input.LA(1);
                if (!(_la === $6551c3dece3fff4e$export$9c4772e191bdb810.ASC || _la === $6551c3dece3fff4e$export$9c4772e191bdb810.DESC)) this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $TNDGs.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        } catch (re) {
            if (re instanceof (0, $beMqO.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    static get _ATN() {
        if (!$6551c3dece3fff4e$export$9c4772e191bdb810.__ATN) $6551c3dece3fff4e$export$9c4772e191bdb810.__ATN = new (0, $lso6d.ATNDeserializer)().deserialize($3jpAZ.toCharArray($6551c3dece3fff4e$export$9c4772e191bdb810._serializedATN));
        return $6551c3dece3fff4e$export$9c4772e191bdb810.__ATN;
    }
    constructor(input){
        super(input);
        this._interp = new (0, $lORdS.ParserATNSimulator)($6551c3dece3fff4e$export$9c4772e191bdb810._ATN, this);
    }
}
$6551c3dece3fff4e$var$_JQLParser = $6551c3dece3fff4e$export$9c4772e191bdb810;
$6551c3dece3fff4e$export$9c4772e191bdb810.LPAREN = 1;
$6551c3dece3fff4e$export$9c4772e191bdb810.RPAREN = 2;
$6551c3dece3fff4e$export$9c4772e191bdb810.COMMA = 3;
$6551c3dece3fff4e$export$9c4772e191bdb810.LBRACKET = 4;
$6551c3dece3fff4e$export$9c4772e191bdb810.RBRACKET = 5;
$6551c3dece3fff4e$export$9c4772e191bdb810.BANG = 6;
$6551c3dece3fff4e$export$9c4772e191bdb810.LT = 7;
$6551c3dece3fff4e$export$9c4772e191bdb810.GT = 8;
$6551c3dece3fff4e$export$9c4772e191bdb810.GTEQ = 9;
$6551c3dece3fff4e$export$9c4772e191bdb810.LTEQ = 10;
$6551c3dece3fff4e$export$9c4772e191bdb810.EQUALS = 11;
$6551c3dece3fff4e$export$9c4772e191bdb810.NOT_EQUALS = 12;
$6551c3dece3fff4e$export$9c4772e191bdb810.LIKE = 13;
$6551c3dece3fff4e$export$9c4772e191bdb810.NOT_LIKE = 14;
$6551c3dece3fff4e$export$9c4772e191bdb810.IN = 15;
$6551c3dece3fff4e$export$9c4772e191bdb810.IS = 16;
$6551c3dece3fff4e$export$9c4772e191bdb810.AND = 17;
$6551c3dece3fff4e$export$9c4772e191bdb810.OR = 18;
$6551c3dece3fff4e$export$9c4772e191bdb810.NOT = 19;
$6551c3dece3fff4e$export$9c4772e191bdb810.EMPTY = 20;
$6551c3dece3fff4e$export$9c4772e191bdb810.WAS = 21;
$6551c3dece3fff4e$export$9c4772e191bdb810.CHANGED = 22;
$6551c3dece3fff4e$export$9c4772e191bdb810.BEFORE = 23;
$6551c3dece3fff4e$export$9c4772e191bdb810.AFTER = 24;
$6551c3dece3fff4e$export$9c4772e191bdb810.FROM = 25;
$6551c3dece3fff4e$export$9c4772e191bdb810.TO = 26;
$6551c3dece3fff4e$export$9c4772e191bdb810.ON = 27;
$6551c3dece3fff4e$export$9c4772e191bdb810.DURING = 28;
$6551c3dece3fff4e$export$9c4772e191bdb810.ORDER = 29;
$6551c3dece3fff4e$export$9c4772e191bdb810.BY = 30;
$6551c3dece3fff4e$export$9c4772e191bdb810.ASC = 31;
$6551c3dece3fff4e$export$9c4772e191bdb810.DESC = 32;
$6551c3dece3fff4e$export$9c4772e191bdb810.POSNUMBER = 33;
$6551c3dece3fff4e$export$9c4772e191bdb810.NEGNUMBER = 34;
$6551c3dece3fff4e$export$9c4772e191bdb810.CUSTOMFIELD = 35;
$6551c3dece3fff4e$export$9c4772e191bdb810.RESERVED_WORD = 36;
$6551c3dece3fff4e$export$9c4772e191bdb810.STRING = 37;
$6551c3dece3fff4e$export$9c4772e191bdb810.MATCHWS = 38;
$6551c3dece3fff4e$export$9c4772e191bdb810.ERROR_RESERVED = 39;
$6551c3dece3fff4e$export$9c4772e191bdb810.ERRORCHAR = 40;
$6551c3dece3fff4e$export$9c4772e191bdb810.QUOTE_STRING = 41;
$6551c3dece3fff4e$export$9c4772e191bdb810.UNCLOSED_QUOTE_STRING = 42;
$6551c3dece3fff4e$export$9c4772e191bdb810.INVALID_QUOTE_STRING = 43;
$6551c3dece3fff4e$export$9c4772e191bdb810.SQUOTE_STRING = 44;
$6551c3dece3fff4e$export$9c4772e191bdb810.UNCLOSED_SQUOTE_STRING = 45;
$6551c3dece3fff4e$export$9c4772e191bdb810.INVALID_SQUOTE_STRING = 46;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlQuery = 0;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlWhere = 1;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlOrClause = 2;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlAndClause = 3;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlNotClause = 4;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlSubClause = 5;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlTerminalClause = 6;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlTerminalClauseRhs = 7;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlEqualsOperator = 8;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlLikeOperator = 9;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlComparisonOperator = 10;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlInOperator = 11;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlIsOperator = 12;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlWasOperator = 13;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlWasInOperator = 14;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlChangedOperator = 15;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlField = 16;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlFieldProperty = 17;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlCustomField = 18;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlString = 19;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlNumber = 20;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlOperand = 21;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlEmpty = 22;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlValue = 23;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlFunction = 24;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlFunctionName = 25;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlArgumentList = 26;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlList = 27;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlListStart = 28;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlListEnd = 29;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlPropertyArgument = 30;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlArgument = 31;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlWasPredicate = 32;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlChangedPredicate = 33;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlDatePredicateOperator = 34;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlDateRangePredicateOperator = 35;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlUserPredicateOperator = 36;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlValuePredicateOperator = 37;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlPredicateOperand = 38;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlOrderBy = 39;
$6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlSearchSort = 40;
// tslint:disable:no-trailing-whitespace
$6551c3dece3fff4e$export$9c4772e191bdb810.ruleNames = [
    'jqlQuery',
    'jqlWhere',
    'jqlOrClause',
    'jqlAndClause',
    'jqlNotClause',
    'jqlSubClause',
    'jqlTerminalClause',
    'jqlTerminalClauseRhs',
    'jqlEqualsOperator',
    'jqlLikeOperator',
    'jqlComparisonOperator',
    'jqlInOperator',
    'jqlIsOperator',
    'jqlWasOperator',
    'jqlWasInOperator',
    'jqlChangedOperator',
    'jqlField',
    'jqlFieldProperty',
    'jqlCustomField',
    'jqlString',
    'jqlNumber',
    'jqlOperand',
    'jqlEmpty',
    'jqlValue',
    'jqlFunction',
    'jqlFunctionName',
    'jqlArgumentList',
    'jqlList',
    'jqlListStart',
    'jqlListEnd',
    'jqlPropertyArgument',
    'jqlArgument',
    'jqlWasPredicate',
    'jqlChangedPredicate',
    'jqlDatePredicateOperator',
    'jqlDateRangePredicateOperator',
    'jqlUserPredicateOperator',
    'jqlValuePredicateOperator',
    'jqlPredicateOperand',
    'jqlOrderBy',
    'jqlSearchSort'
];
$6551c3dece3fff4e$export$9c4772e191bdb810._LITERAL_NAMES = [
    undefined,
    "'('",
    "')'",
    "','",
    "'['",
    "']'",
    "'!'",
    "'<'",
    "'>'",
    "'>='",
    "'<='",
    "'='",
    "'!='",
    "'~'",
    "'!~'"
];
$6551c3dece3fff4e$export$9c4772e191bdb810._SYMBOLIC_NAMES = [
    undefined,
    'LPAREN',
    'RPAREN',
    'COMMA',
    'LBRACKET',
    'RBRACKET',
    'BANG',
    'LT',
    'GT',
    'GTEQ',
    'LTEQ',
    'EQUALS',
    'NOT_EQUALS',
    'LIKE',
    'NOT_LIKE',
    'IN',
    'IS',
    'AND',
    'OR',
    'NOT',
    'EMPTY',
    'WAS',
    'CHANGED',
    'BEFORE',
    'AFTER',
    'FROM',
    'TO',
    'ON',
    'DURING',
    'ORDER',
    'BY',
    'ASC',
    'DESC',
    'POSNUMBER',
    'NEGNUMBER',
    'CUSTOMFIELD',
    'RESERVED_WORD',
    'STRING',
    'MATCHWS',
    'ERROR_RESERVED',
    'ERRORCHAR',
    'QUOTE_STRING',
    'UNCLOSED_QUOTE_STRING',
    'INVALID_QUOTE_STRING',
    'SQUOTE_STRING',
    'UNCLOSED_SQUOTE_STRING',
    'INVALID_SQUOTE_STRING'
];
$6551c3dece3fff4e$export$9c4772e191bdb810.VOCABULARY = new (0, $56U0W.VocabularyImpl)($6551c3dece3fff4e$var$_JQLParser._LITERAL_NAMES, $6551c3dece3fff4e$var$_JQLParser._SYMBOLIC_NAMES, []);
$6551c3dece3fff4e$export$9c4772e191bdb810._serializedATN = '\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x030\u014E\x04\x02	\x02\x04\x03	\x03\x04\x04	\x04\x04\x05	\x05\x04\x06	\x06\x04\x07	\x07\x04\b	\b\x04			\x04\n	\n\x04\v	\v\x04\f	\f\x04\r	\r\x04\x0e	\x0e\x04\x0f	\x0f\x04\x10	\x10\x04\x11	\x11\x04\x12	\x12\x04\x13	\x13\x04\x14	\x14\x04\x15	\x15\x04\x16	\x16\x04\x17	\x17\x04\x18	\x18\x04\x19	\x19\x04\x1a	\x1a\x04\x1b	\x1b\x04\x1c	\x1c\x04\x1d	\x1d\x04\x1e	\x1e\x04\x1f	\x1f\x04 	 \x04!	!\x04"	"\x04#	#\x04$	$\x04%	%\x04&	&\x04\'	\'\x04(	(\x04)	)\x04*	*\x03\x02\x05\x02V\n\x02\x03\x02\x05\x02Y\n\x02\x03\x02\x03\x02\x03\x03\x03\x03\x03\x04\x03\x04\x03\x04\x07\x04b\n\x04\f\x04\x0e\x04e\v\x04\x03\x05\x03\x05\x03\x05\x07\x05j\n\x05\f\x05\x0e\x05m\v\x05\x03\x06\x03\x06\x03\x06\x03\x06\x05\x06s\n\x06\x03\x07\x03\x07\x03\x07\x03\x07\x03\b\x03\b\x03\b\x03	\x03	\x03	\x03	\x05	\x80\n	\x03	\x03	\x03	\x03	\x05	\x86\n	\x03	\x03	\x03	\x05	\x8b\n	\x03	\x03	\x03	\x05	\x90\n	\x03	\x03	\x03	\x03	\x03	\x03	\x03	\x05	\x99\n	\x03	\x07	\x9c\n	\f	\x0e	\x9f\v	\x03	\x03	\x03	\x05	\xa4\n	\x03	\x07	\xa7\n	\f	\x0e	\xaa\v	\x03	\x03	\x07	\xae\n	\f	\x0e	\xb1\v	\x05	\xb3\n	\x03\n\x03\n\x03\v\x03\v\x03\f\x03\f\x03\r\x03\r\x03\r\x05\r\xbe\n\r\x03\x0e\x03\x0e\x03\x0e\x05\x0e\xc3\n\x0e\x03\x0f\x03\x0f\x03\x0f\x05\x0f\xc8\n\x0f\x03\x10\x03\x10\x03\x10\x03\x10\x03\x10\x05\x10\xcf\n\x10\x03\x11\x03\x11\x03\x12\x03\x12\x03\x12\x05\x12\xd6\n\x12\x03\x12\x07\x12\xd9\n\x12\f\x12\x0e\x12\xdc\v\x12\x05\x12\xde\n\x12\x03\x13\x03\x13\x03\x13\x03\x13\x03\x13\x07\x13\xe5\n\x13\f\x13\x0e\x13\xe8\v\x13\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x03\x15\x03\x15\x03\x16\x03\x16\x03\x17\x03\x17\x03\x17\x03\x17\x05\x17\xf7\n\x17\x03\x18\x03\x18\x03\x19\x03\x19\x05\x19\xfd\n\x19\x03\x1a\x03\x1a\x03\x1a\x05\x1a\u0102\n\x1a\x03\x1a\x03\x1a\x03\x1b\x03\x1b\x05\x1b\u0108\n\x1b\x03\x1c\x03\x1c\x03\x1c\x07\x1c\u010D\n\x1c\f\x1c\x0e\x1c\u0110\v\x1c\x03\x1d\x03\x1d\x03\x1d\x03\x1d\x07\x1d\u0116\n\x1d\f\x1d\x0e\x1d\u0119\v\x1d\x03\x1d\x03\x1d\x03\x1e\x03\x1e\x03\x1f\x03\x1f\x03 \x03 \x03!\x03!\x05!\u0125\n!\x03"\x03"\x03"\x05"\u012A\n"\x03"\x03"\x03#\x03#\x03#\x03#\x05#\u0132\n#\x03#\x03#\x03$\x03$\x03%\x03%\x03&\x03&\x03\'\x03\'\x03(\x03(\x03)\x03)\x03)\x03)\x03)\x07)\u0145\n)\f)\x0e)\u0148\v)\x03*\x03*\x05*\u014C\n*\x03*\x02\x02\x02+\x02\x02\x04\x02\x06\x02\b\x02\n\x02\f\x02\x0e\x02\x10\x02\x12\x02\x14\x02\x16\x02\x18\x02\x1a\x02\x1c\x02\x1e\x02 \x02"\x02$\x02&\x02(\x02*\x02,\x02.\x020\x022\x024\x026\x028\x02:\x02<\x02>\x02@\x02B\x02D\x02F\x02H\x02J\x02L\x02N\x02P\x02R\x02\x02\v\x04\x02\b\b\x15\x15\x03\x02\r\x0e\x03\x02\x0f\x10\x03\x02	\f\x05\x02\'\'++..\x03\x02#$\x04\x02\x19\x1a\x1d\x1d\x03\x02\x1b\x1c\x03\x02!"\x02\u0155\x02U\x03\x02\x02\x02\x04\\\x03\x02\x02\x02\x06^\x03\x02\x02\x02\bf\x03\x02\x02\x02\nr\x03\x02\x02\x02\ft\x03\x02\x02\x02\x0ex\x03\x02\x02\x02\x10\xb2\x03\x02\x02\x02\x12\xb4\x03\x02\x02\x02\x14\xb6\x03\x02\x02\x02\x16\xb8\x03\x02\x02\x02\x18\xbd\x03\x02\x02\x02\x1a\xc2\x03\x02\x02\x02\x1c\xc7\x03\x02\x02\x02\x1e\xce\x03\x02\x02\x02 \xd0\x03\x02\x02\x02"\xdd\x03\x02\x02\x02$\xdf\x03\x02\x02\x02&\xe9\x03\x02\x02\x02(\xee\x03\x02\x02\x02*\xf0\x03\x02\x02\x02,\xf6\x03\x02\x02\x02.\xf8\x03\x02\x02\x020\xfc\x03\x02\x02\x022\xfe\x03\x02\x02\x024\u0107\x03\x02\x02\x026\u0109\x03\x02\x02\x028\u0111\x03\x02\x02\x02:\u011C\x03\x02\x02\x02<\u011E\x03\x02\x02\x02>\u0120\x03\x02\x02\x02@\u0124\x03\x02\x02\x02B\u0129\x03\x02\x02\x02D\u0131\x03\x02\x02\x02F\u0135\x03\x02\x02\x02H\u0137\x03\x02\x02\x02J\u0139\x03\x02\x02\x02L\u013B\x03\x02\x02\x02N\u013D\x03\x02\x02\x02P\u013F\x03\x02\x02\x02R\u0149\x03\x02\x02\x02TV\x05\x04\x03\x02UT\x03\x02\x02\x02UV\x03\x02\x02\x02VX\x03\x02\x02\x02WY\x05P)\x02XW\x03\x02\x02\x02XY\x03\x02\x02\x02YZ\x03\x02\x02\x02Z[\x07\x02\x02\x03[\x03\x03\x02\x02\x02\\]\x05\x06\x04\x02]\x05\x03\x02\x02\x02^c\x05\b\x05\x02_`\x07\x14\x02\x02`b\x05\b\x05\x02a_\x03\x02\x02\x02be\x03\x02\x02\x02ca\x03\x02\x02\x02cd\x03\x02\x02\x02d\x07\x03\x02\x02\x02ec\x03\x02\x02\x02fk\x05\n\x06\x02gh\x07\x13\x02\x02hj\x05\n\x06\x02ig\x03\x02\x02\x02jm\x03\x02\x02\x02ki\x03\x02\x02\x02kl\x03\x02\x02\x02l	\x03\x02\x02\x02mk\x03\x02\x02\x02no	\x02\x02\x02os\x05\n\x06\x02ps\x05\f\x07\x02qs\x05\x0e\b\x02rn\x03\x02\x02\x02rp\x03\x02\x02\x02rq\x03\x02\x02\x02s\v\x03\x02\x02\x02tu\x07\x03\x02\x02uv\x05\x06\x04\x02vw\x07\x04\x02\x02w\r\x03\x02\x02\x02xy\x05"\x12\x02yz\x05\x10	\x02z\x0f\x03\x02\x02\x02{\x7f\x05\x12\n\x02|\x80\x05.\x18\x02}\x80\x050\x19\x02~\x80\x052\x1a\x02\x7f|\x03\x02\x02\x02\x7f}\x03\x02\x02\x02\x7f~\x03\x02\x02\x02\x80\xb3\x03\x02\x02\x02\x81\x85\x05\x14\v\x02\x82\x86\x05.\x18\x02\x83\x86\x050\x19\x02\x84\x86\x052\x1a\x02\x85\x82\x03\x02\x02\x02\x85\x83\x03\x02\x02\x02\x85\x84\x03\x02\x02\x02\x86\xb3\x03\x02\x02\x02\x87\x8a\x05\x16\f\x02\x88\x8b\x050\x19\x02\x89\x8b\x052\x1a\x02\x8a\x88\x03\x02\x02\x02\x8a\x89\x03\x02\x02\x02\x8b\xb3\x03\x02\x02\x02\x8c\x8f\x05\x18\r\x02\x8d\x90\x058\x1d\x02\x8e\x90\x052\x1a\x02\x8f\x8d\x03\x02\x02\x02\x8f\x8e\x03\x02\x02\x02\x90\xb3\x03\x02\x02\x02\x91\x92\x05\x1a\x0e\x02\x92\x93\x05.\x18\x02\x93\xb3\x03\x02\x02\x02\x94\x98\x05\x1c\x0f\x02\x95\x99\x05.\x18\x02\x96\x99\x050\x19\x02\x97\x99\x052\x1a\x02\x98\x95\x03\x02\x02\x02\x98\x96\x03\x02\x02\x02\x98\x97\x03\x02\x02\x02\x99\x9d\x03\x02\x02\x02\x9a\x9c\x05B"\x02\x9b\x9a\x03\x02\x02\x02\x9c\x9f\x03\x02\x02\x02\x9d\x9b\x03\x02\x02\x02\x9d\x9e\x03\x02\x02\x02\x9e\xb3\x03\x02\x02\x02\x9f\x9d\x03\x02\x02\x02\xa0\xa3\x05\x1e\x10\x02\xa1\xa4\x058\x1d\x02\xa2\xa4\x052\x1a\x02\xa3\xa1\x03\x02\x02\x02\xa3\xa2\x03\x02\x02\x02\xa4\xa8\x03\x02\x02\x02\xa5\xa7\x05B"\x02\xa6\xa5\x03\x02\x02\x02\xa7\xaa\x03\x02\x02\x02\xa8\xa6\x03\x02\x02\x02\xa8\xa9\x03\x02\x02\x02\xa9\xb3\x03\x02\x02\x02\xaa\xa8\x03\x02\x02\x02\xab\xaf\x05 \x11\x02\xac\xae\x05D#\x02\xad\xac\x03\x02\x02\x02\xae\xb1\x03\x02\x02\x02\xaf\xad\x03\x02\x02\x02\xaf\xb0\x03\x02\x02\x02\xb0\xb3\x03\x02\x02\x02\xb1\xaf\x03\x02\x02\x02\xb2{\x03\x02\x02\x02\xb2\x81\x03\x02\x02\x02\xb2\x87\x03\x02\x02\x02\xb2\x8c\x03\x02\x02\x02\xb2\x91\x03\x02\x02\x02\xb2\x94\x03\x02\x02\x02\xb2\xa0\x03\x02\x02\x02\xb2\xab\x03\x02\x02\x02\xb3\x11\x03\x02\x02\x02\xb4\xb5	\x03\x02\x02\xb5\x13\x03\x02\x02\x02\xb6\xb7	\x04\x02\x02\xb7\x15\x03\x02\x02\x02\xb8\xb9	\x05\x02\x02\xb9\x17\x03\x02\x02\x02\xba\xbe\x07\x11\x02\x02\xbb\xbc\x07\x15\x02\x02\xbc\xbe\x07\x11\x02\x02\xbd\xba\x03\x02\x02\x02\xbd\xbb\x03\x02\x02\x02\xbe\x19\x03\x02\x02\x02\xbf\xc3\x07\x12\x02\x02\xc0\xc1\x07\x12\x02\x02\xc1\xc3\x07\x15\x02\x02\xc2\xbf\x03\x02\x02\x02\xc2\xc0\x03\x02\x02\x02\xc3\x1b\x03\x02\x02\x02\xc4\xc8\x07\x17\x02\x02\xc5\xc6\x07\x17\x02\x02\xc6\xc8\x07\x15\x02\x02\xc7\xc4\x03\x02\x02\x02\xc7\xc5\x03\x02\x02\x02\xc8\x1d\x03\x02\x02\x02\xc9\xca\x07\x17\x02\x02\xca\xcf\x07\x11\x02\x02\xcb\xcc\x07\x17\x02\x02\xcc\xcd\x07\x15\x02\x02\xcd\xcf\x07\x11\x02\x02\xce\xc9\x03\x02\x02\x02\xce\xcb\x03\x02\x02\x02\xcf\x1f\x03\x02\x02\x02\xd0\xd1\x07\x18\x02\x02\xd1!\x03\x02\x02\x02\xd2\xde\x05*\x16\x02\xd3\xd6\x05(\x15\x02\xd4\xd6\x05&\x14\x02\xd5\xd3\x03\x02\x02\x02\xd5\xd4\x03\x02\x02\x02\xd6\xda\x03\x02\x02\x02\xd7\xd9\x05$\x13\x02\xd8\xd7\x03\x02\x02\x02\xd9\xdc\x03\x02\x02\x02\xda\xd8\x03\x02\x02\x02\xda\xdb\x03\x02\x02\x02\xdb\xde\x03\x02\x02\x02\xdc\xda\x03\x02\x02\x02\xdd\xd2\x03\x02\x02\x02\xdd\xd5\x03\x02\x02\x02\xde#\x03\x02\x02\x02\xdf\xe0\x07\x06\x02\x02\xe0\xe1\x05@!\x02\xe1\xe2\x07\x07\x02\x02\xe2\xe6\x03\x02\x02\x02\xe3\xe5\x05> \x02\xe4\xe3\x03\x02\x02\x02\xe5\xe8\x03\x02\x02\x02\xe6\xe4\x03\x02\x02\x02\xe6\xe7\x03\x02\x02\x02\xe7%\x03\x02\x02\x02\xe8\xe6\x03\x02\x02\x02\xe9\xea\x07%\x02\x02\xea\xeb\x07\x06\x02\x02\xeb\xec\x07#\x02\x02\xec\xed\x07\x07\x02\x02\xed\'\x03\x02\x02\x02\xee\xef	\x06\x02\x02\xef)\x03\x02\x02\x02\xf0\xf1	\x07\x02\x02\xf1+\x03\x02\x02\x02\xf2\xf7\x05.\x18\x02\xf3\xf7\x050\x19\x02\xf4\xf7\x052\x1a\x02\xf5\xf7\x058\x1d\x02\xf6\xf2\x03\x02\x02\x02\xf6\xf3\x03\x02\x02\x02\xf6\xf4\x03\x02\x02\x02\xf6\xf5\x03\x02\x02\x02\xf7-\x03\x02\x02\x02\xf8\xf9\x07\x16\x02\x02\xf9/\x03\x02\x02\x02\xfa\xfd\x05(\x15\x02\xfb\xfd\x05*\x16\x02\xfc\xfa\x03\x02\x02\x02\xfc\xfb\x03\x02\x02\x02\xfd1\x03\x02\x02\x02\xfe\xff\x054\x1b\x02\xff\u0101\x07\x03\x02\x02\u0100\u0102\x056\x1c\x02\u0101\u0100\x03\x02\x02\x02\u0101\u0102\x03\x02\x02\x02\u0102\u0103\x03\x02\x02\x02\u0103\u0104\x07\x04\x02\x02\u01043\x03\x02\x02\x02\u0105\u0108\x05(\x15\x02\u0106\u0108\x05*\x16\x02\u0107\u0105\x03\x02\x02\x02\u0107\u0106\x03\x02\x02\x02\u01085\x03\x02\x02\x02\u0109\u010E\x05@!\x02\u010A\u010B\x07\x05\x02\x02\u010B\u010D\x05@!\x02\u010C\u010A\x03\x02\x02\x02\u010D\u0110\x03\x02\x02\x02\u010E\u010C\x03\x02\x02\x02\u010E\u010F\x03\x02\x02\x02\u010F7\x03\x02\x02\x02\u0110\u010E\x03\x02\x02\x02\u0111\u0112\x05:\x1e\x02\u0112\u0117\x05,\x17\x02\u0113\u0114\x07\x05\x02\x02\u0114\u0116\x05,\x17\x02\u0115\u0113\x03\x02\x02\x02\u0116\u0119\x03\x02\x02\x02\u0117\u0115\x03\x02\x02\x02\u0117\u0118\x03\x02\x02\x02\u0118\u011A\x03\x02\x02\x02\u0119\u0117\x03\x02\x02\x02\u011A\u011B\x05<\x1f\x02\u011B9\x03\x02\x02\x02\u011C\u011D\x07\x03\x02\x02\u011D;\x03\x02\x02\x02\u011E\u011F\x07\x04\x02\x02\u011F=\x03\x02\x02\x02\u0120\u0121\x05@!\x02\u0121?\x03\x02\x02\x02\u0122\u0125\x05(\x15\x02\u0123\u0125\x05*\x16\x02\u0124\u0122\x03\x02\x02\x02\u0124\u0123\x03\x02\x02\x02\u0125A\x03\x02\x02\x02\u0126\u012A\x05F$\x02\u0127\u012A\x05H%\x02\u0128\u012A\x05J&\x02\u0129\u0126\x03\x02\x02\x02\u0129\u0127\x03\x02\x02\x02\u0129\u0128\x03\x02\x02\x02\u012A\u012B\x03\x02\x02\x02\u012B\u012C\x05N(\x02\u012CC\x03\x02\x02\x02\u012D\u0132\x05F$\x02\u012E\u0132\x05H%\x02\u012F\u0132\x05J&\x02\u0130\u0132\x05L\'\x02\u0131\u012D\x03\x02\x02\x02\u0131\u012E\x03\x02\x02\x02\u0131\u012F\x03\x02\x02\x02\u0131\u0130\x03\x02\x02\x02\u0132\u0133\x03\x02\x02\x02\u0133\u0134\x05N(\x02\u0134E\x03\x02\x02\x02\u0135\u0136	\b\x02\x02\u0136G\x03\x02\x02\x02\u0137\u0138\x07\x1e\x02\x02\u0138I\x03\x02\x02\x02\u0139\u013A\x07 \x02\x02\u013AK\x03\x02\x02\x02\u013B\u013C		\x02\x02\u013CM\x03\x02\x02\x02\u013D\u013E\x05,\x17\x02\u013EO\x03\x02\x02\x02\u013F\u0140\x07\x1f\x02\x02\u0140\u0141\x07 \x02\x02\u0141\u0146\x05R*\x02\u0142\u0143\x07\x05\x02\x02\u0143\u0145\x05R*\x02\u0144\u0142\x03\x02\x02\x02\u0145\u0148\x03\x02\x02\x02\u0146\u0144\x03\x02\x02\x02\u0146\u0147\x03\x02\x02\x02\u0147Q\x03\x02\x02\x02\u0148\u0146\x03\x02\x02\x02\u0149\u014B\x05"\x12\x02\u014A\u014C	\n\x02\x02\u014B\u014A\x03\x02\x02\x02\u014B\u014C\x03\x02\x02\x02\u014CS\x03\x02\x02\x02$UXckr\x7f\x85\x8a\x8f\x98\x9d\xa3\xa8\xaf\xb2\xbd\xc2\xc7\xce\xd5\xda\xdd\xe6\xf6\xfc\u0101\u0107\u010E\u0117\u0124\u0129\u0131\u0146\u014B';
$6551c3dece3fff4e$export$9c4772e191bdb810.__ATN = void 0;
class $6551c3dece3fff4e$export$ff413535b9575c8 extends (0, $5izRN.ParserRuleContext) {
    EOF() {
        return this.getToken($6551c3dece3fff4e$export$9c4772e191bdb810.EOF, 0);
    }
    jqlWhere() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$4148a879cab28017);
    }
    jqlOrderBy() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$534469b9c8f44139);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlQuery;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlQuery) listener.enterJqlQuery(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlQuery) listener.exitJqlQuery(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlQuery) return visitor.visitJqlQuery(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$4148a879cab28017 extends (0, $5izRN.ParserRuleContext) {
    jqlOrClause() {
        return this.getRuleContext(0, $6551c3dece3fff4e$export$d69831d387793480);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlWhere;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWhere) listener.enterJqlWhere(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWhere) listener.exitJqlWhere(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWhere) return visitor.visitJqlWhere(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$d69831d387793480 extends (0, $5izRN.ParserRuleContext) {
    jqlAndClause(i) {
        if (i === undefined) return this.getRuleContexts($6551c3dece3fff4e$export$f16819001158b9e);
        else return this.getRuleContext(i, $6551c3dece3fff4e$export$f16819001158b9e);
    }
    OR(i) {
        if (i === undefined) return this.getTokens($6551c3dece3fff4e$export$9c4772e191bdb810.OR);
        else return this.getToken($6551c3dece3fff4e$export$9c4772e191bdb810.OR, i);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlOrClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlOrClause) listener.enterJqlOrClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlOrClause) listener.exitJqlOrClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlOrClause) return visitor.visitJqlOrClause(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$f16819001158b9e extends (0, $5izRN.ParserRuleContext) {
    jqlNotClause(i) {
        if (i === undefined) return this.getRuleContexts($6551c3dece3fff4e$export$5e9146f8d5cf1330);
        else return this.getRuleContext(i, $6551c3dece3fff4e$export$5e9146f8d5cf1330);
    }
    AND(i) {
        if (i === undefined) return this.getTokens($6551c3dece3fff4e$export$9c4772e191bdb810.AND);
        else return this.getToken($6551c3dece3fff4e$export$9c4772e191bdb810.AND, i);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlAndClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlAndClause) listener.enterJqlAndClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlAndClause) listener.exitJqlAndClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlAndClause) return visitor.visitJqlAndClause(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$5e9146f8d5cf1330 extends (0, $5izRN.ParserRuleContext) {
    jqlNotClause() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$5e9146f8d5cf1330);
    }
    NOT() {
        return this.tryGetToken($6551c3dece3fff4e$export$9c4772e191bdb810.NOT, 0);
    }
    BANG() {
        return this.tryGetToken($6551c3dece3fff4e$export$9c4772e191bdb810.BANG, 0);
    }
    jqlSubClause() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$a136a0e9655bfb04);
    }
    jqlTerminalClause() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$23486a2f2ddd5bcd);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlNotClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNotClause) listener.enterJqlNotClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNotClause) listener.exitJqlNotClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNotClause) return visitor.visitJqlNotClause(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$a136a0e9655bfb04 extends (0, $5izRN.ParserRuleContext) {
    LPAREN() {
        return this.getToken($6551c3dece3fff4e$export$9c4772e191bdb810.LPAREN, 0);
    }
    jqlOrClause() {
        return this.getRuleContext(0, $6551c3dece3fff4e$export$d69831d387793480);
    }
    RPAREN() {
        return this.getToken($6551c3dece3fff4e$export$9c4772e191bdb810.RPAREN, 0);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlSubClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlSubClause) listener.enterJqlSubClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlSubClause) listener.exitJqlSubClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlSubClause) return visitor.visitJqlSubClause(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$23486a2f2ddd5bcd extends (0, $5izRN.ParserRuleContext) {
    jqlField() {
        return this.getRuleContext(0, $6551c3dece3fff4e$export$b33300c3d916229a);
    }
    jqlTerminalClauseRhs() {
        return this.getRuleContext(0, $6551c3dece3fff4e$export$93924a205c12d32c);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlTerminalClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlTerminalClause) listener.enterJqlTerminalClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlTerminalClause) listener.exitJqlTerminalClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlTerminalClause) return visitor.visitJqlTerminalClause(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$93924a205c12d32c extends (0, $5izRN.ParserRuleContext) {
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlTerminalClauseRhs;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$c428f709a58396e5 extends $6551c3dece3fff4e$export$93924a205c12d32c {
    jqlEqualsOperator() {
        return this.getRuleContext(0, $6551c3dece3fff4e$export$41e475fc1988e413);
    }
    jqlEmpty() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$ebf0cc785e9ee41a);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlEqualsClause) listener.enterJqlEqualsClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlEqualsClause) listener.exitJqlEqualsClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlEqualsClause) return visitor.visitJqlEqualsClause(this);
        else return visitor.visitChildren(this);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
}
class $6551c3dece3fff4e$export$1b131204ef9fa33d extends $6551c3dece3fff4e$export$93924a205c12d32c {
    jqlLikeOperator() {
        return this.getRuleContext(0, $6551c3dece3fff4e$export$b76fe5387fdd7efd);
    }
    jqlEmpty() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$ebf0cc785e9ee41a);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlLikeClause) listener.enterJqlLikeClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlLikeClause) listener.exitJqlLikeClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlLikeClause) return visitor.visitJqlLikeClause(this);
        else return visitor.visitChildren(this);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
}
class $6551c3dece3fff4e$export$d83706ee80a9852a extends $6551c3dece3fff4e$export$93924a205c12d32c {
    jqlComparisonOperator() {
        return this.getRuleContext(0, $6551c3dece3fff4e$export$d821da0716b3ec95);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$ebf0cc785e9ee41a);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlComparisonClause) listener.enterJqlComparisonClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlComparisonClause) listener.exitJqlComparisonClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlComparisonClause) return visitor.visitJqlComparisonClause(this);
        else return visitor.visitChildren(this);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
}
class $6551c3dece3fff4e$export$2934b8ff22fddd2d extends $6551c3dece3fff4e$export$93924a205c12d32c {
    jqlInOperator() {
        return this.getRuleContext(0, $6551c3dece3fff4e$export$178478bfa8292f72);
    }
    jqlList() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$9cb97a63f2be4864);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$ebf0cc785e9ee41a);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlInClause) listener.enterJqlInClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlInClause) listener.exitJqlInClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlInClause) return visitor.visitJqlInClause(this);
        else return visitor.visitChildren(this);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
}
class $6551c3dece3fff4e$export$8b84310182afcf93 extends $6551c3dece3fff4e$export$93924a205c12d32c {
    jqlIsOperator() {
        return this.getRuleContext(0, $6551c3dece3fff4e$export$e64c31d2830b66e4);
    }
    jqlEmpty() {
        return this.getRuleContext(0, $6551c3dece3fff4e$export$d85a062f90025e5c);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlIsClause) listener.enterJqlIsClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlIsClause) listener.exitJqlIsClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlIsClause) return visitor.visitJqlIsClause(this);
        else return visitor.visitChildren(this);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
}
class $6551c3dece3fff4e$export$5df295dc7a2cac7c extends $6551c3dece3fff4e$export$93924a205c12d32c {
    jqlWasOperator() {
        return this.getRuleContext(0, $6551c3dece3fff4e$export$7e283636700e4a6c);
    }
    jqlEmpty() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$ebf0cc785e9ee41a);
    }
    jqlWasPredicate(i) {
        if (i === undefined) return this.getRuleContexts($6551c3dece3fff4e$export$9fa1e4d63f31b911);
        else return this.getRuleContext(i, $6551c3dece3fff4e$export$9fa1e4d63f31b911);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasClause) listener.enterJqlWasClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasClause) listener.exitJqlWasClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasClause) return visitor.visitJqlWasClause(this);
        else return visitor.visitChildren(this);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
}
class $6551c3dece3fff4e$export$9ac3367aee261b32 extends $6551c3dece3fff4e$export$93924a205c12d32c {
    jqlWasInOperator() {
        return this.getRuleContext(0, $6551c3dece3fff4e$export$b9118b1ed9a78d66);
    }
    jqlList() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$9cb97a63f2be4864);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$ebf0cc785e9ee41a);
    }
    jqlWasPredicate(i) {
        if (i === undefined) return this.getRuleContexts($6551c3dece3fff4e$export$9fa1e4d63f31b911);
        else return this.getRuleContext(i, $6551c3dece3fff4e$export$9fa1e4d63f31b911);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasInClause) listener.enterJqlWasInClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasInClause) listener.exitJqlWasInClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasInClause) return visitor.visitJqlWasInClause(this);
        else return visitor.visitChildren(this);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
}
class $6551c3dece3fff4e$export$7a7defca8628a13c extends $6551c3dece3fff4e$export$93924a205c12d32c {
    jqlChangedOperator() {
        return this.getRuleContext(0, $6551c3dece3fff4e$export$493d626ed78ca66);
    }
    jqlChangedPredicate(i) {
        if (i === undefined) return this.getRuleContexts($6551c3dece3fff4e$export$e77e479a48133015);
        else return this.getRuleContext(i, $6551c3dece3fff4e$export$e77e479a48133015);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlChangedClause) listener.enterJqlChangedClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlChangedClause) listener.exitJqlChangedClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlChangedClause) return visitor.visitJqlChangedClause(this);
        else return visitor.visitChildren(this);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
}
class $6551c3dece3fff4e$export$41e475fc1988e413 extends (0, $5izRN.ParserRuleContext) {
    EQUALS() {
        return this.tryGetToken($6551c3dece3fff4e$export$9c4772e191bdb810.EQUALS, 0);
    }
    NOT_EQUALS() {
        return this.tryGetToken($6551c3dece3fff4e$export$9c4772e191bdb810.NOT_EQUALS, 0);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlEqualsOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlEqualsOperator) listener.enterJqlEqualsOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlEqualsOperator) listener.exitJqlEqualsOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlEqualsOperator) return visitor.visitJqlEqualsOperator(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$b76fe5387fdd7efd extends (0, $5izRN.ParserRuleContext) {
    LIKE() {
        return this.tryGetToken($6551c3dece3fff4e$export$9c4772e191bdb810.LIKE, 0);
    }
    NOT_LIKE() {
        return this.tryGetToken($6551c3dece3fff4e$export$9c4772e191bdb810.NOT_LIKE, 0);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlLikeOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlLikeOperator) listener.enterJqlLikeOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlLikeOperator) listener.exitJqlLikeOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlLikeOperator) return visitor.visitJqlLikeOperator(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$d821da0716b3ec95 extends (0, $5izRN.ParserRuleContext) {
    LT() {
        return this.tryGetToken($6551c3dece3fff4e$export$9c4772e191bdb810.LT, 0);
    }
    GT() {
        return this.tryGetToken($6551c3dece3fff4e$export$9c4772e191bdb810.GT, 0);
    }
    LTEQ() {
        return this.tryGetToken($6551c3dece3fff4e$export$9c4772e191bdb810.LTEQ, 0);
    }
    GTEQ() {
        return this.tryGetToken($6551c3dece3fff4e$export$9c4772e191bdb810.GTEQ, 0);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlComparisonOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlComparisonOperator) listener.enterJqlComparisonOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlComparisonOperator) listener.exitJqlComparisonOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlComparisonOperator) return visitor.visitJqlComparisonOperator(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$178478bfa8292f72 extends (0, $5izRN.ParserRuleContext) {
    IN() {
        return this.getToken($6551c3dece3fff4e$export$9c4772e191bdb810.IN, 0);
    }
    NOT() {
        return this.tryGetToken($6551c3dece3fff4e$export$9c4772e191bdb810.NOT, 0);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlInOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlInOperator) listener.enterJqlInOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlInOperator) listener.exitJqlInOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlInOperator) return visitor.visitJqlInOperator(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$e64c31d2830b66e4 extends (0, $5izRN.ParserRuleContext) {
    IS() {
        return this.getToken($6551c3dece3fff4e$export$9c4772e191bdb810.IS, 0);
    }
    NOT() {
        return this.tryGetToken($6551c3dece3fff4e$export$9c4772e191bdb810.NOT, 0);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlIsOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlIsOperator) listener.enterJqlIsOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlIsOperator) listener.exitJqlIsOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlIsOperator) return visitor.visitJqlIsOperator(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$7e283636700e4a6c extends (0, $5izRN.ParserRuleContext) {
    WAS() {
        return this.getToken($6551c3dece3fff4e$export$9c4772e191bdb810.WAS, 0);
    }
    NOT() {
        return this.tryGetToken($6551c3dece3fff4e$export$9c4772e191bdb810.NOT, 0);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlWasOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasOperator) listener.enterJqlWasOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasOperator) listener.exitJqlWasOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasOperator) return visitor.visitJqlWasOperator(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$b9118b1ed9a78d66 extends (0, $5izRN.ParserRuleContext) {
    WAS() {
        return this.getToken($6551c3dece3fff4e$export$9c4772e191bdb810.WAS, 0);
    }
    IN() {
        return this.getToken($6551c3dece3fff4e$export$9c4772e191bdb810.IN, 0);
    }
    NOT() {
        return this.tryGetToken($6551c3dece3fff4e$export$9c4772e191bdb810.NOT, 0);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlWasInOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasInOperator) listener.enterJqlWasInOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasInOperator) listener.exitJqlWasInOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasInOperator) return visitor.visitJqlWasInOperator(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$493d626ed78ca66 extends (0, $5izRN.ParserRuleContext) {
    CHANGED() {
        return this.getToken($6551c3dece3fff4e$export$9c4772e191bdb810.CHANGED, 0);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlChangedOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlChangedOperator) listener.enterJqlChangedOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlChangedOperator) listener.exitJqlChangedOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlChangedOperator) return visitor.visitJqlChangedOperator(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$b33300c3d916229a extends (0, $5izRN.ParserRuleContext) {
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlField;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$11fec15307d2e17b extends $6551c3dece3fff4e$export$b33300c3d916229a {
    jqlNumber() {
        return this.getRuleContext(0, $6551c3dece3fff4e$export$8737d94a1880e8b3);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNumberField) listener.enterJqlNumberField(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNumberField) listener.exitJqlNumberField(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNumberField) return visitor.visitJqlNumberField(this);
        else return visitor.visitChildren(this);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
}
class $6551c3dece3fff4e$export$b8b24f99f985ebb3 extends $6551c3dece3fff4e$export$b33300c3d916229a {
    jqlString() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$bde73d8ad7c8b71e);
    }
    jqlCustomField() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$401a038855cc5b15);
    }
    jqlFieldProperty(i) {
        if (i === undefined) return this.getRuleContexts($6551c3dece3fff4e$export$b02d0b6637ce0593);
        else return this.getRuleContext(i, $6551c3dece3fff4e$export$b02d0b6637ce0593);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNonNumberField) listener.enterJqlNonNumberField(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNonNumberField) listener.exitJqlNonNumberField(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNonNumberField) return visitor.visitJqlNonNumberField(this);
        else return visitor.visitChildren(this);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
}
class $6551c3dece3fff4e$export$b02d0b6637ce0593 extends (0, $5izRN.ParserRuleContext) {
    LBRACKET() {
        return this.tryGetToken($6551c3dece3fff4e$export$9c4772e191bdb810.LBRACKET, 0);
    }
    RBRACKET() {
        return this.tryGetToken($6551c3dece3fff4e$export$9c4772e191bdb810.RBRACKET, 0);
    }
    jqlPropertyArgument(i) {
        if (i === undefined) return this.getRuleContexts($6551c3dece3fff4e$export$e20ce4a2ed16372c);
        else return this.getRuleContext(i, $6551c3dece3fff4e$export$e20ce4a2ed16372c);
    }
    jqlArgument() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$a95583953c237f88);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlFieldProperty;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlFieldProperty) listener.enterJqlFieldProperty(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlFieldProperty) listener.exitJqlFieldProperty(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlFieldProperty) return visitor.visitJqlFieldProperty(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$401a038855cc5b15 extends (0, $5izRN.ParserRuleContext) {
    CUSTOMFIELD() {
        return this.getToken($6551c3dece3fff4e$export$9c4772e191bdb810.CUSTOMFIELD, 0);
    }
    LBRACKET() {
        return this.getToken($6551c3dece3fff4e$export$9c4772e191bdb810.LBRACKET, 0);
    }
    POSNUMBER() {
        return this.getToken($6551c3dece3fff4e$export$9c4772e191bdb810.POSNUMBER, 0);
    }
    RBRACKET() {
        return this.getToken($6551c3dece3fff4e$export$9c4772e191bdb810.RBRACKET, 0);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlCustomField;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlCustomField) listener.enterJqlCustomField(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlCustomField) listener.exitJqlCustomField(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlCustomField) return visitor.visitJqlCustomField(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$bde73d8ad7c8b71e extends (0, $5izRN.ParserRuleContext) {
    STRING() {
        return this.tryGetToken($6551c3dece3fff4e$export$9c4772e191bdb810.STRING, 0);
    }
    QUOTE_STRING() {
        return this.tryGetToken($6551c3dece3fff4e$export$9c4772e191bdb810.QUOTE_STRING, 0);
    }
    SQUOTE_STRING() {
        return this.tryGetToken($6551c3dece3fff4e$export$9c4772e191bdb810.SQUOTE_STRING, 0);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlString;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlString) listener.enterJqlString(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlString) listener.exitJqlString(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlString) return visitor.visitJqlString(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$8737d94a1880e8b3 extends (0, $5izRN.ParserRuleContext) {
    POSNUMBER() {
        return this.tryGetToken($6551c3dece3fff4e$export$9c4772e191bdb810.POSNUMBER, 0);
    }
    NEGNUMBER() {
        return this.tryGetToken($6551c3dece3fff4e$export$9c4772e191bdb810.NEGNUMBER, 0);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlNumber;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNumber) listener.enterJqlNumber(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNumber) listener.exitJqlNumber(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNumber) return visitor.visitJqlNumber(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
        this._jqlNum = void 0;
    }
}
class $6551c3dece3fff4e$export$2eaac5a9828bf647 extends (0, $5izRN.ParserRuleContext) {
    jqlEmpty() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$ebf0cc785e9ee41a);
    }
    jqlList() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$9cb97a63f2be4864);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlOperand;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlOperand) listener.enterJqlOperand(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlOperand) listener.exitJqlOperand(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlOperand) return visitor.visitJqlOperand(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$d85a062f90025e5c extends (0, $5izRN.ParserRuleContext) {
    EMPTY() {
        return this.getToken($6551c3dece3fff4e$export$9c4772e191bdb810.EMPTY, 0);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlEmpty;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlEmpty) listener.enterJqlEmpty(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlEmpty) listener.exitJqlEmpty(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlEmpty) return visitor.visitJqlEmpty(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$2e17d457b0933bec extends (0, $5izRN.ParserRuleContext) {
    jqlString() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$bde73d8ad7c8b71e);
    }
    jqlNumber() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$8737d94a1880e8b3);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlValue;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlValue) listener.enterJqlValue(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlValue) listener.exitJqlValue(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlValue) return visitor.visitJqlValue(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$ebf0cc785e9ee41a extends (0, $5izRN.ParserRuleContext) {
    jqlFunctionName() {
        return this.getRuleContext(0, $6551c3dece3fff4e$export$1f5f7ac816788f44);
    }
    LPAREN() {
        return this.getToken($6551c3dece3fff4e$export$9c4772e191bdb810.LPAREN, 0);
    }
    RPAREN() {
        return this.getToken($6551c3dece3fff4e$export$9c4772e191bdb810.RPAREN, 0);
    }
    jqlArgumentList() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$83d7c13849b931c3);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlFunction;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlFunction) listener.enterJqlFunction(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlFunction) listener.exitJqlFunction(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlFunction) return visitor.visitJqlFunction(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$1f5f7ac816788f44 extends (0, $5izRN.ParserRuleContext) {
    jqlString() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$bde73d8ad7c8b71e);
    }
    jqlNumber() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$8737d94a1880e8b3);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlFunctionName;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlFunctionName) listener.enterJqlFunctionName(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlFunctionName) listener.exitJqlFunctionName(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlFunctionName) return visitor.visitJqlFunctionName(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$83d7c13849b931c3 extends (0, $5izRN.ParserRuleContext) {
    jqlArgument(i) {
        if (i === undefined) return this.getRuleContexts($6551c3dece3fff4e$export$a95583953c237f88);
        else return this.getRuleContext(i, $6551c3dece3fff4e$export$a95583953c237f88);
    }
    COMMA(i) {
        if (i === undefined) return this.getTokens($6551c3dece3fff4e$export$9c4772e191bdb810.COMMA);
        else return this.getToken($6551c3dece3fff4e$export$9c4772e191bdb810.COMMA, i);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlArgumentList;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlArgumentList) listener.enterJqlArgumentList(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlArgumentList) listener.exitJqlArgumentList(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlArgumentList) return visitor.visitJqlArgumentList(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$9cb97a63f2be4864 extends (0, $5izRN.ParserRuleContext) {
    jqlListStart() {
        return this.getRuleContext(0, $6551c3dece3fff4e$export$c419f717bfc46a5d);
    }
    jqlOperand(i) {
        if (i === undefined) return this.getRuleContexts($6551c3dece3fff4e$export$2eaac5a9828bf647);
        else return this.getRuleContext(i, $6551c3dece3fff4e$export$2eaac5a9828bf647);
    }
    jqlListEnd() {
        return this.getRuleContext(0, $6551c3dece3fff4e$export$f6cd3e372f5ab120);
    }
    COMMA(i) {
        if (i === undefined) return this.getTokens($6551c3dece3fff4e$export$9c4772e191bdb810.COMMA);
        else return this.getToken($6551c3dece3fff4e$export$9c4772e191bdb810.COMMA, i);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlList;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlList) listener.enterJqlList(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlList) listener.exitJqlList(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlList) return visitor.visitJqlList(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$c419f717bfc46a5d extends (0, $5izRN.ParserRuleContext) {
    LPAREN() {
        return this.getToken($6551c3dece3fff4e$export$9c4772e191bdb810.LPAREN, 0);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlListStart;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlListStart) listener.enterJqlListStart(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlListStart) listener.exitJqlListStart(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlListStart) return visitor.visitJqlListStart(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$f6cd3e372f5ab120 extends (0, $5izRN.ParserRuleContext) {
    RPAREN() {
        return this.getToken($6551c3dece3fff4e$export$9c4772e191bdb810.RPAREN, 0);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlListEnd;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlListEnd) listener.enterJqlListEnd(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlListEnd) listener.exitJqlListEnd(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlListEnd) return visitor.visitJqlListEnd(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$e20ce4a2ed16372c extends (0, $5izRN.ParserRuleContext) {
    jqlArgument() {
        return this.getRuleContext(0, $6551c3dece3fff4e$export$a95583953c237f88);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlPropertyArgument;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlPropertyArgument) listener.enterJqlPropertyArgument(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlPropertyArgument) listener.exitJqlPropertyArgument(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlPropertyArgument) return visitor.visitJqlPropertyArgument(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$a95583953c237f88 extends (0, $5izRN.ParserRuleContext) {
    jqlString() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$bde73d8ad7c8b71e);
    }
    jqlNumber() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$8737d94a1880e8b3);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlArgument;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlArgument) listener.enterJqlArgument(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlArgument) listener.exitJqlArgument(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlArgument) return visitor.visitJqlArgument(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$9fa1e4d63f31b911 extends (0, $5izRN.ParserRuleContext) {
    jqlPredicateOperand() {
        return this.getRuleContext(0, $6551c3dece3fff4e$export$6b796c5a4b8c18e);
    }
    jqlDatePredicateOperator() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$dc01290aee731418);
    }
    jqlDateRangePredicateOperator() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$75412b8b6a6442e1);
    }
    jqlUserPredicateOperator() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$ad402332075c8656);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlWasPredicate;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasPredicate) listener.enterJqlWasPredicate(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasPredicate) listener.exitJqlWasPredicate(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasPredicate) return visitor.visitJqlWasPredicate(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$e77e479a48133015 extends (0, $5izRN.ParserRuleContext) {
    jqlPredicateOperand() {
        return this.getRuleContext(0, $6551c3dece3fff4e$export$6b796c5a4b8c18e);
    }
    jqlDatePredicateOperator() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$dc01290aee731418);
    }
    jqlDateRangePredicateOperator() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$75412b8b6a6442e1);
    }
    jqlUserPredicateOperator() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$ad402332075c8656);
    }
    jqlValuePredicateOperator() {
        return this.tryGetRuleContext(0, $6551c3dece3fff4e$export$4239d7c0fbafd3f1);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlChangedPredicate;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlChangedPredicate) listener.enterJqlChangedPredicate(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlChangedPredicate) listener.exitJqlChangedPredicate(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlChangedPredicate) return visitor.visitJqlChangedPredicate(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$dc01290aee731418 extends (0, $5izRN.ParserRuleContext) {
    AFTER() {
        return this.tryGetToken($6551c3dece3fff4e$export$9c4772e191bdb810.AFTER, 0);
    }
    BEFORE() {
        return this.tryGetToken($6551c3dece3fff4e$export$9c4772e191bdb810.BEFORE, 0);
    }
    ON() {
        return this.tryGetToken($6551c3dece3fff4e$export$9c4772e191bdb810.ON, 0);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlDatePredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlDatePredicateOperator) listener.enterJqlDatePredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlDatePredicateOperator) listener.exitJqlDatePredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlDatePredicateOperator) return visitor.visitJqlDatePredicateOperator(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$75412b8b6a6442e1 extends (0, $5izRN.ParserRuleContext) {
    DURING() {
        return this.getToken($6551c3dece3fff4e$export$9c4772e191bdb810.DURING, 0);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlDateRangePredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlDateRangePredicateOperator) listener.enterJqlDateRangePredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlDateRangePredicateOperator) listener.exitJqlDateRangePredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlDateRangePredicateOperator) return visitor.visitJqlDateRangePredicateOperator(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$ad402332075c8656 extends (0, $5izRN.ParserRuleContext) {
    BY() {
        return this.getToken($6551c3dece3fff4e$export$9c4772e191bdb810.BY, 0);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlUserPredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlUserPredicateOperator) listener.enterJqlUserPredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlUserPredicateOperator) listener.exitJqlUserPredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlUserPredicateOperator) return visitor.visitJqlUserPredicateOperator(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$4239d7c0fbafd3f1 extends (0, $5izRN.ParserRuleContext) {
    FROM() {
        return this.tryGetToken($6551c3dece3fff4e$export$9c4772e191bdb810.FROM, 0);
    }
    TO() {
        return this.tryGetToken($6551c3dece3fff4e$export$9c4772e191bdb810.TO, 0);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlValuePredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlValuePredicateOperator) listener.enterJqlValuePredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlValuePredicateOperator) listener.exitJqlValuePredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlValuePredicateOperator) return visitor.visitJqlValuePredicateOperator(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$6b796c5a4b8c18e extends (0, $5izRN.ParserRuleContext) {
    jqlOperand() {
        return this.getRuleContext(0, $6551c3dece3fff4e$export$2eaac5a9828bf647);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlPredicateOperand;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlPredicateOperand) listener.enterJqlPredicateOperand(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlPredicateOperand) listener.exitJqlPredicateOperand(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlPredicateOperand) return visitor.visitJqlPredicateOperand(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$534469b9c8f44139 extends (0, $5izRN.ParserRuleContext) {
    ORDER() {
        return this.getToken($6551c3dece3fff4e$export$9c4772e191bdb810.ORDER, 0);
    }
    BY() {
        return this.getToken($6551c3dece3fff4e$export$9c4772e191bdb810.BY, 0);
    }
    jqlSearchSort(i) {
        if (i === undefined) return this.getRuleContexts($6551c3dece3fff4e$export$c7d8f03f36952a46);
        else return this.getRuleContext(i, $6551c3dece3fff4e$export$c7d8f03f36952a46);
    }
    COMMA(i) {
        if (i === undefined) return this.getTokens($6551c3dece3fff4e$export$9c4772e191bdb810.COMMA);
        else return this.getToken($6551c3dece3fff4e$export$9c4772e191bdb810.COMMA, i);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlOrderBy;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlOrderBy) listener.enterJqlOrderBy(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlOrderBy) listener.exitJqlOrderBy(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlOrderBy) return visitor.visitJqlOrderBy(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $6551c3dece3fff4e$export$c7d8f03f36952a46 extends (0, $5izRN.ParserRuleContext) {
    jqlField() {
        return this.getRuleContext(0, $6551c3dece3fff4e$export$b33300c3d916229a);
    }
    DESC() {
        return this.tryGetToken($6551c3dece3fff4e$export$9c4772e191bdb810.DESC, 0);
    }
    ASC() {
        return this.tryGetToken($6551c3dece3fff4e$export$9c4772e191bdb810.ASC, 0);
    }
    // @Override
    get ruleIndex() {
        return $6551c3dece3fff4e$export$9c4772e191bdb810.RULE_jqlSearchSort;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlSearchSort) listener.enterJqlSearchSort(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlSearchSort) listener.exitJqlSearchSort(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlSearchSort) return visitor.visitJqlSearchSort(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
module.exports["JQLParser"] = $6551c3dece3fff4e$export$9c4772e191bdb810;

});

parcelRegister("a0unS", function(module, exports) {

var $45ATP = parcelRequire("45ATP");

var $ixfCV = parcelRequire("ixfCV");


var $a46d9 = parcelRequire("a46d9");

const $1e8224b025e87c14$export$c11f53c00e0a0ad4 = new RegExp(`[\\s${(0, (/*@__PURE__*/$parcel$interopDefault($a46d9)))(`"'=!<>()~,[]|&{}*/%+^$#@?;`)}]`);
const $1e8224b025e87c14$export$1fa3c1f0578bafad = new Set([
    'a',
    'an',
    'abort',
    'access',
    'add',
    'after',
    'alias',
    'all',
    'alter',
    'and',
    'any',
    'are',
    'as',
    'asc',
    'at',
    'audit',
    'avg',
    'be',
    'before',
    'begin',
    'between',
    'boolean',
    'break',
    'but',
    'by',
    'byte',
    'catch',
    'cf',
    'char',
    'character',
    'check',
    'checkpoint',
    'collate',
    'collation',
    'column',
    'commit',
    'connect',
    'continue',
    'count',
    'create',
    'current',
    'date',
    'decimal',
    'declare',
    'decrement',
    'default',
    'defaults',
    'define',
    'delete',
    'delimiter',
    'desc',
    'difference',
    'distinct',
    'divide',
    'do',
    'double',
    'drop',
    'else',
    'empty',
    'encoding',
    'end',
    'equals',
    'escape',
    'exclusive',
    'exec',
    'execute',
    'exists',
    'explain',
    'false',
    'fetch',
    'file',
    'field',
    'first',
    'float',
    'for',
    'from',
    'function',
    'go',
    'goto',
    'grant',
    'greater',
    'group',
    'having',
    'identified',
    'if',
    'immediate',
    'in',
    'increment',
    'index',
    'initial',
    'inner',
    'inout',
    'input',
    'insert',
    'int',
    'integer',
    'intersect',
    'intersection',
    'into',
    'is',
    'isempty',
    'isnull',
    'it',
    'join',
    'last',
    'left',
    'less',
    'like',
    'limit',
    'lock',
    'long',
    'max',
    'min',
    'minus',
    'mode',
    'modify',
    'modulo',
    'more',
    'multiply',
    'next',
    'no',
    'noaudit',
    'not',
    'notin',
    'nowait',
    'null',
    'number',
    'object',
    'of',
    'on',
    'option',
    'or',
    'order',
    'outer',
    'output',
    'power',
    'previous',
    'prior',
    'privileges',
    'public',
    'raise',
    'raw',
    'remainder',
    'rename',
    'resource',
    'return',
    'returns',
    'revoke',
    'right',
    'row',
    'rowid',
    'rownum',
    'rows',
    'select',
    'session',
    'set',
    'share',
    'size',
    'sqrt',
    'start',
    'strict',
    'string',
    'subtract',
    'such',
    'sum',
    'synonym',
    'table',
    'that',
    'the',
    'their',
    'then',
    'there',
    'these',
    'they',
    'this',
    'to',
    'trans',
    'transaction',
    'trigger',
    'true',
    'uid',
    'union',
    'unique',
    'update',
    'user',
    'validate',
    'values',
    'view',
    'was',
    'when',
    'whenever',
    'where',
    'while',
    'will',
    'with'
]);


const $366d5065625ea8b0$export$3eb9033c48208278 = (jqlString)=>{
    // If the string contains special characters, perform a proper escape
    if ((0, $1e8224b025e87c14$export$c11f53c00e0a0ad4).test(jqlString)) return `"${jqlString.replace(/"/g, '\\"')}"`;
    // If the string matches a reserved word, wrap it in quotes since any
    // special characters would have been caught above already
    if ((0, $1e8224b025e87c14$export$1fa3c1f0578bafad).has(jqlString.toLowerCase()) && (0, $ixfCV.fg)('queue-setting-page-jql-bug')) return `"${jqlString}"`;
    return jqlString;
};



var $gkLFx = parcelRequire("gkLFx");

function $909a1b96bc8f19b5$var$acceptArgument(visitor) {
    return visitor.visitArgument ? visitor.visitArgument(this) : visitor.visitChildren(this);
}
function $909a1b96bc8f19b5$var$enterNode(listener) {
    listener.enterArgument && listener.enterArgument(this);
}
function $909a1b96bc8f19b5$var$exitNode(listener) {
    listener.exitArgument && listener.exitArgument(this);
}
const $909a1b96bc8f19b5$export$6ea29ee575e3f5ff = (value)=>$909a1b96bc8f19b5$export$5b341d50fa5bcdd5(value, (0, $366d5065625ea8b0$export$3eb9033c48208278)(value));
const $909a1b96bc8f19b5$export$84c43d23f51170cb = (text)=>$909a1b96bc8f19b5$export$5b341d50fa5bcdd5((0, $45ATP.normaliseJqlString)(text), text);
const $909a1b96bc8f19b5$export$5b341d50fa5bcdd5 = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $909a1b96bc8f19b5$var$acceptArgument,
        enterNode: $909a1b96bc8f19b5$var$enterNode,
        exitNode: $909a1b96bc8f19b5$var$exitNode,
        getChildren: (0, $gkLFx.noChildren),
        parent: null
    });



var $6acZZ = parcelRequire("6acZZ");

var $cOiMv = parcelRequire("cOiMv");


var $dMJZ1 = parcelRequire("dMJZ1");




function $c9b53414103a4ddc$var$acceptCompoundClause(visitor) {
    return visitor.visitCompoundClause ? visitor.visitCompoundClause(this) : visitor.visitChildren(this);
}
function $c9b53414103a4ddc$var$enterNode(listener) {
    listener.enterCompoundClause && listener.enterCompoundClause(this);
}
function $c9b53414103a4ddc$var$exitNode(listener) {
    listener.exitCompoundClause && listener.exitCompoundClause(this);
}
function $c9b53414103a4ddc$var$getChildren() {
    return [
        this.operator,
        ...this.clauses
    ];
}
const $c9b53414103a4ddc$export$ab714e56a32c25f2 = (operator, clauses)=>{
    return $c9b53414103a4ddc$export$cd65eed8c10b0911(operator, clauses);
};
const $c9b53414103a4ddc$export$cd65eed8c10b0911 = (operator, clauses, position = null)=>{
    const node = {
        type: (0, $cOiMv.NODE_TYPE_CLAUSE),
        clauseType: (0, $6acZZ.CLAUSE_TYPE_COMPOUND),
        operator: operator,
        clauses: clauses,
        position: position,
        accept: $c9b53414103a4ddc$var$acceptCompoundClause,
        enterNode: $c9b53414103a4ddc$var$enterNode,
        exitNode: $c9b53414103a4ddc$var$exitNode,
        getChildren: $c9b53414103a4ddc$var$getChildren,
        parent: null,
        appendClause: $dMJZ1.appendClause,
        remove: $dMJZ1.remove,
        removeClause: $dMJZ1.removeClause,
        replace: $dMJZ1.replace,
        replaceClause: $dMJZ1.replaceClause
    };
    (0, $gkLFx.assignParent)(node);
    return node;
};





function $ab5ac31b3d556d8b$var$acceptCompoundOperator(visitor) {
    return visitor.visitCompoundOperator ? visitor.visitCompoundOperator(this) : visitor.visitChildren(this);
}
function $ab5ac31b3d556d8b$var$enterNode(listener) {
    listener.enterCompoundOperator && listener.enterCompoundOperator(this);
}
function $ab5ac31b3d556d8b$var$exitNode(listener) {
    listener.exitCompoundOperator && listener.exitCompoundOperator(this);
}
const $ab5ac31b3d556d8b$export$84bb3ebbba491aee = (value)=>$ab5ac31b3d556d8b$export$63c33bc3fe74fee6(value, []);
const $ab5ac31b3d556d8b$export$63c33bc3fe74fee6 = (value, operatorPositions)=>({
        value: value,
        positions: operatorPositions,
        position: null,
        accept: $ab5ac31b3d556d8b$var$acceptCompoundOperator,
        enterNode: $ab5ac31b3d556d8b$var$enterNode,
        exitNode: $ab5ac31b3d556d8b$var$exitNode,
        getChildren: (0, $gkLFx.noChildren),
        parent: null
    });






function $16f64f4a689bcdd2$var$acceptField(visitor) {
    return visitor.visitField ? visitor.visitField(this) : visitor.visitChildren(this);
}
function $16f64f4a689bcdd2$var$enterNode(listener) {
    listener.enterField && listener.enterField(this);
}
function $16f64f4a689bcdd2$var$exitNode(listener) {
    listener.exitField && listener.exitField(this);
}
function $16f64f4a689bcdd2$var$getChildren() {
    return this.properties ? [
        ...this.properties
    ] : [];
}
const $16f64f4a689bcdd2$export$e0f35d825088c098 = (value, properties)=>{
    return $16f64f4a689bcdd2$export$2193f8c541622b6(value, (0, $366d5065625ea8b0$export$3eb9033c48208278)(value), properties);
};
const $16f64f4a689bcdd2$export$2193f8c541622b6 = (value, text, properties, position = null)=>{
    const node = {
        text: text,
        value: value,
        properties: properties,
        position: position,
        accept: $16f64f4a689bcdd2$var$acceptField,
        enterNode: $16f64f4a689bcdd2$var$enterNode,
        exitNode: $16f64f4a689bcdd2$var$exitNode,
        getChildren: $16f64f4a689bcdd2$var$getChildren,
        parent: null
    };
    (0, $gkLFx.assignParent)(node);
    return node;
};





var $66cjO = parcelRequire("66cjO");




function $299b893aa23ea047$var$acceptFunctionOperand(visitor) {
    return visitor.visitFunctionOperand ? visitor.visitFunctionOperand(this) : visitor.visitChildren(this);
}
function $299b893aa23ea047$var$enterNode(listener) {
    listener.enterFunctionOperand && listener.enterFunctionOperand(this);
}
function $299b893aa23ea047$var$exitNode(listener) {
    listener.exitFunctionOperand && listener.exitFunctionOperand(this);
}
function $299b893aa23ea047$var$getChildren() {
    return [
        this.function,
        ...this.arguments
    ];
}
const $299b893aa23ea047$export$4f981b0e83488ce = (functionString, args = [])=>$299b893aa23ea047$export$c1f2ce91dc05872a(functionString, args);
const $299b893aa23ea047$export$c1f2ce91dc05872a = (functionString, args, position = null)=>{
    const node = {
        type: (0, $cOiMv.NODE_TYPE_OPERAND),
        operandType: (0, $66cjO.OPERAND_TYPE_FUNCTION),
        function: functionString,
        arguments: args,
        position: position,
        accept: $299b893aa23ea047$var$acceptFunctionOperand,
        enterNode: $299b893aa23ea047$var$enterNode,
        exitNode: $299b893aa23ea047$var$exitNode,
        getChildren: $299b893aa23ea047$var$getChildren,
        parent: null
    };
    (0, $gkLFx.assignParent)(node);
    return node;
};






function $99d8a6912c4b3cbb$var$acceptFunctionString(visitor) {
    return visitor.visitFunction ? visitor.visitFunction(this) : visitor.visitChildren(this);
}
function $99d8a6912c4b3cbb$var$enterNode(listener) {
    listener.enterFunction && listener.enterFunction(this);
}
function $99d8a6912c4b3cbb$var$exitNode(listener) {
    listener.exitFunction && listener.exitFunction(this);
}
const $99d8a6912c4b3cbb$export$4e1bb9a7ff8d0ef9 = (value)=>$99d8a6912c4b3cbb$export$7aa9944588b7a69f(value, (0, $366d5065625ea8b0$export$3eb9033c48208278)(value));
const $99d8a6912c4b3cbb$export$7aa9944588b7a69f = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $99d8a6912c4b3cbb$var$acceptFunctionString,
        enterNode: $99d8a6912c4b3cbb$var$enterNode,
        exitNode: $99d8a6912c4b3cbb$var$exitNode,
        getChildren: (0, $gkLFx.noChildren),
        parent: null
    });


const $44f22a08e2264d71$export$b9e70a00f479ff43 = (query, represents = '', errors = [])=>({
        query: query,
        represents: represents,
        errors: errors
    });










function $d9da26922ec088ec$var$acceptKeywordOperand(visitor) {
    return visitor.visitKeywordOperand ? visitor.visitKeywordOperand(this) : visitor.visitChildren(this);
}
function $d9da26922ec088ec$var$enterNode(listener) {
    listener.enterKeywordOperand && listener.enterKeywordOperand(this);
}
function $d9da26922ec088ec$var$exitNode(listener) {
    listener.exitKeywordOperand && listener.exitKeywordOperand(this);
}
const $d9da26922ec088ec$export$2edd4971ed69f2ce = ()=>$d9da26922ec088ec$export$7cc55480b054047b((0, $66cjO.OPERAND_EMPTY));
const $d9da26922ec088ec$export$7cc55480b054047b = (value, position = null)=>({
        type: (0, $cOiMv.NODE_TYPE_OPERAND),
        operandType: (0, $66cjO.OPERAND_TYPE_KEYWORD),
        value: value,
        position: position,
        accept: $d9da26922ec088ec$var$acceptKeywordOperand,
        enterNode: $d9da26922ec088ec$var$enterNode,
        exitNode: $d9da26922ec088ec$var$exitNode,
        getChildren: (0, $gkLFx.noChildren),
        parent: null
    });













function $81766c65dbab2867$export$d94c54f1aee177c4(operand) {
    this.values.push(...operand.operandType === (0, $66cjO.OPERAND_TYPE_LIST) ? operand.values : [
        operand
    ]);
    (0, $gkLFx.assignParent)(this);
}





function $7bc30d04354a735f$var$acceptListOperand(visitor) {
    return visitor.visitListOperand ? visitor.visitListOperand(this) : visitor.visitChildren(this);
}
function $7bc30d04354a735f$var$enterNode(listener) {
    listener.enterListOperand && listener.enterListOperand(this);
}
function $7bc30d04354a735f$var$exitNode(listener) {
    listener.exitListOperand && listener.exitListOperand(this);
}
function $7bc30d04354a735f$var$getChildren() {
    return [
        ...this.values
    ];
}
const $7bc30d04354a735f$export$769866c3e9d41d50 = (values)=>$7bc30d04354a735f$export$663c7831528c984b(values);
const $7bc30d04354a735f$export$663c7831528c984b = (values, position = null)=>{
    const node = {
        type: (0, $cOiMv.NODE_TYPE_OPERAND),
        operandType: (0, $66cjO.OPERAND_TYPE_LIST),
        values: values,
        position: position,
        accept: $7bc30d04354a735f$var$acceptListOperand,
        enterNode: $7bc30d04354a735f$var$enterNode,
        exitNode: $7bc30d04354a735f$var$exitNode,
        getChildren: $7bc30d04354a735f$var$getChildren,
        parent: null,
        appendOperand: $81766c65dbab2867$export$d94c54f1aee177c4
    };
    (0, $gkLFx.assignParent)(node);
    return node;
};








var $9GGch = parcelRequire("9GGch");





var $1eov5 = parcelRequire("1eov5");




function $936a8849a5dd738a$var$acceptNotClauseOperator(visitor) {
    return visitor.visitNotClauseOperator ? visitor.visitNotClauseOperator(this) : visitor.visitChildren(this);
}
function $936a8849a5dd738a$var$enterNode(listener) {
    listener.enterNotClauseOperator && listener.enterNotClauseOperator(this);
}
function $936a8849a5dd738a$var$exitNode(listener) {
    listener.exitNotClauseOperator && listener.exitNotClauseOperator(this);
}
const $936a8849a5dd738a$export$d2cd8239f99c13d3 = ()=>$936a8849a5dd738a$export$1b15a32bb57b9020();
const $936a8849a5dd738a$export$1b15a32bb57b9020 = (position = null)=>({
        value: (0, $1eov5.CLAUSE_OPERATOR_NOT),
        position: position,
        accept: $936a8849a5dd738a$var$acceptNotClauseOperator,
        enterNode: $936a8849a5dd738a$var$enterNode,
        exitNode: $936a8849a5dd738a$var$exitNode,
        getChildren: (0, $gkLFx.noChildren),
        parent: null
    });


function $b8bf2e2d8c7db4ce$var$acceptNotClause(visitor) {
    return visitor.visitNotClause ? visitor.visitNotClause(this) : visitor.visitChildren(this);
}
function $b8bf2e2d8c7db4ce$var$enterNode(listener) {
    listener.enterNotClause && listener.enterNotClause(this);
}
function $b8bf2e2d8c7db4ce$var$exitNode(listener) {
    listener.exitNotClause && listener.exitNotClause(this);
}
function $b8bf2e2d8c7db4ce$var$getChildren() {
    return [
        this.operator,
        this.clause
    ];
}
const $b8bf2e2d8c7db4ce$export$b4734a9fedb4d44e = (clause)=>{
    return $b8bf2e2d8c7db4ce$export$b25621824fea4548(clause, (0, $936a8849a5dd738a$export$d2cd8239f99c13d3)());
};
const $b8bf2e2d8c7db4ce$export$b25621824fea4548 = (clause, operator, position = null)=>{
    const node = {
        type: (0, $cOiMv.NODE_TYPE_CLAUSE),
        clauseType: (0, $6acZZ.CLAUSE_TYPE_NOT),
        clause: clause,
        operator: operator,
        position: position,
        accept: $b8bf2e2d8c7db4ce$var$acceptNotClause,
        enterNode: $b8bf2e2d8c7db4ce$var$enterNode,
        exitNode: $b8bf2e2d8c7db4ce$var$exitNode,
        getChildren: $b8bf2e2d8c7db4ce$var$getChildren,
        parent: null,
        remove: $9GGch.remove,
        removeClause: $9GGch.removeClause,
        replace: $9GGch.replace,
        replaceClause: $9GGch.replaceClause
    };
    (0, $gkLFx.assignParent)(node);
    return node;
};






function $ff80ad97b75b03ce$var$acceptOperator(visitor) {
    return visitor.visitOperator ? visitor.visitOperator(this) : visitor.visitChildren(this);
}
function $ff80ad97b75b03ce$var$enterNode(listener) {
    listener.enterOperator && listener.enterOperator(this);
}
function $ff80ad97b75b03ce$var$exitNode(listener) {
    listener.exitOperator && listener.exitOperator(this);
}
const $ff80ad97b75b03ce$export$dbd72860f701d4f3 = (value)=>$ff80ad97b75b03ce$export$649025bc60ab9c3b(value, value);
const $ff80ad97b75b03ce$export$649025bc60ab9c3b = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $ff80ad97b75b03ce$var$acceptOperator,
        enterNode: $ff80ad97b75b03ce$var$enterNode,
        exitNode: $ff80ad97b75b03ce$var$exitNode,
        getChildren: (0, $gkLFx.noChildren),
        parent: null
    });






var $54s6f = parcelRequire("54s6f");





var $4AL0V = parcelRequire("4AL0V");




function $de768c9b1342606b$var$acceptOrderByOperator(visitor) {
    return visitor.visitOrderByOperator ? visitor.visitOrderByOperator(this) : visitor.visitChildren(this);
}
function $de768c9b1342606b$var$enterNode(listener) {
    listener.enterOrderByOperator && listener.enterOrderByOperator(this);
}
function $de768c9b1342606b$var$exitNode(listener) {
    listener.exitOrderByOperator && listener.exitOrderByOperator(this);
}
const $de768c9b1342606b$export$c7307b67924c61ea = ()=>$de768c9b1342606b$export$739e30af23a08da0();
const $de768c9b1342606b$export$739e30af23a08da0 = (position = null)=>({
        value: (0, $4AL0V.ORDER_BY_OPERATOR_ORDER_BY),
        position: position,
        accept: $de768c9b1342606b$var$acceptOrderByOperator,
        enterNode: $de768c9b1342606b$var$enterNode,
        exitNode: $de768c9b1342606b$var$exitNode,
        getChildren: (0, $gkLFx.noChildren),
        parent: null
    });


function $6970c42ed35fae01$var$acceptOrderBy(visitor) {
    return visitor.visitOrderBy ? visitor.visitOrderBy(this) : visitor.visitChildren(this);
}
function $6970c42ed35fae01$var$enterNode(listener) {
    listener.enterOrderBy && listener.enterOrderBy(this);
}
function $6970c42ed35fae01$var$exitNode(listener) {
    listener.exitOrderBy && listener.exitOrderBy(this);
}
function $6970c42ed35fae01$var$getChildren() {
    return [
        this.operator,
        ...this.fields
    ];
}
const $6970c42ed35fae01$export$f18af21d6f4dafd8 = (fields)=>{
    return $6970c42ed35fae01$export$e4eb1fa6bc8465c1(fields, (0, $de768c9b1342606b$export$c7307b67924c61ea)());
};
const $6970c42ed35fae01$export$e4eb1fa6bc8465c1 = (fields, operator, position = null)=>{
    const node = {
        type: (0, $cOiMv.NODE_TYPE_ORDER_BY),
        operator: operator,
        fields: fields,
        position: position,
        accept: $6970c42ed35fae01$var$acceptOrderBy,
        enterNode: $6970c42ed35fae01$var$enterNode,
        exitNode: $6970c42ed35fae01$var$exitNode,
        getChildren: $6970c42ed35fae01$var$getChildren,
        parent: null,
        prependOrderField: $54s6f.prependOrderField,
        setOrderDirection: $54s6f.setOrderDirection,
        replace: $54s6f.replace,
        replaceOrderField: $54s6f.replaceOrderField,
        remove: $54s6f.remove,
        removeOrderField: $54s6f.removeOrderField
    };
    (0, $gkLFx.assignParent)(node);
    return node;
};





function $9fcfe31dcddcaaf6$var$acceptOrderByDirection(visitor) {
    return visitor.visitOrderByDirection ? visitor.visitOrderByDirection(this) : visitor.visitChildren(this);
}
function $9fcfe31dcddcaaf6$var$enterNode(listener) {
    listener.enterOrderByDirection && listener.enterOrderByDirection(this);
}
function $9fcfe31dcddcaaf6$var$exitNode(listener) {
    listener.exitOrderByDirection && listener.exitOrderByDirection(this);
}
const $9fcfe31dcddcaaf6$export$864d934efed3ccaa = (value)=>$9fcfe31dcddcaaf6$export$8c65cac1a7852d1f(value);
const $9fcfe31dcddcaaf6$export$8c65cac1a7852d1f = (value, position = null)=>({
        value: value,
        position: position,
        accept: $9fcfe31dcddcaaf6$var$acceptOrderByDirection,
        enterNode: $9fcfe31dcddcaaf6$var$enterNode,
        exitNode: $9fcfe31dcddcaaf6$var$exitNode,
        getChildren: (0, $gkLFx.noChildren),
        parent: null
    });





function $3da48df88f1dd673$export$b596730931a09703(orderDirection) {
    this.direction = orderDirection;
    (0, $gkLFx.assignParent)(this);
}
function $3da48df88f1dd673$export$77ad94ebf1c2b9ed(orderByField) {
    if (this.parent) this.parent.replaceOrderField(this, orderByField);
}
function $3da48df88f1dd673$export$cd7f480d6b8286c3() {
    if (this.parent) this.parent.removeOrderField(this);
}





function $1a35e423bea92ff5$var$acceptOrderByField(visitor) {
    return visitor.visitOrderByField ? visitor.visitOrderByField(this) : visitor.visitChildren(this);
}
function $1a35e423bea92ff5$var$enterNode(listener) {
    listener.enterOrderByField && listener.enterOrderByField(this);
}
function $1a35e423bea92ff5$var$exitNode(listener) {
    listener.exitOrderByField && listener.exitOrderByField(this);
}
function $1a35e423bea92ff5$var$getChildren() {
    const children = [
        this.field
    ];
    if (this.direction) children.push(this.direction);
    return children;
}
const $1a35e423bea92ff5$export$942df63e5e3d3899 = (field, direction)=>$1a35e423bea92ff5$export$661a7786e3d15926(field, direction);
const $1a35e423bea92ff5$export$661a7786e3d15926 = (field, direction, position = null)=>{
    const node = {
        field: field,
        direction: direction,
        position: position,
        accept: $1a35e423bea92ff5$var$acceptOrderByField,
        enterNode: $1a35e423bea92ff5$var$enterNode,
        exitNode: $1a35e423bea92ff5$var$exitNode,
        getChildren: $1a35e423bea92ff5$var$getChildren,
        parent: null,
        setOrderDirection: $3da48df88f1dd673$export$b596730931a09703,
        replace: $3da48df88f1dd673$export$77ad94ebf1c2b9ed,
        remove: $3da48df88f1dd673$export$cd7f480d6b8286c3
    };
    (0, $gkLFx.assignParent)(node);
    return node;
};






function $84f5be9db7431b8d$var$acceptPredicate(visitor) {
    return visitor.visitPredicate ? visitor.visitPredicate(this) : visitor.visitChildren(this);
}
function $84f5be9db7431b8d$var$enterNode(listener) {
    listener.enterPredicate && listener.enterPredicate(this);
}
function $84f5be9db7431b8d$var$exitNode(listener) {
    listener.exitPredicate && listener.exitPredicate(this);
}
function $84f5be9db7431b8d$var$getChildren() {
    const children = [
        this.operator
    ];
    if (this.operand) children.push(this.operand);
    return children;
}
const $84f5be9db7431b8d$export$5fc51e445ce24faf = (operator, operand)=>$84f5be9db7431b8d$export$a767a27ad05a38a2(operator, operand);
const $84f5be9db7431b8d$export$a767a27ad05a38a2 = (operator, operand, position = null)=>{
    const node = {
        operator: operator,
        operand: operand,
        position: position,
        accept: $84f5be9db7431b8d$var$acceptPredicate,
        enterNode: $84f5be9db7431b8d$var$enterNode,
        exitNode: $84f5be9db7431b8d$var$exitNode,
        getChildren: $84f5be9db7431b8d$var$getChildren,
        parent: null
    };
    (0, $gkLFx.assignParent)(node);
    return node;
};





function $1d351e9c88c48519$var$acceptPredicateOperator(visitor) {
    return visitor.visitPredicateOperator ? visitor.visitPredicateOperator(this) : visitor.visitChildren(this);
}
function $1d351e9c88c48519$var$enterNode(listener) {
    listener.enterPredicateOperator && listener.enterPredicateOperator(this);
}
function $1d351e9c88c48519$var$exitNode(listener) {
    listener.exitPredicateOperator && listener.exitPredicateOperator(this);
}
const $1d351e9c88c48519$export$5419b7f16910ea62 = (value)=>$1d351e9c88c48519$export$c69d893689716768(value, value);
const $1d351e9c88c48519$export$c69d893689716768 = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $1d351e9c88c48519$var$acceptPredicateOperator,
        enterNode: $1d351e9c88c48519$var$enterNode,
        exitNode: $1d351e9c88c48519$var$exitNode,
        getChildren: (0, $gkLFx.noChildren),
        parent: null
    });





function $d6de2b943ed3b886$var$acceptProperty(visitor) {
    return visitor.visitProperty ? visitor.visitProperty(this) : visitor.visitChildren(this);
}
function $d6de2b943ed3b886$var$enterNode(listener) {
    listener.enterProperty && listener.enterProperty(this);
}
function $d6de2b943ed3b886$var$exitNode(listener) {
    listener.exitProperty && listener.exitProperty(this);
}
function $d6de2b943ed3b886$var$getChildren() {
    const children = [];
    if (this.key) children.push(this.key);
    if (this.path) return children.concat(this.path);
    return children;
}
const $d6de2b943ed3b886$export$d541bacb2bda4494 = (key, path = [])=>$d6de2b943ed3b886$export$1cbd90994fef1fad(key, path);
const $d6de2b943ed3b886$export$1cbd90994fef1fad = (key, path, position = null)=>{
    const node = {
        key: key,
        path: path,
        position: position,
        accept: $d6de2b943ed3b886$var$acceptProperty,
        enterNode: $d6de2b943ed3b886$var$enterNode,
        exitNode: $d6de2b943ed3b886$var$exitNode,
        getChildren: $d6de2b943ed3b886$var$getChildren,
        parent: null
    };
    (0, $gkLFx.assignParent)(node);
    return node;
};






var $lB6q4 = parcelRequire("lB6q4");




/**
 * AstNode accept functions. We define them outside of the creator function so the same function reference is returned
 * when a creator is invoked multiple times (which is helpful when testing for equality of AST objects).
 */ function $ffb5640a7aac8957$var$acceptQuery(visitor) {
    return visitor.visitQuery ? visitor.visitQuery(this) : visitor.visitChildren(this);
}
function $ffb5640a7aac8957$var$enterNode(listener) {
    listener.enterQuery && listener.enterQuery(this);
}
function $ffb5640a7aac8957$var$exitNode(listener) {
    listener.exitQuery && listener.exitQuery(this);
}
function $ffb5640a7aac8957$var$getChildren() {
    const children = [];
    if (this.where) children.push(this.where);
    if (this.orderBy) children.push(this.orderBy);
    return children;
}
const $ffb5640a7aac8957$export$2fa187e846a241c4 = (where, orderBy)=>$ffb5640a7aac8957$export$bc2d6e2e1fd9014(where, orderBy);
const $ffb5640a7aac8957$export$bc2d6e2e1fd9014 = (where, orderBy, position = null)=>{
    const node = {
        type: (0, $cOiMv.NODE_TYPE_QUERY),
        where: where,
        orderBy: orderBy,
        position: position,
        accept: $ffb5640a7aac8957$var$acceptQuery,
        enterNode: $ffb5640a7aac8957$var$enterNode,
        exitNode: $ffb5640a7aac8957$var$exitNode,
        getChildren: $ffb5640a7aac8957$var$getChildren,
        parent: null,
        appendClause: $lB6q4.appendClause,
        prependOrderField: $lB6q4.prependOrderField,
        setOrderDirection: $lB6q4.setOrderDirection,
        removeClause: $lB6q4.removeClause,
        replaceClause: $lB6q4.replaceClause,
        replaceOrderBy: $lB6q4.replaceOrderBy,
        removeOrderBy: $lB6q4.removeOrderBy
    };
    (0, $gkLFx.assignParent)(node);
    return node;
};








var $lfgPa = parcelRequire("lfgPa");




function $64e15f6db67ad4e5$var$acceptTerminalClause(visitor) {
    return visitor.visitTerminalClause ? visitor.visitTerminalClause(this) : visitor.visitChildren(this);
}
function $64e15f6db67ad4e5$var$enterNode(listener) {
    listener.enterTerminalClause && listener.enterTerminalClause(this);
}
function $64e15f6db67ad4e5$var$exitNode(listener) {
    listener.exitTerminalClause && listener.exitTerminalClause(this);
}
function $64e15f6db67ad4e5$var$getChildren() {
    const children = [
        this.field
    ];
    if (this.operator) children.push(this.operator);
    if (this.operand) children.push(this.operand);
    return children.concat(this.predicates);
}
const $64e15f6db67ad4e5$export$2627cbe08dd86b00 = (field, operator, operand, predicates = [])=>{
    return $64e15f6db67ad4e5$export$cc08e43598d091fc(field, operator, operand, predicates);
};
const $64e15f6db67ad4e5$export$cc08e43598d091fc = (field, operator, operand, predicates, position = null)=>{
    const node = {
        type: (0, $cOiMv.NODE_TYPE_CLAUSE),
        clauseType: (0, $6acZZ.CLAUSE_TYPE_TERMINAL),
        field: field,
        operator: operator,
        operand: operand,
        predicates: predicates,
        position: position,
        accept: $64e15f6db67ad4e5$var$acceptTerminalClause,
        enterNode: $64e15f6db67ad4e5$var$enterNode,
        exitNode: $64e15f6db67ad4e5$var$exitNode,
        getChildren: $64e15f6db67ad4e5$var$getChildren,
        parent: null,
        setOperator: $lfgPa.setOperator,
        setOperand: $lfgPa.setOperand,
        appendOperand: $lfgPa.appendOperand,
        remove: $lfgPa.remove,
        replace: $lfgPa.replace
    };
    (0, $gkLFx.assignParent)(node);
    return node;
};













function $d2c34f70e71c98e0$var$acceptValueOperand(visitor) {
    return visitor.visitValueOperand ? visitor.visitValueOperand(this) : visitor.visitChildren(this);
}
function $d2c34f70e71c98e0$var$enterNode(listener) {
    listener.enterValueOperand && listener.enterValueOperand(this);
}
function $d2c34f70e71c98e0$var$exitNode(listener) {
    listener.exitValueOperand && listener.exitValueOperand(this);
}
const $d2c34f70e71c98e0$export$2b6e4d2ed8d53bf3 = (value)=>$d2c34f70e71c98e0$export$79c37d97caac8627(value, (0, $366d5065625ea8b0$export$3eb9033c48208278)(value));
const $d2c34f70e71c98e0$export$3ac9155bde56a45f = (text)=>$d2c34f70e71c98e0$export$79c37d97caac8627((0, $45ATP.normaliseJqlString)(text), text);
const $d2c34f70e71c98e0$export$79c37d97caac8627 = (value, text, position = null)=>({
        type: (0, $cOiMv.NODE_TYPE_OPERAND),
        operandType: (0, $66cjO.OPERAND_TYPE_VALUE),
        text: text,
        value: value,
        position: position,
        accept: $d2c34f70e71c98e0$var$acceptValueOperand,
        enterNode: $d2c34f70e71c98e0$var$enterNode,
        exitNode: $d2c34f70e71c98e0$var$exitNode,
        getChildren: (0, $gkLFx.noChildren),
        parent: null
    });


const $2ce8878373ed49a1$export$64d991963cfb5532 = {
    query: (0, $ffb5640a7aac8957$export$bc2d6e2e1fd9014),
    compoundClause: (0, $c9b53414103a4ddc$export$cd65eed8c10b0911),
    compoundOperator: (0, $ab5ac31b3d556d8b$export$63c33bc3fe74fee6),
    terminalClause: (0, $64e15f6db67ad4e5$export$cc08e43598d091fc),
    notClause: (0, $b8bf2e2d8c7db4ce$export$b25621824fea4548),
    notClauseOperator: (0, $936a8849a5dd738a$export$1b15a32bb57b9020),
    predicate: (0, $84f5be9db7431b8d$export$a767a27ad05a38a2),
    predicateOperator: (0, $1d351e9c88c48519$export$c69d893689716768),
    field: (0, $16f64f4a689bcdd2$export$2193f8c541622b6),
    property: (0, $d6de2b943ed3b886$export$1cbd90994fef1fad),
    operator: (0, $ff80ad97b75b03ce$export$649025bc60ab9c3b),
    valueOperand: (0, $d2c34f70e71c98e0$export$79c37d97caac8627),
    keywordOperand: (0, $d9da26922ec088ec$export$7cc55480b054047b),
    functionOperand: (0, $299b893aa23ea047$export$c1f2ce91dc05872a),
    functionString: (0, $99d8a6912c4b3cbb$export$7aa9944588b7a69f),
    argument: (0, $909a1b96bc8f19b5$export$5b341d50fa5bcdd5),
    listOperand: (0, $7bc30d04354a735f$export$663c7831528c984b),
    orderBy: (0, $6970c42ed35fae01$export$e4eb1fa6bc8465c1),
    orderByOperator: (0, $de768c9b1342606b$export$739e30af23a08da0),
    orderByField: (0, $1a35e423bea92ff5$export$661a7786e3d15926),
    orderByDirection: (0, $9fcfe31dcddcaaf6$export$8c65cac1a7852d1f)
};
const $2ce8878373ed49a1$var$_default_1 = {
    jast: $44f22a08e2264d71$export$b9e70a00f479ff43,
    query: $ffb5640a7aac8957$export$2fa187e846a241c4,
    compoundClause: $c9b53414103a4ddc$export$ab714e56a32c25f2,
    compoundOperator: $ab5ac31b3d556d8b$export$84bb3ebbba491aee,
    terminalClause: $64e15f6db67ad4e5$export$2627cbe08dd86b00,
    notClause: $b8bf2e2d8c7db4ce$export$b4734a9fedb4d44e,
    notClauseOperator: $936a8849a5dd738a$export$d2cd8239f99c13d3,
    predicate: $84f5be9db7431b8d$export$5fc51e445ce24faf,
    predicateOperator: $1d351e9c88c48519$export$5419b7f16910ea62,
    field: $16f64f4a689bcdd2$export$e0f35d825088c098,
    property: $d6de2b943ed3b886$export$d541bacb2bda4494,
    operator: $ff80ad97b75b03ce$export$dbd72860f701d4f3,
    valueOperand: $d2c34f70e71c98e0$export$2b6e4d2ed8d53bf3,
    keywordOperand: $d9da26922ec088ec$export$2edd4971ed69f2ce,
    functionOperand: $299b893aa23ea047$export$4f981b0e83488ce,
    functionString: $99d8a6912c4b3cbb$export$4e1bb9a7ff8d0ef9,
    argument: $909a1b96bc8f19b5$export$6ea29ee575e3f5ff,
    listOperand: $7bc30d04354a735f$export$769866c3e9d41d50,
    orderBy: $6970c42ed35fae01$export$f18af21d6f4dafd8,
    orderByOperator: $de768c9b1342606b$export$c7307b67924c61ea,
    orderByField: $1a35e423bea92ff5$export$942df63e5e3d3899,
    orderByDirection: $9fcfe31dcddcaaf6$export$864d934efed3ccaa,
    byText: {
        argument: (0, $909a1b96bc8f19b5$export$84c43d23f51170cb),
        valueOperand: (0, $d2c34f70e71c98e0$export$3ac9155bde56a45f)
    }
};
var $2ce8878373ed49a1$export$2e2bcd8739ae039 = $2ce8878373ed49a1$var$_default_1;
module.exports["internalCreators"] = $2ce8878373ed49a1$export$64d991963cfb5532;
module.exports["default"] = $2ce8878373ed49a1$export$2e2bcd8739ae039;

});

parcelRegister("45ATP", function(module, exports) {
const $0da5e7ee41c2b5df$export$7a0b99b892e0dda8 = (maybeQuotedString)=>{
    if (maybeQuotedString.length < 2) return false;
    return maybeQuotedString[0] === "'" && maybeQuotedString[maybeQuotedString.length - 1] === "'" && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
};
const $0da5e7ee41c2b5df$export$d5efd6512db694fd = (maybeQuotedString)=>{
    if (maybeQuotedString.length < 2) return false;
    return maybeQuotedString[0] === '"' && maybeQuotedString[maybeQuotedString.length - 1] === '"' && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
};
const $0da5e7ee41c2b5df$export$b86601123607fee5 = (maybeQuotedString)=>$0da5e7ee41c2b5df$export$7a0b99b892e0dda8(maybeQuotedString) || $0da5e7ee41c2b5df$export$d5efd6512db694fd(maybeQuotedString);
const $0da5e7ee41c2b5df$export$cecf78a779acc0ff = (maybeQuotedString)=>{
    if ($0da5e7ee41c2b5df$export$b86601123607fee5(maybeQuotedString)) return maybeQuotedString.slice(1, -1).replace(/(?:\\(.))/g, '$1');
    if (maybeQuotedString.startsWith('"') || maybeQuotedString.startsWith("'")) return maybeQuotedString.slice(1).replace(/(?:\\(.))/g, '$1');
    return maybeQuotedString;
};
module.exports["normaliseJqlString"] = $0da5e7ee41c2b5df$export$cecf78a779acc0ff;

});

parcelRegister("6acZZ", function(module, exports) {
const $31c7b88c4db8faa8$export$7a58b23488ea076b = 'compound';
const $31c7b88c4db8faa8$export$ae56b4ef248a2b6a = 'terminal';
const $31c7b88c4db8faa8$export$e356b89f8c8d2fcb = 'not';
module.exports["CLAUSE_TYPE_COMPOUND"] = $31c7b88c4db8faa8$export$7a58b23488ea076b;
module.exports["CLAUSE_TYPE_TERMINAL"] = $31c7b88c4db8faa8$export$ae56b4ef248a2b6a;
module.exports["CLAUSE_TYPE_NOT"] = $31c7b88c4db8faa8$export$e356b89f8c8d2fcb;

});

parcelRegister("cOiMv", function(module, exports) {
const $4e6bb2292b1ae9d2$export$98dda21ec825792 = 'query';
const $4e6bb2292b1ae9d2$export$2d205682cc545947 = 'clause';
const $4e6bb2292b1ae9d2$export$d2f212d8ddbc8d1d = 'operand';
const $4e6bb2292b1ae9d2$export$da0f73edded4a63d = 'order_by';
module.exports["NODE_TYPE_QUERY"] = $4e6bb2292b1ae9d2$export$98dda21ec825792;
module.exports["NODE_TYPE_CLAUSE"] = $4e6bb2292b1ae9d2$export$2d205682cc545947;
module.exports["NODE_TYPE_OPERAND"] = $4e6bb2292b1ae9d2$export$d2f212d8ddbc8d1d;
module.exports["NODE_TYPE_ORDER_BY"] = $4e6bb2292b1ae9d2$export$da0f73edded4a63d;

});

parcelRegister("dMJZ1", function(module, exports) {
$parcel$export(module.exports, "appendClause", () => appendClause);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceClause", () => replaceClause);

var $6acZZ = parcelRequire("6acZZ");


var $gkLFx = parcelRequire("gkLFx");

function appendClause(clause) {
    let clausesToAppend = [
        clause
    ];
    // If the clause to append is compound with a matching operator then we flatten it into the current clause
    if (clause.clauseType === (0, $6acZZ.CLAUSE_TYPE_COMPOUND) && clause.operator.value === this.operator.value) clausesToAppend = clause.clauses;
    this.clauses.push(...clausesToAppend);
    (0, $gkLFx.assignParent)(this);
}
function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function removeClause(clause) {
    this.clauses = this.clauses.filter((val)=>val !== clause);
    if (this.clauses.length === 1) this.replace(this.clauses[0]);
    else if (this.clauses.length === 0) this.remove();
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}
function replaceClause(clause, nextClause) {
    this.clauses = this.clauses.map((child)=>{
        return child === clause ? nextClause : child;
    });
    (0, $gkLFx.assignParent)(this);
}

});

parcelRegister("66cjO", function(module, exports) {
const $a22b18f233cad889$export$38accfc5a5d1c113 = 'value';
const $a22b18f233cad889$export$f6049126fd97001f = 'keyword';
const $a22b18f233cad889$export$19c7c729db381f9d = 'function';
const $a22b18f233cad889$export$fabec4aebba3f4df = 'list';
const $a22b18f233cad889$export$1c46dca02aac24dd = 'empty';
module.exports["OPERAND_TYPE_VALUE"] = $a22b18f233cad889$export$38accfc5a5d1c113;
module.exports["OPERAND_TYPE_KEYWORD"] = $a22b18f233cad889$export$f6049126fd97001f;
module.exports["OPERAND_TYPE_FUNCTION"] = $a22b18f233cad889$export$19c7c729db381f9d;
module.exports["OPERAND_TYPE_LIST"] = $a22b18f233cad889$export$fabec4aebba3f4df;
module.exports["OPERAND_EMPTY"] = $a22b18f233cad889$export$1c46dca02aac24dd;

});

parcelRegister("9GGch", function(module, exports) {
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceClause", () => replaceClause);

var $gkLFx = parcelRequire("gkLFx");

function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function removeClause(clause) {
    if (this.clause === clause) this.remove();
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}
function replaceClause(clause, nextClause) {
    if (this.clause === clause) {
        this.clause = nextClause;
        (0, $gkLFx.assignParent)(this);
    }
}

});

parcelRegister("1eov5", function(module, exports) {
const $d39c7d4100a8feab$export$c6c71ceedb15cda9 = 'not';
const $d39c7d4100a8feab$export$466517a888d00195 = '=';
const $d39c7d4100a8feab$export$6d0d8810623974a5 = '!=';
const $d39c7d4100a8feab$export$bcbb090ab3c498b3 = '>';
const $d39c7d4100a8feab$export$4bf1a4aa659c6ea4 = '<';
const $d39c7d4100a8feab$export$83ce674214a54b2a = '>=';
const $d39c7d4100a8feab$export$9629fd1727ef62ee = '<=';
const $d39c7d4100a8feab$export$c4e3fb55e320e979 = 'in';
const $d39c7d4100a8feab$export$f9857532eaa24ddc = 'not in';
const $d39c7d4100a8feab$export$221595834b8766ab = '~';
const $d39c7d4100a8feab$export$fcefabf94a9bffbf = '!~';
const $d39c7d4100a8feab$export$4feeb3f4ff56bcef = 'is';
const $d39c7d4100a8feab$export$d08d969a0da27188 = 'is not';
const $d39c7d4100a8feab$export$8f907e179985256d = 'was';
const $d39c7d4100a8feab$export$cc7b9d0b3ee23193 = 'was in';
const $d39c7d4100a8feab$export$585d3c004af078bb = 'was not in';
const $d39c7d4100a8feab$export$123eaa9ccc2d9445 = 'was not';
const $d39c7d4100a8feab$export$15f5b446ba8c941e = 'changed';
const $d39c7d4100a8feab$export$643c6101f3fc8547 = [
    $d39c7d4100a8feab$export$466517a888d00195,
    $d39c7d4100a8feab$export$6d0d8810623974a5
];
const $d39c7d4100a8feab$export$329664c9cf18cca6 = [
    $d39c7d4100a8feab$export$221595834b8766ab,
    $d39c7d4100a8feab$export$fcefabf94a9bffbf
];
const $d39c7d4100a8feab$export$1b167a3705885a8b = [
    $d39c7d4100a8feab$export$4bf1a4aa659c6ea4,
    $d39c7d4100a8feab$export$bcbb090ab3c498b3,
    $d39c7d4100a8feab$export$9629fd1727ef62ee,
    $d39c7d4100a8feab$export$83ce674214a54b2a
];
const $d39c7d4100a8feab$export$f25cf16c2270312f = [
    $d39c7d4100a8feab$export$c4e3fb55e320e979,
    $d39c7d4100a8feab$export$f9857532eaa24ddc
];
const $d39c7d4100a8feab$export$eb58cfffe4a6b805 = [
    $d39c7d4100a8feab$export$4feeb3f4ff56bcef,
    $d39c7d4100a8feab$export$d08d969a0da27188
];
const $d39c7d4100a8feab$export$c22a981f581de218 = [
    $d39c7d4100a8feab$export$8f907e179985256d,
    $d39c7d4100a8feab$export$123eaa9ccc2d9445
];
const $d39c7d4100a8feab$export$6d08c4699bb75284 = [
    $d39c7d4100a8feab$export$cc7b9d0b3ee23193,
    $d39c7d4100a8feab$export$585d3c004af078bb
];
const $d39c7d4100a8feab$export$b7dc214eef214c1c = [
    $d39c7d4100a8feab$export$15f5b446ba8c941e
];
const $d39c7d4100a8feab$export$184799fc79ccac89 = [
    ...$d39c7d4100a8feab$export$643c6101f3fc8547,
    ...$d39c7d4100a8feab$export$329664c9cf18cca6,
    ...$d39c7d4100a8feab$export$1b167a3705885a8b,
    ...$d39c7d4100a8feab$export$f25cf16c2270312f,
    ...$d39c7d4100a8feab$export$eb58cfffe4a6b805,
    ...$d39c7d4100a8feab$export$c22a981f581de218,
    ...$d39c7d4100a8feab$export$6d08c4699bb75284,
    ...$d39c7d4100a8feab$export$b7dc214eef214c1c
];
const $d39c7d4100a8feab$export$77c793736847e030 = [
    $d39c7d4100a8feab$export$c4e3fb55e320e979,
    $d39c7d4100a8feab$export$f9857532eaa24ddc,
    $d39c7d4100a8feab$export$cc7b9d0b3ee23193,
    $d39c7d4100a8feab$export$585d3c004af078bb
];
module.exports["CLAUSE_OPERATOR_NOT"] = $d39c7d4100a8feab$export$c6c71ceedb15cda9;
module.exports["OPERATOR_EQUALS"] = $d39c7d4100a8feab$export$466517a888d00195;
module.exports["OPERATOR_NOT_EQUALS"] = $d39c7d4100a8feab$export$6d0d8810623974a5;
module.exports["OPERATOR_GT"] = $d39c7d4100a8feab$export$bcbb090ab3c498b3;
module.exports["OPERATOR_LT"] = $d39c7d4100a8feab$export$4bf1a4aa659c6ea4;
module.exports["OPERATOR_GT_EQUALS"] = $d39c7d4100a8feab$export$83ce674214a54b2a;
module.exports["OPERATOR_LT_EQUALS"] = $d39c7d4100a8feab$export$9629fd1727ef62ee;
module.exports["OPERATOR_IN"] = $d39c7d4100a8feab$export$c4e3fb55e320e979;
module.exports["OPERATOR_NOT_IN"] = $d39c7d4100a8feab$export$f9857532eaa24ddc;
module.exports["OPERATOR_LIKE"] = $d39c7d4100a8feab$export$221595834b8766ab;
module.exports["OPERATOR_NOT_LIKE"] = $d39c7d4100a8feab$export$fcefabf94a9bffbf;
module.exports["OPERATOR_IS"] = $d39c7d4100a8feab$export$4feeb3f4ff56bcef;
module.exports["OPERATOR_IS_NOT"] = $d39c7d4100a8feab$export$d08d969a0da27188;
module.exports["OPERATOR_WAS"] = $d39c7d4100a8feab$export$8f907e179985256d;
module.exports["OPERATOR_WAS_IN"] = $d39c7d4100a8feab$export$cc7b9d0b3ee23193;
module.exports["OPERATOR_WAS_NOT_IN"] = $d39c7d4100a8feab$export$585d3c004af078bb;
module.exports["OPERATOR_WAS_NOT"] = $d39c7d4100a8feab$export$123eaa9ccc2d9445;
module.exports["OPERATOR_CHANGED"] = $d39c7d4100a8feab$export$15f5b446ba8c941e;
module.exports["EQUALS_OPERATORS"] = $d39c7d4100a8feab$export$643c6101f3fc8547;
module.exports["LIKE_OPERATORS"] = $d39c7d4100a8feab$export$329664c9cf18cca6;
module.exports["COMPARISON_OPERATORS"] = $d39c7d4100a8feab$export$1b167a3705885a8b;
module.exports["IN_OPERATORS"] = $d39c7d4100a8feab$export$f25cf16c2270312f;
module.exports["IS_OPERATORS"] = $d39c7d4100a8feab$export$eb58cfffe4a6b805;
module.exports["WAS_OPERATORS"] = $d39c7d4100a8feab$export$c22a981f581de218;
module.exports["WAS_IN_OPERATORS"] = $d39c7d4100a8feab$export$6d08c4699bb75284;
module.exports["CHANGED_OPERATORS"] = $d39c7d4100a8feab$export$b7dc214eef214c1c;
module.exports["OPERATORS"] = $d39c7d4100a8feab$export$184799fc79ccac89;
module.exports["LIST_OPERATORS"] = $d39c7d4100a8feab$export$77c793736847e030;

});

parcelRegister("54s6f", function(module, exports) {
$parcel$export(module.exports, "prependOrderField", () => prependOrderField);
$parcel$export(module.exports, "setOrderDirection", () => setOrderDirection);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceOrderField", () => replaceOrderField);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeOrderField", () => removeOrderField);

var $gkLFx = parcelRequire("gkLFx");

function prependOrderField(orderField) {
    this.fields.unshift(orderField);
    (0, $gkLFx.assignParent)(this);
}
function setOrderDirection(orderDirection) {
    if (this.fields.length > 0) this.fields[0].setOrderDirection(orderDirection);
}
function replace(nextOrderBy) {
    if (this.parent) this.parent.replaceOrderBy(nextOrderBy);
}
function replaceOrderField(orderByField, nextOrderByField) {
    this.fields = this.fields.map((child)=>{
        return child === orderByField ? nextOrderByField : child;
    });
    (0, $gkLFx.assignParent)(this);
}
function remove() {
    if (this.parent) this.parent.removeOrderBy();
}
function removeOrderField(orderByField) {
    this.fields = this.fields.filter((field)=>field !== orderByField);
    if (this.fields.length === 0) this.remove();
}

});

parcelRegister("4AL0V", function(module, exports) {
const $07cbc25508b3d5f8$export$ca51f5fd60a74517 = 'ORDER BY';
const $07cbc25508b3d5f8$export$6d60017b9e092e73 = 'ASC';
const $07cbc25508b3d5f8$export$2ea27ea5f2121899 = 'DESC';
module.exports["ORDER_BY_OPERATOR_ORDER_BY"] = $07cbc25508b3d5f8$export$ca51f5fd60a74517;
module.exports["ORDER_BY_DIRECTION_ASC"] = $07cbc25508b3d5f8$export$6d60017b9e092e73;
module.exports["ORDER_BY_DIRECTION_DESC"] = $07cbc25508b3d5f8$export$2ea27ea5f2121899;

});

parcelRegister("lB6q4", function(module, exports) {
$parcel$export(module.exports, "appendClause", () => appendClause);
$parcel$export(module.exports, "prependOrderField", () => prependOrderField);
$parcel$export(module.exports, "setOrderDirection", () => setOrderDirection);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replaceOrderBy", () => replaceOrderBy);
$parcel$export(module.exports, "replaceClause", () => replaceClause);
$parcel$export(module.exports, "removeOrderBy", () => removeOrderBy);

var $a0unS = parcelRequire("a0unS");


var $gkLFx = parcelRequire("gkLFx");

function appendClause(clause, compoundOperatorValue) {
    if (!this.where) this.where = clause;
    else {
        const nextCompoundOperator = (0, $a0unS.default).compoundOperator(compoundOperatorValue);
        const nextClause = (0, $a0unS.default).compoundClause(nextCompoundOperator, []);
        // Append previous and new clause which will flatten compound clauses with matching operators.
        nextClause.appendClause(this.where);
        nextClause.appendClause(clause);
        this.where = nextClause;
    }
    (0, $gkLFx.assignParent)(this);
}
function prependOrderField(orderField) {
    if (!this.orderBy) {
        this.orderBy = (0, $a0unS.default).orderBy([
            orderField
        ]);
        (0, $gkLFx.assignParent)(this);
    } else this.orderBy.prependOrderField(orderField);
}
function setOrderDirection(orderDirection) {
    if (this.orderBy) this.orderBy.setOrderDirection(orderDirection);
}
function removeClause(clause) {
    if (this.where === clause) this.where = undefined;
}
function replaceOrderBy(orderBy) {
    if (orderBy && orderBy.fields.length === 0) this.removeOrderBy();
    else {
        this.orderBy = orderBy;
        (0, $gkLFx.assignParent)(this);
    }
}
function replaceClause(clause, nextClause) {
    if (this.where === clause) {
        this.where = nextClause;
        (0, $gkLFx.assignParent)(this);
    }
}
function removeOrderBy() {
    this.orderBy = undefined;
}

});

parcelRegister("lfgPa", function(module, exports) {
$parcel$export(module.exports, "setOperator", () => setOperator);
$parcel$export(module.exports, "setOperand", () => setOperand);
$parcel$export(module.exports, "appendOperand", () => appendOperand);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "replace", () => replace);

var $66cjO = parcelRequire("66cjO");


var $a0unS = parcelRequire("a0unS");


var $gkLFx = parcelRequire("gkLFx");

function setOperator(operator) {
    this.operator = operator;
    (0, $gkLFx.assignParent)(this);
}
function setOperand(operand) {
    this.operand = operand;
    (0, $gkLFx.assignParent)(this);
}
function appendOperand(operand) {
    if (this.operand) {
        if (this.operand.operandType === (0, $66cjO.OPERAND_TYPE_LIST)) this.operand.appendOperand(operand);
        else this.setOperand((0, $a0unS.default).listOperand([
            this.operand,
            ...operand.operandType === (0, $66cjO.OPERAND_TYPE_LIST) ? operand.values : [
                operand
            ]
        ]));
    } else this.setOperand(operand);
}
function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}

});

parcelRegister("4jT2n", function(module, exports) {

var $jLG6B = parcelRequire("jLG6B");

class $2d76f42e416f8d64$export$3276184116160c41 extends (0, $jLG6B.JQLParseError) {
    constructor(message, start, stop, line, charPositionInLine){
        super(message);
        /**
     * The starting character position (zero-indexed) of the offending token.
     */ this.start = void 0;
        /**
     * The last character position (zero-indexed) of the offending token.
     */ this.stop = void 0;
        /**
     * The line number (starting from 1) in the input where the error occurred.
     */ this.line = void 0;
        /**
     * The character position (zero-indexed) within that line where the error occurred.
     */ this.charPositionInLine = void 0;
        this.name = 'JQLSyntaxError';
        this.start = start;
        this.stop = stop;
        this.line = line;
        this.charPositionInLine = charPositionInLine;
    }
}
module.exports["JQLSyntaxError"] = $2d76f42e416f8d64$export$3276184116160c41;

});

parcelRegister("3iWYJ", function(module, exports) {
const $919cfaa46bda42d0$export$6d6d48d210d3ca97 = 'and';
const $919cfaa46bda42d0$export$7b8f0a728d79a753 = 'or';
module.exports["COMPOUND_OPERATOR_AND"] = $919cfaa46bda42d0$export$6d6d48d210d3ca97;
module.exports["COMPOUND_OPERATOR_OR"] = $919cfaa46bda42d0$export$7b8f0a728d79a753;

});

parcelRegister("dcrz0", function(module, exports) {

var $1eov5 = parcelRequire("1eov5");

const $896dd6791b728848$export$4e40859592ee7ac2 = (operator)=>(0, $1eov5.OPERATORS).includes(operator);
const $896dd6791b728848$export$6d0fc196fa8a1673 = (operator)=>(0, $1eov5.EQUALS_OPERATORS).includes(operator);
const $896dd6791b728848$export$ad91b6d6a89cb64e = (operator)=>(0, $1eov5.LIKE_OPERATORS).includes(operator);
const $896dd6791b728848$export$4477c442bd5c2a6d = (operator)=>(0, $1eov5.COMPARISON_OPERATORS).includes(operator);
const $896dd6791b728848$export$c5e1cdef30e30bff = (operator)=>(0, $1eov5.IN_OPERATORS).includes(operator);
const $896dd6791b728848$export$ccc3334744e395c7 = (operator)=>(0, $1eov5.IS_OPERATORS).includes(operator);
const $896dd6791b728848$export$2b1c5d7e7856f91d = (operator)=>(0, $1eov5.WAS_OPERATORS).includes(operator);
const $896dd6791b728848$export$55d8c9b20d99509f = (operator)=>(0, $1eov5.WAS_IN_OPERATORS).includes(operator);
const $896dd6791b728848$export$b65d23d23ade534b = (operator)=>(0, $1eov5.CHANGED_OPERATORS).includes(operator);
const $896dd6791b728848$export$b09522e4061bbdd6 = (operator)=>(0, $1eov5.LIST_OPERATORS).includes(operator);
module.exports["isOperator"] = $896dd6791b728848$export$4e40859592ee7ac2;
module.exports["isEqualsOperator"] = $896dd6791b728848$export$6d0fc196fa8a1673;
module.exports["isLikeOperator"] = $896dd6791b728848$export$ad91b6d6a89cb64e;
module.exports["isComparisonOperator"] = $896dd6791b728848$export$4477c442bd5c2a6d;
module.exports["isInOperator"] = $896dd6791b728848$export$c5e1cdef30e30bff;
module.exports["isIsOperator"] = $896dd6791b728848$export$ccc3334744e395c7;
module.exports["isWasOperator"] = $896dd6791b728848$export$2b1c5d7e7856f91d;
module.exports["isWasInOperator"] = $896dd6791b728848$export$55d8c9b20d99509f;
module.exports["isChangedOperator"] = $896dd6791b728848$export$b65d23d23ade534b;
module.exports["isListOperator"] = $896dd6791b728848$export$b09522e4061bbdd6;

});

parcelRegister("c90ex", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $8d7681ae139968b9$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $8d7681ae139968b9$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Array2DHashSet = void 0;

var $9Rq82 = parcelRequire("9Rq82");


var $egnO5 = parcelRequire("egnO5");


var $ffTXa = parcelRequire("ffTXa");


var $kPsXR = parcelRequire("kPsXR");

/** {@link Set} implementation with closed hashing (open addressing). */ // NOTE:  JavaScript's Set interface has on significant different diffrence from Java's:
// 		  e.g. the return type of add() differs!
//        For this reason I've commented tweaked the implements clause
const $8d7681ae139968b9$var$INITAL_CAPACITY = 16; // must be power of 2
const $8d7681ae139968b9$var$LOAD_FACTOR = 0.75;
class $8d7681ae139968b9$var$Array2DHashSet {
    /**
     * Add `o` to set if not there; return existing value if already
     * there. This method performs the same operation as {@link #add} aside from
     * the return value.
     */ getOrAdd(o) {
        if (this.n > this.threshold) this.expand();
        return this.getOrAddImpl(o);
    }
    getOrAddImpl(o) {
        let b = this.getBucket(o);
        let bucket = this.buckets[b];
        // NEW BUCKET
        if (!bucket) {
            bucket = [
                o
            ];
            this.buckets[b] = bucket;
            this.n++;
            return o;
        }
        // LOOK FOR IT IN BUCKET
        for (let existing of bucket){
            if (this.comparator.equals(existing, o)) return existing; // found existing, quit
        }
        // FULL BUCKET, expand and add to end
        bucket.push(o);
        this.n++;
        return o;
    }
    get(o) {
        if (o == null) return o;
        let b = this.getBucket(o);
        let bucket = this.buckets[b];
        if (!bucket) // no bucket
        return undefined;
        for (let e of bucket){
            if (this.comparator.equals(e, o)) return e;
        }
        return undefined;
    }
    getBucket(o) {
        let hash = this.comparator.hashCode(o);
        let b = hash & this.buckets.length - 1; // assumes len is power of 2
        return b;
    }
    hashCode() {
        let hash = $kPsXR.MurmurHash.initialize();
        for (let bucket of this.buckets){
            if (bucket == null) continue;
            for (let o of bucket){
                if (o == null) break;
                hash = $kPsXR.MurmurHash.update(hash, this.comparator.hashCode(o));
            }
        }
        hash = $kPsXR.MurmurHash.finish(hash, this.size);
        return hash;
    }
    equals(o) {
        if (o === this) return true;
        if (!(o instanceof $8d7681ae139968b9$var$Array2DHashSet)) return false;
        if (o.size !== this.size) return false;
        let same = this.containsAll(o);
        return same;
    }
    expand() {
        let old = this.buckets;
        let newCapacity = this.buckets.length * 2;
        let newTable = this.createBuckets(newCapacity);
        this.buckets = newTable;
        this.threshold = Math.floor(newCapacity * $8d7681ae139968b9$var$LOAD_FACTOR);
        //		System.out.println("new size="+newCapacity+", thres="+threshold);
        // rehash all existing entries
        let oldSize = this.size;
        for (let bucket of old){
            if (!bucket) continue;
            for (let o of bucket){
                let b = this.getBucket(o);
                let newBucket = this.buckets[b];
                if (!newBucket) {
                    newBucket = [];
                    this.buckets[b] = newBucket;
                }
                newBucket.push(o);
            }
        }
        $9Rq82(this.n === oldSize);
    }
    add(t) {
        let existing = this.getOrAdd(t);
        return existing === t;
    }
    get size() {
        return this.n;
    }
    get isEmpty() {
        return this.n === 0;
    }
    contains(o) {
        return this.containsFast(this.asElementType(o));
    }
    containsFast(obj) {
        if (obj == null) return false;
        return this.get(obj) != null;
    }
    *[Symbol.iterator]() {
        yield* this.toArray();
    }
    toArray() {
        const a = new Array(this.size);
        // Copy elements from the nested arrays into the destination array
        let i = 0; // Position within destination array
        for (let bucket of this.buckets){
            if (bucket == null) continue;
            for (let o of bucket){
                if (o == null) break;
                a[i++] = o;
            }
        }
        return a;
    }
    containsAll(collection) {
        if (collection instanceof $8d7681ae139968b9$var$Array2DHashSet) {
            let s = collection;
            for (let bucket of s.buckets){
                if (bucket == null) continue;
                for (let o of bucket){
                    if (o == null) break;
                    if (!this.containsFast(this.asElementType(o))) return false;
                }
            }
        } else for (let o of collection){
            if (!this.containsFast(this.asElementType(o))) return false;
        }
        return true;
    }
    addAll(c) {
        let changed = false;
        for (let o of c){
            let existing = this.getOrAdd(o);
            if (existing !== o) changed = true;
        }
        return changed;
    }
    clear() {
        this.buckets = this.createBuckets($8d7681ae139968b9$var$INITAL_CAPACITY);
        this.n = 0;
        this.threshold = Math.floor($8d7681ae139968b9$var$INITAL_CAPACITY * $8d7681ae139968b9$var$LOAD_FACTOR);
    }
    toString() {
        if (this.size === 0) return "{}";
        let buf = "{";
        let first = true;
        for (let bucket of this.buckets){
            if (bucket == null) continue;
            for (let o of bucket){
                if (o == null) break;
                if (first) first = false;
                else buf += ", ";
                buf += o.toString();
            }
        }
        buf += "}";
        return buf;
    }
    toTableString() {
        let buf = "";
        for (let bucket of this.buckets){
            if (bucket == null) {
                buf += "null\n";
                continue;
            }
            buf += "[";
            let first = true;
            for (let o of bucket){
                if (first) first = false;
                else buf += " ";
                if (o == null) buf += "_";
                else buf += o.toString();
            }
            buf += "]\n";
        }
        return buf;
    }
    /**
     * Return `o` as an instance of the element type `T`. If
     * `o` is non-undefined but known to not be an instance of `T`, this
     * method returns `undefined`. The base implementation does not perform any
     * type checks; override this method to provide strong type checks for the
     * {@link #contains} and {@link #remove} methods to ensure the arguments to
     * the {@link EqualityComparator} for the set always have the expected
     * types.
     *
     * @param o the object to try and cast to the element type of the set
     * @returns `o` if it could be an instance of `T`, otherwise
     * `undefined`.
     */ asElementType(o) {
        return o;
    }
    /**
     * Return an array of `T[]` with length `capacity`.
     *
     * @param capacity the length of the array to return
     * @returns the newly constructed array
     */ createBuckets(capacity) {
        return new Array(capacity);
    }
    constructor(comparatorOrSet, initialCapacity = $8d7681ae139968b9$var$INITAL_CAPACITY){
        /** How many elements in set */ this.n = 0;
        this.threshold = Math.floor($8d7681ae139968b9$var$INITAL_CAPACITY * $8d7681ae139968b9$var$LOAD_FACTOR); // when to expand
        if (comparatorOrSet instanceof $8d7681ae139968b9$var$Array2DHashSet) {
            this.comparator = comparatorOrSet.comparator;
            this.buckets = comparatorOrSet.buckets.slice(0);
            for(let i = 0; i < this.buckets.length; i++){
                let bucket = this.buckets[i];
                if (bucket) this.buckets[i] = bucket.slice(0);
            }
            this.n = comparatorOrSet.n;
            this.threshold = comparatorOrSet.threshold;
        } else {
            this.comparator = comparatorOrSet || $egnO5.DefaultEqualityComparator.INSTANCE;
            this.buckets = this.createBuckets(initialCapacity);
        }
    }
}
$8d7681ae139968b9$var$__decorate([
    $ffTXa.NotNull
], $8d7681ae139968b9$var$Array2DHashSet.prototype, "comparator", void 0);
$8d7681ae139968b9$var$__decorate([
    $ffTXa.Override
], $8d7681ae139968b9$var$Array2DHashSet.prototype, "hashCode", null);
$8d7681ae139968b9$var$__decorate([
    $ffTXa.Override
], $8d7681ae139968b9$var$Array2DHashSet.prototype, "equals", null);
$8d7681ae139968b9$var$__decorate([
    $ffTXa.Override
], $8d7681ae139968b9$var$Array2DHashSet.prototype, "add", null);
$8d7681ae139968b9$var$__decorate([
    $ffTXa.Override
], $8d7681ae139968b9$var$Array2DHashSet.prototype, "size", null);
$8d7681ae139968b9$var$__decorate([
    $ffTXa.Override
], $8d7681ae139968b9$var$Array2DHashSet.prototype, "isEmpty", null);
$8d7681ae139968b9$var$__decorate([
    $ffTXa.Override
], $8d7681ae139968b9$var$Array2DHashSet.prototype, "contains", null);
$8d7681ae139968b9$var$__decorate([
    $8d7681ae139968b9$var$__param(0, $ffTXa.Nullable)
], $8d7681ae139968b9$var$Array2DHashSet.prototype, "containsFast", null);
$8d7681ae139968b9$var$__decorate([
    $ffTXa.Override
], $8d7681ae139968b9$var$Array2DHashSet.prototype, Symbol.iterator, null);
$8d7681ae139968b9$var$__decorate([
    $ffTXa.Override
], $8d7681ae139968b9$var$Array2DHashSet.prototype, "toArray", null);
$8d7681ae139968b9$var$__decorate([
    $ffTXa.Override
], $8d7681ae139968b9$var$Array2DHashSet.prototype, "containsAll", null);
$8d7681ae139968b9$var$__decorate([
    $ffTXa.Override
], $8d7681ae139968b9$var$Array2DHashSet.prototype, "addAll", null);
$8d7681ae139968b9$var$__decorate([
    $ffTXa.Override
], $8d7681ae139968b9$var$Array2DHashSet.prototype, "clear", null);
$8d7681ae139968b9$var$__decorate([
    $ffTXa.Override
], $8d7681ae139968b9$var$Array2DHashSet.prototype, "toString", null);
$8d7681ae139968b9$var$__decorate([
    $ffTXa.SuppressWarnings("unchecked")
], $8d7681ae139968b9$var$Array2DHashSet.prototype, "asElementType", null);
$8d7681ae139968b9$var$__decorate([
    $ffTXa.SuppressWarnings("unchecked")
], $8d7681ae139968b9$var$Array2DHashSet.prototype, "createBuckets", null);
module.exports.Array2DHashSet = $8d7681ae139968b9$var$Array2DHashSet;

});

parcelRegister("9mjSw", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $6d0596925fa82b9b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ArrayEqualityComparator = void 0;

var $ffTXa = parcelRequire("ffTXa");


var $kPsXR = parcelRequire("kPsXR");


var $9PlGk = parcelRequire("9PlGk");

/**
 * This default implementation of {@link EqualityComparator} uses object equality
 * for comparisons by calling {@link Object#hashCode} and {@link Object#equals}.
 *
 * @author Sam Harwell
 */ class $6d0596925fa82b9b$var$ArrayEqualityComparator {
    /**
     * {@inheritDoc}
     *
     * This implementation returns
     * `obj.`{@link Object#hashCode hashCode()}.
     */ hashCode(obj) {
        if (obj == null) return 0;
        return $kPsXR.MurmurHash.hashCode(obj, 0);
    }
    /**
     * {@inheritDoc}
     *
     * This implementation relies on object equality. If both objects are
     * `undefined`, this method returns `true`. Otherwise if only
     * `a` is `undefined`, this method returns `false`. Otherwise,
     * this method returns the result of
     * `a.`{@link Object#equals equals}`(b)`.
     */ equals(a, b) {
        if (a == null) return b == null;
        else if (b == null) return false;
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (!$9PlGk.ObjectEqualityComparator.INSTANCE.equals(a[i], b[i])) return false;
        }
        return true;
    }
}
$6d0596925fa82b9b$var$ArrayEqualityComparator.INSTANCE = new $6d0596925fa82b9b$var$ArrayEqualityComparator();
$6d0596925fa82b9b$var$__decorate([
    $ffTXa.Override
], $6d0596925fa82b9b$var$ArrayEqualityComparator.prototype, "hashCode", null);
$6d0596925fa82b9b$var$__decorate([
    $ffTXa.Override
], $6d0596925fa82b9b$var$ArrayEqualityComparator.prototype, "equals", null);
module.exports.ArrayEqualityComparator = $6d0596925fa82b9b$var$ArrayEqualityComparator;

});

parcelRegister("kPsXR", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MurmurHash = void 0;
/**
 *
 * @author Sam Harwell
 */ var $f29f09d1eefc4f6a$var$MurmurHash;
(function(MurmurHash) {
    const DEFAULT_SEED = 0;
    /**
     * Initialize the hash using the specified `seed`.
     *
     * @param seed the seed (optional)
     * @returns the intermediate hash value
     */ function initialize(seed = DEFAULT_SEED) {
        return seed;
    }
    MurmurHash.initialize = initialize;
    /**
     * Update the intermediate hash value for the next input `value`.
     *
     * @param hash the intermediate hash value
     * @param value the value to add to the current hash
     * @returns the updated intermediate hash value
     */ function update(hash, value) {
        const c1 = 0xCC9E2D51;
        const c2 = 0x1B873593;
        const r1 = 15;
        const r2 = 13;
        const m = 5;
        const n = 0xE6546B64;
        if (value == null) value = 0;
        else if (typeof value === "string") value = hashString(value);
        else if (typeof value === "object") value = value.hashCode();
        let k = value;
        k = Math.imul(k, c1);
        k = k << r1 | k >>> 32 - r1;
        k = Math.imul(k, c2);
        hash = hash ^ k;
        hash = hash << r2 | hash >>> 32 - r2;
        hash = Math.imul(hash, m) + n;
        return hash & 0xFFFFFFFF;
    }
    MurmurHash.update = update;
    /**
     * Apply the final computation steps to the intermediate value `hash`
     * to form the final result of the MurmurHash 3 hash function.
     *
     * @param hash the intermediate hash value
     * @param numberOfWords the number of integer values added to the hash
     * @returns the final hash result
     */ function finish(hash, numberOfWords) {
        hash = hash ^ numberOfWords * 4;
        hash = hash ^ hash >>> 16;
        hash = Math.imul(hash, 0x85EBCA6B);
        hash = hash ^ hash >>> 13;
        hash = Math.imul(hash, 0xC2B2AE35);
        hash = hash ^ hash >>> 16;
        return hash;
    }
    MurmurHash.finish = finish;
    /**
     * Utility function to compute the hash code of an array using the
     * MurmurHash algorithm.
     *
     * @param <T> the array element type
     * @param data the array data
     * @param seed the seed for the MurmurHash algorithm
     * @returns the hash code of the data
     */ function hashCode(data, seed = DEFAULT_SEED) {
        let hash = initialize(seed);
        let length = 0;
        for (let value of data){
            hash = update(hash, value);
            length++;
        }
        hash = finish(hash, length);
        return hash;
    }
    MurmurHash.hashCode = hashCode;
    /**
     * Function to hash a string. Based on the implementation found here:
     * http://stackoverflow.com/a/7616484
     */ function hashString(str) {
        let len = str.length;
        if (len === 0) return 0;
        let hash = 0;
        for(let i = 0; i < len; i++){
            let c = str.charCodeAt(i);
            hash = (hash << 5 >>> 0) - hash + c;
            hash |= 0;
        }
        return hash;
    }
})($f29f09d1eefc4f6a$var$MurmurHash = module.exports.MurmurHash || (module.exports.MurmurHash = {}));

});

parcelRegister("9PlGk", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7279b1fec3b3ba6b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ObjectEqualityComparator = void 0;

var $ffTXa = parcelRequire("ffTXa");

/**
 * This default implementation of {@link EqualityComparator} uses object equality
 * for comparisons by calling {@link Object#hashCode} and {@link Object#equals}.
 *
 * @author Sam Harwell
 */ class $7279b1fec3b3ba6b$var$ObjectEqualityComparator {
    /**
     * {@inheritDoc}
     *
     * This implementation returns
     * `obj.`{@link Object#hashCode hashCode()}.
     */ hashCode(obj) {
        if (obj == null) return 0;
        return obj.hashCode();
    }
    /**
     * {@inheritDoc}
     *
     * This implementation relies on object equality. If both objects are
     * `undefined` or `null`, this method returns `true`. Otherwise if only
     * `a` is `undefined` or `null`, this method returns `false`. Otherwise,
     * this method returns the result of
     * `a.`{@link Object#equals equals}`(b)`.
     */ equals(a, b) {
        if (a == null) return b == null;
        return a.equals(b);
    }
}
$7279b1fec3b3ba6b$var$ObjectEqualityComparator.INSTANCE = new $7279b1fec3b3ba6b$var$ObjectEqualityComparator();
$7279b1fec3b3ba6b$var$__decorate([
    $ffTXa.Override
], $7279b1fec3b3ba6b$var$ObjectEqualityComparator.prototype, "hashCode", null);
$7279b1fec3b3ba6b$var$__decorate([
    $ffTXa.Override
], $7279b1fec3b3ba6b$var$ObjectEqualityComparator.prototype, "equals", null);
module.exports.ObjectEqualityComparator = $7279b1fec3b3ba6b$var$ObjectEqualityComparator;

});

parcelRegister("77InG", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $52fb9d028546b456$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntegerList = void 0;

var $kzQll = parcelRequire("kzQll");


var $ffTXa = parcelRequire("ffTXa");

const $52fb9d028546b456$var$EMPTY_DATA = new Int32Array(0);
const $52fb9d028546b456$var$INITIAL_SIZE = 4;
const $52fb9d028546b456$var$MAX_ARRAY_SIZE = 2147483639;
/**
 *
 * @author Sam Harwell
 */ class $52fb9d028546b456$var$IntegerList {
    add(value) {
        if (this._data.length === this._size) this.ensureCapacity(this._size + 1);
        this._data[this._size] = value;
        this._size++;
    }
    addAll(list) {
        if (Array.isArray(list)) {
            this.ensureCapacity(this._size + list.length);
            this._data.subarray(this._size, this._size + list.length).set(list);
            this._size += list.length;
        } else if (list instanceof $52fb9d028546b456$var$IntegerList) {
            this.ensureCapacity(this._size + list._size);
            this._data.subarray(this._size, this._size + list.size).set(list._data);
            this._size += list._size;
        } else {
            // list is JavaCollection<number>
            this.ensureCapacity(this._size + list.size);
            let current = 0;
            for (let xi of list){
                this._data[this._size + current] = xi;
                current++;
            }
            this._size += list.size;
        }
    }
    get(index) {
        if (index < 0 || index >= this._size) throw RangeError();
        return this._data[index];
    }
    contains(value) {
        for(let i = 0; i < this._size; i++){
            if (this._data[i] === value) return true;
        }
        return false;
    }
    set(index, value) {
        if (index < 0 || index >= this._size) throw RangeError();
        let previous = this._data[index];
        this._data[index] = value;
        return previous;
    }
    removeAt(index) {
        let value = this.get(index);
        this._data.copyWithin(index, index + 1, this._size);
        this._data[this._size - 1] = 0;
        this._size--;
        return value;
    }
    removeRange(fromIndex, toIndex) {
        if (fromIndex < 0 || toIndex < 0 || fromIndex > this._size || toIndex > this._size) throw RangeError();
        if (fromIndex > toIndex) throw RangeError();
        this._data.copyWithin(toIndex, fromIndex, this._size);
        this._data.fill(0, this._size - (toIndex - fromIndex), this._size);
        this._size -= toIndex - fromIndex;
    }
    get isEmpty() {
        return this._size === 0;
    }
    get size() {
        return this._size;
    }
    trimToSize() {
        if (this._data.length === this._size) return;
        this._data = this._data.slice(0, this._size);
    }
    clear() {
        this._data.fill(0, 0, this._size);
        this._size = 0;
    }
    toArray() {
        if (this._size === 0) return [];
        return Array.from(this._data.subarray(0, this._size));
    }
    sort() {
        this._data.subarray(0, this._size).sort();
    }
    /**
     * Compares the specified object with this list for equality.  Returns
     * `true` if and only if the specified object is also an {@link IntegerList},
     * both lists have the same size, and all corresponding pairs of elements in
     * the two lists are equal.  In other words, two lists are defined to be
     * equal if they contain the same elements in the same order.
     *
     * This implementation first checks if the specified object is this
     * list. If so, it returns `true`; if not, it checks if the
     * specified object is an {@link IntegerList}. If not, it returns `false`;
     * if so, it checks the size of both lists. If the lists are not the same size,
     * it returns `false`; otherwise it iterates over both lists, comparing
     * corresponding pairs of elements.  If any comparison returns `false`,
     * this method returns `false`.
     *
     * @param o the object to be compared for equality with this list
     * @returns `true` if the specified object is equal to this list
     */ equals(o) {
        if (o === this) return true;
        if (!(o instanceof $52fb9d028546b456$var$IntegerList)) return false;
        if (this._size !== o._size) return false;
        for(let i = 0; i < this._size; i++){
            if (this._data[i] !== o._data[i]) return false;
        }
        return true;
    }
    /**
     * Returns the hash code value for this list.
     *
     * This implementation uses exactly the code that is used to define the
     * list hash function in the documentation for the {@link List#hashCode}
     * method.
     *
     * @returns the hash code value for this list
     */ hashCode() {
        let hashCode = 1;
        for(let i = 0; i < this._size; i++)hashCode = 31 * hashCode + this._data[i];
        return hashCode;
    }
    /**
     * Returns a string representation of this list.
     */ toString() {
        return this._data.toString();
    }
    binarySearch(key, fromIndex, toIndex) {
        if (fromIndex === undefined) fromIndex = 0;
        if (toIndex === undefined) toIndex = this._size;
        if (fromIndex < 0 || toIndex < 0 || fromIndex > this._size || toIndex > this._size) throw new RangeError();
        if (fromIndex > toIndex) throw new RangeError();
        return $kzQll.Arrays.binarySearch(this._data, key, fromIndex, toIndex);
    }
    ensureCapacity(capacity) {
        if (capacity < 0 || capacity > $52fb9d028546b456$var$MAX_ARRAY_SIZE) throw new RangeError();
        let newLength;
        if (this._data.length === 0) newLength = $52fb9d028546b456$var$INITIAL_SIZE;
        else newLength = this._data.length;
        while(newLength < capacity){
            newLength = newLength * 2;
            if (newLength < 0 || newLength > $52fb9d028546b456$var$MAX_ARRAY_SIZE) newLength = $52fb9d028546b456$var$MAX_ARRAY_SIZE;
        }
        let tmp = new Int32Array(newLength);
        tmp.set(this._data);
        this._data = tmp;
    }
    /** Convert the list to a UTF-16 encoded char array. If all values are less
     *  than the 0xFFFF 16-bit code point limit then this is just a char array
     *  of 16-bit char as usual. For values in the supplementary range, encode
     * them as two UTF-16 code units.
     */ toCharArray() {
        // Optimize for the common case (all data values are < 0xFFFF) to avoid an extra scan
        let resultArray = new Uint16Array(this._size);
        let resultIdx = 0;
        let calculatedPreciseResultSize = false;
        for(let i = 0; i < this._size; i++){
            let codePoint = this._data[i];
            if (codePoint >= 0 && codePoint < 0x10000) {
                resultArray[resultIdx] = codePoint;
                resultIdx++;
                continue;
            }
            // Calculate the precise result size if we encounter a code point > 0xFFFF
            if (!calculatedPreciseResultSize) {
                let newResultArray = new Uint16Array(this.charArraySize());
                newResultArray.set(resultArray, 0);
                resultArray = newResultArray;
                calculatedPreciseResultSize = true;
            }
            // This will throw RangeError if the code point is not a valid Unicode code point
            let pair = String.fromCodePoint(codePoint);
            resultArray[resultIdx] = pair.charCodeAt(0);
            resultArray[resultIdx + 1] = pair.charCodeAt(1);
            resultIdx += 2;
        }
        return resultArray;
    }
    charArraySize() {
        let result = 0;
        for(let i = 0; i < this._size; i++)result += this._data[i] >= 0x10000 ? 2 : 1;
        return result;
    }
    constructor(arg){
        if (!arg) {
            this._data = $52fb9d028546b456$var$EMPTY_DATA;
            this._size = 0;
        } else if (arg instanceof $52fb9d028546b456$var$IntegerList) {
            this._data = arg._data.slice(0);
            this._size = arg._size;
        } else if (typeof arg === "number") {
            if (arg === 0) {
                this._data = $52fb9d028546b456$var$EMPTY_DATA;
                this._size = 0;
            } else {
                this._data = new Int32Array(arg);
                this._size = 0;
            }
        } else {
            // arg is Iterable<number>
            this._data = $52fb9d028546b456$var$EMPTY_DATA;
            this._size = 0;
            for (let value of arg)this.add(value);
        }
    }
}
$52fb9d028546b456$var$__decorate([
    $ffTXa.NotNull
], $52fb9d028546b456$var$IntegerList.prototype, "_data", void 0);
$52fb9d028546b456$var$__decorate([
    $ffTXa.Override
], $52fb9d028546b456$var$IntegerList.prototype, "equals", null);
$52fb9d028546b456$var$__decorate([
    $ffTXa.Override
], $52fb9d028546b456$var$IntegerList.prototype, "hashCode", null);
$52fb9d028546b456$var$__decorate([
    $ffTXa.Override
], $52fb9d028546b456$var$IntegerList.prototype, "toString", null);
module.exports.IntegerList = $52fb9d028546b456$var$IntegerList;

});

parcelRegister("be2mo", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntegerStack = void 0;

var $77InG = parcelRequire("77InG");

/**
 *
 * @author Sam Harwell
 */ class $82c2d53138b74df5$var$IntegerStack extends $77InG.IntegerList {
    push(value) {
        this.add(value);
    }
    pop() {
        return this.removeAt(this.size - 1);
    }
    peek() {
        return this.get(this.size - 1);
    }
    constructor(arg){
        super(arg);
    }
}
module.exports.IntegerStack = $82c2d53138b74df5$var$IntegerStack;

});

parcelRegister("a9s8D", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AcceptStateInfo = void 0;
/**
 * Stores information about a {@link DFAState} which is an accept state under
 * some condition. Certain settings, such as
 * {@link ParserATNSimulator#getPredictionMode()}, may be used in addition to
 * this information to determine whether or not a particular state is an accept
 * state.
 *
 * @author Sam Harwell
 */ class $7640924d70c2f37c$var$AcceptStateInfo {
    /**
     * Gets the prediction made by this accept state. Note that this value
     * assumes the predicates, if any, in the {@link DFAState} evaluate to
     * `true`. If predicate evaluation is enabled, the final prediction of
     * the accept state will be determined by the result of predicate
     * evaluation.
     */ get prediction() {
        return this._prediction;
    }
    /**
     * Gets the {@link LexerActionExecutor} which can be used to execute actions
     * and/or commands after the lexer matches a token.
     */ get lexerActionExecutor() {
        return this._lexerActionExecutor;
    }
    constructor(prediction, lexerActionExecutor){
        this._prediction = prediction;
        this._lexerActionExecutor = lexerActionExecutor;
    }
}
module.exports.AcceptStateInfo = $7640924d70c2f37c$var$AcceptStateInfo;

});

parcelRegister("kjxTv", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ec9fdfae13b676f0$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $ec9fdfae13b676f0$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DFAState = void 0;

var $3pR6v = parcelRequire("3pR6v");


var $kJZRw = parcelRequire("kJZRw");


var $kPsXR = parcelRequire("kPsXR");


var $ffTXa = parcelRequire("ffTXa");


var $2EGxJ = parcelRequire("2EGxJ");


var $9Rq82 = parcelRequire("9Rq82");

/** A DFA state represents a set of possible ATN configurations.
 *  As Aho, Sethi, Ullman p. 117 says "The DFA uses its state
 *  to keep track of all possible states the ATN can be in after
 *  reading each input symbol.  That is to say, after reading
 *  input a1a2..an, the DFA is in a state that represents the
 *  subset T of the states of the ATN that are reachable from the
 *  ATN's start state along some path labeled a1a2..an."
 *  In conventional NFA&rarr;DFA conversion, therefore, the subset T
 *  would be a bitset representing the set of states the
 *  ATN could be in.  We need to track the alt predicted by each
 *  state as well, however.  More importantly, we need to maintain
 *  a stack of states, tracking the closure operations as they
 *  jump from rule to rule, emulating rule invocations (method calls).
 *  I have to add a stack to simulate the proper lookahead sequences for
 *  the underlying LL grammar from which the ATN was derived.
 *
 *  I use a set of ATNConfig objects not simple states.  An ATNConfig
 *  is both a state (ala normal conversion) and a RuleContext describing
 *  the chain of rules (if any) followed to arrive at that state.
 *
 *  A DFA state may have multiple references to a particular state,
 *  but with different ATN contexts (with same or different alts)
 *  meaning that state was reached via a different set of rule invocations.
 */ class $ec9fdfae13b676f0$var$DFAState {
    get isContextSensitive() {
        return !!this.contextSymbols;
    }
    isContextSymbol(symbol) {
        if (!this.isContextSensitive) return false;
        return this.contextSymbols.get(symbol);
    }
    setContextSymbol(symbol) {
        $9Rq82(this.isContextSensitive);
        this.contextSymbols.set(symbol);
    }
    setContextSensitive(atn) {
        $9Rq82(!this.configs.isOutermostConfigSet);
        if (this.isContextSensitive) return;
        if (!this.contextSymbols) this.contextSymbols = new $kJZRw.BitSet();
    }
    get acceptStateInfo() {
        return this._acceptStateInfo;
    }
    set acceptStateInfo(acceptStateInfo) {
        this._acceptStateInfo = acceptStateInfo;
    }
    get isAcceptState() {
        return !!this._acceptStateInfo;
    }
    get prediction() {
        if (!this._acceptStateInfo) return $3pR6v.ATN.INVALID_ALT_NUMBER;
        return this._acceptStateInfo.prediction;
    }
    get lexerActionExecutor() {
        if (!this._acceptStateInfo) return undefined;
        return this._acceptStateInfo.lexerActionExecutor;
    }
    getTarget(symbol) {
        return this.edges.get(symbol);
    }
    setTarget(symbol, target) {
        this.edges.set(symbol, target);
    }
    getEdgeMap() {
        return this.edges;
    }
    getContextTarget(invokingState) {
        if (invokingState === $2EGxJ.PredictionContext.EMPTY_FULL_STATE_KEY) invokingState = -1;
        return this.contextEdges.get(invokingState);
    }
    setContextTarget(invokingState, target) {
        if (!this.isContextSensitive) throw new Error("The state is not context sensitive.");
        if (invokingState === $2EGxJ.PredictionContext.EMPTY_FULL_STATE_KEY) invokingState = -1;
        this.contextEdges.set(invokingState, target);
    }
    getContextEdgeMap() {
        let map = new Map(this.contextEdges);
        let existing = map.get(-1);
        if (existing !== undefined) {
            if (map.size === 1) {
                let result = new Map();
                result.set($2EGxJ.PredictionContext.EMPTY_FULL_STATE_KEY, existing);
                return result;
            } else {
                map.delete(-1);
                map.set($2EGxJ.PredictionContext.EMPTY_FULL_STATE_KEY, existing);
            }
        }
        return map;
    }
    hashCode() {
        let hash = $kPsXR.MurmurHash.initialize(7);
        hash = $kPsXR.MurmurHash.update(hash, this.configs.hashCode());
        hash = $kPsXR.MurmurHash.finish(hash, 1);
        return hash;
    }
    /**
     * Two {@link DFAState} instances are equal if their ATN configuration sets
     * are the same. This method is used to see if a state already exists.
     *
     * Because the number of alternatives and number of ATN configurations are
     * finite, there is a finite number of DFA states that can be processed.
     * This is necessary to show that the algorithm terminates.
     *
     * Cannot test the DFA state numbers here because in
     * {@link ParserATNSimulator#addDFAState} we need to know if any other state
     * exists that has this exact set of ATN configurations. The
     * {@link #stateNumber} is irrelevant.
     */ equals(o) {
        // compare set of ATN configurations in this set with other
        if (this === o) return true;
        if (!(o instanceof $ec9fdfae13b676f0$var$DFAState)) return false;
        let other = o;
        let sameSet = this.configs.equals(other.configs);
        //		System.out.println("DFAState.equals: "+configs+(sameSet?"==":"!=")+other.configs);
        return sameSet;
    }
    toString() {
        let buf = "";
        buf += this.stateNumber + ":" + this.configs;
        if (this.isAcceptState) {
            buf += "=>";
            if (this.predicates) buf += this.predicates;
            else buf += this.prediction;
        }
        return buf.toString();
    }
    /**
     * Constructs a new `DFAState`.
     *
     * @param configs The set of ATN configurations defining this state.
     */ constructor(configs){
        this.stateNumber = -1;
        this.configs = configs;
        this.edges = new Map();
        this.contextEdges = new Map();
    }
}
$ec9fdfae13b676f0$var$__decorate([
    $ffTXa.NotNull
], $ec9fdfae13b676f0$var$DFAState.prototype, "configs", void 0);
$ec9fdfae13b676f0$var$__decorate([
    $ffTXa.NotNull
], $ec9fdfae13b676f0$var$DFAState.prototype, "edges", void 0);
$ec9fdfae13b676f0$var$__decorate([
    $ffTXa.NotNull
], $ec9fdfae13b676f0$var$DFAState.prototype, "contextEdges", void 0);
$ec9fdfae13b676f0$var$__decorate([
    $ffTXa.Override
], $ec9fdfae13b676f0$var$DFAState.prototype, "hashCode", null);
$ec9fdfae13b676f0$var$__decorate([
    $ffTXa.Override
], $ec9fdfae13b676f0$var$DFAState.prototype, "equals", null);
$ec9fdfae13b676f0$var$__decorate([
    $ffTXa.Override
], $ec9fdfae13b676f0$var$DFAState.prototype, "toString", null);
module.exports.DFAState = $ec9fdfae13b676f0$var$DFAState;
(function(DFAState) {
    /** Map a predicate to a predicted alternative. */ let PredPrediction = class PredPrediction {
        toString() {
            return "(" + this.pred + ", " + this.alt + ")";
        }
        constructor(pred, alt){
            this.alt = alt;
            this.pred = pred;
        }
    };
    $ec9fdfae13b676f0$var$__decorate([
        $ffTXa.NotNull
    ], PredPrediction.prototype, "pred", void 0);
    $ec9fdfae13b676f0$var$__decorate([
        $ffTXa.Override
    ], PredPrediction.prototype, "toString", null);
    PredPrediction = $ec9fdfae13b676f0$var$__decorate([
        $ec9fdfae13b676f0$var$__param(0, $ffTXa.NotNull)
    ], PredPrediction);
    DFAState.PredPrediction = PredPrediction;
})($ec9fdfae13b676f0$var$DFAState = module.exports.DFAState || (module.exports.DFAState = {}));

});

parcelRegister("5ZofD", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Array2DHashMap = void 0;

var $c90ex = parcelRequire("c90ex");

class $45c57606daf67ff9$var$MapKeyEqualityComparator {
    hashCode(obj) {
        return this.keyComparator.hashCode(obj.key);
    }
    equals(a, b) {
        return this.keyComparator.equals(a.key, b.key);
    }
    constructor(keyComparator){
        this.keyComparator = keyComparator;
    }
}
class $45c57606daf67ff9$var$Array2DHashMap {
    clear() {
        this.backingStore.clear();
    }
    containsKey(key) {
        return this.backingStore.contains({
            key: key
        });
    }
    get(key) {
        let bucket = this.backingStore.get({
            key: key
        });
        if (!bucket) return undefined;
        return bucket.value;
    }
    get isEmpty() {
        return this.backingStore.isEmpty;
    }
    put(key, value) {
        let element = this.backingStore.get({
            key: key,
            value: value
        });
        let result;
        if (!element) this.backingStore.add({
            key: key,
            value: value
        });
        else {
            result = element.value;
            element.value = value;
        }
        return result;
    }
    putIfAbsent(key, value) {
        let element = this.backingStore.get({
            key: key,
            value: value
        });
        let result;
        if (!element) this.backingStore.add({
            key: key,
            value: value
        });
        else result = element.value;
        return result;
    }
    get size() {
        return this.backingStore.size;
    }
    hashCode() {
        return this.backingStore.hashCode();
    }
    equals(o) {
        if (!(o instanceof $45c57606daf67ff9$var$Array2DHashMap)) return false;
        return this.backingStore.equals(o.backingStore);
    }
    constructor(keyComparer){
        if (keyComparer instanceof $45c57606daf67ff9$var$Array2DHashMap) this.backingStore = new $c90ex.Array2DHashSet(keyComparer.backingStore);
        else this.backingStore = new $c90ex.Array2DHashSet(new $45c57606daf67ff9$var$MapKeyEqualityComparator(keyComparer));
    }
}
module.exports.Array2DHashMap = $45c57606daf67ff9$var$Array2DHashMap;

});

parcelRegister("6AYuC", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $4cd5077b72257a43$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $4cd5077b72257a43$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DFA = void 0;

var $c90ex = parcelRequire("c90ex");


var $64vb9 = parcelRequire("64vb9");


var $fZCit = parcelRequire("fZCit");


var $kjxTv = parcelRequire("kjxTv");


var $9FQ0O = parcelRequire("9FQ0O");


var $ffTXa = parcelRequire("ffTXa");


var $9PlGk = parcelRequire("9PlGk");


var $YUl9W = parcelRequire("YUl9W");


var $56U0W = parcelRequire("56U0W");

let $4cd5077b72257a43$var$DFA = class DFA {
    /**
     * Gets whether this DFA is a precedence DFA. Precedence DFAs use a special
     * start state {@link #s0} which is not stored in {@link #states}. The
     * {@link DFAState#edges} array for this start state contains outgoing edges
     * supplying individual start states corresponding to specific precedence
     * values.
     *
     * @returns `true` if this is a precedence DFA; otherwise,
     * `false`.
     * @see Parser.precedence
     */ get isPrecedenceDfa() {
        return this.precedenceDfa;
    }
    /**
     * Get the start state for a specific precedence value.
     *
     * @param precedence The current precedence.
     * @returns The start state corresponding to the specified precedence, or
     * `undefined` if no start state exists for the specified precedence.
     *
     * @ if this is not a precedence DFA.
     * @see `isPrecedenceDfa`
     */ getPrecedenceStartState(precedence, fullContext) {
        if (!this.isPrecedenceDfa) throw new Error("Only precedence DFAs may contain a precedence start state.");
        // s0 and s0full are never null for a precedence DFA
        if (fullContext) return this.s0full.getTarget(precedence);
        else return this.s0.getTarget(precedence);
    }
    /**
     * Set the start state for a specific precedence value.
     *
     * @param precedence The current precedence.
     * @param startState The start state corresponding to the specified
     * precedence.
     *
     * @ if this is not a precedence DFA.
     * @see `isPrecedenceDfa`
     */ setPrecedenceStartState(precedence, fullContext, startState) {
        if (!this.isPrecedenceDfa) throw new Error("Only precedence DFAs may contain a precedence start state.");
        if (precedence < 0) return;
        if (fullContext) // s0full is never null for a precedence DFA
        this.s0full.setTarget(precedence, startState);
        else // s0 is never null for a precedence DFA
        this.s0.setTarget(precedence, startState);
    }
    get isEmpty() {
        if (this.isPrecedenceDfa) // s0 and s0full are never null for a precedence DFA
        return this.s0.getEdgeMap().size === 0 && this.s0full.getEdgeMap().size === 0;
        return this.s0 == null && this.s0full == null;
    }
    get isContextSensitive() {
        if (this.isPrecedenceDfa) // s0full is never null for a precedence DFA
        return this.s0full.getEdgeMap().size > 0;
        return this.s0full != null;
    }
    addState(state) {
        state.stateNumber = this.nextStateNumber++;
        return this.states.getOrAdd(state);
    }
    toString(vocabulary, ruleNames) {
        if (!vocabulary) vocabulary = $56U0W.VocabularyImpl.EMPTY_VOCABULARY;
        if (!this.s0) return "";
        let serializer;
        if (ruleNames) serializer = new $fZCit.DFASerializer(this, vocabulary, ruleNames, this.atnStartState.atn);
        else serializer = new $fZCit.DFASerializer(this, vocabulary);
        return serializer.toString();
    }
    toLexerString() {
        if (!this.s0) return "";
        let serializer = new $9FQ0O.LexerDFASerializer(this);
        return serializer.toString();
    }
    constructor(atnStartState, decision = 0){
        /**
         * A set of all states in the `DFA`.
         *
         * Note that this collection of states holds the DFA states for both SLL and LL prediction. Only the start state
         * needs to be differentiated for these cases, which is tracked by the `s0` and `s0full` fields.
         */ this.states = new $c90ex.Array2DHashSet($9PlGk.ObjectEqualityComparator.INSTANCE);
        this.nextStateNumber = 0;
        if (!atnStartState.atn) throw new Error("The ATNState must be associated with an ATN");
        this.atnStartState = atnStartState;
        this.atn = atnStartState.atn;
        this.decision = decision;
        // Precedence DFAs are associated with the special precedence decision created for left-recursive rules which
        // evaluate their alternatives using a precedence hierarchy. When such a decision is encountered, we mark this
        // DFA instance as a precedence DFA and initialize the initial states s0 and s0full to special DFAState
        // instances which use outgoing edges to link to the actual start state used for each precedence level.
        let isPrecedenceDfa = false;
        if (atnStartState instanceof $YUl9W.StarLoopEntryState) {
            if (atnStartState.precedenceRuleDecision) {
                isPrecedenceDfa = true;
                this.s0 = new $kjxTv.DFAState(new $64vb9.ATNConfigSet());
                this.s0full = new $kjxTv.DFAState(new $64vb9.ATNConfigSet());
            }
        }
        this.precedenceDfa = isPrecedenceDfa;
    }
};
$4cd5077b72257a43$var$__decorate([
    $ffTXa.NotNull
], $4cd5077b72257a43$var$DFA.prototype, "states", void 0);
$4cd5077b72257a43$var$__decorate([
    $ffTXa.NotNull
], $4cd5077b72257a43$var$DFA.prototype, "atnStartState", void 0);
$4cd5077b72257a43$var$__decorate([
    $ffTXa.NotNull
], $4cd5077b72257a43$var$DFA.prototype, "atn", void 0);
$4cd5077b72257a43$var$DFA = $4cd5077b72257a43$var$__decorate([
    $4cd5077b72257a43$var$__param(0, $ffTXa.NotNull)
], $4cd5077b72257a43$var$DFA);
module.exports.DFA = $4cd5077b72257a43$var$DFA;

});

parcelRegister("kJZRw", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BitSet = void 0;

var $7T2Y0 = parcelRequire("7T2Y0");


var $kPsXR = parcelRequire("kPsXR");

/**
 * Private empty array used to construct empty BitSets
 */ const $f197ff2d2edfdb19$var$EMPTY_DATA = new Uint16Array(0);
/**
 * Gets the word index of the `UInt16` element in `BitSet.data` containing the bit with the specified index.
 */ function $f197ff2d2edfdb19$var$getIndex(bitNumber) {
    return bitNumber >>> 4;
}
/**
 * Convert a word index into the bit index of the LSB of that word
 */ function $f197ff2d2edfdb19$var$unIndex(n) {
    return n * 16;
}
/**
 * Get's the bit number of the least signficant bit set LSB which is set in a word non-zero word;
 * Bit numbers run from LSB to MSB starting with 0.
 */ function $f197ff2d2edfdb19$var$findLSBSet(word) {
    let bit = 1;
    for(let i = 0; i < 16; i++){
        if ((word & bit) !== 0) return i;
        bit = bit << 1 >>> 0;
    }
    throw new RangeError("No specified bit found");
}
function $f197ff2d2edfdb19$var$findMSBSet(word) {
    let bit = 32768;
    for(let i = 15; i >= 0; i--){
        if ((word & bit) !== 0) return i;
        bit = bit >>> 1;
    }
    throw new RangeError("No specified bit found");
}
/**
 * Gets a 16-bit mask with bit numbers fromBit to toBit (inclusive) set.
 * Bit numbers run from LSB to MSB starting with 0.
 */ function $f197ff2d2edfdb19$var$bitsFor(fromBit, toBit) {
    fromBit &= 0xF;
    toBit &= 0xF;
    if (fromBit === toBit) return 1 << fromBit >>> 0;
    return 0xFFFF >>> 15 - toBit ^ 0xFFFF >>> 16 - fromBit;
}
/**
 * A lookup table for number of set bits in a 16-bit integer.   This is used to quickly count the cardinality (number of unique elements) of a BitSet.
 */ const $f197ff2d2edfdb19$var$POP_CNT = new Uint8Array(65536);
for(let i = 0; i < 16; i++){
    const stride = 1 << i >>> 0;
    let index = 0;
    while(index < $f197ff2d2edfdb19$var$POP_CNT.length){
        // skip the numbers where the bit isn't set
        index += stride;
        // increment the ones where the bit is set
        for(let j = 0; j < stride; j++){
            $f197ff2d2edfdb19$var$POP_CNT[index]++;
            index++;
        }
    }
}
class $f197ff2d2edfdb19$var$BitSet {
    /**
     * Performs a logical **AND** of this target bit set with the argument bit set. This bit set is modified so that
     * each bit in it has the value `true` if and only if it both initially had the value `true` and the corresponding
     * bit in the bit set argument also had the value `true`.
     */ and(set) {
        const data = this.data;
        const other = set.data;
        const words = Math.min(data.length, other.length);
        let lastWord = -1; // Keep track of index of last non-zero word
        for(let i = 0; i < words; i++){
            let value = data[i] &= other[i];
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $f197ff2d2edfdb19$var$EMPTY_DATA;
        if (lastWord < data.length - 1) this.data = data.slice(0, lastWord + 1);
    }
    /**
     * Clears all of the bits in this `BitSet` whose corresponding bit is set in the specified `BitSet`.
     */ andNot(set) {
        const data = this.data;
        const other = set.data;
        const words = Math.min(data.length, other.length);
        let lastWord = -1; // Keep track of index of last non-zero word
        for(let i = 0; i < words; i++){
            let value = data[i] &= other[i] ^ 0xFFFF;
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $f197ff2d2edfdb19$var$EMPTY_DATA;
        if (lastWord < data.length - 1) this.data = data.slice(0, lastWord + 1);
    }
    /**
     * Returns the number of bits set to `true` in this `BitSet`.
     */ cardinality() {
        if (this.isEmpty) return 0;
        const data = this.data;
        const length = data.length;
        let result = 0;
        for(let i = 0; i < length; i++)result += $f197ff2d2edfdb19$var$POP_CNT[data[i]];
        return result;
    }
    clear(fromIndex, toIndex) {
        if (fromIndex == null) this.data.fill(0);
        else if (toIndex == null) this.set(fromIndex, false);
        else this.set(fromIndex, toIndex, false);
    }
    flip(fromIndex, toIndex) {
        if (toIndex == null) toIndex = fromIndex;
        if (fromIndex < 0 || toIndex < fromIndex) throw new RangeError();
        let word = $f197ff2d2edfdb19$var$getIndex(fromIndex);
        const lastWord = $f197ff2d2edfdb19$var$getIndex(toIndex);
        if (word === lastWord) this.data[word] ^= $f197ff2d2edfdb19$var$bitsFor(fromIndex, toIndex);
        else {
            this.data[word++] ^= $f197ff2d2edfdb19$var$bitsFor(fromIndex, 15);
            while(word < lastWord)this.data[word++] ^= 0xFFFF;
            this.data[word++] ^= $f197ff2d2edfdb19$var$bitsFor(0, toIndex);
        }
    }
    get(fromIndex, toIndex) {
        if (toIndex === undefined) return !!(this.data[$f197ff2d2edfdb19$var$getIndex(fromIndex)] & $f197ff2d2edfdb19$var$bitsFor(fromIndex, fromIndex));
        else {
            // return a BitSet
            let result = new $f197ff2d2edfdb19$var$BitSet(toIndex + 1);
            for(let i = fromIndex; i <= toIndex; i++)result.set(i, this.get(i));
            return result;
        }
    }
    /**
     * Returns true if the specified `BitSet` has any bits set to `true` that are also set to `true` in this `BitSet`.
     *
     * @param set `BitSet` to intersect with
     */ intersects(set) {
        let smallerLength = Math.min(this.length(), set.length());
        if (smallerLength === 0) return false;
        let bound = $f197ff2d2edfdb19$var$getIndex(smallerLength - 1);
        for(let i = 0; i <= bound; i++){
            if ((this.data[i] & set.data[i]) !== 0) return true;
        }
        return false;
    }
    /**
     * Returns true if this `BitSet` contains no bits that are set to `true`.
     */ get isEmpty() {
        return this.length() === 0;
    }
    /**
     * Returns the "logical size" of this `BitSet`: the index of the highest set bit in the `BitSet` plus one. Returns
     * zero if the `BitSet` contains no set bits.
     */ length() {
        if (!this.data.length) return 0;
        return this.previousSetBit($f197ff2d2edfdb19$var$unIndex(this.data.length) - 1) + 1;
    }
    /**
     * Returns the index of the first bit that is set to `false` that occurs on or after the specified starting index,
     * If no such bit exists then `-1` is returned.
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is negative
     */ nextClearBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $f197ff2d2edfdb19$var$getIndex(fromIndex);
        if (word > length) return -1;
        let ignore = 0xFFFF ^ $f197ff2d2edfdb19$var$bitsFor(fromIndex, 15);
        if ((data[word] | ignore) === 0xFFFF) {
            word++;
            ignore = 0;
            for(; word < length; word++){
                if (data[word] !== 0xFFFF) break;
            }
            if (word === length) // Hit the end
            return -1;
        }
        return $f197ff2d2edfdb19$var$unIndex(word) + $f197ff2d2edfdb19$var$findLSBSet((data[word] | ignore) ^ 0xFFFF);
    }
    /**
     * Returns the index of the first bit that is set to `true` that occurs on or after the specified starting index.
     * If no such bit exists then `-1` is returned.
     *
     * To iterate over the `true` bits in a `BitSet`, use the following loop:
     *
     * ```
     * for (let i = bs.nextSetBit(0); i >= 0; i = bs.nextSetBit(i + 1)) {
     *   // operate on index i here
     * }
     * ```
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is negative
     */ nextSetBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $f197ff2d2edfdb19$var$getIndex(fromIndex);
        if (word > length) return -1;
        let mask = $f197ff2d2edfdb19$var$bitsFor(fromIndex, 15);
        if ((data[word] & mask) === 0) {
            word++;
            mask = 0xFFFF;
            for(; word < length; word++){
                if (data[word] !== 0) break;
            }
            if (word >= length) return -1;
        }
        return $f197ff2d2edfdb19$var$unIndex(word) + $f197ff2d2edfdb19$var$findLSBSet(data[word] & mask);
    }
    /**
     * Performs a logical **OR** of this bit set with the bit set argument. This bit set is modified so that a bit in it
     * has the value `true` if and only if it either already had the value `true` or the corresponding bit in the bit
     * set argument has the value `true`.
     */ or(set) {
        const data = this.data;
        const other = set.data;
        const minWords = Math.min(data.length, other.length);
        const words = Math.max(data.length, other.length);
        const dest = data.length === words ? data : new Uint16Array(words);
        let lastWord = -1;
        // Or those words both sets have in common
        for(let i = 0; i < minWords; i++){
            let value = dest[i] = data[i] | other[i];
            if (value !== 0) lastWord = i;
        }
        // Copy words from larger set (if there is one)
        const longer = data.length > other.length ? data : other;
        for(let i = minWords; i < words; i++){
            let value = dest[i] = longer[i];
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $f197ff2d2edfdb19$var$EMPTY_DATA;
        else if (dest.length === lastWord + 1) this.data = dest;
        else this.data = dest.slice(0, lastWord);
    }
    /**
     * Returns the index of the nearest bit that is set to `false` that occurs on or before the specified starting
     * index. If no such bit exists, or if `-1` is given as the starting index, then `-1` is returned.
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is less than `-1`
     */ previousClearBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $f197ff2d2edfdb19$var$getIndex(fromIndex);
        if (word >= length) word = length - 1;
        let ignore = 0xFFFF ^ $f197ff2d2edfdb19$var$bitsFor(0, fromIndex);
        if ((data[word] | ignore) === 0xFFFF) {
            ignore = 0;
            word--;
            for(; word >= 0; word--){
                if (data[word] !== 0xFFFF) break;
            }
            if (word < 0) // Hit the end
            return -1;
        }
        return $f197ff2d2edfdb19$var$unIndex(word) + $f197ff2d2edfdb19$var$findMSBSet((data[word] | ignore) ^ 0xFFFF);
    }
    /**
     * Returns the index of the nearest bit that is set to `true` that occurs on or before the specified starting index.
     * If no such bit exists, or if `-1` is given as the starting index, then `-1` is returned.
     *
     * To iterate over the `true` bits in a `BitSet`, use the following loop:
     *
     * ```
     * for (let i = bs.length(); (i = bs.previousSetBit(i-1)) >= 0; ) {
     *   // operate on index i here
     * }
     * ```
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is less than `-1`
     */ previousSetBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $f197ff2d2edfdb19$var$getIndex(fromIndex);
        if (word >= length) word = length - 1;
        let mask = $f197ff2d2edfdb19$var$bitsFor(0, fromIndex);
        if ((data[word] & mask) === 0) {
            word--;
            mask = 0xFFFF;
            for(; word >= 0; word--){
                if (data[word] !== 0) break;
            }
            if (word < 0) return -1;
        }
        return $f197ff2d2edfdb19$var$unIndex(word) + $f197ff2d2edfdb19$var$findMSBSet(data[word] & mask);
    }
    set(fromIndex, toIndex, value) {
        if (toIndex === undefined) {
            toIndex = fromIndex;
            value = true;
        } else if (typeof toIndex === "boolean") {
            value = toIndex;
            toIndex = fromIndex;
        }
        if (value === undefined) value = true;
        if (fromIndex < 0 || fromIndex > toIndex) throw new RangeError();
        let word = $f197ff2d2edfdb19$var$getIndex(fromIndex);
        let lastWord = $f197ff2d2edfdb19$var$getIndex(toIndex);
        if (value && lastWord >= this.data.length) {
            // Grow array "just enough" for bits we need to set
            let temp = new Uint16Array(lastWord + 1);
            this.data.forEach((value, index)=>temp[index] = value);
            this.data = temp;
        } else if (!value) {
            // But there is no need to grow array to clear bits.
            if (word >= this.data.length) // Early exit
            return;
            if (lastWord >= this.data.length) {
                // Adjust work to fit array
                lastWord = this.data.length - 1;
                toIndex = this.data.length * 16 - 1;
            }
        }
        if (word === lastWord) this._setBits(word, value, $f197ff2d2edfdb19$var$bitsFor(fromIndex, toIndex));
        else {
            this._setBits(word++, value, $f197ff2d2edfdb19$var$bitsFor(fromIndex, 15));
            while(word < lastWord)this.data[word++] = value ? 0xFFFF : 0;
            this._setBits(word, value, $f197ff2d2edfdb19$var$bitsFor(0, toIndex));
        }
    }
    _setBits(word, value, mask) {
        if (value) this.data[word] |= mask;
        else this.data[word] &= 0xFFFF ^ mask;
    }
    /**
     * Returns the number of bits of space actually in use by this `BitSet` to represent bit values. The maximum element
     * in the set is the size - 1st element.
     */ get size() {
        return this.data.byteLength * 8;
    }
    /**
     * Returns a new byte array containing all the bits in this bit set.
     *
     * More precisely, if
     * `let bytes = s.toByteArray();`
     * then `bytes.length === (s.length()+7)/8` and `s.get(n) === ((bytes[n/8] & (1<<(n%8))) != 0)` for all
     * `n < 8 * bytes.length`.
     */ // toByteArray(): Int8Array {
    // 	throw new Error("NOT IMPLEMENTED");
    // }
    /**
     * Returns a new integer array containing all the bits in this bit set.
     *
     * More precisely, if
     * `let integers = s.toIntegerArray();`
     * then `integers.length === (s.length()+31)/32` and `s.get(n) === ((integers[n/32] & (1<<(n%32))) != 0)` for all
     * `n < 32 * integers.length`.
     */ // toIntegerArray(): Int32Array {
    // 	throw new Error("NOT IMPLEMENTED");
    // }
    hashCode() {
        return $kPsXR.MurmurHash.hashCode(this.data, 22);
    }
    /**
     * Compares this object against the specified object. The result is `true` if and only if the argument is not
     * `undefined` and is a `Bitset` object that has exactly the same set of bits set to `true` as this bit set. That
     * is, for every nonnegative index `k`,
     *
     * ```
     * ((BitSet)obj).get(k) == this.get(k)
     * ```
     *
     * must be true. The current sizes of the two bit sets are not compared.
     */ equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $f197ff2d2edfdb19$var$BitSet)) return false;
        const len = this.length();
        if (len !== obj.length()) return false;
        if (len === 0) return true;
        let bound = $f197ff2d2edfdb19$var$getIndex(len - 1);
        for(let i = 0; i <= bound; i++){
            if (this.data[i] !== obj.data[i]) return false;
        }
        return true;
    }
    /**
     * Returns a string representation of this bit set. For every index for which this `BitSet` contains a bit in the
     * set state, the decimal representation of that index is included in the result. Such indices are listed in order
     * from lowest to highest, separated by ", " (a comma and a space) and surrounded by braces, resulting in the usual
     * mathematical notation for a set of integers.
     *
     * Example:
     *
     *     BitSet drPepper = new BitSet();
     *
     * Now `drPepper.toString()` returns `"{}"`.
     *
     *     drPepper.set(2);
     *
     * Now `drPepper.toString()` returns `"{2}"`.
     *
     *     drPepper.set(4);
     *     drPepper.set(10);
     *
     * Now `drPepper.toString()` returns `"{2, 4, 10}"`.
     */ toString() {
        let result = "{";
        let first = true;
        for(let i = this.nextSetBit(0); i >= 0; i = this.nextSetBit(i + 1)){
            if (first) first = false;
            else result += ", ";
            result += i;
        }
        result += "}";
        return result;
    }
    // static valueOf(bytes: Int8Array): BitSet;
    // static valueOf(buffer: ArrayBuffer): BitSet;
    // static valueOf(integers: Int32Array): BitSet;
    // static valueOf(data: Int8Array | Int32Array | ArrayBuffer): BitSet {
    // 	throw new Error("NOT IMPLEMENTED");
    // }
    /**
     * Performs a logical **XOR** of this bit set with the bit set argument. This bit set is modified so that a bit in
     * it has the value `true` if and only if one of the following statements holds:
     *
     * * The bit initially has the value `true`, and the corresponding bit in the argument has the value `false`.
     * * The bit initially has the value `false`, and the corresponding bit in the argument has the value `true`.
     */ xor(set) {
        const data = this.data;
        const other = set.data;
        const minWords = Math.min(data.length, other.length);
        const words = Math.max(data.length, other.length);
        const dest = data.length === words ? data : new Uint16Array(words);
        let lastWord = -1;
        // Xor those words both sets have in common
        for(let i = 0; i < minWords; i++){
            let value = dest[i] = data[i] ^ other[i];
            if (value !== 0) lastWord = i;
        }
        // Copy words from larger set (if there is one)
        const longer = data.length > other.length ? data : other;
        for(let i = minWords; i < words; i++){
            let value = dest[i] = longer[i];
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $f197ff2d2edfdb19$var$EMPTY_DATA;
        else if (dest.length === lastWord + 1) this.data = dest;
        else this.data = dest.slice(0, lastWord + 1);
    }
    clone() {
        return new $f197ff2d2edfdb19$var$BitSet(this);
    }
    [Symbol.iterator]() {
        return new $f197ff2d2edfdb19$var$BitSetIterator(this.data);
    }
    // Overrides formatting for nodejs assert etc.
    [$7T2Y0.inspect.custom]() {
        return "BitSet " + this.toString();
    }
    /*
    ** constructor implementation
    */ constructor(arg){
        if (!arg) // covering the case of unspecified and nbits===0
        this.data = $f197ff2d2edfdb19$var$EMPTY_DATA;
        else if (typeof arg === "number") {
            if (arg < 0) throw new RangeError("nbits cannot be negative");
            else this.data = new Uint16Array($f197ff2d2edfdb19$var$getIndex(arg - 1) + 1);
        } else if (arg instanceof $f197ff2d2edfdb19$var$BitSet) this.data = arg.data.slice(0); // Clone the data
        else {
            let max = -1;
            for (let v of arg)if (max < v) max = v;
            this.data = new Uint16Array($f197ff2d2edfdb19$var$getIndex(max - 1) + 1);
            for (let v of arg)this.set(v);
        }
    }
}
module.exports.BitSet = $f197ff2d2edfdb19$var$BitSet;
class $f197ff2d2edfdb19$var$BitSetIterator {
    next() {
        while(this.index < this.data.length){
            const bits = this.data[this.index] & this.mask;
            if (bits !== 0) {
                const bitNumber = $f197ff2d2edfdb19$var$unIndex(this.index) + $f197ff2d2edfdb19$var$findLSBSet(bits);
                this.mask = $f197ff2d2edfdb19$var$bitsFor(bitNumber + 1, 15);
                return {
                    done: false,
                    value: bitNumber
                };
            }
            this.index++;
            this.mask = 0xFFFF;
        }
        return {
            done: true,
            value: -1
        };
    }
    [Symbol.iterator]() {
        return this;
    }
    constructor(data){
        this.data = data;
        this.index = 0;
        this.mask = 0xFFFF;
    }
}

});

parcelRegister("kzQll", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Arrays = void 0;
var $efafadca3626d145$var$Arrays;
(function(Arrays) {
    /**
     * Searches the specified array of numbers for the specified value using the binary search algorithm. The array must
     * be sorted prior to making this call. If it is not sorted, the results are unspecified. If the array contains
     * multiple elements with the specified value, there is no guarantee which one will be found.
     *
     * @returns index of the search key, if it is contained in the array; otherwise, (-(insertion point) - 1). The
     * insertion point is defined as the point at which the key would be inserted into the array: the index of the first
     * element greater than the key, or array.length if all elements in the array are less than the specified key. Note
     * that this guarantees that the return value will be >= 0 if and only if the key is found.
     */ function binarySearch(array, key, fromIndex, toIndex) {
        return binarySearch0(array, fromIndex !== undefined ? fromIndex : 0, toIndex !== undefined ? toIndex : array.length, key);
    }
    Arrays.binarySearch = binarySearch;
    function binarySearch0(array, fromIndex, toIndex, key) {
        let low = fromIndex;
        let high = toIndex - 1;
        while(low <= high){
            let mid = low + high >>> 1;
            let midVal = array[mid];
            if (midVal < key) low = mid + 1;
            else if (midVal > key) high = mid - 1;
            else // key found
            return mid;
        }
        // key not found.
        return -(low + 1);
    }
    function toString(array) {
        let result = "[";
        let first = true;
        for (let element of array){
            if (first) first = false;
            else result += ", ";
            if (element === null) result += "null";
            else if (element === undefined) result += "undefined";
            else result += element;
        }
        result += "]";
        return result;
    }
    Arrays.toString = toString;
})($efafadca3626d145$var$Arrays = module.exports.Arrays || (module.exports.Arrays = {}));

});

parcelRegister("g9j02", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $bc1c3987e9125372$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorNode = void 0;

var $ffTXa = parcelRequire("ffTXa");


var $1FMAL = parcelRequire("1FMAL");

/** Represents a token that was consumed during resynchronization
 *  rather than during a valid match operation. For example,
 *  we will create this kind of a node during single token insertion
 *  and deletion as well as during "consume until error recovery set"
 *  upon no viable alternative exceptions.
 */ class $bc1c3987e9125372$var$ErrorNode extends $1FMAL.TerminalNode {
    accept(visitor) {
        return visitor.visitErrorNode(this);
    }
    constructor(token){
        super(token);
    }
}
$bc1c3987e9125372$var$__decorate([
    $ffTXa.Override
], $bc1c3987e9125372$var$ErrorNode.prototype, "accept", null);
module.exports.ErrorNode = $bc1c3987e9125372$var$ErrorNode;

});

parcelRegister("80194", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UUID = void 0;

var $kPsXR = parcelRequire("kPsXR");

class $5d2f363e91859456$var$UUID {
    static fromString(data) {
        if (!/^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/.test(data)) throw new Error("Incorrectly formatted UUID");
        let segments = data.split("-");
        let mostSigBits = parseInt(segments[0], 16);
        let moreSigBits = (parseInt(segments[1], 16) << 16 >>> 0) + parseInt(segments[2], 16);
        let lessSigBits = (parseInt(segments[3], 16) << 16 >>> 0) + parseInt(segments[4].substr(0, 4), 16);
        let leastSigBits = parseInt(segments[4].substr(-8), 16);
        return new $5d2f363e91859456$var$UUID(mostSigBits, moreSigBits, lessSigBits, leastSigBits);
    }
    hashCode() {
        return $kPsXR.MurmurHash.hashCode([
            this.data[0],
            this.data[1],
            this.data[2],
            this.data[3]
        ]);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $5d2f363e91859456$var$UUID)) return false;
        return this.data[0] === obj.data[0] && this.data[1] === obj.data[1] && this.data[2] === obj.data[2] && this.data[3] === obj.data[3];
    }
    toString() {
        return ("00000000" + this.data[0].toString(16)).substr(-8) + "-" + ("0000" + (this.data[1] >>> 16).toString(16)).substr(-4) + "-" + ("0000" + this.data[1].toString(16)).substr(-4) + "-" + ("0000" + (this.data[2] >>> 16).toString(16)).substr(-4) + "-" + ("0000" + this.data[2].toString(16)).substr(-4) + ("00000000" + this.data[3].toString(16)).substr(-8);
    }
    constructor(mostSigBits, moreSigBits, lessSigBits, leastSigBits){
        this.data = new Uint32Array(4);
        this.data[0] = mostSigBits;
        this.data[1] = moreSigBits;
        this.data[2] = lessSigBits;
        this.data[3] = leastSigBits;
    }
}
module.exports.UUID = $5d2f363e91859456$var$UUID;

});

parcelRegister("gkLFx", function(module, exports) {
const $7966301017163f3c$export$470bef71e654b804 = ()=>[];
const $7966301017163f3c$export$a4685923af2913a = (node)=>{
    node.getChildren().forEach((child)=>{
        child.parent = node;
    });
};
module.exports["noChildren"] = $7966301017163f3c$export$470bef71e654b804;
module.exports["assignParent"] = $7966301017163f3c$export$a4685923af2913a;

});

parcelRegister("jLG6B", function(module, exports) {
/**
 * Represents a error occurring when trying to parse JQL into a Jast.
 */ class $cb4a52fccfb63901$export$e8cfe2b2c93fbd4b extends Error {
    constructor(message, cause){
        super(message);
        /**
     * The original JS error that was thrown trying to parse JQL.
     */ this.cause = void 0;
        /**
     * The error message. We use a separate property here so consumers can perform shallow comparison of error objects.
     */ this.description = void 0;
        this.name = 'JQLParseError';
        this.cause = cause;
        this.description = message;
    }
}
module.exports["JQLParseError"] = $cb4a52fccfb63901$export$e8cfe2b2c93fbd4b;

});

parcelRegister("egnO5", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a62506decb3f5c66$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultEqualityComparator = void 0;

var $ffTXa = parcelRequire("ffTXa");


var $kPsXR = parcelRequire("kPsXR");


var $9PlGk = parcelRequire("9PlGk");

/**
 * This default implementation of {@link EqualityComparator} uses object equality
 * for comparisons by calling {@link Object#hashCode} and {@link Object#equals}.
 *
 * @author Sam Harwell
 */ class $a62506decb3f5c66$var$DefaultEqualityComparator {
    /**
     * {@inheritDoc}
     *
     * This implementation returns
     * `obj.`{@link Object#hashCode hashCode()}.
     */ hashCode(obj) {
        if (obj == null) return 0;
        else if (typeof obj === "string" || typeof obj === "number") return $kPsXR.MurmurHash.hashCode([
            obj
        ]);
        else return $9PlGk.ObjectEqualityComparator.INSTANCE.hashCode(obj);
    }
    /**
     * {@inheritDoc}
     *
     * This implementation relies on object equality. If both objects are
     * `undefined` or `null`, this method returns `true`. Otherwise if only
     * `a` is `undefined` or `null`, this method returns `false`. Otherwise,
     * this method returns the result of
     * `a.`{@link Object#equals equals}`(b)`.
     */ equals(a, b) {
        if (a == null) return b == null;
        else if (typeof a === "string" || typeof a === "number") return a === b;
        else return $9PlGk.ObjectEqualityComparator.INSTANCE.equals(a, b);
    }
}
$a62506decb3f5c66$var$DefaultEqualityComparator.INSTANCE = new $a62506decb3f5c66$var$DefaultEqualityComparator();
$a62506decb3f5c66$var$__decorate([
    $ffTXa.Override
], $a62506decb3f5c66$var$DefaultEqualityComparator.prototype, "hashCode", null);
$a62506decb3f5c66$var$__decorate([
    $ffTXa.Override
], $a62506decb3f5c66$var$DefaultEqualityComparator.prototype, "equals", null);
module.exports.DefaultEqualityComparator = $a62506decb3f5c66$var$DefaultEqualityComparator;

});

parcelRegister("fZCit", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ba4a427d383a905b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DFASerializer = void 0;

var $51Z4d = parcelRequire("51Z4d");


var $ffTXa = parcelRequire("ffTXa");


var $2EGxJ = parcelRequire("2EGxJ");


var $bwXFO = parcelRequire("bwXFO");


var $56U0W = parcelRequire("56U0W");

/** A DFA walker that knows how to dump them to serialized strings. */ class $ba4a427d383a905b$var$DFASerializer {
    toString() {
        if (!this.dfa.s0) return "";
        let buf = "";
        if (this.dfa.states) {
            let states = new Array(...this.dfa.states.toArray());
            states.sort((o1, o2)=>o1.stateNumber - o2.stateNumber);
            for (let s of states){
                let edges = s.getEdgeMap();
                let edgeKeys = [
                    ...edges.keys()
                ].sort((a, b)=>a - b);
                let contextEdges = s.getContextEdgeMap();
                let contextEdgeKeys = [
                    ...contextEdges.keys()
                ].sort((a, b)=>a - b);
                for (let entry of edgeKeys){
                    let value = edges.get(entry);
                    if ((value == null || value === $51Z4d.ATNSimulator.ERROR) && !s.isContextSymbol(entry)) continue;
                    let contextSymbol = false;
                    buf += this.getStateString(s) + "-" + this.getEdgeLabel(entry) + "->";
                    if (s.isContextSymbol(entry)) {
                        buf += "!";
                        contextSymbol = true;
                    }
                    let t = value;
                    if (t && t.stateNumber !== $51Z4d.ATNSimulator.ERROR.stateNumber) buf += this.getStateString(t) + "\n";
                    else if (contextSymbol) buf += "ctx\n";
                }
                if (s.isContextSensitive) for (let entry of contextEdgeKeys)buf += this.getStateString(s) + "-" + this.getContextLabel(entry) + "->" + this.getStateString(contextEdges.get(entry)) + "\n";
            }
        }
        let output = buf;
        if (output.length === 0) return "";
        //return Utils.sortLinesInString(output);
        return output;
    }
    getContextLabel(i) {
        if (i === $2EGxJ.PredictionContext.EMPTY_FULL_STATE_KEY) return "ctx:EMPTY_FULL";
        else if (i === $2EGxJ.PredictionContext.EMPTY_LOCAL_STATE_KEY) return "ctx:EMPTY_LOCAL";
        if (this.atn && i > 0 && i <= this.atn.states.length) {
            let state = this.atn.states[i];
            let ruleIndex = state.ruleIndex;
            if (this.ruleNames && ruleIndex >= 0 && ruleIndex < this.ruleNames.length) return "ctx:" + String(i) + "(" + this.ruleNames[ruleIndex] + ")";
        }
        return "ctx:" + String(i);
    }
    getEdgeLabel(i) {
        return this.vocabulary.getDisplayName(i);
    }
    getStateString(s) {
        if (s === $51Z4d.ATNSimulator.ERROR) return "ERROR";
        let n = s.stateNumber;
        let stateStr = "s" + n;
        if (s.isAcceptState) {
            if (s.predicates) stateStr = ":s" + n + "=>" + s.predicates;
            else stateStr = ":s" + n + "=>" + s.prediction;
        }
        if (s.isContextSensitive) {
            stateStr += "*";
            for (let config of s.configs)if (config.reachesIntoOuterContext) {
                stateStr += "*";
                break;
            }
        }
        return stateStr;
    }
    constructor(dfa, vocabulary, ruleNames, atn){
        if (vocabulary instanceof $bwXFO.Recognizer) {
            ruleNames = vocabulary.ruleNames;
            atn = vocabulary.atn;
            vocabulary = vocabulary.vocabulary;
        } else if (!vocabulary) vocabulary = $56U0W.VocabularyImpl.EMPTY_VOCABULARY;
        this.dfa = dfa;
        this.vocabulary = vocabulary;
        this.ruleNames = ruleNames;
        this.atn = atn;
    }
}
$ba4a427d383a905b$var$__decorate([
    $ffTXa.NotNull
], $ba4a427d383a905b$var$DFASerializer.prototype, "dfa", void 0);
$ba4a427d383a905b$var$__decorate([
    $ffTXa.NotNull
], $ba4a427d383a905b$var$DFASerializer.prototype, "vocabulary", void 0);
$ba4a427d383a905b$var$__decorate([
    $ffTXa.Override
], $ba4a427d383a905b$var$DFASerializer.prototype, "toString", null);
module.exports.DFASerializer = $ba4a427d383a905b$var$DFASerializer;

});

parcelRegister("9FQ0O", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $70b049e4f216a736$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $70b049e4f216a736$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerDFASerializer = void 0;

var $fZCit = parcelRequire("fZCit");


var $ffTXa = parcelRequire("ffTXa");


var $56U0W = parcelRequire("56U0W");

let $70b049e4f216a736$var$LexerDFASerializer = class LexerDFASerializer extends $fZCit.DFASerializer {
    getEdgeLabel(i) {
        return "'" + String.fromCodePoint(i) + "'";
    }
    constructor(dfa){
        super(dfa, $56U0W.VocabularyImpl.EMPTY_VOCABULARY);
    }
};
$70b049e4f216a736$var$__decorate([
    $ffTXa.Override,
    $ffTXa.NotNull
], $70b049e4f216a736$var$LexerDFASerializer.prototype, "getEdgeLabel", null);
$70b049e4f216a736$var$LexerDFASerializer = $70b049e4f216a736$var$__decorate([
    $70b049e4f216a736$var$__param(0, $ffTXa.NotNull)
], $70b049e4f216a736$var$LexerDFASerializer);
module.exports.LexerDFASerializer = $70b049e4f216a736$var$LexerDFASerializer;

});


//# sourceMappingURL=modal.f98fa792.js.map
